webpackJsonp([0],Array(34).concat([
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var SaConfigService = function SaConfigService($resource) {
  'ngInject';

  _classCallCheck(this, SaConfigService);

  this.api = $resource('/api/sa_config/:id', { id: '@id' }, {
    index: { method: 'GET', isArray: true },
    show: { method: 'GET', isArray: false },
    update: { method: 'PUT', isArray: false }
  });

  this.oem_api = $resource('/api/oem/sa_config/:id', { id: '@id' }, {
    index: { method: 'GET', isArray: true },
    pageIndex: { method: 'GET', isArray: false },
    show: { method: 'GET', isArray: false },
    create: { method: 'POST', isArray: false },
    update: { method: 'PUT', isArray: false }
  });
};
SaConfigService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.SaConfigService', ['ngResource']).service('SaConfigService', ['$resource', SaConfigService]).name;

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _date_util = __webpack_require__(699);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _angular2.default.module('leptonApp.DateUtil', [_angularMoment2.default]).factory('DateUtil', ['$filter', 'moment', _date_util.DateUtil]).name;

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OemService = function OemService($resource) {
  'ngInject';

  _classCallCheck(this, OemService);

  this.api = $resource('/api/oem/:id', { id: '@id' }, {
    index: { method: 'GET', isArray: false }
  });
  this.oem_api = $resource('/api/oem/oem/:id', { id: '@id' }, {
    index: { method: 'GET', isArray: false }
  });
  this.manage_api = $resource('/:mode/api/oem/:id', { id: '@id', mode: '@mode' }, {
    index: { method: 'GET', isArray: true },
    show: { method: 'GET', isArray: false },
    update: { method: 'PUT', isArray: false }
  });
};
OemService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.OemService', ['ngResource']).service('OemService', ['$resource', OemService]).name;

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CsvUtil = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _compare_weather = __webpack_require__(128);

var _compare_weather2 = _interopRequireDefault(_compare_weather);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var CsvUtil = exports.CsvUtil = function () {
  /*@ngInject*/
  CsvUtil.$inject = ["$filter", "moment", "CompareWeatherLogic"];
  function CsvUtil($filter, moment, CompareWeatherLogic) {
    _classCallCheck(this, CsvUtil);

    this.$filter = $filter;
    this.moment = moment;
    this.CompareWeatherLogic = CompareWeatherLogic;
  }

  _createClass(CsvUtil, [{
    key: 'processEvent',
    value: function processEvent(eventList) {
      var _this = this;

      var csv = '発生日時,サービスコード,設置場所,メモ,イベント名\r\n';
      eventList.forEach(function (event) {
        csv += _this.formatTimeBystr(event.occurred_at) + ',' + event.pms_service_code + ',' + event.location + ',' + event.memo + ',' + event.event_msg + '\r\n';
      });

      return csv;
    }
  }, {
    key: 'processOemEvent',
    value: function processOemEvent(eventList) {
      var _this2 = this;

      var csv = '発生日時,顧客名,サービスコード,設置場所,メモ,イベント名\r\n';

      eventList.forEach(function (event) {
        csv += _this2.formatTimeBystr(event.occurred_at) + ',' + event.company_name + ',' + event.pms_service_code + ',' + event.location + ',' + event.memo + ',' + event.event_msg + '\r\n';
      });

      return csv;
    }
  }, {
    key: 'createEventReportCsv',
    value: function createEventReportCsv(events) {
      var eventList = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var dayEvent = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = dayEvent.events[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var event = _step2.value;

              eventList.push(event);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this.processEvent(eventList);
    }
  }, {
    key: 'processDemandPower',
    value: function processDemandPower(powers, categories, targetDate) {
      var _this3 = this;

      var missingTimes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var weathers = arguments[4];

      var measuredTimes = this.formatCategories(categories, targetDate);

      var csv = '計測日時,需要電力(kW),天候,平均気温(℃),最高気温(℃),最低気温(℃)\r\n';
      powers.forEach(function (power, index) {
        var powerStr = power === null || _this3.isNoDataTime(categories[index], missingTimes) ? 'データ無し' : power;

        var weatherIndex = parseInt(index / 12);

        csv += measuredTimes[index] + ',' + powerStr + ',' + _this3.createWeatherColumn(weathers[weatherIndex]) + '\r\n';
      });

      return csv;
    }
  }, {
    key: 'processBulkDemandPower',
    value: function processBulkDemandPower(powers, weathers) {
      var _this4 = this;

      var csv = '計測日時,需要電力(kW),天候,平均気温(℃),最高気温(℃),最低気温(℃)\r\n';

      var formattedWeathers = this.formattedWeathers(powers, weathers);

      powers.forEach(function (power, index) {
        var weatherIndex = parseInt(index / 12);

        var powerStr = void 0;
        if (power.missing) {
          powerStr = 'データなし';
        } else {
          powerStr = power.value;
        }

        csv += _this4.moment(power.measured_at).format('YYYY/MM/DD HH:mm:ss') + ',' + powerStr + ',' + _this4.createWeatherColumn(formattedWeathers[weatherIndex]) + '\r\n';
      });

      return csv;
    }
  }, {
    key: 'processActivePower',
    value: function processActivePower(powers, categories, targetDate, missingTimes, noCalculateTimes, weathers) {
      var _this5 = this;

      var measuredTimes = this.formatCategories(categories, targetDate);

      var csv = '計測日時,消費電力(kWh),天候,平均気温(℃),最高気温(℃),最低気温(℃)\r\n';
      powers.forEach(function (power, index) {
        var powerStr = power;
        if (power === null || _this5.isNoDataTime(categories[index], missingTimes)) {
          powerStr = 'データ無し';
        } else if (_this5.isNoDataTime(categories[index], noCalculateTimes)) {
          powerStr = '差分計算不可';
        }

        var weatherIndex = parseInt(index / 12);

        csv += measuredTimes[index] + ',' + powerStr + ',' + _this5.createWeatherColumn(weathers[weatherIndex]) + '\r\n';
      });

      return csv;
    }
  }, {
    key: 'processBulkActivePower',
    value: function processBulkActivePower(powers, weathers) {
      var _this6 = this;

      var csv = '計測日時,消費電力(kWh),天候,平均気温(℃),最高気温(℃),最低気温(℃)\r\n';

      var formattedWeathers = this.formattedWeathers(powers, weathers);

      powers.forEach(function (power, index) {
        var weatherIndex = parseInt(index / 12);

        var powerStr = void 0;
        if (index === 0) {
          return;
        } else if (power.missing) {
          powerStr = 'データ無し';
        } else if (powers[index - 1].missing) {
          powerStr = '差分計算不可';
        } else {
          powerStr = power.value - powers[index - 1].value;
        }

        csv += _this6.moment(power.measured_at).format('YYYY/MM/DD HH:mm:ss') + ',' + powerStr + ',' + _this6.createWeatherColumn(formattedWeathers[weatherIndex]) + '\r\n';
      });

      return csv;
    }
  }, {
    key: 'processMaxDemandPower',
    value: function processMaxDemandPower(powers, categories, weathers) {
      var _this7 = this;

      var csv = '集計日,需要電力(kW),天候,平均気温(℃),最高気温(℃),最低気温(℃)\r\n';

      powers.forEach(function (power, index) {
        var powerStr = power === null ? 'データなし' : power;
        csv += _this7.formatDate(categories[index]) + ',' + powerStr + ',' + _this7.createWeatherColumn(weathers[index]) + '\r\n';
      });

      return csv;
    }
  }, {
    key: 'processDailyActivePower',
    value: function processDailyActivePower(powers, categories, weathers) {
      var _this8 = this;

      var csv = '集計日,消費電力(kWh),天候,平均気温(℃),最高気温(℃),最低気温(℃)\r\n';

      powers.forEach(function (power, index) {
        var powerStr = power === null ? 'データなし' : power;
        csv += _this8.formatDate(categories[index]) + ',' + powerStr + ',' + _this8.createWeatherColumn(weathers[index]) + '\r\n';
      });

      return csv;
    }
  }, {
    key: 'processMonthlyMaxDemandPower',
    value: function processMonthlyMaxDemandPower(powers, categories) {
      var _this9 = this;

      var csv = '集計月,需要電力(kW)\r\n';
      powers.forEach(function (power, index) {
        var powerStr = power === null ? 'データなし' : power;
        csv += _this9.formatDateMonth(categories[index]) + ',' + powerStr + '\r\n';
      });

      return csv;
    }
  }, {
    key: 'processMonthlyActivePower',
    value: function processMonthlyActivePower(powers, categories) {
      var _this10 = this;

      var csv = '集計月,消費電力(kWh)\r\n';
      powers.forEach(function (power, index) {
        var powerStr = power === null ? 'データなし' : power;
        csv += _this10.formatDateMonth(categories[index]) + ',' + powerStr + '\r\n';
      });

      return csv;
    }
  }, {
    key: 'processDemandHistogram',
    value: function processDemandHistogram(histogram) {
      var csv = '需要電力(kW),発生回数\r\n';

      histogram.forEach(function (data) {
        csv += data.x + ',' + data.y + '\r\n';
      });

      return csv;
    }
  }, {
    key: 'processGroupActivePower',
    value: function processGroupActivePower(seriesList, categories, targetDate) {
      var measuredTimes = this.formatCategories(categories, targetDate);

      var csv = '計測日時,サービスコード,消費電力(kWh),設置場所,メモ\r\n';
      seriesList.forEach(function (series) {
        series.data.forEach(function (power, index) {
          csv += measuredTimes[index] + ',' + series.name + ',' + power.y + ',' + series.location + ',' + series.memo + '\r\n';
        });
      });

      return csv;
    }
  }, {
    key: 'processDailyGroupActivePower',
    value: function processDailyGroupActivePower(seriesList, categories) {
      var _this11 = this;

      var csv = '集計日,サービスコード,消費電力(kWh),設置場所,メモ\r\n';
      seriesList.forEach(function (series) {
        series.data.forEach(function (power, index) {
          csv += _this11.formatDate(categories[index]) + ',' + series.name + ',' + power.y + ',' + series.location + ',' + series.memo + '\r\n';
        });
      });

      return csv;
    }
  }, {
    key: 'formatTimeBystr',
    value: function formatTimeBystr(timeStr) {
      return this.formatTime(Date.parse(timeStr));
    }
  }, {
    key: 'formatTime',
    value: function formatTime(time) {
      return this.$filter('date')(time, 'yyyy/MM/dd HH:mm:ss');
    }
  }, {
    key: 'formatDate',
    value: function formatDate(date) {
      return this.$filter('date')(date, 'yyyy/MM/dd');
    }
  }, {
    key: 'formatDateMonth',
    value: function formatDateMonth(date) {
      return this.$filter('date')(date, 'yyyy年MM月');
    }
  }, {
    key: 'formatCategories',
    value: function formatCategories(categories, targetDate) {
      var target = this.moment(targetDate).startOf('day');
      return categories.map(function (time) {
        target.add(30, 'minutes');
        return '' + target.format('YYYY/MM/DD HH:mm:ss');
      });
    }
  }, {
    key: 'formattedWeathers',
    value: function formattedWeathers(powers, weathers) {
      var currentTime = this.moment(powers[0].measured_at).startOf('day').add(3, 'hours');
      var endTime = this.moment(powers[powers.length - 1]).startOf('day').add(21, 'hours');

      var samplingTimes = [];
      while (currentTime <= endTime) {
        samplingTimes.push(currentTime.format('YYYY-MM-DD HH:mm:ss'));
        currentTime.add(6, 'hours');
      }

      return this.CompareWeatherLogic.compareDateTime(weathers, samplingTimes);
    }
  }, {
    key: 'isNoDataTime',
    value: function isNoDataTime(time, noDataTimes) {
      return noDataTimes.indexOf(time) !== -1;
    }
  }, {
    key: 'createWeatherColumn',
    value: function createWeatherColumn(weather) {
      var weatherName = 'データなし';
      var temp = 'データなし';
      var tempMax = 'データなし';
      var tempMin = 'データなし';

      if (weather) {
        weatherName = this.$filter('weather-name')(weather.code);
        temp = weather.temp;
        tempMax = weather.temp_max;
        tempMin = weather.temp_min;
      }

      return weatherName + ',' + temp + ',' + tempMax + ',' + tempMin;
    }
  }]);

  return CsvUtil;
}();

exports.default = angular.module('leptonApp.CsvUtil', [_angularMoment2.default, _compare_weather2.default]).service('CsvUtil', ['$filter', 'moment', 'CompareWeatherLogic', CsvUtil]).name;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _math_util = __webpack_require__(88);

var _math_util2 = _interopRequireDefault(_math_util);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var PowerFormatter = function () {
  /*@ngInject*/
  PowerFormatter.$inject = ["moment", "DateUtil", "MathUtil"];
  function PowerFormatter(moment, DateUtil, MathUtil) {
    _classCallCheck(this, PowerFormatter);

    this.moment = moment;
    this.DateUtil = DateUtil;
    this.MathUtil = MathUtil;
  }

  _createClass(PowerFormatter, [{
    key: 'formatDemandPowers',
    value: function formatDemandPowers(demandPowers, targetDate, categories) {
      var missingTimes = [];

      if (demandPowers.length === 0) {
        return [[], []];
      }

      var firstMeasuredAt = this.moment(demandPowers[0].measured_at);
      var beginningTime = this.moment(targetDate).startOf('day').add(30, 'minutes');
      var shift_range = firstMeasuredAt.diff(beginningTime, 'minutes') / 30;

      var formattedPowers = demandPowers.map(function (demandPower, index) {
        if (demandPower.missing) {
          missingTimes.push(categories[index + shift_range]);
          return 0;
        }

        return demandPower.value;
      });

      for (var i = 0; i < shift_range; i++) {
        formattedPowers.unshift(null);
      }

      return [formattedPowers, missingTimes];
    }
  }, {
    key: 'formatDailyDemandPowers',
    value: function formatDailyDemandPowers(dailyMaxDemandPowers, categories) {
      var _this = this;

      var powersIndex = 0;

      return categories.map(function (category) {
        if (!dailyMaxDemandPowers[powersIndex]) {
          return { y: null };
        }

        var power = dailyMaxDemandPowers[powersIndex].value;
        var date = dailyMaxDemandPowers[powersIndex].date;

        var utc = _this.DateUtil.jstToUTC(date + 'T00:00:00+09:00');
        if (category === utc) {
          powersIndex++;
          return { y: power, date: _this.moment(date).toDate() };
        } else {
          return { y: null };
        }
      });
    }
  }, {
    key: 'formatMonthlyDemandPowers',
    value: function formatMonthlyDemandPowers(monthlyMaxDemandPowers, categories, configBillingDate) {
      var _this2 = this;

      var powersIndex = 0;
      monthlyMaxDemandPowers = monthlyMaxDemandPowers.filter(function (power) {
        var date = _this2.moment(power.billing_date);
        return date.date() === configBillingDate;
      });

      return categories.map(function (category) {
        if (!monthlyMaxDemandPowers[powersIndex]) {
          return { y: null };
        }

        var power = monthlyMaxDemandPowers[powersIndex].value;

        var date = monthlyMaxDemandPowers[powersIndex].billing_date;

        var billingDate = _this2.getStartOfMonth(date);
        var linkDate = _this2.moment(date).subtract(1, 'days').startOf('month');

        if (billingDate.isSame(category)) {
          powersIndex++;
          return { y: power, date: linkDate.toDate() };
        } else {
          return { y: null };
        }
      });
    }
  }, {
    key: 'formatActivePowers',
    value: function formatActivePowers(powers, categories, targetDate, power_upper_limit) {
      var _this3 = this;

      var missingTimes = [];
      var noCalculateTimes = [];

      if (powers.length === 0) {
        return [[], [], []];
      }

      var firstMeasuredAt = this.moment(powers[0].measured_at);
      var beginningTime = this.moment(targetDate).startOf('day');
      var shift_range = firstMeasuredAt.diff(beginningTime, 'minutes') / 30;
      var formatted_powers = [];

      powers.forEach(function (power, index) {
        if (!powers[index - 1]) {
          return;
        }

        if (power.missing) {
          missingTimes.push(categories[index + shift_range - 1]);
          formatted_powers.push(0);
        } else if (powers[index - 1].missing) {
          noCalculateTimes.push(categories[index + shift_range - 1]);
          formatted_powers.push(0);
        } else {
          var diff = _this3.calcDailyPowerDiff(powers[index].value, powers[index - 1].value, power_upper_limit);
          formatted_powers.push(diff);
        }
      });

      for (var i = 0; i < shift_range; i++) {
        formatted_powers.unshift(null);
      }

      return [formatted_powers, missingTimes, noCalculateTimes];
    }
  }, {
    key: 'formatDailyActivePowers',
    value: function formatDailyActivePowers(dailyActivePowers, categories) {
      var _this4 = this;

      var powersIndex = 0;

      return categories.map(function (category) {
        if (!dailyActivePowers[powersIndex]) {
          return { y: null };
        }

        var power = dailyActivePowers[powersIndex].value;
        var date = dailyActivePowers[powersIndex].date;

        var utc = _this4.DateUtil.jstToUTC(date + 'T00:00:00+09:00');
        if (category === utc) {
          powersIndex++;
          return { y: power, date: _this4.moment(date).toDate() };
        } else {
          return { y: null };
        }
      });
    }
  }, {
    key: 'formatMonthlyActivePowers',
    value: function formatMonthlyActivePowers(monthlyActivePowers, categories, configBillingDate) {
      var _this5 = this;

      var powersIndex = 0;

      monthlyActivePowers = monthlyActivePowers.filter(function (power) {
        var date = _this5.moment(power.billing_date);
        return date.date() === configBillingDate;
      });

      return categories.map(function (category) {
        if (!monthlyActivePowers[powersIndex]) {
          return { y: null };
        }

        var power = monthlyActivePowers[powersIndex].value;
        var date = monthlyActivePowers[powersIndex].billing_date;

        var billingDate = _this5.getStartOfMonth(date);
        var linkDate = _this5.moment(date).subtract(1, 'days').startOf('month');

        if (billingDate.isSame(category)) {
          powersIndex++;
          return { y: power, date: linkDate.toDate() };
        } else {
          return { y: null };
        }
      });
    }
  }, {
    key: 'calcDailyPowerDiff',
    value: function calcDailyPowerDiff(current_value, before_value, power_upper_limit) {
      if (current_value < before_value) {
        var surplus = this.MathUtil.subtract(power_upper_limit, before_value);
        return this.MathUtil.add(surplus, current_value);
      }

      return this.MathUtil.subtract(current_value, before_value);
    }
  }, {
    key: 'getStartOfMonth',
    value: function getStartOfMonth(date) {
      var tmpDate = this.moment(date).subtract(1, 'days').startOf('month');
      tmpDate.add(tmpDate.utcOffset(), 'minutes').utc();

      return tmpDate;
    }
  }]);

  return PowerFormatter;
}();

exports.default = angular.module('leptonApp.PowerFormatter', [_angularMoment2.default, _date_util2.default, _math_util2.default]).service('PowerFormatter', ['moment', 'DateUtil', 'MathUtil', PowerFormatter]).name;

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _highcharts = __webpack_require__(667);

var _highcharts2 = _interopRequireDefault(_highcharts);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

window.Highcharts = _highcharts2.default;

var Chart = function () {
    function Chart() {
        'ngInject';

        _classCallCheck(this, Chart);

        window.Highcharts.setOptions({
            lang: {
                thousandsSep: ','
            }
        });

        this.template = '<div class="chart"></div>';
        this.restrict = 'E';
        this.replace = true;
        this.scope = { chartConfig: '=value' };
    }

    _createClass(Chart, [{
        key: 'link',
        value: function link(scope, element, attrs) {
            var chartsDefaults = {
                chart: {
                    renderTo: element[0],
                    type: attrs.type || null,
                    height: attrs.height || null,
                    width: attrs.width || null,
                    style: { fontFamily: "'Unica One', sans-serif" },
                    plotBorderColor: '#606063'
                },
                title: {
                    style: {
                        color: '#333333',
                        textTransform: 'uppercase',
                        fontSize: '20px'
                    }
                },
                subtitle: { style: { color: '#666666' } },
                xAxis: {
                    gridLineColor: '#c1c1c1',
                    labels: { style: { color: '#0e0e0e' } },
                    lineColor: '#c1c1c1',
                    minorGridLineColor: '#505053',
                    tickColor: '#c1c1c1',
                    title: { style: { color: '#0e0e0e' } },
                    minPadding: 0,
                    maxPadding: 0
                },
                yAxis: {
                    title: {
                        style: {
                            color: '#0e0e0e',
                            fontSize: '15px'
                        }
                    },
                    plotLines: [{
                        value: 0,
                        width: 1,
                        color: '#808080'
                    }],
                    gridLineColor: '#c1c1c1',
                    labels: { style: { color: '#0e0e0e' } },
                    lineColor: '#c1c1c1',
                    minorGridLineColor: '#c1c1c1',
                    tickColor: '#c1c1c1',
                    tickWidth: 1
                },
                legend: {
                    itemStyle: {
                        color: '#717171'
                    },
                    itemHoverStyle: {
                        color: '#4e4e4e'
                    },
                    borderWidth: 0
                },
                plotOptions: {
                    column: {
                        grouping: false,
                        borderColor: '#8e8d8d'
                    }
                },
                credits: { enabled: false },
                exporting: { enabled: false },
                tooltip: { enabled: true },
                labels: { style: { color: '#666666' } },
                legendBackgroundColor: 'rgba(0, 0, 0, 0.5)',
                background2: '#505053',
                dataLabelsColor: '#B0B0B3',
                textColor: '#C0C0C0',
                contrastTextColor: '#F0F0F3',
                maskColor: 'rgba(255,255,255,0.3)'
            };

            scope.$watch(function (scope) {
                return scope.chartConfig.series;
            }, function (newValue, oldValue, scope) {
                if (!newValue) return;
                var config = angular.merge({}, chartsDefaults, scope.chartConfig);
                var chart = _highcharts2.default.chart(element[0], config);
            });
        }
    }]);

    return Chart;
}();

exports.default = angular.module('leptonApp.Chart', []).directive('chart', [function () {
    return new Chart();
}]).name;

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DistStockService = function DistStockService($resource) {
  'ngInject';

  _classCallCheck(this, DistStockService);

  this.api = $resource('/api/dist_stock', {}, { index: { method: 'GET', isArray: true } });

  this.oem_api = $resource('/api/oem/dist_stock', {}, {
    index: { method: 'GET', isArray: false },
    count: { method: 'GET', isArray: false, params: { count: true } }
  });

  this.manage_api = $resource('/:mode/api/dist_stock', { mode: '@mode' }, {
    index: { method: 'GET', isArray: true },
    create: { method: 'POST', isArray: false }
  });
};
DistStockService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.DistStockService', ['ngResource']).service('DistStockService', ['$resource', DistStockService]).name;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var MathUtil = function () {
  function MathUtil() {
    _classCallCheck(this, MathUtil);
  }

  _createClass(MathUtil, [{
    key: 'subtract',
    value: function subtract(baseNumber, subtractNumber) {
      var decimalDigitNum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;

      var multiple = Math.pow(10, decimalDigitNum);
      var base = this.getInteger(baseNumber, decimalDigitNum);
      var sub = this.getInteger(subtractNumber, decimalDigitNum);

      return (base - sub) / multiple;
    }
  }, {
    key: 'add',
    value: function add(baseNumber, addNumber) {
      var decimalDigitNum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;

      var multiple = Math.pow(10, decimalDigitNum);
      var base = this.getInteger(baseNumber, decimalDigitNum);
      var add = this.getInteger(addNumber, decimalDigitNum);

      return (base + add) / multiple;
    }
  }, {
    key: 'getIntDigit',
    value: function getIntDigit(value) {
      return String(Math.floor(value)).length;
    }
  }, {
    key: 'getInteger',
    value: function getInteger(num, decimalDigitNum) {
      var strValues = String(num).split('.');
      var addDigit = strValues[1] || '';

      if (addDigit.length > decimalDigitNum) {
        addDigit = addDigit.slice(0, decimalDigitNum);
      }

      var length = decimalDigitNum - addDigit.length;
      for (var i = 0; i < length; i++) {
        addDigit += '0';
      }

      return parseInt(strValues[0] + addDigit);
    }
  }]);

  return MathUtil;
}();

exports.default = angular.module('leptonApp.MathUtil', []).service('MathUtil', [MathUtil]).name;

/***/ }),
/* 89 */,
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var EventService = function EventService($resource) {
  'ngInject';

  _classCallCheck(this, EventService);

  this.api = $resource('/api/event/:id', { id: '@id' }, {
    index: { method: 'GET', isArray: true },
    show: { method: 'GET', isArray: true }
  });

  this.oem_api = $resource('/api/oem/event/:id', { id: '@id' }, {
    index: { method: 'GET', isArray: true },
    show: { method: 'GET', isArray: true }
  });

  this.manage_api = $resource('/:mode/api/event/:id', { id: '@id', mode: '@mode' }, {
    show: { method: 'GET', isArray: true }
  });
};
EventService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.EventService', ['ngResource']).service('EventService', ['$resource', EventService]).name;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var ControllerConfigService = function ControllerConfigService($resource) {
    'ngInject';

    _classCallCheck(this, ControllerConfigService);

    this.api = $resource('/api/controller_config/:id', { id: '@id' }, {
        index: { method: 'GET', isArray: true },
        show: { method: 'GET', isArray: false },
        update: { method: 'PUT', isArray: false }
    });

    this.oem_api = $resource('/api/oem/controller_config/:id', { id: '@id' }, {
        index: { method: 'GET', isArray: true },
        show: { method: 'GET', isArray: false },
        create: { method: 'POST', isArray: false },
        update: { method: 'PUT', isArray: false }
    });
};
ControllerConfigService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.ControllerConfigService', ['ngResource']).service('ControllerConfigService', ['$resource', ControllerConfigService]).name;

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(184);
module.exports = 'ngCookies';

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function CompanyService($resource) {
    return $resource('/api/oem/company/:id', { id: '@id' }, {
        index: { method: 'GET', isArray: true },
        show: { method: 'GET', isArray: false },
        create: { method: 'POST', isArray: false },
        update: { method: 'PUT', isArray: false },
        destroy: { method: 'DELETE', isArray: false }
    });
}

exports.default = angular.module('leptonApp.CompanyService', ['ngResource']).service('CompanyService', ['$resource', CompanyService]).name;

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareWeatherLogic = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var CompareWeatherLogic = exports.CompareWeatherLogic = function () {
  /*@ngInject*/
  CompareWeatherLogic.$inject = ["moment"];
  function CompareWeatherLogic(moment) {
    _classCallCheck(this, CompareWeatherLogic);

    this.moment = moment;
  }

  _createClass(CompareWeatherLogic, [{
    key: 'compareDateTime',
    value: function compareDateTime(weathers, samplingTimes) {
      return this.compare(weathers, samplingTimes, 'measured_at', 'YYYY-MM-DD HH:mm:ss');
    }
  }, {
    key: 'compareHourly',
    value: function compareHourly(weathers, samplingTimes) {
      return this.compare(weathers, samplingTimes, 'measured_at', 'HH:mm');
    }
  }, {
    key: 'compareDaily',
    value: function compareDaily(dailyWeathers, samplingTimes) {
      return this.compare(dailyWeathers, samplingTimes, 'date', 'YYYY-MM-DD');
    }
  }, {
    key: 'compare',
    value: function compare(weathers, samplingTimes, propertyName, timeFormat) {
      var _this = this;

      var result = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var time = _step.value;

          var timeStr = time;
          if (typeof timeStr !== 'string') {
            timeStr = _this.moment(time).format(timeFormat);
          }
          var matchedWeather = weathers.find(function (weather) {
            return _this.moment(weather[propertyName]).format(timeFormat) === timeStr;
          });

          result.push(matchedWeather);
        };

        for (var _iterator = samplingTimes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var isAllNotFound = result.every(function (weather) {
        return !weather || !weather.name;
      });
      if (isAllNotFound) {
        result = [];
      }

      return result;
    }
  }]);

  return CompareWeatherLogic;
}();

exports.default = angular.module('leptonApp.CompareWeatherLogic', [_angularMoment2.default]).service('CompareWeatherLogic', ['moment', CompareWeatherLogic]).name;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OemUserService = function OemUserService($resource) {
  'ngInject';

  _classCallCheck(this, OemUserService);

  this.oem_api = $resource('/api/oem/oem_user/:id', { id: '@id' }, {
    index: { method: 'GET', isArray: true },
    show: { method: 'GET', isArray: false },
    create: { method: 'POST', isArray: false },
    update: { method: 'PUT', isArray: false },
    destroy: { method: 'DELETE', isArray: false }
  });

  this.manage_api = $resource('/:mode/api/oem_user/:id', { id: '@id', mode: '@mode' }, {
    index: { method: 'GET', isArray: true },
    create: { method: 'POST', isArray: false },
    destroy: { method: 'DELETE', isArray: false }
  });
};
OemUserService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.OemUserService', ['ngResource']).service('OemUserService', ['$resource', OemUserService]).name;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var WeatherService = function WeatherService($resource) {
  'ngInject';

  _classCallCheck(this, WeatherService);

  this.api = $resource('/api/weather', {}, { index: { method: 'GET', isArray: true } });
};
WeatherService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.WeatherService', ['ngResource']).service('WeatherService', ['$resource', WeatherService]).name;

/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var ServiceStockService = function ServiceStockService($resource) {
  'ngInject';

  _classCallCheck(this, ServiceStockService);

  this.api = $resource('/api/service_stock', {}, { index: { method: 'GET', isArray: false } });

  this.oem_api = $resource('/api/oem/service_stock', {}, { count: { method: 'GET', isArray: false, params: { count: true } } });

  this.manage_api = $resource('/:mode/api/service_stock', { mode: '@mode' }, {
    index: { method: 'GET', isArray: true }
  });
};
ServiceStockService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.ServiceStockService', ['ngResource']).service('ServiceStockService', ['$resource', ServiceStockService]).name;

/***/ }),
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function ActivePowerService($resource) {
  return $resource('/api/active_power/:id', { id: '@id' }, {
    show: { method: 'GET', isArray: false },
    upper_limit: { method: 'GET', isArray: false, url: '/api/active_power/:id/upper_limit' }
  });
}

exports.default = angular.module('leptonApp.ActivePowerService', ['ngResource']).service('ActivePowerService', ['$resource', ActivePowerService]).name;

/***/ }),
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @license AngularJS v1.6.8
 * (c) 2010-2017 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function (window, angular) {
  'use strict';

  /**
   * @ngdoc module
   * @name ngCookies
   * @description
   *
   * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
   *
   * See {@link ngCookies.$cookies `$cookies`} for usage.
   */

  angular.module('ngCookies', ['ng']).info({ angularVersion: '1.6.8' }).
  /**
   * @ngdoc provider
   * @name $cookiesProvider
   * @description
   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
   * */
  provider('$cookies', [/** @this */function $CookiesProvider() {
    /**
     * @ngdoc property
     * @name $cookiesProvider#defaults
     * @description
     *
     * Object containing default options to pass when setting cookies.
     *
     * The object may have following properties:
     *
     * - **path** - `{string}` - The cookie will be available only for this path and its
     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
     * - **domain** - `{string}` - The cookie will be available only for this domain and
     *   its sub-domains. For security reasons the user agent will not accept the cookie
     *   if the current domain is not a sub-domain of this domain or equal to it.
     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
     *   or a Date object indicating the exact date/time this cookie will expire.
     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
     *   secured connection.
     *
     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
     * This is important so that cookies will be visible for all routes when html5mode is enabled.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesProviderExample', ['ngCookies'])
     *   .config(['$cookiesProvider', function($cookiesProvider) {
     *     // Setting default options
     *     $cookiesProvider.defaults.domain = 'foo.com';
     *     $cookiesProvider.defaults.secure = true;
     *   }]);
     * ```
     **/
    var defaults = this.defaults = {};

    function calcOptions(options) {
      return options ? angular.extend({}, defaults, options) : defaults;
    }

    /**
     * @ngdoc service
     * @name $cookies
     *
     * @description
     * Provides read/write access to browser's cookies.
     *
     * <div class="alert alert-info">
     * Up until Angular 1.3, `$cookies` exposed properties that represented the
     * current browser cookie values. In version 1.4, this behavior has changed, and
     * `$cookies` now provides a standard api of getters, setters etc.
     * </div>
     *
     * Requires the {@link ngCookies `ngCookies`} module to be installed.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesExample', ['ngCookies'])
     *   .controller('ExampleController', ['$cookies', function($cookies) {
     *     // Retrieving a cookie
     *     var favoriteCookie = $cookies.get('myFavorite');
     *     // Setting a cookie
     *     $cookies.put('myFavorite', 'oatmeal');
     *   }]);
     * ```
     */
    this.$get = ['$$cookieReader', '$$cookieWriter', function ($$cookieReader, $$cookieWriter) {
      return {
        /**
         * @ngdoc method
         * @name $cookies#get
         *
         * @description
         * Returns the value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {string} Raw cookie value.
         */
        get: function get(key) {
          return $$cookieReader()[key];
        },

        /**
         * @ngdoc method
         * @name $cookies#getObject
         *
         * @description
         * Returns the deserialized value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {Object} Deserialized cookie value.
         */
        getObject: function getObject(key) {
          var value = this.get(key);
          return value ? angular.fromJson(value) : value;
        },

        /**
         * @ngdoc method
         * @name $cookies#getAll
         *
         * @description
         * Returns a key value object with all the cookies
         *
         * @returns {Object} All cookies
         */
        getAll: function getAll() {
          return $$cookieReader();
        },

        /**
         * @ngdoc method
         * @name $cookies#put
         *
         * @description
         * Sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {string} value Raw value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        put: function put(key, value, options) {
          $$cookieWriter(key, value, calcOptions(options));
        },

        /**
         * @ngdoc method
         * @name $cookies#putObject
         *
         * @description
         * Serializes and sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {Object} value Value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        putObject: function putObject(key, value, options) {
          this.put(key, angular.toJson(value), options);
        },

        /**
         * @ngdoc method
         * @name $cookies#remove
         *
         * @description
         * Remove given cookie
         *
         * @param {string} key Id of the key-value pair to delete.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        remove: function remove(key, options) {
          $$cookieWriter(key, undefined, calcOptions(options));
        }
      };
    }];
  }]);

  angular.module('ngCookies').
  /**
   * @ngdoc service
   * @name $cookieStore
   * @deprecated
   * sinceVersion="v1.4.0"
   * Please use the {@link ngCookies.$cookies `$cookies`} service instead.
   *
   * @requires $cookies
   *
   * @description
   * Provides a key-value (string-object) storage, that is backed by session cookies.
   * Objects put or retrieved from this storage are automatically serialized or
   * deserialized by angular's toJson/fromJson.
   *
   * Requires the {@link ngCookies `ngCookies`} module to be installed.
   *
   * @example
   *
   * ```js
   * angular.module('cookieStoreExample', ['ngCookies'])
   *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
   *     // Put cookie
   *     $cookieStore.put('myFavorite','oatmeal');
   *     // Get cookie
   *     var favoriteCookie = $cookieStore.get('myFavorite');
   *     // Removing a cookie
   *     $cookieStore.remove('myFavorite');
   *   }]);
   * ```
   */
  factory('$cookieStore', ['$cookies', function ($cookies) {

    return {
      /**
       * @ngdoc method
       * @name $cookieStore#get
       *
       * @description
       * Returns the value of given cookie key
       *
       * @param {string} key Id to use for lookup.
       * @returns {Object} Deserialized cookie value, undefined if the cookie does not exist.
       */
      get: function get(key) {
        return $cookies.getObject(key);
      },

      /**
       * @ngdoc method
       * @name $cookieStore#put
       *
       * @description
       * Sets a value for given cookie key
       *
       * @param {string} key Id for the `value`.
       * @param {Object} value Value to be stored.
       */
      put: function put(key, value) {
        $cookies.putObject(key, value);
      },

      /**
       * @ngdoc method
       * @name $cookieStore#remove
       *
       * @description
       * Remove given cookie
       *
       * @param {string} key Id of the key-value pair to delete.
       */
      remove: function remove(key) {
        $cookies.remove(key);
      }
    };
  }]);

  /**
   * @name $$cookieWriter
   * @requires $document
   *
   * @description
   * This is a private service for writing cookies
   *
   * @param {string} name Cookie name
   * @param {string=} value Cookie value (if undefined, cookie will be deleted)
   * @param {Object=} options Object with options that need to be stored for the cookie.
   */
  function $$CookieWriter($document, $log, $browser) {
    var cookiePath = $browser.baseHref();
    var rawDocument = $document[0];

    function buildCookieString(name, value, options) {
      var path, expires;
      options = options || {};
      expires = options.expires;
      path = angular.isDefined(options.path) ? options.path : cookiePath;
      if (angular.isUndefined(value)) {
        expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
        value = '';
      }
      if (angular.isString(expires)) {
        expires = new Date(expires);
      }

      var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
      str += path ? ';path=' + path : '';
      str += options.domain ? ';domain=' + options.domain : '';
      str += expires ? ';expires=' + expires.toUTCString() : '';
      str += options.secure ? ';secure' : '';

      // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
      // - 300 cookies
      // - 20 cookies per unique domain
      // - 4096 bytes per cookie
      var cookieLength = str.length + 1;
      if (cookieLength > 4096) {
        $log.warn('Cookie \'' + name + '\' possibly not set or overflowed because it was too large (' + cookieLength + ' > 4096 bytes)!');
      }

      return str;
    }

    return function (name, value, options) {
      rawDocument.cookie = buildCookieString(name, value, options);
    };
  }

  $$CookieWriter.$inject = ['$document', '$log', '$browser'];

  angular.module('ngCookies').provider('$$cookieWriter', /** @this */function $$CookieWriterProvider() {
    this.$get = $$CookieWriter;
  });
})(window, window.angular);

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(186);
module.exports = 'ngMessages';

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @license AngularJS v1.6.8
 * (c) 2010-2017 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function (window, angular) {
  'use strict';

  var forEach;
  var isArray;
  var isString;
  var jqLite;

  /**
   * @ngdoc module
   * @name ngMessages
   * @description
   *
   * The `ngMessages` module provides enhanced support for displaying messages within templates
   * (typically within forms or when rendering message objects that return key/value data).
   * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
   * show and hide error messages specific to the state of an input field, the `ngMessages` and
   * `ngMessage` directives are designed to handle the complexity, inheritance and priority
   * sequencing based on the order of how the messages are defined in the template.
   *
   * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
   * `ngMessage` and `ngMessageExp` directives.
   *
   * ## Usage
   * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
   * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
   * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
   * {@link ngModel ngModel} directive.
   *
   * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
   * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
   * the `ngMessages` directive.
   *
   * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
   * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
   * directive.
   *
   * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
   *
   * ```html
   * <form name="myForm">
   *   <label>
   *     Enter text:
   *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
   *   </label>
   *   <div ng-messages="myForm.myField.$error" role="alert">
   *     <div ng-message="required">Please enter a value for this field.</div>
   *     <div ng-message="email">This field must be a valid email address.</div>
   *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
   *   </div>
   * </form>
   * ```
   *
   * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
   * set to the `$error` object owned by the `myField` input in our `myForm` form.
   *
   * Within this element we then create separate elements for each of the possible errors that `myField` could have.
   * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
   * setting `ng-message="required"` specifies that this particular element should be displayed when there
   * is no value present for the required field `myField` (because the key `required` will be `true` in the object
   * `myForm.myField.$error`).
   *
   * ### Message order
   *
   * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
   * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
   * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
   * to prioritize messages using custom JavaScript code.
   *
   * Given the following error object for our example (which informs us that the field `myField` currently has both the
   * `required` and `email` errors):
   *
   * ```javascript
   * <!-- keep in mind that ngModel automatically sets these error flags -->
   * myField.$error = { required : true, email: true, maxlength: false };
   * ```
   * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
   * Once the user types a single character, the `required` message will disappear (since the field now has a value)
   * but the `email` message will be visible because it is still applicable.
   *
   * ### Displaying multiple messages at the same time
   *
   * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
   * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
   *
   * ```html
   * <!-- attribute-style usage -->
   * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
   *
   * <!-- element-style usage -->
   * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
   * ```
   *
   * ## Reusing and Overriding Messages
   * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
   * template. This allows for generic collection of messages to be reused across multiple parts of an
   * application.
   *
   * ```html
   * <script type="text/ng-template" id="error-messages">
   *   <div ng-message="required">This field is required</div>
   *   <div ng-message="minlength">This field is too short</div>
   * </script>
   *
   * <div ng-messages="myForm.myField.$error" role="alert">
   *   <div ng-messages-include="error-messages"></div>
   * </div>
   * ```
   *
   * However, including generic messages may not be useful enough to match all input fields, therefore,
   * `ngMessages` provides the ability to override messages defined in the remote template by redefining
   * them within the directive container.
   *
   * ```html
   * <!-- a generic template of error messages known as "my-custom-messages" -->
   * <script type="text/ng-template" id="my-custom-messages">
   *   <div ng-message="required">This field is required</div>
   *   <div ng-message="minlength">This field is too short</div>
   * </script>
   *
   * <form name="myForm">
   *   <label>
   *     Email address
   *     <input type="email"
   *            id="email"
   *            name="myEmail"
   *            ng-model="email"
   *            minlength="5"
   *            required />
   *   </label>
   *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
   *        override the messages present in the ng-messages-include template -->
   *   <div ng-messages="myForm.myEmail.$error" role="alert">
   *     <!-- this required message has overridden the template message -->
   *     <div ng-message="required">You did not enter your email address</div>
   *
   *     <!-- this is a brand new message and will appear last in the prioritization -->
   *     <div ng-message="email">Your email address is invalid</div>
   *
   *     <!-- and here are the generic error messages -->
   *     <div ng-messages-include="my-custom-messages"></div>
   *   </div>
   * </form>
   * ```
   *
   * In the example HTML code above the message that is set on required will override the corresponding
   * required message defined within the remote template. Therefore, with particular input fields (such
   * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
   * while more generic messages can be used to handle other, more general input errors.
   *
   * ## Dynamic Messaging
   * ngMessages also supports using expressions to dynamically change key values. Using arrays and
   * repeaters to list messages is also supported. This means that the code below will be able to
   * fully adapt itself and display the appropriate message when any of the expression data changes:
   *
   * ```html
   * <form name="myForm">
   *   <label>
   *     Email address
   *     <input type="email"
   *            name="myEmail"
   *            ng-model="email"
   *            minlength="5"
   *            required />
   *   </label>
   *   <div ng-messages="myForm.myEmail.$error" role="alert">
   *     <div ng-message="required">You did not enter your email address</div>
   *     <div ng-repeat="errorMessage in errorMessages">
   *       <!-- use ng-message-exp for a message whose key is given by an expression -->
   *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
   *     </div>
   *   </div>
   * </form>
   * ```
   *
   * The `errorMessage.type` expression can be a string value or it can be an array so
   * that multiple errors can be associated with a single error message:
   *
   * ```html
   *   <label>
   *     Email address
   *     <input type="email"
   *            ng-model="data.email"
   *            name="myEmail"
   *            ng-minlength="5"
   *            ng-maxlength="100"
   *            required />
   *   </label>
   *   <div ng-messages="myForm.myEmail.$error" role="alert">
   *     <div ng-message-exp="'required'">You did not enter your email address</div>
   *     <div ng-message-exp="['minlength', 'maxlength']">
   *       Your email must be between 5 and 100 characters long
   *     </div>
   *   </div>
   * ```
   *
   * Feel free to use other structural directives such as ng-if and ng-switch to further control
   * what messages are active and when. Be careful, if you place ng-message on the same element
   * as these structural directives, Angular may not be able to determine if a message is active
   * or not. Therefore it is best to place the ng-message on a child element of the structural
   * directive.
   *
   * ```html
   * <div ng-messages="myForm.myEmail.$error" role="alert">
   *   <div ng-if="showRequiredError">
   *     <div ng-message="required">Please enter something</div>
   *   </div>
   * </div>
   * ```
   *
   * ## Animations
   * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
   * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
   * the DOM by the `ngMessages` directive.
   *
   * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
   * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
   * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
   * hook into the animations whenever these classes are added/removed.
   *
   * Let's say that our HTML code for our messages container looks like so:
   *
   * ```html
   * <div ng-messages="myMessages" class="my-messages" role="alert">
   *   <div ng-message="alert" class="some-message">...</div>
   *   <div ng-message="fail" class="some-message">...</div>
   * </div>
   * ```
   *
   * Then the CSS animation code for the message container looks like so:
   *
   * ```css
   * .my-messages {
   *   transition:1s linear all;
   * }
   * .my-messages.ng-active {
   *   // messages are visible
   * }
   * .my-messages.ng-inactive {
   *   // messages are hidden
   * }
   * ```
   *
   * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
   * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
   *
   * Therefore, the CSS code for the inner messages looks like so:
   *
   * ```css
   * .some-message {
   *   transition:1s linear all;
   * }
   *
   * .some-message.ng-enter {}
   * .some-message.ng-enter.ng-enter-active {}
   *
   * .some-message.ng-leave {}
   * .some-message.ng-leave.ng-leave-active {}
   * ```
   *
   * {@link ngAnimate Click here} to learn how to use JavaScript animations or to learn more about ngAnimate.
   */
  angular.module('ngMessages', [], function initAngularHelpers() {
    // Access helpers from angular core.
    // Do it inside a `config` block to ensure `window.angular` is available.
    forEach = angular.forEach;
    isArray = angular.isArray;
    isString = angular.isString;
    jqLite = angular.element;
  }).info({ angularVersion: '1.6.8' })

  /**
   * @ngdoc directive
   * @module ngMessages
   * @name ngMessages
   * @restrict AE
   *
   * @description
   * `ngMessages` is a directive that is designed to show and hide messages based on the state
   * of a key/value object that it listens on. The directive itself complements error message
   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
   *
   * `ngMessages` manages the state of internal messages within its container element. The internal
   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
   * on if they're present within the key/value object. By default, only one message will be displayed
   * at a time and this depends on the prioritization of the messages within the template. (This can
   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
   *
   * A remote template can also be used to promote message reusability and messages can also be
   * overridden.
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   *   <ANY ng-message-exp="expressionValue">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   *   <ng-message when-exp="expressionValue">...</ng-message>
   * </ng-messages>
   * ```
   *
   * @param {string} ngMessages an angular expression evaluating to a key/value object
   *                 (this is typically the $error object on an ngModel instance).
   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
   *
   * @example
   * <example name="ngMessages-directive" module="ngMessagesExample"
   *          deps="angular-messages.js"
   *          animations="true" fixBase="true">
   *   <file name="index.html">
   *     <form name="myForm">
   *       <label>
   *         Enter your name:
   *         <input type="text"
   *                name="myName"
   *                ng-model="name"
   *                ng-minlength="5"
   *                ng-maxlength="20"
   *                required />
   *       </label>
   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
   *
   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
   *         <div ng-message="required">You did not enter a field</div>
   *         <div ng-message="minlength">Your field is too short</div>
   *         <div ng-message="maxlength">Your field is too long</div>
   *       </div>
   *     </form>
   *   </file>
   *   <file name="script.js">
   *     angular.module('ngMessagesExample', ['ngMessages']);
   *   </file>
   * </example>
   */
  .directive('ngMessages', ['$animate', function ($animate) {
    var ACTIVE_CLASS = 'ng-active';
    var INACTIVE_CLASS = 'ng-inactive';

    return {
      require: 'ngMessages',
      restrict: 'AE',
      controller: ['$element', '$scope', '$attrs', function NgMessagesCtrl($element, $scope, $attrs) {
        var ctrl = this;
        var latestKey = 0;
        var nextAttachId = 0;

        this.getAttachId = function getAttachId() {
          return nextAttachId++;
        };

        var messages = this.messages = {};
        var renderLater, cachedCollection;

        this.render = function (collection) {
          collection = collection || {};

          renderLater = false;
          cachedCollection = collection;

          // this is true if the attribute is empty or if the attribute value is truthy
          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) || isAttrTruthy($scope, $attrs.multiple);

          var unmatchedMessages = [];
          var matchedKeys = {};
          var messageItem = ctrl.head;
          var messageFound = false;
          var totalMessages = 0;

          // we use != instead of !== to allow for both undefined and null values
          while (messageItem != null) {
            totalMessages++;
            var messageCtrl = messageItem.message;

            var messageUsed = false;
            if (!messageFound) {
              forEach(collection, function (value, key) {
                if (!messageUsed && truthy(value) && messageCtrl.test(key)) {
                  // this is to prevent the same error name from showing up twice
                  if (matchedKeys[key]) return;
                  matchedKeys[key] = true;

                  messageUsed = true;
                  messageCtrl.attach();
                }
              });
            }

            if (messageUsed) {
              // unless we want to display multiple messages then we should
              // set a flag here to avoid displaying the next message in the list
              messageFound = !multiple;
            } else {
              unmatchedMessages.push(messageCtrl);
            }

            messageItem = messageItem.next;
          }

          forEach(unmatchedMessages, function (messageCtrl) {
            messageCtrl.detach();
          });

          if (unmatchedMessages.length !== totalMessages) {
            $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS);
          } else {
            $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
          }
        };

        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);

        // If the element is destroyed, proactively destroy all the currently visible messages
        $element.on('$destroy', function () {
          forEach(messages, function (item) {
            item.message.detach();
          });
        });

        this.reRender = function () {
          if (!renderLater) {
            renderLater = true;
            $scope.$evalAsync(function () {
              if (renderLater && cachedCollection) {
                ctrl.render(cachedCollection);
              }
            });
          }
        };

        this.register = function (comment, messageCtrl) {
          var nextKey = latestKey.toString();
          messages[nextKey] = {
            message: messageCtrl
          };
          insertMessageNode($element[0], comment, nextKey);
          comment.$$ngMessageNode = nextKey;
          latestKey++;

          ctrl.reRender();
        };

        this.deregister = function (comment) {
          var key = comment.$$ngMessageNode;
          delete comment.$$ngMessageNode;
          removeMessageNode($element[0], comment, key);
          delete messages[key];
          ctrl.reRender();
        };

        function findPreviousMessage(parent, comment) {
          var prevNode = comment;
          var parentLookup = [];

          while (prevNode && prevNode !== parent) {
            var prevKey = prevNode.$$ngMessageNode;
            if (prevKey && prevKey.length) {
              return messages[prevKey];
            }

            // dive deeper into the DOM and examine its children for any ngMessage
            // comments that may be in an element that appears deeper in the list
            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
              parentLookup.push(prevNode);
              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
            } else if (prevNode.previousSibling) {
              prevNode = prevNode.previousSibling;
            } else {
              prevNode = prevNode.parentNode;
              parentLookup.push(prevNode);
            }
          }
        }

        function insertMessageNode(parent, comment, key) {
          var messageNode = messages[key];
          if (!ctrl.head) {
            ctrl.head = messageNode;
          } else {
            var match = findPreviousMessage(parent, comment);
            if (match) {
              messageNode.next = match.next;
              match.next = messageNode;
            } else {
              messageNode.next = ctrl.head;
              ctrl.head = messageNode;
            }
          }
        }

        function removeMessageNode(parent, comment, key) {
          var messageNode = messages[key];

          var match = findPreviousMessage(parent, comment);
          if (match) {
            match.next = messageNode.next;
          } else {
            ctrl.head = messageNode.next;
          }
        }
      }]
    };

    function isAttrTruthy(scope, attr) {
      return isString(attr) && attr.length === 0 || //empty attribute
      truthy(scope.$eval(attr));
    }

    function truthy(val) {
      return isString(val) ? val.length : !!val;
    }
  }])

  /**
   * @ngdoc directive
   * @name ngMessagesInclude
   * @restrict AE
   * @scope
   *
   * @description
   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
   * code from a remote template and place the downloaded template code into the exact spot
   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
   * for a series of pre-defined messages to be reused and also allows for the developer to
   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-messages-include="remoteTplString">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
   * </ng-messages>
   * ```
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
   */
  .directive('ngMessagesInclude', ['$templateRequest', '$document', '$compile', function ($templateRequest, $document, $compile) {

    return {
      restrict: 'AE',
      require: '^^ngMessages', // we only require this for validation sake
      link: function link($scope, element, attrs) {
        var src = attrs.ngMessagesInclude || attrs.src;
        $templateRequest(src).then(function (html) {
          if ($scope.$$destroyed) return;

          if (isString(html) && !html.trim()) {
            // Empty template - nothing to compile
            replaceElementWithMarker(element, src);
          } else {
            // Non-empty template - compile and link
            $compile(html)($scope, function (contents) {
              element.after(contents);
              replaceElementWithMarker(element, src);
            });
          }
        });
      }
    };

    // Helpers
    function replaceElementWithMarker(element, src) {
      // A comment marker is placed for debugging purposes
      var comment = $compile.$$createComment ? $compile.$$createComment('ngMessagesInclude', src) : $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
      var marker = jqLite(comment);
      element.after(marker);

      // Don't pollute the DOM anymore by keeping an empty directive element
      element.remove();
    }
  }])

  /**
   * @ngdoc directive
   * @name ngMessage
   * @restrict AE
   * @scope
   * @priority 1
   *
   * @description
   * `ngMessage` is a directive with the purpose to show and hide a particular message.
   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
   * must be situated since it determines which messages are visible based on the state
   * of the provided key/value map that `ngMessages` listens on.
   *
   * More information about using `ngMessage` can be found in the
   * {@link module:ngMessages `ngMessages` module documentation}.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   * </ng-messages>
   * ```
   *
   * @param {expression} ngMessage|when a string value corresponding to the message key.
   */
  .directive('ngMessage', ngMessageDirectiveFactory())

  /**
   * @ngdoc directive
   * @name ngMessageExp
   * @restrict AE
   * @priority 1
   * @scope
   *
   * @description
   * `ngMessageExp` is the same as {@link directive:ngMessage `ngMessage`}, but instead of a static
   * value, it accepts an expression to be evaluated for the message key.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression">
   *   <ANY ng-message-exp="expressionValue">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression">
   *   <ng-message when-exp="expressionValue">...</ng-message>
   * </ng-messages>
   * ```
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
   */
  .directive('ngMessageExp', ngMessageDirectiveFactory());

  function ngMessageDirectiveFactory() {
    return ['$animate', function ($animate) {
      return {
        restrict: 'AE',
        transclude: 'element',
        priority: 1, // must run before ngBind, otherwise the text is set on the comment
        terminal: true,
        require: '^^ngMessages',
        link: function link(scope, element, attrs, ngMessagesCtrl, $transclude) {
          var commentNode = element[0];

          var records;
          var staticExp = attrs.ngMessage || attrs.when;
          var dynamicExp = attrs.ngMessageExp || attrs.whenExp;
          var assignRecords = function assignRecords(items) {
            records = items ? isArray(items) ? items : items.split(/[\s,]+/) : null;
            ngMessagesCtrl.reRender();
          };

          if (dynamicExp) {
            assignRecords(scope.$eval(dynamicExp));
            scope.$watchCollection(dynamicExp, assignRecords);
          } else {
            assignRecords(staticExp);
          }

          var currentElement, messageCtrl;
          ngMessagesCtrl.register(commentNode, messageCtrl = {
            test: function test(name) {
              return contains(records, name);
            },
            attach: function attach() {
              if (!currentElement) {
                $transclude(function (elm, newScope) {
                  $animate.enter(elm, null, element);
                  currentElement = elm;

                  // Each time we attach this node to a message we get a new id that we can match
                  // when we are destroying the node later.
                  var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();

                  // in the event that the element or a parent element is destroyed
                  // by another structural directive then it's time
                  // to deregister the message from the controller
                  currentElement.on('$destroy', function () {
                    if (currentElement && currentElement.$$attachId === $$attachId) {
                      ngMessagesCtrl.deregister(commentNode);
                      messageCtrl.detach();
                    }
                    newScope.$destroy();
                  });
                });
              }
            },
            detach: function detach() {
              if (currentElement) {
                var elm = currentElement;
                currentElement = null;
                $animate.leave(elm);
              }
            }
          });
        }
      };
    }];

    function contains(collection, key) {
      if (collection) {
        return isArray(collection) ? collection.indexOf(key) >= 0 : collection.hasOwnProperty(key);
      }
    }
  }
})(window, window.angular);

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(188);
module.exports = 'validation.match';

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * angular-validation-match
 * Checks if one input matches another
 * @version v1.9.0
 * @link https://github.com/TheSharpieOne/angular-validation-match
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
(function (window, angular, undefined) {
    'use strict';

    match.$inject = ["$parse"];
    angular.module('validation.match', []);

    angular.module('validation.match').directive('match', match);

    function match($parse) {
        return {
            require: '?ngModel',
            restrict: 'A',
            link: function link(scope, elem, attrs, ctrl) {
                if (!ctrl || !attrs.match) {
                    return;
                }

                var matchGetter = $parse(attrs.match);
                var caselessGetter = $parse(attrs.matchCaseless);
                var noMatchGetter = $parse(attrs.notMatch);
                var matchIgnoreEmptyGetter = $parse(attrs.matchIgnoreEmpty);

                scope.$watch(getMatchValue, function () {
                    ctrl.$$parseAndValidate();
                });

                ctrl.$validators.match = function (modelValue, viewValue) {
                    var matcher = modelValue || viewValue;
                    var match = getMatchValue();
                    var notMatch = noMatchGetter(scope);
                    var value;

                    if (matchIgnoreEmptyGetter(scope) && !viewValue) {
                        return true;
                    }

                    if (caselessGetter(scope)) {
                        value = angular.lowercase(matcher) === angular.lowercase(match);
                    } else {
                        value = matcher === match;
                    }
                    /*jslint bitwise: true */
                    value ^= notMatch;
                    /*jslint bitwise: false */
                    return !!value;
                };

                function getMatchValue() {
                    var match = matchGetter(scope);
                    if (angular.isObject(match) && match.hasOwnProperty('$viewValue')) {
                        match = match.$viewValue;
                    }
                    return match;
                }
            }
        };
    }
})(window, window.angular);

/***/ }),
/* 189 */,
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function GetErrorMessageFilter() {
    return function (deviceError) {
        if (!deviceError) return '';
        if (!deviceError.has_error) return '正常稼働中';
        if (deviceError.cloud_disconnected) return 'クラウドと未接続';
        if (deviceError.meter_off || deviceError.meter_fault) return 'スマートメーターから異常通知を受信';
        if (deviceError.meter_not_found) return 'スマートメーターが見つからない';
        if (deviceError.demand_fault) return 'データ取得失敗';
        if (deviceError.demand_level === 1) return 'デマンド警報発令中 (目標電力超過)';
        if (deviceError.demand_level === 2) return 'デマンド警報発令中 (限界電力超過)';
        if (deviceError.demand_level === 3) return 'デマンド警報発令中 (契約電力超過)';
    };
}

exports.default = angular.module('leptonApp.GetErrorMessageFilter', []).filter('getErrorMessage', [GetErrorMessageFilter]).name;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function DailyActivePowerService($resource) {
    return $resource('/api/daily_active_power/:id', { id: '@id' }, {
        show: { method: 'GET', isArray: false }
    });
}

exports.default = angular.module('leptonApp.DailyActivePowerService', ['ngResource']).factory('DailyActivePowerService', ['$resource', DailyActivePowerService]).name;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DailyWeatherService = function DailyWeatherService($resource) {
  'ngInject';

  _classCallCheck(this, DailyWeatherService);

  this.api = $resource('/api/daily_weather', {}, { index: { method: 'GET', isArray: true } });
};
DailyWeatherService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.DailyWeatherService', ['ngResource']).service('DailyWeatherService', ['$resource', DailyWeatherService]).name;

/***/ }),
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var SaGroupService = function SaGroupService($resource) {
    'ngInject';

    _classCallCheck(this, SaGroupService);

    this.api = $resource('/api/sa_group/:id', { id: '@id' }, {
        index: { method: 'GET', isArray: true },
        show: { method: 'GET', isArray: false },
        create: { method: 'POST', isArray: false },
        update: { method: 'PUT', isArray: false },
        destroy: { method: 'DELETE', isArray: false }
    });
};
SaGroupService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.SaGroupService', ['ngResource']).service('SaGroupService', ['$resource', SaGroupService]).name;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function DemandPowerService($resource) {
    return $resource('/api/demand_power/:id', { id: '@id' }, { show: { method: 'GET', isArray: false } });
}

exports.default = angular.module('leptonApp.DemandPowerService', ['ngResource']).factory('DemandPowerService', ['$resource', DemandPowerService]).name;

/***/ }),
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var ZipSearchLogic = exports.ZipSearchLogic = function () {
  /*@ngInject*/
  function ZipSearchLogic() {
    _classCallCheck(this, ZipSearchLogic);

    this.ZipCodeJp = ZipCodeJp;
    this.ZipCodeJp.setZipCodeBaseUrl('/zip_code');
  }

  _createClass(ZipSearchLogic, [{
    key: 'get',
    value: function get(zipCode) {
      var _this = this;

      var zip = zipCode.replace(/(\d{3})-?(\d{4})/, '$1$2');

      return new Promise(function (resolve, reject) {
        _this.ZipCodeJp.getAddressesOfZipCode(zip, function (err, addresses) {
          if (err) {
            reject(err);
          }
          if (addresses.length === 0) {
            reject([]);
          }
          resolve(addresses[0]);
        });
      });
    }
  }]);

  return ZipSearchLogic;
}();

exports.default = angular.module('leptonApp.ZipSearchLogic', []).service('ZipSearchLogic', [ZipSearchLogic]).name;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function MonthlyMaxDemandPowerService($resource) {
    return $resource('/api/monthly_max_demand_power/:id', { id: '@id' }, {
        show: { method: 'GET', isArray: false },
        showYearly: { method: 'GET', isArray: false, params: { yearly: true } }
    });
}

exports.default = angular.module('leptonApp.MonthlyMaxDemandPowerService', ['ngResource']).factory('MonthlyMaxDemandPowerService', ['$resource', MonthlyMaxDemandPowerService]).name;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _math_util = __webpack_require__(88);

var _math_util2 = _interopRequireDefault(_math_util);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

var _moment = __webpack_require__(468);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var GroupReportUtil = function () {
  /*@ngInject*/
  GroupReportUtil.$inject = ["MathUtil", "PowerFormatter"];
  function GroupReportUtil(MathUtil, PowerFormatter) {
    _classCallCheck(this, GroupReportUtil);

    this.MathUtil = MathUtil;
    this.PowerFormatter = PowerFormatter;
  }

  _createClass(GroupReportUtil, [{
    key: 'createSeriesList',
    value: function createSeriesList(groupActivePowers) {
      var _this = this;

      var shiftRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var seriesList = [];
      groupActivePowers.forEach(function (groupActivePower) {
        groupActivePower.powers.forEach(function (power) {
          var seriesIndex = _this.indexOfObjectArray(seriesList, power.sa_config_id);

          if (seriesIndex === -1) {
            var series = {
              id: power.sa_config_id,
              name: power.pms_service_code,
              location: power.location,
              memo: power.memo,
              data: []
            };

            for (var i = 0; i < shiftRange; i++) {
              series.data.push({ date: null, y: null });
            }
            seriesList.push(series);
          }
        });
      });

      return seriesList;
    }

  }, {
    key: 'createStackSeries',
    value: function createStackSeries(seriesList, groupActivePowers) {
      var _this2 = this;

      var shiftRange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      var sumSeries = { name: '合計値', data: [] };
      for (var i = 0; i < shiftRange; i++) {
        sumSeries.data.push({ date: null, y: null });
      }

      groupActivePowers.forEach(function (groupActivePower) {
        var sum = 0;
        var dateString = groupActivePower.measured_at || groupActivePower.date;
        var date = (0, _moment2.default)(dateString).toDate();

        seriesList.forEach(function (series, seriesIndex) {
          var powerIndex = _this2.indexOfObjectArray(groupActivePower.powers, series.id);
          if (powerIndex === -1) {
            series.data.push({
              date: date,
              y: null
            });
          } else {
            series.data.push({
              date: date,
              y: groupActivePower.powers[powerIndex].value
            });
            sum = _this2.MathUtil.add(sum, groupActivePower.powers[powerIndex].value);
          }
        });

        sumSeries.data.push({
          date: date,
          y: sum
        });
      });

      return [seriesList, [sumSeries]];
    }
  }, {
    key: 'createSumSeries',
    value: function createSumSeries(seriesList) {
      var _this3 = this;

      var sumData = [];
      var sumSeries = { name: '合計値', data: [] };

      if (seriesList.length === 0) {
        return sumSeries;
      }

      var _loop = function _loop(i) {
        var sum = 0;
        seriesList.forEach(function (series) {
          if (series.data[i] && series.data[i].y) {
            sum = _this3.MathUtil.add(sum, series.data[i].y);
          }
        });

        sumSeries.data.push({
          date: seriesList[0].data[i].date,
          y: sum
        });
      };

      for (var i = 0; i < seriesList[0].data.length; i++) {
        _loop(i);
      }

      return sumSeries;
    }
  }, {
    key: 'createDiffArray',
    value: function createDiffArray(seriesList) {
      var _this4 = this;

      seriesList.forEach(function (series) {
        var data = [];
        series.data.reduce(function (pre, current) {
          if (pre && current && current.y !== 0 && pre.y !== 0) {
            data.push({
              date: current.date,
              y: _this4.PowerFormatter.calcDailyPowerDiff(current.y, pre.y)
            });
          } else {
            data.push({
              date: current.date,
              y: null
            });
          }

          return current;
        }, { y: 0, date: null });

        data.shift();
        series.data = data;
      });

      return seriesList;
    }
  }, {
    key: 'indexOfObjectArray',
    value: function indexOfObjectArray(array, id) {
      var index = -1;
      array.some(function (element, i) {
        if ((element.id || element.sa_config_id) === id) {
          index = i;
          return;
        }
      });

      return index;
    }
  }]);

  return GroupReportUtil;
}();

exports.default = angular.module('leptonApp.GroupReportUtil', [_math_util2.default, _powerFormatter2.default]).service('GroupReportUtil', ['MathUtil', 'PowerFormatter', GroupReportUtil]).name;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function DailyMaxDemandPowerService($resource) {
    return $resource('/api/daily_max_demand_power/:id', { id: '@id' }, {
        show: { method: 'GET', isArray: false }
    });
}

exports.default = angular.module('leptonApp.DailyMaxDemandPowerService', ['ngResource']).factory('DailyMaxDemandPowerService', ['$resource', DailyMaxDemandPowerService]).name;

/***/ }),
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DeviceErrorService = function DeviceErrorService($resource) {
  'ngInject';

  _classCallCheck(this, DeviceErrorService);

  this.api = $resource('/api/device_error/:id', { id: '@id' }, {
    index: { method: 'GET', isArray: true },
    show: { method: 'GET', isArray: false }
  });

  this.oem_api = $resource('/api/oem/device_error', {}, { index: { method: 'GET', isArray: false } });
};
DeviceErrorService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.DeviceErrorService', ['ngResource']).service('DeviceErrorService', ['$resource', DeviceErrorService]).name;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function MonthlyActivePowerService($resource) {
    return $resource('/api/monthly_active_power/:id', { id: '@id' }, {
        show: { method: 'GET', isArray: false }
    });
}

exports.default = angular.module('leptonApp.MonthlyActivePowerService', ['ngResource']).factory('MonthlyActivePowerService', ['$resource', MonthlyActivePowerService]).name;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var EndUserService = function EndUserService($resource) {
    'ngInject';

    _classCallCheck(this, EndUserService);

    this.api = $resource('/api/end_user/:id', { id: '@id' }, {
        index: { method: 'GET', isArray: true },
        show: { method: 'GET', isArray: false },
        create: { method: 'POST', isArray: false },
        update: { method: 'PUT', isArray: false },
        destroy: { method: 'DELETE', isArray: false }
    });

    this.oem_api = $resource('/api/oem/end_user/:id', { id: '@id' }, {
        index: { method: 'GET', isArray: true },
        update: { method: 'PUT', isArray: false }
    });
};
EndUserService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.EndUserService', ['ngResource']).service('EndUserService', ['$resource', EndUserService]).name;

/***/ }),
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var UniqueValidator = function () {
    function UniqueValidator() {
        'ngInject';

        _classCallCheck(this, UniqueValidator);

        this.restrict = 'A';
        this.scope = { unique: '=' };
        this.require = 'ngModel';
    }

    _createClass(UniqueValidator, [{
        key: 'link',
        value: function link(scope, element, attrs, ctrl) {
            ctrl.$validators.unique = function (modelValue, viewValue) {
                var index = scope.unique.indexOf(viewValue);
                if (index === -1) {
                    return true;
                } else {
                    return false;
                }
            };
        }
    }]);

    return UniqueValidator;
}();

exports.default = angular.module('leptonApp.Unique', []).directive('unique', [function () {
    return new UniqueValidator();
}]).name;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var AnnounceService = function AnnounceService($resource) {
    'ngInject';

    _classCallCheck(this, AnnounceService);

    this.api = $resource('/api/announce/:id', { id: '@id' }, {
        index: { method: 'GET', isArray: true },
        show: { method: 'GET' }
    });

    this.oem_api = $resource('/api/oem/announce/:id', { id: '@id' }, {
        index: { method: 'GET', isArray: true },
        show: { method: 'GET' }
    });
};
AnnounceService.$inject = ["$resource"];

exports.default = angular.module('leptinApp.AnnounceService', ['ngResource']).service('AnnounceService', ['$resource', AnnounceService]).name;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var MailTestService = function MailTestService($resource) {
    'ngInject';

    _classCallCheck(this, MailTestService);

    this.api = $resource('/api/mail_test', {}, { create: { method: 'POST', isArray: false } });

    this.oem_api = $resource('/api/oem/mail_test', {}, { create: { method: 'POST', isArray: false } });
};
MailTestService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.MailTestService', ['ngResource']).service('MailTestService', ['$resource', MailTestService]).name;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function GroupActivePowerService($resource) {
    return $resource('/api/group_active_power/:id', { id: '@id' }, { show: { method: 'GET', isArray: false } });
}

exports.default = angular.module('leptonApp.GroupActivePowerService', ['ngResource']).service('GroupActivePowerService', ['$resource', GroupActivePowerService]).name;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function DailyGroupActivePowerService($resource) {
    return $resource('/api/daily_group_active_power/:id', { id: '@id' }, {
        show: { method: 'GET', isArray: false }
    });
}

exports.default = angular.module('leptonApp.DailyGroupActivePowerService', ['ngResource']).factory('DailyGroupActivePowerService', ['$resource', DailyGroupActivePowerService]).name;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var UserPasswordService = function UserPasswordService($resource) {
  'ngInject';

  _classCallCheck(this, UserPasswordService);

  this.api = $resource('/auth_api/end_user_password', {}, {
    create: { method: 'POST', isArray: false }
  });

  this.oem_api = $resource('/auth_api/oem_user_password', {}, {
    create: { method: 'POST', isArray: false }
  });
};
UserPasswordService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.UserPasswordService', ['ngResource']).service('UserPasswordService', ['$resource', UserPasswordService]).name;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var SaConfigSearchService = function SaConfigSearchService($resource) {
  'ngInject';

  _classCallCheck(this, SaConfigSearchService);

  this.oem_api = $resource('/api/oem/sa_config_search/:id', { id: '@id' }, {
    index: { method: 'GET', isArray: true },
    pageIndex: { method: 'GET', isArray: false }
  });
};
SaConfigSearchService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.SaConfigSearchService', ['ngResource']).service('SaConfigSearchService', ['$resource', SaConfigSearchService]).name;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function CompareBookmarkService($resource) {
  return $resource('/api/compare_bookmark/:id', { id: '@id' }, {
    index: { method: 'GET', isArray: true },
    show: { method: 'GET', isArray: false },
    create: { method: 'POST', isArray: false },
    destroy: { method: 'DELETE', isArray: false }
  });
}

exports.default = angular.module('leptonApp.CompareBookmarkService', ['ngResource']).service('CompareBookmarkService', ['$resource', CompareBookmarkService]).name;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var GlobalEventService = function GlobalEventService($resource) {
  'ngInject';

  _classCallCheck(this, GlobalEventService);

  this.api = $resource('/api/global_event/:id', { id: '@id' }, {
    index: { method: 'GET', isArray: true }
  });

  this.oem_api = $resource('/api/oem/global_event/:id', { id: '@id' }, {
    index: { method: 'GET', isArray: true },
    create: { method: 'POST', isArray: false }
  });
};
GlobalEventService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.GlobalEventService', ['ngResource']).service('GlobalEventService', ['$resource', GlobalEventService]).name;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var ReadonlyIf = function () {
  function ReadonlyIf() {
    'ngInject';

    _classCallCheck(this, ReadonlyIf);

    this.restrict = 'A';
    this.scope = { readonlyIf: '=' };
  }

  _createClass(ReadonlyIf, [{
    key: 'link',
    value: function link(scope, element) {
      scope.$watch(function () {
        if (!scope.readonlyIf) {
          return;
        }

        angular.forEach(element.find('input'), function (value) {
          var inputElement = angular.element(value);
          inputElement.attr('readonly', 'readonly');
          inputElement.attr('disabled', true);
        });

        angular.forEach(element.find('md-radio-button'), function (value) {
          var radioElement = angular.element(value);
          radioElement.attr('disabled', 'disabled');
        });

        angular.forEach(element.find('md-select'), function (value) {
          var selectElement = angular.element(value);
          selectElement.attr('disabled', 'disabled');
        });

        angular.forEach(element.find('md-option'), function (value) {
          var optionElement = angular.element(value);
          optionElement.attr('disabled', 'disabled');
        });

        angular.forEach(element.find('select'), function (value) {
          var selectElement = angular.element(value);
          selectElement.attr('disabled', 'disabled');
        });

        angular.forEach(element.find('option'), function (value) {
          var optionElement = angular.element(value);
          optionElement.attr('disabled', 'disabled');
        });
      });
    }
  }]);

  return ReadonlyIf;
}();

exports.default = angular.module('leptonApp.ReadonlyIf', []).directive('readonlyIf', [function () {
  return new ReadonlyIf();
}]).name;

/***/ }),
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);
__webpack_require__(621);

module.exports = 'duScroll';

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var InstActivePowerService = function InstActivePowerService($resource) {
    'ngInject';

    _classCallCheck(this, InstActivePowerService);

    this.api = $resource('/api/inst_active_power/:id', { id: '@id' }, {
        show: { method: 'GET', isArray: false },
        create: { method: 'POST', isArray: false },
        update: { method: 'PUT', isArray: false }
    });
};
InstActivePowerService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.InstActivePowerService', ['ngResource']).service('InstActivePowerService', ['$resource', InstActivePowerService]).name;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function ExternalApiCredentialService($resource) {
    return $resource('/api/oem/external_api_credential', {}, {
        index: { method: 'GET', isArray: false },
        create: { method: 'POST', isArray: false }
    });
}

exports.default = angular.module('leptonApp.ExternalApiCredentialService', ['ngResource']).service('ExternalApiCredentialService', ['$resource', ExternalApiCredentialService]).name;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function MissingListService($resource) {
    return $resource('/api/missing_list', {}, { index: { method: 'GET', isArray: true } });
}

exports.default = angular.module('leptonApp.MissingListService', ['ngResource']).factory('MissingListService', ['$resource', MissingListService]).name;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function RetryService($resource) {
    return $resource('/api/retry', {}, { create: { method: 'POST', isArray: false } });
}

exports.default = angular.module('leptonApp.RetryService', ['ngResource']).factory('RetryService', ['$resource', RetryService]).name;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var SaConfigNotifyListService = function SaConfigNotifyListService($resource) {
    'ngInject';

    _classCallCheck(this, SaConfigNotifyListService);

    this.api = $resource('/api/sa_config_notify_list/:id', { id: '@id' }, {
        show: { method: 'GET', isArray: false },
        update: { method: 'PUT', isArray: false }
    });
};
SaConfigNotifyListService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.SaConfigNotifyListService', ['ngResource']).service('SaConfigNotifyListService', ['$resource', SaConfigNotifyListService]).name;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var MailTextService = function MailTextService($resource) {
    'ngInject';

    _classCallCheck(this, MailTextService);

    this.oem_api = $resource('/api/oem/mail_text', {}, {
        index: { method: 'GET', isArray: false },
        create: { method: 'POST', isArray: false }
    });
};
MailTextService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.MailTextService', ['ngResource']).service('MailTextService', ['$resource', MailTextService]).name;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var PredictedPowerService = function PredictedPowerService($resource) {
    'ngInject';

    _classCallCheck(this, PredictedPowerService);

    this.api = $resource('/api/predicted_power/:id', { id: '@id' }, {
        show: { method: 'GET', isArray: false }
    });
};
PredictedPowerService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.PredictedPowerService', ['ngResource']).service('PredictedPowerService', ['$resource', PredictedPowerService]).name;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function MonthlyGroupActivePowerService($resource) {
    return $resource('/api/monthly_group_active_power/:id', { id: '@id' }, {
        show: { method: 'GET', isArray: false }
    });
}

exports.default = angular.module('leptonApp.MonthlyGroupActivePowerService', ['ngResource']).factory('MonthlyGroupActivePowerService', ['$resource', MonthlyGroupActivePowerService]).name;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var SaRebootService = function SaRebootService($resource) {
  'ngInject';

  _classCallCheck(this, SaRebootService);

  this.api = $resource('/api/sa_reboot', {}, {
    reboot: { method: 'POST', isArray: false }
  });

  this.oem_api = $resource('/api/oem/sa_reboot', {}, {
    reboot: { method: 'POST', isArray: false }
  });
};
SaRebootService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.SaRebootService', ['ngResource']).service('SaRebootService', ['$resource', SaRebootService]).name;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OemUserConfirmService = function OemUserConfirmService($resource) {
  'ngInject';

  _classCallCheck(this, OemUserConfirmService);

  this.api = $resource('/auth_api/oem_user_confirm/:token', { token: '@token' }, {
    update: { method: 'PUT', isArray: false }
  });
};
OemUserConfirmService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.OemUserConfirmService', ['ngResource']).service('OemUserConfirmService', ['$resource', OemUserConfirmService]).name;

/***/ }),
/* 558 */,
/* 559 */
/***/ (function(module, exports) {

module.exports = "<table class=\"role-table\" border=\"1\">\n    <tr>\n        <td></td>\n        <td> アカウント情報 変更 </td>\n        <td> 機器情報 変更 </td>\n        <td> 機器情報 閲覧 </td>\n    </tr>\n    <tr>\n        <th>アカウント管理者</th><td>◯</td><td>◯</td><td>◯</td>\n    </tr>\n    <tr>\n        <th>オペレータ</th><td>×</td><td>◯</td><td>◯</td>\n    </tr>\n    <tr>\n        <th>閲覧者</th><td>×</td><td>×</td><td>◯</td>\n    </tr>\n    <tr>\n        <th>制限付き閲覧者</th><td>×</td><td>×</td><td>△<br>(機器が制限されます)</td>\n    </tr>\n</table>\n"

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DemandLevelService = function DemandLevelService($resource) {
  'ngInject';

  _classCallCheck(this, DemandLevelService);

  this.api = $resource('/api/demand_level/:id', { id: '@id' }, {
    update: { method: 'PUT', isArray: false },
    show: { method: 'GET', isArray: false }
  });

  this.oem_api = $resource('/api/oem/demand_level/:id', { id: '@id' }, {
    update: { method: 'PUT', isArray: false },
    show: { method: 'GET', isArray: false }
  });
};
DemandLevelService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.DemandLevelService', ['ngResource']).service('DemandLevelService', ['$resource', DemandLevelService]).name;

/***/ }),
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularAnimate = __webpack_require__(197);

var _angularAnimate2 = _interopRequireDefault(_angularAnimate);

var _angularCookies = __webpack_require__(94);

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

var _angularSanitize = __webpack_require__(209);

var _angularSanitize2 = _interopRequireDefault(_angularSanitize);

__webpack_require__(210);

__webpack_require__(596);

__webpack_require__(597);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMessages = __webpack_require__(185);

var _angularMessages2 = _interopRequireDefault(_angularMessages);

var _angularValidationMatch = __webpack_require__(187);

var _angularValidationMatch2 = _interopRequireDefault(_angularValidationMatch);

var _angularCookie = __webpack_require__(214);

var _angularCookie2 = _interopRequireDefault(_angularCookie);

var _ngTokenAuth = __webpack_require__(215);

var _ngTokenAuth2 = _interopRequireDefault(_ngTokenAuth);

var _angularMaterial = __webpack_require__(216);

var _angularMaterial2 = _interopRequireDefault(_angularMaterial);

var _angularScroll = __webpack_require__(547);

var _angularScroll2 = _interopRequireDefault(_angularScroll);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _app = __webpack_require__(622);

var _account = __webpack_require__(623);

var _account2 = _interopRequireDefault(_account);

var _main = __webpack_require__(628);

var _main2 = _interopRequireDefault(_main);

__webpack_require__(631);

__webpack_require__(632);

var _util = __webpack_require__(633);

var _util2 = _interopRequireDefault(_util);

__webpack_require__(635);

__webpack_require__(636);

__webpack_require__(637);

__webpack_require__(638);

__webpack_require__(639);

__webpack_require__(640);

__webpack_require__(641);

__webpack_require__(642);

__webpack_require__(643);

__webpack_require__(644);

__webpack_require__(645);

__webpack_require__(646);

__webpack_require__(647);

__webpack_require__(648);

__webpack_require__(649);

__webpack_require__(650);

__webpack_require__(651);

__webpack_require__(652);

__webpack_require__(653);

__webpack_require__(654);

__webpack_require__(655);

__webpack_require__(656);

__webpack_require__(657);

__webpack_require__(658);

__webpack_require__(659);

__webpack_require__(660);

__webpack_require__(661);

__webpack_require__(662);

__webpack_require__(663);

__webpack_require__(664);

__webpack_require__(665);

__webpack_require__(666);

var _chart = __webpack_require__(70);

var _chart2 = _interopRequireDefault(_chart);

var _auth_util = __webpack_require__(668);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _login_state_control = __webpack_require__(669);

var _login_state_control2 = _interopRequireDefault(_login_state_control);

var _unique_validator = __webpack_require__(488);

var _unique_validator2 = _interopRequireDefault(_unique_validator);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

var _compare_weather = __webpack_require__(128);

var _compare_weather2 = _interopRequireDefault(_compare_weather);

var _zipSearch = __webpack_require__(217);

var _zipSearch2 = _interopRequireDefault(_zipSearch);

var _role_to_string = __webpack_require__(670);

var _role_to_string2 = _interopRequireDefault(_role_to_string);

var _get_error_message = __webpack_require__(190);

var _get_error_message2 = _interopRequireDefault(_get_error_message);

var _decimal = __webpack_require__(671);

var _decimal2 = _interopRequireDefault(_decimal);

var _day = __webpack_require__(672);

var _day2 = _interopRequireDefault(_day);

var _normalCount = __webpack_require__(673);

var _normalCount2 = _interopRequireDefault(_normalCount);

var _errorCount = __webpack_require__(674);

var _errorCount2 = _interopRequireDefault(_errorCount);

var _companyListTitle = __webpack_require__(675);

var _companyListTitle2 = _interopRequireDefault(_companyListTitle);

var _weatherName = __webpack_require__(676);

var _weatherName2 = _interopRequireDefault(_weatherName);

var _csv_downloader = __webpack_require__(677);

var _csv_downloader2 = _interopRequireDefault(_csv_downloader);

var _bulk_downloader = __webpack_require__(678);

var _bulk_downloader2 = _interopRequireDefault(_bulk_downloader);

var _datepicker = __webpack_require__(679);

var _datepicker2 = _interopRequireDefault(_datepicker);

var _dead_duration_selector = __webpack_require__(682);

var _dead_duration_selector2 = _interopRequireDefault(_dead_duration_selector);

var _deviceIndexItem = __webpack_require__(684);

var _deviceIndexItem2 = _interopRequireDefault(_deviceIndexItem);

var _pagination = __webpack_require__(686);

var _pagination2 = _interopRequireDefault(_pagination);

var _simpleDemandDisplay = __webpack_require__(688);

var _simpleDemandDisplay2 = _interopRequireDefault(_simpleDemandDisplay);

var _tabletDemandDisplay = __webpack_require__(690);

var _tabletDemandDisplay2 = _interopRequireDefault(_tabletDemandDisplay);

var _weather = __webpack_require__(692);

var _weather2 = _interopRequireDefault(_weather);

var _saInfo = __webpack_require__(695);

var _saInfo2 = _interopRequireDefault(_saInfo);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _dist_stock = __webpack_require__(87);

var _dist_stock2 = _interopRequireDefault(_dist_stock);

var _active_power = __webpack_require__(144);

var _active_power2 = _interopRequireDefault(_active_power);

var _inst_active_power = __webpack_require__(548);

var _inst_active_power2 = _interopRequireDefault(_inst_active_power);

var _device_error = __webpack_require__(469);

var _device_error2 = _interopRequireDefault(_device_error);

var _external_api_credential = __webpack_require__(549);

var _external_api_credential2 = _interopRequireDefault(_external_api_credential);

var _service_stock = __webpack_require__(134);

var _service_stock2 = _interopRequireDefault(_service_stock);

var _announce = __webpack_require__(489);

var _announce2 = _interopRequireDefault(_announce);

var _monthly_max_demand_power = __webpack_require__(218);

var _monthly_max_demand_power2 = _interopRequireDefault(_monthly_max_demand_power);

var _missing_list = __webpack_require__(550);

var _missing_list2 = _interopRequireDefault(_missing_list);

var _retry = __webpack_require__(551);

var _retry2 = _interopRequireDefault(_retry);

var _sa_config_notify_list = __webpack_require__(552);

var _sa_config_notify_list2 = _interopRequireDefault(_sa_config_notify_list);

var _mail_test = __webpack_require__(490);

var _mail_test2 = _interopRequireDefault(_mail_test);

var _mail_text = __webpack_require__(553);

var _mail_text2 = _interopRequireDefault(_mail_text);

var _demand_prediction_logic = __webpack_require__(698);

var _demand_prediction_logic2 = _interopRequireDefault(_demand_prediction_logic);

var _math_util = __webpack_require__(88);

var _math_util2 = _interopRequireDefault(_math_util);

var _event = __webpack_require__(90);

var _event2 = _interopRequireDefault(_event);

var _predicted_power = __webpack_require__(554);

var _predicted_power2 = _interopRequireDefault(_predicted_power);

var _daily_active_power = __webpack_require__(191);

var _daily_active_power2 = _interopRequireDefault(_daily_active_power);

var _monthly_active_power = __webpack_require__(470);

var _monthly_active_power2 = _interopRequireDefault(_monthly_active_power);

var _sa_group = __webpack_require__(201);

var _sa_group2 = _interopRequireDefault(_sa_group);

var _group_active_power = __webpack_require__(491);

var _group_active_power2 = _interopRequireDefault(_group_active_power);

var _daily_group_active_power = __webpack_require__(492);

var _daily_group_active_power2 = _interopRequireDefault(_daily_group_active_power);

var _monthly_group_active_power = __webpack_require__(555);

var _monthly_group_active_power2 = _interopRequireDefault(_monthly_group_active_power);

var _group_report_util = __webpack_require__(219);

var _group_report_util2 = _interopRequireDefault(_group_report_util);

var _sa_reboot = __webpack_require__(556);

var _sa_reboot2 = _interopRequireDefault(_sa_reboot);

var _oem_user = __webpack_require__(129);

var _oem_user2 = _interopRequireDefault(_oem_user);

var _oem_user_confirm = __webpack_require__(557);

var _oem_user_confirm2 = _interopRequireDefault(_oem_user_confirm);

var _user_password = __webpack_require__(493);

var _user_password2 = _interopRequireDefault(_user_password);

var _sa_config_search = __webpack_require__(494);

var _sa_config_search2 = _interopRequireDefault(_sa_config_search);

var _weather3 = __webpack_require__(130);

var _weather4 = _interopRequireDefault(_weather3);

var _daily_weather = __webpack_require__(192);

var _daily_weather2 = _interopRequireDefault(_daily_weather);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

var _compare_bookmark = __webpack_require__(495);

var _compare_bookmark2 = _interopRequireDefault(_compare_bookmark);

var _global_event = __webpack_require__(496);

var _global_event2 = _interopRequireDefault(_global_event);

var _home = __webpack_require__(700);

var _home2 = _interopRequireDefault(_home);

var _demand_index = __webpack_require__(704);

var _demand_index2 = _interopRequireDefault(_demand_index);

var _demand_detail = __webpack_require__(707);

var _demand_detail2 = _interopRequireDefault(_demand_detail);

var _demand_monitoring = __webpack_require__(711);

var _demand_monitoring2 = _interopRequireDefault(_demand_monitoring);

var _external_api_credential3 = __webpack_require__(714);

var _external_api_credential4 = _interopRequireDefault(_external_api_credential3);

var _device_error3 = __webpack_require__(717);

var _device_error4 = _interopRequireDefault(_device_error3);

var _device_index = __webpack_require__(720);

var _device_index2 = _interopRequireDefault(_device_index);

var _device_config_edit = __webpack_require__(723);

var _device_config_edit2 = _interopRequireDefault(_device_config_edit);

var _controller_edit = __webpack_require__(726);

var _controller_edit2 = _interopRequireDefault(_controller_edit);

var _retry3 = __webpack_require__(729);

var _retry4 = _interopRequireDefault(_retry3);

var _demand_report_index = __webpack_require__(732);

var _demand_report_index2 = _interopRequireDefault(_demand_report_index);

var _demand_report_show = __webpack_require__(735);

var _demand_report_show2 = _interopRequireDefault(_demand_report_show);

var _daily_demand_report = __webpack_require__(738);

var _daily_demand_report2 = _interopRequireDefault(_daily_demand_report);

var _weekly_demand_report = __webpack_require__(742);

var _weekly_demand_report2 = _interopRequireDefault(_weekly_demand_report);

var _monthly_demand_report = __webpack_require__(746);

var _monthly_demand_report2 = _interopRequireDefault(_monthly_demand_report);

var _yearly_demand_report = __webpack_require__(750);

var _yearly_demand_report2 = _interopRequireDefault(_yearly_demand_report);

var _end_user_index = __webpack_require__(754);

var _end_user_index2 = _interopRequireDefault(_end_user_index);

var _end_user_create = __webpack_require__(757);

var _end_user_create2 = _interopRequireDefault(_end_user_create);

var _end_user_edit = __webpack_require__(760);

var _end_user_edit2 = _interopRequireDefault(_end_user_edit);

var _end_user_confirm = __webpack_require__(763);

var _end_user_confirm2 = _interopRequireDefault(_end_user_confirm);

var _notify_list_index = __webpack_require__(767);

var _notify_list_index2 = _interopRequireDefault(_notify_list_index);

var _notify_list_show = __webpack_require__(770);

var _notify_list_show2 = _interopRequireDefault(_notify_list_show);

var _demand_control_index = __webpack_require__(773);

var _demand_control_index2 = _interopRequireDefault(_demand_control_index);

var _demand_control_edit = __webpack_require__(776);

var _demand_control_edit2 = _interopRequireDefault(_demand_control_edit);

var _daily_active_report = __webpack_require__(779);

var _daily_active_report2 = _interopRequireDefault(_daily_active_report);

var _weekly_active_report = __webpack_require__(783);

var _weekly_active_report2 = _interopRequireDefault(_weekly_active_report);

var _monthly_active_report = __webpack_require__(787);

var _monthly_active_report2 = _interopRequireDefault(_monthly_active_report);

var _yearly_active_report = __webpack_require__(791);

var _yearly_active_report2 = _interopRequireDefault(_yearly_active_report);

var _demand_histogram = __webpack_require__(795);

var _demand_histogram2 = _interopRequireDefault(_demand_histogram);

var _sa_group_index = __webpack_require__(799);

var _sa_group_index2 = _interopRequireDefault(_sa_group_index);

var _sa_group_create = __webpack_require__(802);

var _sa_group_create2 = _interopRequireDefault(_sa_group_create);

var _sa_group_edit = __webpack_require__(805);

var _sa_group_edit2 = _interopRequireDefault(_sa_group_edit);

var _group_report_show = __webpack_require__(808);

var _group_report_show2 = _interopRequireDefault(_group_report_show);

var _daily_group_report = __webpack_require__(811);

var _daily_group_report2 = _interopRequireDefault(_daily_group_report);

var _weekly_group_report = __webpack_require__(815);

var _weekly_group_report2 = _interopRequireDefault(_weekly_group_report);

var _monthly_group_report = __webpack_require__(819);

var _monthly_group_report2 = _interopRequireDefault(_monthly_group_report);

var _yearly_group_report = __webpack_require__(823);

var _yearly_group_report2 = _interopRequireDefault(_yearly_group_report);

var _daily_price_report = __webpack_require__(827);

var _daily_price_report2 = _interopRequireDefault(_daily_price_report);

var _monthly_price_report = __webpack_require__(831);

var _monthly_price_report2 = _interopRequireDefault(_monthly_price_report);

var _end_user_reconfirm = __webpack_require__(835);

var _end_user_reconfirm2 = _interopRequireDefault(_end_user_reconfirm);

var _deviceCheckList = __webpack_require__(838);

var _deviceCheckList2 = _interopRequireDefault(_deviceCheckList);

var _event_report = __webpack_require__(840);

var _event_report2 = _interopRequireDefault(_event_report);

var _sa_reboot3 = __webpack_require__(844);

var _sa_reboot4 = _interopRequireDefault(_sa_reboot3);

var _statistics_index = __webpack_require__(847);

var _statistics_index2 = _interopRequireDefault(_statistics_index);

var _statistics_show = __webpack_require__(850);

var _statistics_show2 = _interopRequireDefault(_statistics_show);

var _powerStatTable = __webpack_require__(853);

var _powerStatTable2 = _interopRequireDefault(_powerStatTable);

var _powerStatGraphIndex = __webpack_require__(856);

var _powerStatGraphIndex2 = _interopRequireDefault(_powerStatGraphIndex);

var _powerStatGraphEvent = __webpack_require__(859);

var _powerStatGraphEvent2 = _interopRequireDefault(_powerStatGraphEvent);

var _powerStatGraphActive = __webpack_require__(861);

var _powerStatGraphActive2 = _interopRequireDefault(_powerStatGraphActive);

var _powerStatGraphDemand = __webpack_require__(863);

var _powerStatGraphDemand2 = _interopRequireDefault(_powerStatGraphDemand);

var _weatherCorrelationGraph = __webpack_require__(865);

var _weatherCorrelationGraph2 = _interopRequireDefault(_weatherCorrelationGraph);

var _tempCorrelationGraph = __webpack_require__(867);

var _tempCorrelationGraph2 = _interopRequireDefault(_tempCorrelationGraph);

var _compareModal = __webpack_require__(869);

var _compareModal2 = _interopRequireDefault(_compareModal);

var _compareGraphShow = __webpack_require__(873);

var _compareGraphShow2 = _interopRequireDefault(_compareGraphShow);

var _compareGraphDaily = __webpack_require__(878);

var _compareGraphDaily2 = _interopRequireDefault(_compareGraphDaily);

var _compareGraphWeekly = __webpack_require__(881);

var _compareGraphWeekly2 = _interopRequireDefault(_compareGraphWeekly);

var _compareGraphMonthly = __webpack_require__(884);

var _compareGraphMonthly2 = _interopRequireDefault(_compareGraphMonthly);

var _compareGraphYearly = __webpack_require__(887);

var _compareGraphYearly2 = _interopRequireDefault(_compareGraphYearly);

var _compareGraphDailyActive = __webpack_require__(890);

var _compareGraphDailyActive2 = _interopRequireDefault(_compareGraphDailyActive);

var _compareGraphWeekly3 = __webpack_require__(893);

var _compareGraphWeekly4 = _interopRequireDefault(_compareGraphWeekly3);

var _compareGraphMonthlyActive = __webpack_require__(896);

var _compareGraphMonthlyActive2 = _interopRequireDefault(_compareGraphMonthlyActive);

var _compareGraphYearlyActive = __webpack_require__(899);

var _compareGraphYearlyActive2 = _interopRequireDefault(_compareGraphYearlyActive);

var _compareGraphIndex = __webpack_require__(902);

var _compareGraphIndex2 = _interopRequireDefault(_compareGraphIndex);

var _global_event3 = __webpack_require__(906);

var _global_event4 = _interopRequireDefault(_global_event3);

var _login = __webpack_require__(909);

var _login2 = _interopRequireDefault(_login);

var _oem_main = __webpack_require__(912);

var _oem_main2 = _interopRequireDefault(_oem_main);

var _oem_home = __webpack_require__(915);

var _oem_home2 = _interopRequireDefault(_oem_home);

var _company_create = __webpack_require__(918);

var _company_create2 = _interopRequireDefault(_company_create);

var _company_index = __webpack_require__(921);

var _company_index2 = _interopRequireDefault(_company_index);

var _company_edit = __webpack_require__(924);

var _company_edit2 = _interopRequireDefault(_company_edit);

var _device_config_create = __webpack_require__(927);

var _device_config_create2 = _interopRequireDefault(_device_config_create);

var _device_index3 = __webpack_require__(930);

var _device_index4 = _interopRequireDefault(_device_index3);

var _device_config_edit3 = __webpack_require__(933);

var _device_config_edit4 = _interopRequireDefault(_device_config_edit3);

var _device_type_select = __webpack_require__(936);

var _device_type_select2 = _interopRequireDefault(_device_type_select);

var _controller_create = __webpack_require__(939);

var _controller_create2 = _interopRequireDefault(_controller_create);

var _controller_edit3 = __webpack_require__(942);

var _controller_edit4 = _interopRequireDefault(_controller_edit3);

var _notify_list_show3 = __webpack_require__(945);

var _notify_list_show4 = _interopRequireDefault(_notify_list_show3);

var _mail_template = __webpack_require__(949);

var _mail_template2 = _interopRequireDefault(_mail_template);

var _demand_control_index3 = __webpack_require__(952);

var _demand_control_index4 = _interopRequireDefault(_demand_control_index3);

var _demand_control_edit3 = __webpack_require__(955);

var _demand_control_edit4 = _interopRequireDefault(_demand_control_edit3);

var _sa_reboot5 = __webpack_require__(958);

var _sa_reboot6 = _interopRequireDefault(_sa_reboot5);

var _sa_reboot_item = __webpack_require__(961);

var _sa_reboot_item2 = _interopRequireDefault(_sa_reboot_item);

var _oem_user_index = __webpack_require__(964);

var _oem_user_index2 = _interopRequireDefault(_oem_user_index);

var _oem_user_create = __webpack_require__(967);

var _oem_user_create2 = _interopRequireDefault(_oem_user_create);

var _oem_user_edit = __webpack_require__(970);

var _oem_user_edit2 = _interopRequireDefault(_oem_user_edit);

var _oem_user_confirm3 = __webpack_require__(973);

var _oem_user_confirm4 = _interopRequireDefault(_oem_user_confirm3);

var _oem_user_reconfirm = __webpack_require__(976);

var _oem_user_reconfirm2 = _interopRequireDefault(_oem_user_reconfirm);

var _device_config_search_form = __webpack_require__(979);

var _device_config_search_form2 = _interopRequireDefault(_device_config_search_form);

var _global_event5 = __webpack_require__(981);

var _global_event6 = _interopRequireDefault(_global_event5);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

_angular2.default.module('leptonApp', [_angularAnimate2.default, _angularCookies2.default, _angularResource2.default, _angularSanitize2.default, _angularMessages2.default, _angularValidationMatch2.default, 'btford.socket-io', _angularjs2.default, _angularCookie2.default, _ngTokenAuth2.default, 'ng-drag-scroll', 'bw.paging', _account2.default, _angularMaterial2.default, _angularMoment2.default, _angularScroll2.default, _main2.default, _chart2.default, _sa_config2.default, _dist_stock2.default, _active_power2.default, _inst_active_power2.default, _device_error2.default, _service_stock2.default, _announce2.default, _external_api_credential2.default, _sa_config_search2.default, _compare_weather2.default, _zipSearch2.default, _monthly_max_demand_power2.default, _missing_list2.default, _retry2.default, _auth_util2.default, _role_to_string2.default, _weatherName2.default, _get_error_message2.default, _login_state_control2.default, _sa_config_notify_list2.default, _mail_test2.default, _unique_validator2.default, _mail_text2.default, _demand_prediction_logic2.default, _math_util2.default, _event2.default, _predicted_power2.default, _csv_downloader2.default, _datepicker2.default, _dead_duration_selector2.default, _deviceIndexItem2.default, _pagination2.default, _simpleDemandDisplay2.default, _tabletDemandDisplay2.default, _weather2.default, _saInfo2.default, _csv2.default, _sa_group2.default, _group_active_power2.default, _daily_group_active_power2.default, _monthly_group_active_power2.default, _group_report_util2.default, _bulk_downloader2.default, _decimal2.default, _sa_reboot2.default, _oem_user2.default, _daily_active_power2.default, _monthly_active_power2.default, _oem_user_confirm2.default, _user_password2.default, _day2.default, _normalCount2.default, _errorCount2.default, _companyListTitle2.default, _weather4.default, _daily_weather2.default, _powerFormatter2.default, _compare_bookmark2.default, _global_event2.default, _home2.default, _demand_index2.default, _demand_detail2.default, _demand_monitoring2.default, _demand_histogram2.default, _device_error4.default, _external_api_credential4.default, _device_index2.default, _device_config_edit2.default, _retry4.default, _daily_active_report2.default, _weekly_active_report2.default, _monthly_active_report2.default, _yearly_active_report2.default, _demand_report_index2.default, _demand_report_show2.default, _daily_demand_report2.default, _weekly_demand_report2.default, _monthly_demand_report2.default, _yearly_demand_report2.default, _end_user_index2.default, _end_user_create2.default, _company_edit2.default, _end_user_confirm2.default, _end_user_edit2.default, _notify_list_index2.default, _notify_list_show2.default, _controller_edit2.default, _demand_control_index2.default, _demand_control_edit2.default, _sa_group_index2.default, _sa_group_create2.default, _sa_group_edit2.default, _group_report_show2.default, _daily_group_report2.default, _weekly_group_report2.default, _monthly_group_report2.default, _yearly_group_report2.default, _daily_price_report2.default, _monthly_price_report2.default, _login2.default, _oem_main2.default, _oem_home2.default, _company_create2.default, _company_index2.default, _device_config_create2.default, _device_index4.default, _device_config_edit4.default, _notify_list_show4.default, _mail_template2.default, _device_type_select2.default, _controller_create2.default, _controller_edit4.default, _demand_control_index4.default, _demand_control_edit4.default, _sa_reboot6.default, _sa_reboot_item2.default, _oem_user_index2.default, _oem_user_create2.default, _oem_user_edit2.default, _oem_user_confirm4.default, _end_user_reconfirm2.default, _oem_user_reconfirm2.default, _deviceCheckList2.default, _event_report2.default, _device_config_search_form2.default, _sa_reboot4.default, _compareGraphIndex2.default, _global_event4.default, _statistics_index2.default, _statistics_show2.default, _powerStatTable2.default, _powerStatGraphIndex2.default, _powerStatGraphEvent2.default, _powerStatGraphActive2.default, _powerStatGraphDemand2.default, _weatherCorrelationGraph2.default, _tempCorrelationGraph2.default, _compareModal2.default, _compareGraphShow2.default, _compareGraphDaily2.default, _compareGraphWeekly2.default, _compareGraphMonthly2.default, _compareGraphYearly2.default, _compareGraphDailyActive2.default, _compareGraphWeekly4.default, _compareGraphMonthlyActive2.default, _compareGraphYearlyActive2.default, _global_event6.default, 'leptonApp.constants', _util2.default]).config(_app.appConfig).run(["$rootScope", "$location", "$state", "$stateParams", "$auth", "$transitions", "$trace", "AuthUtil", "LoginStateControl", function ($rootScope, $location, $state, $stateParams, $auth, $transitions, $trace, AuthUtil, LoginStateControl) {
  'ngInject';

  $state.defaultErrorHandler(function () {});

  $rootScope.$state = $state;
  $rootScope.$stateParams = $stateParams;

  $rootScope.$on('auth:login-success', function (ev, user) {
    AuthUtil.setUserInfo(user);
    LoginStateControl.goHome(user);
  });

  $rootScope.$on('auth:validation-success', function (ev, user) {
    AuthUtil.setUserInfo(user);
    LoginStateControl.rootToHome(user);
  });

  $rootScope.$on('auth:validation-error', function (ev, user) {
    LoginStateControl.goLogin();
  });

  $rootScope.$on('auth:logout-success', function () {
    AuthUtil.resetUserInfo();
    LoginStateControl.goLogin();
  });

  $transitions.onStart({}, function (trans) {
    var next = trans.to();
    var params = trans.params();

    if (next.name === 'login' || next.name === 'oem_login' || next.name === 'end_user_confirm' || next.name === 'oem_user_confirm' || next.name === 'end_user_reconfirm' || next.name === 'oem_user_reconfirm') {
      return;
    }
    $auth.validateUser().then(function (user) {
      if (next.name.match(/^oem_main\..+$/) && user.configName === 'default') {
        $state.go('main.home');
      } else if (!next.name.match(/^oem_main\..+$/) && user.configName === 'oemUser') {
        $state.go('oem_main.oem_home');
      }
    }).catch(function () {
      next.params = params;
      LoginStateControl.goLogin(next);
    });
  });

  $rootScope.isFullScreen = false;
  $rootScope.isSimpleDisplay = false;
  $rootScope.isTabletDisplay = false;
}]);

_angular2.default.element(document).ready(function () {
  _angular2.default.bootstrap(document, ['leptonApp'], {
    strictDi: true
  });
});

/***/ }),
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!function () {
  "use strict";
  e.$inject = ["e", "t", "n"];
  function e(e, t, n) {
    var o = { scope: { dragScroll: "=" }, restrict: "A", link: function link(o, l, r, a) {
        function c() {
          angular.element(t).on("mouseup", s), angular.element(t).on("mousemove", g);
        }function i() {
          angular.element(t).off("mouseup", s), angular.element(t).off("mousemove", g);
        }function u(e) {
          if (o.dragScroll) {
            for (var t = 0; t < E.length; t++) {
              if (angular.element(e.target).hasClass(E[t])) return !1;
            }o.$apply(function () {
              R(o);
            }), c(), x = !0, v = p = e.clientX, y = S = e.clientY, d(), e.preventDefault(), e.stopPropagation();
          }
        }function s(e) {
          if (o.dragScroll) {
            var t = "drag-scroll-text" in e.target.attributes,
                n = e.clientX >= p - $ && e.clientX <= p + $,
                l = e.clientY >= S - $ && e.clientY <= S + $;x = !1, t && n && l && m(e.target), o.$apply(function () {
              w(o);
            }), i();
          }
        }function g(e) {
          o.dragScroll && (x && (D && "x" !== D || (l[0].scrollLeft -= -v + (v = e.clientX)), D && "y" !== D || (l[0].scrollTop -= -y + (y = e.clientY))), e.preventDefault());
        }function f() {
          l.off("mousedown", u), angular.element(t).off("mouseup", s), angular.element(t).off("mousemove", g);
        }function m(e) {
          var n;t.document.selection ? (n = t.document.body.createTextRange(), n.moveToElementText(e), n.select()) : t.getSelection && (n = t.document.createRange(), n.selectNode(e), t.getSelection().addRange(n));
        }function d() {
          t.getSelection ? t.getSelection().empty ? t.getSelection().empty() : t.getSelection().removeAllRanges && t.getSelection().removeAllRanges() : e.selection && e.selection.empty();
        }var p,
            S,
            v,
            y,
            $ = 5,
            x = !1,
            R = n(r.onDragStart),
            w = n(r.onDragEnd),
            D = r.axis || !1,
            E = r.dragScrollExcludedClasses ? r.dragScrollExcludedClasses.split(",") : [];l.on("mousedown", u), o.$on("$destroy", f);
      } };return o;
  }angular.module("ng-drag-scroll", []).directive("dragScroll", e), e.$inject = ["$document", "$window", "$parse"];
}();

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @ngDoc directive
 * @name ng.directive:paging
 *
 * @description
 * A directive to aid in paging large datasets
 * while requiring a small amount of page
 * information.
 *
 * @element EA
 *
 */
angular.module('bw.paging', []).directive('paging', function () {

    /**
     * The regex expression to use for any replace methods
     * Feel free to tweak / fork values for your application
     */
    var regex = /\{page\}/g;

    /**
     * The angular return value required for the directive
     * Feel free to tweak / fork values for your application
     */
    return {

        // Restrict to elements and attributes
        restrict: 'EA',

        // Assign the angular link function
        link: fieldLink,

        // Assign the angular directive template HTML
        template: fieldTemplate,

        // Assign the angular scope attribute formatting
        scope: {
            page: '=',
            pageSize: '=',
            total: '=',
            disabled: '@',
            dots: '@',
            ulClass: '@',
            activeClass: '@',
            disabledClass: '@',
            adjacent: '@',
            pagingAction: '&',
            pgHref: '@',
            textFirst: '@',
            textLast: '@',
            textNext: '@',
            textPrev: '@',
            textFirstClass: '@',
            textLastClass: '@',
            textNextClass: '@',
            textPrevClass: '@',
            textTitlePage: '@',
            textTitleFirst: '@',
            textTitleLast: '@',
            textTitleNext: '@',
            textTitlePrev: '@'
        }

    };

    /**
     * Link the directive to enable our scope watch values
     *
     * @param {object} scope - Angular link scope
     * @param {object} el - Angular link element
     * @param {object} attrs - Angular link attribute
     */
    function fieldLink(scope, el, attrs) {

        // Hook in our watched items
        scope.$watchCollection('[page,pageSize,total,disabled]', function () {
            build(scope, attrs);
        });
    }

    /**
     * Create our template html 
     * We use a function to figure out how to handle href correctly
     * 
     * @param {object} el - Angular link element
     * @param {object} attrs - Angular link attribute
     */
    function fieldTemplate(el, attrs) {
        return '<ul data-ng-hide="Hide" data-ng-class="ulClass"> ' + '<li ' + 'title="{{Item.title}}" ' + 'data-ng-class="Item.liClass" ' + 'data-ng-repeat="Item in List"> ' + '<a ' + (attrs.pgHref ? 'data-ng-href="{{Item.pgHref}}" ' : 'href ') + 'data-ng-class="Item.aClass" ' + 'data-ng-click="Item.action()" ' + 'data-ng-bind="Item.value">' + '</a> ' + '</li>' + '</ul>';
    }

    /**
     * Assign default scope values from settings
     * Feel free to tweak / fork these for your application
     *
     * @param {Object} scope - The local directive scope object
     * @param {Object} attrs - The local directive attribute object
     */
    function setScopeValues(scope, attrs) {

        scope.List = [];
        scope.Hide = false;

        scope.page = parseInt(scope.page) || 1;
        scope.total = parseInt(scope.total) || 0;
        scope.adjacent = parseInt(scope.adjacent) || 2;

        scope.pgHref = scope.pgHref || '';
        scope.dots = scope.dots || '...';

        scope.ulClass = scope.ulClass || 'pagination';
        scope.activeClass = scope.activeClass || 'active';
        scope.disabledClass = scope.disabledClass || 'disabled';

        scope.textFirst = scope.textFirst || '<<';
        scope.textLast = scope.textLast || '>>';
        scope.textNext = scope.textNext || '>';
        scope.textPrev = scope.textPrev || '<';

        scope.textFirstClass = scope.textFirstClass || '';
        scope.textLastClass = scope.textLastClass || '';
        scope.textNextClass = scope.textNextClass || '';
        scope.textPrevClass = scope.textPrevClass || '';

        scope.textTitlePage = scope.textTitlePage || 'Page {page}';
        scope.textTitleFirst = scope.textTitleFirst || 'First Page';
        scope.textTitleLast = scope.textTitleLast || 'Last Page';
        scope.textTitleNext = scope.textTitleNext || 'Next Page';
        scope.textTitlePrev = scope.textTitlePrev || 'Previous Page';

        scope.hideIfEmpty = evalBoolAttribute(scope, attrs.hideIfEmpty);
        scope.showPrevNext = evalBoolAttribute(scope, attrs.showPrevNext);
        scope.showFirstLast = evalBoolAttribute(scope, attrs.showFirstLast);
        scope.scrollTop = evalBoolAttribute(scope, attrs.scrollTop);
        scope.isDisabled = evalBoolAttribute(scope, attrs.disabled);
    }

    /**
     * A helper to perform our boolean eval on attributes
     * This allows flexibility in the attribute for strings and variables in scope
     * 
     * @param {Object} scope - The local directive scope object
     * @param {Object} value - The attribute value of interest
     */
    function evalBoolAttribute(scope, value) {
        return angular.isDefined(value) ? !!scope.$parent.$eval(value) : false;
    }

    /**
     * Validate and clean up any scope values
     * This happens after we have set the scope values
     *
     * @param {Object} scope - The local directive scope object
     * @param {int} pageCount - The last page number or total page count
     */
    function validateScopeValues(scope, pageCount) {

        // Block where the page is larger than the pageCount
        if (scope.page > pageCount) {
            scope.page = pageCount;
        }

        // Block where the page is less than 0
        if (scope.page <= 0) {
            scope.page = 1;
        }

        // Block where adjacent value is 0 or below
        if (scope.adjacent <= 0) {
            scope.adjacent = 2;
        }

        // Hide from page if we have 1 or less pages
        // if directed to hide empty
        if (pageCount <= 1) {
            scope.Hide = scope.hideIfEmpty;
        }
    }

    /**
     * Assign the method action to take when a page is clicked
     *
     * @param {Object} scope - The local directive scope object
     * @param {int} page - The current page of interest
     */
    function internalAction(scope, page) {

        // Block clicks we try to load the active page
        if (scope.page == page) {
            return;
        }

        // Block if we are forcing disabled 
        if (scope.isDisabled) {
            return;
        }

        // Update the page in scope
        scope.page = page;

        // Pass our parameters to the paging action
        scope.pagingAction({
            page: scope.page,
            pageSize: scope.pageSize,
            total: scope.total
        });

        // If allowed scroll up to the top of the page
        if (scope.scrollTop) {
            scrollTo(0, 0);
        }
    }

    /**
     * Add the first, previous, next, and last buttons if desired
     * The logic is defined by the mode of interest
     * This method will simply return if the scope.showPrevNext is false
     * This method will simply return if there are no pages to display
     *
     * @param {Object} scope - The local directive scope object
     * @param {int} pageCount - The last page number or total page count
     * @param {string} mode - The mode of interest either prev or last
     */
    function addPrevNext(scope, pageCount, mode) {

        // Ignore if we are not showing
        // or there are no pages to display
        if (!scope.showPrevNext && !scope.showFirstLast || pageCount < 1) {
            return;
        }

        // Local variables to help determine logic
        var disabled, alpha, beta;

        // Determine logic based on the mode of interest
        // Calculate the previous / next page and if the click actions are allowed
        if (mode === 'prev') {

            disabled = scope.page - 1 <= 0;
            var prevPage = scope.page - 1 <= 0 ? 1 : scope.page - 1;

            if (scope.showFirstLast) {
                alpha = {
                    value: scope.textFirst,
                    title: scope.textTitleFirst,
                    aClass: scope.textFirstClass,
                    page: 1
                };
            }

            if (scope.showPrevNext) {
                beta = {
                    value: scope.textPrev,
                    title: scope.textTitlePrev,
                    aClass: scope.textPrevClass,
                    page: prevPage
                };
            }
        } else {

            disabled = scope.page + 1 > pageCount;
            var nextPage = scope.page + 1 >= pageCount ? pageCount : scope.page + 1;

            if (scope.showPrevNext) {
                alpha = {
                    value: scope.textNext,
                    title: scope.textTitleNext,
                    aClass: scope.textNextClass,
                    page: nextPage
                };
            }

            if (scope.showFirstLast) {
                beta = {
                    value: scope.textLast,
                    title: scope.textTitleLast,
                    aClass: scope.textLastClass,
                    page: pageCount
                };
            }
        }

        // Create the Add Item Function
        var buildItem = function buildItem(item, disabled) {
            return {
                title: item.title,
                aClass: item.aClass,
                value: item.aClass ? '' : item.value,
                liClass: disabled ? scope.disabledClass : '',
                pgHref: disabled ? '' : scope.pgHref.replace(regex, item.page),
                action: function action() {
                    if (!disabled) {
                        internalAction(scope, item.page);
                    }
                }
            };
        };

        // Force disabled if specified
        if (scope.isDisabled) {
            disabled = true;
        }

        // Add alpha items
        if (alpha) {
            var alphaItem = buildItem(alpha, disabled);
            scope.List.push(alphaItem);
        }

        // Add beta items
        if (beta) {
            var betaItem = buildItem(beta, disabled);
            scope.List.push(betaItem);
        }
    }

    /**
     * Adds a range of numbers to our list
     * The range is dependent on the start and finish parameters
     *
     * @param {int} start - The start of the range to add to the paging list
     * @param {int} finish - The end of the range to add to the paging list
     * @param {Object} scope - The local directive scope object
     */
    function addRange(start, finish, scope) {

        // Add our items where i is the page number
        var i = 0;
        for (i = start; i <= finish; i++) {

            var pgHref = scope.pgHref.replace(regex, i);
            var liClass = scope.page == i ? scope.activeClass : '';

            // Handle items that are affected by disabled
            if (scope.isDisabled) {
                pgHref = '';
                liClass = scope.disabledClass;
            }

            scope.List.push({
                value: i,
                title: scope.textTitlePage.replace(regex, i),
                liClass: liClass,
                pgHref: pgHref,
                action: function action() {
                    internalAction(scope, this.value);
                }
            });
        }
    }

    /**
     * Add Dots ie: 1 2 [...] 10 11 12 [...] 56 57
     * This is my favorite function not going to lie
     *
     * @param {Object} scope - The local directive scope object
     */
    function addDots(scope) {
        scope.List.push({
            value: scope.dots,
            liClass: scope.disabledClass
        });
    }

    /**
     * Add the first or beginning items in our paging list
     * We leverage the 'next' parameter to determine if the dots are required
     *
     * @param {Object} scope - The local directive scope object
     * @param {int} next - the next page number in the paging sequence
     */
    function addFirst(scope, next) {

        addRange(1, 2, scope);

        // We ignore dots if the next value is 3
        // ie: 1 2 [...] 3 4 5 becomes just 1 2 3 4 5
        if (next != 3) {
            addDots(scope);
        }
    }

    /**
     * Add the last or end items in our paging list
     * We leverage the 'prev' parameter to determine if the dots are required
     *
     * @param {int} pageCount - The last page number or total page count
     * @param {Object} scope - The local directive scope object
     * @param {int} prev - the previous page number in the paging sequence
     */
    // Add Last Pages
    function addLast(pageCount, scope, prev) {

        // We ignore dots if the previous value is one less that our start range
        // ie: 1 2 3 4 [...] 5 6  becomes just 1 2 3 4 5 6
        if (prev != pageCount - 2) {
            addDots(scope);
        }

        addRange(pageCount - 1, pageCount, scope);
    }

    /**
     * The main build function used to determine the paging logic
     * Feel free to tweak / fork values for your application
     *
     * @param {Object} scope - The local directive scope object
     * @param {Object} attrs - The local directive attribute object
     */
    function build(scope, attrs) {

        // Block divide by 0 and empty page size
        if (!scope.pageSize || scope.pageSize <= 0) {
            scope.pageSize = 1;
        }

        // Determine the last page or total page count
        var pageCount = Math.ceil(scope.total / scope.pageSize);

        // Set the default scope values where needed
        setScopeValues(scope, attrs);

        // Validate the scope values to protect against strange states
        validateScopeValues(scope, pageCount);

        // Create the beginning and end page values
        var start, finish;

        // Calculate the full adjacency value
        var fullAdjacentSize = scope.adjacent * 2 + 2;

        // Add the Next and Previous buttons to our list
        addPrevNext(scope, pageCount, 'prev');

        // If the page count is less than the full adjacnet size
        // Then we simply display all the pages, Otherwise we calculate the proper paging display
        if (pageCount <= fullAdjacentSize + 2) {

            start = 1;
            addRange(start, pageCount, scope);
        } else {

            // Determine if we are showing the beginning of the paging list
            // We know it is the beginning if the page - adjacent is <= 2
            if (scope.page - scope.adjacent <= 2) {

                start = 1;
                finish = 1 + fullAdjacentSize;

                addRange(start, finish, scope);
                addLast(pageCount, scope, finish);
            }

            // Determine if we are showing the middle of the paging list
            // We know we are either in the middle or at the end since the beginning is ruled out above
            // So we simply check if we are not at the end
            // Again 2 is hard coded as we always display two pages after the dots
            else if (scope.page < pageCount - (scope.adjacent + 2)) {

                    start = scope.page - scope.adjacent;
                    finish = scope.page + scope.adjacent;

                    addFirst(scope, start);
                    addRange(start, finish, scope);
                    addLast(pageCount, scope, finish);
                }

                // If nothing else we conclude we are at the end of the paging list
                // We know this since we have already ruled out the beginning and middle above
                else {

                        start = pageCount - fullAdjacentSize;
                        finish = pageCount;

                        addFirst(scope, start);
                        addRange(start, finish, scope);
                    }
        }

        // Add the next and last buttons to our paging list
        addPrevNext(scope, pageCount, 'next');
    }
});

/***/ }),
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

/**
  * x is a value between 0 and 1, indicating where in the animation you are.
  */
var duScrollDefaultEasing = function duScrollDefaultEasing(x) {
  'use strict';

  if (x < 0.5) {
    return Math.pow(x * 2, 2) / 2;
  }
  return 1 - Math.pow((1 - x) * 2, 2) / 2;
};

var duScroll = angular.module('duScroll', ['duScroll.scrollspy', 'duScroll.smoothScroll', 'duScroll.scrollContainer', 'duScroll.spyContext', 'duScroll.scrollHelpers'])
//Default animation duration for smoothScroll directive
.value('duScrollDuration', 350)
//Scrollspy debounce interval, set to 0 to disable
.value('duScrollSpyWait', 100)
//Scrollspy forced refresh interval, use if your content changes or reflows without scrolling.
//0 to disable
.value('duScrollSpyRefreshInterval', 0)
//Wether or not multiple scrollspies can be active at once
.value('duScrollGreedy', false)
//Default offset for smoothScroll directive
.value('duScrollOffset', 0)
//Default easing function for scroll animation
.value('duScrollEasing', duScrollDefaultEasing)
//Which events on the container (such as body) should cancel scroll animations
.value('duScrollCancelOnEvents', 'scroll mousedown mousewheel touchmove keydown')
//Whether or not to activate the last scrollspy, when page/container bottom is reached
.value('duScrollBottomSpy', false)
//Active class name
.value('duScrollActiveClass', 'active');

if (typeof module !== 'undefined' && module && module.exports) {
  module.exports = duScroll;
}

angular.module('duScroll.scrollHelpers', ['duScroll.requestAnimation']).run(["$window", "$q", "cancelAnimation", "requestAnimation", "duScrollEasing", "duScrollDuration", "duScrollOffset", "duScrollCancelOnEvents", function ($window, $q, cancelAnimation, requestAnimation, duScrollEasing, duScrollDuration, duScrollOffset, duScrollCancelOnEvents) {
  'use strict';

  var proto = {};

  var isDocument = function isDocument(el) {
    return typeof HTMLDocument !== 'undefined' && el instanceof HTMLDocument || el.nodeType && el.nodeType === el.DOCUMENT_NODE;
  };

  var isElement = function isElement(el) {
    return typeof HTMLElement !== 'undefined' && el instanceof HTMLElement || el.nodeType && el.nodeType === el.ELEMENT_NODE;
  };

  var unwrap = function unwrap(el) {
    return isElement(el) || isDocument(el) ? el : el[0];
  };

  proto.duScrollTo = function (left, top, duration, easing) {
    var aliasFn;
    if (angular.isElement(left)) {
      aliasFn = this.duScrollToElement;
    } else if (angular.isDefined(duration)) {
      aliasFn = this.duScrollToAnimated;
    }
    if (aliasFn) {
      return aliasFn.apply(this, arguments);
    }
    var el = unwrap(this);
    if (isDocument(el)) {
      return $window.scrollTo(left, top);
    }
    el.scrollLeft = left;
    el.scrollTop = top;
  };

  var scrollAnimation, deferred;
  proto.duScrollToAnimated = function (left, top, duration, easing) {
    if (duration && !easing) {
      easing = duScrollEasing;
    }
    var startLeft = this.duScrollLeft(),
        startTop = this.duScrollTop(),
        deltaLeft = Math.round(left - startLeft),
        deltaTop = Math.round(top - startTop);

    var startTime = null,
        progress = 0;
    var el = this;

    var cancelScrollAnimation = function cancelScrollAnimation($event) {
      if (!$event || progress && $event.which > 0) {
        if (duScrollCancelOnEvents) {
          el.unbind(duScrollCancelOnEvents, cancelScrollAnimation);
        }
        cancelAnimation(scrollAnimation);
        deferred.reject();
        scrollAnimation = null;
      }
    };

    if (scrollAnimation) {
      cancelScrollAnimation();
    }
    deferred = $q.defer();

    if (duration === 0 || !deltaLeft && !deltaTop) {
      if (duration === 0) {
        el.duScrollTo(left, top);
      }
      deferred.resolve();
      return deferred.promise;
    }

    var animationStep = function animationStep(timestamp) {
      if (startTime === null) {
        startTime = timestamp;
      }

      progress = timestamp - startTime;
      var percent = progress >= duration ? 1 : easing(progress / duration);

      el.scrollTo(startLeft + Math.ceil(deltaLeft * percent), startTop + Math.ceil(deltaTop * percent));
      if (percent < 1) {
        scrollAnimation = requestAnimation(animationStep);
      } else {
        if (duScrollCancelOnEvents) {
          el.unbind(duScrollCancelOnEvents, cancelScrollAnimation);
        }
        scrollAnimation = null;
        deferred.resolve();
      }
    };

    //Fix random mobile safari bug when scrolling to top by hitting status bar
    el.duScrollTo(startLeft, startTop);

    if (duScrollCancelOnEvents) {
      el.bind(duScrollCancelOnEvents, cancelScrollAnimation);
    }

    scrollAnimation = requestAnimation(animationStep);
    return deferred.promise;
  };

  proto.duScrollToElement = function (target, offset, duration, easing) {
    var el = unwrap(this);
    if (!angular.isNumber(offset) || isNaN(offset)) {
      offset = duScrollOffset;
    }
    var top = this.duScrollTop() + unwrap(target).getBoundingClientRect().top - offset;
    if (isElement(el)) {
      top -= el.getBoundingClientRect().top;
    }
    return this.duScrollTo(0, top, duration, easing);
  };

  proto.duScrollLeft = function (value, duration, easing) {
    if (angular.isNumber(value)) {
      return this.duScrollTo(value, this.duScrollTop(), duration, easing);
    }
    var el = unwrap(this);
    if (isDocument(el)) {
      return $window.scrollX || document.documentElement.scrollLeft || document.body.scrollLeft;
    }
    return el.scrollLeft;
  };
  proto.duScrollTop = function (value, duration, easing) {
    if (angular.isNumber(value)) {
      return this.duScrollTo(this.duScrollLeft(), value, duration, easing);
    }
    var el = unwrap(this);
    if (isDocument(el)) {
      return $window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
    }
    return el.scrollTop;
  };

  proto.duScrollToElementAnimated = function (target, offset, duration, easing) {
    return this.duScrollToElement(target, offset, duration || duScrollDuration, easing);
  };

  proto.duScrollTopAnimated = function (top, duration, easing) {
    return this.duScrollTop(top, duration || duScrollDuration, easing);
  };

  proto.duScrollLeftAnimated = function (left, duration, easing) {
    return this.duScrollLeft(left, duration || duScrollDuration, easing);
  };

  angular.forEach(proto, function (fn, key) {
    angular.element.prototype[key] = fn;

    //Remove prefix if not already claimed by jQuery / ui.utils
    var unprefixed = key.replace(/^duScroll/, 'scroll');
    if (angular.isUndefined(angular.element.prototype[unprefixed])) {
      angular.element.prototype[unprefixed] = fn;
    }
  });
}]);

//Adapted from https://gist.github.com/paulirish/1579671
angular.module('duScroll.polyfill', []).factory('polyfill', ["$window", function ($window) {
  'use strict';

  var vendors = ['webkit', 'moz', 'o', 'ms'];

  return function (fnName, fallback) {
    if ($window[fnName]) {
      return $window[fnName];
    }
    var suffix = fnName.substr(0, 1).toUpperCase() + fnName.substr(1);
    for (var key, i = 0; i < vendors.length; i++) {
      key = vendors[i] + suffix;
      if ($window[key]) {
        return $window[key];
      }
    }
    return fallback;
  };
}]);

angular.module('duScroll.requestAnimation', ['duScroll.polyfill']).factory('requestAnimation', ["polyfill", "$timeout", function (polyfill, $timeout) {
  'use strict';

  var lastTime = 0;
  var fallback = function fallback(callback, element) {
    var currTime = new Date().getTime();
    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
    var id = $timeout(function () {
      callback(currTime + timeToCall);
    }, timeToCall);
    lastTime = currTime + timeToCall;
    return id;
  };

  return polyfill('requestAnimationFrame', fallback);
}]).factory('cancelAnimation', ["polyfill", "$timeout", function (polyfill, $timeout) {
  'use strict';

  var fallback = function fallback(promise) {
    $timeout.cancel(promise);
  };

  return polyfill('cancelAnimationFrame', fallback);
}]);

angular.module('duScroll.spyAPI', ['duScroll.scrollContainerAPI']).factory('spyAPI', ["$rootScope", "$timeout", "$interval", "$window", "$document", "scrollContainerAPI", "duScrollGreedy", "duScrollSpyWait", "duScrollSpyRefreshInterval", "duScrollBottomSpy", "duScrollActiveClass", function ($rootScope, $timeout, $interval, $window, $document, scrollContainerAPI, duScrollGreedy, duScrollSpyWait, duScrollSpyRefreshInterval, duScrollBottomSpy, duScrollActiveClass) {
  'use strict';

  var createScrollHandler = function createScrollHandler(context) {
    var timer = false,
        queued = false;
    var handler = function handler() {
      queued = false;
      var container = context.container,
          containerEl = container[0],
          containerOffset = 0,
          bottomReached;

      if (typeof HTMLElement !== 'undefined' && containerEl instanceof HTMLElement || containerEl.nodeType && containerEl.nodeType === containerEl.ELEMENT_NODE) {
        containerOffset = containerEl.getBoundingClientRect().top;
        bottomReached = Math.round(containerEl.scrollTop + containerEl.clientHeight) >= containerEl.scrollHeight;
      } else {
        var documentScrollHeight = $document[0].body.scrollHeight || $document[0].documentElement.scrollHeight; // documentElement for IE11
        bottomReached = Math.round($window.pageYOffset + $window.innerHeight) >= documentScrollHeight;
      }
      var compareProperty = duScrollBottomSpy && bottomReached ? 'bottom' : 'top';

      var i, currentlyActive, toBeActive, spies, spy, pos;
      spies = context.spies;
      currentlyActive = context.currentlyActive;
      toBeActive = undefined;

      for (i = 0; i < spies.length; i++) {
        spy = spies[i];
        pos = spy.getTargetPosition();
        if (!pos || !spy.$element) continue;

        if (duScrollBottomSpy && bottomReached || pos.top + spy.offset - containerOffset < 20 && (duScrollGreedy || pos.top * -1 + containerOffset) < pos.height) {
          //Find the one closest the viewport top or the page bottom if it's reached
          if (!toBeActive || toBeActive[compareProperty] < pos[compareProperty]) {
            toBeActive = {
              spy: spy
            };
            toBeActive[compareProperty] = pos[compareProperty];
          }
        }
      }

      if (toBeActive) {
        toBeActive = toBeActive.spy;
      }
      if (currentlyActive === toBeActive || duScrollGreedy && !toBeActive) return;
      if (currentlyActive && currentlyActive.$element) {
        currentlyActive.$element.removeClass(duScrollActiveClass);
        $rootScope.$broadcast('duScrollspy:becameInactive', currentlyActive.$element, angular.element(currentlyActive.getTargetElement()));
      }
      if (toBeActive) {
        toBeActive.$element.addClass(duScrollActiveClass);
        $rootScope.$broadcast('duScrollspy:becameActive', toBeActive.$element, angular.element(toBeActive.getTargetElement()));
      }
      context.currentlyActive = toBeActive;
    };

    if (!duScrollSpyWait) {
      return handler;
    }

    //Debounce for potential performance savings
    return function () {
      if (!timer) {
        handler();
        timer = $timeout(function () {
          timer = false;
          if (queued) {
            handler();
          }
        }, duScrollSpyWait, false);
      } else {
        queued = true;
      }
    };
  };

  var contexts = {};

  var createContext = function createContext($scope) {
    var id = $scope.$id;
    var context = {
      spies: []
    };

    context.handler = createScrollHandler(context);
    contexts[id] = context;

    $scope.$on('$destroy', function () {
      destroyContext($scope);
    });

    return id;
  };

  var destroyContext = function destroyContext($scope) {
    var id = $scope.$id;
    var context = contexts[id],
        container = context.container;
    if (context.intervalPromise) {
      $interval.cancel(context.intervalPromise);
    }
    if (container) {
      container.off('scroll', context.handler);
    }
    delete contexts[id];
  };

  var defaultContextId = createContext($rootScope);

  var getContextForScope = function getContextForScope(scope) {
    if (contexts[scope.$id]) {
      return contexts[scope.$id];
    }
    if (scope.$parent) {
      return getContextForScope(scope.$parent);
    }
    return contexts[defaultContextId];
  };

  var getContextForSpy = function getContextForSpy(spy) {
    var context,
        contextId,
        scope = spy.$scope;
    if (scope) {
      return getContextForScope(scope);
    }
    //No scope, most likely destroyed
    for (contextId in contexts) {
      context = contexts[contextId];
      if (context.spies.indexOf(spy) !== -1) {
        return context;
      }
    }
  };

  var isElementInDocument = function isElementInDocument(element) {
    while (element.parentNode) {
      element = element.parentNode;
      if (element === document) {
        return true;
      }
    }
    return false;
  };

  var addSpy = function addSpy(spy) {
    var context = getContextForSpy(spy);
    if (!context) return;
    context.spies.push(spy);
    if (!context.container || !isElementInDocument(context.container)) {
      if (context.container) {
        context.container.off('scroll', context.handler);
      }
      context.container = scrollContainerAPI.getContainer(spy.$scope);
      if (duScrollSpyRefreshInterval && !context.intervalPromise) {
        context.intervalPromise = $interval(context.handler, duScrollSpyRefreshInterval, 0, false);
      }
      context.container.on('scroll', context.handler).triggerHandler('scroll');
    }
  };

  var removeSpy = function removeSpy(spy) {
    var context = getContextForSpy(spy);
    if (spy === context.currentlyActive) {
      $rootScope.$broadcast('duScrollspy:becameInactive', context.currentlyActive.$element);
      context.currentlyActive = null;
    }
    var i = context.spies.indexOf(spy);
    if (i !== -1) {
      context.spies.splice(i, 1);
    }
    spy.$element = null;
  };

  return {
    addSpy: addSpy,
    removeSpy: removeSpy,
    createContext: createContext,
    destroyContext: destroyContext,
    getContextForScope: getContextForScope
  };
}]);

angular.module('duScroll.scrollContainerAPI', []).factory('scrollContainerAPI', ["$document", function ($document) {
  'use strict';

  var containers = {};

  var setContainer = function setContainer(scope, element) {
    var id = scope.$id;
    containers[id] = element;
    return id;
  };

  var getContainerId = function getContainerId(scope) {
    if (containers[scope.$id]) {
      return scope.$id;
    }
    if (scope.$parent) {
      return getContainerId(scope.$parent);
    }
    return;
  };

  var getContainer = function getContainer(scope) {
    var id = getContainerId(scope);
    return id ? containers[id] : $document;
  };

  var removeContainer = function removeContainer(scope) {
    var id = getContainerId(scope);
    if (id) {
      delete containers[id];
    }
  };

  return {
    getContainerId: getContainerId,
    getContainer: getContainer,
    setContainer: setContainer,
    removeContainer: removeContainer
  };
}]);

angular.module('duScroll.smoothScroll', ['duScroll.scrollHelpers', 'duScroll.scrollContainerAPI']).directive('duSmoothScroll', ["duScrollDuration", "duScrollOffset", "scrollContainerAPI", function (duScrollDuration, duScrollOffset, scrollContainerAPI) {
  'use strict';

  return {
    link: function link($scope, $element, $attr) {
      $element.on('click', function (e) {
        if ((!$attr.href || $attr.href.indexOf('#') === -1) && $attr.duSmoothScroll === '') return;

        var id = $attr.href ? $attr.href.replace(/.*(?=#[^\s]+$)/, '').substring(1) : $attr.duSmoothScroll;

        var target = document.getElementById(id) || document.getElementsByName(id)[0];
        if (!target || !target.getBoundingClientRect) return;

        if (e.stopPropagation) e.stopPropagation();
        if (e.preventDefault) e.preventDefault();

        var offset = $attr.offset ? parseInt($attr.offset, 10) : duScrollOffset;
        var duration = $attr.duration ? parseInt($attr.duration, 10) : duScrollDuration;
        var container = scrollContainerAPI.getContainer($scope);

        container.duScrollToElement(angular.element(target), isNaN(offset) ? 0 : offset, isNaN(duration) ? 0 : duration);
      });
    }
  };
}]);

angular.module('duScroll.spyContext', ['duScroll.spyAPI']).directive('duSpyContext', ["spyAPI", function (spyAPI) {
  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function compile(tElement, tAttrs, transclude) {
      return {
        pre: function preLink($scope, iElement, iAttrs, controller) {
          spyAPI.createContext($scope);
        }
      };
    }
  };
}]);

angular.module('duScroll.scrollContainer', ['duScroll.scrollContainerAPI']).directive('duScrollContainer', ["scrollContainerAPI", function (scrollContainerAPI) {
  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function compile(tElement, tAttrs, transclude) {
      return {
        pre: function preLink($scope, iElement, iAttrs, controller) {
          iAttrs.$observe('duScrollContainer', function (element) {
            if (angular.isString(element)) {
              element = document.getElementById(element);
            }

            element = angular.isElement(element) ? angular.element(element) : iElement;
            scrollContainerAPI.setContainer($scope, element);
            $scope.$on('$destroy', function () {
              scrollContainerAPI.removeContainer($scope);
            });
          });
        }
      };
    }
  };
}]);

angular.module('duScroll.scrollspy', ['duScroll.spyAPI']).directive('duScrollspy', ["spyAPI", "duScrollOffset", "$timeout", "$rootScope", function (spyAPI, duScrollOffset, $timeout, $rootScope) {
  'use strict';

  var Spy = function Spy(targetElementOrId, $scope, $element, offset) {
    if (angular.isElement(targetElementOrId)) {
      this.target = targetElementOrId;
    } else if (angular.isString(targetElementOrId)) {
      this.targetId = targetElementOrId;
    }
    this.$scope = $scope;
    this.$element = $element;
    this.offset = offset;
  };

  Spy.prototype.getTargetElement = function () {
    if (!this.target && this.targetId) {
      this.target = document.getElementById(this.targetId) || document.getElementsByName(this.targetId)[0];
    }
    return this.target;
  };

  Spy.prototype.getTargetPosition = function () {
    var target = this.getTargetElement();
    if (target) {
      return target.getBoundingClientRect();
    }
  };

  Spy.prototype.flushTargetCache = function () {
    if (this.targetId) {
      this.target = undefined;
    }
  };

  return {
    link: function link($scope, $element, $attr) {
      var href = $attr.ngHref || $attr.href;
      var targetId;

      if (href && href.indexOf('#') !== -1) {
        targetId = href.replace(/.*(?=#[^\s]+$)/, '').substring(1);
      } else if ($attr.duScrollspy) {
        targetId = $attr.duScrollspy;
      } else if ($attr.duSmoothScroll) {
        targetId = $attr.duSmoothScroll;
      }
      if (!targetId) return;

      // Run this in the next execution loop so that the scroll context has a chance
      // to initialize
      var timeoutPromise = $timeout(function () {
        var spy = new Spy(targetId, $scope, $element, -($attr.offset ? parseInt($attr.offset, 10) : duScrollOffset));
        spyAPI.addSpy(spy);

        $scope.$on('$locationChangeSuccess', spy.flushTargetCache.bind(spy));
        var deregisterOnStateChange = $rootScope.$on('$stateChangeSuccess', spy.flushTargetCache.bind(spy));
        $scope.$on('$destroy', function () {
          spyAPI.removeSpy(spy);
          deregisterOnStateChange();
        });
      }, 0, false);
      $scope.$on('$destroy', function () {
        $timeout.cancel(timeoutPromise);
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(189)(module)))

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


appConfig.$inject = ["$urlRouterProvider", "$locationProvider", "$authProvider", "$mdThemingProvider", "$httpProvider", "$qProvider", "$urlServiceProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appConfig = appConfig;
function appConfig($urlRouterProvider, $locationProvider, $authProvider, $mdThemingProvider, $httpProvider, $qProvider, $urlServiceProvider) {
  'ngInject';

  $urlRouterProvider.otherwise('/');

  $locationProvider.html5Mode(true).hashPrefix('');

  $authProvider.configure([{
    default: {}
  }, {
    oemUser: {
      tokenValidationPath: '/oem_auth/validate_token',
      signOutUrl: '/oem_auth/sign_out',
      emailSignInPath: '/oem_auth/sign_in'
    }
  }]);

  var backgroundMap = $mdThemingProvider.extendPalette('grey', {
    '50': '#ffffff'
  });
  $mdThemingProvider.definePalette('backgroundTheme', backgroundMap);

  $mdThemingProvider.theme('default').backgroundPalette('backgroundTheme');

  $mdThemingProvider.theme('oemTheme').primaryPalette('teal').warnPalette('orange');

  $qProvider.errorOnUnhandledRejections(false);
}

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _account = __webpack_require__(624);

var _account2 = _interopRequireDefault(_account);

var _login = __webpack_require__(626);

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _angular2.default.module('leptonApp.account', [_angularjs2.default, _login2.default]).config(_account2.default).name;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('login', {
        url: '/login',
        template: __webpack_require__(625),
        controller: 'LoginController',
        controllerAs: 'ctrl'
    });
}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = "<div id=\"header\">\n  <md-button id=\"logo\" ui-sref=\"main.home\">\n    <span class=\"fa-stack\" style=\"font-size: 13px\">\n      <i class=\"fa fa-cloud fa-stack-2x\" style=\"color: #1e88e5\"></i>\n      <i class=\"fa fa-plug fa-stack-1x\" style=\"color: #fffde7\"></i>\n    </span>&nbsp; Bルートデマンド監視サービス\n  </md-button>\n</div>\n<md-content class=\"login-content\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <h3><i class=\"fas fa-sign-in-alt fa-fw\"></i> ログイン</h3>\n    </div>\n    <div class=\"col-sm-12\">\n      <form name=\"loginForm\" ng-submit=\"ctrl.disableButton();ctrl.submitLogin()\" role=\"form\" ng-init=\"loginForm = {}\">\n        <md-input-container style=\"margin-right: 15px;\">\n          <label><i class=\"fa fa-user fa-fw\"></i> ログインID</label>\n          <input md-maxlength=\"255\" name=\"email\" ng-model=\"ctrl.loginInfo.email\">\n          <div ng-messages=\"loginForm.email.$error\">\n            <div ng-message=\"required\">入力してください</div>\n            <div ng-message=\"md-maxlength\">255文字以下で記載してください</div>\n          </div>\n        </md-input-container>\n        <md-input-container>\n          <label><i class=\"fa fa-key fa-fw\"></i>パスワード</label>\n          <input md-maxlength=\"128\" name=\"password\" type=\"password\" ng-model=\"ctrl.loginInfo.password\" maxlength=\"128\">\n          <div ng-messages=\"loginForm.password.$error\">\n            <div ng-message=\"required\">入力してください</div>\n            <div ng-message=\"md-maxlength\">128文字以下で記載してください</div>\n          </div>\n        </md-input-container>\n\n        <div class=\"button-row\">\n          <md-button type=\"submit\" ng-disabled=\"buttonDisabled\" class=\"md-primary md-raised\" style=\"margin: 0; padding: 0 30px;\">ログイン</md-button>\n          <span class=\"span-link reconfirm-link\" ui-sref=\"end_user_reconfirm\">パスワードを忘れた場合</span>\n        </div>\n      </form>\n    </div>\n  </div>\n</md-content>\n<md-divider></md-divider>\n<div id=\"footer\">\n  <div><a target=\"_blank\" href=\"http://www.iij.ad.jp/securitypolicy/\">情報セキュリティ基本方針</a></div>\n  <div><a target=\"_blank\" href=\"http://www.iij.ad.jp/privacy/\">個人情報保護ポリシー</a></div>\n  <div>&copy; 2016 Internet Initiative Japan Inc.</div>\n</div>\n"

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _login = __webpack_require__(627);

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = angular.module('leptonApp.login', []).controller('LoginController', _login2.default).name;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var LoginController = function () {
  /*@ngInject*/
  LoginController.$inject = ["$auth", "$scope", "$mdToast"];
  function LoginController($auth, $scope, $mdToast) {
    var _this = this;

    _classCallCheck(this, LoginController);

    this.loginInfo = {
      email: '',
      password: ''
    };

    this.$auth = $auth;
    this.buttonDisabled = false;
    this.$mdToast = $mdToast;

    $scope.$on('auth:login-error', function (ev, reason) {
      _this.buttonDisabled = false;

      if (reason.errors[0].indexOf('A confirmation email was sent') !== -1) {
        _this.showToast('パスワードが未設定です。パスワード設定用メールが送られていないか確認してください。');
      } else {
        _this.showToast('ログインIDまたはパスワードが違います');
      }
    });
  }

  _createClass(LoginController, [{
    key: 'submitLogin',
    value: function submitLogin() {
      this.$auth.submitLogin(this.loginInfo);
    }
  }, {
    key: 'disableButton',
    value: function disableButton() {
      this.buttonDisabled = true;
    }
  }, {
    key: 'showToast',
    value: function showToast(message) {
      this.$mdToast.show(this.$mdToast.simple().content(message).position('top left right').hideDelay(3000));
    }
  }]);

  return LoginController;
}();

exports.default = LoginController;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _main = __webpack_require__(629);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var MainController = exports.MainController = function () {
  /*@ngInject*/
  MainController.$inject = ["$auth", "$rootScope"];
  function MainController($auth, $rootScope) {
    var _this = this;

    _classCallCheck(this, MainController);

    this.$rootScope = $rootScope;
    this.logout = function () {
      $auth.signOut();
    };
    this.widthStyle = this.getWidthStyle($rootScope.isFullScreen);

    $rootScope.$watch('isFullScreen', function (newValue) {
      _this.widthStyle = _this.getWidthStyle(newValue);
    });
  }

  _createClass(MainController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'getWidthStyle',
    value: function getWidthStyle(isFullScreen) {
      if (isFullScreen) {
        return { 'width': '100%' };
      } else {
        return { 'width': 'calc(100% - 173px)' };
      }
    }
  }]);

  return MainController;
}();

exports.default = _angular2.default.module('leptonApp.main', [_angularjs2.default]).config(_main2.default).component('main', {
  template: __webpack_require__(630),
  controller: MainController
}).name;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main', {
    url: '/',
    template: '<main></main>'
  });
};

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = "<div id=\"header\" layout=\"row\" layout-align=\"space-between center\" ng-hide=\"$root.isFullScreen\" class=\"animate front-slide\">\n  <span id=\"logo\" ui-sref=\"main.home\">\n    <ng-include src=\"($root.oemKey) ? 'logos/'+$root.oemKey+'/service_logo.html' : ''\"></ng-include>\n  </span>\n  <div id=\"user-menu\">\n    <div id=\"account\"><i class=\"fa fa-user fa-fw\"></i> {{$root.username}}</div>\n    <div class=\"header-button\" ng-if=\"$root.manualFile && $root.manualFile !== ''\">\n      <a ng-href=\"logos/{{$root.oemKey}}/{{$root.manualFile}}\" target=\"_blank\">\n        <i class=\"far fa-question-circle\"></i>\n      </a>\n    </div>\n    <div ng-click=\"$ctrl.logout()\" class=\"header-button\"><i class=\"fas fa-sign-out-alt fa-fw\"></i></div>\n  </div>\n</div>\n<div layout=\"row\">\n  <md-sidenav id=\"main-menu\" class=\"md-sidenav-left animate side-slide\"\n    md-component-id=\"left\" md-is-locked-open=\"true\" md-whiteframe=\"1\"\n    layout=\"column\" ng-hide=\"$root.isFullScreen\">\n    <md-list>\n      <md-button ui-sref=\"main.home\"><i class=\"fa fa-home fa-fw\"></i> ホーム　</md-button>\n      <md-divider></md-divider>\n      <md-button ui-sref=\"main.demand_index\"><i class=\"fa fa-chart-line fa-fw\"></i> デマンド</md-button>\n      <md-divider></md-divider>\n      <md-button ui-sref=\"main.demand_report_index\"><i class=\"fa fa-chart-bar fa-fw\"></i> 実績データ</md-button>\n      <md-divider></md-divider>\n      <md-button ui-sref=\"main.compare_graph_index\" ng-if=\"!$root.is_limited_viewer\"><i class=\"fas fa-exchange-alt\"></i> 拠点比較</md-button>\n      <md-divider ng-if=\"!$root.is_limited_viewer\"></md-divider>\n      <md-button ui-sref=\"main.device_error\"><i class=\"fa fa-exclamation-triangle fa-fw\"></i>  異常サマリ</md-button>\n      <md-divider></md-divider>\n      <md-button ui-sref=\"main.statistics_index\" ng-if=\"!$root.is_limited_viewer\"><i class=\"fas fa-chart-pie fa-fw\"></i> 統計レポート</md-button>\n      <md-divider ng-if=\"!$root.is_limited_viewer\"></md-divider>\n      <md-button ui-sref=\"main.device_index\"><i class=\"fa fa-wrench fa-fw\"></i> 設定変更</md-button>\n      <md-divider></md-divider>\n      <md-button ui-sref=\"main.sa_group_index\" ng-if=\"!$root.is_limited_viewer\"><i class=\"fas fa-copy fa-fw\"></i> グループ管理</md-button>\n      <md-divider ng-if=\"!$root.is_limited_viewer\"></md-divider>\n      <md-button ui-sref=\"main.demand_control_index\" ng-if=\"($root.is_admin || $root.is_operator) && $root.demandEnabled\"><i class=\"fas fa-hand-pointer fa-fw\"></i> 手動デマンド制御</md-button>\n      <md-divider></md-divider>\n      <md-button ui-sref=\"main.sa_reboot\" ng-if=\"$root.is_admin || $root.is_operator\"><i class=\"fas fa-redo fa-fw\" aria-hidden=\"true\"></i> 端末再起動</md-button>\n      <md-divider ng-if=\"$root.is_admin || $root.is_operator\"></md-divider>\n      <md-button ui-sref=\"main.notify_list_index\"><i class=\"fa fa-envelope fa-fw\"></i> メール通知設定</md-button>\n      <md-divider></md-divider>\n      <md-button ui-sref=\"main.retry\" ng-if=\"!$root.is_limited_viewer\"><i class=\"fa fa-history fa-fw\"></i> 再検針</md-button>\n      <md-divider ng-if=\"!$root.is_limited_viewer\"></md-divider>\n      <md-button ui-sref=\"main.end_user_index\" ng-if=\"$root.is_admin\"><i class=\"fa fa-users fa-fw\"></i> アカウント管理</md-button>\n      <md-divider></md-divider>\n    </md-list>\n  </md-sidenav>\n  <div ui-view ng-style=\"$ctrl.widthStyle\"></div>\n</div>\n"

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular, undefined) {
	angular.module("leptonApp.constants", []).constant("appConfig", {
		"userRoles": ["guest", "user", "admin"]
	});
})(angular);

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

(function (modules) {
  var installedModules = {};
  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) {
      return installedModules[moduleId].exports;
    }
    var module = installedModules[moduleId] = { i: moduleId,
      l: false,
      exports: {}
    };
    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    module.l = true;
    return module.exports;
  }
  __webpack_require__.m = modules;
  __webpack_require__.c = installedModules;
  __webpack_require__.i = function (value) {
    return value;
  };
  __webpack_require__.d = function (exports, name, getter) {
    if (!__webpack_require__.o(exports, name)) {
      Object.defineProperty(exports, name, { configurable: false,
        enumerable: true,
        get: getter
      });
    }
  };
  __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function getDefault() {
      return module['default'];
    } : function getModuleExports() {
      return module;
    };
    __webpack_require__.d(getter, 'a', getter);
    return getter;
  };
  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  __webpack_require__.p = "/";
  return __webpack_require__(__webpack_require__.s = 2);
})([function (module, exports, __webpack_require__) {

  "use strict";

  function isObject(obj) {
    return null !== obj && 'object' === (typeof obj === 'undefined' ? 'undefined' : _typeof(obj));
  }

  module.exports = isObject;
}, function (module, exports, __webpack_require__) {

  "use strict";

  var request = __webpack_require__(6);
  var zeropad = __webpack_require__(10);

  var ZipCodeJp = {};

  ZipCodeJp.setZipCodeBaseUrl = function (url) {
    ZipCodeJp.zip_code_base_url = url;
  };

  ZipCodeJp.setCityBaseUrl = function (url) {
    ZipCodeJp.city_base_url = url;
  };

  ZipCodeJp.getAddressesOfZipCode = function (zipCode, cb) {
    var prefix = zipCode.slice(0, 3);
    request.get(ZipCodeJp.zip_code_base_url + '/' + prefix + '/' + zipCode + '.json').end(function (err, res) {
      if (err) {
        if (err.status === 404) {
          cb(null, []);
        } else {
          cb(err, []);
        }
      } else {
        cb(null, res.body);
      }
    });
  };

  ZipCodeJp.getCitiesOfPrefecture = function (prefectureJisCode, cb) {
    request.get(ZipCodeJp.city_base_url + '/' + zeropad(prefectureJisCode, 2) + '.json').end(function (err, res) {
      if (err) {
        if (err.status === 404) {
          cb(null, []);
        } else {
          cb(err, []);
        }
      } else {
        cb(null, res.body);
      }
    });
  };

  ZipCodeJp.setZipCodeBaseUrl('/zip_code');
  ZipCodeJp.setCityBaseUrl('/city');
  module.exports = ZipCodeJp;
}, function (module, exports, __webpack_require__) {

  "use strict";

  window.ZipCodeJp = __webpack_require__(1);
}, function (module, exports, __webpack_require__) {

  if (true) {
    module.exports = Emitter;
  }

  function Emitter(obj) {
    if (obj) return mixin(obj);
  };

  function mixin(obj) {
    for (var key in Emitter.prototype) {
      obj[key] = Emitter.prototype[key];
    }
    return obj;
  }

  Emitter.prototype.on = Emitter.prototype.addEventListener = function (event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
  };

  Emitter.prototype.once = function (event, fn) {
    function on() {
      this.off(event, on);
      fn.apply(this, arguments);
    }

    on.fn = fn;
    this.on(event, on);
    return this;
  };

  Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function (event, fn) {
    this._callbacks = this._callbacks || {};

    if (0 == arguments.length) {
      this._callbacks = {};
      return this;
    }

    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;

    if (1 == arguments.length) {
      delete this._callbacks['$' + event];
      return this;
    }

    var cb;
    for (var i = 0; i < callbacks.length; i++) {
      cb = callbacks[i];
      if (cb === fn || cb.fn === fn) {
        callbacks.splice(i, 1);
        break;
      }
    }
    return this;
  };

  Emitter.prototype.emit = function (event) {
    this._callbacks = this._callbacks || {};
    var args = [].slice.call(arguments, 1),
        callbacks = this._callbacks['$' + event];

    if (callbacks) {
      callbacks = callbacks.slice(0);
      for (var i = 0, len = callbacks.length; i < len; ++i) {
        callbacks[i].apply(this, args);
      }
    }

    return this;
  };

  Emitter.prototype.listeners = function (event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
  };

  Emitter.prototype.hasListeners = function (event) {
    return !!this.listeners(event).length;
  };
}, function (module, exports, __webpack_require__) {

  "use strict";

  module.exports = function (x) {
    return x === 0 && 1 / x === -Infinity;
  };
}, function (module, exports) {

  function Agent() {
    this._defaults = [];
  }

  ["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects", "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function (fn) {
    Agent.prototype[fn] = function () {
      this._defaults.push({ fn: fn, arguments: arguments });
      return this;
    };
  });

  Agent.prototype._setDefaults = function (req) {
    this._defaults.forEach(function (def) {
      req[def.fn].apply(req, def.arguments);
    });
  };

  module.exports = Agent;
}, function (module, exports, __webpack_require__) {

  var root;
  if (typeof window !== 'undefined') {
    root = window;
  } else if (typeof self !== 'undefined') {
    root = self;
  } else {
    console.warn("Using browser-only version of superagent in non-browser environment");
    root = this;
  }

  var Emitter = __webpack_require__(3);
  var RequestBase = __webpack_require__(7);
  var isObject = __webpack_require__(0);
  var ResponseBase = __webpack_require__(8);
  var Agent = __webpack_require__(5);

  function noop() {};

  var request = exports = module.exports = function (method, url) {
    if ('function' == typeof url) {
      return new exports.Request('GET', method).end(url);
    }

    if (1 == arguments.length) {
      return new exports.Request('GET', method);
    }

    return new exports.Request(method, url);
  };

  exports.Request = Request;

  request.getXHR = function () {
    if (root.XMLHttpRequest && (!root.location || 'file:' != root.location.protocol || !root.ActiveXObject)) {
      return new XMLHttpRequest();
    } else {
      try {
        return new ActiveXObject('Microsoft.XMLHTTP');
      } catch (e) {}
      try {
        return new ActiveXObject('Msxml2.XMLHTTP.6.0');
      } catch (e) {}
      try {
        return new ActiveXObject('Msxml2.XMLHTTP.3.0');
      } catch (e) {}
      try {
        return new ActiveXObject('Msxml2.XMLHTTP');
      } catch (e) {}
    }
    throw Error("Browser-only version of superagent could not find XHR");
  };

  var trim = ''.trim ? function (s) {
    return s.trim();
  } : function (s) {
    return s.replace(/(^\s*|\s*$)/g, '');
  };

  function serialize(obj) {
    if (!isObject(obj)) return obj;
    var pairs = [];
    for (var key in obj) {
      pushEncodedKeyValuePair(pairs, key, obj[key]);
    }
    return pairs.join('&');
  }

  function pushEncodedKeyValuePair(pairs, key, val) {
    if (val != null) {
      if (Array.isArray(val)) {
        val.forEach(function (v) {
          pushEncodedKeyValuePair(pairs, key, v);
        });
      } else if (isObject(val)) {
        for (var subkey in val) {
          pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
        }
      } else {
        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
      }
    } else if (val === null) {
      pairs.push(encodeURIComponent(key));
    }
  }

  request.serializeObject = serialize;

  function parseString(str) {
    var obj = {};
    var pairs = str.split('&');
    var pair;
    var pos;

    for (var i = 0, len = pairs.length; i < len; ++i) {
      pair = pairs[i];
      pos = pair.indexOf('=');
      if (pos == -1) {
        obj[decodeURIComponent(pair)] = '';
      } else {
        obj[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
      }
    }

    return obj;
  }

  request.parseString = parseString;

  request.types = {
    html: 'text/html',
    json: 'application/json',
    xml: 'text/xml',
    urlencoded: 'application/x-www-form-urlencoded',
    'form': 'application/x-www-form-urlencoded',
    'form-data': 'application/x-www-form-urlencoded'
  };

  request.serialize = {
    'application/x-www-form-urlencoded': serialize,
    'application/json': JSON.stringify
  };

  request.parse = {
    'application/x-www-form-urlencoded': parseString,
    'application/json': JSON.parse
  };

  function parseHeader(str) {
    var lines = str.split(/\r?\n/);
    var fields = {};
    var index;
    var line;
    var field;
    var val;

    for (var i = 0, len = lines.length; i < len; ++i) {
      line = lines[i];
      index = line.indexOf(':');
      if (index === -1) {
        continue;
      }
      field = line.slice(0, index).toLowerCase();
      val = trim(line.slice(index + 1));
      fields[field] = val;
    }

    return fields;
  }

  function isJSON(mime) {
    return (/[\/+]json($|[^-\w])/.test(mime)
    );
  }

  function Response(req) {
    this.req = req;
    this.xhr = this.req.xhr;

    this.text = this.req.method != 'HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text') || typeof this.xhr.responseType === 'undefined' ? this.xhr.responseText : null;
    this.statusText = this.req.xhr.statusText;
    var status = this.xhr.status;

    if (status === 1223) {
      status = 204;
    }
    this._setStatusProperties(status);
    this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());

    this.header['content-type'] = this.xhr.getResponseHeader('content-type');
    this._setHeaderProperties(this.header);

    if (null === this.text && req._responseType) {
      this.body = this.xhr.response;
    } else {
      this.body = this.req.method != 'HEAD' ? this._parseBody(this.text ? this.text : this.xhr.response) : null;
    }
  }

  ResponseBase(Response.prototype);

  Response.prototype._parseBody = function (str) {
    var parse = request.parse[this.type];
    if (this.req._parser) {
      return this.req._parser(this, str);
    }
    if (!parse && isJSON(this.type)) {
      parse = request.parse['application/json'];
    }
    return parse && str && (str.length || str instanceof Object) ? parse(str) : null;
  };

  Response.prototype.toError = function () {
    var req = this.req;
    var method = req.method;
    var url = req.url;

    var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
    var err = new Error(msg);
    err.status = this.status;
    err.method = method;
    err.url = url;

    return err;
  };

  request.Response = Response;

  function Request(method, url) {
    var self = this;
    this._query = this._query || [];
    this.method = method;
    this.url = url;
    this.header = {};
    this._header = {};
    this.on('end', function () {
      var err = null;
      var res = null;

      try {
        res = new Response(self);
      } catch (e) {
        err = new Error('Parser is unable to parse the response');
        err.parse = true;
        err.original = e;

        if (self.xhr) {
          err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;

          err.status = self.xhr.status ? self.xhr.status : null;
          err.statusCode = err.status;
        } else {
          err.rawResponse = null;
          err.status = null;
        }

        return self.callback(err);
      }

      self.emit('response', res);

      var new_err;
      try {
        if (!self._isResponseOK(res)) {
          new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
        }
      } catch (custom_err) {
        new_err = custom_err;
      }

      if (new_err) {
        new_err.original = err;
        new_err.response = res;
        new_err.status = res.status;
        self.callback(new_err, res);
      } else {
        self.callback(null, res);
      }
    });
  }

  Emitter(Request.prototype);
  RequestBase(Request.prototype);

  Request.prototype.type = function (type) {
    this.set('Content-Type', request.types[type] || type);
    return this;
  };

  Request.prototype.accept = function (type) {
    this.set('Accept', request.types[type] || type);
    return this;
  };

  Request.prototype.auth = function (user, pass, options) {
    if (1 === arguments.length) pass = '';
    if ((typeof pass === 'undefined' ? 'undefined' : _typeof(pass)) === 'object' && pass !== null) {
      options = pass;
      pass = '';
    }
    if (!options) {
      options = {
        type: 'function' === typeof btoa ? 'basic' : 'auto'
      };
    }

    var encoder = function encoder(string) {
      if ('function' === typeof btoa) {
        return btoa(string);
      }
      throw new Error('Cannot use basic auth, btoa is not a function');
    };

    return this._auth(user, pass, options, encoder);
  };

  Request.prototype.query = function (val) {
    if ('string' != typeof val) val = serialize(val);
    if (val) this._query.push(val);
    return this;
  };

  Request.prototype.attach = function (field, file, options) {
    if (file) {
      if (this._data) {
        throw Error("superagent can't mix .send() and .attach()");
      }

      this._getFormData().append(field, file, options || file.name);
    }
    return this;
  };

  Request.prototype._getFormData = function () {
    if (!this._formData) {
      this._formData = new root.FormData();
    }
    return this._formData;
  };

  Request.prototype.callback = function (err, res) {
    if (this._shouldRetry(err, res)) {
      return this._retry();
    }

    var fn = this._callback;
    this.clearTimeout();

    if (err) {
      if (this._maxRetries) err.retries = this._retries - 1;
      this.emit('error', err);
    }

    fn(err, res);
  };

  Request.prototype.crossDomainError = function () {
    var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
    err.crossDomain = true;

    err.status = this.status;
    err.method = this.method;
    err.url = this.url;

    this.callback(err);
  };

  Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function () {
    console.warn("This is not supported in browser version of superagent");
    return this;
  };

  Request.prototype.pipe = Request.prototype.write = function () {
    throw Error("Streaming is not supported in browser version of superagent");
  };

  Request.prototype._isHost = function _isHost(obj) {
    return obj && 'object' === (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
  };

  Request.prototype.end = function (fn) {
    if (this._endCalled) {
      console.warn("Warning: .end() was called twice. This is not supported in superagent");
    }
    this._endCalled = true;

    this._callback = fn || noop;

    this._finalizeQueryString();

    return this._end();
  };

  Request.prototype._end = function () {
    var self = this;
    var xhr = this.xhr = request.getXHR();
    var data = this._formData || this._data;

    this._setTimeouts();

    xhr.onreadystatechange = function () {
      var readyState = xhr.readyState;
      if (readyState >= 2 && self._responseTimeoutTimer) {
        clearTimeout(self._responseTimeoutTimer);
      }
      if (4 != readyState) {
        return;
      }

      var status;
      try {
        status = xhr.status;
      } catch (e) {
        status = 0;
      }

      if (!status) {
        if (self.timedout || self._aborted) return;
        return self.crossDomainError();
      }
      self.emit('end');
    };

    var handleProgress = function handleProgress(direction, e) {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100;
      }
      e.direction = direction;
      self.emit('progress', e);
    };
    if (this.hasListeners('progress')) {
      try {
        xhr.onprogress = handleProgress.bind(null, 'download');
        if (xhr.upload) {
          xhr.upload.onprogress = handleProgress.bind(null, 'upload');
        }
      } catch (e) {}
    }

    try {
      if (this.username && this.password) {
        xhr.open(this.method, this.url, true, this.username, this.password);
      } else {
        xhr.open(this.method, this.url, true);
      }
    } catch (err) {
      return this.callback(err);
    }

    if (this._withCredentials) xhr.withCredentials = true;

    if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
      var contentType = this._header['content-type'];
      var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
      if (!serialize && isJSON(contentType)) {
        serialize = request.serialize['application/json'];
      }
      if (serialize) data = serialize(data);
    }

    for (var field in this.header) {
      if (null == this.header[field]) continue;

      if (this.header.hasOwnProperty(field)) xhr.setRequestHeader(field, this.header[field]);
    }

    if (this._responseType) {
      xhr.responseType = this._responseType;
    }

    this.emit('request', this);

    xhr.send(typeof data !== 'undefined' ? data : null);
    return this;
  };

  request.agent = function () {
    return new Agent();
  };

  ["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function (method) {
    Agent.prototype[method.toLowerCase()] = function (url, fn) {
      var req = new request.Request(method, url);
      this._setDefaults(req);
      if (fn) {
        req.end(fn);
      }
      return req;
    };
  });

  Agent.prototype.del = Agent.prototype['delete'];

  request.get = function (url, data, fn) {
    var req = request('GET', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.query(data);
    if (fn) req.end(fn);
    return req;
  };

  request.head = function (url, data, fn) {
    var req = request('HEAD', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.query(data);
    if (fn) req.end(fn);
    return req;
  };

  request.options = function (url, data, fn) {
    var req = request('OPTIONS', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
  };

  function del(url, data, fn) {
    var req = request('DELETE', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
  }

  request['del'] = del;
  request['delete'] = del;

  request.patch = function (url, data, fn) {
    var req = request('PATCH', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
  };

  request.post = function (url, data, fn) {
    var req = request('POST', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
  };

  request.put = function (url, data, fn) {
    var req = request('PUT', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
  };
}, function (module, exports, __webpack_require__) {

  "use strict";

  var isObject = __webpack_require__(0);

  module.exports = RequestBase;

  function RequestBase(obj) {
    if (obj) return mixin(obj);
  }

  function mixin(obj) {
    for (var key in RequestBase.prototype) {
      obj[key] = RequestBase.prototype[key];
    }
    return obj;
  }

  RequestBase.prototype.clearTimeout = function _clearTimeout() {
    clearTimeout(this._timer);
    clearTimeout(this._responseTimeoutTimer);
    delete this._timer;
    delete this._responseTimeoutTimer;
    return this;
  };

  RequestBase.prototype.parse = function parse(fn) {
    this._parser = fn;
    return this;
  };

  RequestBase.prototype.responseType = function (val) {
    this._responseType = val;
    return this;
  };

  RequestBase.prototype.serialize = function serialize(fn) {
    this._serializer = fn;
    return this;
  };

  RequestBase.prototype.timeout = function timeout(options) {
    if (!options || 'object' !== (typeof options === 'undefined' ? 'undefined' : _typeof(options))) {
      this._timeout = options;
      this._responseTimeout = 0;
      return this;
    }

    for (var option in options) {
      switch (option) {
        case 'deadline':
          this._timeout = options.deadline;
          break;
        case 'response':
          this._responseTimeout = options.response;
          break;
        default:
          console.warn("Unknown timeout option", option);
      }
    }
    return this;
  };

  RequestBase.prototype.retry = function retry(count, fn) {
    if (arguments.length === 0 || count === true) count = 1;
    if (count <= 0) count = 0;
    this._maxRetries = count;
    this._retries = 0;
    this._retryCallback = fn;
    return this;
  };

  var ERROR_CODES = ['ECONNRESET', 'ETIMEDOUT', 'EADDRINFO', 'ESOCKETTIMEDOUT'];

  RequestBase.prototype._shouldRetry = function (err, res) {
    if (!this._maxRetries || this._retries++ >= this._maxRetries) {
      return false;
    }
    if (this._retryCallback) {
      try {
        var override = this._retryCallback(err, res);
        if (override === true) return true;
        if (override === false) return false;
      } catch (e) {
        console.error(e);
      }
    }
    if (res && res.status && res.status >= 500 && res.status != 501) return true;
    if (err) {
      if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;

      if (err.timeout && err.code == 'ECONNABORTED') return true;
      if (err.crossDomain) return true;
    }
    return false;
  };

  RequestBase.prototype._retry = function () {

    this.clearTimeout();

    if (this.req) {
      this.req = null;
      this.req = this.request();
    }

    this._aborted = false;
    this.timedout = false;

    return this._end();
  };

  RequestBase.prototype.then = function then(resolve, reject) {
    if (!this._fullfilledPromise) {
      var self = this;
      if (this._endCalled) {
        console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
      }
      this._fullfilledPromise = new Promise(function (innerResolve, innerReject) {
        self.end(function (err, res) {
          if (err) innerReject(err);else innerResolve(res);
        });
      });
    }
    return this._fullfilledPromise.then(resolve, reject);
  };

  RequestBase.prototype.catch = function (cb) {
    return this.then(undefined, cb);
  };

  RequestBase.prototype.use = function use(fn) {
    fn(this);
    return this;
  };

  RequestBase.prototype.ok = function (cb) {
    if ('function' !== typeof cb) throw Error("Callback required");
    this._okCallback = cb;
    return this;
  };

  RequestBase.prototype._isResponseOK = function (res) {
    if (!res) {
      return false;
    }

    if (this._okCallback) {
      return this._okCallback(res);
    }

    return res.status >= 200 && res.status < 300;
  };

  RequestBase.prototype.get = function (field) {
    return this._header[field.toLowerCase()];
  };

  RequestBase.prototype.getHeader = RequestBase.prototype.get;

  RequestBase.prototype.set = function (field, val) {
    if (isObject(field)) {
      for (var key in field) {
        this.set(key, field[key]);
      }
      return this;
    }
    this._header[field.toLowerCase()] = val;
    this.header[field] = val;
    return this;
  };

  RequestBase.prototype.unset = function (field) {
    delete this._header[field.toLowerCase()];
    delete this.header[field];
    return this;
  };

  RequestBase.prototype.field = function (name, val) {
    if (null === name || undefined === name) {
      throw new Error('.field(name, val) name can not be empty');
    }

    if (this._data) {
      console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
    }

    if (isObject(name)) {
      for (var key in name) {
        this.field(key, name[key]);
      }
      return this;
    }

    if (Array.isArray(val)) {
      for (var i in val) {
        this.field(name, val[i]);
      }
      return this;
    }

    if (null === val || undefined === val) {
      throw new Error('.field(name, val) val can not be empty');
    }
    if ('boolean' === typeof val) {
      val = '' + val;
    }
    this._getFormData().append(name, val);
    return this;
  };

  RequestBase.prototype.abort = function () {
    if (this._aborted) {
      return this;
    }
    this._aborted = true;
    this.xhr && this.xhr.abort();
    this.req && this.req.abort();
    this.clearTimeout();
    this.emit('abort');
    return this;
  };

  RequestBase.prototype._auth = function (user, pass, options, base64Encoder) {
    switch (options.type) {
      case 'basic':
        this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
        break;

      case 'auto':
        this.username = user;
        this.password = pass;
        break;

      case 'bearer':
        this.set('Authorization', 'Bearer ' + user);
        break;
    }
    return this;
  };

  RequestBase.prototype.withCredentials = function (on) {
    if (on == undefined) on = true;
    this._withCredentials = on;
    return this;
  };

  RequestBase.prototype.redirects = function (n) {
    this._maxRedirects = n;
    return this;
  };

  RequestBase.prototype.maxResponseSize = function (n) {
    if ('number' !== typeof n) {
      throw TypeError("Invalid argument");
    }
    this._maxResponseSize = n;
    return this;
  };

  RequestBase.prototype.toJSON = function () {
    return {
      method: this.method,
      url: this.url,
      data: this._data,
      headers: this._header
    };
  };

  RequestBase.prototype.send = function (data) {
    var isObj = isObject(data);
    var type = this._header['content-type'];

    if (this._formData) {
      console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
    }

    if (isObj && !this._data) {
      if (Array.isArray(data)) {
        this._data = [];
      } else if (!this._isHost(data)) {
        this._data = {};
      }
    } else if (data && this._data && this._isHost(this._data)) {
      throw Error("Can't merge these send calls");
    }

    if (isObj && isObject(this._data)) {
      for (var key in data) {
        this._data[key] = data[key];
      }
    } else if ('string' == typeof data) {
      if (!type) this.type('form');
      type = this._header['content-type'];
      if ('application/x-www-form-urlencoded' == type) {
        this._data = this._data ? this._data + '&' + data : data;
      } else {
        this._data = (this._data || '') + data;
      }
    } else {
      this._data = data;
    }

    if (!isObj || this._isHost(data)) {
      return this;
    }

    if (!type) this.type('json');
    return this;
  };

  RequestBase.prototype.sortQuery = function (sort) {
    this._sort = typeof sort === 'undefined' ? true : sort;
    return this;
  };

  RequestBase.prototype._finalizeQueryString = function () {
    var query = this._query.join('&');
    if (query) {
      this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
    }
    this._query.length = 0;

    if (this._sort) {
      var index = this.url.indexOf('?');
      if (index >= 0) {
        var queryArr = this.url.substring(index + 1).split('&');
        if ('function' === typeof this._sort) {
          queryArr.sort(this._sort);
        } else {
          queryArr.sort();
        }
        this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
      }
    }
  };

  RequestBase.prototype._appendQueryString = function () {
    console.trace("Unsupported");
  };

  RequestBase.prototype._timeoutError = function (reason, timeout, errno) {
    if (this._aborted) {
      return;
    }
    var err = new Error(reason + timeout + 'ms exceeded');
    err.timeout = timeout;
    err.code = 'ECONNABORTED';
    err.errno = errno;
    this.timedout = true;
    this.abort();
    this.callback(err);
  };

  RequestBase.prototype._setTimeouts = function () {
    var self = this;

    if (this._timeout && !this._timer) {
      this._timer = setTimeout(function () {
        self._timeoutError('Timeout of ', self._timeout, 'ETIME');
      }, this._timeout);
    }

    if (this._responseTimeout && !this._responseTimeoutTimer) {
      this._responseTimeoutTimer = setTimeout(function () {
        self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
      }, this._responseTimeout);
    }
  };
}, function (module, exports, __webpack_require__) {

  "use strict";

  var utils = __webpack_require__(9);

  module.exports = ResponseBase;

  function ResponseBase(obj) {
    if (obj) return mixin(obj);
  }

  function mixin(obj) {
    for (var key in ResponseBase.prototype) {
      obj[key] = ResponseBase.prototype[key];
    }
    return obj;
  }

  ResponseBase.prototype.get = function (field) {
    return this.header[field.toLowerCase()];
  };

  ResponseBase.prototype._setHeaderProperties = function (header) {
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    var params = utils.params(ct);
    for (var key in params) {
      this[key] = params[key];
    }this.links = {};

    try {
      if (header.link) {
        this.links = utils.parseLinks(header.link);
      }
    } catch (err) {}
  };

  ResponseBase.prototype._setStatusProperties = function (status) {
    var type = status / 100 | 0;

    this.status = this.statusCode = status;
    this.statusType = type;

    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = 4 == type || 5 == type ? this.toError() : false;

    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
  };
}, function (module, exports, __webpack_require__) {

  "use strict";

  exports.type = function (str) {
    return str.split(/ *; */).shift();
  };

  exports.params = function (str) {
    return str.split(/ *; */).reduce(function (obj, str) {
      var parts = str.split(/ *= */);
      var key = parts.shift();
      var val = parts.shift();

      if (key && val) obj[key] = val;
      return obj;
    }, {});
  };

  exports.parseLinks = function (str) {
    return str.split(/ *, */).reduce(function (obj, str) {
      var parts = str.split(/ *; */);
      var url = parts[0].slice(1, -1);
      var rel = parts[1].split(/ *= */)[1].slice(1, -1);
      obj[rel] = url;
      return obj;
    }, {});
  };

  exports.cleanHeader = function (header, changesOrigin) {
    delete header['content-type'];
    delete header['content-length'];
    delete header['transfer-encoding'];
    delete header['host'];

    if (changesOrigin) {
      delete header['authorization'];
      delete header['cookie'];
    }
    return header;
  };
}, function (module, exports, __webpack_require__) {

  "use strict";

  var isNegativeZero = __webpack_require__(4);

  module.exports = function (number, length) {
    if (isNaN(number)) {
      throw new SyntaxError('zeropad requires a number or string');
    }

    if (typeof length !== 'undefined' && (isNaN(length) || length < 0)) {
      throw new SyntaxError('zeropad requires a positive integer for length');
    }

    var prefix = isNegativeZero(number) || number < 0 ? '-' : '';

    length = length || 2;
    number = Math.abs(parseFloat(number));
    var padLength = length - String(number).length + 1;

    var pads = new Array(padLength).join('0');
    return prefix + pads + number;
  };
}]);

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(634);

exports.default = angular.module('leptonApp.util', []).factory('Util', _util.UtilService).name;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


UtilService.$inject = ["$window"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UtilService = UtilService;
function UtilService($window) {
  'ngInject';

  var Util = {
    safeCb: function safeCb(cb) {
      return angular.isFunction(cb) ? cb : angular.noop;
    },

    urlParse: function urlParse(url) {
      var a = document.createElement('a');
      a.href = url;

      if (a.host === '') {
        a.href = a.href;
      }

      return a;
    },

    isSameOrigin: function isSameOrigin(url, origins) {
      url = Util.urlParse(url);
      origins = origins && [].concat(origins) || [];
      origins = origins.map(Util.urlParse);
      origins.push($window.location);
      origins = origins.filter(function (o) {
        var hostnameCheck = url.hostname === o.hostname;
        var protocolCheck = url.protocol === o.protocol;

        var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port === '443');
        return hostnameCheck && protocolCheck && portCheck;
      });
      return origins.length >= 1;
    }
  };

  return Util;
}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 Highcharts JS v6.0.4 (2017-12-15)

 (c) 2009-2016 Torstein Honsi

 License: www.highcharts.com/license
*/
(function (S, M) {
  "object" === ( false ? "undefined" : _typeof(module)) && module.exports ? module.exports = S.document ? M(S) : M : S.Highcharts = M(S);
})("undefined" !== typeof window ? window : undefined, function (S) {
  var M = function () {
    var a = "undefined" === typeof S ? window : S,
        E = a.document,
        D = a.navigator && a.navigator.userAgent || "",
        H = E && E.createElementNS && !!E.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect,
        p = /(edge|msie|trident)/i.test(D) && !a.opera,
        f = /Firefox/.test(D),
        l = f && 4 > parseInt(D.split("Firefox/")[1], 10);return a.Highcharts ? a.Highcharts.error(16, !0) : { product: "Highcharts", version: "6.0.4", deg2rad: 2 * Math.PI / 360, doc: E, hasBidiBug: l, hasTouch: E && void 0 !== E.documentElement.ontouchstart, isMS: p, isWebKit: /AppleWebKit/.test(D), isFirefox: f, isTouchDevice: /(Mobile|Android|Windows Phone)/.test(D), SVG_NS: "http://www.w3.org/2000/svg", chartCount: 0, seriesTypes: {}, symbolSizes: {}, svg: H, win: a, marginNames: ["plotTop", "marginRight", "marginBottom", "plotLeft"], noop: function noop() {}, charts: [] };
  }();(function (a) {
    a.timers = [];var E = a.charts,
        D = a.doc,
        H = a.win;a.error = function (p, f) {
      p = a.isNumber(p) ? "Highcharts error #" + p + ": www.highcharts.com/errors/" + p : p;if (f) throw Error(p);H.console && console.log(p);
    };a.Fx = function (a, f, l) {
      this.options = f;this.elem = a;this.prop = l;
    };a.Fx.prototype = { dSetter: function dSetter() {
        var a = this.paths[0],
            f = this.paths[1],
            l = [],
            r = this.now,
            n = a.length,
            w;if (1 === r) l = this.toD;else if (n === f.length && 1 > r) for (; n--;) {
          w = parseFloat(a[n]), l[n] = isNaN(w) ? f[n] : r * parseFloat(f[n] - w) + w;
        } else l = f;this.elem.attr("d", l, null, !0);
      }, update: function update() {
        var a = this.elem,
            f = this.prop,
            l = this.now,
            r = this.options.step;if (this[f + "Setter"]) this[f + "Setter"]();else a.attr ? a.element && a.attr(f, l, null, !0) : a.style[f] = l + this.unit;r && r.call(a, l, this);
      }, run: function run(p, f, l) {
        var r = this,
            n = r.options,
            w = function w(a) {
          return w.stopped ? !1 : r.step(a);
        },
            u = H.requestAnimationFrame || function (a) {
          setTimeout(a, 13);
        },
            e = function e() {
          for (var h = 0; h < a.timers.length; h++) {
            a.timers[h]() || a.timers.splice(h--, 1);
          }a.timers.length && u(e);
        };p === f ? (delete n.curAnim[this.prop], n.complete && 0 === a.keys(n.curAnim).length && n.complete.call(this.elem)) : (this.startTime = +new Date(), this.start = p, this.end = f, this.unit = l, this.now = this.start, this.pos = 0, w.elem = this.elem, w.prop = this.prop, w() && 1 === a.timers.push(w) && u(e));
      }, step: function step(p) {
        var f = +new Date(),
            l,
            r = this.options,
            n = this.elem,
            w = r.complete,
            u = r.duration,
            e = r.curAnim;n.attr && !n.element ? p = !1 : p || f >= u + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), l = e[this.prop] = !0, a.objectEach(e, function (a) {
          !0 !== a && (l = !1);
        }), l && w && w.call(n), p = !1) : (this.pos = r.easing((f - this.startTime) / u), this.now = this.start + (this.end - this.start) * this.pos, this.update(), p = !0);return p;
      }, initPath: function initPath(p, f, l) {
        function r(a) {
          var b, c;for (k = a.length; k--;) {
            b = "M" === a[k] || "L" === a[k], c = /[a-zA-Z]/.test(a[k + 3]), b && c && a.splice(k + 1, 0, a[k + 1], a[k + 2], a[k + 1], a[k + 2]);
          }
        }function n(a, b) {
          for (; a.length < c;) {
            a[0] = b[c - a.length];var e = a.slice(0, d);[].splice.apply(a, [0, 0].concat(e));z && (e = a.slice(a.length - d), [].splice.apply(a, [a.length, 0].concat(e)), k--);
          }a[0] = "M";
        }function w(a, k) {
          for (var e = (c - a.length) / d; 0 < e && e--;) {
            b = a.slice().splice(a.length / B - d, d * B), b[0] = k[c - d - e * d], m && (b[d - 6] = b[d - 2], b[d - 5] = b[d - 1]), [].splice.apply(a, [a.length / B, 0].concat(b)), z && e--;
          }
        }f = f || "";var u,
            e = p.startX,
            h = p.endX,
            m = -1 < f.indexOf("C"),
            d = m ? 7 : 3,
            c,
            b,
            k;f = f.split(" ");l = l.slice();var z = p.isArea,
            B = z ? 2 : 1,
            I;m && (r(f), r(l));if (e && h) {
          for (k = 0; k < e.length; k++) {
            if (e[k] === h[0]) {
              u = k;break;
            } else if (e[0] === h[h.length - e.length + k]) {
              u = k;I = !0;break;
            }
          }void 0 === u && (f = []);
        }f.length && a.isNumber(u) && (c = l.length + u * B * d, I ? (n(f, l), w(l, f)) : (n(l, f), w(f, l)));return [f, l];
      } };a.Fx.prototype.fillSetter = a.Fx.prototype.strokeSetter = function () {
      this.elem.attr(this.prop, a.color(this.start).tweenTo(a.color(this.end), this.pos), null, !0);
    };a.extend = function (a, f) {
      var l;a || (a = {});for (l in f) {
        a[l] = f[l];
      }return a;
    };a.merge = function () {
      var p,
          f = arguments,
          l,
          r = {},
          n = function n(l, p) {
        "object" !== (typeof l === "undefined" ? "undefined" : _typeof(l)) && (l = {});a.objectEach(p, function (e, h) {
          !a.isObject(e, !0) || a.isClass(e) || a.isDOMElement(e) ? l[h] = p[h] : l[h] = n(l[h] || {}, e);
        });return l;
      };!0 === f[0] && (r = f[1], f = Array.prototype.slice.call(f, 2));l = f.length;for (p = 0; p < l; p++) {
        r = n(r, f[p]);
      }return r;
    };a.pInt = function (a, f) {
      return parseInt(a, f || 10);
    };a.isString = function (a) {
      return "string" === typeof a;
    };a.isArray = function (a) {
      a = Object.prototype.toString.call(a);return "[object Array]" === a || "[object Array Iterator]" === a;
    };a.isObject = function (p, f) {
      return !!p && "object" === (typeof p === "undefined" ? "undefined" : _typeof(p)) && (!f || !a.isArray(p));
    };a.isDOMElement = function (p) {
      return a.isObject(p) && "number" === typeof p.nodeType;
    };a.isClass = function (p) {
      var f = p && p.constructor;return !(!a.isObject(p, !0) || a.isDOMElement(p) || !f || !f.name || "Object" === f.name);
    };a.isNumber = function (a) {
      return "number" === typeof a && !isNaN(a) && Infinity > a && -Infinity < a;
    };a.erase = function (a, f) {
      for (var l = a.length; l--;) {
        if (a[l] === f) {
          a.splice(l, 1);break;
        }
      }
    };a.defined = function (a) {
      return void 0 !== a && null !== a;
    };a.attr = function (p, f, l) {
      var r;a.isString(f) ? a.defined(l) ? p.setAttribute(f, l) : p && p.getAttribute && (r = p.getAttribute(f)) : a.defined(f) && a.isObject(f) && a.objectEach(f, function (a, l) {
        p.setAttribute(l, a);
      });return r;
    };a.splat = function (p) {
      return a.isArray(p) ? p : [p];
    };a.syncTimeout = function (a, f, l) {
      if (f) return setTimeout(a, f, l);a.call(0, l);
    };a.pick = function () {
      var a = arguments,
          f,
          l,
          r = a.length;for (f = 0; f < r; f++) {
        if (l = a[f], void 0 !== l && null !== l) return l;
      }
    };a.css = function (p, f) {
      a.isMS && !a.svg && f && void 0 !== f.opacity && (f.filter = "alpha(opacity\x3d" + 100 * f.opacity + ")");a.extend(p.style, f);
    };a.createElement = function (p, f, l, r, n) {
      p = D.createElement(p);var w = a.css;f && a.extend(p, f);n && w(p, { padding: 0, border: "none", margin: 0 });l && w(p, l);r && r.appendChild(p);return p;
    };a.extendClass = function (p, f) {
      var l = function l() {};l.prototype = new p();a.extend(l.prototype, f);return l;
    };
    a.pad = function (a, f, l) {
      return Array((f || 2) + 1 - String(a).length).join(l || 0) + a;
    };a.relativeLength = function (a, f, l) {
      return (/%$/.test(a) ? f * parseFloat(a) / 100 + (l || 0) : parseFloat(a)
      );
    };a.wrap = function (a, f, l) {
      var p = a[f];a[f] = function () {
        var a = Array.prototype.slice.call(arguments),
            f = arguments,
            u = this;u.proceed = function () {
          p.apply(u, arguments.length ? arguments : f);
        };a.unshift(p);a = l.apply(this, a);u.proceed = null;return a;
      };
    };a.getTZOffset = function (p) {
      var f = a.Date;return 6E4 * (f.hcGetTimezoneOffset && f.hcGetTimezoneOffset(p) || f.hcTimezoneOffset || 0);
    };a.dateFormat = function (p, f, l) {
      if (!a.defined(f) || isNaN(f)) return a.defaultOptions.lang.invalidDate || "";p = a.pick(p, "%Y-%m-%d %H:%M:%S");var r = a.Date,
          n = new r(f - a.getTZOffset(f)),
          w = n[r.hcGetHours](),
          u = n[r.hcGetDay](),
          e = n[r.hcGetDate](),
          h = n[r.hcGetMonth](),
          m = n[r.hcGetFullYear](),
          d = a.defaultOptions.lang,
          c = d.weekdays,
          b = d.shortWeekdays,
          k = a.pad,
          r = a.extend({ a: b ? b[u] : c[u].substr(0, 3), A: c[u], d: k(e), e: k(e, 2, " "), w: u, b: d.shortMonths[h], B: d.months[h], m: k(h + 1), y: m.toString().substr(2, 2), Y: m,
        H: k(w), k: w, I: k(w % 12 || 12), l: w % 12 || 12, M: k(n[r.hcGetMinutes]()), p: 12 > w ? "AM" : "PM", P: 12 > w ? "am" : "pm", S: k(n.getSeconds()), L: k(Math.round(f % 1E3), 3) }, a.dateFormats);a.objectEach(r, function (a, b) {
        for (; -1 !== p.indexOf("%" + b);) {
          p = p.replace("%" + b, "function" === typeof a ? a(f) : a);
        }
      });return l ? p.substr(0, 1).toUpperCase() + p.substr(1) : p;
    };a.formatSingle = function (p, f) {
      var l = /\.([0-9])/,
          r = a.defaultOptions.lang;/f$/.test(p) ? (l = (l = p.match(l)) ? l[1] : -1, null !== f && (f = a.numberFormat(f, l, r.decimalPoint, -1 < p.indexOf(",") ? r.thousandsSep : ""))) : f = a.dateFormat(p, f);return f;
    };a.format = function (p, f) {
      for (var l = "{", r = !1, n, w, u, e, h = [], m; p;) {
        l = p.indexOf(l);if (-1 === l) break;n = p.slice(0, l);if (r) {
          n = n.split(":");w = n.shift().split(".");e = w.length;m = f;for (u = 0; u < e; u++) {
            m && (m = m[w[u]]);
          }n.length && (m = a.formatSingle(n.join(":"), m));h.push(m);
        } else h.push(n);p = p.slice(l + 1);l = (r = !r) ? "}" : "{";
      }h.push(p);return h.join("");
    };a.getMagnitude = function (a) {
      return Math.pow(10, Math.floor(Math.log(a) / Math.LN10));
    };a.normalizeTickInterval = function (p, f, l, r, n) {
      var w,
          u = p;l = a.pick(l, 1);w = p / l;f || (f = n ? [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] : [1, 2, 2.5, 5, 10], !1 === r && (1 === l ? f = a.grep(f, function (a) {
        return 0 === a % 1;
      }) : .1 >= l && (f = [1 / l])));for (r = 0; r < f.length && !(u = f[r], n && u * l >= p || !n && w <= (f[r] + (f[r + 1] || f[r])) / 2); r++) {}return u = a.correctFloat(u * l, -Math.round(Math.log(.001) / Math.LN10));
    };a.stableSort = function (a, f) {
      var l = a.length,
          p,
          n;for (n = 0; n < l; n++) {
        a[n].safeI = n;
      }a.sort(function (a, n) {
        p = f(a, n);return 0 === p ? a.safeI - n.safeI : p;
      });for (n = 0; n < l; n++) {
        delete a[n].safeI;
      }
    };a.arrayMin = function (a) {
      for (var f = a.length, l = a[0]; f--;) {
        a[f] < l && (l = a[f]);
      }return l;
    };a.arrayMax = function (a) {
      for (var f = a.length, l = a[0]; f--;) {
        a[f] > l && (l = a[f]);
      }return l;
    };a.destroyObjectProperties = function (p, f) {
      a.objectEach(p, function (a, r) {
        a && a !== f && a.destroy && a.destroy();delete p[r];
      });
    };a.discardElement = function (p) {
      var f = a.garbageBin;f || (f = a.createElement("div"));p && f.appendChild(p);f.innerHTML = "";
    };a.correctFloat = function (a, f) {
      return parseFloat(a.toPrecision(f || 14));
    };a.setAnimation = function (p, f) {
      f.renderer.globalAnimation = a.pick(p, f.options.chart.animation, !0);
    };a.animObject = function (p) {
      return a.isObject(p) ? a.merge(p) : { duration: p ? 500 : 0 };
    };a.timeUnits = { millisecond: 1, second: 1E3, minute: 6E4, hour: 36E5, day: 864E5, week: 6048E5, month: 24192E5, year: 314496E5 };a.numberFormat = function (p, f, l, r) {
      p = +p || 0;f = +f;var n = a.defaultOptions.lang,
          w = (p.toString().split(".")[1] || "").split("e")[0].length,
          u,
          e,
          h = p.toString().split("e");-1 === f ? f = Math.min(w, 20) : a.isNumber(f) ? f && h[1] && 0 > h[1] && (u = f + +h[1], 0 <= u ? (h[0] = (+h[0]).toExponential(u).split("e")[0], f = u) : (h[0] = h[0].split(".")[0] || 0, p = 20 > f ? (h[0] * Math.pow(10, h[1])).toFixed(f) : 0, h[1] = 0)) : f = 2;e = (Math.abs(h[1] ? h[0] : p) + Math.pow(10, -Math.max(f, w) - 1)).toFixed(f);w = String(a.pInt(e));u = 3 < w.length ? w.length % 3 : 0;l = a.pick(l, n.decimalPoint);r = a.pick(r, n.thousandsSep);p = (0 > p ? "-" : "") + (u ? w.substr(0, u) + r : "");p += w.substr(u).replace(/(\d{3})(?=\d)/g, "$1" + r);f && (p += l + e.slice(-f));h[1] && 0 !== +p && (p += "e" + h[1]);return p;
    };Math.easeInOutSine = function (a) {
      return -.5 * (Math.cos(Math.PI * a) - 1);
    };a.getStyle = function (p, f, l) {
      if ("width" === f) return Math.min(p.offsetWidth, p.scrollWidth) - a.getStyle(p, "padding-left") - a.getStyle(p, "padding-right");if ("height" === f) return Math.min(p.offsetHeight, p.scrollHeight) - a.getStyle(p, "padding-top") - a.getStyle(p, "padding-bottom");H.getComputedStyle || a.error(27, !0);if (p = H.getComputedStyle(p, void 0)) p = p.getPropertyValue(f), a.pick(l, "opacity" !== f) && (p = a.pInt(p));return p;
    };a.inArray = function (p, f) {
      return (a.indexOfPolyfill || Array.prototype.indexOf).call(f, p);
    };a.grep = function (p, f) {
      return (a.filterPolyfill || Array.prototype.filter).call(p, f);
    };a.find = Array.prototype.find ? function (a, f) {
      return a.find(f);
    } : function (a, f) {
      var l,
          r = a.length;for (l = 0; l < r; l++) {
        if (f(a[l], l)) return a[l];
      }
    };a.map = function (a, f) {
      for (var l = [], r = 0, n = a.length; r < n; r++) {
        l[r] = f.call(a[r], a[r], r, a);
      }return l;
    };a.keys = function (p) {
      return (a.keysPolyfill || Object.keys).call(void 0, p);
    };a.reduce = function (p, f, l) {
      return (a.reducePolyfill || Array.prototype.reduce).call(p, f, l);
    };a.offset = function (a) {
      var f = D.documentElement;a = a.parentElement ? a.getBoundingClientRect() : { top: 0, left: 0 };return { top: a.top + (H.pageYOffset || f.scrollTop) - (f.clientTop || 0), left: a.left + (H.pageXOffset || f.scrollLeft) - (f.clientLeft || 0) };
    };a.stop = function (p, f) {
      for (var l = a.timers.length; l--;) {
        a.timers[l].elem !== p || f && f !== a.timers[l].prop || (a.timers[l].stopped = !0);
      }
    };a.each = function (p, f, l) {
      return (a.forEachPolyfill || Array.prototype.forEach).call(p, f, l);
    };a.objectEach = function (a, f, l) {
      for (var r in a) {
        a.hasOwnProperty(r) && f.call(l, a[r], r, a);
      }
    };a.addEvent = function (p, f, l) {
      var r,
          n,
          w = p.addEventListener || a.addEventListenerPolyfill;p.hcEvents && !Object.prototype.hasOwnProperty.call(p, "hcEvents") && (n = {}, a.objectEach(p.hcEvents, function (a, e) {
        n[e] = a.slice(0);
      }), p.hcEvents = n);r = p.hcEvents = p.hcEvents || {};w && w.call(p, f, l, !1);r[f] || (r[f] = []);r[f].push(l);return function () {
        a.removeEvent(p, f, l);
      };
    };a.removeEvent = function (p, f, l) {
      function r(e, m) {
        var d = p.removeEventListener || a.removeEventListenerPolyfill;d && d.call(p, e, m, !1);
      }function n() {
        var e, m;p.nodeName && (f ? (e = {}, e[f] = !0) : e = u, a.objectEach(e, function (a, c) {
          if (u[c]) for (m = u[c].length; m--;) {
            r(c, u[c][m]);
          }
        }));
      }
      var w,
          u = p.hcEvents,
          e;u && (f ? (w = u[f] || [], l ? (e = a.inArray(l, w), -1 < e && (w.splice(e, 1), u[f] = w), r(f, l)) : (n(), u[f] = [])) : (n(), p.hcEvents = {}));
    };a.fireEvent = function (p, f, l, r) {
      var n;n = p.hcEvents;var w, u;l = l || {};if (D.createEvent && (p.dispatchEvent || p.fireEvent)) n = D.createEvent("Events"), n.initEvent(f, !0, !0), a.extend(n, l), p.dispatchEvent ? p.dispatchEvent(n) : p.fireEvent(f, n);else if (n) for (n = n[f] || [], w = n.length, l.target || a.extend(l, { preventDefault: function preventDefault() {
          l.defaultPrevented = !0;
        }, target: p, type: f }), f = 0; f < w; f++) {
        (u = n[f]) && !1 === u.call(p, l) && l.preventDefault();
      }r && !l.defaultPrevented && r(l);
    };a.animate = function (p, f, l) {
      var r,
          n = "",
          w,
          u,
          e;a.isObject(l) || (e = arguments, l = { duration: e[2], easing: e[3], complete: e[4] });a.isNumber(l.duration) || (l.duration = 400);l.easing = "function" === typeof l.easing ? l.easing : Math[l.easing] || Math.easeInOutSine;l.curAnim = a.merge(f);a.objectEach(f, function (e, m) {
        a.stop(p, m);u = new a.Fx(p, l, m);w = null;"d" === m ? (u.paths = u.initPath(p, p.d, f.d), u.toD = f.d, r = 0, w = 1) : p.attr ? r = p.attr(m) : (r = parseFloat(a.getStyle(p, m)) || 0, "opacity" !== m && (n = "px"));w || (w = e);w && w.match && w.match("px") && (w = w.replace(/px/g, ""));u.run(r, w, n);
      });
    };a.seriesType = function (p, f, l, r, n) {
      var w = a.getOptions(),
          u = a.seriesTypes;w.plotOptions[p] = a.merge(w.plotOptions[f], l);u[p] = a.extendClass(u[f] || function () {}, r);u[p].prototype.type = p;n && (u[p].prototype.pointClass = a.extendClass(a.Point, n));return u[p];
    };a.uniqueKey = function () {
      var a = Math.random().toString(36).substring(2, 9),
          f = 0;return function () {
        return "highcharts-" + a + "-" + f++;
      };
    }();H.jQuery && (H.jQuery.fn.highcharts = function () {
      var p = [].slice.call(arguments);if (this[0]) return p[0] ? (new a[a.isString(p[0]) ? p.shift() : "Chart"](this[0], p[0], p[1]), this) : E[a.attr(this[0], "data-highcharts-chart")];
    });
  })(M);(function (a) {
    var E = a.each,
        D = a.isNumber,
        H = a.map,
        p = a.merge,
        f = a.pInt;a.Color = function (l) {
      if (!(this instanceof a.Color)) return new a.Color(l);this.init(l);
    };a.Color.prototype = { parsers: [{ regex: /rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/, parse: function parse(a) {
          return [f(a[1]), f(a[2]), f(a[3]), parseFloat(a[4], 10)];
        } }, { regex: /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/, parse: function parse(a) {
          return [f(a[1]), f(a[2]), f(a[3]), 1];
        } }], names: { none: "rgba(255,255,255,0)", white: "#ffffff", black: "#000000" }, init: function init(l) {
        var f, n, w, u;if ((this.input = l = this.names[l && l.toLowerCase ? l.toLowerCase() : ""] || l) && l.stops) this.stops = H(l.stops, function (e) {
          return new a.Color(e[1]);
        });else if (l && l.charAt && "#" === l.charAt() && (f = l.length, l = parseInt(l.substr(1), 16), 7 === f ? n = [(l & 16711680) >> 16, (l & 65280) >> 8, l & 255, 1] : 4 === f && (n = [(l & 3840) >> 4 | (l & 3840) >> 8, (l & 240) >> 4 | l & 240, (l & 15) << 4 | l & 15, 1])), !n) for (w = this.parsers.length; w-- && !n;) {
          u = this.parsers[w], (f = u.regex.exec(l)) && (n = u.parse(f));
        }this.rgba = n || [];
      }, get: function get(a) {
        var f = this.input,
            n = this.rgba,
            l;this.stops ? (l = p(f), l.stops = [].concat(l.stops), E(this.stops, function (n, e) {
          l.stops[e] = [l.stops[e][0], n.get(a)];
        })) : l = n && D(n[0]) ? "rgb" === a || !a && 1 === n[3] ? "rgb(" + n[0] + "," + n[1] + "," + n[2] + ")" : "a" === a ? n[3] : "rgba(" + n.join(",") + ")" : f;return l;
      }, brighten: function brighten(a) {
        var l,
            n = this.rgba;
        if (this.stops) E(this.stops, function (n) {
          n.brighten(a);
        });else if (D(a) && 0 !== a) for (l = 0; 3 > l; l++) {
          n[l] += f(255 * a), 0 > n[l] && (n[l] = 0), 255 < n[l] && (n[l] = 255);
        }return this;
      }, setOpacity: function setOpacity(a) {
        this.rgba[3] = a;return this;
      }, tweenTo: function tweenTo(a, f) {
        var n = this.rgba,
            l = a.rgba;l.length && n && n.length ? (a = 1 !== l[3] || 1 !== n[3], f = (a ? "rgba(" : "rgb(") + Math.round(l[0] + (n[0] - l[0]) * (1 - f)) + "," + Math.round(l[1] + (n[1] - l[1]) * (1 - f)) + "," + Math.round(l[2] + (n[2] - l[2]) * (1 - f)) + (a ? "," + (l[3] + (n[3] - l[3]) * (1 - f)) : "") + ")") : f = a.input || "none";return f;
      } };
    a.color = function (l) {
      return new a.Color(l);
    };
  })(M);(function (a) {
    var E,
        D,
        H = a.addEvent,
        p = a.animate,
        f = a.attr,
        l = a.charts,
        r = a.color,
        n = a.css,
        w = a.createElement,
        u = a.defined,
        e = a.deg2rad,
        h = a.destroyObjectProperties,
        m = a.doc,
        d = a.each,
        c = a.extend,
        b = a.erase,
        k = a.grep,
        z = a.hasTouch,
        B = a.inArray,
        I = a.isArray,
        x = a.isFirefox,
        K = a.isMS,
        t = a.isObject,
        C = a.isString,
        N = a.isWebKit,
        q = a.merge,
        A = a.noop,
        F = a.objectEach,
        G = a.pick,
        g = a.pInt,
        v = a.removeEvent,
        Q = a.stop,
        L = a.svg,
        P = a.SVG_NS,
        J = a.symbolSizes,
        R = a.win;E = a.SVGElement = function () {
      return this;
    };
    c(E.prototype, { opacity: 1, SVG_NS: P, textProps: "direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline".split(" "), init: function init(a, g) {
        this.element = "span" === g ? w(g) : m.createElementNS(this.SVG_NS, g);this.renderer = a;
      }, animate: function animate(y, g, b) {
        g = a.animObject(G(g, this.renderer.globalAnimation, !0));0 !== g.duration ? (b && (g.complete = b), p(this, y, g)) : (this.attr(y, null, b), g.step && g.step.call(this));return this;
      }, colorGradient: function colorGradient(y, g, b) {
        var v = this.renderer,
            c,
            O,
            k,
            e,
            z,
            h,
            m,
            L,
            A,
            J,
            t = [],
            x;y.radialGradient ? O = "radialGradient" : y.linearGradient && (O = "linearGradient");O && (k = y[O], z = v.gradients, m = y.stops, J = b.radialReference, I(k) && (y[O] = k = { x1: k[0], y1: k[1], x2: k[2], y2: k[3], gradientUnits: "userSpaceOnUse" }), "radialGradient" === O && J && !u(k.gradientUnits) && (e = k, k = q(k, v.getRadialAttr(J, e), { gradientUnits: "userSpaceOnUse" })), F(k, function (a, y) {
          "id" !== y && t.push(y, a);
        }), F(m, function (a) {
          t.push(a);
        }), t = t.join(","), z[t] ? J = z[t].attr("id") : (k.id = J = a.uniqueKey(), z[t] = h = v.createElement(O).attr(k).add(v.defs), h.radAttr = e, h.stops = [], d(m, function (y) {
          0 === y[1].indexOf("rgba") ? (c = a.color(y[1]), L = c.get("rgb"), A = c.get("a")) : (L = y[1], A = 1);y = v.createElement("stop").attr({ offset: y[0], "stop-color": L, "stop-opacity": A }).add(h);h.stops.push(y);
        })), x = "url(" + v.url + "#" + J + ")", b.setAttribute(g, x), b.gradient = t, y.toString = function () {
          return x;
        });
      }, applyTextOutline: function applyTextOutline(y) {
        var g = this.element,
            v,
            c,
            k,
            q,
            e;-1 !== y.indexOf("contrast") && (y = y.replace(/contrast/g, this.renderer.getContrast(g.style.fill)));y = y.split(" ");c = y[y.length - 1];
        if ((k = y[0]) && "none" !== k && a.svg) {
          this.fakeTS = !0;y = [].slice.call(g.getElementsByTagName("tspan"));this.ySetter = this.xSetter;k = k.replace(/(^[\d\.]+)(.*?)$/g, function (a, y, g) {
            return 2 * y + g;
          });for (e = y.length; e--;) {
            v = y[e], "highcharts-text-outline" === v.getAttribute("class") && b(y, g.removeChild(v));
          }q = g.firstChild;d(y, function (a, y) {
            0 === y && (a.setAttribute("x", g.getAttribute("x")), y = g.getAttribute("y"), a.setAttribute("y", y || 0), null === y && g.setAttribute("y", 0));a = a.cloneNode(1);f(a, { "class": "highcharts-text-outline",
              fill: c, stroke: c, "stroke-width": k, "stroke-linejoin": "round" });g.insertBefore(a, q);
          });
        }
      }, attr: function attr(a, g, b, v) {
        var y,
            c = this.element,
            k,
            d = this,
            O,
            q;"string" === typeof a && void 0 !== g && (y = a, a = {}, a[y] = g);"string" === typeof a ? d = (this[a + "Getter"] || this._defaultGetter).call(this, a, c) : (F(a, function (y, g) {
          O = !1;v || Q(this, g);this.symbolName && /^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/.test(g) && (k || (this.symbolAttr(a), k = !0), O = !0);!this.rotation || "x" !== g && "y" !== g || (this.doTransform = !0);O || (q = this[g + "Setter"] || this._defaultSetter, q.call(this, y, g, c), this.shadows && /^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(g) && this.updateShadows(g, y, q));
        }, this), this.afterSetters());b && b();return d;
      }, afterSetters: function afterSetters() {
        this.doTransform && (this.updateTransform(), this.doTransform = !1);
      }, updateShadows: function updateShadows(a, g, b) {
        for (var y = this.shadows, v = y.length; v--;) {
          b.call(y[v], "height" === a ? Math.max(g - (y[v].cutHeight || 0), 0) : "d" === a ? this.d : g, a, y[v]);
        }
      }, addClass: function addClass(a, g) {
        var y = this.attr("class") || "";-1 === y.indexOf(a) && (g || (a = (y + (y ? " " : "") + a).replace("  ", " ")), this.attr("class", a));return this;
      }, hasClass: function hasClass(a) {
        return -1 !== B(a, (this.attr("class") || "").split(" "));
      }, removeClass: function removeClass(a) {
        return this.attr("class", (this.attr("class") || "").replace(a, ""));
      }, symbolAttr: function symbolAttr(a) {
        var y = this;d("x y r start end width height innerR anchorX anchorY".split(" "), function (g) {
          y[g] = G(a[g], y[g]);
        });y.attr({ d: y.renderer.symbols[y.symbolName](y.x, y.y, y.width, y.height, y) });
      }, clip: function clip(a) {
        return this.attr("clip-path", a ? "url(" + this.renderer.url + "#" + a.id + ")" : "none");
      }, crisp: function crisp(a, g) {
        var y;g = g || a.strokeWidth || 0;y = Math.round(g) % 2 / 2;a.x = Math.floor(a.x || this.x || 0) + y;a.y = Math.floor(a.y || this.y || 0) + y;a.width = Math.floor((a.width || this.width || 0) - 2 * y);a.height = Math.floor((a.height || this.height || 0) - 2 * y);u(a.strokeWidth) && (a.strokeWidth = g);return a;
      }, css: function css(a) {
        var y = this.styles,
            b = {},
            v = this.element,
            k,
            d = "",
            q,
            e = !y,
            z = ["textOutline", "textOverflow", "width"];a && a.color && (a.fill = a.color);y && F(a, function (a, g) {
          a !== y[g] && (b[g] = a, e = !0);
        });
        e && (y && (a = c(y, b)), k = this.textWidth = a && a.width && "auto" !== a.width && "text" === v.nodeName.toLowerCase() && g(a.width), this.styles = a, k && !L && this.renderer.forExport && delete a.width, K && !L ? n(this.element, a) : (q = function q(a, y) {
          return "-" + y.toLowerCase();
        }, F(a, function (a, y) {
          -1 === B(y, z) && (d += y.replace(/([A-Z])/g, q) + ":" + a + ";");
        }), d && f(v, "style", d)), this.added && ("text" === this.element.nodeName && this.renderer.buildText(this), a && a.textOutline && this.applyTextOutline(a.textOutline)));return this;
      }, strokeWidth: function strokeWidth() {
        return this["stroke-width"] || 0;
      }, on: function on(a, g) {
        var y = this,
            b = y.element;z && "click" === a ? (b.ontouchstart = function (a) {
          y.touchEventFired = Date.now();a.preventDefault();g.call(b, a);
        }, b.onclick = function (a) {
          (-1 === R.navigator.userAgent.indexOf("Android") || 1100 < Date.now() - (y.touchEventFired || 0)) && g.call(b, a);
        }) : b["on" + a] = g;return this;
      }, setRadialReference: function setRadialReference(a) {
        var y = this.renderer.gradients[this.element.gradient];this.element.radialReference = a;y && y.radAttr && y.animate(this.renderer.getRadialAttr(a, y.radAttr));return this;
      }, translate: function translate(a, g) {
        return this.attr({ translateX: a, translateY: g });
      }, invert: function invert(a) {
        this.inverted = a;this.updateTransform();return this;
      }, updateTransform: function updateTransform() {
        var a = this.translateX || 0,
            g = this.translateY || 0,
            b = this.scaleX,
            v = this.scaleY,
            c = this.inverted,
            k = this.rotation,
            d = this.matrix,
            q = this.element;c && (a += this.width, g += this.height);a = ["translate(" + a + "," + g + ")"];u(d) && a.push("matrix(" + d.join(",") + ")");c ? a.push("rotate(90) scale(-1,1)") : k && a.push("rotate(" + k + " " + G(this.rotationOriginX, q.getAttribute("x"), 0) + " " + G(this.rotationOriginY, q.getAttribute("y") || 0) + ")");(u(b) || u(v)) && a.push("scale(" + G(b, 1) + " " + G(v, 1) + ")");a.length && q.setAttribute("transform", a.join(" "));
      }, toFront: function toFront() {
        var a = this.element;a.parentNode.appendChild(a);return this;
      }, align: function align(a, g, v) {
        var y,
            c,
            k,
            d,
            q = {};c = this.renderer;k = c.alignedObjects;var e, O;if (a) {
          if (this.alignOptions = a, this.alignByTranslate = g, !v || C(v)) this.alignTo = y = v || "renderer", b(k, this), k.push(this), v = null;
        } else a = this.alignOptions, g = this.alignByTranslate, y = this.alignTo;v = G(v, c[y], c);y = a.align;
        c = a.verticalAlign;k = (v.x || 0) + (a.x || 0);d = (v.y || 0) + (a.y || 0);"right" === y ? e = 1 : "center" === y && (e = 2);e && (k += (v.width - (a.width || 0)) / e);q[g ? "translateX" : "x"] = Math.round(k);"bottom" === c ? O = 1 : "middle" === c && (O = 2);O && (d += (v.height - (a.height || 0)) / O);q[g ? "translateY" : "y"] = Math.round(d);this[this.placed ? "animate" : "attr"](q);this.placed = !0;this.alignAttr = q;return this;
      }, getBBox: function getBBox(a, g) {
        var y,
            b = this.renderer,
            v,
            k = this.element,
            q = this.styles,
            O,
            z = this.textStr,
            h,
            m = b.cache,
            L = b.cacheKeys,
            A;g = G(g, this.rotation);v = g * e;
        O = q && q.fontSize;u(z) && (A = z.toString(), -1 === A.indexOf("\x3c") && (A = A.replace(/[0-9]/g, "0")), A += ["", g || 0, O, q && q.width, q && q.textOverflow].join());A && !a && (y = m[A]);if (!y) {
          if (k.namespaceURI === this.SVG_NS || b.forExport) {
            try {
              (h = this.fakeTS && function (a) {
                d(k.querySelectorAll(".highcharts-text-outline"), function (y) {
                  y.style.display = a;
                });
              }) && h("none"), y = k.getBBox ? c({}, k.getBBox()) : { width: k.offsetWidth, height: k.offsetHeight }, h && h("");
            } catch (W) {}if (!y || 0 > y.width) y = { width: 0, height: 0 };
          } else y = this.htmlGetBBox();b.isSVG && (a = y.width, b = y.height, q && "11px" === q.fontSize && 17 === Math.round(b) && (y.height = b = 14), g && (y.width = Math.abs(b * Math.sin(v)) + Math.abs(a * Math.cos(v)), y.height = Math.abs(b * Math.cos(v)) + Math.abs(a * Math.sin(v))));if (A && 0 < y.height) {
            for (; 250 < L.length;) {
              delete m[L.shift()];
            }m[A] || L.push(A);m[A] = y;
          }
        }return y;
      }, show: function show(a) {
        return this.attr({ visibility: a ? "inherit" : "visible" });
      }, hide: function hide() {
        return this.attr({ visibility: "hidden" });
      }, fadeOut: function fadeOut(a) {
        var y = this;y.animate({ opacity: 0 }, { duration: a || 150, complete: function complete() {
            y.attr({ y: -9999 });
          } });
      },
      add: function add(a) {
        var y = this.renderer,
            g = this.element,
            b;a && (this.parentGroup = a);this.parentInverted = a && a.inverted;void 0 !== this.textStr && y.buildText(this);this.added = !0;if (!a || a.handleZ || this.zIndex) b = this.zIndexSetter();b || (a ? a.element : y.box).appendChild(g);if (this.onAdd) this.onAdd();return this;
      }, safeRemoveChild: function safeRemoveChild(a) {
        var y = a.parentNode;y && y.removeChild(a);
      }, destroy: function destroy() {
        var a = this,
            g = a.element || {},
            v = a.renderer.isSVG && "SPAN" === g.nodeName && a.parentGroup,
            c = g.ownerSVGElement;g.onclick = g.onmouseout = g.onmouseover = g.onmousemove = g.point = null;Q(a);a.clipPath && c && (d(c.querySelectorAll("[clip-path],[CLIP-PATH]"), function (g) {
          g.getAttribute("clip-path").match(RegExp('[("]#' + a.clipPath.element.id + '[)"]')) && g.removeAttribute("clip-path");
        }), a.clipPath = a.clipPath.destroy());if (a.stops) {
          for (c = 0; c < a.stops.length; c++) {
            a.stops[c] = a.stops[c].destroy();
          }a.stops = null;
        }a.safeRemoveChild(g);for (a.destroyShadows(); v && v.div && 0 === v.div.childNodes.length;) {
          g = v.parentGroup, a.safeRemoveChild(v.div), delete v.div, v = g;
        }a.alignTo && b(a.renderer.alignedObjects, a);F(a, function (g, y) {
          delete a[y];
        });return null;
      }, shadow: function shadow(a, g, b) {
        var y = [],
            v,
            c,
            k = this.element,
            d,
            q,
            e,
            z;if (!a) this.destroyShadows();else if (!this.shadows) {
          q = G(a.width, 3);e = (a.opacity || .15) / q;z = this.parentInverted ? "(-1,-1)" : "(" + G(a.offsetX, 1) + ", " + G(a.offsetY, 1) + ")";for (v = 1; v <= q; v++) {
            c = k.cloneNode(0), d = 2 * q + 1 - 2 * v, f(c, { isShadow: "true", stroke: a.color || "#000000", "stroke-opacity": e * v, "stroke-width": d, transform: "translate" + z, fill: "none" }), b && (f(c, "height", Math.max(f(c, "height") - d, 0)), c.cutHeight = d), g ? g.element.appendChild(c) : k.parentNode && k.parentNode.insertBefore(c, k), y.push(c);
          }this.shadows = y;
        }return this;
      }, destroyShadows: function destroyShadows() {
        d(this.shadows || [], function (a) {
          this.safeRemoveChild(a);
        }, this);this.shadows = void 0;
      }, xGetter: function xGetter(a) {
        "circle" === this.element.nodeName && ("x" === a ? a = "cx" : "y" === a && (a = "cy"));return this._defaultGetter(a);
      }, _defaultGetter: function _defaultGetter(a) {
        a = G(this[a + "Value"], this[a], this.element ? this.element.getAttribute(a) : null, 0);/^[\-0-9\.]+$/.test(a) && (a = parseFloat(a));
        return a;
      }, dSetter: function dSetter(a, g, b) {
        a && a.join && (a = a.join(" "));/(NaN| {2}|^$)/.test(a) && (a = "M 0 0");this[g] !== a && (b.setAttribute(g, a), this[g] = a);
      }, dashstyleSetter: function dashstyleSetter(a) {
        var b,
            v = this["stroke-width"];"inherit" === v && (v = 1);if (a = a && a.toLowerCase()) {
          a = a.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");for (b = a.length; b--;) {
            a[b] = g(a[b]) * v;
          }a = a.join(",").replace(/NaN/g, "none");this.element.setAttribute("stroke-dasharray", a);
        }
      }, alignSetter: function alignSetter(a) {
        this.alignValue = a;this.element.setAttribute("text-anchor", { left: "start", center: "middle", right: "end" }[a]);
      }, opacitySetter: function opacitySetter(a, g, b) {
        this[g] = a;b.setAttribute(g, a);
      }, titleSetter: function titleSetter(a) {
        var g = this.element.getElementsByTagName("title")[0];g || (g = m.createElementNS(this.SVG_NS, "title"), this.element.appendChild(g));g.firstChild && g.removeChild(g.firstChild);g.appendChild(m.createTextNode(String(G(a), "").replace(/<[^>]*>/g, "")));
      }, textSetter: function textSetter(a) {
        a !== this.textStr && (delete this.bBox, this.textStr = a, this.added && this.renderer.buildText(this));
      }, fillSetter: function fillSetter(a, g, b) {
        "string" === typeof a ? b.setAttribute(g, a) : a && this.colorGradient(a, g, b);
      }, visibilitySetter: function visibilitySetter(a, g, b) {
        "inherit" === a ? b.removeAttribute(g) : this[g] !== a && b.setAttribute(g, a);this[g] = a;
      }, zIndexSetter: function zIndexSetter(a, b) {
        var v = this.renderer,
            y = this.parentGroup,
            c = (y || v).element || v.box,
            k,
            d = this.element,
            q,
            e,
            v = c === v.box;k = this.added;var z;u(a) && (d.zIndex = a, a = +a, this[b] === a && (k = !1), this[b] = a);if (k) {
          (a = this.zIndex) && y && (y.handleZ = !0);b = c.childNodes;for (z = b.length - 1; 0 <= z && !q; z--) {
            if (y = b[z], k = y.zIndex, e = !u(k), y !== d) if (0 > a && e && !v && !z) c.insertBefore(d, b[z]), q = !0;else if (g(k) <= a || e && (!u(a) || 0 <= a)) c.insertBefore(d, b[z + 1] || null), q = !0;
          }q || (c.insertBefore(d, b[v ? 3 : 0] || null), q = !0);
        }return q;
      }, _defaultSetter: function _defaultSetter(a, g, b) {
        b.setAttribute(g, a);
      } });E.prototype.yGetter = E.prototype.xGetter;E.prototype.translateXSetter = E.prototype.translateYSetter = E.prototype.rotationSetter = E.prototype.verticalAlignSetter = E.prototype.rotationOriginXSetter = E.prototype.rotationOriginYSetter = E.prototype.scaleXSetter = E.prototype.scaleYSetter = E.prototype.matrixSetter = function (a, g) {
      this[g] = a;this.doTransform = !0;
    };E.prototype["stroke-widthSetter"] = E.prototype.strokeSetter = function (a, g, b) {
      this[g] = a;this.stroke && this["stroke-width"] ? (E.prototype.fillSetter.call(this, this.stroke, "stroke", b), b.setAttribute("stroke-width", this["stroke-width"]), this.hasStroke = !0) : "stroke-width" === g && 0 === a && this.hasStroke && (b.removeAttribute("stroke"), this.hasStroke = !1);
    };D = a.SVGRenderer = function () {
      this.init.apply(this, arguments);
    };c(D.prototype, { Element: E, SVG_NS: P, init: function init(a, g, b, v, c, k) {
        var y;v = this.createElement("svg").attr({ version: "1.1", "class": "highcharts-root" }).css(this.getStyle(v));y = v.element;a.appendChild(y);f(a, "dir", "ltr");-1 === a.innerHTML.indexOf("xmlns") && f(y, "xmlns", this.SVG_NS);this.isSVG = !0;this.box = y;this.boxWrapper = v;this.alignedObjects = [];this.url = (x || N) && m.getElementsByTagName("base").length ? R.location.href.replace(/#.*?$/, "").replace(/<[^>]*>/g, "").replace(/([\('\)])/g, "\\$1").replace(/ /g, "%20") : "";this.createElement("desc").add().element.appendChild(m.createTextNode("Created with Highcharts 6.0.4"));this.defs = this.createElement("defs").add();this.allowHTML = k;this.forExport = c;this.gradients = {};this.cache = {};this.cacheKeys = [];this.imgCount = 0;this.setSize(g, b, !1);var d;x && a.getBoundingClientRect && (g = function g() {
          n(a, { left: 0, top: 0 });d = a.getBoundingClientRect();n(a, { left: Math.ceil(d.left) - d.left + "px", top: Math.ceil(d.top) - d.top + "px" });
        }, g(), this.unSubPixelFix = H(R, "resize", g));
      }, getStyle: function getStyle(a) {
        return this.style = c({ fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', fontSize: "12px" }, a);
      }, setStyle: function setStyle(a) {
        this.boxWrapper.css(this.getStyle(a));
      }, isHidden: function isHidden() {
        return !this.boxWrapper.getBBox().width;
      }, destroy: function destroy() {
        var a = this.defs;this.box = null;this.boxWrapper = this.boxWrapper.destroy();h(this.gradients || {});this.gradients = null;a && (this.defs = a.destroy());
        this.unSubPixelFix && this.unSubPixelFix();return this.alignedObjects = null;
      }, createElement: function createElement(a) {
        var g = new this.Element();g.init(this, a);return g;
      }, draw: A, getRadialAttr: function getRadialAttr(a, g) {
        return { cx: a[0] - a[2] / 2 + g.cx * a[2], cy: a[1] - a[2] / 2 + g.cy * a[2], r: g.r * a[2] };
      }, getSpanWidth: function getSpanWidth(a, g) {
        var b = a.getBBox(!0).width;!L && this.forExport && (b = this.measureSpanWidth(g.firstChild.data, a.styles));return b;
      }, applyEllipsis: function applyEllipsis(a, g, b, v) {
        var c = a.rotation,
            y = b,
            k,
            d = 0,
            q = b.length,
            e = function e(a) {
          g.removeChild(g.firstChild);
          a && g.appendChild(m.createTextNode(a));
        },
            z;a.rotation = 0;y = this.getSpanWidth(a, g);if (z = y > v) {
          for (; d <= q;) {
            k = Math.ceil((d + q) / 2), y = b.substring(0, k) + "\u2026", e(y), y = this.getSpanWidth(a, g), d === q ? d = q + 1 : y > v ? q = k - 1 : d = k;
          }0 === q && e("");
        }a.rotation = c;return z;
      }, escapes: { "\x26": "\x26amp;", "\x3c": "\x26lt;", "\x3e": "\x26gt;", "'": "\x26#39;", '"': "\x26quot;" }, buildText: function buildText(a) {
        var b = a.element,
            v = this,
            c = v.forExport,
            y = G(a.textStr, "").toString(),
            q = -1 !== y.indexOf("\x3c"),
            e = b.childNodes,
            z,
            h,
            A,
            J,
            t = f(b, "x"),
            x = a.styles,
            B = a.textWidth,
            l = x && x.lineHeight,
            C = x && x.textOutline,
            u = x && "ellipsis" === x.textOverflow,
            Q = x && "nowrap" === x.whiteSpace,
            w = x && x.fontSize,
            R,
            I,
            r = e.length,
            x = B && !a.added && this.box,
            p = function p(a) {
          var c;c = /(px|em)$/.test(a && a.style.fontSize) ? a.style.fontSize : w || v.style.fontSize || 12;return l ? g(l) : v.fontMetrics(c, a.getAttribute("style") ? a : b).h;
        },
            K = function K(a) {
          F(v.escapes, function (g, b) {
            a = a.replace(new RegExp(g, "g"), b);
          });return a;
        };R = [y, u, Q, l, C, w, B].join();if (R !== a.textCache) {
          for (a.textCache = R; r--;) {
            b.removeChild(e[r]);
          }q || C || u || B || -1 !== y.indexOf(" ") ? (z = /<.*class="([^"]+)".*>/, h = /<.*style="([^"]+)".*>/, A = /<.*href="([^"]+)".*>/, x && x.appendChild(b), y = q ? y.replace(/<(b|strong)>/g, '\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g, '\x3cspan style\x3d"font-style:italic"\x3e').replace(/<a/g, "\x3cspan").replace(/<\/(b|strong|i|em|a)>/g, "\x3c/span\x3e").split(/<br.*?>/g) : [y], y = k(y, function (a) {
            return "" !== a;
          }), d(y, function (g, y) {
            var k,
                q = 0;g = g.replace(/^\s+|\s+$/g, "").replace(/<span/g, "|||\x3cspan").replace(/<\/span>/g, "\x3c/span\x3e|||");
            k = g.split("|||");d(k, function (g) {
              if ("" !== g || 1 === k.length) {
                var d = {},
                    e = m.createElementNS(v.SVG_NS, "tspan"),
                    x,
                    F;z.test(g) && (x = g.match(z)[1], f(e, "class", x));h.test(g) && (F = g.match(h)[1].replace(/(;| |^)color([ :])/, "$1fill$2"), f(e, "style", F));A.test(g) && !c && (f(e, "onclick", 'location.href\x3d"' + g.match(A)[1] + '"'), f(e, "class", "highcharts-anchor"), n(e, { cursor: "pointer" }));g = K(g.replace(/<[a-zA-Z\/](.|\n)*?>/g, "") || " ");if (" " !== g) {
                  e.appendChild(m.createTextNode(g));q ? d.dx = 0 : y && null !== t && (d.x = t);f(e, d);b.appendChild(e);
                  !q && I && (!L && c && n(e, { display: "block" }), f(e, "dy", p(e)));if (B) {
                    d = g.replace(/([^\^])-/g, "$1- ").split(" ");x = 1 < k.length || y || 1 < d.length && !Q;var O = [],
                        l,
                        C = p(e),
                        G = a.rotation;for (u && (J = v.applyEllipsis(a, e, g, B)); !u && x && (d.length || O.length);) {
                      a.rotation = 0, l = v.getSpanWidth(a, e), g = l > B, void 0 === J && (J = g), g && 1 !== d.length ? (e.removeChild(e.firstChild), O.unshift(d.pop())) : (d = O, O = [], d.length && !Q && (e = m.createElementNS(P, "tspan"), f(e, { dy: C, x: t }), F && f(e, "style", F), b.appendChild(e)), l > B && (B = l)), d.length && e.appendChild(m.createTextNode(d.join(" ").replace(/- /g, "-")));
                    }a.rotation = G;
                  }q++;
                }
              }
            });I = I || b.childNodes.length;
          }), J && a.attr("title", a.textStr), x && x.removeChild(b), C && a.applyTextOutline && a.applyTextOutline(C)) : b.appendChild(m.createTextNode(K(y)));
        }
      }, getContrast: function getContrast(a) {
        a = r(a).rgba;return 510 < a[0] + a[1] + a[2] ? "#000000" : "#FFFFFF";
      }, button: function button(a, g, b, v, d, k, e, z, h) {
        var y = this.label(a, g, b, h, null, null, null, null, "button"),
            m = 0;y.attr(q({ padding: 8, r: 2 }, d));var A, L, J, t;d = q({ fill: "#f7f7f7", stroke: "#cccccc", "stroke-width": 1, style: { color: "#333333", cursor: "pointer",
            fontWeight: "normal" } }, d);A = d.style;delete d.style;k = q(d, { fill: "#e6e6e6" }, k);L = k.style;delete k.style;e = q(d, { fill: "#e6ebf5", style: { color: "#000000", fontWeight: "bold" } }, e);J = e.style;delete e.style;z = q(d, { style: { color: "#cccccc" } }, z);t = z.style;delete z.style;H(y.element, K ? "mouseover" : "mouseenter", function () {
          3 !== m && y.setState(1);
        });H(y.element, K ? "mouseout" : "mouseleave", function () {
          3 !== m && y.setState(m);
        });y.setState = function (a) {
          1 !== a && (y.state = m = a);y.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + ["normal", "hover", "pressed", "disabled"][a || 0]);y.attr([d, k, e, z][a || 0]).css([A, L, J, t][a || 0]);
        };y.attr(d).css(c({ cursor: "default" }, A));return y.on("click", function (a) {
          3 !== m && v.call(y, a);
        });
      }, crispLine: function crispLine(a, g) {
        a[1] === a[4] && (a[1] = a[4] = Math.round(a[1]) - g % 2 / 2);a[2] === a[5] && (a[2] = a[5] = Math.round(a[2]) + g % 2 / 2);return a;
      }, path: function path(a) {
        var g = { fill: "none" };I(a) ? g.d = a : t(a) && c(g, a);return this.createElement("path").attr(g);
      }, circle: function circle(a, g, b) {
        a = t(a) ? a : { x: a, y: g, r: b };g = this.createElement("circle");g.xSetter = g.ySetter = function (a, g, b) {
          b.setAttribute("c" + g, a);
        };return g.attr(a);
      }, arc: function arc(a, g, b, v, c, d) {
        t(a) ? (v = a, g = v.y, b = v.r, a = v.x) : v = { innerR: v, start: c, end: d };a = this.symbol("arc", a, g, b, b, v);a.r = b;return a;
      }, rect: function rect(a, g, b, v, c, d) {
        c = t(a) ? a.r : c;var k = this.createElement("rect");a = t(a) ? a : void 0 === a ? {} : { x: a, y: g, width: Math.max(b, 0), height: Math.max(v, 0) };void 0 !== d && (a.strokeWidth = d, a = k.crisp(a));a.fill = "none";c && (a.r = c);k.rSetter = function (a, g, b) {
          f(b, { rx: a, ry: a });
        };return k.attr(a);
      }, setSize: function setSize(a, g, b) {
        var v = this.alignedObjects,
            c = v.length;this.width = a;this.height = g;for (this.boxWrapper.animate({ width: a, height: g }, { step: function step() {
            this.attr({ viewBox: "0 0 " + this.attr("width") + " " + this.attr("height") });
          }, duration: G(b, !0) ? void 0 : 0 }); c--;) {
          v[c].align();
        }
      }, g: function g(a) {
        var g = this.createElement("g");return a ? g.attr({ "class": "highcharts-" + a }) : g;
      }, image: function image(a, g, b, v, d) {
        var k = { preserveAspectRatio: "none" };1 < arguments.length && c(k, { x: g, y: b, width: v, height: d });k = this.createElement("image").attr(k);k.element.setAttributeNS ? k.element.setAttributeNS("http://www.w3.org/1999/xlink", "href", a) : k.element.setAttribute("hc-svg-href", a);return k;
      }, symbol: function symbol(a, g, b, v, k, q) {
        var e = this,
            y,
            z = /^url\((.*?)\)$/,
            h = z.test(a),
            A = !h && (this.symbols[a] ? a : "circle"),
            L = A && this.symbols[A],
            t = u(g) && L && L.call(this.symbols, Math.round(g), Math.round(b), v, k, q),
            x,
            F;L ? (y = this.path(t), y.attr("fill", "none"), c(y, { symbolName: A, x: g, y: b, width: v, height: k }), q && c(y, q)) : h && (x = a.match(z)[1], y = this.image(x), y.imgwidth = G(J[x] && J[x].width, q && q.width), y.imgheight = G(J[x] && J[x].height, q && q.height), F = function F() {
          y.attr({ width: y.width, height: y.height });
        }, d(["width", "height"], function (a) {
          y[a + "Setter"] = function (a, g) {
            var b = {},
                v = this["img" + g],
                c = "width" === g ? "translateX" : "translateY";this[g] = a;u(v) && (this.element && this.element.setAttribute(g, v), this.alignByTranslate || (b[c] = ((this[g] || 0) - v) / 2, this.attr(b)));
          };
        }), u(g) && y.attr({ x: g, y: b }), y.isImg = !0, u(y.imgwidth) && u(y.imgheight) ? F() : (y.attr({ width: 0, height: 0 }), w("img", { onload: function onload() {
            var a = l[e.chartIndex];0 === this.width && (n(this, { position: "absolute", top: "-999em" }), m.body.appendChild(this));J[x] = { width: this.width, height: this.height };y.imgwidth = this.width;y.imgheight = this.height;y.element && F();this.parentNode && this.parentNode.removeChild(this);e.imgCount--;if (!e.imgCount && a && a.onload) a.onload();
          }, src: x }), this.imgCount++));return y;
      }, symbols: { circle: function circle(a, g, b, v) {
          return this.arc(a + b / 2, g + v / 2, b / 2, v / 2, { start: 0, end: 2 * Math.PI, open: !1 });
        }, square: function square(a, g, b, v) {
          return ["M", a, g, "L", a + b, g, a + b, g + v, a, g + v, "Z"];
        }, triangle: function triangle(a, g, b, v) {
          return ["M", a + b / 2, g, "L", a + b, g + v, a, g + v, "Z"];
        }, "triangle-down": function triangleDown(a, g, b, v) {
          return ["M", a, g, "L", a + b, g, a + b / 2, g + v, "Z"];
        }, diamond: function diamond(a, g, b, v) {
          return ["M", a + b / 2, g, "L", a + b, g + v / 2, a + b / 2, g + v, a, g + v / 2, "Z"];
        }, arc: function arc(a, g, b, v, c) {
          var k = c.start,
              d = c.r || b,
              q = c.r || v || b,
              e = c.end - .001;b = c.innerR;v = G(c.open, .001 > Math.abs(c.end - c.start - 2 * Math.PI));var y = Math.cos(k),
              z = Math.sin(k),
              h = Math.cos(e),
              e = Math.sin(e);c = .001 > c.end - k - Math.PI ? 0 : 1;d = ["M", a + d * y, g + q * z, "A", d, q, 0, c, 1, a + d * h, g + q * e];u(b) && d.push(v ? "M" : "L", a + b * h, g + b * e, "A", b, b, 0, c, 0, a + b * y, g + b * z);d.push(v ? "" : "Z");return d;
        }, callout: function callout(a, g, b, v, c) {
          var d = Math.min(c && c.r || 0, b, v),
              k = d + 6,
              q = c && c.anchorX;c = c && c.anchorY;var e;e = ["M", a + d, g, "L", a + b - d, g, "C", a + b, g, a + b, g, a + b, g + d, "L", a + b, g + v - d, "C", a + b, g + v, a + b, g + v, a + b - d, g + v, "L", a + d, g + v, "C", a, g + v, a, g + v, a, g + v - d, "L", a, g + d, "C", a, g, a, g, a + d, g];q && q > b ? c > g + k && c < g + v - k ? e.splice(13, 3, "L", a + b, c - 6, a + b + 6, c, a + b, c + 6, a + b, g + v - d) : e.splice(13, 3, "L", a + b, v / 2, q, c, a + b, v / 2, a + b, g + v - d) : q && 0 > q ? c > g + k && c < g + v - k ? e.splice(33, 3, "L", a, c + 6, a - 6, c, a, c - 6, a, g + d) : e.splice(33, 3, "L", a, v / 2, q, c, a, v / 2, a, g + d) : c && c > v && q > a + k && q < a + b - k ? e.splice(23, 3, "L", q + 6, g + v, q, g + v + 6, q - 6, g + v, a + d, g + v) : c && 0 > c && q > a + k && q < a + b - k && e.splice(3, 3, "L", q - 6, g, q, g - 6, q + 6, g, b - d, g);return e;
        } }, clipRect: function clipRect(g, b, v, c) {
        var d = a.uniqueKey(),
            k = this.createElement("clipPath").attr({ id: d }).add(this.defs);g = this.rect(g, b, v, c, 0).add(k);g.id = d;g.clipPath = k;g.count = 0;return g;
      }, text: function text(a, g, b, v) {
        var c = {};if (v && (this.allowHTML || !this.forExport)) return this.html(a, g, b);c.x = Math.round(g || 0);b && (c.y = Math.round(b));if (a || 0 === a) c.text = a;a = this.createElement("text").attr(c);v || (a.xSetter = function (a, g, b) {
          var v = b.getElementsByTagName("tspan"),
              c,
              d = b.getAttribute(g),
              k;for (k = 0; k < v.length; k++) {
            c = v[k], c.getAttribute(g) === d && c.setAttribute(g, a);
          }b.setAttribute(g, a);
        });return a;
      }, fontMetrics: function fontMetrics(a, b) {
        a = a || b && b.style && b.style.fontSize || this.style && this.style.fontSize;a = /px/.test(a) ? g(a) : /em/.test(a) ? parseFloat(a) * (b ? this.fontMetrics(null, b.parentNode).f : 16) : 12;b = 24 > a ? a + 3 : Math.round(1.2 * a);return { h: b, b: Math.round(.8 * b), f: a };
      }, rotCorr: function rotCorr(a, g, b) {
        var v = a;g && b && (v = Math.max(v * Math.cos(g * e), 4));return { x: -a / 3 * Math.sin(g * e), y: v };
      }, label: function label(g, b, k, e, z, h, m, A, L) {
        var y = this,
            J = y.g("button" !== L && "label"),
            t = J.text = y.text("", 0, 0, m).attr({ zIndex: 1 }),
            x,
            F,
            n = 0,
            B = 3,
            l = 0,
            C,
            f,
            Q,
            G,
            w,
            R = {},
            I,
            P,
            r = /^url\((.*?)\)$/.test(e),
            p = r,
            K,
            O,
            N,
            T;L && J.addClass("highcharts-" + L);p = r;K = function K() {
          return (I || 0) % 2 / 2;
        };O = function O() {
          var a = t.element.style,
              g = {};F = (void 0 === C || void 0 === f || w) && u(t.textStr) && t.getBBox();J.width = (C || F.width || 0) + 2 * B + l;J.height = (f || F.height || 0) + 2 * B;P = B + y.fontMetrics(a && a.fontSize, t).b;p && (x || (J.box = x = y.symbols[e] || r ? y.symbol(e) : y.rect(), x.addClass(("button" === L ? "" : "highcharts-label-box") + (L ? " highcharts-" + L + "-box" : "")), x.add(J), a = K(), g.x = a, g.y = (A ? -P : 0) + a), g.width = Math.round(J.width), g.height = Math.round(J.height), x.attr(c(g, R)), R = {});
        };N = function N() {
          var a = l + B,
              g;g = A ? 0 : P;u(C) && F && ("center" === w || "right" === w) && (a += { center: .5, right: 1 }[w] * (C - F.width));if (a !== t.x || g !== t.y) t.attr("x", a), void 0 !== g && t.attr("y", g);t.x = a;t.y = g;
        };T = function T(a, g) {
          x ? x.attr(a, g) : R[a] = g;
        };J.onAdd = function () {
          t.add(J);J.attr({ text: g || 0 === g ? g : "", x: b, y: k });x && u(z) && J.attr({ anchorX: z, anchorY: h });
        };J.widthSetter = function (g) {
          C = a.isNumber(g) ? g : null;
        };J.heightSetter = function (a) {
          f = a;
        };J["text-alignSetter"] = function (a) {
          w = a;
        };J.paddingSetter = function (a) {
          u(a) && a !== B && (B = J.padding = a, N());
        };J.paddingLeftSetter = function (a) {
          u(a) && a !== l && (l = a, N());
        };J.alignSetter = function (a) {
          a = { left: 0, center: .5, right: 1 }[a];a !== n && (n = a, F && J.attr({ x: Q }));
        };J.textSetter = function (a) {
          void 0 !== a && t.textSetter(a);
          O();N();
        };J["stroke-widthSetter"] = function (a, g) {
          a && (p = !0);I = this["stroke-width"] = a;T(g, a);
        };J.strokeSetter = J.fillSetter = J.rSetter = function (a, g) {
          "r" !== g && ("fill" === g && a && (p = !0), J[g] = a);T(g, a);
        };J.anchorXSetter = function (a, g) {
          z = J.anchorX = a;T(g, Math.round(a) - K() - Q);
        };J.anchorYSetter = function (a, g) {
          h = J.anchorY = a;T(g, a - G);
        };J.xSetter = function (a) {
          J.x = a;n && (a -= n * ((C || F.width) + 2 * B));Q = Math.round(a);J.attr("translateX", Q);
        };J.ySetter = function (a) {
          G = J.y = Math.round(a);J.attr("translateY", G);
        };var U = J.css;return c(J, { css: function css(a) {
            if (a) {
              var g = {};a = q(a);d(J.textProps, function (b) {
                void 0 !== a[b] && (g[b] = a[b], delete a[b]);
              });t.css(g);
            }return U.call(J, a);
          }, getBBox: function getBBox() {
            return { width: F.width + 2 * B, height: F.height + 2 * B, x: F.x - B, y: F.y - B };
          }, shadow: function shadow(a) {
            a && (O(), x && x.shadow(a));return J;
          }, destroy: function destroy() {
            v(J.element, "mouseenter");v(J.element, "mouseleave");t && (t = t.destroy());x && (x = x.destroy());E.prototype.destroy.call(J);J = y = O = N = T = null;
          } });
      } });a.Renderer = D;
  })(M);(function (a) {
    var E = a.attr,
        D = a.createElement,
        H = a.css,
        p = a.defined,
        f = a.each,
        l = a.extend,
        r = a.isFirefox,
        n = a.isMS,
        w = a.isWebKit,
        u = a.pick,
        e = a.pInt,
        h = a.SVGRenderer,
        m = a.win,
        d = a.wrap;l(a.SVGElement.prototype, { htmlCss: function htmlCss(a) {
        var b = this.element;if (b = a && "SPAN" === b.tagName && a.width) delete a.width, this.textWidth = b, this.updateTransform();a && "ellipsis" === a.textOverflow && (a.whiteSpace = "nowrap", a.overflow = "hidden");this.styles = l(this.styles, a);H(this.element, a);return this;
      }, htmlGetBBox: function htmlGetBBox() {
        var a = this.element;return { x: a.offsetLeft, y: a.offsetTop, width: a.offsetWidth, height: a.offsetHeight };
      },
      htmlUpdateTransform: function htmlUpdateTransform() {
        if (this.added) {
          var a = this.renderer,
              b = this.element,
              d = this.translateX || 0,
              z = this.translateY || 0,
              h = this.x || 0,
              m = this.y || 0,
              x = this.textAlign || "left",
              n = { left: 0, center: .5, right: 1 }[x],
              t = this.styles;H(b, { marginLeft: d, marginTop: z });this.shadows && f(this.shadows, function (a) {
            H(a, { marginLeft: d + 1, marginTop: z + 1 });
          });this.inverted && f(b.childNodes, function (c) {
            a.invertChild(c, b);
          });if ("SPAN" === b.tagName) {
            var l = this.rotation,
                u = e(this.textWidth),
                q = t && t.whiteSpace,
                A = [l, x, b.innerHTML, this.textWidth, this.textAlign].join();A !== this.cTT && (t = a.fontMetrics(b.style.fontSize).b, p(l) && this.setSpanRotation(l, n, t), H(b, { width: "", whiteSpace: q || "nowrap" }), b.offsetWidth > u && /[ \-]/.test(b.textContent || b.innerText) && H(b, { width: u + "px", display: "block", whiteSpace: q || "normal" }), this.getSpanCorrection(b.offsetWidth, t, n, l, x));H(b, { left: h + (this.xCorr || 0) + "px", top: m + (this.yCorr || 0) + "px" });w && (t = b.offsetHeight);this.cTT = A;
          }
        } else this.alignOnAdd = !0;
      }, setSpanRotation: function setSpanRotation(a, b, d) {
        var c = {},
            k = this.renderer.getTransformKey();
        c[k] = c.transform = "rotate(" + a + "deg)";c[k + (r ? "Origin" : "-origin")] = c.transformOrigin = 100 * b + "% " + d + "px";H(this.element, c);
      }, getSpanCorrection: function getSpanCorrection(a, b, d) {
        this.xCorr = -a * d;this.yCorr = -b;
      } });l(h.prototype, { getTransformKey: function getTransformKey() {
        return n && !/Edge/.test(m.navigator.userAgent) ? "-ms-transform" : w ? "-webkit-transform" : r ? "MozTransform" : m.opera ? "-o-transform" : "";
      }, html: function html(a, b, k) {
        var c = this.createElement("span"),
            e = c.element,
            h = c.renderer,
            m = h.isSVG,
            w = function w(a, b) {
          f(["opacity", "visibility"], function (c) {
            d(a, c + "Setter", function (a, c, d, k) {
              a.call(this, c, d, k);b[d] = c;
            });
          });
        };c.textSetter = function (a) {
          a !== e.innerHTML && delete this.bBox;this.textStr = a;e.innerHTML = u(a, "");c.htmlUpdateTransform();
        };m && w(c, c.element.style);c.xSetter = c.ySetter = c.alignSetter = c.rotationSetter = function (a, b) {
          "align" === b && (b = "textAlign");c[b] = a;c.htmlUpdateTransform();
        };c.attr({ text: a, x: Math.round(b), y: Math.round(k) }).css({ fontFamily: this.style.fontFamily, fontSize: this.style.fontSize, position: "absolute" });e.style.whiteSpace = "nowrap";c.css = c.htmlCss;m && (c.add = function (a) {
          var b,
              d = h.box.parentNode,
              k = [];if (this.parentGroup = a) {
            if (b = a.div, !b) {
              for (; a;) {
                k.push(a), a = a.parentGroup;
              }f(k.reverse(), function (a) {
                function e(g, b) {
                  a[b] = g;n ? q[h.getTransformKey()] = "translate(" + (a.x || a.translateX) + "px," + (a.y || a.translateY) + "px)" : "translateX" === b ? q.left = g + "px" : q.top = g + "px";a.doTransform = !0;
                }var q,
                    g = E(a.element, "class");g && (g = { className: g });b = a.div = a.div || D("div", g, { position: "absolute", left: (a.translateX || 0) + "px", top: (a.translateY || 0) + "px", display: a.display,
                  opacity: a.opacity, pointerEvents: a.styles && a.styles.pointerEvents }, b || d);q = b.style;l(a, { classSetter: function (a) {
                    return function (g) {
                      this.element.setAttribute("class", g);a.className = g;
                    };
                  }(b), on: function on() {
                    k[0].div && c.on.apply({ element: k[0].div }, arguments);return a;
                  }, translateXSetter: e, translateYSetter: e });w(a, q);
              });
            }
          } else b = d;b.appendChild(e);c.added = !0;c.alignOnAdd && c.htmlUpdateTransform();return c;
        });return c;
      } });
  })(M);(function (a) {
    function E() {
      var n = a.defaultOptions.global,
          l = r.moment;if (n.timezone) {
        if (l) return function (a) {
          return -l.tz(a, n.timezone).utcOffset();
        };a.error(25);
      }return n.useUTC && n.getTimezoneOffset;
    }function D() {
      var n = a.defaultOptions.global,
          f,
          u = n.useUTC,
          e = u ? "getUTC" : "get",
          h = u ? "setUTC" : "set",
          m = "Minutes Hours Day Date Month FullYear".split(" "),
          d = m.concat(["Milliseconds", "Seconds"]);a.Date = f = n.Date || r.Date;f.hcTimezoneOffset = u && n.timezoneOffset;f.hcGetTimezoneOffset = E();f.hcHasTimeZone = !(!f.hcTimezoneOffset && !f.hcGetTimezoneOffset);f.hcMakeTime = function (a, b, d, e, h, m) {
        var c;u ? (c = f.UTC.apply(0, arguments), c += p(c)) : c = new f(a, b, l(d, 1), l(e, 0), l(h, 0), l(m, 0)).getTime();return c;
      };for (n = 0; n < m.length; n++) {
        f["hcGet" + m[n]] = e + m[n];
      }for (n = 0; n < d.length; n++) {
        f["hcSet" + d[n]] = h + d[n];
      }
    }var H = a.color,
        p = a.getTZOffset,
        f = a.merge,
        l = a.pick,
        r = a.win;a.defaultOptions = { colors: "#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "), symbols: ["circle", "diamond", "square", "triangle", "triangle-down"], lang: { loading: "Loading...", months: "January February March April May June July August September October November December".split(" "),
        shortMonths: "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "), weekdays: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "), decimalPoint: ".", numericSymbols: "kMGTPE".split(""), resetZoom: "Reset zoom", resetZoomTitle: "Reset zoom level 1:1", thousandsSep: " " }, global: { useUTC: !0 }, chart: { borderRadius: 0, defaultSeriesType: "line", ignoreHiddenSeries: !0, spacing: [10, 10, 15, 10], resetZoomButton: { theme: { zIndex: 6 }, position: { align: "right", x: -10, y: 10 } }, width: null, height: null, borderColor: "#335cad",
        backgroundColor: "#ffffff", plotBorderColor: "#cccccc" }, title: { text: "Chart title", align: "center", margin: 15, widthAdjust: -44 }, subtitle: { text: "", align: "center", widthAdjust: -44 }, plotOptions: {}, labels: { style: { position: "absolute", color: "#333333" } }, legend: { enabled: !0, align: "center", layout: "horizontal", labelFormatter: function labelFormatter() {
          return this.name;
        }, borderColor: "#999999", borderRadius: 0, navigation: { activeColor: "#003399", inactiveColor: "#cccccc" }, itemStyle: { color: "#333333", fontSize: "12px", fontWeight: "bold", textOverflow: "ellipsis" },
        itemHoverStyle: { color: "#000000" }, itemHiddenStyle: { color: "#cccccc" }, shadow: !1, itemCheckboxStyle: { position: "absolute", width: "13px", height: "13px" }, squareSymbol: !0, symbolPadding: 5, verticalAlign: "bottom", x: 0, y: 0, title: { style: { fontWeight: "bold" } } }, loading: { labelStyle: { fontWeight: "bold", position: "relative", top: "45%" }, style: { position: "absolute", backgroundColor: "#ffffff", opacity: .5, textAlign: "center" } }, tooltip: { enabled: !0, animation: a.svg, borderRadius: 3, dateTimeLabelFormats: { millisecond: "%A, %b %e, %H:%M:%S.%L",
          second: "%A, %b %e, %H:%M:%S", minute: "%A, %b %e, %H:%M", hour: "%A, %b %e, %H:%M", day: "%A, %b %e, %Y", week: "Week from %A, %b %e, %Y", month: "%B %Y", year: "%Y" }, footerFormat: "", padding: 8, snap: a.isTouchDevice ? 25 : 10, backgroundColor: H("#f7f7f7").setOpacity(.85).get(), borderWidth: 1, headerFormat: '\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e', pointFormat: "<span style=\"color:{point.color}\">\u25CF</span> {series.name}: <b>{point.y}</b><br/>", shadow: !0,
        style: { color: "#333333", cursor: "default", fontSize: "12px", pointerEvents: "none", whiteSpace: "nowrap" } }, credits: { enabled: !0, href: "http://www.highcharts.com", position: { align: "right", x: -10, verticalAlign: "bottom", y: -5 }, style: { cursor: "pointer", color: "#999999", fontSize: "9px" }, text: "Highcharts.com" } };a.setOptions = function (n) {
      a.defaultOptions = f(!0, a.defaultOptions, n);D();return a.defaultOptions;
    };a.getOptions = function () {
      return a.defaultOptions;
    };a.defaultPlotOptions = a.defaultOptions.plotOptions;D();
  })(M);(function (a) {
    var E = a.correctFloat,
        D = a.defined,
        H = a.destroyObjectProperties,
        p = a.isNumber,
        f = a.merge,
        l = a.pick,
        r = a.deg2rad;a.Tick = function (a, l, f, e) {
      this.axis = a;this.pos = l;this.type = f || "";this.isNewLabel = this.isNew = !0;f || e || this.addLabel();
    };a.Tick.prototype = { addLabel: function addLabel() {
        var a = this.axis,
            w = a.options,
            u = a.chart,
            e = a.categories,
            h = a.names,
            m = this.pos,
            d = w.labels,
            c = a.tickPositions,
            b = m === c[0],
            k = m === c[c.length - 1],
            h = e ? l(e[m], h[m], m) : m,
            e = this.label,
            c = c.info,
            z;a.isDatetimeAxis && c && (z = w.dateTimeLabelFormats[c.higherRanks[m] || c.unitName]);
        this.isFirst = b;this.isLast = k;w = a.labelFormatter.call({ axis: a, chart: u, isFirst: b, isLast: k, dateTimeLabelFormat: z, value: a.isLog ? E(a.lin2log(h)) : h, pos: m });D(e) ? e && e.attr({ text: w }) : (this.labelLength = (this.label = e = D(w) && d.enabled ? u.renderer.text(w, 0, 0, d.useHTML).css(f(d.style)).add(a.labelGroup) : null) && e.getBBox().width, this.rotation = 0);
      }, getLabelSize: function getLabelSize() {
        return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
      }, handleOverflow: function handleOverflow(a) {
        var f = this.axis,
            n = f.options.labels,
            e = a.x,
            h = f.chart.chartWidth,
            m = f.chart.spacing,
            d = l(f.labelLeft, Math.min(f.pos, m[3])),
            m = l(f.labelRight, Math.max(f.isRadial ? 0 : f.pos + f.len, h - m[1])),
            c = this.label,
            b = this.rotation,
            k = { left: 0, center: .5, right: 1 }[f.labelAlign || c.attr("align")],
            z = c.getBBox().width,
            B = f.getSlotWidth(),
            I = B,
            x = 1,
            p,
            t = {};if (b || !1 === n.overflow) 0 > b && e - k * z < d ? p = Math.round(e / Math.cos(b * r) - d) : 0 < b && e + k * z > m && (p = Math.round((h - e) / Math.cos(b * r)));else if (h = e + (1 - k) * z, e - k * z < d ? I = a.x + I * (1 - k) - d : h > m && (I = m - a.x + I * k, x = -1), I = Math.min(B, I), I < B && "center" === f.labelAlign && (a.x += x * (B - I - k * (B - Math.min(z, I)))), z > I || f.autoRotation && (c.styles || {}).width) p = I;p && (t.width = p, (n.style || {}).textOverflow || (t.textOverflow = "ellipsis"), c.css(t));
      }, getPosition: function getPosition(a, f, l, e) {
        var h = this.axis,
            m = h.chart,
            d = e && m.oldChartHeight || m.chartHeight;return { x: a ? h.translate(f + l, null, null, e) + h.transB : h.left + h.offset + (h.opposite ? (e && m.oldChartWidth || m.chartWidth) - h.right - h.left : 0), y: a ? d - h.bottom + h.offset - (h.opposite ? h.height : 0) : d - h.translate(f + l, null, null, e) - h.transB };
      }, getLabelPosition: function getLabelPosition(a, f, l, e, h, m, d, c) {
        var b = this.axis,
            k = b.transA,
            z = b.reversed,
            B = b.staggerLines,
            n = b.tickRotCorr || { x: 0, y: 0 },
            x = h.y,
            u = e || b.reserveSpaceDefault ? 0 : -b.labelOffset * ("center" === b.labelAlign ? .5 : 1);D(x) || (x = 0 === b.side ? l.rotation ? -8 : -l.getBBox().height : 2 === b.side ? n.y + 8 : Math.cos(l.rotation * r) * (n.y - l.getBBox(!1, 0).height / 2));a = a + h.x + u + n.x - (m && e ? m * k * (z ? -1 : 1) : 0);f = f + x - (m && !e ? m * k * (z ? 1 : -1) : 0);B && (l = d / (c || 1) % B, b.opposite && (l = B - l - 1), f += b.labelOffset / B * l);return { x: a, y: Math.round(f) };
      }, getMarkPath: function getMarkPath(a, f, l, e, h, m) {
        return m.crispLine(["M", a, f, "L", a + (h ? 0 : -l), f + (h ? l : 0)], e);
      }, renderGridLine: function renderGridLine(a, f, l) {
        var e = this.axis,
            h = e.options,
            m = this.gridLine,
            d = {},
            c = this.pos,
            b = this.type,
            k = e.tickmarkOffset,
            z = e.chart.renderer,
            B = b ? b + "Grid" : "grid",
            n = h[B + "LineWidth"],
            x = h[B + "LineColor"],
            h = h[B + "LineDashStyle"];m || (d.stroke = x, d["stroke-width"] = n, h && (d.dashstyle = h), b || (d.zIndex = 1), a && (d.opacity = 0), this.gridLine = m = z.path().attr(d).addClass("highcharts-" + (b ? b + "-" : "") + "grid-line").add(e.gridGroup));if (!a && m && (a = e.getPlotLinePath(c + k, m.strokeWidth() * l, a, !0))) m[this.isNew ? "attr" : "animate"]({ d: a, opacity: f });
      }, renderMark: function renderMark(a, f, u) {
        var e = this.axis,
            h = e.options,
            m = e.chart.renderer,
            d = this.type,
            c = d ? d + "Tick" : "tick",
            b = e.tickSize(c),
            k = this.mark,
            z = !k,
            B = a.x;a = a.y;var n = l(h[c + "Width"], !d && e.isXAxis ? 1 : 0),
            h = h[c + "Color"];b && (e.opposite && (b[0] = -b[0]), z && (this.mark = k = m.path().addClass("highcharts-" + (d ? d + "-" : "") + "tick").add(e.axisGroup), k.attr({ stroke: h, "stroke-width": n })), k[z ? "attr" : "animate"]({ d: this.getMarkPath(B, a, b[0], k.strokeWidth() * u, e.horiz, m), opacity: f }));
      }, renderLabel: function renderLabel(a, f, u, e) {
        var h = this.axis,
            m = h.horiz,
            d = h.options,
            c = this.label,
            b = d.labels,
            k = b.step,
            h = h.tickmarkOffset,
            z = !0,
            B = a.x;a = a.y;c && p(B) && (c.xy = a = this.getLabelPosition(B, a, c, m, b, h, e, k), this.isFirst && !this.isLast && !l(d.showFirstLabel, 1) || this.isLast && !this.isFirst && !l(d.showLastLabel, 1) ? z = !1 : !m || b.step || b.rotation || f || 0 === u || this.handleOverflow(a), k && e % k && (z = !1), z && p(a.y) ? (a.opacity = u, c[this.isNewLabel ? "attr" : "animate"](a), this.isNewLabel = !1) : (c.attr("y", -9999), this.isNewLabel = !0));
      }, render: function render(a, f, u) {
        var e = this.axis,
            h = e.horiz,
            m = this.getPosition(h, this.pos, e.tickmarkOffset, f),
            d = m.x,
            c = m.y,
            e = h && d === e.pos + e.len || !h && c === e.pos ? -1 : 1;u = l(u, 1);this.isActive = !0;this.renderGridLine(f, u, e);this.renderMark(m, u, e);this.renderLabel(m, f, u, a);this.isNew = !1;
      }, destroy: function destroy() {
        H(this, this.axis);
      } };
  })(M);var V = function (a) {
    var E = a.addEvent,
        D = a.animObject,
        H = a.arrayMax,
        p = a.arrayMin,
        f = a.color,
        l = a.correctFloat,
        r = a.defaultOptions,
        n = a.defined,
        w = a.deg2rad,
        u = a.destroyObjectProperties,
        e = a.each,
        h = a.extend,
        m = a.fireEvent,
        d = a.format,
        c = a.getMagnitude,
        b = a.grep,
        k = a.inArray,
        z = a.isArray,
        B = a.isNumber,
        I = a.isString,
        x = a.merge,
        K = a.normalizeTickInterval,
        t = a.objectEach,
        C = a.pick,
        N = a.removeEvent,
        q = a.splat,
        A = a.syncTimeout,
        F = a.Tick,
        G = function G() {
      this.init.apply(this, arguments);
    };a.extend(G.prototype, { defaultOptions: { dateTimeLabelFormats: { millisecond: "%H:%M:%S.%L", second: "%H:%M:%S", minute: "%H:%M", hour: "%H:%M", day: "%e. %b", week: "%e. %b", month: "%b '%y", year: "%Y" }, endOnTick: !1, labels: { enabled: !0, style: { color: "#666666", cursor: "default", fontSize: "11px" },
          x: 0 }, maxPadding: .01, minorTickLength: 2, minorTickPosition: "outside", minPadding: .01, startOfWeek: 1, startOnTick: !1, tickLength: 10, tickmarkPlacement: "between", tickPixelInterval: 100, tickPosition: "outside", title: { align: "middle", style: { color: "#666666" } }, type: "linear", minorGridLineColor: "#f2f2f2", minorGridLineWidth: 1, minorTickColor: "#999999", lineColor: "#ccd6eb", lineWidth: 1, gridLineColor: "#e6e6e6", tickColor: "#ccd6eb" }, defaultYAxisOptions: { endOnTick: !0, tickPixelInterval: 72, showLastLabel: !0, labels: { x: -8 }, maxPadding: .05,
        minPadding: .05, startOnTick: !0, title: { rotation: 270, text: "Values" }, stackLabels: { allowOverlap: !1, enabled: !1, formatter: function formatter() {
            return a.numberFormat(this.total, -1);
          }, style: { fontSize: "11px", fontWeight: "bold", color: "#000000", textOutline: "1px contrast" } }, gridLineWidth: 1, lineWidth: 0 }, defaultLeftAxisOptions: { labels: { x: -15 }, title: { rotation: 270 } }, defaultRightAxisOptions: { labels: { x: 15 }, title: { rotation: 90 } }, defaultBottomAxisOptions: { labels: { autoRotation: [-45], x: 0 }, title: { rotation: 0 } }, defaultTopAxisOptions: { labels: { autoRotation: [-45],
          x: 0 }, title: { rotation: 0 } }, init: function init(a, b) {
        var g = b.isX,
            v = this;v.chart = a;v.horiz = a.inverted && !v.isZAxis ? !g : g;v.isXAxis = g;v.coll = v.coll || (g ? "xAxis" : "yAxis");v.opposite = b.opposite;v.side = b.side || (v.horiz ? v.opposite ? 0 : 2 : v.opposite ? 1 : 3);v.setOptions(b);var c = this.options,
            d = c.type;v.labelFormatter = c.labels.formatter || v.defaultLabelFormatter;v.userOptions = b;v.minPixelPadding = 0;v.reversed = c.reversed;v.visible = !1 !== c.visible;v.zoomEnabled = !1 !== c.zoomEnabled;v.hasNames = "category" === d || !0 === c.categories;v.categories = c.categories || v.hasNames;v.names = v.names || [];v.plotLinesAndBandsGroups = {};v.isLog = "logarithmic" === d;v.isDatetimeAxis = "datetime" === d;v.positiveValuesOnly = v.isLog && !v.allowNegativeLog;v.isLinked = n(c.linkedTo);v.ticks = {};v.labelEdge = [];v.minorTicks = {};v.plotLinesAndBands = [];v.alternateBands = {};v.len = 0;v.minRange = v.userMinRange = c.minRange || c.maxZoom;v.range = c.range;v.offset = c.offset || 0;v.stacks = {};v.oldStacks = {};v.stacksTouched = 0;v.max = null;v.min = null;v.crosshair = C(c.crosshair, q(a.options.tooltip.crosshairs)[g ? 0 : 1], !1);b = v.options.events;-1 === k(v, a.axes) && (g ? a.axes.splice(a.xAxis.length, 0, v) : a.axes.push(v), a[v.coll].push(v));v.series = v.series || [];a.inverted && !v.isZAxis && g && void 0 === v.reversed && (v.reversed = !0);t(b, function (a, g) {
          E(v, g, a);
        });v.lin2log = c.linearToLogConverter || v.lin2log;v.isLog && (v.val2lin = v.log2lin, v.lin2val = v.lin2log);
      }, setOptions: function setOptions(a) {
        this.options = x(this.defaultOptions, "yAxis" === this.coll && this.defaultYAxisOptions, [this.defaultTopAxisOptions, this.defaultRightAxisOptions, this.defaultBottomAxisOptions, this.defaultLeftAxisOptions][this.side], x(r[this.coll], a));
      }, defaultLabelFormatter: function defaultLabelFormatter() {
        var g = this.axis,
            b = this.value,
            c = g.categories,
            k = this.dateTimeLabelFormat,
            e = r.lang,
            q = e.numericSymbols,
            e = e.numericSymbolMagnitude || 1E3,
            h = q && q.length,
            m,
            z = g.options.labels.format,
            g = g.isLog ? Math.abs(b) : g.tickInterval;if (z) m = d(z, this);else if (c) m = b;else if (k) m = a.dateFormat(k, b);else if (h && 1E3 <= g) for (; h-- && void 0 === m;) {
          c = Math.pow(e, h + 1), g >= c && 0 === 10 * b % c && null !== q[h] && 0 !== b && (m = a.numberFormat(b / c, -1) + q[h]);
        }void 0 === m && (m = 1E4 <= Math.abs(b) ? a.numberFormat(b, -1) : a.numberFormat(b, -1, void 0, ""));return m;
      }, getSeriesExtremes: function getSeriesExtremes() {
        var a = this,
            v = a.chart;a.hasVisibleSeries = !1;a.dataMin = a.dataMax = a.threshold = null;a.softThreshold = !a.isXAxis;a.buildStacks && a.buildStacks();e(a.series, function (g) {
          if (g.visible || !v.options.chart.ignoreHiddenSeries) {
            var c = g.options,
                d = c.threshold,
                k;a.hasVisibleSeries = !0;a.positiveValuesOnly && 0 >= d && (d = null);if (a.isXAxis) c = g.xData, c.length && (g = p(c), k = H(c), B(g) || g instanceof Date || (c = b(c, B), g = p(c)), a.dataMin = Math.min(C(a.dataMin, c[0], g), g), a.dataMax = Math.max(C(a.dataMax, c[0], k), k));else if (g.getExtremes(), k = g.dataMax, g = g.dataMin, n(g) && n(k) && (a.dataMin = Math.min(C(a.dataMin, g), g), a.dataMax = Math.max(C(a.dataMax, k), k)), n(d) && (a.threshold = d), !c.softThreshold || a.positiveValuesOnly) a.softThreshold = !1;
          }
        });
      }, translate: function translate(a, b, c, d, k, e) {
        var g = this.linkedParent || this,
            v = 1,
            q = 0,
            h = d ? g.oldTransA : g.transA;d = d ? g.oldMin : g.min;var m = g.minPixelPadding;k = (g.isOrdinal || g.isBroken || g.isLog && k) && g.lin2val;
        h || (h = g.transA);c && (v *= -1, q = g.len);g.reversed && (v *= -1, q -= v * (g.sector || g.len));b ? (a = (a * v + q - m) / h + d, k && (a = g.lin2val(a))) : (k && (a = g.val2lin(a)), a = B(d) ? v * (a - d) * h + q + v * m + (B(e) ? h * e : 0) : void 0);return a;
      }, toPixels: function toPixels(a, b) {
        return this.translate(a, !1, !this.horiz, null, !0) + (b ? 0 : this.pos);
      }, toValue: function toValue(a, b) {
        return this.translate(a - (b ? 0 : this.pos), !0, !this.horiz, null, !0);
      }, getPlotLinePath: function getPlotLinePath(a, b, c, d, k) {
        var g = this.chart,
            v = this.left,
            q = this.top,
            e,
            h,
            m = c && g.oldChartHeight || g.chartHeight,
            z = c && g.oldChartWidth || g.chartWidth,
            A;e = this.transB;var t = function t(a, g, b) {
          if (a < g || a > b) d ? a = Math.min(Math.max(g, a), b) : A = !0;return a;
        };k = C(k, this.translate(a, null, null, c));a = c = Math.round(k + e);e = h = Math.round(m - k - e);B(k) ? this.horiz ? (e = q, h = m - this.bottom, a = c = t(a, v, v + this.width)) : (a = v, c = z - this.right, e = h = t(e, q, q + this.height)) : (A = !0, d = !1);return A && !d ? null : g.renderer.crispLine(["M", a, e, "L", c, h], b || 1);
      }, getLinearTickPositions: function getLinearTickPositions(a, b, c) {
        var g,
            v = l(Math.floor(b / a) * a);c = l(Math.ceil(c / a) * a);var d = [],
            k;l(v + a) === v && (k = 20);if (this.single) return [b];
        for (b = v; b <= c;) {
          d.push(b);b = l(b + a, k);if (b === g) break;g = b;
        }return d;
      }, getMinorTickInterval: function getMinorTickInterval() {
        var a = this.options;return !0 === a.minorTicks ? C(a.minorTickInterval, "auto") : !1 === a.minorTicks ? null : a.minorTickInterval;
      }, getMinorTickPositions: function getMinorTickPositions() {
        var a = this,
            b = a.options,
            c = a.tickPositions,
            d = a.minorTickInterval,
            k = [],
            q = a.pointRangePadding || 0,
            h = a.min - q,
            q = a.max + q,
            m = q - h;if (m && m / d < a.len / 3) if (a.isLog) e(this.paddedTicks, function (g, b, v) {
          b && k.push.apply(k, a.getLogTickPositions(d, v[b - 1], v[b], !0));
        });else if (a.isDatetimeAxis && "auto" === this.getMinorTickInterval()) k = k.concat(a.getTimeTicks(a.normalizeTimeTickInterval(d), h, q, b.startOfWeek));else for (b = h + (c[0] - h) % d; b <= q && b !== k[0]; b += d) {
          k.push(b);
        }0 !== k.length && a.trimTicks(k);return k;
      }, adjustForMinRange: function adjustForMinRange() {
        var a = this.options,
            b = this.min,
            c = this.max,
            d,
            k,
            q,
            h,
            m,
            z,
            A,
            t;this.isXAxis && void 0 === this.minRange && !this.isLog && (n(a.min) || n(a.max) ? this.minRange = null : (e(this.series, function (a) {
          z = a.xData;for (h = A = a.xIncrement ? 1 : z.length - 1; 0 < h; h--) {
            if (m = z[h] - z[h - 1], void 0 === q || m < q) q = m;
          }
        }), this.minRange = Math.min(5 * q, this.dataMax - this.dataMin)));c - b < this.minRange && (k = this.dataMax - this.dataMin >= this.minRange, t = this.minRange, d = (t - c + b) / 2, d = [b - d, C(a.min, b - d)], k && (d[2] = this.isLog ? this.log2lin(this.dataMin) : this.dataMin), b = H(d), c = [b + t, C(a.max, b + t)], k && (c[2] = this.isLog ? this.log2lin(this.dataMax) : this.dataMax), c = p(c), c - b < t && (d[0] = c - t, d[1] = C(a.min, c - t), b = H(d)));this.min = b;this.max = c;
      }, getClosest: function getClosest() {
        var a;this.categories ? a = 1 : e(this.series, function (g) {
          var b = g.closestPointRange,
              v = g.visible || !g.chart.options.chart.ignoreHiddenSeries;!g.noSharedTooltip && n(b) && v && (a = n(a) ? Math.min(a, b) : b);
        });return a;
      }, nameToX: function nameToX(a) {
        var g = z(this.categories),
            b = g ? this.categories : this.names,
            c = a.options.x,
            d;a.series.requireSorting = !1;n(c) || (c = !1 === this.options.uniqueNames ? a.series.autoIncrement() : k(a.name, b));-1 === c ? g || (d = b.length) : d = c;void 0 !== d && (this.names[d] = a.name);return d;
      }, updateNames: function updateNames() {
        var a = this;0 < this.names.length && (this.names.length = 0, this.minRange = this.userMinRange, e(this.series || [], function (g) {
          g.xIncrement = null;if (!g.points || g.isDirtyData) g.processData(), g.generatePoints();e(g.points, function (b, v) {
            var c;b.options && (c = a.nameToX(b), void 0 !== c && c !== b.x && (b.x = c, g.xData[v] = c));
          });
        }));
      }, setAxisTranslation: function setAxisTranslation(a) {
        var g = this,
            b = g.max - g.min,
            c = g.axisPointRange || 0,
            d,
            k = 0,
            q = 0,
            h = g.linkedParent,
            m = !!g.categories,
            z = g.transA,
            A = g.isXAxis;if (A || m || c) d = g.getClosest(), h ? (k = h.minPointOffset, q = h.pointRangePadding) : e(g.series, function (a) {
          var b = m ? 1 : A ? C(a.options.pointRange, d, 0) : g.axisPointRange || 0;
          a = a.options.pointPlacement;c = Math.max(c, b);g.single || (k = Math.max(k, I(a) ? 0 : b / 2), q = Math.max(q, "on" === a ? 0 : b));
        }), h = g.ordinalSlope && d ? g.ordinalSlope / d : 1, g.minPointOffset = k *= h, g.pointRangePadding = q *= h, g.pointRange = Math.min(c, b), A && (g.closestPointRange = d);a && (g.oldTransA = z);g.translationSlope = g.transA = z = g.options.staticScale || g.len / (b + q || 1);g.transB = g.horiz ? g.left : g.bottom;g.minPixelPadding = z * k;
      }, minFromRange: function minFromRange() {
        return this.max - this.range;
      }, setTickInterval: function setTickInterval(g) {
        var b = this,
            d = b.chart,
            k = b.options,
            q = b.isLog,
            h = b.log2lin,
            z = b.isDatetimeAxis,
            A = b.isXAxis,
            t = b.isLinked,
            x = k.maxPadding,
            f = k.minPadding,
            F = k.tickInterval,
            u = k.tickPixelInterval,
            G = b.categories,
            p = b.threshold,
            I = b.softThreshold,
            r,
            w,
            N,
            D;z || G || t || this.getTickAmount();N = C(b.userMin, k.min);D = C(b.userMax, k.max);t ? (b.linkedParent = d[b.coll][k.linkedTo], d = b.linkedParent.getExtremes(), b.min = C(d.min, d.dataMin), b.max = C(d.max, d.dataMax), k.type !== b.linkedParent.options.type && a.error(11, 1)) : (!I && n(p) && (b.dataMin >= p ? (r = p, f = 0) : b.dataMax <= p && (w = p, x = 0)), b.min = C(N, r, b.dataMin), b.max = C(D, w, b.dataMax));q && (b.positiveValuesOnly && !g && 0 >= Math.min(b.min, C(b.dataMin, b.min)) && a.error(10, 1), b.min = l(h(b.min), 15), b.max = l(h(b.max), 15));b.range && n(b.max) && (b.userMin = b.min = N = Math.max(b.dataMin, b.minFromRange()), b.userMax = D = b.max, b.range = null);m(b, "foundExtremes");b.beforePadding && b.beforePadding();b.adjustForMinRange();!(G || b.axisPointRange || b.usePercentage || t) && n(b.min) && n(b.max) && (h = b.max - b.min) && (!n(N) && f && (b.min -= h * f), !n(D) && x && (b.max += h * x));B(k.softMin) && !B(b.userMin) && (b.min = Math.min(b.min, k.softMin));B(k.softMax) && !B(b.userMax) && (b.max = Math.max(b.max, k.softMax));B(k.floor) && (b.min = Math.max(b.min, k.floor));B(k.ceiling) && (b.max = Math.min(b.max, k.ceiling));I && n(b.dataMin) && (p = p || 0, !n(N) && b.min < p && b.dataMin >= p ? b.min = p : !n(D) && b.max > p && b.dataMax <= p && (b.max = p));b.tickInterval = b.min === b.max || void 0 === b.min || void 0 === b.max ? 1 : t && !F && u === b.linkedParent.options.tickPixelInterval ? F = b.linkedParent.tickInterval : C(F, this.tickAmount ? (b.max - b.min) / Math.max(this.tickAmount - 1, 1) : void 0, G ? 1 : (b.max - b.min) * u / Math.max(b.len, u));A && !g && e(b.series, function (a) {
          a.processData(b.min !== b.oldMin || b.max !== b.oldMax);
        });b.setAxisTranslation(!0);b.beforeSetTickPositions && b.beforeSetTickPositions();b.postProcessTickInterval && (b.tickInterval = b.postProcessTickInterval(b.tickInterval));b.pointRange && !F && (b.tickInterval = Math.max(b.pointRange, b.tickInterval));g = C(k.minTickInterval, b.isDatetimeAxis && b.closestPointRange);!F && b.tickInterval < g && (b.tickInterval = g);z || q || F || (b.tickInterval = K(b.tickInterval, null, c(b.tickInterval), C(k.allowDecimals, !(.5 < b.tickInterval && 5 > b.tickInterval && 1E3 < b.max && 9999 > b.max)), !!this.tickAmount));this.tickAmount || (b.tickInterval = b.unsquish());this.setTickPositions();
      }, setTickPositions: function setTickPositions() {
        var a = this.options,
            b,
            c = a.tickPositions;b = this.getMinorTickInterval();var d = a.tickPositioner,
            k = a.startOnTick,
            q = a.endOnTick;this.tickmarkOffset = this.categories && "between" === a.tickmarkPlacement && 1 === this.tickInterval ? .5 : 0;this.minorTickInterval = "auto" === b && this.tickInterval ? this.tickInterval / 5 : b;this.single = this.min === this.max && n(this.min) && !this.tickAmount && (parseInt(this.min, 10) === this.min || !1 !== a.allowDecimals);this.tickPositions = b = c && c.slice();!b && (b = this.isDatetimeAxis ? this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval, a.units), this.min, this.max, a.startOfWeek, this.ordinalPositions, this.closestPointRange, !0) : this.isLog ? this.getLogTickPositions(this.tickInterval, this.min, this.max) : this.getLinearTickPositions(this.tickInterval, this.min, this.max), b.length > this.len && (b = [b[0], b.pop()], b[0] === b[1] && (b.length = 1)), this.tickPositions = b, d && (d = d.apply(this, [this.min, this.max]))) && (this.tickPositions = b = d);this.paddedTicks = b.slice(0);this.trimTicks(b, k, q);this.isLinked || (this.single && 2 > b.length && (this.min -= .5, this.max += .5), c || d || this.adjustTickAmount());
      }, trimTicks: function trimTicks(a, b, c) {
        var g = a[0],
            d = a[a.length - 1],
            k = this.minPointOffset || 0;if (!this.isLinked) {
          if (b && -Infinity !== g) this.min = g;else for (; this.min - k > a[0];) {
            a.shift();
          }if (c) this.max = d;else for (; this.max + k < a[a.length - 1];) {
            a.pop();
          }0 === a.length && n(g) && !this.options.tickPositions && a.push((d + g) / 2);
        }
      }, alignToOthers: function alignToOthers() {
        var a = {},
            b,
            c = this.options;!1 === this.chart.options.chart.alignTicks || !1 === c.alignTicks || this.isLog || e(this.chart[this.coll], function (g) {
          var c = g.options,
              c = [g.horiz ? c.left : c.top, c.width, c.height, c.pane].join();g.series.length && (a[c] ? b = !0 : a[c] = 1);
        });return b;
      }, getTickAmount: function getTickAmount() {
        var a = this.options,
            b = a.tickAmount,
            c = a.tickPixelInterval;!n(a.tickInterval) && this.len < c && !this.isRadial && !this.isLog && a.startOnTick && a.endOnTick && (b = 2);!b && this.alignToOthers() && (b = Math.ceil(this.len / c) + 1);4 > b && (this.finalTickAmt = b, b = 5);this.tickAmount = b;
      }, adjustTickAmount: function adjustTickAmount() {
        var a = this.tickInterval,
            b = this.tickPositions,
            c = this.tickAmount,
            d = this.finalTickAmt,
            k = b && b.length,
            q = C(this.threshold, this.softThreshold ? 0 : null);if (this.hasData()) {
          if (k < c) {
            for (; b.length < c;) {
              b.length % 2 || this.min === q ? b.push(l(b[b.length - 1] + a)) : b.unshift(l(b[0] - a));
            }this.transA *= (k - 1) / (c - 1);this.min = b[0];this.max = b[b.length - 1];
          } else k > c && (this.tickInterval *= 2, this.setTickPositions());if (n(d)) {
            for (a = c = b.length; a--;) {
              (3 === d && 1 === a % 2 || 2 >= d && 0 < a && a < c - 1) && b.splice(a, 1);
            }this.finalTickAmt = void 0;
          }
        }
      }, setScale: function setScale() {
        var a, b;this.oldMin = this.min;this.oldMax = this.max;this.oldAxisLength = this.len;this.setAxisSize();b = this.len !== this.oldAxisLength;e(this.series, function (b) {
          if (b.isDirtyData || b.isDirty || b.xAxis.isDirty) a = !0;
        });b || a || this.isLinked || this.forceRedraw || this.userMin !== this.oldUserMin || this.userMax !== this.oldUserMax || this.alignToOthers() ? (this.resetStacks && this.resetStacks(), this.forceRedraw = !1, this.getSeriesExtremes(), this.setTickInterval(), this.oldUserMin = this.userMin, this.oldUserMax = this.userMax, this.isDirty || (this.isDirty = b || this.min !== this.oldMin || this.max !== this.oldMax)) : this.cleanStacks && this.cleanStacks();
      }, setExtremes: function setExtremes(a, b, c, d, k) {
        var g = this,
            q = g.chart;c = C(c, !0);e(g.series, function (a) {
          delete a.kdTree;
        });k = h(k, { min: a, max: b });m(g, "setExtremes", k, function () {
          g.userMin = a;g.userMax = b;g.eventArgs = k;c && q.redraw(d);
        });
      }, zoom: function zoom(a, b) {
        var g = this.dataMin,
            c = this.dataMax,
            d = this.options,
            k = Math.min(g, C(d.min, g)),
            d = Math.max(c, C(d.max, c));if (a !== this.min || b !== this.max) this.allowZoomOutside || (n(g) && (a < k && (a = k), a > d && (a = d)), n(c) && (b < k && (b = k), b > d && (b = d))), this.displayBtn = void 0 !== a || void 0 !== b, this.setExtremes(a, b, !1, void 0, { trigger: "zoom" });return !0;
      }, setAxisSize: function setAxisSize() {
        var b = this.chart,
            c = this.options,
            d = c.offsets || [0, 0, 0, 0],
            k = this.horiz,
            q = this.width = Math.round(a.relativeLength(C(c.width, b.plotWidth - d[3] + d[1]), b.plotWidth)),
            e = this.height = Math.round(a.relativeLength(C(c.height, b.plotHeight - d[0] + d[2]), b.plotHeight)),
            h = this.top = Math.round(a.relativeLength(C(c.top, b.plotTop + d[0]), b.plotHeight, b.plotTop)),
            c = this.left = Math.round(a.relativeLength(C(c.left, b.plotLeft + d[3]), b.plotWidth, b.plotLeft));this.bottom = b.chartHeight - e - h;this.right = b.chartWidth - q - c;this.len = Math.max(k ? q : e, 0);this.pos = k ? c : h;
      }, getExtremes: function getExtremes() {
        var a = this.isLog,
            b = this.lin2log;return { min: a ? l(b(this.min)) : this.min, max: a ? l(b(this.max)) : this.max, dataMin: this.dataMin, dataMax: this.dataMax, userMin: this.userMin,
          userMax: this.userMax };
      }, getThreshold: function getThreshold(a) {
        var b = this.isLog,
            g = this.lin2log,
            c = b ? g(this.min) : this.min,
            b = b ? g(this.max) : this.max;null === a ? a = c : c > a ? a = c : b < a && (a = b);return this.translate(a, 0, 1, 0, 1);
      }, autoLabelAlign: function autoLabelAlign(a) {
        a = (C(a, 0) - 90 * this.side + 720) % 360;return 15 < a && 165 > a ? "right" : 195 < a && 345 > a ? "left" : "center";
      }, tickSize: function tickSize(a) {
        var b = this.options,
            g = b[a + "Length"],
            c = C(b[a + "Width"], "tick" === a && this.isXAxis ? 1 : 0);if (c && g) return "inside" === b[a + "Position"] && (g = -g), [g, c];
      }, labelMetrics: function labelMetrics() {
        var a = this.tickPositions && this.tickPositions[0] || 0;return this.chart.renderer.fontMetrics(this.options.labels.style && this.options.labels.style.fontSize, this.ticks[a] && this.ticks[a].label);
      }, unsquish: function unsquish() {
        var a = this.options.labels,
            b = this.horiz,
            c = this.tickInterval,
            d = c,
            k = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / c),
            q,
            h = a.rotation,
            m = this.labelMetrics(),
            z,
            A = Number.MAX_VALUE,
            t,
            x = function x(a) {
          a /= k || 1;a = 1 < a ? Math.ceil(a) : 1;return a * c;
        };b ? (t = !a.staggerLines && !a.step && (n(h) ? [h] : k < C(a.autoRotationLimit, 80) && a.autoRotation)) && e(t, function (a) {
          var b;if (a === h || a && -90 <= a && 90 >= a) z = x(Math.abs(m.h / Math.sin(w * a))), b = z + Math.abs(a / 360), b < A && (A = b, q = a, d = z);
        }) : a.step || (d = x(m.h));this.autoRotation = t;this.labelRotation = C(q, h);return d;
      }, getSlotWidth: function getSlotWidth() {
        var a = this.chart,
            b = this.horiz,
            c = this.options.labels,
            d = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1),
            k = a.margin[3];return b && 2 > (c.step || 0) && !c.rotation && (this.staggerLines || 1) * this.len / d || !b && (c.style && parseInt(c.style.width, 10) || k && k - a.spacing[3] || .33 * a.chartWidth);
      }, renderUnsquish: function renderUnsquish() {
        var a = this.chart,
            b = a.renderer,
            c = this.tickPositions,
            d = this.ticks,
            k = this.options.labels,
            q = this.horiz,
            h = this.getSlotWidth(),
            m = Math.max(1, Math.round(h - 2 * (k.padding || 5))),
            z = {},
            A = this.labelMetrics(),
            t = k.style && k.style.textOverflow,
            f,
            F = 0,
            l,
            B;I(k.rotation) || (z.rotation = k.rotation || 0);e(c, function (a) {
          (a = d[a]) && a.labelLength > F && (F = a.labelLength);
        });this.maxLabelLength = F;if (this.autoRotation) F > m && F > A.h ? z.rotation = this.labelRotation : this.labelRotation = 0;else if (h && (f = { width: m + "px" }, !t)) for (f.textOverflow = "clip", l = c.length; !q && l--;) {
          if (B = c[l], m = d[B].label) m.styles && "ellipsis" === m.styles.textOverflow ? m.css({ textOverflow: "clip" }) : d[B].labelLength > h && m.css({ width: h + "px" }), m.getBBox().height > this.len / c.length - (A.h - A.f) && (m.specCss = { textOverflow: "ellipsis" });
        }z.rotation && (f = { width: (F > .5 * a.chartHeight ? .33 * a.chartHeight : a.chartHeight) + "px" }, t || (f.textOverflow = "ellipsis"));if (this.labelAlign = k.align || this.autoLabelAlign(this.labelRotation)) z.align = this.labelAlign;e(c, function (a) {
          var b = (a = d[a]) && a.label;b && (b.attr(z), f && b.css(x(f, b.specCss)), delete b.specCss, a.rotation = z.rotation);
        });this.tickRotCorr = b.rotCorr(A.b, this.labelRotation || 0, 0 !== this.side);
      }, hasData: function hasData() {
        return this.hasVisibleSeries || n(this.min) && n(this.max) && this.tickPositions && 0 < this.tickPositions.length;
      }, addTitle: function addTitle(a) {
        var b = this.chart.renderer,
            g = this.horiz,
            c = this.opposite,
            d = this.options.title,
            k;this.axisTitle || ((k = d.textAlign) || (k = (g ? { low: "left", middle: "center", high: "right" } : { low: c ? "right" : "left", middle: "center", high: c ? "left" : "right" })[d.align]), this.axisTitle = b.text(d.text, 0, 0, d.useHTML).attr({ zIndex: 7, rotation: d.rotation || 0, align: k }).addClass("highcharts-axis-title").css(d.style).add(this.axisGroup), this.axisTitle.isNew = !0);d.style.width || this.isRadial || this.axisTitle.css({ width: this.len });this.axisTitle[a ? "show" : "hide"](!0);
      }, generateTick: function generateTick(a) {
        var b = this.ticks;b[a] ? b[a].addLabel() : b[a] = new F(this, a);
      }, getOffset: function getOffset() {
        var a = this,
            b = a.chart,
            c = b.renderer,
            d = a.options,
            k = a.tickPositions,
            q = a.ticks,
            h = a.horiz,
            m = a.side,
            z = b.inverted && !a.isZAxis ? [1, 0, 3, 2][m] : m,
            A,
            x,
            f = 0,
            F,
            l = 0,
            B = d.title,
            u = d.labels,
            G = 0,
            p = b.axisOffset,
            b = b.clipOffset,
            I = [-1, 1, 1, -1][m],
            r = d.className,
            w = a.axisParent,
            K = this.tickSize("tick");A = a.hasData();a.showAxis = x = A || C(d.showEmpty, !0);a.staggerLines = a.horiz && u.staggerLines;a.axisGroup || (a.gridGroup = c.g("grid").attr({ zIndex: d.gridZIndex || 1 }).addClass("highcharts-" + this.coll.toLowerCase() + "-grid " + (r || "")).add(w), a.axisGroup = c.g("axis").attr({ zIndex: d.zIndex || 2 }).addClass("highcharts-" + this.coll.toLowerCase() + " " + (r || "")).add(w), a.labelGroup = c.g("axis-labels").attr({ zIndex: u.zIndex || 7 }).addClass("highcharts-" + a.coll.toLowerCase() + "-labels " + (r || "")).add(w));A || a.isLinked ? (e(k, function (b, c) {
          a.generateTick(b, c);
        }), a.renderUnsquish(), a.reserveSpaceDefault = 0 === m || 2 === m || { 1: "left", 3: "right" }[m] === a.labelAlign, C(u.reserveSpace, "center" === a.labelAlign ? !0 : null, a.reserveSpaceDefault) && e(k, function (a) {
          G = Math.max(q[a].getLabelSize(), G);
        }), a.staggerLines && (G *= a.staggerLines), a.labelOffset = G * (a.opposite ? -1 : 1)) : t(q, function (a, b) {
          a.destroy();delete q[b];
        });B && B.text && !1 !== B.enabled && (a.addTitle(x), x && !1 !== B.reserveSpace && (a.titleOffset = f = a.axisTitle.getBBox()[h ? "height" : "width"], F = B.offset, l = n(F) ? 0 : C(B.margin, h ? 5 : 10)));a.renderLine();a.offset = I * C(d.offset, p[m]);a.tickRotCorr = a.tickRotCorr || { x: 0, y: 0 };c = 0 === m ? -a.labelMetrics().h : 2 === m ? a.tickRotCorr.y : 0;l = Math.abs(G) + l;G && (l = l - c + I * (h ? C(u.y, a.tickRotCorr.y + 8 * I) : u.x));a.axisTitleMargin = C(F, l);p[m] = Math.max(p[m], a.axisTitleMargin + f + I * a.offset, l, A && k.length && K ? K[0] + I * a.offset : 0);d = d.offset ? 0 : 2 * Math.floor(a.axisLine.strokeWidth() / 2);b[z] = Math.max(b[z], d);
      }, getLinePath: function getLinePath(a) {
        var b = this.chart,
            c = this.opposite,
            g = this.offset,
            d = this.horiz,
            k = this.left + (c ? this.width : 0) + g,
            g = b.chartHeight - this.bottom - (c ? this.height : 0) + g;c && (a *= -1);return b.renderer.crispLine(["M", d ? this.left : k, d ? g : this.top, "L", d ? b.chartWidth - this.right : k, d ? g : b.chartHeight - this.bottom], a);
      }, renderLine: function renderLine() {
        this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.axisLine.attr({ stroke: this.options.lineColor, "stroke-width": this.options.lineWidth, zIndex: 7 }));
      }, getTitlePosition: function getTitlePosition() {
        var a = this.horiz,
            b = this.left,
            c = this.top,
            d = this.len,
            k = this.options.title,
            q = a ? b : c,
            e = this.opposite,
            h = this.offset,
            m = k.x || 0,
            z = k.y || 0,
            A = this.axisTitle,
            t = this.chart.renderer.fontMetrics(k.style && k.style.fontSize, A),
            A = Math.max(A.getBBox(null, 0).height - t.h - 1, 0),
            d = { low: q + (a ? 0 : d), middle: q + d / 2, high: q + (a ? d : 0) }[k.align],
            b = (a ? c + this.height : b) + (a ? 1 : -1) * (e ? -1 : 1) * this.axisTitleMargin + [-A, A, t.f, -A][this.side];return { x: a ? d + m : b + (e ? this.width : 0) + h + m, y: a ? b + z - (e ? this.height : 0) + h : d + z };
      }, renderMinorTick: function renderMinorTick(a) {
        var b = this.chart.hasRendered && B(this.oldMin),
            c = this.minorTicks;c[a] || (c[a] = new F(this, a, "minor"));b && c[a].isNew && c[a].render(null, !0);c[a].render(null, !1, 1);
      }, renderTick: function renderTick(a, b) {
        var c = this.isLinked,
            g = this.ticks,
            d = this.chart.hasRendered && B(this.oldMin);if (!c || a >= this.min && a <= this.max) g[a] || (g[a] = new F(this, a)), d && g[a].isNew && g[a].render(b, !0, .1), g[a].render(b);
      }, render: function render() {
        var b = this,
            c = b.chart,
            d = b.options,
            k = b.isLog,
            q = b.lin2log,
            h = b.isLinked,
            m = b.tickPositions,
            z = b.axisTitle,
            x = b.ticks,
            f = b.minorTicks,
            l = b.alternateBands,
            C = d.stackLabels,
            n = d.alternateGridColor,
            u = b.tickmarkOffset,
            G = b.axisLine,
            p = b.showAxis,
            I = D(c.renderer.globalAnimation),
            r,
            w;b.labelEdge.length = 0;b.overlap = !1;e([x, f, l], function (a) {
          t(a, function (a) {
            a.isActive = !1;
          });
        });if (b.hasData() || h) b.minorTickInterval && !b.categories && e(b.getMinorTickPositions(), function (a) {
          b.renderMinorTick(a);
        }), m.length && (e(m, function (a, c) {
          b.renderTick(a, c);
        }), u && (0 === b.min || b.single) && (x[-1] || (x[-1] = new F(b, -1, null, !0)), x[-1].render(-1))), n && e(m, function (d, g) {
          w = void 0 !== m[g + 1] ? m[g + 1] + u : b.max - u;0 === g % 2 && d < b.max && w <= b.max + (c.polar ? -u : u) && (l[d] || (l[d] = new a.PlotLineOrBand(b)), r = d + u, l[d].options = { from: k ? q(r) : r, to: k ? q(w) : w, color: n }, l[d].render(), l[d].isActive = !0);
        }), b._addedPlotLB || (e((d.plotLines || []).concat(d.plotBands || []), function (a) {
          b.addPlotBandOrLine(a);
        }), b._addedPlotLB = !0);e([x, f, l], function (a) {
          var b,
              d = [],
              g = I.duration;t(a, function (a, b) {
            a.isActive || (a.render(b, !1, 0), a.isActive = !1, d.push(b));
          });A(function () {
            for (b = d.length; b--;) {
              a[d[b]] && !a[d[b]].isActive && (a[d[b]].destroy(), delete a[d[b]]);
            }
          }, a !== l && c.hasRendered && g ? g : 0);
        });G && (G[G.isPlaced ? "animate" : "attr"]({ d: this.getLinePath(G.strokeWidth()) }), G.isPlaced = !0, G[p ? "show" : "hide"](!0));z && p && (d = b.getTitlePosition(), B(d.y) ? (z[z.isNew ? "attr" : "animate"](d), z.isNew = !1) : (z.attr("y", -9999), z.isNew = !0));C && C.enabled && b.renderStackTotals();b.isDirty = !1;
      }, redraw: function redraw() {
        this.visible && (this.render(), e(this.plotLinesAndBands, function (a) {
          a.render();
        }));e(this.series, function (a) {
          a.isDirty = !0;
        });
      }, keepProps: "extKey hcEvents names series userMax userMin".split(" "), destroy: function destroy(a) {
        var b = this,
            c = b.stacks,
            d = b.plotLinesAndBands,
            g;a || N(b);t(c, function (a, b) {
          u(a);c[b] = null;
        });e([b.ticks, b.minorTicks, b.alternateBands], function (a) {
          u(a);
        });if (d) for (a = d.length; a--;) {
          d[a].destroy();
        }e("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross".split(" "), function (a) {
          b[a] && (b[a] = b[a].destroy());
        });for (g in b.plotLinesAndBandsGroups) {
          b.plotLinesAndBandsGroups[g] = b.plotLinesAndBandsGroups[g].destroy();
        }t(b, function (a, c) {
          -1 === k(c, b.keepProps) && delete b[c];
        });
      }, drawCrosshair: function drawCrosshair(a, b) {
        var c,
            d = this.crosshair,
            g = C(d.snap, !0),
            k,
            q = this.cross;a || (a = this.cross && this.cross.e);this.crosshair && !1 !== (n(b) || !g) ? (g ? n(b) && (k = this.isXAxis ? b.plotX : this.len - b.plotY) : k = a && (this.horiz ? a.chartX - this.pos : this.len - a.chartY + this.pos), n(k) && (c = this.getPlotLinePath(b && (this.isXAxis ? b.x : C(b.stackY, b.y)), null, null, null, k) || null), n(c) ? (b = this.categories && !this.isRadial, q || (this.cross = q = this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (b ? "category " : "thin ") + d.className).attr({ zIndex: C(d.zIndex, 2) }).add(), q.attr({ stroke: d.color || (b ? f("#ccd6eb").setOpacity(.25).get() : "#cccccc"), "stroke-width": C(d.width, 1) }).css({ "pointer-events": "none" }), d.dashStyle && q.attr({ dashstyle: d.dashStyle })), q.show().attr({ d: c }), b && !d.width && q.attr({ "stroke-width": this.transA }), this.cross.e = a) : this.hideCrosshair()) : this.hideCrosshair();
      }, hideCrosshair: function hideCrosshair() {
        this.cross && this.cross.hide();
      } });return a.Axis = G;
  }(M);(function (a) {
    var E = a.Axis,
        D = a.Date,
        H = a.dateFormat,
        p = a.defaultOptions,
        f = a.defined,
        l = a.each,
        r = a.extend,
        n = a.getMagnitude,
        w = a.getTZOffset,
        u = a.normalizeTickInterval,
        e = a.pick,
        h = a.timeUnits;E.prototype.getTimeTicks = function (a, d, c, b) {
      var k = [],
          m = {},
          B = p.global.useUTC,
          n,
          x = new D(d - Math.max(w(d), w(c))),
          u = D.hcMakeTime,
          t = a.unitRange,
          C = a.count,
          N,
          q;if (f(d)) {
        x[D.hcSetMilliseconds](t >= h.second ? 0 : C * Math.floor(x.getMilliseconds() / C));if (t >= h.second) x[D.hcSetSeconds](t >= h.minute ? 0 : C * Math.floor(x.getSeconds() / C));if (t >= h.minute) x[D.hcSetMinutes](t >= h.hour ? 0 : C * Math.floor(x[D.hcGetMinutes]() / C));if (t >= h.hour) x[D.hcSetHours](t >= h.day ? 0 : C * Math.floor(x[D.hcGetHours]() / C));if (t >= h.day) x[D.hcSetDate](t >= h.month ? 1 : C * Math.floor(x[D.hcGetDate]() / C));t >= h.month && (x[D.hcSetMonth](t >= h.year ? 0 : C * Math.floor(x[D.hcGetMonth]() / C)), n = x[D.hcGetFullYear]());if (t >= h.year) x[D.hcSetFullYear](n - n % C);if (t === h.week) x[D.hcSetDate](x[D.hcGetDate]() - x[D.hcGetDay]() + e(b, 1));n = x[D.hcGetFullYear]();b = x[D.hcGetMonth]();
        var A = x[D.hcGetDate](),
            F = x[D.hcGetHours]();d = x.getTime();D.hcHasTimeZone && (q = (!B || !!D.hcGetTimezoneOffset) && (c - d > 4 * h.month || w(d) !== w(c)), N = w(x), x = new D(d + N));B = x.getTime();for (d = 1; B < c;) {
          k.push(B), B = t === h.year ? u(n + d * C, 0) : t === h.month ? u(n, b + d * C) : !q || t !== h.day && t !== h.week ? q && t === h.hour ? u(n, b, A, F + d * C, 0, 0, N) - N : B + t * C : u(n, b, A + d * C * (t === h.day ? 1 : 7)), d++;
        }k.push(B);t <= h.hour && 1E4 > k.length && l(k, function (a) {
          0 === a % 18E5 && "000000000" === H("%H%M%S%L", a) && (m[a] = "day");
        });
      }k.info = r(a, { higherRanks: m, totalRange: t * C });return k;
    };
    E.prototype.normalizeTimeTickInterval = function (a, d) {
      var c = d || [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2]], ["week", [1, 2]], ["month", [1, 2, 3, 4, 6]], ["year", null]];d = c[c.length - 1];var b = h[d[0]],
          k = d[1],
          e;for (e = 0; e < c.length && !(d = c[e], b = h[d[0]], k = d[1], c[e + 1] && a <= (b * k[k.length - 1] + h[c[e + 1][0]]) / 2); e++) {}b === h.year && a < 5 * b && (k = [1, 2, 5]);a = u(a / b, k, "year" === d[0] ? Math.max(n(a / b), 1) : 1);return { unitRange: b, count: a, unitName: d[0] };
    };
  })(M);
  (function (a) {
    var E = a.Axis,
        D = a.getMagnitude,
        H = a.map,
        p = a.normalizeTickInterval,
        f = a.pick;E.prototype.getLogTickPositions = function (a, r, n, w) {
      var l = this.options,
          e = this.len,
          h = this.lin2log,
          m = this.log2lin,
          d = [];w || (this._minorAutoInterval = null);if (.5 <= a) a = Math.round(a), d = this.getLinearTickPositions(a, r, n);else if (.08 <= a) for (var e = Math.floor(r), c, b, k, z, B, l = .3 < a ? [1, 2, 4] : .15 < a ? [1, 2, 4, 6, 8] : [1, 2, 3, 4, 5, 6, 7, 8, 9]; e < n + 1 && !B; e++) {
        for (b = l.length, c = 0; c < b && !B; c++) {
          k = m(h(e) * l[c]), k > r && (!w || z <= n) && void 0 !== z && d.push(z), z > n && (B = !0), z = k;
        }
      } else r = h(r), n = h(n), a = w ? this.getMinorTickInterval() : l.tickInterval, a = f("auto" === a ? null : a, this._minorAutoInterval, l.tickPixelInterval / (w ? 5 : 1) * (n - r) / ((w ? e / this.tickPositions.length : e) || 1)), a = p(a, null, D(a)), d = H(this.getLinearTickPositions(a, r, n), m), w || (this._minorAutoInterval = a / 5);w || (this.tickInterval = a);return d;
    };E.prototype.log2lin = function (a) {
      return Math.log(a) / Math.LN10;
    };E.prototype.lin2log = function (a) {
      return Math.pow(10, a);
    };
  })(M);(function (a, E) {
    var D = a.arrayMax,
        H = a.arrayMin,
        p = a.defined,
        f = a.destroyObjectProperties,
        l = a.each,
        r = a.erase,
        n = a.merge,
        w = a.pick;a.PlotLineOrBand = function (a, e) {
      this.axis = a;e && (this.options = e, this.id = e.id);
    };a.PlotLineOrBand.prototype = { render: function render() {
        var f = this,
            e = f.axis,
            h = e.horiz,
            m = f.options,
            d = m.label,
            c = f.label,
            b = m.to,
            k = m.from,
            z = m.value,
            l = p(k) && p(b),
            r = p(z),
            x = f.svgElem,
            K = !x,
            t = [],
            C = m.color,
            N = w(m.zIndex, 0),
            q = m.events,
            t = { "class": "highcharts-plot-" + (l ? "band " : "line ") + (m.className || "") },
            A = {},
            F = e.chart.renderer,
            G = l ? "bands" : "lines",
            g = e.log2lin;e.isLog && (k = g(k), b = g(b), z = g(z));r ? (t = { stroke: C, "stroke-width": m.width }, m.dashStyle && (t.dashstyle = m.dashStyle)) : l && (C && (t.fill = C), m.borderWidth && (t.stroke = m.borderColor, t["stroke-width"] = m.borderWidth));A.zIndex = N;G += "-" + N;(C = e.plotLinesAndBandsGroups[G]) || (e.plotLinesAndBandsGroups[G] = C = F.g("plot-" + G).attr(A).add());K && (f.svgElem = x = F.path().attr(t).add(C));if (r) t = e.getPlotLinePath(z, x.strokeWidth());else if (l) t = e.getPlotBandPath(k, b, m);else return;K && t && t.length ? (x.attr({ d: t }), q && a.objectEach(q, function (a, b) {
          x.on(b, function (a) {
            q[b].apply(f, [a]);
          });
        })) : x && (t ? (x.show(), x.animate({ d: t })) : (x.hide(), c && (f.label = c = c.destroy())));d && p(d.text) && t && t.length && 0 < e.width && 0 < e.height && !t.flat ? (d = n({ align: h && l && "center", x: h ? !l && 4 : 10, verticalAlign: !h && l && "middle", y: h ? l ? 16 : 10 : l ? 6 : -4, rotation: h && !l && 90 }, d), this.renderLabel(d, t, l, N)) : c && c.hide();return f;
      }, renderLabel: function renderLabel(a, e, h, m) {
        var d = this.label,
            c = this.axis.chart.renderer;d || (d = { align: a.textAlign || a.align, rotation: a.rotation, "class": "highcharts-plot-" + (h ? "band" : "line") + "-label " + (a.className || "") }, d.zIndex = m, this.label = d = c.text(a.text, 0, 0, a.useHTML).attr(d).add(), d.css(a.style));m = e.xBounds || [e[1], e[4], h ? e[6] : e[1]];e = e.yBounds || [e[2], e[5], h ? e[7] : e[2]];h = H(m);c = H(e);d.align(a, !1, { x: h, y: c, width: D(m) - h, height: D(e) - c });d.show();
      }, destroy: function destroy() {
        r(this.axis.plotLinesAndBands, this);delete this.axis;f(this);
      } };a.extend(E.prototype, { getPlotBandPath: function getPlotBandPath(a, e) {
        var h = this.getPlotLinePath(e, null, null, !0),
            m = this.getPlotLinePath(a, null, null, !0),
            d = [],
            c = this.horiz,
            b = 1,
            k;a = a < this.min && e < this.min || a > this.max && e > this.max;if (m && h) for (a && (k = m.toString() === h.toString(), b = 0), a = 0; a < m.length; a += 6) {
          c && h[a + 1] === m[a + 1] ? (h[a + 1] += b, h[a + 4] += b) : c || h[a + 2] !== m[a + 2] || (h[a + 2] += b, h[a + 5] += b), d.push("M", m[a + 1], m[a + 2], "L", m[a + 4], m[a + 5], h[a + 4], h[a + 5], h[a + 1], h[a + 2], "z"), d.flat = k;
        }return d;
      }, addPlotBand: function addPlotBand(a) {
        return this.addPlotBandOrLine(a, "plotBands");
      }, addPlotLine: function addPlotLine(a) {
        return this.addPlotBandOrLine(a, "plotLines");
      }, addPlotBandOrLine: function addPlotBandOrLine(f, e) {
        var h = new a.PlotLineOrBand(this, f).render(),
            m = this.userOptions;h && (e && (m[e] = m[e] || [], m[e].push(f)), this.plotLinesAndBands.push(h));return h;
      }, removePlotBandOrLine: function removePlotBandOrLine(a) {
        for (var e = this.plotLinesAndBands, h = this.options, m = this.userOptions, d = e.length; d--;) {
          e[d].id === a && e[d].destroy();
        }l([h.plotLines || [], m.plotLines || [], h.plotBands || [], m.plotBands || []], function (c) {
          for (d = c.length; d--;) {
            c[d].id === a && r(c, c[d]);
          }
        });
      }, removePlotBand: function removePlotBand(a) {
        this.removePlotBandOrLine(a);
      }, removePlotLine: function removePlotLine(a) {
        this.removePlotBandOrLine(a);
      } });
  })(M, V);(function (a) {
    var E = a.dateFormat,
        D = a.each,
        H = a.extend,
        p = a.format,
        f = a.isNumber,
        l = a.map,
        r = a.merge,
        n = a.pick,
        w = a.splat,
        u = a.syncTimeout,
        e = a.timeUnits;a.Tooltip = function () {
      this.init.apply(this, arguments);
    };a.Tooltip.prototype = { init: function init(a, e) {
        this.chart = a;this.options = e;this.crosshairs = [];this.now = { x: 0, y: 0 };this.isHidden = !0;this.split = e.split && !a.inverted;this.shared = e.shared || this.split;
      }, cleanSplit: function cleanSplit(a) {
        D(this.chart.series, function (e) {
          var d = e && e.tt;d && (!d.isActive || a ? e.tt = d.destroy() : d.isActive = !1);
        });
      }, getLabel: function getLabel() {
        var a = this.chart.renderer,
            e = this.options;this.label || (this.split ? this.label = a.g("tooltip") : (this.label = a.label("", 0, 0, e.shape || "callout", null, null, e.useHTML, null, "tooltip").attr({ padding: e.padding, r: e.borderRadius }), this.label.attr({ fill: e.backgroundColor, "stroke-width": e.borderWidth }).css(e.style).shadow(e.shadow)), this.label.attr({ zIndex: 8 }).add());return this.label;
      }, update: function update(a) {
        this.destroy();r(!0, this.chart.options.tooltip.userOptions, a);this.init(this.chart, r(!0, this.options, a));
      }, destroy: function destroy() {
        this.label && (this.label = this.label.destroy());this.split && this.tt && (this.cleanSplit(this.chart, !0), this.tt = this.tt.destroy());clearTimeout(this.hideTimer);clearTimeout(this.tooltipTimeout);
      }, move: function move(a, e, d, c) {
        var b = this,
            k = b.now,
            h = !1 !== b.options.animation && !b.isHidden && (1 < Math.abs(a - k.x) || 1 < Math.abs(e - k.y)),
            m = b.followPointer || 1 < b.len;H(k, { x: h ? (2 * k.x + a) / 3 : a, y: h ? (k.y + e) / 2 : e, anchorX: m ? void 0 : h ? (2 * k.anchorX + d) / 3 : d, anchorY: m ? void 0 : h ? (k.anchorY + c) / 2 : c });b.getLabel().attr(k);h && (clearTimeout(this.tooltipTimeout), this.tooltipTimeout = setTimeout(function () {
          b && b.move(a, e, d, c);
        }, 32));
      }, hide: function hide(a) {
        var e = this;clearTimeout(this.hideTimer);a = n(a, this.options.hideDelay, 500);this.isHidden || (this.hideTimer = u(function () {
          e.getLabel()[a ? "fadeOut" : "hide"]();e.isHidden = !0;
        }, a));
      }, getAnchor: function getAnchor(a, e) {
        var d,
            c = this.chart,
            b = c.inverted,
            k = c.plotTop,
            h = c.plotLeft,
            m = 0,
            f = 0,
            x,
            n;a = w(a);d = a[0].tooltipPos;this.followPointer && e && (void 0 === e.chartX && (e = c.pointer.normalize(e)), d = [e.chartX - c.plotLeft, e.chartY - k]);d || (D(a, function (a) {
          x = a.series.yAxis;n = a.series.xAxis;m += a.plotX + (!b && n ? n.left - h : 0);f += (a.plotLow ? (a.plotLow + a.plotHigh) / 2 : a.plotY) + (!b && x ? x.top - k : 0);
        }), m /= a.length, f /= a.length, d = [b ? c.plotWidth - f : m, this.shared && !b && 1 < a.length && e ? e.chartY - k : b ? c.plotHeight - m : f]);return l(d, Math.round);
      }, getPosition: function getPosition(a, e, d) {
        var c = this.chart,
            b = this.distance,
            k = {},
            h = c.inverted && d.h || 0,
            m,
            f = ["y", c.chartHeight, e, d.plotY + c.plotTop, c.plotTop, c.plotTop + c.plotHeight],
            x = ["x", c.chartWidth, a, d.plotX + c.plotLeft, c.plotLeft, c.plotLeft + c.plotWidth],
            l = !this.followPointer && n(d.ttBelow, !c.inverted === !!d.negative),
            t = function t(a, c, d, g, e, q) {
          var m = d < g - b,
              z = g + b + d < c,
              A = g - b - d;g += b;if (l && z) k[a] = g;else if (!l && m) k[a] = A;else if (m) k[a] = Math.min(q - d, 0 > A - h ? A : A - h);else if (z) k[a] = Math.max(e, g + h + d > c ? g : g + h);else return !1;
        },
            C = function C(a, c, d, g) {
          var e;g < b || g > c - b ? e = !1 : k[a] = g < d / 2 ? 1 : g > c - d / 2 ? c - d - 2 : g - d / 2;return e;
        },
            p = function p(a) {
          var b = f;f = x;x = b;m = a;
        },
            q = function q() {
          !1 !== t.apply(0, f) ? !1 !== C.apply(0, x) || m || (p(!0), q()) : m ? k.x = k.y = 0 : (p(!0), q());
        };(c.inverted || 1 < this.len) && p();q();return k;
      },
      defaultFormatter: function defaultFormatter(a) {
        var e = this.points || w(this),
            d;d = [a.tooltipFooterHeaderFormatter(e[0])];d = d.concat(a.bodyFormatter(e));d.push(a.tooltipFooterHeaderFormatter(e[0], !0));return d;
      }, refresh: function refresh(a, e) {
        var d,
            c = this.options,
            b,
            k = a,
            h,
            m = {},
            f = [];d = c.formatter || this.defaultFormatter;var m = this.shared,
            x;c.enabled && (clearTimeout(this.hideTimer), this.followPointer = w(k)[0].series.tooltipOptions.followPointer, h = this.getAnchor(k, e), e = h[0], b = h[1], !m || k.series && k.series.noSharedTooltip ? m = k.getLabelConfig() : (D(k, function (a) {
          a.setState("hover");f.push(a.getLabelConfig());
        }), m = { x: k[0].category, y: k[0].y }, m.points = f, k = k[0]), this.len = f.length, m = d.call(m, this), x = k.series, this.distance = n(x.tooltipOptions.distance, 16), !1 === m ? this.hide() : (d = this.getLabel(), this.isHidden && d.attr({ opacity: 1 }).show(), this.split ? this.renderSplit(m, w(a)) : (c.style.width || d.css({ width: this.chart.spacingBox.width }), d.attr({ text: m && m.join ? m.join("") : m }), d.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-" + n(k.colorIndex, x.colorIndex)), d.attr({ stroke: c.borderColor || k.color || x.color || "#666666" }), this.updatePosition({ plotX: e, plotY: b, negative: k.negative, ttBelow: k.ttBelow, h: h[2] || 0 })), this.isHidden = !1));
      }, renderSplit: function renderSplit(e, m) {
        var d = this,
            c = [],
            b = this.chart,
            k = b.renderer,
            h = !0,
            f = this.options,
            l = 0,
            x = this.getLabel();a.isString(e) && (e = [!1, e]);D(e.slice(0, m.length + 1), function (a, e) {
          if (!1 !== a) {
            e = m[e - 1] || { isHeader: !0, plotX: m[0].plotX };var z = e.series || d,
                t = z.tt,
                q = e.series || {},
                A = "highcharts-color-" + n(e.colorIndex, q.colorIndex, "none");
            t || (z.tt = t = k.label(null, null, null, "callout", null, null, f.useHTML).addClass("highcharts-tooltip-box " + A).attr({ padding: f.padding, r: f.borderRadius, fill: f.backgroundColor, stroke: f.borderColor || e.color || q.color || "#333333", "stroke-width": f.borderWidth }).add(x));t.isActive = !0;t.attr({ text: a });t.css(f.style).shadow(f.shadow);a = t.getBBox();q = a.width + t.strokeWidth();e.isHeader ? (l = a.height, q = Math.max(0, Math.min(e.plotX + b.plotLeft - q / 2, b.chartWidth - q))) : q = e.plotX + b.plotLeft - n(f.distance, 16) - q;0 > q && (h = !1);a = (e.series && e.series.yAxis && e.series.yAxis.pos) + (e.plotY || 0);a -= b.plotTop;c.push({ target: e.isHeader ? b.plotHeight + l : a, rank: e.isHeader ? 1 : 0, size: z.tt.getBBox().height + 1, point: e, x: q, tt: t });
          }
        });this.cleanSplit();a.distribute(c, b.plotHeight + l);D(c, function (a) {
          var c = a.point,
              d = c.series;a.tt.attr({ visibility: void 0 === a.pos ? "hidden" : "inherit", x: h || c.isHeader ? a.x : c.plotX + b.plotLeft + n(f.distance, 16), y: a.pos + b.plotTop, anchorX: c.isHeader ? c.plotX + b.plotLeft : c.plotX + d.xAxis.pos, anchorY: c.isHeader ? a.pos + b.plotTop - 15 : c.plotY + d.yAxis.pos });
        });
      },
      updatePosition: function updatePosition(a) {
        var e = this.chart,
            d = this.getLabel(),
            d = (this.options.positioner || this.getPosition).call(this, d.width, d.height, a);this.move(Math.round(d.x), Math.round(d.y || 0), a.plotX + e.plotLeft, a.plotY + e.plotTop);
      }, getDateFormat: function getDateFormat(a, m, d, c) {
        var b = E("%m-%d %H:%M:%S.%L", m),
            k,
            h,
            f = { millisecond: 15, second: 12, minute: 9, hour: 6, day: 3 },
            l = "millisecond";for (h in e) {
          if (a === e.week && +E("%w", m) === d && "00:00:00.000" === b.substr(6)) {
            h = "week";break;
          }if (e[h] > a) {
            h = l;break;
          }if (f[h] && b.substr(f[h]) !== "01-01 00:00:00.000".substr(f[h])) break;
          "week" !== h && (l = h);
        }h && (k = c[h]);return k;
      }, getXDateFormat: function getXDateFormat(a, e, d) {
        e = e.dateTimeLabelFormats;var c = d && d.closestPointRange;return (c ? this.getDateFormat(c, a.x, d.options.startOfWeek, e) : e.day) || e.year;
      }, tooltipFooterHeaderFormatter: function tooltipFooterHeaderFormatter(a, e) {
        e = e ? "footer" : "header";var d = a.series,
            c = d.tooltipOptions,
            b = c.xDateFormat,
            k = d.xAxis,
            h = k && "datetime" === k.options.type && f(a.key),
            m = c[e + "Format"];h && !b && (b = this.getXDateFormat(a, c, k));h && b && D(a.point && a.point.tooltipDateKeys || ["key"], function (a) {
          m = m.replace("{point." + a + "}", "{point." + a + ":" + b + "}");
        });return p(m, { point: a, series: d });
      }, bodyFormatter: function bodyFormatter(a) {
        return l(a, function (a) {
          var d = a.series.tooltipOptions;return (d[(a.point.formatPrefix || "point") + "Formatter"] || a.point.tooltipFormatter).call(a.point, d[(a.point.formatPrefix || "point") + "Format"]);
        });
      } };
  })(M);(function (a) {
    var E = a.addEvent,
        D = a.attr,
        H = a.charts,
        p = a.color,
        f = a.css,
        l = a.defined,
        r = a.each,
        n = a.extend,
        w = a.find,
        u = a.fireEvent,
        e = a.isObject,
        h = a.offset,
        m = a.pick,
        d = a.splat,
        c = a.Tooltip;a.Pointer = function (a, c) {
      this.init(a, c);
    };a.Pointer.prototype = { init: function init(a, d) {
        this.options = d;this.chart = a;this.runChartClick = d.chart.events && !!d.chart.events.click;this.pinchDown = [];this.lastValidTouch = {};c && (a.tooltip = new c(a, d.tooltip), this.followTouchMove = m(d.tooltip.followTouchMove, !0));this.setDOMEvents();
      }, zoomOption: function zoomOption(a) {
        var b = this.chart,
            c = b.options.chart,
            d = c.zoomType || "",
            b = b.inverted;/touch/.test(a.type) && (d = m(c.pinchType, d));this.zoomX = a = /x/.test(d);this.zoomY = d = /y/.test(d);this.zoomHor = a && !b || d && b;this.zoomVert = d && !b || a && b;this.hasZoom = a || d;
      }, normalize: function normalize(a, c) {
        var b;b = a.touches ? a.touches.length ? a.touches.item(0) : a.changedTouches[0] : a;c || (this.chartPosition = c = h(this.chart.container));return n(a, { chartX: Math.round(b.pageX - c.left), chartY: Math.round(b.pageY - c.top) });
      }, getCoordinates: function getCoordinates(a) {
        var b = { xAxis: [], yAxis: [] };r(this.chart.axes, function (c) {
          b[c.isXAxis ? "xAxis" : "yAxis"].push({ axis: c, value: c.toValue(a[c.horiz ? "chartX" : "chartY"]) });
        });return b;
      }, findNearestKDPoint: function findNearestKDPoint(a, c, d) {
        var b;r(a, function (a) {
          var k = !(a.noSharedTooltip && c) && 0 > a.options.findNearestPointBy.indexOf("y");a = a.searchPoint(d, k);if ((k = e(a, !0)) && !(k = !e(b, !0))) var k = b.distX - a.distX,
              h = b.dist - a.dist,
              m = (a.series.group && a.series.group.zIndex) - (b.series.group && b.series.group.zIndex),
              k = 0 < (0 !== k && c ? k : 0 !== h ? h : 0 !== m ? m : b.series.index > a.series.index ? -1 : 1);k && (b = a);
        });return b;
      }, getPointFromEvent: function getPointFromEvent(a) {
        a = a.target;for (var b; a && !b;) {
          b = a.point, a = a.parentNode;
        }return b;
      }, getChartCoordinatesFromPoint: function getChartCoordinatesFromPoint(a, c) {
        var b = a.series,
            d = b.xAxis,
            b = b.yAxis,
            k = m(a.clientX, a.plotX);if (d && b) return c ? { chartX: d.len + d.pos - k, chartY: b.len + b.pos - a.plotY } : { chartX: k + d.pos, chartY: a.plotY + b.pos };
      }, getHoverData: function getHoverData(b, c, d, h, f, l, n) {
        var k,
            z = [],
            x = n && n.isBoosting;h = !(!h || !b);n = c && !c.stickyTracking ? [c] : a.grep(d, function (a) {
          return a.visible && !(!f && a.directTouch) && m(a.options.enableMouseTracking, !0) && a.stickyTracking;
        });c = (k = h ? b : this.findNearestKDPoint(n, f, l)) && k.series;k && (f && !c.noSharedTooltip ? (n = a.grep(d, function (a) {
          return a.visible && !(!f && a.directTouch) && m(a.options.enableMouseTracking, !0) && !a.noSharedTooltip;
        }), r(n, function (a) {
          var b = w(a.points, function (a) {
            return a.x === k.x && !a.isNull;
          });e(b) && (x && (b = a.getPoint(b)), z.push(b));
        })) : z.push(k));return { hoverPoint: k, hoverSeries: c, hoverPoints: z };
      }, runPointActions: function runPointActions(b, c) {
        var d = this.chart,
            k = d.tooltip && d.tooltip.options.enabled ? d.tooltip : void 0,
            e = k ? k.shared : !1,
            h = c || d.hoverPoint,
            f = h && h.series || d.hoverSeries,
            f = this.getHoverData(h, f, d.series, !!c || f && f.directTouch && this.isDirectTouch, e, b, { isBoosting: d.isBoosting }),
            l,
            h = f.hoverPoint;l = f.hoverPoints;
        c = (f = f.hoverSeries) && f.tooltipOptions.followPointer;e = e && f && !f.noSharedTooltip;if (h && (h !== d.hoverPoint || k && k.isHidden)) {
          r(d.hoverPoints || [], function (b) {
            -1 === a.inArray(b, l) && b.setState();
          });r(l || [], function (a) {
            a.setState("hover");
          });if (d.hoverSeries !== f) f.onMouseOver();d.hoverPoint && d.hoverPoint.firePointEvent("mouseOut");if (!h.series) return;h.firePointEvent("mouseOver");d.hoverPoints = l;d.hoverPoint = h;k && k.refresh(e ? l : h, b);
        } else c && k && !k.isHidden && (h = k.getAnchor([{}], b), k.updatePosition({ plotX: h[0], plotY: h[1] }));
        this.unDocMouseMove || (this.unDocMouseMove = E(d.container.ownerDocument, "mousemove", function (b) {
          var c = H[a.hoverChartIndex];if (c) c.pointer.onDocumentMouseMove(b);
        }));r(d.axes, function (c) {
          var d = m(c.crosshair.snap, !0),
              k = d ? a.find(l, function (a) {
            return a.series[c.coll] === c;
          }) : void 0;k || !d ? c.drawCrosshair(b, k) : c.hideCrosshair();
        });
      }, reset: function reset(a, c) {
        var b = this.chart,
            k = b.hoverSeries,
            e = b.hoverPoint,
            h = b.hoverPoints,
            m = b.tooltip,
            f = m && m.shared ? h : e;a && f && r(d(f), function (b) {
          b.series.isCartesian && void 0 === b.plotX && (a = !1);
        });if (a) m && f && (m.refresh(f), e && (e.setState(e.state, !0), r(b.axes, function (a) {
          a.crosshair && a.drawCrosshair(null, e);
        })));else {
          if (e) e.onMouseOut();h && r(h, function (a) {
            a.setState();
          });if (k) k.onMouseOut();m && m.hide(c);this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove());r(b.axes, function (a) {
            a.hideCrosshair();
          });this.hoverX = b.hoverPoints = b.hoverPoint = null;
        }
      }, scaleGroups: function scaleGroups(a, c) {
        var b = this.chart,
            d;r(b.series, function (k) {
          d = a || k.getPlotBox();k.xAxis && k.xAxis.zoomEnabled && k.group && (k.group.attr(d), k.markerGroup && (k.markerGroup.attr(d), k.markerGroup.clip(c ? b.clipRect : null)), k.dataLabelsGroup && k.dataLabelsGroup.attr(d));
        });b.clipRect.attr(c || b.clipBox);
      }, dragStart: function dragStart(a) {
        var b = this.chart;b.mouseIsDown = a.type;b.cancelClick = !1;b.mouseDownX = this.mouseDownX = a.chartX;b.mouseDownY = this.mouseDownY = a.chartY;
      }, drag: function drag(a) {
        var b = this.chart,
            c = b.options.chart,
            d = a.chartX,
            e = a.chartY,
            h = this.zoomHor,
            m = this.zoomVert,
            f = b.plotLeft,
            l = b.plotTop,
            n = b.plotWidth,
            q = b.plotHeight,
            A,
            F = this.selectionMarker,
            G = this.mouseDownX,
            g = this.mouseDownY,
            v = c.panKey && a[c.panKey + "Key"];F && F.touch || (d < f ? d = f : d > f + n && (d = f + n), e < l ? e = l : e > l + q && (e = l + q), this.hasDragged = Math.sqrt(Math.pow(G - d, 2) + Math.pow(g - e, 2)), 10 < this.hasDragged && (A = b.isInsidePlot(G - f, g - l), b.hasCartesianSeries && (this.zoomX || this.zoomY) && A && !v && !F && (this.selectionMarker = F = b.renderer.rect(f, l, h ? 1 : n, m ? 1 : q, 0).attr({ fill: c.selectionMarkerFill || p("#335cad").setOpacity(.25).get(), "class": "highcharts-selection-marker", zIndex: 7 }).add()), F && h && (d -= G, F.attr({ width: Math.abs(d), x: (0 < d ? 0 : d) + G })), F && m && (d = e - g, F.attr({ height: Math.abs(d), y: (0 < d ? 0 : d) + g })), A && !F && c.panning && b.pan(a, c.panning)));
      }, drop: function drop(a) {
        var b = this,
            c = this.chart,
            d = this.hasPinched;if (this.selectionMarker) {
          var e = { originalEvent: a, xAxis: [], yAxis: [] },
              h = this.selectionMarker,
              m = h.attr ? h.attr("x") : h.x,
              t = h.attr ? h.attr("y") : h.y,
              p = h.attr ? h.attr("width") : h.width,
              w = h.attr ? h.attr("height") : h.height,
              q;if (this.hasDragged || d) r(c.axes, function (c) {
            if (c.zoomEnabled && l(c.min) && (d || b[{ xAxis: "zoomX", yAxis: "zoomY" }[c.coll]])) {
              var k = c.horiz,
                  h = "touchend" === a.type ? c.minPixelPadding : 0,
                  g = c.toValue((k ? m : t) + h),
                  k = c.toValue((k ? m + p : t + w) - h);e[c.coll].push({ axis: c, min: Math.min(g, k), max: Math.max(g, k) });q = !0;
            }
          }), q && u(c, "selection", e, function (a) {
            c.zoom(n(a, d ? { animation: !1 } : null));
          });this.selectionMarker = this.selectionMarker.destroy();d && this.scaleGroups();
        }c && (f(c.container, { cursor: c._cursor }), c.cancelClick = 10 < this.hasDragged, c.mouseIsDown = this.hasDragged = this.hasPinched = !1, this.pinchDown = []);
      }, onContainerMouseDown: function onContainerMouseDown(a) {
        2 !== a.button && (a = this.normalize(a), this.zoomOption(a), a.preventDefault && a.preventDefault(), this.dragStart(a));
      }, onDocumentMouseUp: function onDocumentMouseUp(b) {
        H[a.hoverChartIndex] && H[a.hoverChartIndex].pointer.drop(b);
      }, onDocumentMouseMove: function onDocumentMouseMove(a) {
        var b = this.chart,
            c = this.chartPosition;a = this.normalize(a, c);!c || this.inClass(a.target, "highcharts-tracker") || b.isInsidePlot(a.chartX - b.plotLeft, a.chartY - b.plotTop) || this.reset();
      }, onContainerMouseLeave: function onContainerMouseLeave(b) {
        var c = H[a.hoverChartIndex];c && (b.relatedTarget || b.toElement) && (c.pointer.reset(), c.pointer.chartPosition = null);
      }, onContainerMouseMove: function onContainerMouseMove(b) {
        var c = this.chart;l(a.hoverChartIndex) && H[a.hoverChartIndex] && H[a.hoverChartIndex].mouseIsDown || (a.hoverChartIndex = c.index);b = this.normalize(b);b.returnValue = !1;"mousedown" === c.mouseIsDown && this.drag(b);!this.inClass(b.target, "highcharts-tracker") && !c.isInsidePlot(b.chartX - c.plotLeft, b.chartY - c.plotTop) || c.openMenu || this.runPointActions(b);
      }, inClass: function inClass(a, c) {
        for (var b; a;) {
          if (b = D(a, "class")) {
            if (-1 !== b.indexOf(c)) return !0;if (-1 !== b.indexOf("highcharts-container")) return !1;
          }a = a.parentNode;
        }
      }, onTrackerMouseOut: function onTrackerMouseOut(a) {
        var b = this.chart.hoverSeries;a = a.relatedTarget || a.toElement;this.isDirectTouch = !1;if (!(!b || !a || b.stickyTracking || this.inClass(a, "highcharts-tooltip") || this.inClass(a, "highcharts-series-" + b.index) && this.inClass(a, "highcharts-tracker"))) b.onMouseOut();
      }, onContainerClick: function onContainerClick(a) {
        var b = this.chart,
            c = b.hoverPoint,
            d = b.plotLeft,
            e = b.plotTop;a = this.normalize(a);b.cancelClick || (c && this.inClass(a.target, "highcharts-tracker") ? (u(c.series, "click", n(a, { point: c })), b.hoverPoint && c.firePointEvent("click", a)) : (n(a, this.getCoordinates(a)), b.isInsidePlot(a.chartX - d, a.chartY - e) && u(b, "click", a)));
      }, setDOMEvents: function setDOMEvents() {
        var b = this,
            c = b.chart.container,
            d = c.ownerDocument;c.onmousedown = function (a) {
          b.onContainerMouseDown(a);
        };c.onmousemove = function (a) {
          b.onContainerMouseMove(a);
        };c.onclick = function (a) {
          b.onContainerClick(a);
        };this.unbindContainerMouseLeave = E(c, "mouseleave", b.onContainerMouseLeave);a.unbindDocumentMouseUp || (a.unbindDocumentMouseUp = E(d, "mouseup", b.onDocumentMouseUp));
        a.hasTouch && (c.ontouchstart = function (a) {
          b.onContainerTouchStart(a);
        }, c.ontouchmove = function (a) {
          b.onContainerTouchMove(a);
        }, a.unbindDocumentTouchEnd || (a.unbindDocumentTouchEnd = E(d, "touchend", b.onDocumentTouchEnd)));
      }, destroy: function destroy() {
        var b = this;b.unDocMouseMove && b.unDocMouseMove();this.unbindContainerMouseLeave();a.chartCount || (a.unbindDocumentMouseUp && (a.unbindDocumentMouseUp = a.unbindDocumentMouseUp()), a.unbindDocumentTouchEnd && (a.unbindDocumentTouchEnd = a.unbindDocumentTouchEnd()));clearInterval(b.tooltipTimeout);
        a.objectEach(b, function (a, c) {
          b[c] = null;
        });
      } };
  })(M);(function (a) {
    var E = a.charts,
        D = a.each,
        H = a.extend,
        p = a.map,
        f = a.noop,
        l = a.pick;H(a.Pointer.prototype, { pinchTranslate: function pinchTranslate(a, f, l, p, e, h) {
        this.zoomHor && this.pinchTranslateDirection(!0, a, f, l, p, e, h);this.zoomVert && this.pinchTranslateDirection(!1, a, f, l, p, e, h);
      }, pinchTranslateDirection: function pinchTranslateDirection(a, f, l, p, e, h, m, d) {
        var c = this.chart,
            b = a ? "x" : "y",
            k = a ? "X" : "Y",
            z = "chart" + k,
            n = a ? "width" : "height",
            r = c["plot" + (a ? "Left" : "Top")],
            x,
            w,
            t = d || 1,
            C = c.inverted,
            u = c.bounds[a ? "h" : "v"],
            q = 1 === f.length,
            A = f[0][z],
            F = l[0][z],
            G = !q && f[1][z],
            g = !q && l[1][z],
            v;l = function l() {
          !q && 20 < Math.abs(A - G) && (t = d || Math.abs(F - g) / Math.abs(A - G));w = (r - F) / t + A;x = c["plot" + (a ? "Width" : "Height")] / t;
        };l();f = w;f < u.min ? (f = u.min, v = !0) : f + x > u.max && (f = u.max - x, v = !0);v ? (F -= .8 * (F - m[b][0]), q || (g -= .8 * (g - m[b][1])), l()) : m[b] = [F, g];C || (h[b] = w - r, h[n] = x);h = C ? 1 / t : t;e[n] = x;e[b] = f;p[C ? a ? "scaleY" : "scaleX" : "scale" + k] = t;p["translate" + k] = h * r + (F - h * A);
      }, pinch: function pinch(a) {
        var n = this,
            r = n.chart,
            u = n.pinchDown,
            e = a.touches,
            h = e.length,
            m = n.lastValidTouch,
            d = n.hasZoom,
            c = n.selectionMarker,
            b = {},
            k = 1 === h && (n.inClass(a.target, "highcharts-tracker") && r.runTrackerClick || n.runChartClick),
            z = {};1 < h && (n.initiated = !0);d && n.initiated && !k && a.preventDefault();p(e, function (a) {
          return n.normalize(a);
        });"touchstart" === a.type ? (D(e, function (a, b) {
          u[b] = { chartX: a.chartX, chartY: a.chartY };
        }), m.x = [u[0].chartX, u[1] && u[1].chartX], m.y = [u[0].chartY, u[1] && u[1].chartY], D(r.axes, function (a) {
          if (a.zoomEnabled) {
            var b = r.bounds[a.horiz ? "h" : "v"],
                c = a.minPixelPadding,
                d = a.toPixels(l(a.options.min, a.dataMin)),
                e = a.toPixels(l(a.options.max, a.dataMax)),
                k = Math.max(d, e);b.min = Math.min(a.pos, Math.min(d, e) - c);b.max = Math.max(a.pos + a.len, k + c);
          }
        }), n.res = !0) : n.followTouchMove && 1 === h ? this.runPointActions(n.normalize(a)) : u.length && (c || (n.selectionMarker = c = H({ destroy: f, touch: !0 }, r.plotBox)), n.pinchTranslate(u, e, b, c, z, m), n.hasPinched = d, n.scaleGroups(b, z), n.res && (n.res = !1, this.reset(!1, 0)));
      }, touch: function touch(f, n) {
        var p = this.chart,
            r,
            e;if (p.index !== a.hoverChartIndex) this.onContainerMouseLeave({ relatedTarget: !0 });
        a.hoverChartIndex = p.index;1 === f.touches.length ? (f = this.normalize(f), (e = p.isInsidePlot(f.chartX - p.plotLeft, f.chartY - p.plotTop)) && !p.openMenu ? (n && this.runPointActions(f), "touchmove" === f.type && (n = this.pinchDown, r = n[0] ? 4 <= Math.sqrt(Math.pow(n[0].chartX - f.chartX, 2) + Math.pow(n[0].chartY - f.chartY, 2)) : !1), l(r, !0) && this.pinch(f)) : n && this.reset()) : 2 === f.touches.length && this.pinch(f);
      }, onContainerTouchStart: function onContainerTouchStart(a) {
        this.zoomOption(a);this.touch(a, !0);
      }, onContainerTouchMove: function onContainerTouchMove(a) {
        this.touch(a);
      }, onDocumentTouchEnd: function onDocumentTouchEnd(f) {
        E[a.hoverChartIndex] && E[a.hoverChartIndex].pointer.drop(f);
      } });
  })(M);(function (a) {
    var E = a.addEvent,
        D = a.charts,
        H = a.css,
        p = a.doc,
        f = a.extend,
        l = a.noop,
        r = a.Pointer,
        n = a.removeEvent,
        w = a.win,
        u = a.wrap;if (!a.hasTouch && (w.PointerEvent || w.MSPointerEvent)) {
      var e = {},
          h = !!w.PointerEvent,
          m = function m() {
        var c = [];c.item = function (a) {
          return this[a];
        };a.objectEach(e, function (a) {
          c.push({ pageX: a.pageX, pageY: a.pageY, target: a.target });
        });return c;
      },
          d = function d(c, b, _d, e) {
        "touch" !== c.pointerType && c.pointerType !== c.MSPOINTER_TYPE_TOUCH || !D[a.hoverChartIndex] || (e(c), e = D[a.hoverChartIndex].pointer, e[b]({ type: _d, target: c.currentTarget, preventDefault: l, touches: m() }));
      };f(r.prototype, { onContainerPointerDown: function onContainerPointerDown(a) {
          d(a, "onContainerTouchStart", "touchstart", function (a) {
            e[a.pointerId] = { pageX: a.pageX, pageY: a.pageY, target: a.currentTarget };
          });
        }, onContainerPointerMove: function onContainerPointerMove(a) {
          d(a, "onContainerTouchMove", "touchmove", function (a) {
            e[a.pointerId] = { pageX: a.pageX, pageY: a.pageY };e[a.pointerId].target || (e[a.pointerId].target = a.currentTarget);
          });
        }, onDocumentPointerUp: function onDocumentPointerUp(a) {
          d(a, "onDocumentTouchEnd", "touchend", function (a) {
            delete e[a.pointerId];
          });
        }, batchMSEvents: function batchMSEvents(a) {
          a(this.chart.container, h ? "pointerdown" : "MSPointerDown", this.onContainerPointerDown);a(this.chart.container, h ? "pointermove" : "MSPointerMove", this.onContainerPointerMove);a(p, h ? "pointerup" : "MSPointerUp", this.onDocumentPointerUp);
        } });u(r.prototype, "init", function (a, b, d) {
        a.call(this, b, d);this.hasZoom && H(b.container, { "-ms-touch-action": "none", "touch-action": "none" });
      });u(r.prototype, "setDOMEvents", function (a) {
        a.apply(this);
        (this.hasZoom || this.followTouchMove) && this.batchMSEvents(E);
      });u(r.prototype, "destroy", function (a) {
        this.batchMSEvents(n);a.call(this);
      });
    }
  })(M);(function (a) {
    var E = a.addEvent,
        D = a.css,
        H = a.discardElement,
        p = a.defined,
        f = a.each,
        l = a.isFirefox,
        r = a.marginNames,
        n = a.merge,
        w = a.pick,
        u = a.setAnimation,
        e = a.stableSort,
        h = a.win,
        m = a.wrap;a.Legend = function (a, c) {
      this.init(a, c);
    };a.Legend.prototype = { init: function init(a, c) {
        this.chart = a;this.setOptions(c);c.enabled && (this.render(), E(this.chart, "endResize", function () {
          this.legend.positionCheckboxes();
        }));
      },
      setOptions: function setOptions(a) {
        var c = w(a.padding, 8);this.options = a;this.itemStyle = a.itemStyle;this.itemHiddenStyle = n(this.itemStyle, a.itemHiddenStyle);this.itemMarginTop = a.itemMarginTop || 0;this.padding = c;this.initialItemY = c - 5;this.itemHeight = this.maxItemWidth = 0;this.symbolWidth = w(a.symbolWidth, 16);this.pages = [];
      }, update: function update(a, c) {
        var b = this.chart;this.setOptions(n(!0, this.options, a));this.destroy();b.isDirtyLegend = b.isDirtyBox = !0;w(c, !0) && b.redraw();
      }, colorizeItem: function colorizeItem(a, c) {
        a.legendGroup[c ? "removeClass" : "addClass"]("highcharts-legend-item-hidden");var b = this.options,
            d = a.legendItem,
            e = a.legendLine,
            h = a.legendSymbol,
            f = this.itemHiddenStyle.color,
            b = c ? b.itemStyle.color : f,
            m = c ? a.color || f : f,
            l = a.options && a.options.marker,
            t = { fill: m };d && d.css({ fill: b, color: b });e && e.attr({ stroke: m });h && (l && h.isMarker && (t = a.pointAttribs(), c || (t.stroke = t.fill = f)), h.attr(t));
      }, positionItem: function positionItem(a) {
        var c = this.options,
            b = c.symbolPadding,
            c = !c.rtl,
            d = a._legendItemPos,
            e = d[0],
            d = d[1],
            h = a.checkbox;(a = a.legendGroup) && a.element && a.translate(c ? e : this.legendWidth - e - 2 * b - 4, d);h && (h.x = e, h.y = d);
      }, destroyItem: function destroyItem(a) {
        var c = a.checkbox;f(["legendItem", "legendLine", "legendSymbol", "legendGroup"], function (b) {
          a[b] && (a[b] = a[b].destroy());
        });c && H(a.checkbox);
      }, destroy: function destroy() {
        function a(a) {
          this[a] && (this[a] = this[a].destroy());
        }f(this.getAllItems(), function (c) {
          f(["legendItem", "legendGroup"], a, c);
        });f("clipRect up down pager nav box title group".split(" "), a, this);this.display = null;
      }, positionCheckboxes: function positionCheckboxes() {
        var a = this.group && this.group.alignAttr,
            c,
            b = this.clipHeight || this.legendHeight,
            e = this.titleHeight;a && (c = a.translateY, f(this.allItems, function (d) {
          var k = d.checkbox,
              h;k && (h = c + e + k.y + (this.scrollOffset || 0) + 3, D(k, { left: a.translateX + d.checkboxOffset + k.x - 20 + "px", top: h + "px", display: h > c - 6 && h < c + b - 6 ? "" : "none" }));
        }, this));
      }, renderTitle: function renderTitle() {
        var a = this.options,
            c = this.padding,
            b = a.title,
            e = 0;b.text && (this.title || (this.title = this.chart.renderer.label(b.text, c - 3, c - 4, null, null, null, a.useHTML, null, "legend-title").attr({ zIndex: 1 }).css(b.style).add(this.group)), a = this.title.getBBox(), e = a.height, this.offsetWidth = a.width, this.contentGroup.attr({ translateY: e }));this.titleHeight = e;
      }, setText: function setText(d) {
        var c = this.options;d.legendItem.attr({ text: c.labelFormat ? a.format(c.labelFormat, d) : c.labelFormatter.call(d) });
      }, renderItem: function renderItem(a) {
        var c = this.chart,
            b = c.renderer,
            d = this.options,
            e = "horizontal" === d.layout,
            h = this.symbolWidth,
            f = d.symbolPadding,
            m = this.itemStyle,
            l = this.itemHiddenStyle,
            t = this.padding,
            p = e ? w(d.itemDistance, 20) : 0,
            r = !d.rtl,
            q = d.width,
            A = d.itemMarginBottom || 0,
            F = this.itemMarginTop,
            G = a.legendItem,
            g = !a.series,
            v = !g && a.series.drawLegendSymbol ? a.series : a,
            u = v.options,
            L = this.createCheckboxForItem && u && u.showCheckbox,
            u = h + f + p + (L ? 20 : 0),
            P = d.useHTML,
            J = a.options.className;G || (a.legendGroup = b.g("legend-item").addClass("highcharts-" + v.type + "-series highcharts-color-" + a.colorIndex + (J ? " " + J : "") + (g ? " highcharts-series-" + a.index : "")).attr({ zIndex: 1 }).add(this.scrollGroup), a.legendItem = G = b.text("", r ? h + f : -f, this.baseline || 0, P).css(n(a.visible ? m : l)).attr({ align: r ? "left" : "right",
          zIndex: 2 }).add(a.legendGroup), this.baseline || (h = m.fontSize, this.fontMetrics = b.fontMetrics(h, G), this.baseline = this.fontMetrics.f + 3 + F, G.attr("y", this.baseline)), this.symbolHeight = d.symbolHeight || this.fontMetrics.f, v.drawLegendSymbol(this, a), this.setItemEvents && this.setItemEvents(a, G, P), L && this.createCheckboxForItem(a));this.colorizeItem(a, a.visible);m.width || G.css({ width: (d.itemWidth || d.width || c.spacingBox.width) - u });this.setText(a);b = G.getBBox();m = a.checkboxOffset = d.itemWidth || a.legendItemWidth || b.width + u;this.itemHeight = b = Math.round(a.legendItemHeight || b.height || this.symbolHeight);e && this.itemX - t + m > (q || c.spacingBox.width - 2 * t - d.x) && (this.itemX = t, this.itemY += F + this.lastLineHeight + A, this.lastLineHeight = 0);this.maxItemWidth = Math.max(this.maxItemWidth, m);this.lastItemY = F + this.itemY + A;this.lastLineHeight = Math.max(b, this.lastLineHeight);a._legendItemPos = [this.itemX, this.itemY];e ? this.itemX += m : (this.itemY += F + b + A, this.lastLineHeight = b);this.offsetWidth = q || Math.max((e ? this.itemX - t - (a.checkbox ? 0 : p) : m) + t, this.offsetWidth);
      },
      getAllItems: function getAllItems() {
        var a = [];f(this.chart.series, function (c) {
          var b = c && c.options;c && w(b.showInLegend, p(b.linkedTo) ? !1 : void 0, !0) && (a = a.concat(c.legendItems || ("point" === b.legendType ? c.data : c)));
        });return a;
      }, getAlignment: function getAlignment() {
        var a = this.options;return a.floating ? "" : a.align.charAt(0) + a.verticalAlign.charAt(0) + a.layout.charAt(0);
      }, adjustMargins: function adjustMargins(a, c) {
        var b = this.chart,
            d = this.options,
            e = this.getAlignment();e && f([/(lth|ct|rth)/, /(rtv|rm|rbv)/, /(rbh|cb|lbh)/, /(lbv|lm|ltv)/], function (k, h) {
          k.test(e) && !p(a[h]) && (b[r[h]] = Math.max(b[r[h]], b.legend[(h + 1) % 2 ? "legendHeight" : "legendWidth"] + [1, -1, -1, 1][h] * d[h % 2 ? "x" : "y"] + w(d.margin, 12) + c[h] + (0 === h ? b.titleOffset + b.options.title.margin : 0)));
        });
      }, render: function render() {
        var a = this,
            c = a.chart,
            b = c.renderer,
            k = a.group,
            h,
            m,
            l,
            x,
            p = a.box,
            t = a.options,
            C = a.padding;a.itemX = C;a.itemY = a.initialItemY;a.offsetWidth = 0;a.lastItemY = 0;k || (a.group = k = b.g("legend").attr({ zIndex: 7 }).add(), a.contentGroup = b.g().attr({ zIndex: 1 }).add(k), a.scrollGroup = b.g().add(a.contentGroup));a.renderTitle();
        h = a.getAllItems();e(h, function (a, b) {
          return (a.options && a.options.legendIndex || 0) - (b.options && b.options.legendIndex || 0);
        });t.reversed && h.reverse();a.allItems = h;a.display = m = !!h.length;a.lastLineHeight = 0;f(h, function (b) {
          a.renderItem(b);
        });l = (t.width || a.offsetWidth) + C;x = a.lastItemY + a.lastLineHeight + a.titleHeight;x = a.handleOverflow(x);x += C;p || (a.box = p = b.rect().addClass("highcharts-legend-box").attr({ r: t.borderRadius }).add(k), p.isNew = !0);p.attr({ stroke: t.borderColor, "stroke-width": t.borderWidth || 0, fill: t.backgroundColor || "none" }).shadow(t.shadow);0 < l && 0 < x && (p[p.isNew ? "attr" : "animate"](p.crisp.call({}, { x: 0, y: 0, width: l, height: x }, p.strokeWidth())), p.isNew = !1);p[m ? "show" : "hide"]();a.legendWidth = l;a.legendHeight = x;f(h, function (b) {
          a.positionItem(b);
        });m && (b = c.spacingBox, /(lth|ct|rth)/.test(a.getAlignment()) && (b = n(b, { y: b.y + c.titleOffset + c.options.title.margin })), k.align(n(t, { width: l, height: x }), !0, b));c.isResizing || this.positionCheckboxes();
      }, handleOverflow: function handleOverflow(a) {
        var c = this,
            b = this.chart,
            d = b.renderer,
            e = this.options,
            h = e.y,
            m = this.padding,
            b = b.spacingBox.height + ("top" === e.verticalAlign ? -h : h) - m,
            h = e.maxHeight,
            l,
            n = this.clipRect,
            t = e.navigation,
            p = w(t.animation, !0),
            r = t.arrowSize || 12,
            q = this.nav,
            A = this.pages,
            F,
            G = this.allItems,
            g = function g(a) {
          "number" === typeof a ? n.attr({ height: a }) : n && (c.clipRect = n.destroy(), c.contentGroup.clip());c.contentGroup.div && (c.contentGroup.div.style.clip = a ? "rect(" + m + "px,9999px," + (m + a) + "px,0)" : "auto");
        };"horizontal" !== e.layout || "middle" === e.verticalAlign || e.floating || (b /= 2);h && (b = Math.min(b, h));A.length = 0;a > b && !1 !== t.enabled ? (this.clipHeight = l = Math.max(b - 20 - this.titleHeight - m, 0), this.currentPage = w(this.currentPage, 1), this.fullHeight = a, f(G, function (a, b) {
          var c = a._legendItemPos[1],
              d = Math.round(a.legendItem.getBBox().height),
              g = A.length;if (!g || c - A[g - 1] > l && (F || c) !== A[g - 1]) A.push(F || c), g++;a.pageIx = g - 1;F && (G[b - 1].pageIx = g - 1);b === G.length - 1 && c + d - A[g - 1] > l && (A.push(c), a.pageIx = g);c !== F && (F = c);
        }), n || (n = c.clipRect = d.clipRect(0, m, 9999, 0), c.contentGroup.clip(n)), g(l), q || (this.nav = q = d.g().attr({ zIndex: 1 }).add(this.group), this.up = d.symbol("triangle", 0, 0, r, r).on("click", function () {
          c.scroll(-1, p);
        }).add(q), this.pager = d.text("", 15, 10).addClass("highcharts-legend-navigation").css(t.style).add(q), this.down = d.symbol("triangle-down", 0, 0, r, r).on("click", function () {
          c.scroll(1, p);
        }).add(q)), c.scroll(0), a = b) : q && (g(), this.nav = q.destroy(), this.scrollGroup.attr({ translateY: 1 }), this.clipHeight = 0);return a;
      }, scroll: function scroll(a, c) {
        var b = this.pages,
            d = b.length;a = this.currentPage + a;var e = this.clipHeight,
            h = this.options.navigation,
            f = this.pager,
            m = this.padding;a > d && (a = d);0 < a && (void 0 !== c && u(c, this.chart), this.nav.attr({ translateX: m, translateY: e + this.padding + 7 + this.titleHeight, visibility: "visible" }), this.up.attr({ "class": 1 === a ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" }), f.attr({ text: a + "/" + d }), this.down.attr({ x: 18 + this.pager.getBBox().width, "class": a === d ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" }), this.up.attr({ fill: 1 === a ? h.inactiveColor : h.activeColor }).css({ cursor: 1 === a ? "default" : "pointer" }), this.down.attr({ fill: a === d ? h.inactiveColor : h.activeColor }).css({ cursor: a === d ? "default" : "pointer" }), this.scrollOffset = -b[a - 1] + this.initialItemY, this.scrollGroup.animate({ translateY: this.scrollOffset }), this.currentPage = a, this.positionCheckboxes());
      } };a.LegendSymbolMixin = { drawRectangle: function drawRectangle(a, c) {
        var b = a.symbolHeight,
            d = a.options.squareSymbol;c.legendSymbol = this.chart.renderer.rect(d ? (a.symbolWidth - b) / 2 : 0, a.baseline - b + 1, d ? b : a.symbolWidth, b, w(a.options.symbolRadius, b / 2)).addClass("highcharts-point").attr({ zIndex: 3 }).add(c.legendGroup);
      },
      drawLineMarker: function drawLineMarker(a) {
        var c = this.options,
            b = c.marker,
            d = a.symbolWidth,
            e = a.symbolHeight,
            h = e / 2,
            f = this.chart.renderer,
            m = this.legendGroup;a = a.baseline - Math.round(.3 * a.fontMetrics.b);var l;l = { "stroke-width": c.lineWidth || 0 };c.dashStyle && (l.dashstyle = c.dashStyle);this.legendLine = f.path(["M", 0, a, "L", d, a]).addClass("highcharts-graph").attr(l).add(m);b && !1 !== b.enabled && (c = Math.min(w(b.radius, h), h), 0 === this.symbol.indexOf("url") && (b = n(b, { width: e, height: e }), c = 0), this.legendSymbol = b = f.symbol(this.symbol, d / 2 - c, a - c, 2 * c, 2 * c, b).addClass("highcharts-point").add(m), b.isMarker = !0);
      } };(/Trident\/7\.0/.test(h.navigator.userAgent) || l) && m(a.Legend.prototype, "positionItem", function (a, c) {
      var b = this,
          d = function d() {
        c._legendItemPos && a.call(b, c);
      };d();setTimeout(d);
    });
  })(M);(function (a) {
    var E = a.addEvent,
        D = a.animate,
        H = a.animObject,
        p = a.attr,
        f = a.doc,
        l = a.Axis,
        r = a.createElement,
        n = a.defaultOptions,
        w = a.discardElement,
        u = a.charts,
        e = a.css,
        h = a.defined,
        m = a.each,
        d = a.extend,
        c = a.find,
        b = a.fireEvent,
        k = a.grep,
        z = a.isNumber,
        B = a.isObject,
        I = a.isString,
        x = a.Legend,
        K = a.marginNames,
        t = a.merge,
        C = a.objectEach,
        N = a.Pointer,
        q = a.pick,
        A = a.pInt,
        F = a.removeEvent,
        G = a.seriesTypes,
        g = a.splat,
        v = a.svg,
        Q = a.syncTimeout,
        L = a.win,
        P = a.Chart = function () {
      this.getArgs.apply(this, arguments);
    };a.chart = function (a, b, c) {
      return new P(a, b, c);
    };d(P.prototype, { callbacks: [], getArgs: function getArgs() {
        var a = [].slice.call(arguments);if (I(a[0]) || a[0].nodeName) this.renderTo = a.shift();this.init(a[0], a[1]);
      }, init: function init(b, c) {
        var d,
            g,
            e = b.series,
            k = b.plotOptions || {};b.series = null;d = t(n, b);for (g in d.plotOptions) {
          d.plotOptions[g].tooltip = k[g] && t(k[g].tooltip) || void 0;
        }d.tooltip.userOptions = b.chart && b.chart.forExport && b.tooltip.userOptions || b.tooltip;d.series = b.series = e;this.userOptions = b;b = d.chart;g = b.events;this.margin = [];this.spacing = [];this.bounds = { h: {}, v: {} };this.labelCollectors = [];this.callback = c;this.isResizing = 0;this.options = d;this.axes = [];this.series = [];this.hasCartesianSeries = b.showAxes;var q = this;q.index = u.length;u.push(q);a.chartCount++;g && C(g, function (a, b) {
          E(q, b, a);
        });q.xAxis = [];q.yAxis = [];q.pointCount = q.colorCounter = q.symbolCounter = 0;q.firstRender();
      }, initSeries: function initSeries(b) {
        var c = this.options.chart;(c = G[b.type || c.type || c.defaultSeriesType]) || a.error(17, !0);c = new c();c.init(this, b);return c;
      }, orderSeries: function orderSeries(a) {
        var b = this.series;for (a = a || 0; a < b.length; a++) {
          b[a] && (b[a].index = a, b[a].name = b[a].name || "Series " + (b[a].index + 1));
        }
      }, isInsidePlot: function isInsidePlot(a, b, c) {
        var d = c ? b : a;a = c ? a : b;return 0 <= d && d <= this.plotWidth && 0 <= a && a <= this.plotHeight;
      }, redraw: function redraw(c) {
        var g = this.axes,
            e = this.series,
            k = this.pointer,
            q = this.legend,
            h = this.isDirtyLegend,
            f,
            l,
            v = this.hasCartesianSeries,
            A = this.isDirtyBox,
            F,
            t = this.renderer,
            x = t.isHidden(),
            n = [];this.setResponsive && this.setResponsive(!1);a.setAnimation(c, this);x && this.temporaryDisplay();this.layOutTitles();for (c = e.length; c--;) {
          if (F = e[c], F.options.stacking && (f = !0, F.isDirty)) {
            l = !0;break;
          }
        }if (l) for (c = e.length; c--;) {
          F = e[c], F.options.stacking && (F.isDirty = !0);
        }m(e, function (a) {
          a.isDirty && "point" === a.options.legendType && (a.updateTotals && a.updateTotals(), h = !0);a.isDirtyData && b(a, "updatedData");
        });h && q.options.enabled && (q.render(), this.isDirtyLegend = !1);f && this.getStacks();v && m(g, function (a) {
          a.updateNames();a.setScale();
        });this.getMargins();v && (m(g, function (a) {
          a.isDirty && (A = !0);
        }), m(g, function (a) {
          var c = a.min + "," + a.max;a.extKey !== c && (a.extKey = c, n.push(function () {
            b(a, "afterSetExtremes", d(a.eventArgs, a.getExtremes()));delete a.eventArgs;
          }));(A || f) && a.redraw();
        }));A && this.drawChartBox();b(this, "predraw");m(e, function (a) {
          (A || a.isDirty) && a.visible && a.redraw();a.isDirtyData = !1;
        });k && k.reset(!0);t.draw();b(this, "redraw");b(this, "render");x && this.temporaryDisplay(!0);m(n, function (a) {
          a.call();
        });
      }, get: function get(a) {
        function b(b) {
          return b.id === a || b.options && b.options.id === a;
        }var d,
            g = this.series,
            e;d = c(this.axes, b) || c(this.series, b);for (e = 0; !d && e < g.length; e++) {
          d = c(g[e].points || [], b);
        }return d;
      }, getAxes: function getAxes() {
        var a = this,
            b = this.options,
            c = b.xAxis = g(b.xAxis || {}),
            b = b.yAxis = g(b.yAxis || {});m(c, function (a, b) {
          a.index = b;a.isX = !0;
        });m(b, function (a, b) {
          a.index = b;
        });c = c.concat(b);m(c, function (b) {
          new l(a, b);
        });
      }, getSelectedPoints: function getSelectedPoints() {
        var a = [];m(this.series, function (b) {
          a = a.concat(k(b.data || [], function (a) {
            return a.selected;
          }));
        });return a;
      }, getSelectedSeries: function getSelectedSeries() {
        return k(this.series, function (a) {
          return a.selected;
        });
      }, setTitle: function setTitle(a, b, c) {
        var d = this,
            g = d.options,
            e;e = g.title = t({ style: { color: "#333333", fontSize: g.isStock ? "16px" : "18px" } }, g.title, a);g = g.subtitle = t({ style: { color: "#666666" } }, g.subtitle, b);m([["title", a, e], ["subtitle", b, g]], function (a, b) {
          var c = a[0],
              g = d[c],
              e = a[1];a = a[2];g && e && (d[c] = g = g.destroy());a && !g && (d[c] = d.renderer.text(a.text, 0, 0, a.useHTML).attr({ align: a.align, "class": "highcharts-" + c, zIndex: a.zIndex || 4 }).add(), d[c].update = function (a) {
            d.setTitle(!b && a, b && a);
          }, d[c].css(a.style));
        });d.layOutTitles(c);
      }, layOutTitles: function layOutTitles(a) {
        var b = 0,
            c,
            g = this.renderer,
            e = this.spacingBox;m(["title", "subtitle"], function (a) {
          var c = this[a],
              k = this.options[a];a = "title" === a ? -3 : k.verticalAlign ? 0 : b + 2;var q;c && (q = k.style.fontSize, q = g.fontMetrics(q, c).b, c.css({ width: (k.width || e.width + k.widthAdjust) + "px" }).align(d({ y: a + q }, k), !1, "spacingBox"), k.floating || k.verticalAlign || (b = Math.ceil(b + c.getBBox(k.useHTML).height)));
        }, this);c = this.titleOffset !== b;this.titleOffset = b;!this.isDirtyBox && c && (this.isDirtyBox = c, this.hasRendered && q(a, !0) && this.isDirtyBox && this.redraw());
      }, getChartSize: function getChartSize() {
        var b = this.options.chart,
            c = b.width,
            b = b.height,
            d = this.renderTo;h(c) || (this.containerWidth = a.getStyle(d, "width"));h(b) || (this.containerHeight = a.getStyle(d, "height"));this.chartWidth = Math.max(0, c || this.containerWidth || 600);this.chartHeight = Math.max(0, a.relativeLength(b, this.chartWidth) || (1 < this.containerHeight ? this.containerHeight : 400));
      }, temporaryDisplay: function temporaryDisplay(b) {
        var c = this.renderTo;if (b) for (; c && c.style;) {
          c.hcOrigStyle && (a.css(c, c.hcOrigStyle), delete c.hcOrigStyle), c.hcOrigDetached && (f.body.removeChild(c), c.hcOrigDetached = !1), c = c.parentNode;
        } else for (; c && c.style;) {
          f.body.contains(c) || c.parentNode || (c.hcOrigDetached = !0, f.body.appendChild(c));if ("none" === a.getStyle(c, "display", !1) || c.hcOricDetached) c.hcOrigStyle = { display: c.style.display, height: c.style.height, overflow: c.style.overflow }, b = { display: "block", overflow: "hidden" }, c !== this.renderTo && (b.height = 0), a.css(c, b), c.offsetWidth || c.style.setProperty("display", "block", "important");c = c.parentNode;if (c === f.body) break;
        }
      }, setClassName: function setClassName(a) {
        this.container.className = "highcharts-container " + (a || "");
      }, getContainer: function getContainer() {
        var b,
            c = this.options,
            g = c.chart,
            e,
            k;b = this.renderTo;var q = a.uniqueKey(),
            h;b || (this.renderTo = b = g.renderTo);I(b) && (this.renderTo = b = f.getElementById(b));b || a.error(13, !0);e = A(p(b, "data-highcharts-chart"));z(e) && u[e] && u[e].hasRendered && u[e].destroy();p(b, "data-highcharts-chart", this.index);b.innerHTML = "";g.skipClone || b.offsetWidth || this.temporaryDisplay();this.getChartSize();e = this.chartWidth;k = this.chartHeight;h = d({ position: "relative", overflow: "hidden", width: e + "px", height: k + "px", textAlign: "left", lineHeight: "normal", zIndex: 0, "-webkit-tap-highlight-color": "rgba(0,0,0,0)" }, g.style);this.container = b = r("div", { id: q }, h, b);this._cursor = b.style.cursor;this.renderer = new (a[g.renderer] || a.Renderer)(b, e, k, null, g.forExport, c.exporting && c.exporting.allowHTML);this.setClassName(g.className);this.renderer.setStyle(g.style);this.renderer.chartIndex = this.index;
      }, getMargins: function getMargins(a) {
        var b = this.spacing,
            c = this.margin,
            d = this.titleOffset;this.resetMargins();d && !h(c[0]) && (this.plotTop = Math.max(this.plotTop, d + this.options.title.margin + b[0]));this.legend && this.legend.display && this.legend.adjustMargins(c, b);this.extraMargin && (this[this.extraMargin.type] = (this[this.extraMargin.type] || 0) + this.extraMargin.value);this.adjustPlotArea && this.adjustPlotArea();a || this.getAxisMargins();
      }, getAxisMargins: function getAxisMargins() {
        var a = this,
            b = a.axisOffset = [0, 0, 0, 0],
            c = a.margin;a.hasCartesianSeries && m(a.axes, function (a) {
          a.visible && a.getOffset();
        });m(K, function (d, g) {
          h(c[g]) || (a[d] += b[g]);
        });a.setChartSize();
      }, reflow: function reflow(b) {
        var c = this,
            d = c.options.chart,
            g = c.renderTo,
            e = h(d.width) && h(d.height),
            k = d.width || a.getStyle(g, "width"),
            d = d.height || a.getStyle(g, "height"),
            g = b ? b.target : L;if (!e && !c.isPrinting && k && d && (g === L || g === f)) {
          if (k !== c.containerWidth || d !== c.containerHeight) clearTimeout(c.reflowTimeout), c.reflowTimeout = Q(function () {
            c.container && c.setSize(void 0, void 0, !1);
          }, b ? 100 : 0);c.containerWidth = k;c.containerHeight = d;
        }
      }, initReflow: function initReflow() {
        var a = this,
            b;b = E(L, "resize", function (b) {
          a.reflow(b);
        });E(a, "destroy", b);
      }, setSize: function setSize(c, d, g) {
        var k = this,
            q = k.renderer;k.isResizing += 1;a.setAnimation(g, k);k.oldChartHeight = k.chartHeight;k.oldChartWidth = k.chartWidth;void 0 !== c && (k.options.chart.width = c);void 0 !== d && (k.options.chart.height = d);k.getChartSize();c = q.globalAnimation;(c ? D : e)(k.container, { width: k.chartWidth + "px", height: k.chartHeight + "px" }, c);k.setChartSize(!0);q.setSize(k.chartWidth, k.chartHeight, g);m(k.axes, function (a) {
          a.isDirty = !0;a.setScale();
        });k.isDirtyLegend = !0;k.isDirtyBox = !0;k.layOutTitles();k.getMargins();k.redraw(g);k.oldChartHeight = null;b(k, "resize");Q(function () {
          k && b(k, "endResize", null, function () {
            --k.isResizing;
          });
        }, H(c).duration);
      }, setChartSize: function setChartSize(a) {
        var b = this.inverted,
            c = this.renderer,
            d = this.chartWidth,
            g = this.chartHeight,
            e = this.options.chart,
            k = this.spacing,
            q = this.clipOffset,
            h,
            f,
            l,
            v;this.plotLeft = h = Math.round(this.plotLeft);this.plotTop = f = Math.round(this.plotTop);this.plotWidth = l = Math.max(0, Math.round(d - h - this.marginRight));this.plotHeight = v = Math.max(0, Math.round(g - f - this.marginBottom));this.plotSizeX = b ? v : l;this.plotSizeY = b ? l : v;this.plotBorderWidth = e.plotBorderWidth || 0;this.spacingBox = c.spacingBox = { x: k[3], y: k[0], width: d - k[3] - k[1], height: g - k[0] - k[2] };this.plotBox = c.plotBox = { x: h, y: f, width: l, height: v };d = 2 * Math.floor(this.plotBorderWidth / 2);b = Math.ceil(Math.max(d, q[3]) / 2);c = Math.ceil(Math.max(d, q[0]) / 2);this.clipBox = { x: b, y: c, width: Math.floor(this.plotSizeX - Math.max(d, q[1]) / 2 - b), height: Math.max(0, Math.floor(this.plotSizeY - Math.max(d, q[2]) / 2 - c)) };a || m(this.axes, function (a) {
          a.setAxisSize();a.setAxisTranslation();
        });
      }, resetMargins: function resetMargins() {
        var a = this,
            b = a.options.chart;m(["margin", "spacing"], function (c) {
          var d = b[c],
              g = B(d) ? d : [d, d, d, d];m(["Top", "Right", "Bottom", "Left"], function (d, e) {
            a[c][e] = q(b[c + d], g[e]);
          });
        });m(K, function (b, c) {
          a[b] = q(a.margin[c], a.spacing[c]);
        });a.axisOffset = [0, 0, 0, 0];a.clipOffset = [0, 0, 0, 0];
      }, drawChartBox: function drawChartBox() {
        var a = this.options.chart,
            b = this.renderer,
            c = this.chartWidth,
            d = this.chartHeight,
            g = this.chartBackground,
            e = this.plotBackground,
            k = this.plotBorder,
            q,
            h = this.plotBGImage,
            f = a.backgroundColor,
            m = a.plotBackgroundColor,
            l = a.plotBackgroundImage,
            v,
            A = this.plotLeft,
            F = this.plotTop,
            t = this.plotWidth,
            x = this.plotHeight,
            n = this.plotBox,
            p = this.clipRect,
            z = this.clipBox,
            G = "animate";g || (this.chartBackground = g = b.rect().addClass("highcharts-background").add(), G = "attr");q = a.borderWidth || 0;v = q + (a.shadow ? 8 : 0);f = { fill: f || "none" };if (q || g["stroke-width"]) f.stroke = a.borderColor, f["stroke-width"] = q;g.attr(f).shadow(a.shadow);g[G]({ x: v / 2, y: v / 2, width: c - v - q % 2, height: d - v - q % 2, r: a.borderRadius });G = "animate";e || (G = "attr", this.plotBackground = e = b.rect().addClass("highcharts-plot-background").add());e[G](n);e.attr({ fill: m || "none" }).shadow(a.plotShadow);l && (h ? h.animate(n) : this.plotBGImage = b.image(l, A, F, t, x).add());p ? p.animate({ width: z.width, height: z.height }) : this.clipRect = b.clipRect(z);G = "animate";k || (G = "attr", this.plotBorder = k = b.rect().addClass("highcharts-plot-border").attr({ zIndex: 1 }).add());k.attr({ stroke: a.plotBorderColor, "stroke-width": a.plotBorderWidth || 0, fill: "none" });k[G](k.crisp({ x: A, y: F, width: t, height: x }, -k.strokeWidth()));this.isDirtyBox = !1;
      }, propFromSeries: function propFromSeries() {
        var a = this,
            b = a.options.chart,
            c,
            d = a.options.series,
            g,
            e;m(["inverted", "angular", "polar"], function (k) {
          c = G[b.type || b.defaultSeriesType];e = b[k] || c && c.prototype[k];for (g = d && d.length; !e && g--;) {
            (c = G[d[g].type]) && c.prototype[k] && (e = !0);
          }a[k] = e;
        });
      }, linkSeries: function linkSeries() {
        var a = this,
            b = a.series;m(b, function (a) {
          a.linkedSeries.length = 0;
        });m(b, function (b) {
          var c = b.options.linkedTo;I(c) && (c = ":previous" === c ? a.series[b.index - 1] : a.get(c)) && c.linkedParent !== b && (c.linkedSeries.push(b), b.linkedParent = c, b.visible = q(b.options.visible, c.options.visible, b.visible));
        });
      }, renderSeries: function renderSeries() {
        m(this.series, function (a) {
          a.translate();a.render();
        });
      }, renderLabels: function renderLabels() {
        var a = this,
            b = a.options.labels;b.items && m(b.items, function (c) {
          var g = d(b.style, c.style),
              e = A(g.left) + a.plotLeft,
              k = A(g.top) + a.plotTop + 12;delete g.left;delete g.top;a.renderer.text(c.html, e, k).attr({ zIndex: 2 }).css(g).add();
        });
      }, render: function render() {
        var a = this.axes,
            b = this.renderer,
            c = this.options,
            d,
            g,
            e;this.setTitle();this.legend = new x(this, c.legend);this.getStacks && this.getStacks();this.getMargins(!0);this.setChartSize();c = this.plotWidth;d = this.plotHeight = Math.max(this.plotHeight - 21, 0);m(a, function (a) {
          a.setScale();
        });this.getAxisMargins();g = 1.1 < c / this.plotWidth;e = 1.05 < d / this.plotHeight;if (g || e) m(a, function (a) {
          (a.horiz && g || !a.horiz && e) && a.setTickInterval(!0);
        }), this.getMargins();this.drawChartBox();this.hasCartesianSeries && m(a, function (a) {
          a.visible && a.render();
        });this.seriesGroup || (this.seriesGroup = b.g("series-group").attr({ zIndex: 3 }).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive && this.setResponsive();this.hasRendered = !0;
      }, addCredits: function addCredits(a) {
        var b = this;a = t(!0, this.options.credits, a);a.enabled && !this.credits && (this.credits = this.renderer.text(a.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function () {
          a.href && (L.location.href = a.href);
        }).attr({ align: a.position.align, zIndex: 8 }).css(a.style).add().align(a.position), this.credits.update = function (a) {
          b.credits = b.credits.destroy();b.addCredits(a);
        });
      }, destroy: function destroy() {
        var c = this,
            d = c.axes,
            g = c.series,
            e = c.container,
            k,
            q = e && e.parentNode;b(c, "destroy");c.renderer.forExport ? a.erase(u, c) : u[c.index] = void 0;a.chartCount--;c.renderTo.removeAttribute("data-highcharts-chart");F(c);for (k = d.length; k--;) {
          d[k] = d[k].destroy();
        }this.scroller && this.scroller.destroy && this.scroller.destroy();for (k = g.length; k--;) {
          g[k] = g[k].destroy();
        }m("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "), function (a) {
          var b = c[a];b && b.destroy && (c[a] = b.destroy());
        });e && (e.innerHTML = "", F(e), q && w(e));C(c, function (a, b) {
          delete c[b];
        });
      }, isReadyToRender: function isReadyToRender() {
        var a = this;return v || L != L.top || "complete" === f.readyState ? !0 : (f.attachEvent("onreadystatechange", function () {
          f.detachEvent("onreadystatechange", a.firstRender);"complete" === f.readyState && a.firstRender();
        }), !1);
      }, firstRender: function firstRender() {
        var a = this,
            c = a.options;if (a.isReadyToRender()) {
          a.getContainer();b(a, "init");a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();m(c.series || [], function (b) {
            a.initSeries(b);
          });a.linkSeries();b(a, "beforeRender");N && (a.pointer = new N(a, c));a.render();if (!a.renderer.imgCount && a.onload) a.onload();a.temporaryDisplay(!0);
        }
      }, onload: function onload() {
        m([this.callback].concat(this.callbacks), function (a) {
          a && void 0 !== this.index && a.apply(this, [this]);
        }, this);b(this, "load");b(this, "render");h(this.index) && !1 !== this.options.chart.reflow && this.initReflow();this.onload = null;
      } });
  })(M);(function (a) {
    var E,
        D = a.each,
        H = a.extend,
        p = a.erase,
        f = a.fireEvent,
        l = a.format,
        r = a.isArray,
        n = a.isNumber,
        w = a.pick,
        u = a.removeEvent;a.Point = E = function E() {};a.Point.prototype = { init: function init(a, h, f) {
        this.series = a;this.color = a.color;this.applyOptions(h, f);a.options.colorByPoint ? (h = a.options.colors || a.chart.options.colors, this.color = this.color || h[a.colorCounter], h = h.length, f = a.colorCounter, a.colorCounter++, a.colorCounter === h && (a.colorCounter = 0)) : f = a.colorIndex;this.colorIndex = w(this.colorIndex, f);a.chart.pointCount++;return this;
      }, applyOptions: function applyOptions(a, h) {
        var e = this.series,
            d = e.options.pointValKey || e.pointValKey;a = E.prototype.optionsToObject.call(this, a);H(this, a);this.options = this.options ? H(this.options, a) : a;a.group && delete this.group;d && (this.y = this[d]);this.isNull = w(this.isValid && !this.isValid(), null === this.x || !n(this.y, !0));this.selected && (this.state = "select");"name" in this && void 0 === h && e.xAxis && e.xAxis.hasNames && (this.x = e.xAxis.nameToX(this));void 0 === this.x && e && (this.x = void 0 === h ? e.autoIncrement(this) : h);return this;
      }, optionsToObject: function optionsToObject(a) {
        var e = {},
            f = this.series,
            d = f.options.keys,
            c = d || f.pointArrayMap || ["y"],
            b = c.length,
            k = 0,
            l = 0;if (n(a) || null === a) e[c[0]] = a;else if (r(a)) for (!d && a.length > b && (f = _typeof(a[0]), "string" === f ? e.name = a[0] : "number" === f && (e.x = a[0]), k++); l < b;) {
          d && void 0 === a[k] || (e[c[l]] = a[k]), k++, l++;
        } else "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && (e = a, a.dataLabels && (f._hasPointLabels = !0), a.marker && (f._hasPointMarkers = !0));return e;
      }, getClassName: function getClassName() {
        return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (void 0 !== this.colorIndex ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
      }, getZone: function getZone() {
        var a = this.series,
            h = a.zones,
            a = a.zoneAxis || "y",
            f = 0,
            d;for (d = h[f]; this[a] >= d.value;) {
          d = h[++f];
        }d && d.color && !this.options.color && (this.color = d.color);return d;
      }, destroy: function destroy() {
        var a = this.series.chart,
            h = a.hoverPoints,
            f;a.pointCount--;h && (this.setState(), p(h, this), h.length || (a.hoverPoints = null));if (this === a.hoverPoint) this.onMouseOut();if (this.graphic || this.dataLabel) u(this), this.destroyElements();this.legendItem && a.legend.destroyItem(this);for (f in this) {
          this[f] = null;
        }
      }, destroyElements: function destroyElements() {
        for (var a = ["graphic", "dataLabel", "dataLabelUpper", "connector", "shadowGroup"], h, f = 6; f--;) {
          h = a[f], this[h] && (this[h] = this[h].destroy());
        }
      }, getLabelConfig: function getLabelConfig() {
        return { x: this.category, y: this.y, color: this.color, colorIndex: this.colorIndex, key: this.name || this.category, series: this.series, point: this, percentage: this.percentage, total: this.total || this.stackTotal };
      }, tooltipFormatter: function tooltipFormatter(a) {
        var e = this.series,
            f = e.tooltipOptions,
            d = w(f.valueDecimals, ""),
            c = f.valuePrefix || "",
            b = f.valueSuffix || "";D(e.pointArrayMap || ["y"], function (e) {
          e = "{point." + e;if (c || b) a = a.replace(e + "}", c + e + "}" + b);a = a.replace(e + "}", e + ":,." + d + "f}");
        });return l(a, { point: this, series: this.series });
      }, firePointEvent: function firePointEvent(a, h, m) {
        var d = this,
            c = this.series.options;(c.point.events[a] || d.options && d.options.events && d.options.events[a]) && this.importEvents();"click" === a && c.allowPointSelect && (m = function m(a) {
          d.select && d.select(null, a.ctrlKey || a.metaKey || a.shiftKey);
        });f(this, a, h, m);
      }, visible: !0 };
  })(M);(function (a) {
    var E = a.addEvent,
        D = a.animObject,
        H = a.arrayMax,
        p = a.arrayMin,
        f = a.correctFloat,
        l = a.Date,
        r = a.defaultOptions,
        n = a.defaultPlotOptions,
        w = a.defined,
        u = a.each,
        e = a.erase,
        h = a.extend,
        m = a.fireEvent,
        d = a.grep,
        c = a.isArray,
        b = a.isNumber,
        k = a.isString,
        z = a.merge,
        B = a.objectEach,
        I = a.pick,
        x = a.removeEvent,
        K = a.splat,
        t = a.SVGElement,
        C = a.syncTimeout,
        N = a.win;a.Series = a.seriesType("line", null, { lineWidth: 2, allowPointSelect: !1, showCheckbox: !1, animation: { duration: 1E3 }, events: {}, marker: { lineWidth: 0, lineColor: "#ffffff", radius: 4, states: { hover: { animation: { duration: 50 }, enabled: !0, radiusPlus: 2, lineWidthPlus: 1 }, select: { fillColor: "#cccccc",
            lineColor: "#000000", lineWidth: 2 } } }, point: { events: {} }, dataLabels: { align: "center", formatter: function formatter() {
          return null === this.y ? "" : a.numberFormat(this.y, -1);
        }, style: { fontSize: "11px", fontWeight: "bold", color: "contrast", textOutline: "1px contrast" }, verticalAlign: "bottom", x: 0, y: 0, padding: 5 }, cropThreshold: 300, pointRange: 0, softThreshold: !0, states: { hover: { animation: { duration: 50 }, lineWidthPlus: 1, marker: {}, halo: { size: 10, opacity: .25 } }, select: { marker: {} } }, stickyTracking: !0, turboThreshold: 1E3, findNearestPointBy: "x" }, { isCartesian: !0, pointClass: a.Point, sorted: !0, requireSorting: !0, directTouch: !1, axisTypes: ["xAxis", "yAxis"], colorCounter: 0, parallelArrays: ["x", "y"], coll: "series", init: function init(a, b) {
        var c = this,
            d,
            g = a.series,
            e;c.chart = a;c.options = b = c.setOptions(b);c.linkedSeries = [];c.bindAxes();h(c, { name: b.name, state: "", visible: !1 !== b.visible, selected: !0 === b.selected });d = b.events;B(d, function (a, b) {
          E(c, b, a);
        });if (d && d.click || b.point && b.point.events && b.point.events.click || b.allowPointSelect) a.runTrackerClick = !0;c.getColor();
        c.getSymbol();u(c.parallelArrays, function (a) {
          c[a + "Data"] = [];
        });c.setData(b.data, !1);c.isCartesian && (a.hasCartesianSeries = !0);g.length && (e = g[g.length - 1]);c._i = I(e && e._i, -1) + 1;a.orderSeries(this.insert(g));
      }, insert: function insert(a) {
        var c = this.options.index,
            d;if (b(c)) {
          for (d = a.length; d--;) {
            if (c >= I(a[d].options.index, a[d]._i)) {
              a.splice(d + 1, 0, this);break;
            }
          }-1 === d && a.unshift(this);d += 1;
        } else a.push(this);return I(d, a.length - 1);
      }, bindAxes: function bindAxes() {
        var b = this,
            c = b.options,
            d = b.chart,
            e;u(b.axisTypes || [], function (g) {
          u(d[g], function (a) {
            e = a.options;if (c[g] === e.index || void 0 !== c[g] && c[g] === e.id || void 0 === c[g] && 0 === e.index) b.insert(a.series), b[g] = a, a.isDirty = !0;
          });b[g] || b.optionalAxis === g || a.error(18, !0);
        });
      }, updateParallelArrays: function updateParallelArrays(a, c) {
        var d = a.series,
            e = arguments,
            g = b(c) ? function (b) {
          var g = "y" === b && d.toYData ? d.toYData(a) : a[b];d[b + "Data"][c] = g;
        } : function (a) {
          Array.prototype[c].apply(d[a + "Data"], Array.prototype.slice.call(e, 2));
        };u(d.parallelArrays, g);
      }, autoIncrement: function autoIncrement() {
        var b = this.options,
            c = this.xIncrement,
            d,
            e = b.pointIntervalUnit,
            g = 0,
            c = I(c, b.pointStart, 0);this.pointInterval = d = I(this.pointInterval, b.pointInterval, 1);e && (b = new l(c), "day" === e ? b = +b[l.hcSetDate](b[l.hcGetDate]() + d) : "month" === e ? b = +b[l.hcSetMonth](b[l.hcGetMonth]() + d) : "year" === e && (b = +b[l.hcSetFullYear](b[l.hcGetFullYear]() + d)), l.hcHasTimeZone && (g = a.getTZOffset(b) - a.getTZOffset(c)), d = b - c + g);this.xIncrement = c + d;return c;
      }, setOptions: function setOptions(a) {
        var b = this.chart,
            c = b.options,
            d = c.plotOptions,
            g = (b.userOptions || {}).plotOptions || {},
            e = d[this.type];this.userOptions = a;b = z(e, d.series, a);this.tooltipOptions = z(r.tooltip, r.plotOptions.series && r.plotOptions.series.tooltip, r.plotOptions[this.type].tooltip, c.tooltip.userOptions, d.series && d.series.tooltip, d[this.type].tooltip, a.tooltip);this.stickyTracking = I(a.stickyTracking, g[this.type] && g[this.type].stickyTracking, g.series && g.series.stickyTracking, this.tooltipOptions.shared && !this.noSharedTooltip ? !0 : b.stickyTracking);null === e.marker && delete b.marker;this.zoneAxis = b.zoneAxis;a = this.zones = (b.zones || []).slice();!b.negativeColor && !b.negativeFillColor || b.zones || a.push({ value: b[this.zoneAxis + "Threshold"] || b.threshold || 0, className: "highcharts-negative", color: b.negativeColor, fillColor: b.negativeFillColor });a.length && w(a[a.length - 1].value) && a.push({ color: this.color, fillColor: this.fillColor });return b;
      }, getCyclic: function getCyclic(a, b, c) {
        var d,
            g = this.chart,
            e = this.userOptions,
            k = a + "Index",
            h = a + "Counter",
            q = c ? c.length : I(g.options.chart[a + "Count"], g[a + "Count"]);b || (d = I(e[k], e["_" + k]), w(d) || (g.series.length || (g[h] = 0), e["_" + k] = d = g[h] % q, g[h] += 1), c && (b = c[d]));void 0 !== d && (this[k] = d);this[a] = b;
      }, getColor: function getColor() {
        this.options.colorByPoint ? this.options.color = null : this.getCyclic("color", this.options.color || n[this.type].color, this.chart.options.colors);
      }, getSymbol: function getSymbol() {
        this.getCyclic("symbol", this.options.marker.symbol, this.chart.options.symbols);
      }, drawLegendSymbol: a.LegendSymbolMixin.drawLineMarker, setData: function setData(d, e, h, f) {
        var g = this,
            q = g.points,
            m = q && q.length || 0,
            l,
            A = g.options,
            t = g.chart,
            x = null,
            n = g.xAxis,
            p = A.turboThreshold,
            z = this.xData,
            F = this.yData,
            C = (l = g.pointArrayMap) && l.length;d = d || [];l = d.length;e = I(e, !0);if (!1 !== f && l && m === l && !g.cropped && !g.hasGroupedData && g.visible) u(d, function (a, b) {
          q[b].update && a !== A.data[b] && q[b].update(a, !1, null, !1);
        });else {
          g.xIncrement = null;g.colorCounter = 0;u(this.parallelArrays, function (a) {
            g[a + "Data"].length = 0;
          });if (p && l > p) {
            for (h = 0; null === x && h < l;) {
              x = d[h], h++;
            }if (b(x)) for (h = 0; h < l; h++) {
              z[h] = this.autoIncrement(), F[h] = d[h];
            } else if (c(x)) {
              if (C) for (h = 0; h < l; h++) {
                x = d[h], z[h] = x[0], F[h] = x.slice(1, C + 1);
              } else for (h = 0; h < l; h++) {
                x = d[h], z[h] = x[0], F[h] = x[1];
              }
            } else a.error(12);
          } else for (h = 0; h < l; h++) {
            void 0 !== d[h] && (x = { series: g }, g.pointClass.prototype.applyOptions.apply(x, [d[h]]), g.updateParallelArrays(x, h));
          }F && k(F[0]) && a.error(14, !0);g.data = [];g.options.data = g.userOptions.data = d;for (h = m; h--;) {
            q[h] && q[h].destroy && q[h].destroy();
          }n && (n.minRange = n.userMinRange);g.isDirty = t.isDirtyBox = !0;g.isDirtyData = !!q;h = !1;
        }"point" === A.legendType && (this.processData(), this.generatePoints());e && t.redraw(h);
      }, processData: function processData(b) {
        var c = this.xData,
            d = this.yData,
            e = c.length,
            g;g = 0;var k,
            h,
            q = this.xAxis,
            f,
            m = this.options;f = m.cropThreshold;var l = this.getExtremesFromAll || m.getExtremesFromAll,
            t = this.isCartesian,
            m = q && q.val2lin,
            x = q && q.isLog,
            n = this.requireSorting,
            p,
            z;if (t && !this.isDirty && !q.isDirty && !this.yAxis.isDirty && !b) return !1;q && (b = q.getExtremes(), p = b.min, z = b.max);if (t && this.sorted && !l && (!f || e > f || this.forceCrop)) if (c[e - 1] < p || c[0] > z) c = [], d = [];else if (c[0] < p || c[e - 1] > z) g = this.cropData(this.xData, this.yData, p, z), c = g.xData, d = g.yData, g = g.start, k = !0;for (f = c.length || 1; --f;) {
          e = x ? m(c[f]) - m(c[f - 1]) : c[f] - c[f - 1], 0 < e && (void 0 === h || e < h) ? h = e : 0 > e && n && (a.error(15), n = !1);
        }this.cropped = k;this.cropStart = g;this.processedXData = c;this.processedYData = d;this.closestPointRange = h;
      }, cropData: function cropData(a, b, c, d) {
        var g = a.length,
            e = 0,
            k = g,
            h = I(this.cropShoulder, 1),
            f;for (f = 0; f < g; f++) {
          if (a[f] >= c) {
            e = Math.max(0, f - h);break;
          }
        }for (c = f; c < g; c++) {
          if (a[c] > d) {
            k = c + h;break;
          }
        }return { xData: a.slice(e, k), yData: b.slice(e, k), start: e, end: k };
      }, generatePoints: function generatePoints() {
        var a = this.options,
            b = a.data,
            c = this.data,
            d,
            g = this.processedXData,
            e = this.processedYData,
            k = this.pointClass,
            h = g.length,
            f = this.cropStart || 0,
            m,
            l = this.hasGroupedData,
            a = a.keys,
            t,
            x = [],
            n;c || l || (c = [], c.length = b.length, c = this.data = c);a && l && (this.options.keys = !1);for (n = 0; n < h; n++) {
          m = f + n, l ? (t = new k().init(this, [g[n]].concat(K(e[n]))), t.dataGroup = this.groupMap[n]) : (t = c[m]) || void 0 === b[m] || (c[m] = t = new k().init(this, b[m], g[n])), t && (t.index = m, x[n] = t);
        }this.options.keys = a;if (c && (h !== (d = c.length) || l)) for (n = 0; n < d; n++) {
          n !== f || l || (n += h), c[n] && (c[n].destroyElements(), c[n].plotX = void 0);
        }this.data = c;this.points = x;
      }, getExtremes: function getExtremes(a) {
        var d = this.yAxis,
            e = this.processedXData,
            k,
            g = [],
            h = 0;k = this.xAxis.getExtremes();var f = k.min,
            q = k.max,
            m,
            l,
            t,
            n;a = a || this.stackedYData || this.processedYData || [];k = a.length;for (n = 0; n < k; n++) {
          if (l = e[n], t = a[n], m = (b(t, !0) || c(t)) && (!d.positiveValuesOnly || t.length || 0 < t), l = this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || (e[n + 1] || l) >= f && (e[n - 1] || l) <= q, m && l) if (m = t.length) for (; m--;) {
            "number" === typeof t[m] && (g[h++] = t[m]);
          } else g[h++] = t;
        }this.dataMin = p(g);this.dataMax = H(g);
      }, translate: function translate() {
        this.processedXData || this.processData();this.generatePoints();var a = this.options,
            c = a.stacking,
            d = this.xAxis,
            e = d.categories,
            g = this.yAxis,
            k = this.points,
            h = k.length,
            m = !!this.modifyValue,
            l = a.pointPlacement,
            t = "between" === l || b(l),
            n = a.threshold,
            x = a.startFromThreshold ? n : 0,
            p,
            z,
            C,
            r,
            u = Number.MAX_VALUE;"between" === l && (l = .5);b(l) && (l *= I(a.pointRange || d.pointRange));for (a = 0; a < h; a++) {
          var B = k[a],
              N = B.x,
              K = B.y;z = B.low;var D = c && g.stacks[(this.negStacks && K < (x ? 0 : n) ? "-" : "") + this.stackKey],
              E;g.positiveValuesOnly && null !== K && 0 >= K && (B.isNull = !0);B.plotX = p = f(Math.min(Math.max(-1E5, d.translate(N, 0, 0, 0, 1, l, "flags" === this.type)), 1E5));c && this.visible && !B.isNull && D && D[N] && (r = this.getStackIndicator(r, N, this.index), E = D[N], K = E.points[r.key], z = K[0], K = K[1], z === x && r.key === D[N].base && (z = I(n, g.min)), g.positiveValuesOnly && 0 >= z && (z = null), B.total = B.stackTotal = E.total, B.percentage = E.total && B.y / E.total * 100, B.stackY = K, E.setOffset(this.pointXOffset || 0, this.barW || 0));B.yBottom = w(z) ? g.translate(z, 0, 1, 0, 1) : null;m && (K = this.modifyValue(K, B));B.plotY = z = "number" === typeof K && Infinity !== K ? Math.min(Math.max(-1E5, g.translate(K, 0, 1, 0, 1)), 1E5) : void 0;B.isInside = void 0 !== z && 0 <= z && z <= g.len && 0 <= p && p <= d.len;B.clientX = t ? f(d.translate(N, 0, 0, 0, 1, l)) : p;B.negative = B.y < (n || 0);B.category = e && void 0 !== e[B.x] ? e[B.x] : B.x;B.isNull || (void 0 !== C && (u = Math.min(u, Math.abs(p - C))), C = p);B.zone = this.zones.length && B.getZone();
        }this.closestPointRangePx = u;
      }, getValidPoints: function getValidPoints(a, b) {
        var c = this.chart;return d(a || this.points || [], function (a) {
          return b && !c.isInsidePlot(a.plotX, a.plotY, c.inverted) ? !1 : !a.isNull;
        });
      }, setClip: function setClip(a) {
        var b = this.chart,
            c = this.options,
            d = b.renderer,
            g = b.inverted,
            e = this.clipBox,
            k = e || b.clipBox,
            h = this.sharedClipKey || ["_sharedClip", a && a.duration, a && a.easing, k.height, c.xAxis, c.yAxis].join(),
            f = b[h],
            q = b[h + "m"];f || (a && (k.width = 0, g && (k.x = b.plotSizeX), b[h + "m"] = q = d.clipRect(g ? b.plotSizeX + 99 : -99, g ? -b.plotLeft : -b.plotTop, 99, g ? b.chartWidth : b.chartHeight)), b[h] = f = d.clipRect(k), f.count = { length: 0 });a && !f.count[this.index] && (f.count[this.index] = !0, f.count.length += 1);!1 !== c.clip && (this.group.clip(a || e ? f : b.clipRect), this.markerGroup.clip(q), this.sharedClipKey = h);a || (f.count[this.index] && (delete f.count[this.index], --f.count.length), 0 === f.count.length && h && b[h] && (e || (b[h] = b[h].destroy()), b[h + "m"] && (b[h + "m"] = b[h + "m"].destroy())));
      }, animate: function animate(a) {
        var b = this.chart,
            c = D(this.options.animation),
            d;a ? this.setClip(c) : (d = this.sharedClipKey, (a = b[d]) && a.animate({ width: b.plotSizeX, x: 0 }, c), b[d + "m"] && b[d + "m"].animate({ width: b.plotSizeX + 99, x: 0 }, c), this.animate = null);
      }, afterAnimate: function afterAnimate() {
        this.setClip();m(this, "afterAnimate");this.finishedAnimating = !0;
      }, drawPoints: function drawPoints() {
        var a = this.points,
            b = this.chart,
            c,
            d,
            g,
            e,
            k = this.options.marker,
            h,
            f,
            l,
            m = this[this.specialGroup] || this.markerGroup,
            t,
            n = I(k.enabled, this.xAxis.isRadial ? !0 : null, this.closestPointRangePx >= 2 * k.radius);if (!1 !== k.enabled || this._hasPointMarkers) for (c = 0; c < a.length; c++) {
          d = a[c], e = d.graphic, h = d.marker || {}, f = !!d.marker, g = n && void 0 === h.enabled || h.enabled, l = d.isInside, g && !d.isNull ? (g = I(h.symbol, this.symbol), d.hasImage = 0 === g.indexOf("url"), t = this.markerAttribs(d, d.selected && "select"), e ? e[l ? "show" : "hide"](!0).animate(t) : l && (0 < t.width || d.hasImage) && (d.graphic = e = b.renderer.symbol(g, t.x, t.y, t.width, t.height, f ? h : k).add(m)), e && e.attr(this.pointAttribs(d, d.selected && "select")), e && e.addClass(d.getClassName(), !0)) : e && (d.graphic = e.destroy());
        }
      }, markerAttribs: function markerAttribs(a, b) {
        var c = this.options.marker,
            d = a.marker || {},
            g = I(d.radius, c.radius);b && (c = c.states[b], b = d.states && d.states[b], g = I(b && b.radius, c && c.radius, g + (c && c.radiusPlus || 0)));a.hasImage && (g = 0);a = { x: Math.floor(a.plotX) - g, y: a.plotY - g };g && (a.width = a.height = 2 * g);return a;
      }, pointAttribs: function pointAttribs(a, b) {
        var c = this.options.marker,
            d = a && a.options,
            g = d && d.marker || {},
            e = this.color,
            k = d && d.color,
            h = a && a.color,
            d = I(g.lineWidth, c.lineWidth);a = a && a.zone && a.zone.color;e = k || a || h || e;a = g.fillColor || c.fillColor || e;e = g.lineColor || c.lineColor || e;b && (c = c.states[b], b = g.states && g.states[b] || {}, d = I(b.lineWidth, c.lineWidth, d + I(b.lineWidthPlus, c.lineWidthPlus, 0)), a = b.fillColor || c.fillColor || a, e = b.lineColor || c.lineColor || e);return { stroke: e, "stroke-width": d, fill: a };
      }, destroy: function destroy() {
        var a = this,
            b = a.chart,
            c = /AppleWebKit\/533/.test(N.navigator.userAgent),
            d,
            g,
            k = a.data || [],
            h,
            f;m(a, "destroy");x(a);u(a.axisTypes || [], function (b) {
          (f = a[b]) && f.series && (e(f.series, a), f.isDirty = f.forceRedraw = !0);
        });a.legendItem && a.chart.legend.destroyItem(a);for (g = k.length; g--;) {
          (h = k[g]) && h.destroy && h.destroy();
        }a.points = null;clearTimeout(a.animationTimeout);B(a, function (a, b) {
          a instanceof t && !a.survive && (d = c && "group" === b ? "hide" : "destroy", a[d]());
        });b.hoverSeries === a && (b.hoverSeries = null);e(b.series, a);b.orderSeries();B(a, function (b, c) {
          delete a[c];
        });
      }, getGraphPath: function getGraphPath(a, b, c) {
        var d = this,
            g = d.options,
            e = g.step,
            k,
            h = [],
            f = [],
            l;a = a || d.points;(k = a.reversed) && a.reverse();(e = { right: 1, center: 2 }[e] || e && 3) && k && (e = 4 - e);!g.connectNulls || b || c || (a = this.getValidPoints(a));u(a, function (k, m) {
          var q = k.plotX,
              t = k.plotY,
              n = a[m - 1];(k.leftCliff || n && n.rightCliff) && !c && (l = !0);k.isNull && !w(b) && 0 < m ? l = !g.connectNulls : k.isNull && !b ? l = !0 : (0 === m || l ? m = ["M", k.plotX, k.plotY] : d.getPointSpline ? m = d.getPointSpline(a, k, m) : e ? (m = 1 === e ? ["L", n.plotX, t] : 2 === e ? ["L", (n.plotX + q) / 2, n.plotY, "L", (n.plotX + q) / 2, t] : ["L", q, n.plotY], m.push("L", q, t)) : m = ["L", q, t], f.push(k.x), e && f.push(k.x), h.push.apply(h, m), l = !1);
        });h.xMap = f;return d.graphPath = h;
      }, drawGraph: function drawGraph() {
        var a = this,
            b = this.options,
            c = (this.gappedPath || this.getGraphPath).call(this),
            d = [["graph", "highcharts-graph", b.lineColor || this.color, b.dashStyle]];u(this.zones, function (c, e) {
          d.push(["zone-graph-" + e, "highcharts-graph highcharts-zone-graph-" + e + " " + (c.className || ""), c.color || a.color, c.dashStyle || b.dashStyle]);
        });u(d, function (d, e) {
          var g = d[0],
              k = a[g];k ? (k.endX = a.preventGraphAnimation ? null : c.xMap, k.animate({ d: c })) : c.length && (a[g] = a.chart.renderer.path(c).addClass(d[1]).attr({ zIndex: 1 }).add(a.group), k = { stroke: d[2], "stroke-width": b.lineWidth, fill: a.fillGraph && a.color || "none" }, d[3] ? k.dashstyle = d[3] : "square" !== b.linecap && (k["stroke-linecap"] = k["stroke-linejoin"] = "round"), k = a[g].attr(k).shadow(2 > e && b.shadow));k && (k.startX = c.xMap, k.isArea = c.isArea);
        });
      },
      applyZones: function applyZones() {
        var a = this,
            b = this.chart,
            c = b.renderer,
            d = this.zones,
            e,
            k,
            h = this.clips || [],
            f,
            m = this.graph,
            l = this.area,
            t = Math.max(b.chartWidth, b.chartHeight),
            n = this[(this.zoneAxis || "y") + "Axis"],
            x,
            p,
            z = b.inverted,
            C,
            r,
            w,
            B,
            K = !1;d.length && (m || l) && n && void 0 !== n.min && (p = n.reversed, C = n.horiz, m && m.hide(), l && l.hide(), x = n.getExtremes(), u(d, function (d, g) {
          e = p ? C ? b.plotWidth : 0 : C ? 0 : n.toPixels(x.min);e = Math.min(Math.max(I(k, e), 0), t);k = Math.min(Math.max(Math.round(n.toPixels(I(d.value, x.max), !0)), 0), t);K && (e = k = n.toPixels(x.max));
          r = Math.abs(e - k);w = Math.min(e, k);B = Math.max(e, k);n.isXAxis ? (f = { x: z ? B : w, y: 0, width: r, height: t }, C || (f.x = b.plotHeight - f.x)) : (f = { x: 0, y: z ? B : w, width: t, height: r }, C && (f.y = b.plotWidth - f.y));z && c.isVML && (f = n.isXAxis ? { x: 0, y: p ? w : B, height: f.width, width: b.chartWidth } : { x: f.y - b.plotLeft - b.spacingBox.x, y: 0, width: f.height, height: b.chartHeight });h[g] ? h[g].animate(f) : (h[g] = c.clipRect(f), m && a["zone-graph-" + g].clip(h[g]), l && a["zone-area-" + g].clip(h[g]));K = d.value > x.max;
        }), this.clips = h);
      }, invertGroups: function invertGroups(a) {
        function b() {
          u(["group", "markerGroup"], function (b) {
            c[b] && (d.renderer.isVML && c[b].attr({ width: c.yAxis.len, height: c.xAxis.len }), c[b].width = c.yAxis.len, c[b].height = c.xAxis.len, c[b].invert(a));
          });
        }var c = this,
            d = c.chart,
            e;c.xAxis && (e = E(d, "resize", b), E(c, "destroy", e), b(a), c.invertGroups = b);
      }, plotGroup: function plotGroup(a, b, c, d, e) {
        var g = this[a],
            k = !g;k && (this[a] = g = this.chart.renderer.g().attr({ zIndex: d || .1 }).add(e));g.addClass("highcharts-" + b + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (w(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (g.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0);g.attr({ visibility: c })[k ? "attr" : "animate"](this.getPlotBox());return g;
      }, getPlotBox: function getPlotBox() {
        var a = this.chart,
            b = this.xAxis,
            c = this.yAxis;a.inverted && (b = c, c = this.xAxis);return { translateX: b ? b.left : a.plotLeft, translateY: c ? c.top : a.plotTop, scaleX: 1, scaleY: 1 };
      }, render: function render() {
        var a = this,
            b = a.chart,
            c,
            d = a.options,
            e = !!a.animate && b.renderer.isSVG && D(d.animation).duration,
            k = a.visible ? "inherit" : "hidden",
            h = d.zIndex,
            f = a.hasRendered,
            m = b.seriesGroup,
            l = b.inverted;c = a.plotGroup("group", "series", k, h, m);a.markerGroup = a.plotGroup("markerGroup", "markers", k, h, m);e && a.animate(!0);c.inverted = a.isCartesian ? l : !1;a.drawGraph && (a.drawGraph(), a.applyZones());a.drawDataLabels && a.drawDataLabels();a.visible && a.drawPoints();a.drawTracker && !1 !== a.options.enableMouseTracking && a.drawTracker();a.invertGroups(l);!1 === d.clip || a.sharedClipKey || f || c.clip(b.clipRect);e && a.animate();f || (a.animationTimeout = C(function () {
          a.afterAnimate();
        }, e));a.isDirty = !1;a.hasRendered = !0;
      }, redraw: function redraw() {
        var a = this.chart,
            b = this.isDirty || this.isDirtyData,
            c = this.group,
            d = this.xAxis,
            e = this.yAxis;c && (a.inverted && c.attr({ width: a.plotWidth, height: a.plotHeight }), c.animate({ translateX: I(d && d.left, a.plotLeft), translateY: I(e && e.top, a.plotTop) }));this.translate();this.render();b && delete this.kdTree;
      }, kdAxisArray: ["clientX", "plotY"], searchPoint: function searchPoint(a, b) {
        var c = this.xAxis,
            d = this.yAxis,
            e = this.chart.inverted;return this.searchKDTree({ clientX: e ? c.len - a.chartY + c.pos : a.chartX - c.pos, plotY: e ? d.len - a.chartX + d.pos : a.chartY - d.pos }, b);
      }, buildKDTree: function buildKDTree() {
        function a(c, d, e) {
          var g, k;if (k = c && c.length) return g = b.kdAxisArray[d % e], c.sort(function (a, b) {
            return a[g] - b[g];
          }), k = Math.floor(k / 2), { point: c[k], left: a(c.slice(0, k), d + 1, e), right: a(c.slice(k + 1), d + 1, e) };
        }this.buildingKdTree = !0;var b = this,
            c = -1 < b.options.findNearestPointBy.indexOf("y") ? 2 : 1;delete b.kdTree;C(function () {
          b.kdTree = a(b.getValidPoints(null, !b.directTouch), c, c);b.buildingKdTree = !1;
        }, b.options.kdNow ? 0 : 1);
      },
      searchKDTree: function searchKDTree(a, b) {
        function c(a, b, g, f) {
          var m = b.point,
              l = d.kdAxisArray[g % f],
              q,
              t,
              n = m;t = w(a[e]) && w(m[e]) ? Math.pow(a[e] - m[e], 2) : null;q = w(a[k]) && w(m[k]) ? Math.pow(a[k] - m[k], 2) : null;q = (t || 0) + (q || 0);m.dist = w(q) ? Math.sqrt(q) : Number.MAX_VALUE;m.distX = w(t) ? Math.sqrt(t) : Number.MAX_VALUE;l = a[l] - m[l];q = 0 > l ? "left" : "right";t = 0 > l ? "right" : "left";b[q] && (q = c(a, b[q], g + 1, f), n = q[h] < n[h] ? q : m);b[t] && Math.sqrt(l * l) < n[h] && (a = c(a, b[t], g + 1, f), n = a[h] < n[h] ? a : n);return n;
        }var d = this,
            e = this.kdAxisArray[0],
            k = this.kdAxisArray[1],
            h = b ? "distX" : "dist";b = -1 < d.options.findNearestPointBy.indexOf("y") ? 2 : 1;this.kdTree || this.buildingKdTree || this.buildKDTree();if (this.kdTree) return c(a, this.kdTree, b, b);
      } });
  })(M);(function (a) {
    var E = a.Axis,
        D = a.Chart,
        H = a.correctFloat,
        p = a.defined,
        f = a.destroyObjectProperties,
        l = a.each,
        r = a.format,
        n = a.objectEach,
        w = a.pick,
        u = a.Series;a.StackItem = function (a, h, f, d, c) {
      var b = a.chart.inverted;this.axis = a;this.isNegative = f;this.options = h;this.x = d;this.total = null;this.points = {};this.stack = c;this.rightCliff = this.leftCliff = 0;this.alignOptions = { align: h.align || (b ? f ? "left" : "right" : "center"), verticalAlign: h.verticalAlign || (b ? "middle" : f ? "bottom" : "top"), y: w(h.y, b ? 4 : f ? 14 : -6), x: w(h.x, b ? f ? -6 : 6 : 0) };this.textAlign = h.textAlign || (b ? f ? "right" : "left" : "center");
    };a.StackItem.prototype = { destroy: function destroy() {
        f(this, this.axis);
      }, render: function render(a) {
        var e = this.options,
            f = e.format,
            f = f ? r(f, this) : e.formatter.call(this);this.label ? this.label.attr({ text: f, visibility: "hidden" }) : this.label = this.axis.chart.renderer.text(f, null, null, e.useHTML).css(e.style).attr({ align: this.textAlign,
          rotation: e.rotation, visibility: "hidden" }).add(a);
      }, setOffset: function setOffset(a, h) {
        var e = this.axis,
            d = e.chart,
            c = e.translate(e.usePercentage ? 100 : this.total, 0, 0, 0, 1),
            e = e.translate(0),
            e = Math.abs(c - e);a = d.xAxis[0].translate(this.x) + a;c = this.getStackBox(d, this, a, c, h, e);if (h = this.label) h.align(this.alignOptions, null, c), c = h.alignAttr, h[!1 === this.options.crop || d.isInsidePlot(c.x, c.y) ? "show" : "hide"](!0);
      }, getStackBox: function getStackBox(a, h, f, d, c, b) {
        var e = h.axis.reversed,
            l = a.inverted;a = a.plotHeight;h = h.isNegative && !e || !h.isNegative && e;return { x: l ? h ? d : d - b : f, y: l ? a - f - c : h ? a - d - b : a - d, width: l ? b : c, height: l ? c : b };
      } };D.prototype.getStacks = function () {
      var a = this;l(a.yAxis, function (a) {
        a.stacks && a.hasVisibleSeries && (a.oldStacks = a.stacks);
      });l(a.series, function (e) {
        !e.options.stacking || !0 !== e.visible && !1 !== a.options.chart.ignoreHiddenSeries || (e.stackKey = e.type + w(e.options.stack, ""));
      });
    };E.prototype.buildStacks = function () {
      var a = this.series,
          h = w(this.options.reversedStacks, !0),
          f = a.length,
          d;if (!this.isXAxis) {
        this.usePercentage = !1;for (d = f; d--;) {
          a[h ? d : f - d - 1].setStackedPoints();
        }for (d = 0; d < f; d++) {
          a[d].modifyStacks();
        }
      }
    };E.prototype.renderStackTotals = function () {
      var a = this.chart,
          h = a.renderer,
          f = this.stacks,
          d = this.stackTotalGroup;d || (this.stackTotalGroup = d = h.g("stack-labels").attr({ visibility: "visible", zIndex: 6 }).add());d.translate(a.plotLeft, a.plotTop);n(f, function (a) {
        n(a, function (a) {
          a.render(d);
        });
      });
    };E.prototype.resetStacks = function () {
      var a = this,
          h = a.stacks;a.isXAxis || n(h, function (e) {
        n(e, function (d, c) {
          d.touched < a.stacksTouched ? (d.destroy(), delete e[c]) : (d.total = null, d.cumulative = null);
        });
      });
    };E.prototype.cleanStacks = function () {
      var a;this.isXAxis || (this.oldStacks && (a = this.stacks = this.oldStacks), n(a, function (a) {
        n(a, function (a) {
          a.cumulative = a.total;
        });
      }));
    };u.prototype.setStackedPoints = function () {
      if (this.options.stacking && (!0 === this.visible || !1 === this.chart.options.chart.ignoreHiddenSeries)) {
        var e = this.processedXData,
            h = this.processedYData,
            f = [],
            d = h.length,
            c = this.options,
            b = c.threshold,
            k = w(c.startFromThreshold && b, 0),
            l = c.stack,
            c = c.stacking,
            n = this.stackKey,
            r = "-" + n,
            x = this.negStacks,
            u = this.yAxis,
            t = u.stacks,
            C = u.oldStacks,
            N,
            q,
            A,
            F,
            G,
            g,
            v;u.stacksTouched += 1;for (G = 0; G < d; G++) {
          g = e[G], v = h[G], N = this.getStackIndicator(N, g, this.index), F = N.key, A = (q = x && v < (k ? 0 : b)) ? r : n, t[A] || (t[A] = {}), t[A][g] || (C[A] && C[A][g] ? (t[A][g] = C[A][g], t[A][g].total = null) : t[A][g] = new a.StackItem(u, u.options.stackLabels, q, g, l)), A = t[A][g], null !== v ? (A.points[F] = A.points[this.index] = [w(A.cumulative, k)], p(A.cumulative) || (A.base = F), A.touched = u.stacksTouched, 0 < N.index && !1 === this.singleStacks && (A.points[F][0] = A.points[this.index + "," + g + ",0"][0])) : A.points[F] = A.points[this.index] = null, "percent" === c ? (q = q ? n : r, x && t[q] && t[q][g] ? (q = t[q][g], A.total = q.total = Math.max(q.total, A.total) + Math.abs(v) || 0) : A.total = H(A.total + (Math.abs(v) || 0))) : A.total = H(A.total + (v || 0)), A.cumulative = w(A.cumulative, k) + (v || 0), null !== v && (A.points[F].push(A.cumulative), f[G] = A.cumulative);
        }"percent" === c && (u.usePercentage = !0);this.stackedYData = f;u.oldStacks = {};
      }
    };u.prototype.modifyStacks = function () {
      var a = this,
          h = a.stackKey,
          f = a.yAxis.stacks,
          d = a.processedXData,
          c,
          b = a.options.stacking;a[b + "Stacker"] && l([h, "-" + h], function (e) {
        for (var k = d.length, h, l; k--;) {
          if (h = d[k], c = a.getStackIndicator(c, h, a.index, e), l = (h = f[e] && f[e][h]) && h.points[c.key]) a[b + "Stacker"](l, h, k);
        }
      });
    };u.prototype.percentStacker = function (a, h, f) {
      h = h.total ? 100 / h.total : 0;a[0] = H(a[0] * h);a[1] = H(a[1] * h);this.stackedYData[f] = a[1];
    };u.prototype.getStackIndicator = function (a, h, f, d) {
      !p(a) || a.x !== h || d && a.key !== d ? a = { x: h, index: 0, key: d } : a.index++;a.key = [f, h, a.index].join();return a;
    };
  })(M);(function (a) {
    var E = a.addEvent,
        D = a.animate,
        H = a.Axis,
        p = a.createElement,
        f = a.css,
        l = a.defined,
        r = a.each,
        n = a.erase,
        w = a.extend,
        u = a.fireEvent,
        e = a.inArray,
        h = a.isNumber,
        m = a.isObject,
        d = a.isArray,
        c = a.merge,
        b = a.objectEach,
        k = a.pick,
        z = a.Point,
        B = a.Series,
        I = a.seriesTypes,
        x = a.setAnimation,
        K = a.splat;w(a.Chart.prototype, { addSeries: function addSeries(a, b, c) {
        var d,
            e = this;a && (b = k(b, !0), u(e, "addSeries", { options: a }, function () {
          d = e.initSeries(a);e.isDirtyLegend = !0;e.linkSeries();b && e.redraw(c);
        }));return d;
      }, addAxis: function addAxis(a, b, d, e) {
        var h = b ? "xAxis" : "yAxis",
            f = this.options;
        a = c(a, { index: this[h].length, isX: b });b = new H(this, a);f[h] = K(f[h] || {});f[h].push(a);k(d, !0) && this.redraw(e);return b;
      }, showLoading: function showLoading(a) {
        var b = this,
            c = b.options,
            d = b.loadingDiv,
            e = c.loading,
            k = function k() {
          d && f(d, { left: b.plotLeft + "px", top: b.plotTop + "px", width: b.plotWidth + "px", height: b.plotHeight + "px" });
        };d || (b.loadingDiv = d = p("div", { className: "highcharts-loading highcharts-loading-hidden" }, null, b.container), b.loadingSpan = p("span", { className: "highcharts-loading-inner" }, null, d), E(b, "redraw", k));d.className = "highcharts-loading";b.loadingSpan.innerHTML = a || c.lang.loading;f(d, w(e.style, { zIndex: 10 }));f(b.loadingSpan, e.labelStyle);b.loadingShown || (f(d, { opacity: 0, display: "" }), D(d, { opacity: e.style.opacity || .5 }, { duration: e.showDuration || 0 }));b.loadingShown = !0;k();
      }, hideLoading: function hideLoading() {
        var a = this.options,
            b = this.loadingDiv;b && (b.className = "highcharts-loading highcharts-loading-hidden", D(b, { opacity: 0 }, { duration: a.loading.hideDuration || 100, complete: function complete() {
            f(b, { display: "none" });
          } }));this.loadingShown = !1;
      }, propsRequireDirtyBox: "backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
      propsRequireUpdateSeries: "chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions tooltip".split(" "), update: function update(a, d, f) {
        var m = this,
            n = { credits: "addCredits", title: "setTitle", subtitle: "setSubtitle" },
            t = a.chart,
            x,
            g,
            p = [];if (t) {
          c(!0, m.options.chart, t);"className" in t && m.setClassName(t.className);if ("inverted" in t || "polar" in t) m.propFromSeries(), x = !0;"alignTicks" in t && (x = !0);b(t, function (a, b) {
            -1 !== e("chart." + b, m.propsRequireUpdateSeries) && (g = !0);-1 !== e(b, m.propsRequireDirtyBox) && (m.isDirtyBox = !0);
          });"style" in t && m.renderer.setStyle(t.style);
        }a.colors && (this.options.colors = a.colors);a.plotOptions && c(!0, this.options.plotOptions, a.plotOptions);b(a, function (a, b) {
          if (m[b] && "function" === typeof m[b].update) m[b].update(a, !1);else if ("function" === typeof m[n[b]]) m[n[b]](a);"chart" !== b && -1 !== e(b, m.propsRequireUpdateSeries) && (g = !0);
        });r("xAxis yAxis zAxis series colorAxis pane".split(" "), function (b) {
          a[b] && (r(K(a[b]), function (a, c) {
            (c = l(a.id) && m.get(a.id) || m[b][c]) && c.coll === b && (c.update(a, !1), f && (c.touched = !0));if (!c && f) if ("series" === b) m.addSeries(a, !1).touched = !0;else if ("xAxis" === b || "yAxis" === b) m.addAxis(a, "xAxis" === b, !1).touched = !0;
          }), f && r(m[b], function (a) {
            a.touched ? delete a.touched : p.push(a);
          }));
        });r(p, function (a) {
          a.remove(!1);
        });x && r(m.axes, function (a) {
          a.update({}, !1);
        });g && r(m.series, function (a) {
          a.update({}, !1);
        });a.loading && c(!0, m.options.loading, a.loading);x = t && t.width;t = t && t.height;h(x) && x !== m.chartWidth || h(t) && t !== m.chartHeight ? m.setSize(x, t) : k(d, !0) && m.redraw();
      }, setSubtitle: function setSubtitle(a) {
        this.setTitle(void 0, a);
      } });w(z.prototype, { update: function update(a, b, c, d) {
        function e() {
          h.applyOptions(a);null === h.y && g && (h.graphic = g.destroy());m(a, !0) && (g && g.element && a && a.marker && void 0 !== a.marker.symbol && (h.graphic = g.destroy()), a && a.dataLabels && h.dataLabel && (h.dataLabel = h.dataLabel.destroy()), h.connector && (h.connector = h.connector.destroy()));l = h.index;f.updateParallelArrays(h, l);t.data[l] = m(t.data[l], !0) || m(a, !0) ? h.options : a;f.isDirty = f.isDirtyData = !0;!f.fixedBox && f.hasCartesianSeries && (n.isDirtyBox = !0);"point" === t.legendType && (n.isDirtyLegend = !0);b && n.redraw(c);
        }var h = this,
            f = h.series,
            g = h.graphic,
            l,
            n = f.chart,
            t = f.options;b = k(b, !0);!1 === d ? e() : h.firePointEvent("update", { options: a }, e);
      }, remove: function remove(a, b) {
        this.series.removePoint(e(this, this.series.data), a, b);
      } });w(B.prototype, { addPoint: function addPoint(a, b, c, d) {
        var e = this.options,
            h = this.data,
            f = this.chart,
            g = this.xAxis,
            g = g && g.hasNames && g.names,
            l = e.data,
            m,
            n,
            t = this.xData,
            q,
            x;b = k(b, !0);m = { series: this };this.pointClass.prototype.applyOptions.apply(m, [a]);x = m.x;q = t.length;if (this.requireSorting && x < t[q - 1]) for (n = !0; q && t[q - 1] > x;) {
          q--;
        }this.updateParallelArrays(m, "splice", q, 0, 0);this.updateParallelArrays(m, q);g && m.name && (g[x] = m.name);l.splice(q, 0, a);n && (this.data.splice(q, 0, null), this.processData());"point" === e.legendType && this.generatePoints();c && (h[0] && h[0].remove ? h[0].remove(!1) : (h.shift(), this.updateParallelArrays(m, "shift"), l.shift()));this.isDirtyData = this.isDirty = !0;b && f.redraw(d);
      }, removePoint: function removePoint(a, b, c) {
        var d = this,
            e = d.data,
            h = e[a],
            f = d.points,
            g = d.chart,
            l = function l() {
          f && f.length === e.length && f.splice(a, 1);e.splice(a, 1);d.options.data.splice(a, 1);d.updateParallelArrays(h || { series: d }, "splice", a, 1);h && h.destroy();d.isDirty = !0;d.isDirtyData = !0;b && g.redraw();
        };x(c, g);b = k(b, !0);h ? h.firePointEvent("remove", null, l) : l();
      }, remove: function remove(a, b, c) {
        function d() {
          e.destroy();h.isDirtyLegend = h.isDirtyBox = !0;h.linkSeries();k(a, !0) && h.redraw(b);
        }var e = this,
            h = e.chart;!1 !== c ? u(e, "remove", null, d) : d();
      }, update: function update(a, b) {
        var d = this,
            e = d.chart,
            h = d.userOptions,
            f = d.oldType || d.type,
            l = a.type || h.type || e.options.chart.type,
            g = I[f].prototype,
            m,
            n = ["group", "markerGroup", "dataLabelsGroup"],
            t = ["navigatorSeries", "baseSeries"],
            x = d.finishedAnimating && { animation: !1 };if (Object.keys && "data" === Object.keys(a).toString()) return this.setData(a.data, b);t = n.concat(t);r(t, function (a) {
          t[a] = d[a];delete d[a];
        });a = c(h, x, { index: d.index, pointStart: d.xData[0] }, { data: d.options.data }, a);d.remove(!1, null, !1);for (m in g) {
          d[m] = void 0;
        }w(d, I[l || f].prototype);r(t, function (a) {
          d[a] = t[a];
        });d.init(e, a);a.zIndex !== h.zIndex && r(n, function (b) {
          d[b] && d[b].attr({ zIndex: a.zIndex });
        });
        d.oldType = f;e.linkSeries();k(b, !0) && e.redraw(!1);
      } });w(H.prototype, { update: function update(a, b) {
        var d = this.chart;a = d.options[this.coll][this.options.index] = c(this.userOptions, a);this.destroy(!0);this.init(d, w(a, { events: void 0 }));d.isDirtyBox = !0;k(b, !0) && d.redraw();
      }, remove: function remove(a) {
        for (var b = this.chart, c = this.coll, e = this.series, h = e.length; h--;) {
          e[h] && e[h].remove(!1);
        }n(b.axes, this);n(b[c], this);d(b.options[c]) ? b.options[c].splice(this.options.index, 1) : delete b.options[c];r(b[c], function (a, b) {
          a.options.index = b;
        });this.destroy();b.isDirtyBox = !0;k(a, !0) && b.redraw();
      }, setTitle: function setTitle(a, b) {
        this.update({ title: a }, b);
      }, setCategories: function setCategories(a, b) {
        this.update({ categories: a }, b);
      } });
  })(M);(function (a) {
    var E = a.color,
        D = a.each,
        H = a.map,
        p = a.pick,
        f = a.Series,
        l = a.seriesType;l("area", "line", { softThreshold: !1, threshold: 0 }, { singleStacks: !1, getStackPoints: function getStackPoints(f) {
        var l = [],
            r = [],
            u = this.xAxis,
            e = this.yAxis,
            h = e.stacks[this.stackKey],
            m = {},
            d = this.index,
            c = e.series,
            b = c.length,
            k,
            z = p(e.options.reversedStacks, !0) ? 1 : -1,
            B;f = f || this.points;
        if (this.options.stacking) {
          for (B = 0; B < f.length; B++) {
            f[B].leftNull = f[B].rightNull = null, m[f[B].x] = f[B];
          }a.objectEach(h, function (a, b) {
            null !== a.total && r.push(b);
          });r.sort(function (a, b) {
            return a - b;
          });k = H(c, function () {
            return this.visible;
          });D(r, function (a, c) {
            var f = 0,
                n,
                x;if (m[a] && !m[a].isNull) l.push(m[a]), D([-1, 1], function (e) {
              var f = 1 === e ? "rightNull" : "leftNull",
                  l = 0,
                  t = h[r[c + e]];if (t) for (B = d; 0 <= B && B < b;) {
                n = t.points[B], n || (B === d ? m[a][f] = !0 : k[B] && (x = h[a].points[B]) && (l -= x[1] - x[0])), B += z;
              }m[a][1 === e ? "rightCliff" : "leftCliff"] = l;
            });else {
              for (B = d; 0 <= B && B < b;) {
                if (n = h[a].points[B]) {
                  f = n[1];break;
                }B += z;
              }f = e.translate(f, 0, 1, 0, 1);l.push({ isNull: !0, plotX: u.translate(a, 0, 0, 0, 1), x: a, plotY: f, yBottom: f });
            }
          });
        }return l;
      }, getGraphPath: function getGraphPath(a) {
        var l = f.prototype.getGraphPath,
            r = this.options,
            u = r.stacking,
            e = this.yAxis,
            h,
            m,
            d = [],
            c = [],
            b = this.index,
            k,
            z = e.stacks[this.stackKey],
            B = r.threshold,
            I = e.getThreshold(r.threshold),
            x,
            r = r.connectNulls || "percent" === u,
            K = function K(h, f, l) {
          var m = a[h];h = u && z[m.x].points[b];var n = m[l + "Null"] || 0;l = m[l + "Cliff"] || 0;var x,
              t,
              m = !0;l || n ? (x = (n ? h[0] : h[1]) + l, t = h[0] + l, m = !!n) : !u && a[f] && a[f].isNull && (x = t = B);void 0 !== x && (c.push({ plotX: k, plotY: null === x ? I : e.getThreshold(x), isNull: m, isCliff: !0 }), d.push({ plotX: k, plotY: null === t ? I : e.getThreshold(t), doCurve: !1 }));
        };a = a || this.points;u && (a = this.getStackPoints(a));for (h = 0; h < a.length; h++) {
          if (m = a[h].isNull, k = p(a[h].rectPlotX, a[h].plotX), x = p(a[h].yBottom, I), !m || r) r || K(h, h - 1, "left"), m && !u && r || (c.push(a[h]), d.push({ x: h, plotX: k, plotY: x })), r || K(h, h + 1, "right");
        }h = l.call(this, c, !0, !0);d.reversed = !0;m = l.call(this, d, !0, !0);m.length && (m[0] = "L");m = h.concat(m);l = l.call(this, c, !1, r);m.xMap = h.xMap;this.areaPath = m;return l;
      }, drawGraph: function drawGraph() {
        this.areaPath = [];f.prototype.drawGraph.apply(this);var a = this,
            l = this.areaPath,
            w = this.options,
            u = [["area", "highcharts-area", this.color, w.fillColor]];D(this.zones, function (e, h) {
          u.push(["zone-area-" + h, "highcharts-area highcharts-zone-area-" + h + " " + e.className, e.color || a.color, e.fillColor || w.fillColor]);
        });D(u, function (e) {
          var h = e[0],
              f = a[h];f ? (f.endX = a.preventGraphAnimation ? null : l.xMap, f.animate({ d: l })) : (f = a[h] = a.chart.renderer.path(l).addClass(e[1]).attr({ fill: p(e[3], E(e[2]).setOpacity(p(w.fillOpacity, .75)).get()), zIndex: 0 }).add(a.group), f.isArea = !0);f.startX = l.xMap;f.shiftUnit = w.step ? 2 : 1;
        });
      }, drawLegendSymbol: a.LegendSymbolMixin.drawRectangle });
  })(M);(function (a) {
    var E = a.pick;a = a.seriesType;a("spline", "line", {}, { getPointSpline: function getPointSpline(a, H, p) {
        var f = H.plotX,
            l = H.plotY,
            r = a[p - 1];p = a[p + 1];var n, w, u, e;if (r && !r.isNull && !1 !== r.doCurve && !H.isCliff && p && !p.isNull && !1 !== p.doCurve && !H.isCliff) {
          a = r.plotY;u = p.plotX;p = p.plotY;var h = 0;n = (1.5 * f + r.plotX) / 2.5;w = (1.5 * l + a) / 2.5;u = (1.5 * f + u) / 2.5;e = (1.5 * l + p) / 2.5;u !== n && (h = (e - w) * (u - f) / (u - n) + l - e);w += h;e += h;w > a && w > l ? (w = Math.max(a, l), e = 2 * l - w) : w < a && w < l && (w = Math.min(a, l), e = 2 * l - w);e > p && e > l ? (e = Math.max(p, l), w = 2 * l - e) : e < p && e < l && (e = Math.min(p, l), w = 2 * l - e);H.rightContX = u;H.rightContY = e;
        }H = ["C", E(r.rightContX, r.plotX), E(r.rightContY, r.plotY), E(n, f), E(w, l), f, l];r.rightContX = r.rightContY = null;return H;
      } });
  })(M);(function (a) {
    var E = a.seriesTypes.area.prototype,
        D = a.seriesType;D("areaspline", "spline", a.defaultPlotOptions.area, { getStackPoints: E.getStackPoints, getGraphPath: E.getGraphPath, drawGraph: E.drawGraph, drawLegendSymbol: a.LegendSymbolMixin.drawRectangle });
  })(M);(function (a) {
    var E = a.animObject,
        D = a.color,
        H = a.each,
        p = a.extend,
        f = a.isNumber,
        l = a.merge,
        r = a.pick,
        n = a.Series,
        w = a.seriesType,
        u = a.svg;w("column", "line", { borderRadius: 0, crisp: !0, groupPadding: .2, marker: null, pointPadding: .1, minPointLength: 0, cropThreshold: 50, pointRange: null, states: { hover: { halo: !1, brightness: .1 },
        select: { color: "#cccccc", borderColor: "#000000" } }, dataLabels: { align: null, verticalAlign: null, y: null }, softThreshold: !1, startFromThreshold: !0, stickyTracking: !1, tooltip: { distance: 6 }, threshold: 0, borderColor: "#ffffff" }, { cropShoulder: 0, directTouch: !0, trackerGroups: ["group", "dataLabelsGroup"], negStacks: !0, init: function init() {
        n.prototype.init.apply(this, arguments);var a = this,
            h = a.chart;h.hasRendered && H(h.series, function (e) {
          e.type === a.type && (e.isDirty = !0);
        });
      }, getColumnMetrics: function getColumnMetrics() {
        var a = this,
            h = a.options,
            f = a.xAxis,
            d = a.yAxis,
            c = f.reversed,
            b,
            k = {},
            l = 0;!1 === h.grouping ? l = 1 : H(a.chart.series, function (c) {
          var e = c.options,
              h = c.yAxis,
              f;c.type !== a.type || !c.visible && a.chart.options.chart.ignoreHiddenSeries || d.len !== h.len || d.pos !== h.pos || (e.stacking ? (b = c.stackKey, void 0 === k[b] && (k[b] = l++), f = k[b]) : !1 !== e.grouping && (f = l++), c.columnIndex = f);
        });var n = Math.min(Math.abs(f.transA) * (f.ordinalSlope || h.pointRange || f.closestPointRange || f.tickInterval || 1), f.len),
            p = n * h.groupPadding,
            x = (n - 2 * p) / (l || 1),
            h = Math.min(h.maxPointWidth || f.len, r(h.pointWidth, x * (1 - 2 * h.pointPadding)));a.columnMetrics = { width: h, offset: (x - h) / 2 + (p + ((a.columnIndex || 0) + (c ? 1 : 0)) * x - n / 2) * (c ? -1 : 1) };return a.columnMetrics;
      }, crispCol: function crispCol(a, h, f, d) {
        var c = this.chart,
            b = this.borderWidth,
            e = -(b % 2 ? .5 : 0),
            b = b % 2 ? .5 : 1;c.inverted && c.renderer.isVML && (b += 1);this.options.crisp && (f = Math.round(a + f) + e, a = Math.round(a) + e, f -= a);d = Math.round(h + d) + b;e = .5 >= Math.abs(h) && .5 < d;h = Math.round(h) + b;d -= h;e && d && (--h, d += 1);return { x: a, y: h, width: f, height: d };
      }, translate: function translate() {
        var a = this,
            h = a.chart,
            f = a.options,
            d = a.dense = 2 > a.closestPointRange * a.xAxis.transA,
            d = a.borderWidth = r(f.borderWidth, d ? 0 : 1),
            c = a.yAxis,
            b = f.threshold,
            k = a.translatedThreshold = c.getThreshold(b),
            l = r(f.minPointLength, 5),
            p = a.getColumnMetrics(),
            u = p.width,
            x = a.barW = Math.max(u, 1 + 2 * d),
            w = a.pointXOffset = p.offset;h.inverted && (k -= .5);f.pointPadding && (x = Math.ceil(x));n.prototype.translate.apply(a);H(a.points, function (d) {
          var e = r(d.yBottom, k),
              f = 999 + Math.abs(e),
              f = Math.min(Math.max(-f, d.plotY), c.len + f),
              m = d.plotX + w,
              n = x,
              t = Math.min(f, e),
              p,
              g = Math.max(f, e) - t;l && Math.abs(g) < l && (g = l, p = !c.reversed && !d.negative || c.reversed && d.negative, d.y === b && a.dataMax <= b && c.min < b && (p = !p), t = Math.abs(t - k) > l ? e - l : k - (p ? l : 0));d.barX = m;d.pointWidth = u;d.tooltipPos = h.inverted ? [c.len + c.pos - h.plotLeft - f, a.xAxis.len - m - n / 2, g] : [m + n / 2, f + c.pos - h.plotTop, g];d.shapeType = "rect";d.shapeArgs = a.crispCol.apply(a, d.isNull ? [m, k, n, 0] : [m, t, n, g]);
        });
      }, getSymbol: a.noop, drawLegendSymbol: a.LegendSymbolMixin.drawRectangle, drawGraph: function drawGraph() {
        this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
      },
      pointAttribs: function pointAttribs(a, f) {
        var e = this.options,
            d,
            c = this.pointAttrToOptions || {};d = c.stroke || "borderColor";var b = c["stroke-width"] || "borderWidth",
            k = a && a.color || this.color,
            h = a && a[d] || e[d] || this.color || k,
            n = a && a[b] || e[b] || this[b] || 0,
            c = e.dashStyle;a && this.zones.length && (k = a.getZone(), k = a.options.color || k && k.color || this.color);f && (a = l(e.states[f], a.options.states && a.options.states[f] || {}), f = a.brightness, k = a.color || void 0 !== f && D(k).brighten(a.brightness).get() || k, h = a[d] || h, n = a[b] || n, c = a.dashStyle || c);d = { fill: k,
          stroke: h, "stroke-width": n };c && (d.dashstyle = c);return d;
      }, drawPoints: function drawPoints() {
        var a = this,
            h = this.chart,
            m = a.options,
            d = h.renderer,
            c = m.animationLimit || 250,
            b;H(a.points, function (e) {
          var k = e.graphic;if (f(e.plotY) && null !== e.y) {
            b = e.shapeArgs;if (k) k[h.pointCount < c ? "animate" : "attr"](l(b));else e.graphic = k = d[e.shapeType](b).add(e.group || a.group);m.borderRadius && k.attr({ r: m.borderRadius });k.attr(a.pointAttribs(e, e.selected && "select")).shadow(m.shadow, null, m.stacking && !m.borderRadius);k.addClass(e.getClassName(), !0);
          } else k && (e.graphic = k.destroy());
        });
      }, animate: function animate(a) {
        var e = this,
            f = this.yAxis,
            d = e.options,
            c = this.chart.inverted,
            b = {},
            k = c ? "translateX" : "translateY",
            l;u && (a ? (b.scaleY = .001, a = Math.min(f.pos + f.len, Math.max(f.pos, f.toPixels(d.threshold))), c ? b.translateX = a - f.len : b.translateY = a, e.group.attr(b)) : (l = e.group.attr(k), e.group.animate({ scaleY: 1 }, p(E(e.options.animation), { step: function step(a, c) {
            b[k] = l + c.pos * (f.pos - l);e.group.attr(b);
          } })), e.animate = null));
      }, remove: function remove() {
        var a = this,
            f = a.chart;f.hasRendered && H(f.series, function (e) {
          e.type === a.type && (e.isDirty = !0);
        });n.prototype.remove.apply(a, arguments);
      } });
  })(M);(function (a) {
    a = a.seriesType;a("bar", "column", null, { inverted: !0 });
  })(M);(function (a) {
    var E = a.Series;a = a.seriesType;a("scatter", "line", { lineWidth: 0, findNearestPointBy: "xy", marker: { enabled: !0 }, tooltip: { headerFormat: "<span style=\"color:{point.color}\">\u25CF</span> <span style=\"font-size: 0.85em\"> {series.name}</span><br/>", pointFormat: "x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e" } }, { sorted: !1, requireSorting: !1, noSharedTooltip: !0, trackerGroups: ["group", "markerGroup", "dataLabelsGroup"], takeOrdinalPosition: !1, drawGraph: function drawGraph() {
        this.options.lineWidth && E.prototype.drawGraph.call(this);
      } });
  })(M);(function (a) {
    var E = a.deg2rad,
        D = a.isNumber,
        H = a.pick,
        p = a.relativeLength;a.CenteredSeriesMixin = { getCenter: function getCenter() {
        var a = this.options,
            l = this.chart,
            r = 2 * (a.slicedOffset || 0),
            n = l.plotWidth - 2 * r,
            l = l.plotHeight - 2 * r,
            w = a.center,
            w = [H(w[0], "50%"), H(w[1], "50%"), a.size || "100%", a.innerSize || 0],
            u = Math.min(n, l),
            e,
            h;for (e = 0; 4 > e; ++e) {
          h = w[e], a = 2 > e || 2 === e && /%$/.test(h), w[e] = p(h, [n, l, u, w[2]][e]) + (a ? r : 0);
        }w[3] > w[2] && (w[3] = w[2]);return w;
      }, getStartAndEndRadians: function getStartAndEndRadians(a, l) {
        a = D(a) ? a : 0;l = D(l) && l > a && 360 > l - a ? l : a + 360;return { start: E * (a + -90), end: E * (l + -90) };
      } };
  })(M);(function (a) {
    var E = a.addEvent,
        D = a.CenteredSeriesMixin,
        H = a.defined,
        p = a.each,
        f = a.extend,
        l = D.getStartAndEndRadians,
        r = a.inArray,
        n = a.noop,
        w = a.pick,
        u = a.Point,
        e = a.Series,
        h = a.seriesType,
        m = a.setAnimation;h("pie", "line", { center: [null, null], clip: !1, colorByPoint: !0, dataLabels: { distance: 30,
        enabled: !0, formatter: function formatter() {
          return this.point.isNull ? void 0 : this.point.name;
        }, x: 0 }, ignoreHiddenPoint: !0, legendType: "point", marker: null, size: null, showInLegend: !1, slicedOffset: 10, stickyTracking: !1, tooltip: { followPointer: !0 }, borderColor: "#ffffff", borderWidth: 1, states: { hover: { brightness: .1, shadow: !1 } } }, { isCartesian: !1, requireSorting: !1, directTouch: !0, noSharedTooltip: !0, trackerGroups: ["group", "dataLabelsGroup"], axisTypes: [], pointAttribs: a.seriesTypes.column.prototype.pointAttribs, animate: function animate(a) {
        var c = this,
            b = c.points,
            d = c.startAngleRad;a || (p(b, function (a) {
          var b = a.graphic,
              e = a.shapeArgs;b && (b.attr({ r: a.startR || c.center[3] / 2, start: d, end: d }), b.animate({ r: e.r, start: e.start, end: e.end }, c.options.animation));
        }), c.animate = null);
      }, updateTotals: function updateTotals() {
        var a,
            c = 0,
            b = this.points,
            e = b.length,
            f,
            h = this.options.ignoreHiddenPoint;for (a = 0; a < e; a++) {
          f = b[a], c += h && !f.visible ? 0 : f.isNull ? 0 : f.y;
        }this.total = c;for (a = 0; a < e; a++) {
          f = b[a], f.percentage = 0 < c && (f.visible || !h) ? f.y / c * 100 : 0, f.total = c;
        }
      }, generatePoints: function generatePoints() {
        e.prototype.generatePoints.call(this);
        this.updateTotals();
      }, translate: function translate(a) {
        this.generatePoints();var c = 0,
            b = this.options,
            d = b.slicedOffset,
            e = d + (b.borderWidth || 0),
            f,
            h,
            m,
            n = l(b.startAngle, b.endAngle),
            t = this.startAngleRad = n.start,
            n = (this.endAngleRad = n.end) - t,
            p = this.points,
            u,
            q = b.dataLabels.distance,
            b = b.ignoreHiddenPoint,
            r,
            F = p.length,
            G;a || (this.center = a = this.getCenter());this.getX = function (b, c, d) {
          m = Math.asin(Math.min((b - a[1]) / (a[2] / 2 + d.labelDistance), 1));return a[0] + (c ? -1 : 1) * Math.cos(m) * (a[2] / 2 + d.labelDistance);
        };for (r = 0; r < F; r++) {
          G = p[r];
          G.labelDistance = w(G.options.dataLabels && G.options.dataLabels.distance, q);this.maxLabelDistance = Math.max(this.maxLabelDistance || 0, G.labelDistance);f = t + c * n;if (!b || G.visible) c += G.percentage / 100;h = t + c * n;G.shapeType = "arc";G.shapeArgs = { x: a[0], y: a[1], r: a[2] / 2, innerR: a[3] / 2, start: Math.round(1E3 * f) / 1E3, end: Math.round(1E3 * h) / 1E3 };m = (h + f) / 2;m > 1.5 * Math.PI ? m -= 2 * Math.PI : m < -Math.PI / 2 && (m += 2 * Math.PI);G.slicedTranslation = { translateX: Math.round(Math.cos(m) * d), translateY: Math.round(Math.sin(m) * d) };h = Math.cos(m) * a[2] / 2;u = Math.sin(m) * a[2] / 2;G.tooltipPos = [a[0] + .7 * h, a[1] + .7 * u];G.half = m < -Math.PI / 2 || m > Math.PI / 2 ? 1 : 0;G.angle = m;f = Math.min(e, G.labelDistance / 5);G.labelPos = [a[0] + h + Math.cos(m) * G.labelDistance, a[1] + u + Math.sin(m) * G.labelDistance, a[0] + h + Math.cos(m) * f, a[1] + u + Math.sin(m) * f, a[0] + h, a[1] + u, 0 > G.labelDistance ? "center" : G.half ? "right" : "left", m];
        }
      }, drawGraph: null, drawPoints: function drawPoints() {
        var a = this,
            c = a.chart.renderer,
            b,
            e,
            h,
            l,
            m = a.options.shadow;m && !a.shadowGroup && (a.shadowGroup = c.g("shadow").add(a.group));p(a.points, function (d) {
          e = d.graphic;if (d.isNull) e && (d.graphic = e.destroy());else {
            l = d.shapeArgs;b = d.getTranslate();var k = d.shadowGroup;m && !k && (k = d.shadowGroup = c.g("shadow").add(a.shadowGroup));k && k.attr(b);h = a.pointAttribs(d, d.selected && "select");e ? e.setRadialReference(a.center).attr(h).animate(f(l, b)) : (d.graphic = e = c[d.shapeType](l).setRadialReference(a.center).attr(b).add(a.group), d.visible || e.attr({ visibility: "hidden" }), e.attr(h).attr({ "stroke-linejoin": "round" }).shadow(m, k));e.addClass(d.getClassName());
          }
        });
      }, searchPoint: n,
      sortByAngle: function sortByAngle(a, c) {
        a.sort(function (a, d) {
          return void 0 !== a.angle && (d.angle - a.angle) * c;
        });
      }, drawLegendSymbol: a.LegendSymbolMixin.drawRectangle, getCenter: D.getCenter, getSymbol: n }, { init: function init() {
        u.prototype.init.apply(this, arguments);var a = this,
            c;a.name = w(a.name, "Slice");c = function c(b) {
          a.slice("select" === b.type);
        };E(a, "select", c);E(a, "unselect", c);return a;
      }, isValid: function isValid() {
        return a.isNumber(this.y, !0) && 0 <= this.y;
      }, setVisible: function setVisible(a, c) {
        var b = this,
            d = b.series,
            e = d.chart,
            f = d.options.ignoreHiddenPoint;
        c = w(c, f);a !== b.visible && (b.visible = b.options.visible = a = void 0 === a ? !b.visible : a, d.options.data[r(b, d.data)] = b.options, p(["graphic", "dataLabel", "connector", "shadowGroup"], function (c) {
          if (b[c]) b[c][a ? "show" : "hide"](!0);
        }), b.legendItem && e.legend.colorizeItem(b, a), a || "hover" !== b.state || b.setState(""), f && (d.isDirty = !0), c && e.redraw());
      }, slice: function slice(a, c, b) {
        var d = this.series;m(b, d.chart);w(c, !0);this.sliced = this.options.sliced = H(a) ? a : !this.sliced;d.options.data[r(this, d.data)] = this.options;this.graphic.animate(this.getTranslate());
        this.shadowGroup && this.shadowGroup.animate(this.getTranslate());
      }, getTranslate: function getTranslate() {
        return this.sliced ? this.slicedTranslation : { translateX: 0, translateY: 0 };
      }, haloPath: function haloPath(a) {
        var c = this.shapeArgs;return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(c.x, c.y, c.r + a, c.r + a, { innerR: this.shapeArgs.r - 1, start: c.start, end: c.end });
      } });
  })(M);(function (a) {
    var E = a.addEvent,
        D = a.arrayMax,
        H = a.defined,
        p = a.each,
        f = a.extend,
        l = a.format,
        r = a.map,
        n = a.merge,
        w = a.noop,
        u = a.pick,
        e = a.relativeLength,
        h = a.Series,
        m = a.seriesTypes,
        d = a.stableSort;a.distribute = function (a, b) {
      function c(a, b) {
        return a.target - b.target;
      }var e,
          f = !0,
          h = a,
          l = [],
          m;m = 0;for (e = a.length; e--;) {
        m += a[e].size;
      }if (m > b) {
        d(a, function (a, b) {
          return (b.rank || 0) - (a.rank || 0);
        });for (m = e = 0; m <= b;) {
          m += a[e].size, e++;
        }l = a.splice(e - 1, a.length);
      }d(a, c);for (a = r(a, function (a) {
        return { size: a.size, targets: [a.target], align: u(a.align, .5) };
      }); f;) {
        for (e = a.length; e--;) {
          f = a[e], m = (Math.min.apply(0, f.targets) + Math.max.apply(0, f.targets)) / 2, f.pos = Math.min(Math.max(0, m - f.size * f.align), b - f.size);
        }e = a.length;for (f = !1; e--;) {
          0 < e && a[e - 1].pos + a[e - 1].size > a[e].pos && (a[e - 1].size += a[e].size, a[e - 1].targets = a[e - 1].targets.concat(a[e].targets), a[e - 1].align = .5, a[e - 1].pos + a[e - 1].size > b && (a[e - 1].pos = b - a[e - 1].size), a.splice(e, 1), f = !0);
        }
      }e = 0;p(a, function (a) {
        var b = 0;p(a.targets, function () {
          h[e].pos = a.pos + b;b += h[e].size;e++;
        });
      });h.push.apply(h, l);d(h, c);
    };h.prototype.drawDataLabels = function () {
      function c(a, b) {
        var c = b.filter;return c ? (b = c.operator, a = a[c.property], c = c.value, "\x3e" === b && a > c || "\x3c" === b && a < c || "\x3e\x3d" === b && a >= c || "\x3c\x3d" === b && a <= c || "\x3d\x3d" === b && a == c || "\x3d\x3d\x3d" === b && a === c ? !0 : !1) : !0;
      }var b = this,
          d = b.options,
          e = d.dataLabels,
          f = b.points,
          h,
          m,
          r = b.hasRendered || 0,
          t,
          w,
          D = u(e.defer, !!d.animation),
          q = b.chart.renderer;if (e.enabled || b._hasPointLabels) b.dlProcessOptions && b.dlProcessOptions(e), w = b.plotGroup("dataLabelsGroup", "data-labels", D && !r ? "hidden" : "visible", e.zIndex || 6), D && (w.attr({ opacity: +r }), r || E(b, "afterAnimate", function () {
        b.visible && w.show(!0);w[d.animation ? "animate" : "attr"]({ opacity: 1 }, { duration: 200 });
      })), m = e, p(f, function (f) {
        var k,
            p = f.dataLabel,
            g,
            x,
            r = f.connector,
            z = !p,
            C;h = f.dlOptions || f.options && f.options.dataLabels;(k = u(h && h.enabled, m.enabled) && !f.isNull) && (k = !0 === c(f, h || e));k && (e = n(m, h), g = f.getLabelConfig(), C = e[f.formatPrefix + "Format"] || e.format, t = H(C) ? l(C, g) : (e[f.formatPrefix + "Formatter"] || e.formatter).call(g, e), C = e.style, g = e.rotation, C.color = u(e.color, C.color, b.color, "#000000"), "contrast" === C.color && (f.contrastColor = q.getContrast(f.color || b.color), C.color = e.inside || 0 > u(f.labelDistance, e.distance) || d.stacking ? f.contrastColor : "#000000"), d.cursor && (C.cursor = d.cursor), x = { fill: e.backgroundColor, stroke: e.borderColor, "stroke-width": e.borderWidth, r: e.borderRadius || 0, rotation: g, padding: e.padding, zIndex: 1 }, a.objectEach(x, function (a, b) {
          void 0 === a && delete x[b];
        }));!p || k && H(t) ? k && H(t) && (p ? x.text = t : (p = f.dataLabel = g ? q.text(t, 0, -9999).addClass("highcharts-data-label") : q.label(t, 0, -9999, e.shape, null, null, e.useHTML, null, "data-label"), p.addClass(" highcharts-data-label-color-" + f.colorIndex + " " + (e.className || "") + (e.useHTML ? "highcharts-tracker" : ""))), p.attr(x), p.css(C).shadow(e.shadow), p.added || p.add(w), b.alignDataLabel(f, p, e, null, z)) : (f.dataLabel = p = p.destroy(), r && (f.connector = r.destroy()));
      });
    };h.prototype.alignDataLabel = function (a, b, d, e, h) {
      var c = this.chart,
          k = c.inverted,
          l = u(a.dlBox && a.dlBox.centerX, a.plotX, -9999),
          m = u(a.plotY, -9999),
          n = b.getBBox(),
          p,
          q = d.rotation,
          r = d.align,
          w = this.visible && (a.series.forceDL || c.isInsidePlot(l, Math.round(m), k) || e && c.isInsidePlot(l, k ? e.x + 1 : e.y + e.height - 1, k)),
          z = "justify" === u(d.overflow, "justify");if (w && (p = d.style.fontSize, p = c.renderer.fontMetrics(p, b).b, e = f({ x: k ? this.yAxis.len - m : l, y: Math.round(k ? this.xAxis.len - l : m), width: 0, height: 0 }, e), f(d, { width: n.width, height: n.height }), q ? (z = !1, l = c.renderer.rotCorr(p, q), l = { x: e.x + d.x + e.width / 2 + l.x, y: e.y + d.y + { top: 0, middle: .5, bottom: 1 }[d.verticalAlign] * e.height }, b[h ? "attr" : "animate"](l).attr({ align: r }), m = (q + 720) % 360, m = 180 < m && 360 > m, "left" === r ? l.y -= m ? n.height : 0 : "center" === r ? (l.x -= n.width / 2, l.y -= n.height / 2) : "right" === r && (l.x -= n.width, l.y -= m ? 0 : n.height)) : (b.align(d, null, e), l = b.alignAttr), z ? a.isLabelJustified = this.justifyDataLabel(b, d, l, n, e, h) : u(d.crop, !0) && (w = c.isInsidePlot(l.x, l.y) && c.isInsidePlot(l.x + n.width, l.y + n.height)), d.shape && !q)) b[h ? "attr" : "animate"]({ anchorX: k ? c.plotWidth - a.plotY : a.plotX, anchorY: k ? c.plotHeight - a.plotX : a.plotY });w || (b.attr({ y: -9999 }), b.placed = !1);
    };h.prototype.justifyDataLabel = function (a, b, d, e, f, h) {
      var c = this.chart,
          k = b.align,
          l = b.verticalAlign,
          m,
          n,
          p = a.box ? 0 : a.padding || 0;m = d.x + p;0 > m && ("right" === k ? b.align = "left" : b.x = -m, n = !0);
      m = d.x + e.width - p;m > c.plotWidth && ("left" === k ? b.align = "right" : b.x = c.plotWidth - m, n = !0);m = d.y + p;0 > m && ("bottom" === l ? b.verticalAlign = "top" : b.y = -m, n = !0);m = d.y + e.height - p;m > c.plotHeight && ("top" === l ? b.verticalAlign = "bottom" : b.y = c.plotHeight - m, n = !0);n && (a.placed = !h, a.align(b, null, f));return n;
    };m.pie && (m.pie.prototype.drawDataLabels = function () {
      var c = this,
          b = c.data,
          d,
          e = c.chart,
          f = c.options.dataLabels,
          l = u(f.connectorPadding, 10),
          m = u(f.connectorWidth, 1),
          n = e.plotWidth,
          t = e.plotHeight,
          r,
          w = c.center,
          q = w[2] / 2,
          A = w[1],
          F,
          G,
          g,
          v,
          E = [[], []],
          L,
          P,
          J,
          M,
          y = [0, 0, 0, 0];c.visible && (f.enabled || c._hasPointLabels) && (p(b, function (a) {
        a.dataLabel && a.visible && a.dataLabel.shortened && (a.dataLabel.attr({ width: "auto" }).css({ width: "auto", textOverflow: "clip" }), a.dataLabel.shortened = !1);
      }), h.prototype.drawDataLabels.apply(c), p(b, function (a) {
        a.dataLabel && a.visible && (E[a.half].push(a), a.dataLabel._pos = null);
      }), p(E, function (b, h) {
        var k,
            m,
            x = b.length,
            r = [],
            z;if (x) for (c.sortByAngle(b, h - .5), 0 < c.maxLabelDistance && (k = Math.max(0, A - q - c.maxLabelDistance), m = Math.min(A + q + c.maxLabelDistance, e.plotHeight), p(b, function (a) {
          0 < a.labelDistance && a.dataLabel && (a.top = Math.max(0, A - q - a.labelDistance), a.bottom = Math.min(A + q + a.labelDistance, e.plotHeight), z = a.dataLabel.getBBox().height || 21, a.positionsIndex = r.push({ target: a.labelPos[1] - a.top + z / 2, size: z, rank: a.y }) - 1);
        }), a.distribute(r, m + z - k)), M = 0; M < x; M++) {
          d = b[M], m = d.positionsIndex, g = d.labelPos, F = d.dataLabel, J = !1 === d.visible ? "hidden" : "inherit", P = k = g[1], r && H(r[m]) && (void 0 === r[m].pos ? J = "hidden" : (v = r[m].size, P = d.top + r[m].pos)), delete d.positionIndex, L = f.justify ? w[0] + (h ? -1 : 1) * (q + d.labelDistance) : c.getX(P < d.top + 2 || P > d.bottom - 2 ? k : P, h, d), F._attr = { visibility: J, align: g[6] }, F._pos = { x: L + f.x + ({ left: l, right: -l }[g[6]] || 0), y: P + f.y - 10 }, g.x = L, g.y = P, u(f.crop, !0) && (G = F.getBBox().width, k = null, L - G < l ? (k = Math.round(G - L + l), y[3] = Math.max(k, y[3])) : L + G > n - l && (k = Math.round(L + G - n + l), y[1] = Math.max(k, y[1])), 0 > P - v / 2 ? y[0] = Math.max(Math.round(-P + v / 2), y[0]) : P + v / 2 > t && (y[2] = Math.max(Math.round(P + v / 2 - t), y[2])), F.sideOverflow = k);
        }
      }), 0 === D(y) || this.verifyDataLabelOverflow(y)) && (this.placeDataLabels(), m && p(this.points, function (a) {
        var b;r = a.connector;if ((F = a.dataLabel) && F._pos && a.visible && 0 < a.labelDistance) {
          J = F._attr.visibility;if (b = !r) a.connector = r = e.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + a.colorIndex).add(c.dataLabelsGroup), r.attr({ "stroke-width": m, stroke: f.connectorColor || a.color || "#666666" });r[b ? "attr" : "animate"]({ d: c.connectorPath(a.labelPos) });r.attr("visibility", J);
        } else r && (a.connector = r.destroy());
      }));
    }, m.pie.prototype.connectorPath = function (a) {
      var b = a.x,
          c = a.y;return u(this.options.dataLabels.softConnector, !0) ? ["M", b + ("left" === a[6] ? 5 : -5), c, "C", b, c, 2 * a[2] - a[4], 2 * a[3] - a[5], a[2], a[3], "L", a[4], a[5]] : ["M", b + ("left" === a[6] ? 5 : -5), c, "L", a[2], a[3], "L", a[4], a[5]];
    }, m.pie.prototype.placeDataLabels = function () {
      p(this.points, function (a) {
        var b = a.dataLabel;b && a.visible && ((a = b._pos) ? (b.sideOverflow && (b._attr.width = b.getBBox().width - b.sideOverflow, b.css({ width: b._attr.width + "px", textOverflow: "ellipsis" }), b.shortened = !0), b.attr(b._attr), b[b.moved ? "animate" : "attr"](a), b.moved = !0) : b && b.attr({ y: -9999 }));
      }, this);
    }, m.pie.prototype.alignDataLabel = w, m.pie.prototype.verifyDataLabelOverflow = function (a) {
      var b = this.center,
          c = this.options,
          d = c.center,
          f = c.minSize || 80,
          h,
          l = null !== c.size;l || (null !== d[0] ? h = Math.max(b[2] - Math.max(a[1], a[3]), f) : (h = Math.max(b[2] - a[1] - a[3], f), b[0] += (a[3] - a[1]) / 2), null !== d[1] ? h = Math.max(Math.min(h, b[2] - Math.max(a[0], a[2])), f) : (h = Math.max(Math.min(h, b[2] - a[0] - a[2]), f), b[1] += (a[0] - a[2]) / 2), h < b[2] ? (b[2] = h, b[3] = Math.min(e(c.innerSize || 0, h), h), this.translate(b), this.drawDataLabels && this.drawDataLabels()) : l = !0);return l;
    });m.column && (m.column.prototype.alignDataLabel = function (a, b, d, e, f) {
      var c = this.chart.inverted,
          k = a.series,
          l = a.dlBox || a.shapeArgs,
          m = u(a.below, a.plotY > u(this.translatedThreshold, k.yAxis.len)),
          p = u(d.inside, !!this.options.stacking);l && (e = n(l), 0 > e.y && (e.height += e.y, e.y = 0), l = e.y + e.height - k.yAxis.len, 0 < l && (e.height -= l), c && (e = { x: k.yAxis.len - e.y - e.height, y: k.xAxis.len - e.x - e.width, width: e.height, height: e.width }), p || (c ? (e.x += m ? 0 : e.width, e.width = 0) : (e.y += m ? e.height : 0, e.height = 0)));d.align = u(d.align, !c || p ? "center" : m ? "right" : "left");d.verticalAlign = u(d.verticalAlign, c || p ? "middle" : m ? "top" : "bottom");h.prototype.alignDataLabel.call(this, a, b, d, e, f);a.isLabelJustified && a.contrastColor && a.dataLabel.css({ color: a.contrastColor });
    });
  })(M);(function (a) {
    var E = a.Chart,
        D = a.each,
        H = a.objectEach,
        p = a.pick;a = a.addEvent;a(E.prototype, "render", function () {
      var a = [];D(this.labelCollectors || [], function (f) {
        a = a.concat(f());
      });D(this.yAxis || [], function (f) {
        f.options.stackLabels && !f.options.stackLabels.allowOverlap && H(f.stacks, function (f) {
          H(f, function (f) {
            a.push(f.label);
          });
        });
      });D(this.series || [], function (f) {
        var l = f.options.dataLabels,
            n = f.dataLabelCollections || ["dataLabel"];(l.enabled || f._hasPointLabels) && !l.allowOverlap && f.visible && D(n, function (l) {
          D(f.points, function (f) {
            f[l] && (f[l].labelrank = p(f.labelrank, f.shapeArgs && f.shapeArgs.height), a.push(f[l]));
          });
        });
      });this.hideOverlappingLabels(a);
    });E.prototype.hideOverlappingLabels = function (a) {
      var f = a.length,
          p,
          n,
          w,
          u,
          e,
          h,
          m,
          d,
          c,
          b = function b(a, _b, c, d, e, f, h, l) {
        return !(e > a + c || e + h < a || f > _b + d || f + l < _b);
      };for (n = 0; n < f; n++) {
        if (p = a[n]) p.oldOpacity = p.opacity, p.newOpacity = 1, p.width || (w = p.getBBox(), p.width = w.width, p.height = w.height);
      }a.sort(function (a, b) {
        return (b.labelrank || 0) - (a.labelrank || 0);
      });for (n = 0; n < f; n++) {
        for (w = a[n], p = n + 1; p < f; ++p) {
          if (u = a[p], w && u && w !== u && w.placed && u.placed && 0 !== w.newOpacity && 0 !== u.newOpacity && (e = w.alignAttr, h = u.alignAttr, m = w.parentGroup, d = u.parentGroup, c = 2 * (w.box ? 0 : w.padding || 0), e = b(e.x + m.translateX, e.y + m.translateY, w.width - c, w.height - c, h.x + d.translateX, h.y + d.translateY, u.width - c, u.height - c))) (w.labelrank < u.labelrank ? w : u).newOpacity = 0;
        }
      }D(a, function (a) {
        var b, c;a && (c = a.newOpacity, a.oldOpacity !== c && a.placed && (c ? a.show(!0) : b = function b() {
          a.hide();
        }, a.alignAttr.opacity = c, a[a.isOld ? "animate" : "attr"](a.alignAttr, null, b)), a.isOld = !0);
      });
    };
  })(M);(function (a) {
    var E = a.addEvent,
        D = a.Chart,
        H = a.createElement,
        p = a.css,
        f = a.defaultOptions,
        l = a.defaultPlotOptions,
        r = a.each,
        n = a.extend,
        w = a.fireEvent,
        u = a.hasTouch,
        e = a.inArray,
        h = a.isObject,
        m = a.Legend,
        d = a.merge,
        c = a.pick,
        b = a.Point,
        k = a.Series,
        z = a.seriesTypes,
        B = a.svg,
        I;I = a.TrackerMixin = { drawTrackerPoint: function drawTrackerPoint() {
        var a = this,
            b = a.chart.pointer,
            c = function c(a) {
          var c = b.getPointFromEvent(a);void 0 !== c && (b.isDirectTouch = !0, c.onMouseOver(a));
        };r(a.points, function (a) {
          a.graphic && (a.graphic.element.point = a);a.dataLabel && (a.dataLabel.div ? a.dataLabel.div.point = a : a.dataLabel.element.point = a);
        });a._hasTracking || (r(a.trackerGroups, function (d) {
          if (a[d]) {
            a[d].addClass("highcharts-tracker").on("mouseover", c).on("mouseout", function (a) {
              b.onTrackerMouseOut(a);
            });
            if (u) a[d].on("touchstart", c);a.options.cursor && a[d].css(p).css({ cursor: a.options.cursor });
          }
        }), a._hasTracking = !0);
      }, drawTrackerGraph: function drawTrackerGraph() {
        var a = this,
            b = a.options,
            c = b.trackByArea,
            d = [].concat(c ? a.areaPath : a.graphPath),
            e = d.length,
            f = a.chart,
            h = f.pointer,
            k = f.renderer,
            l = f.options.tooltip.snap,
            g = a.tracker,
            m,
            n = function n() {
          if (f.hoverSeries !== a) a.onMouseOver();
        },
            p = "rgba(192,192,192," + (B ? .0001 : .002) + ")";if (e && !c) for (m = e + 1; m--;) {
          "M" === d[m] && d.splice(m + 1, 0, d[m + 1] - l, d[m + 2], "L"), (m && "M" === d[m] || m === e) && d.splice(m, 0, "L", d[m - 2] + l, d[m - 1]);
        }g ? g.attr({ d: d }) : a.graph && (a.tracker = k.path(d).attr({ "stroke-linejoin": "round", visibility: a.visible ? "visible" : "hidden", stroke: p, fill: c ? p : "none", "stroke-width": a.graph.strokeWidth() + (c ? 0 : 2 * l), zIndex: 2 }).add(a.group), r([a.tracker, a.markerGroup], function (a) {
          a.addClass("highcharts-tracker").on("mouseover", n).on("mouseout", function (a) {
            h.onTrackerMouseOut(a);
          });b.cursor && a.css({ cursor: b.cursor });if (u) a.on("touchstart", n);
        }));
      } };z.column && (z.column.prototype.drawTracker = I.drawTrackerPoint);
    z.pie && (z.pie.prototype.drawTracker = I.drawTrackerPoint);z.scatter && (z.scatter.prototype.drawTracker = I.drawTrackerPoint);n(m.prototype, { setItemEvents: function setItemEvents(a, c, e) {
        var f = this,
            h = f.chart.renderer.boxWrapper,
            k = "highcharts-legend-" + (a instanceof b ? "point" : "series") + "-active";(e ? c : a.legendGroup).on("mouseover", function () {
          a.setState("hover");h.addClass(k);c.css(f.options.itemHoverStyle);
        }).on("mouseout", function () {
          c.css(d(a.visible ? f.itemStyle : f.itemHiddenStyle));h.removeClass(k);a.setState();
        }).on("click", function (b) {
          var c = function c() {
            a.setVisible && a.setVisible();
          };h.removeClass(k);b = { browserEvent: b };a.firePointEvent ? a.firePointEvent("legendItemClick", b, c) : w(a, "legendItemClick", b, c);
        });
      }, createCheckboxForItem: function createCheckboxForItem(a) {
        a.checkbox = H("input", { type: "checkbox", checked: a.selected, defaultChecked: a.selected }, this.options.itemCheckboxStyle, this.chart.container);E(a.checkbox, "click", function (b) {
          w(a.series || a, "checkboxClick", { checked: b.target.checked, item: a }, function () {
            a.select();
          });
        });
      } });f.legend.itemStyle.cursor = "pointer";n(D.prototype, { showResetZoom: function showResetZoom() {
        var a = this,
            b = f.lang,
            c = a.options.chart.resetZoomButton,
            d = c.theme,
            e = d.states,
            h = "chart" === c.relativeTo ? null : "plotBox";this.resetZoomButton = a.renderer.button(b.resetZoom, null, null, function () {
          a.zoomOut();
        }, d, e && e.hover).attr({ align: c.position.align, title: b.resetZoomTitle }).addClass("highcharts-reset-zoom").add().align(c.position, !1, h);
      }, zoomOut: function zoomOut() {
        var a = this;w(a, "selection", { resetSelection: !0 }, function () {
          a.zoom();
        });
      }, zoom: function zoom(a) {
        var b,
            d = this.pointer,
            e = !1,
            f;!a || a.resetSelection ? (r(this.axes, function (a) {
          b = a.zoom();
        }), d.initiated = !1) : r(a.xAxis.concat(a.yAxis), function (a) {
          var c = a.axis;d[c.isXAxis ? "zoomX" : "zoomY"] && (b = c.zoom(a.min, a.max), c.displayBtn && (e = !0));
        });f = this.resetZoomButton;e && !f ? this.showResetZoom() : !e && h(f) && (this.resetZoomButton = f.destroy());b && this.redraw(c(this.options.chart.animation, a && a.animation, 100 > this.pointCount));
      }, pan: function pan(a, b) {
        var c = this,
            d = c.hoverPoints,
            e;d && r(d, function (a) {
          a.setState();
        });r("xy" === b ? [1, 0] : [1], function (b) {
          b = c[b ? "xAxis" : "yAxis"][0];var d = b.horiz,
              f = a[d ? "chartX" : "chartY"],
              d = d ? "mouseDownX" : "mouseDownY",
              h = c[d],
              g = (b.pointRange || 0) / 2,
              k = b.getExtremes(),
              l = b.toValue(h - f, !0) + g,
              m = b.toValue(h + b.len - f, !0) - g,
              n = m < l,
              h = n ? m : l,
              l = n ? l : m,
              m = Math.min(k.dataMin, g ? k.min : b.toValue(b.toPixels(k.min) - b.minPixelPadding)),
              g = Math.max(k.dataMax, g ? k.max : b.toValue(b.toPixels(k.max) + b.minPixelPadding)),
              n = m - h;0 < n && (l += n, h = m);n = l - g;0 < n && (l = g, h -= n);b.series.length && h !== k.min && l !== k.max && (b.setExtremes(h, l, !1, !1, { trigger: "pan" }), e = !0);c[d] = f;
        });e && c.redraw(!1);p(c.container, { cursor: "move" });
      } });n(b.prototype, { select: function select(a, b) {
        var d = this,
            f = d.series,
            h = f.chart;a = c(a, !d.selected);d.firePointEvent(a ? "select" : "unselect", { accumulate: b }, function () {
          d.selected = d.options.selected = a;f.options.data[e(d, f.data)] = d.options;d.setState(a && "select");b || r(h.getSelectedPoints(), function (a) {
            a.selected && a !== d && (a.selected = a.options.selected = !1, f.options.data[e(a, f.data)] = a.options, a.setState(""), a.firePointEvent("unselect"));
          });
        });
      }, onMouseOver: function onMouseOver(a) {
        var b = this.series.chart,
            c = b.pointer;a = a ? c.normalize(a) : c.getChartCoordinatesFromPoint(this, b.inverted);c.runPointActions(a, this);
      }, onMouseOut: function onMouseOut() {
        var a = this.series.chart;this.firePointEvent("mouseOut");r(a.hoverPoints || [], function (a) {
          a.setState();
        });a.hoverPoints = a.hoverPoint = null;
      }, importEvents: function importEvents() {
        if (!this.hasImportedEvents) {
          var b = this,
              c = d(b.series.options.point, b.options).events;b.events = c;a.objectEach(c, function (a, c) {
            E(b, c, a);
          });this.hasImportedEvents = !0;
        }
      }, setState: function setState(a, b) {
        var d = Math.floor(this.plotX),
            e = this.plotY,
            f = this.series,
            h = f.options.states[a] || {},
            k = l[f.type].marker && f.options.marker,
            m = k && !1 === k.enabled,
            p = k && k.states && k.states[a] || {},
            g = !1 === p.enabled,
            r = f.stateMarkerGraphic,
            u = this.marker || {},
            w = f.chart,
            x = f.halo,
            z,
            B = k && f.markerAttribs;a = a || "";if (!(a === this.state && !b || this.selected && "select" !== a || !1 === h.enabled || a && (g || m && !1 === p.enabled) || a && u.states && u.states[a] && !1 === u.states[a].enabled)) {
          B && (z = f.markerAttribs(this, a));if (this.graphic) this.state && this.graphic.removeClass("highcharts-point-" + this.state), a && this.graphic.addClass("highcharts-point-" + a), this.graphic.animate(f.pointAttribs(this, a), c(w.options.chart.animation, h.animation)), z && this.graphic.animate(z, c(w.options.chart.animation, p.animation, k.animation)), r && r.hide();else {
            if (a && p) {
              k = u.symbol || f.symbol;r && r.currentSymbol !== k && (r = r.destroy());if (r) r[b ? "animate" : "attr"]({ x: z.x, y: z.y });else k && (f.stateMarkerGraphic = r = w.renderer.symbol(k, z.x, z.y, z.width, z.height).add(f.markerGroup), r.currentSymbol = k);r && r.attr(f.pointAttribs(this, a));
            }r && (r[a && w.isInsidePlot(d, e, w.inverted) ? "show" : "hide"](), r.element.point = this);
          }(d = h.halo) && d.size ? (x || (f.halo = x = w.renderer.path().add((this.graphic || r).parentGroup)), x[b ? "animate" : "attr"]({ d: this.haloPath(d.size) }), x.attr({ "class": "highcharts-halo highcharts-color-" + c(this.colorIndex, f.colorIndex) }), x.point = this, x.attr(n({ fill: this.color || f.color, "fill-opacity": d.opacity, zIndex: -1 }, d.attributes))) : x && x.point && x.point.haloPath && x.animate({ d: x.point.haloPath(0) });this.state = a;
        }
      }, haloPath: function haloPath(a) {
        return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX) - a, this.plotY - a, 2 * a, 2 * a);
      } });n(k.prototype, { onMouseOver: function onMouseOver() {
        var a = this.chart,
            b = a.hoverSeries;if (b && b !== this) b.onMouseOut();this.options.events.mouseOver && w(this, "mouseOver");this.setState("hover");a.hoverSeries = this;
      }, onMouseOut: function onMouseOut() {
        var a = this.options,
            b = this.chart,
            c = b.tooltip,
            d = b.hoverPoint;b.hoverSeries = null;if (d) d.onMouseOut();this && a.events.mouseOut && w(this, "mouseOut");!c || this.stickyTracking || c.shared && !this.noSharedTooltip || c.hide();this.setState();
      }, setState: function setState(a) {
        var b = this,
            d = b.options,
            e = b.graph,
            f = d.states,
            h = d.lineWidth,
            d = 0;a = a || "";if (b.state !== a && (r([b.group, b.markerGroup, b.dataLabelsGroup], function (c) {
          c && (b.state && c.removeClass("highcharts-series-" + b.state), a && c.addClass("highcharts-series-" + a));
        }), b.state = a, !f[a] || !1 !== f[a].enabled) && (a && (h = f[a].lineWidth || h + (f[a].lineWidthPlus || 0)), e && !e.dashstyle)) for (h = { "stroke-width": h }, e.animate(h, c(b.chart.options.chart.animation, f[a] && f[a].animation)); b["zone-graph-" + d];) {
          b["zone-graph-" + d].attr(h), d += 1;
        }
      }, setVisible: function setVisible(a, b) {
        var c = this,
            d = c.chart,
            e = c.legendItem,
            f,
            h = d.options.chart.ignoreHiddenSeries,
            k = c.visible;f = (c.visible = a = c.options.visible = c.userOptions.visible = void 0 === a ? !k : a) ? "show" : "hide";r(["group", "dataLabelsGroup", "markerGroup", "tracker", "tt"], function (a) {
          if (c[a]) c[a][f]();
        });if (d.hoverSeries === c || (d.hoverPoint && d.hoverPoint.series) === c) c.onMouseOut();e && d.legend.colorizeItem(c, a);c.isDirty = !0;c.options.stacking && r(d.series, function (a) {
          a.options.stacking && a.visible && (a.isDirty = !0);
        });r(c.linkedSeries, function (b) {
          b.setVisible(a, !1);
        });h && (d.isDirtyBox = !0);!1 !== b && d.redraw();w(c, f);
      }, show: function show() {
        this.setVisible(!0);
      }, hide: function hide() {
        this.setVisible(!1);
      }, select: function select(a) {
        this.selected = a = void 0 === a ? !this.selected : a;this.checkbox && (this.checkbox.checked = a);w(this, a ? "select" : "unselect");
      }, drawTracker: I.drawTrackerGraph });
  })(M);(function (a) {
    var E = a.Chart,
        D = a.each,
        H = a.inArray,
        p = a.isArray,
        f = a.isObject,
        l = a.pick,
        r = a.splat;E.prototype.setResponsive = function (f) {
      var l = this.options.responsive,
          n = [],
          e = this.currentResponsive;l && l.rules && D(l.rules, function (e) {
        void 0 === e._id && (e._id = a.uniqueKey());this.matchResponsiveRule(e, n, f);
      }, this);var h = a.merge.apply(0, a.map(n, function (e) {
        return a.find(l.rules, function (a) {
          return a._id === e;
        }).chartOptions;
      })),
          n = n.toString() || void 0;n !== (e && e.ruleIds) && (e && this.update(e.undoOptions, f), n ? (this.currentResponsive = { ruleIds: n, mergedOptions: h, undoOptions: this.currentOptions(h) }, this.update(h, f)) : this.currentResponsive = void 0);
    };E.prototype.matchResponsiveRule = function (a, f) {
      var n = a.condition;(n.callback || function () {
        return this.chartWidth <= l(n.maxWidth, Number.MAX_VALUE) && this.chartHeight <= l(n.maxHeight, Number.MAX_VALUE) && this.chartWidth >= l(n.minWidth, 0) && this.chartHeight >= l(n.minHeight, 0);
      }).call(this) && f.push(a._id);
    };E.prototype.currentOptions = function (l) {
      function n(e, h, l, d) {
        var c;a.objectEach(e, function (a, e) {
          if (!d && -1 < H(e, ["series", "xAxis", "yAxis"])) for (a = r(a), l[e] = [], c = 0; c < a.length; c++) {
            h[e][c] && (l[e][c] = {}, n(a[c], h[e][c], l[e][c], d + 1));
          } else f(a) ? (l[e] = p(a) ? [] : {}, n(a, h[e] || {}, l[e], d + 1)) : l[e] = h[e] || null;
        });
      }var u = {};n(l, this.options, u, 0);return u;
    };
  })(M);return M;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(189)(module)))

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthUtil = AuthUtil;

var _angularCookies = __webpack_require__(94);

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _oem = __webpack_require__(56);

var _oem2 = _interopRequireDefault(_oem);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function AuthUtil($rootScope, $cookies, moment, OemService) {
  function is_admin(role) {
    return role === 'admin' || role === 'oem';
  }

  function is_operator(role) {
    return role === 'operator';
  }

  function is_viewer(role) {
    return role === 'viewer' || role === 'limited_viewer';
  }

  function is_limited_viewer(role) {
    return role === 'limited_viewer';
  }

  return {
    setUserInfo: function setUserInfo(user) {
      $rootScope.username = user.email;
      $rootScope.is_admin = is_admin(user.role);
      $rootScope.is_operator = is_operator(user.role);
      $rootScope.is_viewer = is_viewer(user.role);
      $rootScope.is_limited_viewer = is_limited_viewer(user.role);

      $rootScope.oemKey = $cookies.get('oemKey');

      var oemPromise = null;
      if (user.configName === 'oemUser') {
        oemPromise = OemService.oem_api.index().$promise;
      } else {
        oemPromise = OemService.api.index().$promise;
      }

      oemPromise.then(function (response) {
        $rootScope.demandEnabled = response.demand_alert_enabled;

        if (!$rootScope.oemKey) {
          $cookies.put('oemKey', response.logo_folder_name, { expires: moment().add(1, 'day').toDate() });
          $rootScope.oemKey = response.logo_folder_name;
        }

        if (!$rootScope.manualFile) {
          $cookies.put('manualFile', response.manual_file_name, { expires: moment().add(1, 'day').toDate() });
          $rootScope.manualFile = response.manual_file_name;
        }
      });
    },
    resetUserInfo: function resetUserInfo() {
      $rootScope.username = '';
      $rootScope.is_admin = $rootScope.is_operator = $rootScope.is_viewer = false;
      $rootScope.oemKey = null;
      $rootScope.manualFile = null;
      $cookies.remove('oemKey');
      $cookies.remove('manualFile');
    }
  };
}

exports.default = angular.module('leptonApp.AuthUtil', [_angularCookies2.default, _angularMoment2.default, _oem2.default]).factory('AuthUtil', ['$rootScope', '$cookies', 'moment', 'OemService', AuthUtil]).name;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var LoginStateControl = function () {
  /*@ngInject*/
  LoginStateControl.$inject = ["$location", "$state", "$rootScope"];
  function LoginStateControl($location, $state, $rootScope) {
    _classCallCheck(this, LoginStateControl);

    this.currentHostname = $location.host();
    this.isAdminMode = $location.search().admin_mode;
    this.demandId = $location.search().demand_id;

    this.location = $location;
    this.rootScope = $rootScope;

    this.$state = $state;
  }

  _createClass(LoginStateControl, [{
    key: 'goHome',
    value: function goHome(user) {
      if (this.rootScope.next) {
        this.$state.go(this.rootScope.next.name, this.rootScope.next.params);
        this.rootScope.next = null;
        return;
      }

      if (user.configName === 'oemUser') {
        this.$state.go('oem_main.oem_home');
      } else {
        this.$state.go('main.home');
      }
    }
  }, {
    key: 'goLogin',
    value: function goLogin(next) {
      var confirmationToken = this.location.search().confirm_token;
      if (next && next.url !== '/') {
        this.rootScope.next = next;
      }

      if (this.currentHostname.match(/-admin/) || this.isAdminMode) {
        if (confirmationToken) {
          this.$state.go('oem_user_confirm', { token: confirmationToken });
        } else {
          this.$state.go('oem_login');
        }
      } else {
        if (confirmationToken) {
          this.$state.go('end_user_confirm', { token: confirmationToken });
        } else {
          this.$state.go('login');
        }
      }
    }
  }, {
    key: 'rootToHome',
    value: function rootToHome(user) {
      if (this.location.path() === '/') {
        this.goHome(user);
      }
    }
  }]);

  return LoginStateControl;
}();

exports.default = angular.module('leptonApp.LoginStateControl', [_angularjs2.default]).service('LoginStateControl', ['$location', '$state', '$rootScope', LoginStateControl]).name;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function RoleToStringFilter() {
  return function (role) {
    if (role === 'admin') return "アカウント管理者";
    if (role === 'operator') return "オペレータ";
    if (role === 'viewer') return "閲覧者";
    if (role === 'limited_viewer') return "制限付き閲覧者";
  };
}

exports.default = angular.module('leptonApp.RoleToStringFilter', []).filter('roleToString', [RoleToStringFilter]).name;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function DecimalFilter($filter) {
  return function (input, decimalSize) {
    if (!input || Number.isNaN(input)) {
      return input;
    }
    var factor = Math.pow(10, decimalSize);
    var roundedNum = Math.round(input * factor) / factor;
    return $filter('number')(roundedNum);
  };
}

exports.default = angular.module('leptonApp.DecimalFilter', []).filter('decimalFilter', ['$filter', DecimalFilter]).name;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function DayFilter(moment) {
  return function (input) {
    var Week = ['日', '月', '火', '水', '木', '金', '土'];
    return Week[moment(input).day()];
  };
}

exports.default = angular.module('leptonApp.DayFilter', []).filter('dayFilter', ['moment', DayFilter]).name;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function NormalEventCount() {
  return function (events) {
    var count = 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var event = _step.value;

        if (!event.is_error) {
          count++;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return count;
  };
}

exports.default = angular.module('leptonApp.NormalEventCount', []).filter('normalEventCount', [NormalEventCount]).name;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function ErrorEventCount() {
  return function (events) {
    var count = 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var event = _step.value;

        if (event.is_error) {
          count++;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return count;
  };
}

exports.default = angular.module('leptonApp.ErrorEventCount', []).filter('errorEventCount', [ErrorEventCount]).name;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function CompanyListTitleFilter() {
  return function (stateName) {
    if (stateName === 'company_edit') {
      return '設定を変更する顧客を選択';
    }
    if (stateName === 'device_type_select') {
      return '端末を新規に作成する顧客を選択';
    }
    if (stateName === 'device_index') {
      return '設定変更する端末を持つ顧客を選択';
    }
    if (stateName === 'demand_control_index') {
      return 'デマンド制御を行う顧客を選択';
    }
    if (stateName === 'sa_reboot') {
      return '設顧客を選択';
    }
    if (stateName === 'notify_list_show') {
      return '通知先を設定する顧客を選択';
    }
    if (stateName === 'external_api_credential') {
      return 'API認証情報を確認する顧客を選択';
    }
  };
}

exports.default = angular.module('leptonApp.companyListTitle', []).filter('companyListTitle', [CompanyListTitleFilter]).name;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function WeatherNameFilter() {
  return function (weather_code) {
    switch (true) {
      case /2\d\d/.test(weather_code):
        return '雷雨';
      case /3\d\d/.test(weather_code):
        return '霧雨';
      case /5\d\d/.test(weather_code):
        return '雨';
      case /6\d\d/.test(weather_code):
        return '雪';
      case /7\d\d/.test(weather_code):
        return '霧';
      case /800/.test(weather_code):
        return '快晴';
      case /80\d/.test(weather_code):
        return '曇り';
      case /9\d\d/.test(weather_code):
        return '特殊';
    }
  };
}

exports.default = angular.module('leptonApp.WeatherName', []).filter('weather-name', [WeatherNameFilter]).name;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var CsvDownloader = function () {
    function CsvDownloader() {
        'ngInject';

        _classCallCheck(this, CsvDownloader);

        this.restrict = 'A';
        this.scope = {
            filename: '=',
            csvData: '='
        };
    }

    _createClass(CsvDownloader, [{
        key: 'link',
        value: function link(scope, element) {
            scope.$watch('filename', function (value) {
                element.attr('download', value);
            });

            scope.$watch('csvData', function (value) {
                var bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
                var blob = new Blob([bom, value], {
                    type: "text/csv;charset=utf-8"
                });
                var csv = null;
                if (window.navigator.msSaveBlob) {
                    element.attr('href', 'javascript: void(0);');
                    element.off('click');
                    element.on('click', function () {
                        window.navigator.msSaveBlob(blob, scope.filename);
                    });
                } else {
                    csv = window.URL.createObjectURL(blob);
                    element.attr('href', csv);
                }
            });
        }
    }]);

    return CsvDownloader;
}();

exports.default = angular.module('leptonApp.csvDownloader', []).directive('csvDownloader', [function () {
    return new CsvDownloader();
}]).name;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var BulkDownloader = function () {
  function BulkDownloader() {
    'ngInject';

    _classCallCheck(this, BulkDownloader);

    this.restrict = 'A';
    this.scope = {
      filename: '=',
      csvGenerator: '='
    };
  }

  _createClass(BulkDownloader, [{
    key: 'link',
    value: function link(scope, element) {
      var downloadLink = document.createElement('a');
      scope.$watch('filename', function (value) {
        downloadLink.setAttribute('download', value);
      });

      element.on('click', function () {
        scope.csvGenerator().then(function (csv) {
          var bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
          var blob = new Blob([bom, csv], {
            type: "text/csv;charset=utf-8"
          });

          if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, scope.filename);
          } else {
            var csvURL = window.URL.createObjectURL(blob);
            downloadLink.setAttribute('href', csvURL);

            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          }
        });
      });
    }
  }]);

  return BulkDownloader;
}();

exports.default = angular.module('leptonApp.bulkDownloader', []).directive('bulkDownloader', [function () {
  return new BulkDownloader();
}]).name;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _flatpickr = __webpack_require__(680);

var _flatpickr2 = _interopRequireDefault(_flatpickr);

var _ja = __webpack_require__(681);

var _moment = __webpack_require__(468);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DatePicker = function () {
  function DatePicker() {
    'ngInject';

    _classCallCheck(this, DatePicker);

    this.restrict = 'A';
    this.require = 'ngModel';
    this.scope = {
      ngModel: '=',
      ngChange: '&',
      maxRange: '=',
      maxDate: '='
    };
    this.replace = false;
  }

  _createClass(DatePicker, [{
    key: 'link',
    value: function link(scope, element) {
      var fp = new _flatpickr2.default(element[0], {
        onChange: function onChange(selectedDates) {
          if (selectedDates.length === 0) {
            return;
          }
          scope.$apply(function () {
            scope.ngModel = selectedDates[0];
          });
          scope.ngChange(selectedDates[0]);
        },
        maxDate: scope.maxDate,
        locale: _ja.Japanese
      });

      if (scope.maxRange) {
        fp.set('minDate', (0, _moment2.default)().subtract(scope.maxRange, 'days'));
      }

      scope.$watch('ngModel', function (newValue) {
        if (fp.selectedDates === newValue) {
          return;
        }
        fp.setDate(newValue);
      });
    }
  }]);

  return DatePicker;
}();

exports.default = angular.module('leptonApp.datepicker', []).directive('datepicker', [function () {
  return new DatePicker();
}]).name;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* flatpickr v4.3.2, @license MIT */
(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.flatpickr = {});
})(undefined, function (exports) {
    'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0
    
    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.
    
    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
        }
        return t;
    };

    var pad = function pad(number) {
        return ("0" + number).slice(-2);
    };
    var int = function int(bool) {
        return bool === true ? 1 : 0;
    };
    function debounce(func, wait, immediate) {
        if (immediate === void 0) {
            immediate = false;
        }
        var timeout;
        return function () {
            var context = this,
                args = arguments;
            timeout !== null && clearTimeout(timeout);
            timeout = window.setTimeout(function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            }, wait);
            if (immediate && !timeout) func.apply(context, args);
        };
    }
    var arrayify = function arrayify(obj) {
        return obj instanceof Array ? obj : [obj];
    };

    var do_nothing = function do_nothing() {
        return undefined;
    };
    var revFormat = {
        D: do_nothing,
        F: function F(dateObj, monthName, locale) {
            dateObj.setMonth(locale.months.longhand.indexOf(monthName));
        },
        G: function G(dateObj, hour) {
            dateObj.setHours(parseFloat(hour));
        },
        H: function H(dateObj, hour) {
            dateObj.setHours(parseFloat(hour));
        },
        J: function J(dateObj, day) {
            dateObj.setDate(parseFloat(day));
        },
        K: function K(dateObj, amPM, locale) {
            dateObj.setHours(dateObj.getHours() % 12 + 12 * int(new RegExp(locale.amPM[1], "i").test(amPM)));
        },
        M: function M(dateObj, shortMonth, locale) {
            dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
        },
        S: function S(dateObj, seconds) {
            dateObj.setSeconds(parseFloat(seconds));
        },
        U: function U(_, unixSeconds) {
            return new Date(parseFloat(unixSeconds) * 1000);
        },
        W: function W(dateObj, weekNum) {
            var weekNumber = parseInt(weekNum);
            return new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        },
        Y: function Y(dateObj, year) {
            dateObj.setFullYear(parseFloat(year));
        },
        Z: function Z(_, ISODate) {
            return new Date(ISODate);
        },
        d: function d(dateObj, day) {
            dateObj.setDate(parseFloat(day));
        },
        h: function h(dateObj, hour) {
            dateObj.setHours(parseFloat(hour));
        },
        i: function i(dateObj, minutes) {
            dateObj.setMinutes(parseFloat(minutes));
        },
        j: function j(dateObj, day) {
            dateObj.setDate(parseFloat(day));
        },
        l: do_nothing,
        m: function m(dateObj, month) {
            dateObj.setMonth(parseFloat(month) - 1);
        },
        n: function n(dateObj, month) {
            dateObj.setMonth(parseFloat(month) - 1);
        },
        s: function s(dateObj, seconds) {
            dateObj.setSeconds(parseFloat(seconds));
        },
        w: do_nothing,
        y: function y(dateObj, year) {
            dateObj.setFullYear(2000 + parseFloat(year));
        }
    };
    var tokenRegex = {
        D: "(\\w+)",
        F: "(\\w+)",
        G: "(\\d\\d|\\d)",
        H: "(\\d\\d|\\d)",
        J: "(\\d\\d|\\d)\\w+",
        K: "",
        M: "(\\w+)",
        S: "(\\d\\d|\\d)",
        U: "(.+)",
        W: "(\\d\\d|\\d)",
        Y: "(\\d{4})",
        Z: "(.+)",
        d: "(\\d\\d|\\d)",
        h: "(\\d\\d|\\d)",
        i: "(\\d\\d|\\d)",
        j: "(\\d\\d|\\d)",
        l: "(\\w+)",
        m: "(\\d\\d|\\d)",
        n: "(\\d\\d|\\d)",
        s: "(\\d\\d|\\d)",
        w: "(\\d\\d|\\d)",
        y: "(\\d{2})"
    };
    var formats = {
        Z: function Z(date) {
            return date.toISOString();
        },
        D: function D(date, locale, options) {
            return locale.weekdays.shorthand[formats.w(date, locale, options)];
        },
        F: function F(date, locale, options) {
            return monthToStr(formats.n(date, locale, options) - 1, false, locale);
        },
        G: function G(date, locale, options) {
            return pad(formats.h(date, locale, options));
        },
        H: function H(date) {
            return pad(date.getHours());
        },
        J: function J(date, locale) {
            return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
        },
        K: function K(date, locale) {
            return locale.amPM[int(date.getHours() > 11)];
        },
        M: function M(date, locale) {
            return monthToStr(date.getMonth(), true, locale);
        },
        S: function S(date) {
            return pad(date.getSeconds());
        },
        U: function U(date) {
            return date.getTime() / 1000;
        },
        W: function W(date, _, options) {
            return options.getWeek(date);
        },
        Y: function Y(date) {
            return date.getFullYear();
        },
        d: function d(date) {
            return pad(date.getDate());
        },
        h: function h(date) {
            return date.getHours() % 12 ? date.getHours() % 12 : 12;
        },
        i: function i(date) {
            return pad(date.getMinutes());
        },
        j: function j(date) {
            return date.getDate();
        },
        l: function l(date, locale) {
            return locale.weekdays.longhand[date.getDay()];
        },
        m: function m(date) {
            return pad(date.getMonth() + 1);
        },
        n: function n(date) {
            return date.getMonth() + 1;
        },
        s: function s(date) {
            return date.getSeconds();
        },
        w: function w(date) {
            return date.getDay();
        },
        y: function y(date) {
            return String(date.getFullYear()).substring(2);
        }
    };

    var english = {
        weekdays: {
            shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
        },
        months: {
            shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
        },
        daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        firstDayOfWeek: 0,
        ordinal: function ordinal(nth) {
            var s = nth % 100;
            if (s > 3 && s < 21) return "th";
            switch (s % 10) {
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        },
        rangeSeparator: " to ",
        weekAbbreviation: "Wk",
        scrollTitle: "Scroll to increment",
        toggleTitle: "Click to toggle",
        amPM: ["AM", "PM"]
    };

    var createDateFormatter = function createDateFormatter(_a) {
        var _b = _a.config,
            config = _b === void 0 ? defaults : _b,
            _c = _a.l10n,
            l10n = _c === void 0 ? english : _c;
        return function (dateObj, frmt, overrideLocale) {
            if (config.formatDate !== undefined) return config.formatDate(dateObj, frmt);
            var locale = overrideLocale || l10n;
            return frmt.split("").map(function (c, i, arr) {
                return formats[c] && arr[i - 1] !== "\\" ? formats[c](dateObj, locale, config) : c !== "\\" ? c : "";
            }).join("");
        };
    };
    var createDateParser = function createDateParser(_a) {
        var _b = _a.config,
            config = _b === void 0 ? defaults : _b,
            _c = _a.l10n,
            l10n = _c === void 0 ? english : _c;
        return function (date, givenFormat, timeless) {
            if (date !== 0 && !date) return undefined;
            var parsedDate;
            var date_orig = date;
            if (date instanceof Date) parsedDate = new Date(date.getTime());else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);else if (typeof date === "string") {
                var format = givenFormat || (config || defaults).dateFormat;
                var datestr = String(date).trim();
                if (datestr === "today") {
                    parsedDate = new Date();
                    timeless = true;
                } else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);else if (config && config.parseDate) parsedDate = config.parseDate(date, format);else {
                    parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                    var matched = void 0,
                        ops = [];
                    for (var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++) {
                        var token = format[i];
                        var isBackSlash = token === "\\";
                        var escaped = format[i - 1] === "\\" || isBackSlash;
                        if (tokenRegex[token] && !escaped) {
                            regexStr += tokenRegex[token];
                            var match = new RegExp(regexStr).exec(date);
                            if (match && (matched = true)) {
                                ops[token !== "Y" ? "push" : "unshift"]({
                                    fn: revFormat[token],
                                    val: match[++matchIndex]
                                });
                            }
                        } else if (!isBackSlash) regexStr += ".";
                        ops.forEach(function (_a) {
                            var fn = _a.fn,
                                val = _a.val;
                            return parsedDate = fn(parsedDate, val, l10n) || parsedDate;
                        });
                    }
                    parsedDate = matched ? parsedDate : undefined;
                }
            }
            if (!(parsedDate instanceof Date)) {
                config.errorHandler(new Error("Invalid date provided: " + date_orig));
                return undefined;
            }
            if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
            return parsedDate;
        };
    };
    function compareDates(date1, date2, timeless) {
        if (timeless === void 0) {
            timeless = true;
        }
        if (timeless !== false) {
            return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
        }
        return date1.getTime() - date2.getTime();
    }

    var monthToStr = function monthToStr(monthNumber, shorthand, locale) {
        return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
    };
    var getWeek = function getWeek(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    };
    var duration = {
        DAY: 86400000
    };

    var defaults = {
        _disable: [],
        _enable: [],
        allowInput: false,
        altFormat: "F j, Y",
        altInput: false,
        altInputClass: "form-control input",
        animate: (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
        ariaDateFormat: "F j, Y",
        clickOpens: true,
        closeOnSelect: true,
        conjunction: ", ",
        dateFormat: "Y-m-d",
        defaultHour: 12,
        defaultMinute: 0,
        defaultSeconds: 0,
        disable: [],
        disableMobile: false,
        enable: [],
        enableSeconds: false,
        enableTime: false,
        errorHandler: console.warn,
        getWeek: getWeek,
        hourIncrement: 1,
        ignoredFocusElements: [],
        inline: false,
        locale: "default",
        minuteIncrement: 5,
        mode: "single",
        nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
        noCalendar: false,
        onChange: [],
        onClose: [],
        onDayCreate: [],
        onDestroy: [],
        onKeyDown: [],
        onMonthChange: [],
        onOpen: [],
        onParseConfig: [],
        onReady: [],
        onValueUpdate: [],
        onYearChange: [],
        onPreCalendarPosition: [],
        plugins: [],
        position: "auto",
        positionElement: undefined,
        prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
        shorthandCurrentMonth: false,
        static: false,
        time_24hr: false,
        weekNumbers: false,
        wrap: false
    };

    function toggleClass(elem, className, bool) {
        if (bool === true) return elem.classList.add(className);
        elem.classList.remove(className);
    }
    function createElement(tag, className, content) {
        var e = window.document.createElement(tag);
        className = className || "";
        content = content || "";
        e.className = className;
        if (content !== undefined) e.textContent = content;
        return e;
    }
    function clearNode(node) {
        while (node.firstChild) {
            node.removeChild(node.firstChild);
        }
    }
    function findParent(node, condition) {
        if (condition(node)) return node;else if (node.parentNode) return findParent(node.parentNode, condition);
        return undefined;
    }
    function createNumberInput(inputClassName, opts) {
        var wrapper = createElement("div", "numInputWrapper"),
            numInput = createElement("input", "numInput " + inputClassName),
            arrowUp = createElement("span", "arrowUp"),
            arrowDown = createElement("span", "arrowDown");
        numInput.type = "text";
        numInput.pattern = "\\d*";
        if (opts !== undefined) for (var key in opts) {
            numInput.setAttribute(key, opts[key]);
        }wrapper.appendChild(numInput);
        wrapper.appendChild(arrowUp);
        wrapper.appendChild(arrowDown);
        return wrapper;
    }

    if (typeof Object.assign !== "function") {
        Object.assign = function (target) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (!target) {
                throw TypeError("Cannot convert undefined or null to object");
            }
            var _loop_1 = function _loop_1(source) {
                if (source) {
                    Object.keys(source).forEach(function (key) {
                        return target[key] = source[key];
                    });
                }
            };
            for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
                var source = args_1[_a];
                _loop_1(source);
            }
            return target;
        };
    }

    var DEBOUNCED_CHANGE_MS = 300;
    function FlatpickrInstance(element, instanceConfig) {
        var self = {
            config: __assign({}, flatpickr.defaultConfig),
            l10n: english
        };
        self.parseDate = createDateParser({ config: self.config, l10n: self.l10n });
        self._handlers = [];
        self._bind = bind;
        self._setHoursFromDate = setHoursFromDate;
        self.changeMonth = changeMonth;
        self.changeYear = changeYear;
        self.clear = clear;
        self.close = close;
        self._createElement = createElement;
        self.destroy = destroy;
        self.isEnabled = isEnabled;
        self.jumpToDate = jumpToDate;
        self.open = open;
        self.redraw = redraw;
        self.set = set;
        self.setDate = setDate;
        self.toggle = toggle;
        function setupHelperFunctions() {
            self.utils = {
                getDaysInMonth: function getDaysInMonth(month, yr) {
                    if (month === void 0) {
                        month = self.currentMonth;
                    }
                    if (yr === void 0) {
                        yr = self.currentYear;
                    }
                    if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                    return self.l10n.daysInMonth[month];
                }
            };
        }
        function init() {
            self.element = self.input = element;
            self.isOpen = false;
            parseConfig();
            setupLocale();
            setupInputs();
            setupDates();
            setupHelperFunctions();
            if (!self.isMobile) build();
            bindEvents();
            if (self.selectedDates.length || self.config.noCalendar) {
                if (self.config.enableTime) {
                    setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj || self.config.minDate : undefined);
                }
                updateValue(false);
            }
            self.showTimeInput = self.selectedDates.length > 0 || self.config.noCalendar;
            if (self.weekWrapper !== undefined && self.daysContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
                self.calendarContainer.style.width = self.daysContainer.offsetWidth + self.weekWrapper.offsetWidth + "px";
                self.calendarContainer.style.visibility = "visible";
                self.calendarContainer.style.display = null;
            }
            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            if (!self.isMobile && isSafari) {
                positionCalendar();
            }
            triggerEvent("onReady");
        }
        function bindToInstance(fn) {
            return fn.bind(self);
        }
        function updateTime(e) {
            if (self.config.noCalendar && self.selectedDates.length === 0) {
                self.setDate(self.config.minDate !== undefined ? new Date(self.config.minDate.getTime()) : new Date().setHours(self.config.defaultHour, self.config.defaultMinute, self.config.defaultSeconds, 0), false);
                setHoursFromInputs();
                updateValue();
            }
            timeWrapper(e);
            if (self.selectedDates.length === 0) return;
            if (e.type !== "input") {
                setHoursFromInputs();
                updateValue();
            } else {
                setTimeout(function () {
                    setHoursFromInputs();
                    updateValue();
                }, DEBOUNCED_CHANGE_MS);
            }
        }
        function ampm2military(hour, amPM) {
            return hour % 12 + 12 * int(amPM === self.l10n.amPM[1]);
        }
        function military2ampm(hour) {
            switch (hour % 24) {
                case 0:
                case 12:
                    return 12;
                default:
                    return hour % 12;
            }
        }
        function setHoursFromInputs() {
            if (self.hourElement === undefined || self.minuteElement === undefined) return;
            var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24,
                minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60,
                seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
            if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
            var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && compareDates(self.latestSelectedDateObj, self.config.minDate, true) === 0;
            var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && compareDates(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours()) minutes = Math.max(minutes, minTime.getMinutes());
            }
            setHours(hours, minutes, seconds);
        }
        function setHoursFromDate(dateObj) {
            var date = dateObj || self.latestSelectedDateObj;
            if (date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
        }
        function setHours(hours, minutes, seconds) {
            if (self.latestSelectedDateObj !== undefined) {
                self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
            }
            if (!self.hourElement || !self.minuteElement || self.isMobile) return;
            self.hourElement.value = pad(!self.config.time_24hr ? (12 + hours) % 12 + 12 * int(hours % 12 === 0) : hours);
            self.minuteElement.value = pad(minutes);
            if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[int(hours >= 12)];
            if (self.secondElement !== undefined) self.secondElement.value = pad(seconds);
        }
        function onYearInput(event) {
            var year = parseInt(event.target.value) + (event.delta || 0);
            if (year.toString().length === 4 || event.key === "Enter") {
                self.currentYearElement.blur();
                if (!/[^\d]/.test(year.toString())) changeYear(year);
            }
        }
        function bind(element, event, handler, options) {
            if (event instanceof Array) return event.forEach(function (ev) {
                return bind(element, ev, handler, options);
            });
            if (element instanceof Array) return element.forEach(function (el) {
                return bind(el, event, handler, options);
            });
            element.addEventListener(event, handler, options);
            self._handlers.push({ element: element, event: event, handler: handler });
        }
        function onClick(handler) {
            return function (evt) {
                evt.which === 1 && handler(evt);
            };
        }
        function triggerChange() {
            triggerEvent("onChange");
        }
        function bindEvents() {
            if (self.config.wrap) {
                ["open", "close", "toggle", "clear"].forEach(function (evt) {
                    Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function (el) {
                        return bind(el, "click", self[evt]);
                    });
                });
            }
            if (self.isMobile) {
                setupMobile();
                return;
            }
            var debouncedResize = debounce(onResize, 50);
            self._debouncedChange = debounce(triggerChange, DEBOUNCED_CHANGE_MS);
            if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function (e) {
                if (self.config.mode === "range") onMouseOver(e.target);
            });
            bind(window.document.body, "keydown", onKeyDown);
            if (!self.config.static) bind(self._input, "keydown", onKeyDown);
            if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
            if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
            bind(window.document, "mousedown", onClick(documentClick));
            bind(window.document, "focus", documentClick, { capture: true });
            if (self.config.clickOpens === true) {
                bind(self._input, "focus", self.open);
                bind(self._input, "mousedown", onClick(self.open));
            }
            if (self.daysContainer !== undefined) {
                bind(self.monthNav, "mousedown", onClick(onMonthNavClick));
                bind(self.monthNav, ["keyup", "increment"], onYearInput);
                bind(self.daysContainer, "mousedown", onClick(selectDate));
            }
            if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
                var selText = function selText(e) {
                    return e.target.select();
                };
                bind(self.timeContainer, ["input", "increment"], updateTime);
                bind(self.timeContainer, "mousedown", onClick(timeIncrement));
                bind(self.timeContainer, ["input", "increment"], self._debouncedChange, {
                    passive: true
                });
                bind([self.hourElement, self.minuteElement], ["focus", "click"], selText);
                if (self.secondElement !== undefined) bind(self.secondElement, "focus", function () {
                    return self.secondElement && self.secondElement.select();
                });
                if (self.amPM !== undefined) {
                    bind(self.amPM, "mousedown", onClick(function (e) {
                        updateTime(e);
                        triggerChange();
                    }));
                }
            }
        }
        function jumpToDate(jumpDate) {
            var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
            try {
                if (jumpTo !== undefined) {
                    self.currentYear = jumpTo.getFullYear();
                    self.currentMonth = jumpTo.getMonth();
                }
            } catch (e) {
                e.message = "Invalid date supplied: " + jumpTo;
                self.config.errorHandler(e);
            }
            self.redraw();
        }
        function timeIncrement(e) {
            if (~e.target.className.indexOf("arrow")) incrementNumInput(e, e.target.classList.contains("arrowUp") ? 1 : -1);
        }
        function incrementNumInput(e, delta, inputElem) {
            var target = e && e.target;
            var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
            var event = createEvent("increment");
            event.delta = delta;
            input && input.dispatchEvent(event);
        }
        function build() {
            var fragment = window.document.createDocumentFragment();
            self.calendarContainer = createElement("div", "flatpickr-calendar");
            self.calendarContainer.tabIndex = -1;
            if (!self.config.noCalendar) {
                fragment.appendChild(buildMonthNav());
                self.innerContainer = createElement("div", "flatpickr-innerContainer");
                if (self.config.weekNumbers) {
                    var _a = buildWeeks(),
                        weekWrapper = _a.weekWrapper,
                        weekNumbers = _a.weekNumbers;
                    self.innerContainer.appendChild(weekWrapper);
                    self.weekNumbers = weekNumbers;
                    self.weekWrapper = weekWrapper;
                }
                self.rContainer = createElement("div", "flatpickr-rContainer");
                self.rContainer.appendChild(buildWeekdays());
                if (!self.daysContainer) {
                    self.daysContainer = createElement("div", "flatpickr-days");
                    self.daysContainer.tabIndex = -1;
                }
                buildDays();
                self.rContainer.appendChild(self.daysContainer);
                self.innerContainer.appendChild(self.rContainer);
                fragment.appendChild(self.innerContainer);
            }
            if (self.config.enableTime) {
                fragment.appendChild(buildTime());
            }
            toggleClass(self.calendarContainer, "rangeMode", self.config.mode === "range");
            toggleClass(self.calendarContainer, "animate", self.config.animate);
            self.calendarContainer.appendChild(fragment);
            var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType;
            if (self.config.inline || self.config.static) {
                self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
                if (self.config.inline) {
                    if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
                }
                if (self.config.static) {
                    var wrapper = createElement("div", "flatpickr-wrapper");
                    if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                    wrapper.appendChild(self.element);
                    if (self.altInput) wrapper.appendChild(self.altInput);
                    wrapper.appendChild(self.calendarContainer);
                }
            }
            if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
        }
        function createDay(className, date, dayNumber, i) {
            var dateIsEnabled = isEnabled(date, true),
                dayElement = createElement("span", "flatpickr-day " + className, date.getDate().toString());
            dayElement.dateObj = date;
            dayElement.$i = i;
            dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
            if (compareDates(date, self.now) === 0) {
                self.todayDateElem = dayElement;
                dayElement.classList.add("today");
            }
            if (dateIsEnabled) {
                dayElement.tabIndex = -1;
                if (isDateSelected(date)) {
                    dayElement.classList.add("selected");
                    self.selectedDateElem = dayElement;
                    if (self.config.mode === "range") {
                        toggleClass(dayElement, "startRange", self.selectedDates[0] && compareDates(date, self.selectedDates[0]) === 0);
                        toggleClass(dayElement, "endRange", self.selectedDates[1] && compareDates(date, self.selectedDates[1]) === 0);
                    }
                }
            } else {
                dayElement.classList.add("disabled");
                if (self.selectedDates[0] && self.minRangeDate && date > self.minRangeDate && date < self.selectedDates[0]) self.minRangeDate = date;else if (self.selectedDates[0] && self.maxRangeDate && date < self.maxRangeDate && date > self.selectedDates[0]) self.maxRangeDate = date;
            }
            if (self.config.mode === "range") {
                if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
                if (self.selectedDates.length === 1 && self.minRangeDate !== undefined && self.maxRangeDate !== undefined && (date < self.minRangeDate || date > self.maxRangeDate)) dayElement.classList.add("notAllowed");
            }
            if (self.weekNumbers && className !== "prevMonthDay" && dayNumber % 7 === 1) {
                self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
            }
            triggerEvent("onDayCreate", dayElement);
            return dayElement;
        }
        function focusOnDay(currentIndex, offset) {
            var newIndex = currentIndex + offset || 0,
                targetNode = currentIndex !== undefined ? self.days.childNodes[newIndex] : self.selectedDateElem || self.todayDateElem || self.days.childNodes[0];
            var focus = function focus() {
                targetNode = targetNode || self.days.childNodes[newIndex];
                targetNode.focus();
                if (self.config.mode === "range") onMouseOver(targetNode);
            };
            if (targetNode === undefined && offset !== 0) {
                if (offset > 0) {
                    self.changeMonth(1, true, true);
                    newIndex = newIndex % 42;
                } else if (offset < 0) {
                    self.changeMonth(-1, true, true);
                    newIndex += 42;
                }
            }
            focus();
        }
        function buildDays() {
            if (self.daysContainer === undefined) {
                return;
            }
            var firstOfMonth = (new Date(self.currentYear, self.currentMonth, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7,
                isRangeMode = self.config.mode === "range";
            var prevMonthDays = self.utils.getDaysInMonth((self.currentMonth - 1 + 12) % 12);
            var daysInMonth = self.utils.getDaysInMonth(),
                days = window.document.createDocumentFragment();
            var dayNumber = prevMonthDays + 1 - firstOfMonth,
                dayIndex = 0;
            if (self.weekNumbers && self.weekNumbers.firstChild) self.weekNumbers.textContent = "";
            if (isRangeMode) {
                self.minRangeDate = new Date(self.currentYear, self.currentMonth - 1, dayNumber);
                self.maxRangeDate = new Date(self.currentYear, self.currentMonth + 1, (42 - firstOfMonth) % daysInMonth);
            }
            for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) {
                days.appendChild(createDay("prevMonthDay", new Date(self.currentYear, self.currentMonth - 1, dayNumber), dayNumber, dayIndex));
            }
            for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) {
                days.appendChild(createDay("", new Date(self.currentYear, self.currentMonth, dayNumber), dayNumber, dayIndex));
            }
            for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth; dayNum++, dayIndex++) {
                days.appendChild(createDay("nextMonthDay", new Date(self.currentYear, self.currentMonth + 1, dayNum % daysInMonth), dayNum, dayIndex));
            }
            if (isRangeMode && self.selectedDates.length === 1 && days.childNodes[0]) {
                self._hidePrevMonthArrow = self._hidePrevMonthArrow || !!self.minRangeDate && self.minRangeDate > days.childNodes[0].dateObj;
                self._hideNextMonthArrow = self._hideNextMonthArrow || !!self.maxRangeDate && self.maxRangeDate < new Date(self.currentYear, self.currentMonth + 1, 1);
            } else updateNavigationCurrentMonth();
            var dayContainer = createElement("div", "dayContainer");
            dayContainer.appendChild(days);
            clearNode(self.daysContainer);
            self.daysContainer.insertBefore(dayContainer, self.daysContainer.firstChild);
            self.days = self.daysContainer.firstChild;
        }
        function buildMonthNav() {
            var monthNavFragment = window.document.createDocumentFragment();
            self.monthNav = createElement("div", "flatpickr-month");
            self.prevMonthNav = createElement("span", "flatpickr-prev-month");
            self.prevMonthNav.innerHTML = self.config.prevArrow;
            self.currentMonthElement = createElement("span", "cur-month");
            var yearInput = createNumberInput("cur-year", { tabindex: "-1" });
            self.currentYearElement = yearInput.childNodes[0];
            if (self.config.minDate) self.currentYearElement.setAttribute("data-min", self.config.minDate.getFullYear().toString());
            if (self.config.maxDate) {
                self.currentYearElement.setAttribute("data-max", self.config.maxDate.getFullYear().toString());
                self.currentYearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
            }
            self.nextMonthNav = createElement("span", "flatpickr-next-month");
            self.nextMonthNav.innerHTML = self.config.nextArrow;
            self.navigationCurrentMonth = createElement("div", "flatpickr-current-month");
            self.navigationCurrentMonth.appendChild(self.currentMonthElement);
            self.navigationCurrentMonth.appendChild(yearInput);
            monthNavFragment.appendChild(self.prevMonthNav);
            monthNavFragment.appendChild(self.navigationCurrentMonth);
            monthNavFragment.appendChild(self.nextMonthNav);
            self.monthNav.appendChild(monthNavFragment);
            Object.defineProperty(self, "_hidePrevMonthArrow", {
                get: function get() {
                    return self.__hidePrevMonthArrow;
                },
                set: function set(bool) {
                    if (self.__hidePrevMonthArrow !== bool) self.prevMonthNav.style.display = bool ? "none" : "block";
                    self.__hidePrevMonthArrow = bool;
                }
            });
            Object.defineProperty(self, "_hideNextMonthArrow", {
                get: function get() {
                    return self.__hideNextMonthArrow;
                },
                set: function set(bool) {
                    if (self.__hideNextMonthArrow !== bool) self.nextMonthNav.style.display = bool ? "none" : "block";
                    self.__hideNextMonthArrow = bool;
                }
            });
            updateNavigationCurrentMonth();
            return self.monthNav;
        }
        function buildTime() {
            self.calendarContainer.classList.add("hasTime");
            if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
            self.timeContainer = createElement("div", "flatpickr-time");
            self.timeContainer.tabIndex = -1;
            var separator = createElement("span", "flatpickr-time-separator", ":");
            var hourInput = createNumberInput("flatpickr-hour");
            self.hourElement = hourInput.childNodes[0];
            var minuteInput = createNumberInput("flatpickr-minute");
            self.minuteElement = minuteInput.childNodes[0];
            self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
            self.hourElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? self.config.defaultHour : military2ampm(self.config.defaultHour));
            self.minuteElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : self.config.defaultMinute);
            self.hourElement.setAttribute("data-step", self.config.hourIncrement.toString());
            self.minuteElement.setAttribute("data-step", self.config.minuteIncrement.toString());
            self.hourElement.setAttribute("data-min", self.config.time_24hr ? "0" : "1");
            self.hourElement.setAttribute("data-max", self.config.time_24hr ? "23" : "12");
            self.minuteElement.setAttribute("data-min", "0");
            self.minuteElement.setAttribute("data-max", "59");
            self.timeContainer.appendChild(hourInput);
            self.timeContainer.appendChild(separator);
            self.timeContainer.appendChild(minuteInput);
            if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
            if (self.config.enableSeconds) {
                self.timeContainer.classList.add("hasSeconds");
                var secondInput = createNumberInput("flatpickr-second");
                self.secondElement = secondInput.childNodes[0];
                self.secondElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : self.config.defaultSeconds);
                self.secondElement.setAttribute("data-step", self.minuteElement.getAttribute("data-step"));
                self.secondElement.setAttribute("data-min", self.minuteElement.getAttribute("data-min"));
                self.secondElement.setAttribute("data-max", self.minuteElement.getAttribute("data-max"));
                self.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
                self.timeContainer.appendChild(secondInput);
            }
            if (!self.config.time_24hr) {
                self.amPM = createElement("span", "flatpickr-am-pm", self.l10n.amPM[int((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
                self.amPM.title = self.l10n.toggleTitle;
                self.amPM.tabIndex = -1;
                self.timeContainer.appendChild(self.amPM);
            }
            return self.timeContainer;
        }
        function buildWeekdays() {
            if (!self.weekdayContainer) self.weekdayContainer = createElement("div", "flatpickr-weekdays");
            var firstDayOfWeek = self.l10n.firstDayOfWeek;
            var weekdays = self.l10n.weekdays.shorthand.slice();
            if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
                weekdays = weekdays.splice(firstDayOfWeek, weekdays.length).concat(weekdays.splice(0, firstDayOfWeek));
            }
            self.weekdayContainer.innerHTML = "\n    <span class=flatpickr-weekday>\n      " + weekdays.join("</span><span class=flatpickr-weekday>") + "\n    </span>\n    ";
            return self.weekdayContainer;
        }
        function buildWeeks() {
            self.calendarContainer.classList.add("hasWeeks");
            var weekWrapper = createElement("div", "flatpickr-weekwrapper");
            weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
            var weekNumbers = createElement("div", "flatpickr-weeks");
            weekWrapper.appendChild(weekNumbers);
            return {
                weekWrapper: weekWrapper,
                weekNumbers: weekNumbers
            };
        }
        function changeMonth(value, is_offset, from_keyboard) {
            if (is_offset === void 0) {
                is_offset = true;
            }
            if (from_keyboard === void 0) {
                from_keyboard = false;
            }
            var delta = is_offset ? value : value - self.currentMonth;
            if (delta < 0 && self._hidePrevMonthArrow || delta > 0 && self._hideNextMonthArrow) return;
            self.currentMonth += delta;
            if (self.currentMonth < 0 || self.currentMonth > 11) {
                self.currentYear += self.currentMonth > 11 ? 1 : -1;
                self.currentMonth = (self.currentMonth + 12) % 12;
                triggerEvent("onYearChange");
            }
            buildDays();
            triggerEvent("onMonthChange");
            updateNavigationCurrentMonth();
            if (from_keyboard && document.activeElement && document.activeElement.$i) {
                var index = document.activeElement.$i;
                focusOnDay(index, 0);
            }
        }
        function clear(triggerChangeEvent) {
            if (triggerChangeEvent === void 0) {
                triggerChangeEvent = true;
            }
            self.input.value = "";
            if (self.altInput) self.altInput.value = "";
            if (self.mobileInput) self.mobileInput.value = "";
            self.selectedDates = [];
            self.latestSelectedDateObj = undefined;
            self.showTimeInput = false;
            if (self.config.enableTime) {
                if (self.config.minDate !== undefined) setHoursFromDate(self.config.minDate);else setHours(self.config.defaultHour, self.config.defaultMinute, self.config.defaultSeconds);
            }
            self.redraw();
            if (triggerChangeEvent) triggerEvent("onChange");
        }
        function close() {
            self.isOpen = false;
            if (!self.isMobile) {
                self.calendarContainer.classList.remove("open");
                self._input.classList.remove("active");
            }
            triggerEvent("onClose");
        }
        function destroy() {
            if (self.config !== undefined) triggerEvent("onDestroy");
            for (var i = self._handlers.length; i--;) {
                var h = self._handlers[i];
                h.element.removeEventListener(h.event, h.handler);
            }
            self._handlers = [];
            if (self.mobileInput) {
                if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
                self.mobileInput = undefined;
            } else if (self.calendarContainer && self.calendarContainer.parentNode) self.calendarContainer.parentNode.removeChild(self.calendarContainer);
            if (self.altInput) {
                self.input.type = "text";
                if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
                delete self.altInput;
            }
            if (self.input) {
                self.input.type = self.input._type;
                self.input.classList.remove("flatpickr-input");
                self.input.removeAttribute("readonly");
                self.input.value = "";
            }
            ["_showTimeInput", "latestSelectedDateObj", "_hideNextMonthArrow", "_hidePrevMonthArrow", "__hideNextMonthArrow", "__hidePrevMonthArrow", "isMobile", "isOpen", "selectedDateElem", "minDateHasTime", "maxDateHasTime", "days", "daysContainer", "_input", "_positionElement", "innerContainer", "rContainer", "monthNav", "todayDateElem", "calendarContainer", "weekdayContainer", "prevMonthNav", "nextMonthNav", "currentMonthElement", "currentYearElement", "navigationCurrentMonth", "selectedDateElem", "config"].forEach(function (k) {
                try {
                    delete self[k];
                } catch (_) {}
            });
        }
        function isCalendarElem(elem) {
            if (self.config.appendTo && self.config.appendTo.contains(elem)) return true;
            return self.calendarContainer.contains(elem);
        }
        function documentClick(e) {
            if (self.isOpen && !self.config.inline) {
                var isCalendarElement = isCalendarElem(e.target);
                var isInput = e.target === self.input || e.target === self.altInput || self.element.contains(e.target) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
                var lostFocus = e.type === "blur" ? isInput && e.relatedTarget && !isCalendarElem(e.relatedTarget) : !isInput && !isCalendarElement;
                var isIgnored = !self.config.ignoredFocusElements.some(function (elem) {
                    return elem.contains(e.target);
                });
                if (lostFocus && isIgnored) {
                    self.close();
                    if (self.config.mode === "range" && self.selectedDates.length === 1) {
                        self.clear(false);
                        self.redraw();
                    }
                }
            }
        }
        function changeYear(newYear) {
            if (!newYear || self.currentYearElement.getAttribute("data-min") && newYear < parseInt(self.currentYearElement.getAttribute("data-min")) || self.currentYearElement.getAttribute("data-max") && newYear > parseInt(self.currentYearElement.getAttribute("data-max"))) return;
            var newYearNum = newYear,
                isNewYear = self.currentYear !== newYearNum;
            self.currentYear = newYearNum || self.currentYear;
            if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) {
                self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
            } else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) {
                self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
            }
            if (isNewYear) {
                self.redraw();
                triggerEvent("onYearChange");
            }
        }
        function isEnabled(date, timeless) {
            if (timeless === void 0) {
                timeless = true;
            }
            var dateToCheck = self.parseDate(date, undefined, timeless);
            if (self.config.minDate && dateToCheck && compareDates(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && compareDates(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
            if (!self.config.enable.length && !self.config.disable.length) return true;
            if (dateToCheck === undefined) return false;
            var bool = self.config.enable.length > 0,
                array = bool ? self.config.enable : self.config.disable;
            for (var i = 0, d = void 0; i < array.length; i++) {
                d = array[i];
                if (typeof d === "function" && d(dateToCheck)) return bool;else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;else if (typeof d === "string" && dateToCheck !== undefined) {
                    var parsed = self.parseDate(d, undefined, true);
                    return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
                } else if ((typeof d === 'undefined' ? 'undefined' : _typeof(d)) === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
            }
            return !bool;
        }
        function onKeyDown(e) {
            var isInput = e.target === self._input;
            var calendarElem = isCalendarElem(e.target);
            var allowInput = self.config.allowInput;
            var allowKeydown = self.isOpen && (!allowInput || !isInput);
            var allowInlineKeydown = self.config.inline && isInput && !allowInput;
            if (e.keyCode === 13 && isInput) {
                if (allowInput) {
                    self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
                    return e.target.blur();
                } else self.open();
            } else if (calendarElem || allowKeydown || allowInlineKeydown) {
                var isTimeObj = !!self.timeContainer && self.timeContainer.contains(e.target);
                switch (e.keyCode) {
                    case 13:
                        if (isTimeObj) updateValue();else selectDate(e);
                        break;
                    case 27:
                        e.preventDefault();
                        self.close();
                        break;
                    case 8:
                    case 46:
                        if (isInput && !self.config.allowInput) self.clear();
                        break;
                    case 37:
                    case 39:
                        if (!isTimeObj) {
                            e.preventDefault();
                            if (self.daysContainer) {
                                var delta_1 = e.keyCode === 39 ? 1 : -1;
                                if (!e.ctrlKey) focusOnDay(e.target.$i, delta_1);else changeMonth(delta_1, true, true);
                            }
                        } else if (self.hourElement) self.hourElement.focus();
                        break;
                    case 38:
                    case 40:
                        e.preventDefault();
                        var delta = e.keyCode === 40 ? 1 : -1;
                        if (self.daysContainer && e.target.$i !== undefined) {
                            if (e.ctrlKey) {
                                changeYear(self.currentYear - delta);
                                focusOnDay(e.target.$i, 0);
                            } else if (!isTimeObj) focusOnDay(e.target.$i, delta * 7);
                        } else if (self.config.enableTime) {
                            if (!isTimeObj && self.hourElement) self.hourElement.focus();
                            updateTime(e);
                            self._debouncedChange();
                        }
                        break;
                    case 9:
                        if (e.target === self.hourElement) {
                            e.preventDefault();
                            self.minuteElement.select();
                        } else if (e.target === self.minuteElement && (self.secondElement || self.amPM)) {
                            e.preventDefault();
                            if (self.secondElement !== undefined) self.secondElement.focus();else if (self.amPM !== undefined) self.amPM.focus();
                        } else if (e.target === self.secondElement && self.amPM) {
                            e.preventDefault();
                            self.amPM.focus();
                        }
                        break;
                    default:
                        break;
                }
                switch (e.key) {
                    case self.l10n.amPM[0].charAt(0):
                        if (self.amPM !== undefined && e.target === self.amPM) {
                            self.amPM.textContent = self.l10n.amPM[0];
                            setHoursFromInputs();
                            updateValue();
                        }
                        break;
                    case self.l10n.amPM[1].charAt(0):
                        if (self.amPM !== undefined && e.target === self.amPM) {
                            self.amPM.textContent = self.l10n.amPM[1];
                            setHoursFromInputs();
                            updateValue();
                        }
                        break;
                    default:
                        break;
                }
                triggerEvent("onKeyDown", e);
            }
        }
        function onMouseOver(elem) {
            if (self.selectedDates.length !== 1 || !elem.classList.contains("flatpickr-day") || elem.classList.contains("disabled") || self.minRangeDate === undefined || self.maxRangeDate === undefined) return;
            var hoverDate = elem.dateObj,
                initialDate = self.parseDate(self.selectedDates[0], undefined, true),
                rangeStartDate = Math.min(hoverDate.getTime(), self.selectedDates[0].getTime()),
                rangeEndDate = Math.max(hoverDate.getTime(), self.selectedDates[0].getTime()),
                containsDisabled = false;
            for (var t = rangeStartDate; t < rangeEndDate; t += duration.DAY) {
                if (!isEnabled(new Date(t))) {
                    containsDisabled = true;
                    break;
                }
            }
            var _loop_1 = function _loop_1(i, date) {
                var timestamp = date.getTime();
                var outOfRange = timestamp < self.minRangeDate.getTime() || timestamp > self.maxRangeDate.getTime(),
                    dayElem = self.days.childNodes[i];
                if (outOfRange) {
                    dayElem.classList.add("notAllowed");
                    ["inRange", "startRange", "endRange"].forEach(function (c) {
                        dayElem.classList.remove(c);
                    });
                    return "continue";
                } else if (containsDisabled && !outOfRange) return "continue";
                ["startRange", "inRange", "endRange", "notAllowed"].forEach(function (c) {
                    dayElem.classList.remove(c);
                });
                var minRangeDate = Math.max(self.minRangeDate.getTime(), rangeStartDate),
                    maxRangeDate = Math.min(self.maxRangeDate.getTime(), rangeEndDate);
                elem.classList.add(hoverDate < self.selectedDates[0] ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate.getTime()) dayElem.classList.add("startRange");else if (initialDate > hoverDate && timestamp === initialDate.getTime()) dayElem.classList.add("endRange");
                if (timestamp >= minRangeDate && timestamp <= maxRangeDate) dayElem.classList.add("inRange");
            };
            for (var i = 0, date = self.days.childNodes[i].dateObj; i < 42; i++, date = self.days.childNodes[i] && self.days.childNodes[i].dateObj) {
                _loop_1(i, date);
            }
        }
        function onResize() {
            if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
        }
        function open(e, positionElement) {
            if (positionElement === void 0) {
                positionElement = self._input;
            }
            if (self.isMobile) {
                if (e) {
                    e.preventDefault();
                    e.target && e.target.blur();
                }
                setTimeout(function () {
                    self.mobileInput !== undefined && self.mobileInput.click();
                }, 0);
                triggerEvent("onOpen");
                return;
            }
            if (self._input.disabled || self.config.inline) return;
            var wasOpen = self.isOpen;
            self.isOpen = true;
            if (!wasOpen) {
                self.calendarContainer.classList.add("open");
                self._input.classList.add("active");
                triggerEvent("onOpen");
                positionCalendar(positionElement);
            }
        }
        function minMaxDateSetter(type) {
            return function (date) {
                var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
                var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
                if (dateObj !== undefined) {
                    self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
                }
                if (self.selectedDates) {
                    self.selectedDates = self.selectedDates.filter(function (d) {
                        return isEnabled(d);
                    });
                    if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                    updateValue();
                }
                if (self.daysContainer) {
                    redraw();
                    if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();else self.currentYearElement.removeAttribute(type);
                    self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
                }
            };
        }
        function parseConfig() {
            var boolOpts = ["wrap", "weekNumbers", "allowInput", "clickOpens", "time_24hr", "enableTime", "noCalendar", "altInput", "shorthandCurrentMonth", "inline", "static", "enableSeconds", "disableMobile"];
            var hooks = ["onChange", "onClose", "onDayCreate", "onDestroy", "onKeyDown", "onMonthChange", "onOpen", "onParseConfig", "onReady", "onValueUpdate", "onYearChange", "onPreCalendarPosition"];
            var userConfig = __assign({}, instanceConfig, JSON.parse(JSON.stringify(element.dataset || {})));
            var formats$$1 = {};
            self.config.parseDate = userConfig.parseDate;
            self.config.formatDate = userConfig.formatDate;
            Object.defineProperty(self.config, "enable", {
                get: function get() {
                    return self.config._enable || [];
                },
                set: function set(dates) {
                    self.config._enable = parseDateRules(dates);
                }
            });
            Object.defineProperty(self.config, "disable", {
                get: function get() {
                    return self.config._disable || [];
                },
                set: function set(dates) {
                    self.config._disable = parseDateRules(dates);
                }
            });
            if (!userConfig.dateFormat && userConfig.enableTime) {
                formats$$1.dateFormat = userConfig.noCalendar ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : flatpickr.defaultConfig.dateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
            }
            if (userConfig.altInput && userConfig.enableTime && !userConfig.altFormat) {
                formats$$1.altFormat = userConfig.noCalendar ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : flatpickr.defaultConfig.altFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
            }
            Object.defineProperty(self.config, "minDate", {
                get: function get() {
                    return self.config._minDate;
                },
                set: minMaxDateSetter("min")
            });
            Object.defineProperty(self.config, "maxDate", {
                get: function get() {
                    return self.config._maxDate;
                },
                set: minMaxDateSetter("max")
            });
            var minMaxTimeSetter = function minMaxTimeSetter(type) {
                return function (val) {
                    self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i");
                };
            };
            Object.defineProperty(self.config, "minTime", {
                get: function get() {
                    return self.config._minTime;
                },
                set: minMaxTimeSetter("min")
            });
            Object.defineProperty(self.config, "maxTime", {
                get: function get() {
                    return self.config._maxTime;
                },
                set: minMaxTimeSetter("max")
            });
            Object.assign(self.config, formats$$1, userConfig);
            for (var i = 0; i < boolOpts.length; i++) {
                self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
            }for (var i = hooks.length; i--;) {
                if (self.config[hooks[i]] !== undefined) {
                    self.config[hooks[i]] = arrayify(self.config[hooks[i]] || []).map(bindToInstance);
                }
            }
            for (var i = 0; i < self.config.plugins.length; i++) {
                var pluginConf = self.config.plugins[i](self) || {};
                for (var key in pluginConf) {
                    if (~hooks.indexOf(key)) {
                        self.config[key] = arrayify(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                    } else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
                }
            }
            self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable.length && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            triggerEvent("onParseConfig");
        }
        function setupLocale() {
            if (_typeof(self.config.locale) !== "object" && typeof flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
            self.l10n = __assign({}, flatpickr.l10ns.default, _typeof(self.config.locale) === "object" ? self.config.locale : self.config.locale !== "default" ? flatpickr.l10ns[self.config.locale] : undefined);
            tokenRegex.K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
            self.formatDate = createDateFormatter(self);
        }
        function positionCalendar(customPositionElement) {
            if (self.calendarContainer === undefined) return;
            triggerEvent("onPreCalendarPosition");
            var positionElement = customPositionElement || self._positionElement;
            var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function (acc, child) {
                return acc + child.offsetHeight;
            }, 0),
                calendarWidth = self.calendarContainer.offsetWidth,
                configPos = self.config.position,
                inputBounds = positionElement.getBoundingClientRect(),
                distanceFromBottom = window.innerHeight - inputBounds.bottom,
                showOnTop = configPos === "above" || configPos !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
            var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
            toggleClass(self.calendarContainer, "arrowTop", !showOnTop);
            toggleClass(self.calendarContainer, "arrowBottom", showOnTop);
            if (self.config.inline) return;
            var left = window.pageXOffset + inputBounds.left;
            var right = window.document.body.offsetWidth - inputBounds.right;
            var rightMost = left + calendarWidth > window.document.body.offsetWidth;
            toggleClass(self.calendarContainer, "rightMost", rightMost);
            if (self.config.static) return;
            self.calendarContainer.style.top = top + "px";
            if (!rightMost) {
                self.calendarContainer.style.left = left + "px";
                self.calendarContainer.style.right = "auto";
            } else {
                self.calendarContainer.style.left = "auto";
                self.calendarContainer.style.right = right + "px";
            }
        }
        function redraw() {
            if (self.config.noCalendar || self.isMobile) return;
            buildWeekdays();
            updateNavigationCurrentMonth();
            buildDays();
        }
        function focusAndClose() {
            self._input.focus();
            if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) {
                setTimeout(self.close, 0);
            } else {
                self.close();
            }
        }
        function selectDate(e) {
            e.preventDefault();
            e.stopPropagation();
            var isSelectable = function isSelectable(day) {
                return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("disabled") && !day.classList.contains("notAllowed");
            };
            var t = findParent(e.target, isSelectable);
            if (t === undefined) return;
            var target = t;
            var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
            var shouldChangeMonth = selectedDate.getMonth() !== self.currentMonth && self.config.mode !== "range";
            self.selectedDateElem = target;
            if (self.config.mode === "single") self.selectedDates = [selectedDate];else if (self.config.mode === "multiple") {
                var selectedIndex = isDateSelected(selectedDate);
                if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);else self.selectedDates.push(selectedDate);
            } else if (self.config.mode === "range") {
                if (self.selectedDates.length === 2) self.clear();
                self.selectedDates.push(selectedDate);
                if (compareDates(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function (a, b) {
                    return a.getTime() - b.getTime();
                });
            }
            setHoursFromInputs();
            if (shouldChangeMonth) {
                var isNewYear = self.currentYear !== selectedDate.getFullYear();
                self.currentYear = selectedDate.getFullYear();
                self.currentMonth = selectedDate.getMonth();
                if (isNewYear) triggerEvent("onYearChange");
                triggerEvent("onMonthChange");
            }
            buildDays();
            if (self.config.minDate && self.minDateHasTime && self.config.enableTime && compareDates(selectedDate, self.config.minDate) === 0) setHoursFromDate(self.config.minDate);
            updateValue();
            if (self.config.enableTime) setTimeout(function () {
                return self.showTimeInput = true;
            }, 50);
            if (self.config.mode === "range") {
                if (self.selectedDates.length === 1) {
                    onMouseOver(target);
                    self._hidePrevMonthArrow = self._hidePrevMonthArrow || self.minRangeDate !== undefined && self.minRangeDate > self.days.childNodes[0].dateObj;
                    self._hideNextMonthArrow = self._hideNextMonthArrow || self.maxRangeDate !== undefined && self.maxRangeDate < new Date(self.currentYear, self.currentMonth + 1, 1);
                } else updateNavigationCurrentMonth();
            }
            if (!shouldChangeMonth) focusOnDay(target.$i, 0);else self.selectedDateElem && self.selectedDateElem.focus();
            if (self.hourElement !== undefined) setTimeout(function () {
                return self.hourElement !== undefined && self.hourElement.select();
            }, 451);
            if (self.config.closeOnSelect) {
                var single = self.config.mode === "single" && !self.config.enableTime;
                var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
                if (single || range) {
                    focusAndClose();
                }
            }
            triggerChange();
        }
        var CALLBACKS = {
            locale: [setupLocale]
        };
        function set(option, value) {
            if (option !== null && (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === "object") Object.assign(self.config, option);else {
                self.config[option] = value;
                if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function (x) {
                    return x();
                });
            }
            self.redraw();
            jumpToDate();
        }
        function setSelectedDate(inputDate, format) {
            var dates = [];
            if (inputDate instanceof Array) dates = inputDate.map(function (d) {
                return self.parseDate(d, format);
            });else if (inputDate instanceof Date || typeof inputDate === "number") dates = [self.parseDate(inputDate, format)];else if (typeof inputDate === "string") {
                switch (self.config.mode) {
                    case "single":
                        dates = [self.parseDate(inputDate, format)];
                        break;
                    case "multiple":
                        dates = inputDate.split(self.config.conjunction).map(function (date) {
                            return self.parseDate(date, format);
                        });
                        break;
                    case "range":
                        dates = inputDate.split(self.l10n.rangeSeparator).map(function (date) {
                            return self.parseDate(date, format);
                        });
                        break;
                    default:
                        break;
                }
            } else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
            self.selectedDates = dates.filter(function (d) {
                return d instanceof Date && isEnabled(d, false);
            });
            if (self.config.mode === "range") self.selectedDates.sort(function (a, b) {
                return a.getTime() - b.getTime();
            });
        }
        function setDate(date, triggerChange, format) {
            if (triggerChange === void 0) {
                triggerChange = false;
            }
            if (format === void 0) {
                format = self.config.dateFormat;
            }
            if (date !== 0 && !date) return self.clear(triggerChange);
            setSelectedDate(date, format);
            self.showTimeInput = self.selectedDates.length > 0;
            self.latestSelectedDateObj = self.selectedDates[0];
            self.redraw();
            jumpToDate();
            setHoursFromDate();
            updateValue(triggerChange);
            if (triggerChange) triggerEvent("onChange");
        }
        function parseDateRules(arr) {
            return arr.map(function (rule) {
                if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) {
                    return self.parseDate(rule, undefined, true);
                } else if (rule && (typeof rule === 'undefined' ? 'undefined' : _typeof(rule)) === "object" && rule.from && rule.to) return {
                    from: self.parseDate(rule.from, undefined),
                    to: self.parseDate(rule.to, undefined)
                };
                return rule;
            }).filter(function (x) {
                return x;
            });
        }
        function setupDates() {
            self.selectedDates = [];
            self.now = new Date();
            var preloadedDate = self.config.defaultDate || self.input.value;
            if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
            var initialDate = self.selectedDates.length ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
            self.currentYear = initialDate.getFullYear();
            self.currentMonth = initialDate.getMonth();
            if (self.selectedDates.length) self.latestSelectedDateObj = self.selectedDates[0];
            if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
            if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
            self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
            self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
            Object.defineProperty(self, "showTimeInput", {
                get: function get() {
                    return self._showTimeInput;
                },
                set: function set(bool) {
                    self._showTimeInput = bool;
                    if (self.calendarContainer) toggleClass(self.calendarContainer, "showTimeInput", bool);
                    self.isOpen && positionCalendar();
                }
            });
        }
        function setupInputs() {
            self.input = self.config.wrap ? element.querySelector("[data-input]") : element;
            if (!self.input) {
                self.config.errorHandler(new Error("Invalid input element specified"));
                return;
            }
            self.input._type = self.input.type;
            self.input.type = "text";
            self.input.classList.add("flatpickr-input");
            self._input = self.input;
            if (self.config.altInput) {
                self.altInput = createElement(self.input.nodeName, self.input.className + " " + self.config.altInputClass);
                self._input = self.altInput;
                self.altInput.placeholder = self.input.placeholder;
                self.altInput.disabled = self.input.disabled;
                self.altInput.required = self.input.required;
                self.altInput.tabIndex = self.input.tabIndex;
                self.altInput.type = "text";
                self.input.type = "hidden";
                if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
            }
            if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
            self._positionElement = self.config.positionElement || self._input;
        }
        function setupMobile() {
            var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
            self.mobileInput = createElement("input", self.input.className + " flatpickr-mobile");
            self.mobileInput.step = self.input.getAttribute("step") || "any";
            self.mobileInput.tabIndex = 1;
            self.mobileInput.type = inputType;
            self.mobileInput.disabled = self.input.disabled;
            self.mobileInput.required = self.input.required;
            self.mobileInput.placeholder = self.input.placeholder;
            self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
            if (self.selectedDates.length) {
                self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
            }
            if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
            if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
            self.input.type = "hidden";
            if (self.altInput !== undefined) self.altInput.type = "hidden";
            try {
                if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
            } catch (_a) {}
            bind(self.mobileInput, "change", function (e) {
                self.setDate(e.target.value, false, self.mobileFormatStr);
                triggerEvent("onChange");
                triggerEvent("onClose");
            });
        }
        function toggle() {
            if (self.isOpen) return self.close();
            self.open();
        }
        function triggerEvent(event, data) {
            var hooks = self.config[event];
            if (hooks !== undefined && hooks.length > 0) {
                for (var i = 0; hooks[i] && i < hooks.length; i++) {
                    hooks[i](self.selectedDates, self.input.value, self, data);
                }
            }
            if (event === "onChange") {
                self.input.dispatchEvent(createEvent("change"));
                self.input.dispatchEvent(createEvent("input"));
            }
        }
        function createEvent(name) {
            var e = document.createEvent("Event");
            e.initEvent(name, true, true);
            return e;
        }
        function isDateSelected(date) {
            for (var i = 0; i < self.selectedDates.length; i++) {
                if (compareDates(self.selectedDates[i], date) === 0) return "" + i;
            }
            return false;
        }
        function isDateInRange(date) {
            if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
            return compareDates(date, self.selectedDates[0]) >= 0 && compareDates(date, self.selectedDates[1]) <= 0;
        }
        function updateNavigationCurrentMonth() {
            if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
            self.currentMonthElement.textContent = monthToStr(self.currentMonth, self.config.shorthandCurrentMonth, self.l10n) + " ";
            self.currentYearElement.value = self.currentYear.toString();
            self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
            self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
        }
        function updateValue(triggerChange) {
            if (triggerChange === void 0) {
                triggerChange = true;
            }
            if (!self.selectedDates.length) return self.clear(triggerChange);
            if (self.mobileInput !== undefined && self.mobileFormatStr) {
                self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
            }
            var joinChar = self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator;
            self.input.value = self.selectedDates.map(function (dObj) {
                return self.formatDate(dObj, self.config.dateFormat);
            }).join(joinChar);
            if (self.altInput !== undefined) {
                self.altInput.value = self.selectedDates.map(function (dObj) {
                    return self.formatDate(dObj, self.config.altFormat);
                }).join(joinChar);
            }
            if (triggerChange !== false) triggerEvent("onValueUpdate");
        }
        function onMonthNavClick(e) {
            e.preventDefault();
            var isPrevMonth = self.prevMonthNav.contains(e.target);
            var isNextMonth = self.nextMonthNav.contains(e.target);
            if (isPrevMonth || isNextMonth) {
                changeMonth(isPrevMonth ? -1 : 1);
            } else if (e.target === self.currentYearElement) {
                self.currentYearElement.select();
            } else if (e.target.className === "arrowUp") {
                self.changeYear(self.currentYear + 1);
            } else if (e.target.className === "arrowDown") {
                self.changeYear(self.currentYear - 1);
            }
        }
        function timeWrapper(e) {
            e.preventDefault();
            var isKeyDown = e.type === "keydown",
                input = e.target;
            if (self.amPM !== undefined && e.target === self.amPM) {
                self.amPM.textContent = self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
            }
            var min = parseFloat(input.getAttribute("data-min")),
                max = parseFloat(input.getAttribute("data-max")),
                step = parseFloat(input.getAttribute("data-step")),
                curValue = parseInt(input.value, 10),
                delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
            var newValue = curValue + step * delta;
            if (typeof input.value !== "undefined" && input.value.length === 2) {
                var isHourElem = input === self.hourElement,
                    isMinuteElem = input === self.minuteElement;
                if (newValue < min) {
                    newValue = max + newValue + int(!isHourElem) + (int(isHourElem) && int(!self.amPM));
                    if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
                } else if (newValue > max) {
                    newValue = input === self.hourElement ? newValue - max - int(!self.amPM) : min;
                    if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
                }
                if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) {
                    self.amPM.textContent = self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
                }
                input.value = pad(newValue);
            }
        }
        init();
        return self;
    }
    function _flatpickr(nodeList, config) {
        var nodes = Array.prototype.slice.call(nodeList);
        var instances = [];
        for (var i = 0; i < nodes.length; i++) {
            var node = nodes[i];
            try {
                if (node.getAttribute("data-fp-omit") !== null) continue;
                if (node._flatpickr !== undefined) {
                    node._flatpickr.destroy();
                    node._flatpickr = undefined;
                }
                node._flatpickr = FlatpickrInstance(node, config || {});
                instances.push(node._flatpickr);
            } catch (e) {
                console.error(e);
            }
        }
        return instances.length === 1 ? instances[0] : instances;
    }
    if (typeof HTMLElement !== "undefined") {
        HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {
            return _flatpickr(this, config);
        };
        HTMLElement.prototype.flatpickr = function (config) {
            return _flatpickr([this], config);
        };
    }
    var flatpickr;
    flatpickr = function flatpickr(selector, config) {
        if (selector instanceof NodeList) return _flatpickr(selector, config);else if (typeof selector === "string") return _flatpickr(window.document.querySelectorAll(selector), config);
        return _flatpickr([selector], config);
    };
    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === "object") window.flatpickr = flatpickr;
    flatpickr.defaultConfig = defaults;
    flatpickr.l10ns = {
        en: __assign({}, english),
        default: __assign({}, english)
    };
    flatpickr.localize = function (l10n) {
        flatpickr.l10ns.default = __assign({}, flatpickr.l10ns.default, l10n);
    };
    flatpickr.setDefaults = function (config) {
        flatpickr.defaultConfig = __assign({}, flatpickr.defaultConfig, config);
    };
    flatpickr.parseDate = createDateParser({});
    flatpickr.formatDate = createDateFormatter({});
    flatpickr.compareDates = compareDates;
    if (typeof jQuery !== "undefined") {
        jQuery.fn.flatpickr = function (config) {
            return _flatpickr(this, config);
        };
    }
    Date.prototype.fp_incr = function (days) {
        return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
    };
    var flatpickr$1 = flatpickr;

    exports.default = flatpickr$1;

    Object.defineProperty(exports, '__esModule', { value: true });
});

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* flatpickr v4.3.2, @license MIT */
(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.ja = {});
})(undefined, function (exports) {
    'use strict';

    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var Japanese = {
        weekdays: {
            shorthand: ["日", "月", "火", "水", "木", "金", "土"],
            longhand: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"]
        },
        months: {
            shorthand: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
            longhand: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
        }
    };
    fp.l10ns.ja = Japanese;
    var ja = fp.l10ns;

    exports.Japanese = Japanese;
    exports.default = ja;

    Object.defineProperty(exports, '__esModule', { value: true });
});

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DeadDurationSelector = function () {
  DeadDurationSelector.$inject = ["$timeout"];
  function DeadDurationSelector($timeout) {
    'ngInject';

    _classCallCheck(this, DeadDurationSelector);

    this.$timeout = $timeout;

    this.restrict = 'E';
    this.require = 'ngModel';
    this.scope = {
      ngModel: '=',
      min: '=',
      max: '='
    };
    this.template = __webpack_require__(683);
  }

  _createClass(DeadDurationSelector, [{
    key: 'link',
    value: function link(scope) {
      var _this = this;

      this.loaded = false;
      var min = scope.min | 0;
      var max = scope.max | 20;
      var options = [];
      for (var i = min; i <= max; i++) {
        options.push(i);
      }
      scope.options = options;

      scope.$watch('ngModel', function (newValue) {
        if (newValue == null || newValue !== newValue) {
          return;
        }
        if (_this.loaded) {
          return;
        }

        var value = newValue / 60;
        _this.$timeout(function () {
          scope.value = value + '';
        });
        _this.loaded = true;
      });

      scope.$watch('value', function (newValue) {
        scope.ngModel = newValue * 60;
      });
    }
  }]);

  return DeadDurationSelector;
}();

exports.default = angular.module('leptonApp.durationSelector', []).directive('durationSelector', ['$timeout', function ($timeout) {
  return new DeadDurationSelector($timeout);
}]).name;

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports = "<select ng-model=\"value\">\n  <option ng-repeat=\"num in options\" value=\"{{num}}\">{{num}}</option>\n</select>\n"

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DeviceConfigIndexItem = function () {
  DeviceConfigIndexItem.$inject = ["$state"];
  function DeviceConfigIndexItem($state) {
    'ngInject';

    _classCallCheck(this, DeviceConfigIndexItem);

    this.$state = $state;

    this.restrict = 'E';
    this.replace = true;
    this.template = __webpack_require__(685);
    this.scope = {
      device: '=',
      linkState: '=',
      oem: '=',
      secondIndent: '='
    };
  }

  _createClass(DeviceConfigIndexItem, [{
    key: 'link',
    value: function link(scope) {
      var baseState = 'main';
      if (scope.oem) {
        baseState = 'oem_main';
      }

      if (!scope.secondIndent) {
        scope.style = { width: '100%', padding: '12px 0' };
      }

      var stateParams = { id: scope.device.id, company_id: scope.device.company_id };
      var stateName = '';

      if (scope.device.operating_mode === 'reading') {
        scope.iconClass = 'fa-tachometer-alt';
        stateName = scope.linkState || baseState + '.device_config_edit';
      } else {
        scope.iconClass = 'fa-sliders-h';
        stateName = scope.linkState || baseState + '.controller_device_edit';
      }

      scope.href = this.$state.href(stateName, stateParams);
    }
  }]);

  return DeviceConfigIndexItem;
}();

exports.default = _angular2.default.module('leptonApp.configIndexItem', []).directive('configIndexItem', ['$state', function ($state) {
  return new DeviceConfigIndexItem($state);
}]).name;

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports = "<a ng-href=\"{{href}}\"\n   ng-style=\"style\">\n  <div layout=\"row\" layout-align=\"start center\" style=\"width: 100%;\">\n    <div class=\"device-list-icon\">\n      <i class=\"fa {{iconClass}} fa-lg\" aria-hidden=\"true\"></i>\n    </div>\n    <div class=\"md-list-item-text device-list-item\" layout=\"column\">\n      <h3>{{ device.pms_service_code }}</h3>\n      <div ng-if=\"oem\">\n        <h4>{{ device.management_id }} {{ device.management_info }}</h4>\n        <p>{{ device.location }}</p>\n      </div>\n      <div ng-if=\"!oem\">\n        <h4>{{ device.location }}</h4>\n        <p>{{ device.memo }}</p>\n      </div>\n    </div>\n  </div>\n</a>\n"

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var PaginationDirective = function PaginationDirective() {
  'ngInject';

  _classCallCheck(this, PaginationDirective);

  this.restrict = 'E';
  this.require = 'paginationObject';
  this.scope = {
    pgObject: '=',
    action: '&'
  };
  this.template = __webpack_require__(687);
};

exports.default = angular.module('leptonApp.pagination', []).directive('pagination', [function () {
  return new PaginationDirective();
}]).name;

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = "<paging\n        page=\"pgObject.current_page\"\n        page-size=\"pgObject.per_page\"\n        total=\"pgObject.total_count\"\n        paging-action=\"action({page: page})\"\n        adjacent=\"1\"\n        hide-if-empty=\"true\"\n        show-prev-next=\"true\"\n        show-first-last=\"false\"\n        text-next=\"次へ >\"\n        text-prev=\"< 前へ\">\n</paging>\n"

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var SimpleDemandDisplay = function () {
  function SimpleDemandDisplay() {
    'ngInject';

    _classCallCheck(this, SimpleDemandDisplay);

    this.restrict = 'E';
    this.scope = {
      timeStr: '=',
      maxPower: '=',
      predictedDemand: '=',
      currentPower: '=',
      powerDiff: '=',
      deviceError: '=',
      remainingDiff: '=',
      targetPower: '=',
      limitPower: '=',
      contractPower: '=',
      toggle: '&'
    };
    this.template = __webpack_require__(689);
  }

  _createClass(SimpleDemandDisplay, [{
    key: 'link',
    value: function link(scope) {
      var _this = this;

      scope.blackMode = true;

      scope.getColorClass = function () {
        if (!scope.deviceError.has_error) {
          return 'simple-demand-color-normal';
        }
        if (_this.isError(scope.deviceError)) {
          return 'simple-demand-color-contract';
        }

        switch (scope.deviceError.demand_level) {
          case 0:
            return 'simple-demand-color-normal';
          case 1:
            return 'simple-demand-color-target';
          case 2:
            return 'simple-demand-color-limit';
          case 3:
            return 'simple-demand-color-contract';
        }
      };

      scope.isNotifyTime = function () {
        if (scope.remainingDiff < 300) {
          return 'simple-demand-time-flash';
        }
      };

      scope.toggleMode = function () {
        scope.blackMode = !scope.blackMode;
      };

      scope.thresholdTitle = function () {
        if (scope.predictedDemand <= scope.targetPower) {
          return '目標電力';
        } else if (scope.predictedDemand <= scope.limitPower) {
          return '限界電力';
        } else {
          return '契約電力';
        }
      };

      scope.thresholdValue = function () {
        if (scope.predictedDemand <= scope.targetPower) {
          return scope.targetPower;
        } else if (scope.predictedDemand <= scope.limitPower) {
          return scope.limitPower;
        } else {
          return scope.contractPower;
        }
      };
    }
  }, {
    key: 'isError',
    value: function isError(deviceError) {
      return deviceError.cloud_disconnected || deviceError.meter_off || deviceError.meter_fault || deviceError.meter_not_found || deviceError.demand_fault;
    }
  }]);

  return SimpleDemandDisplay;
}();

exports.default = angular.module('leptonApp.simpleDemandDisplay', []).directive('simpleDemandDisplay', [function () {
  return new SimpleDemandDisplay();
}]).name;

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports = "<div class=\"simple-demand-content\" ng-class=\"blackMode ? 'simple-demand-black' : 'simple-demand-white'\">\n  <div class=\"simple-demand-header\">\n    <div><span ng-click=\"toggle()\"><i class=\"fas fa-reply\"></i></span></div>\n    <div class=\"simple-demand-button black\" ng-if=\"blackMode\"><span ng-click=\"toggleMode()\">白背景</span></div>\n    <div class=\"simple-demand-button white\" ng-if=\"!blackMode\"><span ng-click=\"toggleMode()\">黒背景</span></div>\n  </div>\n  <div class=\"simple-demand-item simple-demand-first\">\n    <div class=\"simple-demand-title\">残り時間</div>\n    <div class=\"simple-demand-value\" ng-class=\"isNotifyTime()\">{{timeStr}}</div>\n  </div>\n  <div class=\"simple-demand-item\">\n    <div class=\"simple-demand-title\">今月の最大デマンド</div>\n    <div class=\"simple-demand-value\" ng-class=\"getColorClass()\" ng-hide=\"maxPower=== null\">{{maxPower.value}} kW</div>\n    <div class=\"simple-demand-value\" ng-if=\"maxPower === null\">未受信</div>\n  </div>\n  <div class=\"simple-demand-item\" ng-if=\"$root.demandEnabled\">\n    <div class=\"simple-demand-title\">予測値 <span class=\"simple-demand-threshold-title\">/{{ thresholdTitle() }}</span></div>\n    <div class=\"simple-demand-value simple-demand-padding\" ng-class=\"getColorClass()\" ng-hide=\"predictedDemand === null\">\n      {{predictedDemand | number: 1}}<div class=\"simple-demand-threshold-value\"> /{{ thresholdValue() }}</div> kW\n    </div>\n    <div class=\"simple-demand-value\" ng-if=\"predictedDemand === null\">未計算</div>\n  </div>\n  <div class=\"simple-demand-item\">\n    <div class=\"simple-demand-title\">現在値</div>\n    <div class=\"simple-demand-value simple-demand-current-padding\" ng-hide=\"currentPower === null\">\n      {{currentPower}}<div class=\"simple-demand-threshold-value\">(+{{powerDiff}})</div> kW\n    </div>\n    <div class=\"simple-demand-value\" ng-if=\"currentPower === null\">未受信</div>\n  </div>\n  <div class=\"simple-demand-item\">\n    <div class=\"simple-demand-title simple-demand-error-msg\">{{deviceError | getErrorMessage}}</div>\n    <div class=\"simple-demand-value\" ng-class=\"getColorClass()\"><i class=\"fas fa-circle\"></i></div>\n  </div>\n</div>\n"

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var TabletDemandDisplay = function () {
  function TabletDemandDisplay() {
    'ngInject';

    _classCallCheck(this, TabletDemandDisplay);

    this.restrict = 'E';
    this.scope = {
      timeStr: '=',
      maxPower: '=',
      predictedDemand: '=',
      currentPower: '=',
      powerDiff: '=',
      deviceError: '=',
      remainingDiff: '=',
      targetPower: '=',
      limitPower: '=',
      contractPower: '=',
      toggle: '&'
    };
    this.template = __webpack_require__(691);
  }

  _createClass(TabletDemandDisplay, [{
    key: 'link',
    value: function link(scope) {
      var _this = this;

      scope.getColorClass = function () {
        if (!scope.deviceError.has_error) {
          return 'tablet-demand-color-normal';
        }
        if (_this.isError(scope.deviceError)) {
          return 'tablet-demand-color-contract';
        }

        switch (scope.deviceError.demand_level) {
          case 0:
            return 'tablet-demand-color-normal';
          case 1:
            return 'tablet-demand-color-target';
          case 2:
            return 'tablet-demand-color-limit';
          case 3:
            return 'tablet-demand-color-contract';
        }
      };

      scope.statusName = function () {
        switch (scope.deviceError.demand_level) {
          case 0:
            return '正常稼働中';
          case 1:
            return '目標電力超過';
          case 2:
            return '限界電力超過';
          case 3:
            return '契約電力超過';
        }
      };

      scope.getStatus = function () {
        if (!scope.deviceError.has_error) {
          return 0;
        }
        if (_this.isError(scope.deviceError)) {
          return 5;
        }

        return scope.deviceError.demand_level;
      };

      scope.isNotifyTime = function () {
        if (scope.remainingDiff < 300) {
          return 'tablet-demand-time-flash';
        }
      };

      scope.thresholdTitle = function () {
        if (scope.predictedDemand <= scope.targetPower) {
          return '目標電力';
        } else if (scope.predictedDemand <= scope.limitPower) {
          return '限界電力';
        } else {
          return '契約電力';
        }
      };

      scope.thresholdValue = function () {
        if (scope.predictedDemand <= scope.targetPower) {
          return scope.targetPower;
        } else if (scope.predictedDemand <= scope.limitPower) {
          return scope.limitPower;
        } else {
          return scope.contractPower;
        }
      };
    }
  }, {
    key: 'isError',
    value: function isError(deviceError) {
      return deviceError.cloud_disconnected || deviceError.meter_off || deviceError.meter_fault || deviceError.meter_not_found || deviceError.demand_fault;
    }
  }]);

  return TabletDemandDisplay;
}();

exports.default = angular.module('leptonApp.tabletDemandDisplay', []).directive('tabletDemandDisplay', [function () {
  return new TabletDemandDisplay();
}]).name;

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tablet-demand-content\">\n  <div class=\"tablet-demand-header\">\n    <div><span ng-click=\"toggle()\"><i class=\"fas fa-reply\"></i></span></div>\n  </div>\n\n  <div class=\"tablet-demand-table\">\n\n    <div class=\"tablet-demand-status\">\n        <div class=\"tablet-demand-status-nomal\" ng-if=\"getStatus() === 0\">\n          <img class=\"tablet-demand-status-img\" src=\"vendor/demand-icons/nomal.png\"/> \n          <div class=\"tablet-demand-status-text\">{{ statusName() }}</div>\n        </div>\n        <div class=\"tablet-demand-status-target\" ng-if=\"getStatus() === 1\">\n          <img class=\"tablet-demand-status-img\" src=\"vendor/demand-icons/target.png\"/> \n          <div class=\"tablet-demand-status-text\">{{ statusName() }}</div>\n        </div>\n        <div class=\"tablet-demand-status-limit\" ng-if=\"getStatus() === 2\">\n          <img class=\"tablet-demand-status-img\" src=\"vendor/demand-icons/limit.png\"/> \n          <div class=\"tablet-demand-status-text\">{{ statusName() }}</div>\n        </div>\n        <div class=\"tablet-demand-status-contract\" ng-if=\"getStatus() === 3\">\n          <img class=\"tablet-demand-status-img\" src=\"vendor/demand-icons/contract.png\"/> \n          <div class=\"tablet-demand-status-text\">{{ statusName() }}</div>\n        </div>\n        <div class=\"tablet-demand-status-unknown\" ng-if=\"getStatus() === 4\">\n          <img class=\"tablet-demand-status-img\" src=\"vendor/demand-icons/error.png\"/> \n          <div class=\"tablet-demand-status-error-text\">{{deviceError | getErrorMessage}}</div>\n        </div>\n        <div class=\"tablet-demand-status-error\" ng-if=\"getStatus() === 5\">\n          <img class=\"tablet-demand-status-img\" src=\"vendor/demand-icons/error.png\"/> \n          <div class=\"tablet-demand-status-error-text\">{{deviceError | getErrorMessage}}</div>\n        </div>\n    </div>\n    <div class=\"tablet-demand-items\">\n      <div class=\"tablet-demand-item tablet-demand-first\">\n        <div class=\"tablet-demand-title\">残り時間</div>\n        <div class=\"tablet-demand-time\" ng-class=\"isNotifyTime()\">{{timeStr}}</div>\n      </div>\n      <div class=\"tablet-demand-item\">\n        <div class=\"tablet-demand-title\">{{ thresholdTitle() }}</div>\n        <div class=\"tablet-demand-threshold-value\" ng-class=\"getColorClass()\">{{ thresholdValue() }} kW</div>\n      </div>\n      <div class=\"tablet-demand-item\" ng-if=\"$root.demandEnabled\">\n        <div class=\"tablet-demand-title\">予測値 </div>\n        <div class=\"tablet-demand-value\" ng-class=\"getColorClass()\" ng-hide=\"predictedDemand === null\">\n          {{predictedDemand | number: 1}} kW\n        </div>\n        <div class=\"tablet-demand-value\" ng-if=\"predictedDemand === null\">未計算</div>\n      </div>\n      <div class=\"tablet-demand-item\">\n        <div class=\"tablet-demand-title\">現在値</div>\n        <div class=\"tablet-demand-value\" ng-hide=\"currentPower === null\">{{currentPower}} kW</div>\n        <div class=\"tablet-demand-value\" ng-if=\"currentPower === null\">未受信</div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

__webpack_require__(693);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var WeatherDirective = function () {
  function WeatherDirective() {
    'ngInject';

    _classCallCheck(this, WeatherDirective);

    this.restrict = 'E';
    this.scope = {
      weather: '=',
      simple: '=',
      iconSize: '=',
      linkId: '=',
      device: '='
    };
    this.template = __webpack_require__(694);
  }

  _createClass(WeatherDirective, [{
    key: 'link',
    value: function link(scope) {
      scope.iconWidth = 26;
      if (scope.iconSize === 'middle') {
        scope.iconWidth = 25;
      } else if (scope.iconSize === 'small') {
        scope.iconWidth = 15;
      }
    }
  }]);

  return WeatherDirective;
}();

exports.default = angular.module('leptonApp.weatherDirective', []).directive('weatherDirective', [function () {
  return new WeatherDirective();
}]).name;

/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports = "<div class=\"weather-content\" ng-if=\"weather && weather.name\">\n  <span>\n    <img ng-style=\"{width: iconWidth + 'px'}\" class=\"weather-icon\" ng-src=\"vendor/weather-icons/{{weather.icon_id}}.png\"/>\n  </span>\n  <span ng-if=\"!simple\" class=\"weather-temp\">\n    <span class=\"weather-temp-max\">{{weather.temp_max}}</span> / <span class=\"weather-temp-min\">{{weather.temp_min}}</span>\n  </span>\n</div>\n<div ng-if=\"weather && !weather.name && !simple\">\n  <div>\n    <span class=\"weather-empty-message\">天候情報取得不可</span>\n  </div>\n  <div>\n    <span class=\"span-link weather-span-link\" ui-sref=\"main.device_config_edit({id: {{linkId}} })\">郵便番号を再設定</span>\n  </div>\n</div>\n<div ng-if=\"!weather && !simple\">\n  <div>\n    <span class=\"weather-empty-message\">天候情報未取得</span>\n  </div>\n  <div ng-if=\"!device.zip_code\">\n    <span class=\"span-link weather-span-link\" ui-sref=\"main.device_config_edit({id: {{linkId}} })\">郵便番号を設定</span>\n  </div>\n  <div ng-if=\"device.zip_code\">\n    <span class=\"weather-minor-message\">更新までお待ちください</span>\n  </div>\n</div>\n"

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(696);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var SaInfoDirective = function SaInfoDirective() {
  'nginject';

  _classCallCheck(this, SaInfoDirective);

  this.restrict = 'E';
  this.template = __webpack_require__(697);
  this.scope = {
    sa: '=',
    show: '='
  };
};

exports.default = angular.module('leptonApp.saInfoDirective', []).directive('saInfoDirective', [function () {
  return new SaInfoDirective();
}]).name;

/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports = "<div class=\"sa-info-directive-animate\" ng-show=\"show\">\n  <div class=\"sa-info-body\">\n    <table border=\"0\">\n      <tr>\n        <td>サービスコード</td>\n        <td>{{ sa.pms_service_code }}</td>\n      </tr>\n      <tr>\n        <td>管理ID</td>\n        <td>{{ sa.management_id }}</td>\n      </tr>\n      <tr>\n        <td>設置場所</td>\n        <td>{{ sa.location }}</td>\n      </tr>\n      <tr>\n        <td>メモ</td>\n        <td>{{ sa.memo }}</td>\n      </tr>\n      <tr>\n        <td>機器ID</td>\n        <td>{{ sa.distribution_id }}</td>\n      </tr>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _math_util = __webpack_require__(88);

var _math_util2 = _interopRequireDefault(_math_util);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DemandPredictionLogic = function () {
  DemandPredictionLogic.$inject = ["moment", "MathUtil"];
  function DemandPredictionLogic(moment, MathUtil) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, DemandPredictionLogic);

    this.moment = moment;

    this.predict = function (baseTime, instPowers) {
      if (instPowers.length < 2) {
        return null;
      }

      var lastPower = instPowers[instPowers.length - 1];
      var lastPowerTime = moment(lastPower.x);
      var demandStartTime = moment(baseTime);
      var demandEndTime = demandStartTime.clone().add(30, 'minutes');

      var span = _this.calcSpan(demandStartTime, lastPower.x);
      var targetValue = _this.findTargetPower(instPowers, lastPowerTime.clone().subtract(span, 'seconds'));

      if (targetValue === null) {
        return null;
      }

      var averageForSecond = MathUtil.subtract(lastPower.y, targetValue) / span;

      return lastPower.y + averageForSecond * demandEndTime.diff(lastPowerTime, 'seconds');
    };
  }

  _createClass(DemandPredictionLogic, [{
    key: 'calcSpan',
    value: function calcSpan(start, last) {
      if (this.moment(last).diff(this.moment(start), 'seconds') > 1200) {
        return 120;
      } else {
        return 180;
      }
    }

  }, {
    key: 'findTargetPower',
    value: function findTargetPower(powers, targetTime) {
      var _this2 = this;

      var findMargin = this.moment.duration(70, 'seconds');
      var lower = targetTime.clone().subtract(findMargin);
      var upper = targetTime.clone().add(findMargin);

      var target = null;
      var filteredPowers = powers.filter(function (power) {
        return _this2.moment(power.x).isBetween(lower, upper);
      });

      if (filteredPowers.length === 0) {
        return null;
      }

      return (filteredPowers[0].y + filteredPowers[filteredPowers.length - 1].y) / 2;
    }
  }]);

  return DemandPredictionLogic;
}();

exports.default = _angular2.default.module('leptonApp.DemandPredictionLogic', [_angularMoment2.default, _math_util2.default]).service('DemandPredictionLogic', ['moment', 'MathUtil', DemandPredictionLogic]).name;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

exports.DateUtil = DateUtil;
function DateUtil($filter, moment) {
  var OneDayInMSec = 24 * 60 * 60 * 1000;
  var OneHourInMSec = 60 * 60 * 1000;
  var OneMinuteInMSec = 60 * 1000;
  var ServerTimeZoneOffset = 9 * OneHourInMSec;

  function beginningOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function leapDate(baseDate, elapsedDate) {
    return new Date(baseDate.valueOf() + elapsedDate * OneDayInMSec);
  }

  function leapMonth(baseDate, elapsedMonth) {
    var tmp = angular.copy(baseDate);
    return new Date(tmp.setMonth(tmp.getMonth() + elapsedMonth));
  }

  function jstToUTC(date_string) {
    return Date.parse(date_string) + ServerTimeZoneOffset;
  }

  function localToJST(date) {
    var utc = date.valueOf() + new Date().getTimezoneOffset() * OneMinuteInMSec;
    return new Date(utc + ServerTimeZoneOffset);
  }

  function getDemandRange(date) {
    var demand_start_time = null;
    if (date.getMinutes() < 30) {
      demand_start_time = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), 0, 0);
    } else {
      demand_start_time = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), 30, 0);
    }
    var demand_end_time = new Date(demand_start_time.valueOf() + 30 * OneMinuteInMSec);

    return [demand_start_time, demand_end_time];
  }

  function getBillingDate(date, billingDate) {
    var numberOfDay = date.clone().endOf('month').date();

    if (billingDate > numberOfDay) {
      return date.clone().endOf('month').startOf('date');
    } else {
      return date.clone().date(billingDate);
    }
  }

  return {
    isToday: function isToday(date) {
      var now = localToJST(new Date());
      return beginningOfDay(date).valueOf() === beginningOfDay(now).valueOf();
    },
    isOldest: function isOldest(date) {
      var now = localToJST(new Date());
      return (now - date) / OneDayInMSec >= 99;
    },
    getDateString: function getDateString(date) {
      return ('0' + (date.getMonth() + 1)).slice(-2) + '月' + ('0' + date.getDate()).slice(-2) + '日';
    },
    getDateDomain: function getDateDomain(date) {
      var today = beginningOfDay(date);
      var tomorrow = beginningOfDay(leapDate(date, 1));
      return [today.valueOf(), tomorrow.valueOf()];
    },
    getBillingDateDomain: function getBillingDateDomain(date, billingDate) {
      if (billingDate === 0) {
        billingDate = 1;
      }

      var target = moment(date).startOf('day');
      var start = void 0,
          end = void 0;

      if (date.getDate() >= billingDate) {
        start = getBillingDate(target, billingDate);
      } else {
        start = getBillingDate(target.clone().subtract(1, 'months'), billingDate);
      }

      if (date.getDate() >= billingDate) {
        end = getBillingDate(target.clone().add(1, 'months'), billingDate).subtract(1, 'days');
      } else {
        end = getBillingDate(target, billingDate).subtract(1, 'days');
      }

      return [start.toDate(), end.toDate()];
    },
    getDateTicks: function getDateTicks(date, interval) {
      if (angular.isUndefined(interval) || interval === 0) {
        interval = 1;
      }
      var today = beginningOfDay(date);
      var tickValue = [];
      for (var i = 0; i < 24 / interval; i++) {
        tickValue.push(today.valueOf() + OneHourInMSec * i * interval);
      }
      return tickValue;
    },
    getXLabels: ["00:30", "01:00", "01:30", "02:00", "02:30", "03:00", "03:30", "04:00", "04:30", "05:00", "05:30", "06:00", "06:30", "07:00", "07:30", "08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00", "20:30", "21:00", "21:30", "22:00", "22:30", "23:00", "23:30", "00:00"],
    getQueryParams: function getQueryParams(date) {
      return {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate()
      };
    },
    getActivePowerQueries: function getActivePowerQueries(date) {
      var start_time = new Date(beginningOfDay(date));
      var end_time = new Date(beginningOfDay(leapDate(date, 1)));
      return {
        start_y: start_time.getFullYear(),
        start_m: start_time.getMonth() + 1,
        start_d: start_time.getDate(),
        start_hour: 0, start_min: 0,
        end_y: end_time.getFullYear(),
        end_m: end_time.getMonth() + 1,
        end_d: end_time.getDate(),
        end_hour: 0, end_min: 0
      };
    },
    getDateRangeQueries: function getDateRangeQueries(startDate, endDate) {
      var start = moment(startDate);
      var end = moment(endDate);

      return {
        start_y: start.year(),
        start_m: start.month() + 1,
        start_d: start.date(),
        end_y: end.year(),
        end_m: end.month() + 1,
        end_d: end.date()
      };
    },
    datetimeRangeQuery: function datetimeRangeQuery(startDate, endDate) {
      return {
        start_y: startDate.year(),
        start_m: startDate.month() + 1,
        start_d: startDate.date(),
        start_hour: 0,
        start_min: 30,
        end_y: endDate.year(),
        end_m: endDate.month() + 1,
        end_d: endDate.date(),
        end_hour: 0,
        end_min: 0
      };
    },
    getDemandRange: getDemandRange,
    getDemandTitle: function getDemandTitle(date) {
      var _getDemandRange = getDemandRange(date),
          _getDemandRange2 = _slicedToArray(_getDemandRange, 2),
          start_time = _getDemandRange2[0],
          end_time = _getDemandRange2[1];

      return $filter('date')(start_time, 'yyyy年MM月dd日 HH:mm ~') + ' ' + $filter('date')(end_time, 'HH:mm');
    },
    jstToLocal: function jstToLocal(date_string) {
      var utc = jstToUTC(date_string);
      return utc + new Date().getTimezoneOffset() * OneMinuteInMSec;
    },
    localToUTC: function localToUTC(date) {
      return date.valueOf() - new Date().getTimezoneOffset() * OneMinuteInMSec;
    },
    jstToUTC: jstToUTC,
    localToJST: localToJST,
    leapDate: leapDate,

    leapJstDate: function leapJstDate(date_string, elapsedDate) {
      var utc = jstToUTC(date_string);
      return leapDate(utc, elapsedDate).valueOf();
    },
    leapMonth: leapMonth,
    beginningOfDay: beginningOfDay,
    beginningOfWeek: function beginningOfWeek(date) {
      var baseDate = beginningOfDay(date);
      return leapDate(baseDate, -1 * baseDate.getDay());
    },
    beginningOfMonth: function beginningOfMonth(date) {
      var baseDate = beginningOfDay(date);
      return new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);
    }
  };
}

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HomeController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _home = __webpack_require__(701);

var _home2 = _interopRequireDefault(_home);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _device_status = __webpack_require__(702);

var _device_status2 = _interopRequireDefault(_device_status);

var _event = __webpack_require__(90);

var _event2 = _interopRequireDefault(_event);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var HomeController = exports.HomeController = function () {
  /*@ngInject*/
  HomeController.$inject = ["$filter", "$interval", "$mdDialog", "moment", "DeviceStatusService", "EventService", "CsvUtil"];
  function HomeController($filter, $interval, $mdDialog, moment, DeviceStatusService, EventService, CsvUtil) {
    _classCallCheck(this, HomeController);

    this.announces = [];

    this.$filter = $filter;
    this.$interval = $interval;
    this.$mdDialog = $mdDialog;
    this.moment = moment;
    this.DeviceStatusService = DeviceStatusService;
    this.EventService = EventService;
    this.CsvUtil = CsvUtil;
    this.downloadFileName = 'event.csv';

    this.errorList = [];
    this.correctList = [];
    this.demandAlertList = [];
  }

  _createClass(HomeController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.updateStatus();

      this.timer = this.$interval(function () {
        _this.updateStatus();
      }, 20000);
    }
  }, {
    key: 'updateStatus',
    value: function updateStatus() {
      var _this2 = this;

      this.EventService.api.index(function (response) {
        _this2.events = response;
        _this2.eventCsv = _this2.CsvUtil.processEvent(_this2.events);

        _this2.downloadFileName = _this2.moment().format('[event]_YYYY-MM-DD[.csv]');
      });

      this.DeviceStatusService.api.index(function (response) {
        _this2.correctList = _this2.$filter("filter")(response, { has_error: false });

        _this2.errorList = _this2.$filter("filter")(response, function (device_error) {
          return _this2.isError(device_error);
        });

        _this2.demandAlertList = _this2.$filter("filter")(response, function (device_error) {
          return _this2.isDemandAlert(device_error);
        });
      });
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      if (this.timer) {
        this.$interval.cancel(this.timer);
      }
    }
  }, {
    key: 'isReadingDevice',
    value: function isReadingDevice(device) {
      return device.operating_mode === 'reading';
    }
  }, {
    key: 'isReadingDeviceCode',
    value: function isReadingDeviceCode(serviceCode) {
      return (/^(dss|tds)[0-9]+/.test(serviceCode)
      );
    }

  }, {
    key: 'isError',
    value: function isError(deviceError) {
      return deviceError.has_error && (deviceError.cloud_disconnected || deviceError.meter_off || deviceError.meter_fault || deviceError.meter_not_found || deviceError.demand_fault);
    }
  }, {
    key: 'allDeviceLength',
    value: function allDeviceLength() {
      return this.errorList.length + this.correctList.length + this.demandAlertList.length;
    }

  }, {
    key: 'isDemandAlert',
    value: function isDemandAlert(deviceError) {
      return deviceError.demand_level > 0 && !this.isError(deviceError);
    }
  }]);

  return HomeController;
}();

exports.default = _angular2.default.module('leptonApp.home', [_angularjs2.default, _angularMoment2.default, _device_status2.default, _event2.default, _csv2.default]).config(_home2.default).component('home', {
  template: __webpack_require__(703),
  controller: HomeController
}).name;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.home', {
    url: 'home',
    template: '<home></home>'
  });
};

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var DeviceStatusService = function DeviceStatusService($resource) {
    'ngInject';

    _classCallCheck(this, DeviceStatusService);

    this.api = $resource('/api/device_status', {}, { index: { method: 'GET', isArray: true } });
};
DeviceStatusService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.DeviceStatusService', ['ngResource']).service('DeviceStatusService', ['$resource', DeviceStatusService]).name;

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports = "<md-content>\n  <div layout=\"row\">\n    <div>\n      <div class=\"subcontent\">\n        <div layout=\"row\">\n          <md-button class=\"status-card\" ui-sref=\"main.demand_index\" style=\"border-color: #009688\">\n            <div class=\"status-card-title\">正常稼働中</div>\n            <div><span class=\"bold-num\">{{$ctrl.correctList.length}}</span> 件</div>\n          </md-button>\n          <md-button class=\"status-card\" style=\"border-color: #F56523\">\n            <div class=\"status-card-title\" style=\"line-height: 18px; font-size: 15px;\">デマンド警報<br>発令中</div>\n            <div><span class=\"bold-num\">{{$ctrl.demandAlertList.length}}</span> 台</div>\n          </md-button>\n          <md-button class=\"status-card\" ui-sref=\"main.device_error\" style=\"border-color: #F56523\">\n            <div class=\"status-card-title\">異常発生中</div>\n            <div><span class=\"bold-num\">{{$ctrl.errorList.length}}</span> 台</div>\n          </md-button>\n        </div>\n      </div>\n\n      <div class=\"subcontent\" style=\"margin-top: 3px; width: 457px;\">\n        <global-event></global-event>\n      </div>\n    </div>\n    <div class=\"subcontent\" flex=\"grow\" style=\"margin-top: 13px; margin-left: 0; max-width: calc(100% - 496px);\">\n      <div class=\"home-event-list-title align-right\">\n        <div>\n          <h4>イベント履歴</h4>\n        </div>\n        <div>\n          <a class=\"csv-downloader\" csv-downloader filename=\"$ctrl.downloadFileName\" csv-data=\"$ctrl.eventCsv\">\n            <i class=\"fa fa-download\" aria-hidden=\"true\"></i>\n          </a>\n        </div>\n      </div>\n      <div ng-if=\"$ctrl.events.length === 0\">\n        イベントはまだありません\n      </div>\n      <div class=\"event\" ng-if=\"$ctrl.events.length > 0\">\n        <md-list>\n          <md-list-item class=\"md-2-line\" ng-repeat=\"event in $ctrl.events\" style=\"padding: 0 0 0 10px;min-height: 0\">\n            <div ui-sref=\"{{ $ctrl.isReadingDeviceCode(event.pms_service_code) ?\n              'main.demand_monitoring.daily_report({id: event.sa_config_id })'\n              : 'main.home' }}\"\n                 ng-class=\"$ctrl.isReadingDeviceCode(event.pms_service_code) ? '' : 'event-list-item-no-link'\"\n                 class=\"event-list-item\" layout=\"row\" layout-align=\"start center\">\n              <i ng-class=\"event.is_error ? 'fa fa-exclamation-circle error fa-fw' : 'fa fa-check-square normal fa-fw'\"></i>\n              <div class=\"event-info\" layout=\"column\" layout-align=\"space-around start\">\n                <div layout=\"row\" layout-align=\"space-between center\" style=\"width: 100%;\">\n                  <div class=\"event-msg\">\n                    {{ event.event_msg }}<span ng-if=\"event.triggered_by\" class=\"edited-by\"> (変更者: {{ event.triggered_by }})</span>\n                  </div>\n                  <div class=\"event-minor-info\" layout=\"column\" layout-align=\"center end\">\n                    <span>{{ event.occurred_at | date : 'M/d HH:mm' }}</span><span>{{ event.pms_service_code }}</span>\n                  </div>\n                </div>\n                <div class=\"event-minor-info event-location\">\n                  {{ event.location }}\n                </div>\n              </div>\n            </div>\n            <md-divider></md-divider>\n          </md-list-item>\n        </md-list>\n      </div>\n    </div>\n  </div>\n  <div class=\"subcontent device-status-list\">\n    <div>\n      <md-toolbar class=\"md-hue-2\" style=\"background-color: #21BFD3; font-weight: bold; font-size: 18px;\">\n        稼働中機器一覧\n      </md-toolbar>\n      <div class=\"device-status-list-empty\" ng-if=\"$ctrl.allDeviceLength() === 0\">\n        稼働中の機器はありません\n      </div>\n      <table class=\"device-list-table\" ng-if=\"$ctrl.allDeviceLength() > 0\">\n        <tr class=\"device-list-header\">\n          <th class=\"device-list-service-code\">サービスコード</th>\n          <th class=\"device-list-info\">設置場所・メモ</th>\n          <th class=\"device-list-current-power\">現在電力 (契約電力)</th>\n          <th class=\"device-list-status-detail\">ステータス</th>\n        </tr>\n        <tr ng-repeat=\"device in $ctrl.demandAlertList\">\n          <td class=\"device-list-service-code\">\n            <i class=\"fa fa-fw\" ng-class=\"$ctrl.isReadingDevice(device) ? 'fa-tachometer-alt' : 'fa-sliders-h'\"></i>&nbsp;\n            <span class=\"span-link\" ui-sref=\"{{ $ctrl.isReadingDevice(device) ?\n                'main.demand_monitoring.daily_report({id:device.id})' : 'main.controller_device_edit({ id: device.id})' }}\">\n                {{ device.pms_service_code }}\n            </span>\n          </td>\n          <td class=\"device-list-info\">\n            <div>{{ device.location }}</div>\n            <div>{{ device.memo }}</div>\n          </td>\n          <td class=\"device-list-current-power current-power-error\" ng-if=\"device.current_power !== undefined\">\n            {{ device.current_power * 2 | number }}kW ({{device.contract_power}}kW)\n          </td>\n          <td class=\"device-list-current-power current-power-error\" ng-if=\"device.current_power === undefined\">\n            -\n          </td>\n          <td class=\"device-list-status-detail\">\n            <div class=\"status-detail-error\">{{ device | getErrorMessage }}</div>\n          </td>\n        </tr>\n        <tr ng-repeat=\"device in $ctrl.errorList\">\n          <td class=\"device-list-service-code\">\n            <i class=\"fa fa-fw\" ng-class=\"$ctrl.isReadingDevice(device) ? 'fa-tachometer-alt' : 'fa-sliders-h'\"></i>&nbsp;\n            <span class=\"span-link\" ui-sref=\"{{ $ctrl.isReadingDevice(device) ?\n                'main.demand_monitoring.daily_report({id:device.id})' : 'main.controller_device_edit({ id: device.id})' }}\">\n                {{ device.pms_service_code }}\n            </span>\n          </td>\n          <td class=\"device-list-info\">\n            <div>{{ device.location }}</div>\n            <div>{{ device.memo }}</div>\n          </td>\n          <td class=\"device-list-current-power current-power-error\" ng-if=\"device.current_power !== undefined\">\n            {{ device.current_power * 2 | number }}kW ({{device.contract_power}}kW)\n          </td>\n          <td class=\"device-list-current-power current-power-error\" ng-if=\"device.current_power === undefined\">\n            -\n          </td>\n          <td class=\"device-list-status-detail\">\n            <div class=\"status-detail-error\">{{ device | getErrorMessage }}</div>\n          </td>\n        </tr>\n        <tr ng-repeat=\"device in $ctrl.correctList\">\n          <td class=\"device-list-service-code\">\n            <i class=\"fa fa-fw\" ng-class=\"$ctrl.isReadingDevice(device) ? 'fa-tachometer-alt' : 'fa-sliders-h'\"></i>&nbsp;\n            <span class=\"span-link\" ui-sref=\"{{ $ctrl.isReadingDevice(device) ?\n                'main.demand_monitoring.daily_report({id:device.id})' : 'main.controller_device_edit({ id: device.id})' }}\">\n                {{ device.pms_service_code }}\n            </span>\n          </td>\n          <td class=\"device-list-info\">\n            <div>{{ device.location }}</div>\n            <div>{{ device.memo }}</div>\n          </td>\n          <td class=\"device-list-current-power current-power-correct\" ng-if=\"device.current_power !== undefined\">\n            {{ device.current_power * 2 | number }}kW ({{device.contract_power}}kW)\n          </td>\n          <td class=\"device-list-current-power current-power-correct\" ng-if=\"device.current_power === undefined\">\n            -\n          </td>\n          <td class=\"device-list-status-detail\">\n            <div class=\"status-detail-correct\">{{ device | getErrorMessage }}</div>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n</md-content>\n"

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DemandIndexController = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _demand_index = __webpack_require__(705);

var _demand_index2 = _interopRequireDefault(_demand_index);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var DemandIndexController = exports.DemandIndexController = function () {
    /*@ngInject*/
    DemandIndexController.$inject = ["SaConfigService"];
    function DemandIndexController(SaConfigService) {
        _classCallCheck(this, DemandIndexController);

        this.saList = [];
        this.SaConfigService = SaConfigService;
    }

    _createClass(DemandIndexController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.SaConfigService.api.index(function (response) {
                _this.saList = response;
            });
        }
    }]);

    return DemandIndexController;
}();

exports.default = _angular2.default.module('leptonApp.demandIndex', [_angularjs2.default, _sa_config2.default]).config(_demand_index2.default).component('demandIndex', {
    template: __webpack_require__(706),
    controller: DemandIndexController
}).name;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.demand_index', {
    url: 'demand_index',
    template: '<demand-index></demand-index>'
  });
};

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-chart-line fa-fw\"></i>&nbsp;メーター 一覧</h2>\n  </div>\n</md-toolbar>\n<div ng-if=\"$ctrl.saList.length === 0\" class=\"empty-notice\">設定済みの機器がありません。</div>\n<md-content>\n  <md-list-item class=\"md-3-line\" ng-repeat=\"sa in $ctrl.saList\">\n    <a ui-sref=\"main.demand_monitoring.daily_report({id:{{sa.id}}})\" style=\"width: 100%; padding: 12px 0\">\n      <div class=\"md-list-item-text device-list-item\" layout=\"column\" style=\"margin: 0;\">\n        <h3>{{ sa.pms_service_code }} {{ sa.management_id }}</h3>\n        <h4>{{ sa.location }}</h4>\n        <p>{{ sa.memo }}</p>\n      </div>\n    </a>\n    <md-divider></md-divider>\n  </md-list-item>\n</md-content>\n"

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DemandDetailController = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularCookies = __webpack_require__(94);

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _demand_detail = __webpack_require__(708);

var _demand_detail2 = _interopRequireDefault(_demand_detail);

var _inst_active_power = __webpack_require__(548);

var _inst_active_power2 = _interopRequireDefault(_inst_active_power);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _monthly_max_demand_power = __webpack_require__(218);

var _monthly_max_demand_power2 = _interopRequireDefault(_monthly_max_demand_power);

var _event = __webpack_require__(90);

var _event2 = _interopRequireDefault(_event);

var _device_error = __webpack_require__(469);

var _device_error2 = _interopRequireDefault(_device_error);

var _predicted_power = __webpack_require__(554);

var _predicted_power2 = _interopRequireDefault(_predicted_power);

var _active_power = __webpack_require__(144);

var _active_power2 = _interopRequireDefault(_active_power);

var _weather = __webpack_require__(130);

var _weather2 = _interopRequireDefault(_weather);

var _chart = __webpack_require__(70);

var _chart2 = _interopRequireDefault(_chart);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _math_util = __webpack_require__(88);

var _math_util2 = _interopRequireDefault(_math_util);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

var _demand_detail3 = __webpack_require__(709);

var _demand_detail4 = _interopRequireDefault(_demand_detail3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DemandDetailController = exports.DemandDetailController = function () {
  /*@ngInject*/
  DemandDetailController.$inject = ["$state", "$stateParams", "$q", "$interval", "$rootScope", "$cookies", "moment", "InstActivePowerService", "SaConfigService", "MonthlyMaxDemandPowerService", "DateUtil", "MathUtil", "CsvUtil", "EventService", "DeviceErrorService", "PredictedPowerService", "ActivePowerService", "WeatherService"];
  function DemandDetailController($state, $stateParams, $q, $interval, $rootScope, $cookies, moment, InstActivePowerService, SaConfigService, MonthlyMaxDemandPowerService, DateUtil, MathUtil, CsvUtil, EventService, DeviceErrorService, PredictedPowerService, ActivePowerService, WeatherService) {
    _classCallCheck(this, DemandDetailController);

    var self = this;
    this.id = $stateParams.id;
    this.cookies = $cookies;
    this.q = $q;
    this.state = $state;
    this.interval = $interval;
    this.rootScope = $rootScope;
    this.moment = moment;
    this.InstActivePowerService = InstActivePowerService;
    this.SaConfigService = SaConfigService;
    this.MonthlyMaxDemandPowerService = MonthlyMaxDemandPowerService;
    this.EventService = EventService;
    this.DeviceErrorService = DeviceErrorService;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;
    this.PredictedPowerService = PredictedPowerService;
    this.ActivePowerService = ActivePowerService;
    this.WeatherService = WeatherService;
    this.MathUtil = MathUtil;
    this.predictedDemand = null;
    this.predictedPercentage = null;
    this.chartConfig = (0, _demand_detail4.default)(this);
    this.deviceError = {};
    this.currentWeather = {};
    this.remainingTimeStr = '00:00';
    this.downloadFileName = 'event.csv';
  }

  _createClass(DemandDetailController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.SaConfigService.api.show({ id: this.id }).$promise.then(function (response) {
        _this.saConfig = response;
        _this.targetPower = _this.saConfig.target_power;
        _this.limitPower = _this.saConfig.limit_power;
        _this.contractPower = _this.saConfig.contract_power;

        if (_this.chart || _this.rootScope.isSimpleDisplay || _this.rootScope.isTabletDisplay) {
          _this.update();
        }

        if (!_this.rootScope.isTabletDisplay) {
          _this.timer = _this.interval(function () {
            _this.update();
          }, 20000);
        } else {
          _this.timer = _this.interval(function () {
            _this.update();
          }, 60000);
        }

        _this.remaningTimer = _this.interval(function () {
          _this.updateTime();
        }, 1000);
      }).catch(function (err) {
        if (err.status === 404 || err.status === 403) {
          _this.state.go('main.home');
        }
      });

      this.MonthlyMaxDemandPowerService.show({ id: this.id }, function (max_power) {
        _this.maxPower = max_power;
      }, function (error_response) {
        _this.maxPower = null;
      });
    }
  }, {
    key: 'update',
    value: function update() {
      var _this2 = this;

      if (this.cookies.get('tabret_view') === 'on') {
        this.rootScope.isFullScreen = true;
        this.rootScope.isTabletDisplay = true;
      }

      var instActivePowers = null;
      var predictedValue = null;
      var basePower = null;
      this.targetDate = new Date();

      var _DateUtil$getDemandRa = this.DateUtil.getDemandRange(this.moment(this.targetDate).add(this.moment().utcOffset(), 'minutes').toDate());

      var _DateUtil$getDemandRa2 = _slicedToArray(_DateUtil$getDemandRa, 2);

      this.demand_start_time = _DateUtil$getDemandRa2[0];
      this.demand_end_time = _DateUtil$getDemandRa2[1];

      this.q.all([this.InstActivePowerService.api.show({ id: this.id }).$promise, this.ActivePowerService.show(this.activePowerQuery(this.id, this.demand_start_time)).$promise]).then(function (responses) {
        instActivePowers = responses[0];

        var activePowers = responses[1].powers;
        if (activePowers.length > 0) {
          basePower = activePowers[0].value;
        }

        return _this2.PredictedPowerService.api.show({ id: _this2.id }).$promise;
      }).then(function (response) {
        predictedValue = response.value;
      }).finally(function () {
        _this2.updateGraph(instActivePowers, predictedValue, basePower);
      });

      this.DeviceErrorService.api.show({ id: this.id }, function (response) {
        _this2.deviceError = response;
      });
      if (!this.rootScope.isTabletDisplay) {
        this.EventService.api.show({ id: this.id }, function (response) {
          _this2.eventList = response;
          _this2.eventCsv = _this2.CsvUtil.processEvent(_this2.eventList);
          _this2.downloadFileName = _this2.moment().format('[event]_YYYY-MM-DD[.csv]');
        });
        this.MonthlyMaxDemandPowerService.show({ id: this.id }, function (max_power) {
          _this2.maxPower = max_power;
        }, function (error_response) {
          _this2.maxPower = null;
        });
        this.WeatherService.api.index({ sa_config_id: this.id }, function (res) {
          _this2.currentWeather = res[0];
        });
      }
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(instActivePowers, predictedValue, basePower) {
      var todayPowers = instActivePowers.today_powers.map(function (power) {
        return {
          value: power.value * 2,
          measured_at: power.measured_at
        };
      });
      var yesterdayPowers = instActivePowers.yesterday_powers.map(function (power) {
        return {
          value: power.value * 2,
          measured_at: power.measured_at
        };
      });

      var lastPower = todayPowers[todayPowers.length - 1];
      var beforePower = todayPowers[todayPowers.length - 2];

      this.currentPower = null;
      this.powerDiff = null;
      var base = null;
      if (todayPowers.length > 0) {
        base = basePower === null || basePower === 0 ? todayPowers[0].value : basePower * 2;
        this.currentPower = this.MathUtil.subtract(lastPower.value, base);
        this.powerDiff = this.MathUtil.subtract(lastPower.value, beforePower.value);
      }

      var contract_powers = [];
      var limit_powers = [];
      var target_powers = [];

      if (this.contractPower !== 0) {
        this.predictedDemand = predictedValue;

        var insertTime = this.moment(this.demand_start_time);
        for (var i = 0; i <= 15; i++) {
          contract_powers.push([insertTime.valueOf(), this.contractPower]);
          limit_powers.push([insertTime.valueOf(), this.limitPower]);
          target_powers.push([insertTime.valueOf(), this.targetPower]);
          insertTime.add(2, 'minutes');
        }
      }

      var predictedData = [];
      var baseThreshold = this.effectiveThreshold(this.targetPower, this.limitPower, this.contractPower);
      if (this.predictedDemand !== null) {
        predictedData.push([this.moment(lastPower.measured_at).add(9, 'hours').valueOf(), this.currentPower]);
        predictedData.push([this.demand_end_time.valueOf(), this.predictedDemand]);

        this.predictedPercentage = 100 * this.predictedDemand / baseThreshold;
      }

      if (this.rootScope.isSimpleDisplay || this.rootScope.isTabletDisplay) {
        return;
      }

      this.chart.setTitle({ text: 'デマンド状況と予測' }, { text: this.DateUtil.getDemandTitle(this.targetDate) }, false);
      this.chart.series[0].setData(target_powers, false);
      this.chart.series[1].setData(limit_powers, false);
      this.chart.series[2].setData(contract_powers, false);
      this.chart.series[3].setData(predictedData, false);
      this.chart.series[4].setData(this.formatInstActivePowers(yesterdayPowers, null, 1), false);
      this.chart.series[5].setData(this.formatInstActivePowers(todayPowers, base, 0), false);

      this.chart.redraw();
      this.chart.reflow();
    }
  }, {
    key: 'updateTime',
    value: function updateTime() {
      var now = this.moment();
      var end = this.moment(this.demand_end_time).subtract(9, 'hours');
      var minutesDiff = end.diff(now, 'minutes');
      var secondsDiff = end.diff(now, 'seconds') % 60;

      this.remainingTimeStr = this.zeroPadding(minutesDiff) + ':' + this.zeroPadding(secondsDiff);
      this.remainingDiff = end.diff(now, 'seconds');
    }
  }, {
    key: 'zeroPadding',
    value: function zeroPadding(num) {
      if (num < 0) {
        num = 0;
      }
      return ('0' + num).slice(-2);
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      this.rootScope.isFullScreen = false;
      this.rootScope.isSimpleDisplay = false;
      this.rootScope.isTabletDisplay = false;

      if (this.timer) {
        this.interval.cancel(this.timer);
      }
      if (this.remaningTimer) {
        this.interval.cancel(this.remaningTimer);
      }

      this.cookies.put('tabret_view', 'off');
    }
  }, {
    key: 'formatInstActivePowers',
    value: function formatInstActivePowers(instActivePowers, base, elapsedDate) {
      var _this3 = this;

      if (instActivePowers.length === 0) {
        return [];
      }
      base = base || instActivePowers[0].value;

      return instActivePowers.map(function (instActivePower) {
        return {
          x: _this3.DateUtil.leapJstDate(instActivePower.measured_at, elapsedDate),
          y: _this3.MathUtil.subtract(instActivePower.value, base)
        };
      });
    }
  }, {
    key: 'activePowerQuery',
    value: function activePowerQuery(id, demandStartTime) {
      var target = this.moment(demandStartTime).subtract(this.moment().utcOffset(), 'minutes');
      return {
        id: id,
        start_y: target.year(),
        start_m: target.month() + 1,
        start_d: target.date(),
        start_hour: target.hour(),
        start_min: target.minute(),
        end_y: target.year(),
        end_m: target.month() + 1,
        end_d: target.date(),
        end_hour: target.hour(),
        end_min: target.minute()
      };
    }
  }, {
    key: 'effectiveThreshold',
    value: function effectiveThreshold(targetPower, limitPower, contractPower) {
      if (targetPower > 0) {
        return targetPower;
      }
      if (limitPower > 0) {
        return limitPower;
      }
      if (contractPower > 0) {
        return contractPower;
      }
    }
  }, {
    key: 'toggleFullScreen',
    value: function toggleFullScreen() {
      var _this4 = this;

      this.rootScope.isFullScreen = !this.rootScope.isFullScreen;

      setTimeout(function () {
        if (_this4.rootScope.isFullScreen) {
          _this4.chart.setSize(null, 450, false);
        } else {
          _this4.chart.setSize(null, 400, false);
        }
        _this4.chart.redraw();
        _this4.chart.reflow();
      }, 350);
    }
  }, {
    key: 'toggleSimpleDisplay',
    value: function toggleSimpleDisplay() {
      this.rootScope.isSimpleDisplay = !this.rootScope.isSimpleDisplay;
      this.rootScope.isFullScreen = !this.rootScope.isFullScreen;
      this.update();
    }
  }, {
    key: 'toggleTabletDisplay',
    value: function toggleTabletDisplay() {
      var _this5 = this;

      this.rootScope.isTabletDisplay = !this.rootScope.isTabletDisplay;
      this.rootScope.isFullScreen = !this.rootScope.isFullScreen;

      if (this.timer) {
        this.interval.cancel(this.timer);
      }
      if (this.rootScope.isTabletDisplay) {
        this.cookies.put('tabret_view', 'on', { expires: this.moment().add(30, 'year').toDate() });

        this.timer = this.interval(function () {
          _this5.update();
        }, 60000);
      } else {
        this.cookies.put('tabret_view', 'off', { expires: this.moment().add(30, 'year').toDate() });

        this.timer = this.interval(function () {
          _this5.update();
        }, 20000);
      }
      this.update();
    }
  }]);

  return DemandDetailController;
}();

exports.default = _angular2.default.module('leptonApp.demandDetail', [_angularjs2.default, _angularCookies2.default, _inst_active_power2.default, _sa_config2.default, _monthly_max_demand_power2.default, _chart2.default, _date_util2.default, _angularMoment2.default, _math_util2.default, _csv2.default, _event2.default, _device_error2.default, _predicted_power2.default, _active_power2.default, _weather2.default]).config(_demand_detail2.default).component('demandDetail', {
  template: __webpack_require__(710),
  controller: DemandDetailController
}).name;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.demand_monitoring.demand_detail', {
    template: '<demand-detail></demand-detail>'
  });
};

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  var chartConfig = {
    chart: {
      type: 'line',
      height: 400,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    title: {
      text: 'デマンド状況'
    },
    xAxis: {
      type: 'datetime',
      labels: {
        format: "{value:%H:%M}"
      }
    },
    yAxis: {
      plotBands: [{
        color: 'rgba(68,170,213,0.1)'
      }],
      title: {
        text: 'kW',
        margin: 5,
        style: { color: '#5d5d5d' }
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      floating: true,
      verticalAlign: 'top',
      reversed: true,
      x: -45
    },
    tooltip: {
      headerFormat: '<span style="font-size: 12px;">{point.key}</span><br/>',
      pointFormat: "<span style=\"color:{point.color}\">\u25CF</span> {series.name}: <b style=\"font-size: 14px;\">{point.y} kW</b><br/>",
      xDateFormat: '%H:%M:%S'
    },
    plotOptions: {
      line: {
        marker: {
          enabled: false
        }
      }
    },
    series: [{
      name: '目標電力',
      color: '#8bc34a',
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      tooltip: {
        followPointer: true,
        headerFormat: ''
      }
    }, {
      name: '限界電力',
      color: '#e67e22',
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      tooltip: {
        followPointer: true,
        headerFormat: ''
      }
    }, {
      name: '契約電力',
      color: '#D32F2F',
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      tooltip: {
        followPointer: true,
        headerFormat: ''
      }
    }, {
      name: '予測値',
      color: '#00acc1',
      marker: {
        enabled: false
      },
      dashStyle: 'ShortDash',
      lineWidth: 3,
      tooltip: {
        headerFormat: ''
      }
    }, {
      name: '前日の実績',
      color: '#3d5afe',
      marker: {
        enabled: false
      },
      turboThreshold: 0
    }, {
      name: '実績',
      color: '#26c6da',
      marker: {
        symbol: 'circle'
      },
      lineWidth: 4,
      turboThreshold: 0
    }]
  };

  return chartConfig;
}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = "<div class=\"demand-detail-content\" ng-if=\"!$root.isSimpleDisplay && !$root.isTabletDisplay\">\n  <table id=\"demandSummary\" ng-class=\"{'fullscreen-demand-summary': $root.isFullScreen}\"\n         md-whiteframe=\"1\">\n    <tr style=\"background-color: #3f51b5; color: #FFF; padding: 0 5px\">\n      <th ng-if=\"$ctrl.currentWeather\">\n        <img class=\"sun-cloud-icon\" src=\"vendor/weather-icons/sun_cloud.png\"/> {{$ctrl.currentWeather.measured_at | date : 'HH:mm'}} 時点の天気\n      </th>\n      <th ng-if=\"!$ctrl.currentWeather\">\n        <img class=\"sun-cloud-icon\" src=\"vendor/weather-icons/sun_cloud.png\"/> 天候情報\n      </th>\n      <th>ステータス</th>\n      <th>残り時間</th>\n      <th ng-if=\"$root.demandEnabled\">デマンド予測</th>\n      <th>現在電力</th>\n      <th>今月の最大デマンド</th>\n    </tr>\n    <tr>\n      <td>\n        <weather-directive weather=\"$ctrl.currentWeather\" link-id=\"$ctrl.id\" device=\"$ctrl.saConfig\"></weather-directive>\n      </td>\n      <td ng-class=\"$ctrl.deviceError.has_error ? 'demand-status-error' : 'demand-status-normal'\"\n          style=\"font-size: 15px;\">\n        {{ $ctrl.deviceError | getErrorMessage }}\n      </td>\n      <td class=\"demand-summary-time\" style=\"font-weight: bold; font-size: 20px;\">\n        {{ $ctrl.remainingTimeStr }}\n      </td>\n      <td ng-if=\"$root.demandEnabled\">\n            <span ng-if=\"$ctrl.predictedDemand\">\n                <span class=\"value\">\n                    {{$ctrl.predictedPercentage | number:0}}\n                </span> % (<span style=\"font-size: 14px\">{{$ctrl.predictedDemand | number: 1}}</span> kW)\n            </span>\n        <span ng-if=\"!$ctrl.predictedDemand\" class=\"empty-value\">未計算</span>\n      </td>\n      <td ng-if=\"$ctrl.currentPower !== null\"><span class=\"value\">{{$ctrl.currentPower}}</span> kW</td>\n      <td ng-if=\"$ctrl.currentPower === null\"><span class=\"empty-value\"> 未受信 </span></td>\n      <td ng-if=\"$ctrl.maxPower !== null\"><span class=\"value\">{{$ctrl.maxPower.value}}</span> kW (\n        {{$ctrl.maxPower.measured_at | date: 'M月d日'}}({{$ctrl.maxPower.measured_at | dayFilter}}) )\n      </td>\n      <td ng-if=\"$ctrl.maxPower === null\"><span class=\"empty-value\"> 未受信 </span></td>\n    </tr>\n  </table>\n  <div class='graph-and-event'>\n    <div class='demand-graph-area'>\n      <md-content>\n        <div class=\"full-screen-button align-right\">\n          <div></div>\n          <div>\n          <span ng-click=\"$ctrl.toggleTabletDisplay()\" ng-if=\"!$root.isFullScreen\">\n              <i class=\"fas fa-tablet-alt\" aria-hidden=\"true\" style=\"font-size: 21px\"></i>\n          </span>\n          <span ng-click=\"$ctrl.toggleSimpleDisplay()\" ng-if=\"!$root.isFullScreen\">\n              <i class=\"fas fa-desktop\" aria-hidden=\"true\" style=\"font-size: 21px\"></i>\n          </span>\n            <span ng-click=\"$ctrl.toggleFullScreen()\">\n              <i class=\"fas\" aria-hidden=\"true\" style=\"font-size: 21px\"\n                 ng-class=\"$root.isFullScreen ? 'fa-compress' : 'fa-expand'\"></i>\n          </span>\n          </div>\n        </div>\n        <chart value=\"$ctrl.chartConfig\"></chart>\n      </md-content>\n      <div class=\"demand-detail-sa-info animate front-slide\" ng-hide=\"$root.isFullScreen\">\n        <div class=\"demand-detail-sa-info-header\">\n          <i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>&nbsp; 機器情報 <span class=\"span-link\"\n                                                                                ui-sref=\"main.device_config_edit({id:{{$ctrl.id}}})\">編集</span>\n        </div>\n        <div class=\"demand-detail-sa-info-body\">\n          <table border=\"0\">\n            <tr>\n              <td>サービスコード</td>\n              <td>{{ $ctrl.saConfig.pms_service_code }}</td>\n            </tr>\n            <tr>\n              <td>管理ID</td>\n              <td>{{ $ctrl.saConfig.management_id }}</td>\n            </tr>\n            <tr>\n              <td>設置場所</td>\n              <td>{{ $ctrl.saConfig.location }}</td>\n            </tr>\n            <tr>\n              <td>メモ</td>\n              <td>{{ $ctrl.saConfig.memo }}</td>\n            </tr>\n            <tr>\n              <td>機器ID</td>\n              <td>{{ $ctrl.saConfig.distribution_id }}</td>\n            </tr>\n            <tr>\n              <td>目標電力</td>\n              <td>{{ $ctrl.saConfig.target_power }} kW</td>\n            </tr>\n            <tr>\n              <td>限界電力</td>\n              <td>{{ $ctrl.saConfig.limit_power }} kW</td>\n            </tr>\n            <tr>\n              <td>契約電力</td>\n              <td>{{ $ctrl.saConfig.contract_power }} kW</td>\n            </tr>\n          </table>\n        </div>\n      </div>\n    </div>\n    <div class=\"subcontent demand-event-area animate side-slide\" style=\"margin: 0 0 0 10px;\" ng-hide=\"$root.isFullScreen\">\n      <div class=\"event-list-title align-right\">\n        <div>\n          <h4>イベント履歴</h4>\n        </div>\n        <div>\n          <a class=\"csv-downloader\" csv-downloader filename=\"$ctrl.downloadFileName\" csv-data=\"$ctrl.eventCsv\">\n            <i class=\"fa fa-download\" aria-hidden=\"true\"></i>\n          </a>\n        </div>\n      </div>\n      <div ng-if=\"$ctrl.eventList.length === 0\">\n        イベントはまだありません\n      </div>\n      <div class=\"device-event\" ng-if=\"$ctrl.eventList.length > 0\">\n        <md-list>\n          <md-list-item class=\"md-2-line\" ng-repeat=\"event in $ctrl.eventList\" style=\"padding: 0 0 0 10px;min-height: 0\">\n            <div class=\"event-list-item\" layout=\"row\" layout-align=\"start center\">\n              <i ng-class=\"event.is_error ? 'fa fa-exclamation-circle error' : 'fa fa-check-square normal'\"></i>\n              <div class=\"event-info\" layout=\"column\" layout-align=\"space-around start\">\n                <div layout=\"row\" layout-align=\"space-between center\" style=\"width: 100%;\">\n                  <div class=\"event-msg\">\n                    {{ event.event_msg }}<span ng-if=\"event.triggered_by\" class=\"edited-by\"> (変更者: {{ event.triggered_by }})</span>\n                  </div>\n                </div>\n                <div class=\"event-minor-info\" layout=\"column\" layout-align=\"center end\">\n                  <span>{{ event.occurred_at | date : 'M/d HH:mm' }}</span>\n                </div>\n              </div>\n            </div>\n            <md-divider ng-if=\"!$last\"></md-divider>\n          </md-list-item>\n        </md-list>\n      </div>\n    </div>\n  </div>\n</div>\n<simple-demand-display\n        ng-if=\"$root.isSimpleDisplay\"\n        time-str=\"$ctrl.remainingTimeStr\"\n        max-power=\"$ctrl.maxPower\"\n        predicted-demand=\"$ctrl.predictedDemand\"\n        current-power=\"$ctrl.currentPower\"\n        device-error=\"$ctrl.deviceError\"\n        remaining-diff=\"$ctrl.remainingDiff\"\n        target-power=\"$ctrl.targetPower\"\n        limit-power=\"$ctrl.limitPower\"\n        contract-power=\"$ctrl.contractPower\"\n        power-diff=\"$ctrl.powerDiff\"\n        toggle=\"$ctrl.toggleSimpleDisplay()\"></simple-demand-display>\n<tablet-demand-display\n        ng-if=\"$root.isTabletDisplay\"\n        time-str=\"$ctrl.remainingTimeStr\"\n        max-power=\"$ctrl.maxPower\"\n        predicted-demand=\"$ctrl.predictedDemand\"\n        current-power=\"$ctrl.currentPower\"\n        device-error=\"$ctrl.deviceError\"\n        remaining-diff=\"$ctrl.remainingDiff\"\n        target-power=\"$ctrl.targetPower\"\n        limit-power=\"$ctrl.limitPower\"\n        contract-power=\"$ctrl.contractPower\"\n        power-diff=\"$ctrl.powerDiff\"\n        toggle=\"$ctrl.toggleTabletDisplay()\"></tablet-demand-display>\n"

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _demand_monitoring = __webpack_require__(712);

var _demand_monitoring2 = _interopRequireDefault(_demand_monitoring);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _angular2.default.module('leptonApp.demandMonitoring', [_angularjs2.default]).config(_demand_monitoring2.default).component('demandMonitoring', {
    template: __webpack_require__(713)
}).name;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.demand_monitoring', {
    template: '<demand-monitoring></demand-monitoring>'
  }).state('main.demand_monitoring.daily_report', {
    url: 'demand_monitoring/:id',
    views: {
      inst_active_power: {
        template: '<demand-detail></demand-detail>'
      }
    }
  });
};

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <div ui-view=\"inst_active_power\" ng-class=\"$root.isSimpleDisplay ? 'demand-monitoring-simple-display' : 'demand-monitoring'\"></div>\n</div>\n"

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ExternalApiCredentialController = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _external_api_credential = __webpack_require__(715);

var _external_api_credential2 = _interopRequireDefault(_external_api_credential);

var _external_api_credential3 = __webpack_require__(549);

var _external_api_credential4 = _interopRequireDefault(_external_api_credential3);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var ExternalApiCredentialController = exports.ExternalApiCredentialController = function () {
    /*@ngInject*/
    ExternalApiCredentialController.$inject = ["$state", "ExternalApiCredentialService", "$mdDialog", "$location", "$stateParams"];
    function ExternalApiCredentialController($state, ExternalApiCredentialService, $mdDialog, $location, $stateParams) {
        _classCallCheck(this, ExternalApiCredentialController);

        this.ExternalApiCredentialService = ExternalApiCredentialService;
        this.access_key = '読み込み中';
        this.access_token = '読み込み中';
        this.updated_at = '読み込み中';
        this.company_id = $stateParams.company_id;
        this.$location = $location;
        this.$mdDialog = $mdDialog;
        this.$state = $state;
        this.dialog = {
            confirm: $mdDialog.confirm({
                disableParentScroll: false,
                title: '本当に変更しますか？',
                ok: '変更する',
                cancel: '変更しない'
            }),
            success: $mdDialog.alert({
                disableParentScroll: false,
                title: '変更しました',
                ok: 'OK'
            }),
            error: $mdDialog.alert({
                disableParentScroll: false,
                title: 'エラーが発生しました',
                ok: 'OK'
            })
        };
    }

    _createClass(ExternalApiCredentialController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.ExternalApiCredentialService.index({ company_id: this.company_id }, function (response) {
                _this.access_key = response.access_key;
                _this.access_token = response.access_token;
                _this.updated_at = response.updated_at;
            }, function (err) {
                if (err.status === 404 || err.status === 403) {
                    _this.$state.go('oem_main.oem_home');
                }
            });
        }
    }, {
        key: 'showConfirm',
        value: function showConfirm() {
            var _this2 = this;

            this.$mdDialog.show(this.dialog.confirm).then(function () {
                _this2.ExternalApiCredentialService.create({ company_id: _this2.company_id }, function (okResponse) {
                    _this2.access_key = okResponse.access_key;
                    _this2.access_token = okResponse.access_token;
                    _this2.updated_at = okResponse.updated_at;
                    _this2.$mdDialog.show(_this2.dialog.success);
                }, function (errResponse) {
                    _this2.$mdDialog.show(_this2.dialog.error.content(errResponse.data.message));
                });
            });
        }
    }]);

    return ExternalApiCredentialController;
}();

exports.default = _angular2.default.module('leptonApp.externalApiCredential', [_angularjs2.default, _external_api_credential4.default]).config(_external_api_credential2.default).component('externalApiCredential', {
    template: __webpack_require__(716),
    controller: ExternalApiCredentialController
}).name;

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('oem_main.external_api_credential', {
        url: '/company/:company_id/external_api_credential',
        template: '<external-api-credential></external-api-credential>'
    });
};

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n    <div class=\"md-toolbar-tools\">\n        <h2><i class=\"fa fa-key\"></i>&nbsp;API認証情報</h2>\n    </div>\n</md-toolbar>\n<md-item-content>\n    <div class=\"credential-set\">\n        <h3 class=\"external-api-credential-value\">Access Key : {{$ctrl.access_key}}</h3>\n        <h3 class=\"external-api-credential-value\">Access Token : {{$ctrl.access_token}}</h3>\n        <h4 class=\"last-update-date\">最終変更日 : {{$ctrl.updated_at | date:'yyyy-MM-dd'}}</h4>\n    </div>\n</md-item-content>\n<md-divider></md-divider>\n<div class=\"viewPadding\" layout=\"column\" layout-align=\"space-around start\">\n    <div class=\"change-credential-button\">\n        <md-button ng-click=\"$ctrl.showConfirm()\" class=\"md-warn md-raised\" style=\"padding: 3px 40px; font-size: 20px; color: #FFF;margin-left: 0;\">\n            変更する\n        </md-button>\n    </div>\n    <div class=\"attention-info\">\n        <i class=\"fa fa-warning\"></i>&nbsp;現在の Key と Token を失効して、新しい値を生成します。<br>\n        変更に伴い、お客様のシステムも設定を変更する必要がございます。\n    </div>\n</div>\n"

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DeviceErrorController = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _device_error = __webpack_require__(718);

var _device_error2 = _interopRequireDefault(_device_error);

var _device_error3 = __webpack_require__(469);

var _device_error4 = _interopRequireDefault(_device_error3);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var DeviceErrorController = exports.DeviceErrorController = function () {
    /*@ngInject*/
    DeviceErrorController.$inject = ["DeviceErrorService", "$interval"];
    function DeviceErrorController(DeviceErrorService, $interval) {
        _classCallCheck(this, DeviceErrorController);

        this.cloud_discon_list = [];
        this.meter_fault_list = [];
        this.meter_not_found_list = [];
        this.demand_fault_list = [];

        this.interval = $interval;

        this.DeviceErrorService = DeviceErrorService;
    }

    _createClass(DeviceErrorController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.update();

            this.timer = this.interval(function () {
                _this.update();
            }, 20000);
        }
    }, {
        key: 'update',
        value: function update() {
            var _this2 = this;

            var cloud_discon_list = [];
            var meter_fault_list = [];
            var meter_not_found_list = [];
            var demand_fault_list = [];

            this.DeviceErrorService.api.index(function (error_list) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = error_list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var error = _step.value;

                        if (error.cloud_disconnected) {
                            cloud_discon_list.push(error);
                        }
                        if (error.meter_not_found) {
                            meter_not_found_list.push(error);
                        }
                        if (error.meter_off || error.meter_fault) {
                            meter_fault_list.push(error);
                        }
                        if (error.demand_fault) {
                            demand_fault_list.push(error);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                _this2.cloud_discon_list = cloud_discon_list;
                _this2.meter_not_found_list = meter_not_found_list;
                _this2.meter_fault_list = meter_fault_list;
                _this2.demand_fault_list = demand_fault_list;
            });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            if (this.timer) {
                this.interval.cancel(this.timer);
            }
        }
    }, {
        key: 'isReadingDevice',
        value: function isReadingDevice(device) {
            return device.operating_mode === 'reading';
        }
    }]);

    return DeviceErrorController;
}();

exports.default = _angular2.default.module('leptonApp.deviceError', [_angularjs2.default, _device_error4.default]).config(_device_error2.default).component('deviceError', {
    template: __webpack_require__(719),
    controller: DeviceErrorController
}).name;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.device_error', {
        url: 'device_error',
        template: '<device_error></device_error>'
    });
};

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n    <div class=\"md-toolbar-tools\">\n        <h2><i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>&nbsp;異常状態機器一覧</h2>\n    </div>\n</md-toolbar>\n<md-content class=\"error-device-list\">\n    <div class=\"error-header\">\n        <h3><i class=\"fas fa-cloud-upload-alt\" aria-hidden=\"true\"></i>&nbsp;クラウドと未接続</h3>\n        <span><i class=\"fa fa-hand-o-right\"></i> インターネットへの接続、モバイルの設定内容やモバイルサービスの障害・メンテナンスの有無を確認してください。</span>\n    </div>\n    <md-list>\n        <md-item ng-repeat=\"item in $ctrl.cloud_discon_list\">\n            <md-divider></md-divider>\n            <a ui-sref=\"{{ $ctrl.isReadingDevice(item) ?\n             'main.demand_monitoring.daily_report({ id: item.id })' : 'main.controller_device_edit({ id: item.id })' }}\"\n             style=\"text-decoration: none;\">\n                <div class=\"md-tile-content error-content\">\n                    <div><span class=\"error-service-code\">{{ item.pms_service_code }}</span><span class=\"error-memo\"> {{ item.memo }}</span>\n                    </div>\n                    <div class=\"minor-info\">{{ item.location }}</div>\n                    <div class=\"minor-info\">更新日時: {{ item.updated_at | date:'yyyy-MM-dd HH:mm' }}</div>\n                </div>\n            </a>\n        </md-item>\n    </md-list>\n    <div class=\"empty-info\" ng-if=\"$ctrl.cloud_discon_list.length === 0\">\n        なし\n    </div>\n</md-content>\n<md-divider class=\"error-divider\"></md-divider>\n\n<md-content class=\"error-device-list\" ng-if=\"$root.demandEnabled\">\n    <div class=\"error-header\">\n        <h3><i class=\"fas fa-tachometer-alt\" aria-hidden=\"true\" style=\"font-size: 22px;\"></i>&nbsp;データ取得失敗</h3>\n        <span><i class=\"fa fa-hand-o-right\"></i> スマートメーターからのデータ取得に失敗しました。一時的にデマンド予測が停止している可能性があります。</span>\n    </div>\n    <md-list>\n        <md-item ng-repeat=\"item in $ctrl.demand_fault_list\">\n            <md-divider></md-divider>\n            <a ui-sref=\"{{ $ctrl.isReadingDevice(item) ?\n             'main.demand_monitoring.daily_report({ id: item.id })' : 'main.controller_device_edit({ id: item.id })' }}\"\n             style=\"text-decoration: none;\">\n                <div class=\"md-tile-content error-content\">\n                    <div><span class=\"error-service-code\">{{ item.pms_service_code }}</span><span class=\"error-memo\"> {{ item.memo }}</span>\n                    </div>\n                    <div class=\"minor-info\">{{ item.location }}</div>\n                    <div class=\"minor-info\">更新日時: {{ item.updated_at | date:'yyyy-MM-dd HH:mm' }}</div>\n                </div>\n            </a>\n        </md-item>\n    </md-list>\n    <div class=\"empty-info\" ng-if=\"$ctrl.demand_fault_list.length === 0\">\n        なし\n    </div>\n</md-content>\n<md-divider class=\"error-divider\" ng-if=\"$root.demandEnabled\"></md-divider>\n\n<md-content class=\"error-device-list\">\n    <div class=\"error-header\">\n        <h3><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>&nbsp;スマートメーターが見つからない</h3>\n        <span><i class=\"fa fa-hand-o-right\"></i> 端末とスマートメーター間の接続を確認してください。</span>\n    </div>\n    <md-list>\n        <md-item ng-repeat=\"item in $ctrl.meter_not_found_list\">\n            <md-divider></md-divider>\n            <a ui-sref=\"{{ $ctrl.isReadingDevice(item) ?\n             'main.demand_monitoring.daily_report({ id: item.id })' : 'main.controller_device_edit({ id: item.id })' }}\"\n             style=\"text-decoration: none;\">\n                <div class=\"md-tile-content error-content\">\n                    <div><span class=\"error-service-code\">{{ item.pms_service_code }}</span><span class=\"error-memo\"> {{ item.memo }}</span>\n                    </div>\n                    <div class=\"minor-info\">{{ item.location }}</div>\n                    <div class=\"minor-info\">更新日時: {{ item.updated_at | date:'yyyy-MM-dd HH:mm' }}</div>\n                </div>\n            </a>\n        </md-item>\n    </md-list>\n    <div class=\"empty-info\" ng-if=\"$ctrl.meter_not_found_list.length === 0\">\n        なし\n    </div>\n</md-content>\n<md-divider class=\"error-divider\"></md-divider>\n\n<md-content class=\"error-device-list\">\n    <div class=\"error-header\">\n        <h3><i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>&nbsp;スマートメーターから異常通知を受信</h3>\n        <span><i class=\"fa fa-hand-o-right\"></i> スマートメーターが正常復旧するまでお待ちください。</span>\n    </div>\n    <md-list>\n        <md-item ng-repeat=\"item in $ctrl.meter_fault_list\">\n            <md-divider></md-divider>\n            <a ui-sref=\"{{ $ctrl.isReadingDevice(item) ?\n             'main.demand_monitoring.daily_report({ id: item.id })' : 'main.controller_device_edit({ id: item.id })' }}\"\n             style=\"text-decoration: none;\">\n                <div class=\"md-tile-content error-content\">\n                    <div><span class=\"error-service-code\">{{ item.pms_service_code }}</span><span class=\"error-memo\"> {{ item.memo }}</span>\n                    </div>\n                    <div class=\"minor-info\">{{ item.location }}</div>\n                    <div class=\"minor-info\">更新日時: {{ item.updated_at | date:'yyyy-MM-dd HH:mm' }}</div>\n                </div>\n            </a>\n        </md-item>\n    </md-list>\n    <div class=\"empty-info\" ng-if=\"$ctrl.meter_fault_list.length === 0\">\n        なし\n    </div>\n</md-content>\n<md-divider class=\"error-divider\"></md-divider>\n"

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceIndexController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _device_index = __webpack_require__(721);

var _device_index2 = _interopRequireDefault(_device_index);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _controller_config = __webpack_require__(91);

var _controller_config2 = _interopRequireDefault(_controller_config);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DeviceIndexController = exports.DeviceIndexController = function () {
  /*@ngInject*/
  DeviceIndexController.$inject = ["SaConfigService", "ControllerConfigService"];
  function DeviceIndexController(SaConfigService, ControllerConfigService) {
    _classCallCheck(this, DeviceIndexController);

    this.saList = [];
    this.SaConfigService = SaConfigService;
    this.ControllerConfigService = ControllerConfigService;
  }

  _createClass(DeviceIndexController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.SaConfigService.api.index().$promise.then(function (response) {
        _this.saList = response;

        return _this.ControllerConfigService.api.index().$promise;
      }).then(function (response) {
        var controllerDeviceList = response;

        _this.saList.forEach(function (device) {
          var controlTargets = controllerDeviceList.filter(function (controllerDevice) {
            return controllerDevice.reading_device_id === device.id;
          });
          device.controlTargets = controlTargets;
        });
      });
    }
  }]);

  return DeviceIndexController;
}();

exports.default = _angular2.default.module('leptonApp.deviceIndex', [_angularjs2.default, _sa_config2.default, _controller_config2.default]).config(_device_index2.default).component('deviceIndex', {
  template: __webpack_require__(722),
  controller: DeviceIndexController
}).name;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.device_index', {
    url: 'device_index',
    template: '<device-index></device-index>'
  });
};

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-wrench\"></i>&nbsp;メーター 一覧</h2>\n  </div>\n</md-toolbar>\n<div ng-if=\"$ctrl.saList.length === 0\" class=\"empty-notice\">設定済みの機器がありません。</div>\n<md-content>\n  <md-list-item class=\"md-3-line\" ng-repeat=\"sa in $ctrl.saList\" style=\"flex-direction: column; padding-right: 0;\">\n    <div class=\"device-list-item-row\">\n      <config-index-item device=\"sa\"></config-index-item>\n      <md-divider></md-divider>\n    </div>\n    <md-list-item style=\"padding: 0;\" class=\"md-3-line control-device-list\" ng-repeat=\"controlDevice in sa.controlTargets\">\n      <div class=\"device-list-item-row\">\n        <md-divider></md-divider>\n        <config-index-item device=\"controlDevice\" second-indent=\"true\"></config-index-item>\n      </div>\n    </md-list-item>\n  </md-list-item>\n</md-content>\n"

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceConfigEditController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _device_config_edit = __webpack_require__(724);

var _device_config_edit2 = _interopRequireDefault(_device_config_edit);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _readonly_if = __webpack_require__(497);

var _readonly_if2 = _interopRequireDefault(_readonly_if);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DeviceConfigEditController = exports.DeviceConfigEditController = function () {
  /*@ngInject*/
  DeviceConfigEditController.$inject = ["$stateParams", "SaConfigService", "$state", "$mdDialog"];
  function DeviceConfigEditController($stateParams, SaConfigService, $state, $mdDialog) {
    _classCallCheck(this, DeviceConfigEditController);

    this.id = $stateParams.id;
    this.SaConfigService = SaConfigService;
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.dialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '変更しますか？',
        ok: '変更する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '変更しました',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };
  }

  _createClass(DeviceConfigEditController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.SaConfigService.api.show({ id: this.id }, function (response) {
        _this.deviceConfig = response;
      }, function (err) {
        if (err.status === 404 || err.status === 403) {
          _this.$state.go('main.home');
        }
      });
    }
  }, {
    key: 'showConfirm',
    value: function showConfirm(deviceConfig, ev) {
      var _this2 = this;

      this.$mdDialog.show(this.dialog.confirm.targetEvent(ev)).then(function () {
        deviceConfig.base_unit_price = deviceConfig.base_unit_price || 0;
        deviceConfig.power_unit_price = deviceConfig.power_unit_price || 0;
        _this2.SaConfigService.api.update(deviceConfig, function (okResponse) {
          _this2.$mdDialog.show(_this2.dialog.success);
        }, function (errResponse) {
          _this2.$mdDialog.show(_this2.dialog.error.content(errResponse.data.message));
        });
      });
    }
  }]);

  return DeviceConfigEditController;
}();

exports.default = _angular2.default.module('leptonApp.deviceConfigEdit', [_angularjs2.default, _sa_config2.default, _readonly_if2.default]).config(_device_config_edit2.default).component('deviceConfigEdit', {
  template: __webpack_require__(725),
  controller: DeviceConfigEditController
}).name;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.device_config_edit', {
    url: 'device_config_edit/:id',
    template: '<device-config-edit></device-config-edit>'
  });
};

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-wrench\"></i>&nbsp;設定変更: {{$ctrl.deviceConfig.pms_service_code}}</h2>\n  </div>\n</md-toolbar>\n<md-content style=\"padding: 20px 30px;\">\n  <form readonly-if=\"$root.is_viewer\" name=\"configForm\" novalidate>\n    <h4 class=\"input-group-title\">管理情報</h4>\n    <div layout-gt-sm=\"row\" style=\"width: 70%;\">\n      <md-input-container class=\"md-block input-container\" flex-gt-sm style=\"margin-right: 20px;\">\n        <label>メモ</label>\n        <input name=\"memo\" ng-model=\"$ctrl.deviceConfig.memo\" md-maxlength=\"128\" maxlength=\"128\">\n        <div ng-messages=\"configForm.memo.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">128文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <md-input-container class=\"input-container zip-input-content\" flex-gt-sm>\n      <div>\n        <label>郵便番号 (現地の天候情報取得に使用されます)</label>\n        <input name=\"zip_code\" ng-model=\"$ctrl.deviceConfig.zip_code\" placeholder=\"000-0000\" ng-pattern=\"/^[0-9]{3}-[0-9]{4}$/\">\n        <div ng-messages=\"configForm.zip_code.$error\" role=\"alert\">\n          <div ng-message=\"pattern\">000-0000の形式で記載してください</div>\n        </div>\n      </div>\n      <div class=\"weather-zip-notice\">\n        ※ 事業所用個別郵便番号では天候情報は取得できません。地域の郵便番号を設定ください。<br>\n        ※ 天候情報が取得できなかった場合は、近隣都市の郵便番号をお試しください。\n      </div>\n    </md-input-container>\n\n    <h4 class=\"input-group-title\">デマンド監視閾値</h4>\n    <span class=\"sub-info\">※ 0 を入力するとデマンド監視が無効化されます</span>\n    <div layout-gt-sm=\"row\">\n      <div layout-gt-sm=\"row\" flex=\"75\" offset=\"50\">\n        <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px; min-width: 150px;\">\n          <label>契約電力<span class=\"require-sign\"> ＊</span></label>\n          <input type=\"number\" name=\"contract_power\" ng-model=\"$ctrl.deviceConfig.contract_power\" min=\"0\" max=\"99999\"\n            flex=\"80\" required ng-pattern=\"/^[0-9][^\\.]*$/\">\n          <div class=\"power_unit\">&nbsp;&nbsp;kW</div>\n          <div ng-messages=\"configForm.contract_power.$error\" ng-if=\"configForm.contract_power.$dirty\" role=\"alert\" multiple>\n            <div ng-message=\"max\">99999 以下の数字を入力してください。</div>\n            <div ng-message=\"min\">0 以上の数字を入力してください。</div>\n            <div ng-message=\"number\">数値を入力してください。</div>\n            <div ng-message=\"pattern\">整数を入力してください</div>\n            <div ng-message=\"required\">0 ~ 99999 までの数字を入力してください。</div>\n          </div>\n        </md-input-container>\n\n        <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px; min-width: 150px;\">\n          <label>限界電力<span class=\"require-sign\"> ＊</span></label>\n          <input type=\"number\" name=\"limit_power\" ng-model=\"$ctrl.deviceConfig.limit_power\" min=\"0\" max=\"{{$ctrl.deviceConfig.contract_power}}\" flex=\"80\" required ng-pattern=\"/^[0-9][^\\.]*$/\">\n          <div class=\"power_unit\">&nbsp;&nbsp;kW</div>\n          <div ng-messages=\"configForm.limit_power.$error\" ng-if=\"configForm.limit_power.$dirty\" role=\"alert\" multiple>\n            <div ng-message=\"max\">契約電力量以下の数字を入力してください。</div>\n            <div ng-message=\"min\">0 以上の数字を入力してください。</div>\n            <div ng-message=\"number\">数値を入力してください。</div>\n            <div ng-message=\"pattern\">整数を入力してください</div>\n            <div ng-message=\"required\">0 ~ 契約電力量までの数字を入力してください。</div>\n          </div>\n        </md-input-container>\n\n        <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px; min-width: 150px;\">\n          <label>目標電力<span class=\"require-sign\"> ＊</span></label>\n          <input type=\"number\" name=\"target_power\" ng-model=\"$ctrl.deviceConfig.target_power\" min=\"0\" max=\"{{$ctrl.deviceConfig.limit_power}}\"\n            flex=\"80\" required ng-pattern=\"/^[0-9][^\\.]*$/\">\n          <div class=\"power_unit\">&nbsp;&nbsp;kW</div>\n          <div ng-messages=\"configForm.target_power.$error\" ng-if=\"configForm.target_power.$dirty\" role=\"alert\" multiple>\n            <div ng-message=\"max\">限界電力量以下の数字を入力してください。</div>\n            <div ng-message=\"min\">0 以上の数字を入力してください。</div>\n            <div ng-message=\"number\">数値を入力してください。</div>\n            <div ng-message=\"pattern\">整数を入力してください</div>\n            <div ng-message=\"required\">0 ~ 限界電力量までの数字を入力してください。</div>\n          </div>\n        </md-input-container>\n      </div>\n    </div>\n\n    <h4 class=\"input-group-title\">デマンド監視無効時間</h4>\n    <div class=\"dead-duration-sub\">デマンド時限開始から\n      <duration-selector ng-model=\"$ctrl.deviceConfig.demand_dead_duration\"></duration-selector>\n      分間 デマンド監視を無効化します。\n    </div>\n\n    <h4 class=\"input-group-title\">デマンド警報解除条件</h4>\n    <div class=\"dead-duration-sub\" ng-switch=\"$ctrl.deviceConfig.demand_level_down_count\">\n      <div ng-switch-when=3>標準判定\n        <span style=\"font-size: 12px; margin-left: 10px;\">(予測値が閾値の90％を下回った状態が3分間継続した時点で警報を解除します。)</span>\n      </div>\n      <div ng-switch-when=1>即時解除\n        <span style=\"font-size: 12px; margin-left: 10px;\">(予測値が閾値の90％を1度下回った時点で警報を解除します。)</span>\n      </div>\n    </div>\n\n    <h4 class=\"input-group-title\">電気料金単価</h4>\n    <div layout-gt-sm=\"row\" flex=\"75\">\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px; min-width: 150px;\">\n        <label>基本料金単価</label>\n        <input type=\"number\" name=\"base_unit_price\" ng-model=\"$ctrl.deviceConfig.base_unit_price\" min=\"0\" max=\"9999.99\" flex=\"80\" step=\"0.01\" ng-pattern=\"/^[0-9]+\\.?[0-9]{0,2}$/\">\n        <div class=\"power_unit\">&nbsp;&nbsp;円 /1 kW</div>\n        <div ng-messages=\"configForm.base_unit_price.$error\" ng-if=\"configForm.base_unit_price.$dirty\" role=\"alert\" multiple>\n          <div ng-message=\"max\">9999.99 以下の数字を入力してください。</div>\n          <div ng-message=\"min\">0 以上の数字を入力してください。</div>\n          <div ng-message=\"pattern\">小数２桁までの数値を入力してください</div>\n          <div ng-message=\"number\">数値を入力してください。</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px; min-width: 150px;\">\n        <label>電力量単価</label>\n        <input type=\"number\" name=\"power_unit_price\" ng-model=\"$ctrl.deviceConfig.power_unit_price\" min=\"0\" max=\"9999.99\" flex=\"80\" step=\"0.01\" ng-pattern=\"/^[0-9]+\\.?[0-9]{0,2}$/\">\n        <div class=\"power_unit\">&nbsp;&nbsp;円 /1 kWh</div>\n        <div ng-messages=\"configForm.power_unit_price.$error\" ng-if=\"configForm.power_unit_price.$dirty\" role=\"alert\" multiple>\n          <div ng-message=\"max\">9999.99 以下の数字を入力してください。</div>\n          <div ng-message=\"min\">0 以上の数字を入力してください。</div>\n          <div ng-message=\"pattern\">小数２桁までの数値を入力してください</div>\n          <div ng-message=\"number\">数値を入力してください。</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <h4 class=\"input-group-title\">機器 ID</h4>\n    <span style=\"font-size: 12px; color: #78747A\">※機器IDは変更することができません</span>\n    <div style=\"margin: 11px 2px 20px; font-size: 19px;\">\n      {{ $ctrl.deviceConfig.distribution_id }}\n    </div>\n\n    <md-button ng-click=\"$ctrl.showConfirm($ctrl.deviceConfig, $event)\" ng-disabled=\"configForm.$invalid\" class=\"md-primary md-raised\"\n      ng-if=\"$root.is_admin || $root.is_operator\" style=\"margin: 16px 0; padding: 0 20px\">\n      変更する\n    </md-button>\n  </form>\n</md-content>\n"

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControllerConfigEditController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _controller_edit = __webpack_require__(727);

var _controller_edit2 = _interopRequireDefault(_controller_edit);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _controller_config = __webpack_require__(91);

var _controller_config2 = _interopRequireDefault(_controller_config);

var _readonly_if = __webpack_require__(497);

var _readonly_if2 = _interopRequireDefault(_readonly_if);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var ControllerConfigEditController = exports.ControllerConfigEditController = function () {
  /*@ngInject*/
  ControllerConfigEditController.$inject = ["$state", "$stateParams", "$mdDialog", "SaConfigService", "ControllerConfigService"];
  function ControllerConfigEditController($state, $stateParams, $mdDialog, SaConfigService, ControllerConfigService) {
    _classCallCheck(this, ControllerConfigEditController);

    this.ControllerConfigService = ControllerConfigService;
    this.SaConfigService = SaConfigService;
    this.id = $stateParams.id;
    this.$state = $state;
    this.$mdDialog = $mdDialog;

    this.dialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '変更しますか？',
        ok: '変更する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '変更しました',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };
  }

  _createClass(ControllerConfigEditController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.ControllerConfigService.api.show({ id: this.id }, function (response) {
        _this.deviceConfig = response;
        _this.currentReadingId = _this.deviceConfig.reading_device_id = _this.deviceConfig.reading_device_id + '';

        _this.SaConfigService.api.index(function (response) {
          _this.readingDevices = response;
        });
      }, function (err) {
        if (err.status === 404 || err.status === 403) {
          _this.$state.go('main.home');
        }
      });
    }
  }, {
    key: 'showConfirm',
    value: function showConfirm(deviceConfig, ev) {
      var _this2 = this;

      this.$mdDialog.show(this.dialog.confirm.targetEvent(ev)).then(function () {
        _this2.ControllerConfigService.api.update(deviceConfig, function (okResponse) {
          _this2.$mdDialog.show(_this2.dialog.success);
        }, function (errResponse) {
          _this2.$mdDialog.show(_this2.dialog.error.content(errResponse.data.message));
        });
      });
    }
  }]);

  return ControllerConfigEditController;
}();

exports.default = _angular2.default.module('leptonApp.controllerDeviceEdit', [_angularjs2.default, _sa_config2.default, _controller_config2.default, _readonly_if2.default]).config(_controller_edit2.default).component('controllerDeviceEdit', {
  template: __webpack_require__(728),
  controller: ControllerConfigEditController
}).name;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.controller_device_edit', {
    url: 'controller_edit/:id',
    template: '<controller-device-edit></controller-device-edit>'
  });
};

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-wrench\"></i>&nbsp;&nbsp;設定変更</h2>\n  </div>\n</md-toolbar>\n<md-content style=\"padding: 20px 30px;\">\n  <form readonly-if=\"$root.is_viewer\" name=\"configForm\" novalidate>\n    <h4 class=\"input-group-title\">管理情報</h4>\n    <div layout-gt-sm=\"row\" style=\"width: 70%;\">\n      <md-input-container class=\"md-block input-container\" flex-gt-sm style=\"margin-right: 20px\">\n        <label>メモ</label>\n        <input name=\"memo\" ng-model=\"$ctrl.deviceConfig.memo\" md-maxlength=\"128\" maxlength=\"128\">\n        <div ng-messages=\"configForm.memo.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">128文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <h4 class=\"input-group-title\">連携先 検針用端末<span class=\"require-sign\"> ＊</span></h4>\n    <div>\n      <md-input-container style=\"max-width: 70%\">\n        <label>一覧から選択</label>\n        <md-select id=\"readingDeviceSelect\" class=\"ng-animate-disabled\" name=\"reading_device_id\" ng-model=\"$ctrl.deviceConfig.reading_device_id\" required>\n          <md-option class=\"ng-animate-disabled\" ng-repeat=\"readingDevice in $ctrl.readingDevices\" value=\"{{readingDevice.id}}\">\n            <div class=\"reading-device-info\">\n              <div class=\"reading-device-major-info\">\n                <span class=\"reading-device-code\">{{readingDevice.pms_service_code}}</span>  <span style=\"font-size: 15px;\">{{readingDevice.distribution_id}}</span>\n              </div>\n              <div class=\"reading-device-minor-info\">\n                {{readingDevice.location}}\n              </div>\n            </div>\n          </md-option>\n        </md-select>\n      </md-input-container>\n      <small class=\"change_flg\" ng-if=\"$ctrl.currentReadingId !== $ctrl.deviceConfig.reading_device_id\">\n        変更あり\n      </small>\n    </div>\n\n    <h4 class=\"input-group-title\">機器 ID</h4>\n    <span style=\"font-size: 12px; color: #78747A\">※機器IDは変更することができません</span>\n    <div style=\"margin: 11px 2px 20px; font-size: 19px;\">\n      {{ $ctrl.deviceConfig.distribution_id }}\n    </div>\n\n    <md-button ng-click=\"$ctrl.showConfirm($ctrl.deviceConfig, $event)\" \n      ng-disabled=\"configForm.$invalid\" \n      ng-if=\"$root.is_admin || $root.is_operator\"\n      class=\"md-primary md-raised\" style=\"margin: 16px 0; padding: 0 20px\">\n      変更する\n    </md-button>\n  </form>\n</md-content>\n"

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RetryController = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _retry = __webpack_require__(730);

var _retry2 = _interopRequireDefault(_retry);

var _missing_list = __webpack_require__(550);

var _missing_list2 = _interopRequireDefault(_missing_list);

var _retry3 = __webpack_require__(551);

var _retry4 = _interopRequireDefault(_retry3);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var RetryController = exports.RetryController = function () {
    /*@ngInject*/
    RetryController.$inject = ["$mdDialog", "$interval", "$filter", "MissingListService", "RetryService", "DateUtil"];
    function RetryController($mdDialog, $interval, $filter, MissingListService, RetryService, DateUtil) {
        _classCallCheck(this, RetryController);

        this.RetryService = RetryService;
        this.MissingListService = MissingListService;
        this.DateUtil = DateUtil;
        this.$interval = $interval;
        this.$filter = $filter;

        this.targetDate = this.DateUtil.beginningOfDay(new Date());
        this.minDate = this.DateUtil.leapDate(this.targetDate, -99);
        this.maxDate = this.targetDate;
        this.maxPolling = 18;

        this.$mdDialog = $mdDialog;
        this.error_dialog = $mdDialog.alert({
            clickOutSideToClose: true,
            title: 'エラーが発生しました',
            content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
            ok: 'OK'
        });
    }

    _createClass(RetryController, [{
        key: '$onInit',
        value: function $onInit() {
            this.updateMissingList();
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.stopTimer();
        }
    }, {
        key: 'updateMissingList',
        value: function updateMissingList() {
            var _this = this;

            this.MissingListService.index(this.DateUtil.getQueryParams(this.targetDate), function (response) {
                _this.missingList = _this.$filter("filter")(response, function (missingDevice) {
                    return !/^(tdc|dsc)[0-9]+/.test(missingDevice.pms_service_code);
                });
                _this.missingDevices = _this.countMissing(_this.missingList);
                _this.missingDeviceCount = Object.keys(_this.missingDevices).length;

                if (_this.missingDeviceCount === 0) {
                    _this.stopTimer();
                }
            });
        }

    }, {
        key: 'countMissing',
        value: function countMissing(missingList) {
            var deviceList = {};

            missingList.reduce(function (devices, currentMissingValue) {
                var service_code = currentMissingValue.pms_service_code;
                devices[service_code] = devices[service_code] ? devices[service_code] + 1 : 1;

                return devices;
            }, deviceList);

            return deviceList;
        }
    }, {
        key: 'changeDate',
        value: function changeDate(diff) {
            this.stopTimer();

            if (diff !== undefined) {
                this.targetDate = this.DateUtil.leapDate(this.targetDate, diff);
            }
            this.retried = false;
            this.retryFailed = false;

            this.updateMissingList();
        }
    }, {
        key: 'retry',
        value: function retry() {
            var _this2 = this;

            this.retried = true;
            this.retryFailed = false;
            this.RetryService.create({
                retry_list: this.missingList
            }, function (response) {
                _this2.timer = _this2.$interval(function (count) {
                    _this2.updateMissingList();
                    if (count >= _this2.maxPolling) {
                        _this2.retryFailed = true;
                    }
                }, 10000, _this2.maxPolling);
            }, function (error) {
                _this2.$mdDialog.show(_this2.error_dialog);
            });
        }
    }, {
        key: 'stopTimer',
        value: function stopTimer() {
            if (this.timer) {
                this.$interval.cancel(this.timer);
            }
        }
    }]);

    return RetryController;
}();

exports.default = _angular2.default.module('leptonApp.retry', [_angularjs2.default, _missing_list2.default, _retry4.default, _date_util2.default]).config(_retry2.default).component('retry', {
    template: __webpack_require__(731),
    controller: RetryController
}).name;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.retry', {
        url: 'retry',
        template: '<retry></retry>'
    });
}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports = "<md-content id=\"retry-content\" class=\"date-component retry-date-component\">\n    <div layout=\"row\" layout-align=\"start center\">\n        <md-button ng-disabled=\"$ctrl.targetDate.valueOf() === $ctrl.minDate.valueOf()\" ng-click=\"$ctrl.changeDate(-1)\" class=\"md-fab md-mini md-primary\">\n            <i class=\"fa fa-arrow-left\"></i>\n        </md-button>\n        <div datepicker class=\"date-picker\" ng-model=\"$ctrl.targetDate\" ng-change=\"$ctrl.changeDate()\" max-date=\"$ctrl.maxDate\">\n            {{$ctrl.targetDate | date: 'yyyy/MM/dd'}}<i class=\"fa fa-sort-down\" aria-hidden=\"true\"></i>\n        </div>\n        <md-button ng-disabled=\"$ctrl.targetDate.valueOf() === $ctrl.maxDate.valueOf()\" ng-click=\"$ctrl.changeDate(1)\" class=\"md-fab md-mini md-primary\">\n            <i class=\"fa fa-arrow-right\"></i>\n        </md-button>\n    </div>\n\n    <div id=\"missing-count\">\n        欠損のある機器: <span>{{$ctrl.missingDeviceCount}}</span> 台\n    </div>\n\n    <div class=\"retry-button\" ng-if=\"(!$ctrl.retried || $ctrl.missingDeviceCount === 0 || $ctrl.retryFailed) && ($root.is_admin || $root.is_operator)\" layout=\"row\" layout-align=\"start center\">\n        <md-button ng-click=\"$ctrl.retry()\" ng-disabled=\"$ctrl.missingDeviceCount === 0\" class=\"md-warn md-raised\">\n            <i class=\"fa fa-history\" aria-hidden=\"true\"></i>&nbsp;再検針を実施\n        </md-button>\n        <span id=\"retry-failed\" ng-if=\"$ctrl.missingDeviceCount > 0 && $ctrl.retryFailed\">再検針に失敗した可能性のある機器があります。<br/>異常が発生していないか確認してください。</span>\n    </div>\n\n    <div class=\"retry-button\" ng-if=\"$ctrl.retried && $ctrl.missingDeviceCount > 0 && !$ctrl.retryFailed\" layout=\"row\" layout-align=\"start center\">\n        <md-button ng-click=\"$ctrl.retry()\" ng-disabled=\"true\" class=\"md-warn md-raised\">\n            <i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i>&nbsp;再検針を実施中\n        </md-button>\n        <span>3分ほどかかる場合があります。</span>\n    </div>\n\n    <table id=\"missing-table\" ng-if=\"$ctrl.missingDeviceCount > 0\">\n        <tr>\n            <th>機器のサービスコード</th>\n            <th>定時データの欠損数</th>\n        </tr>\n        <tr ng-repeat=\"(service_code, count) in $ctrl.missingDevices\">\n            <td>{{ service_code }}</td>\n            <td>{{ count }}</td>\n        </tr>\n    </table>\n    <div id=\"no-missings\" ng-if=\"$ctrl.missingDeviceCount === 0\">\n        <i class=\"fa fa-check\"></i> 欠損はありません。\n    </div>\n</md-content>\n"

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DemandReportIndexController = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _demand_report_index = __webpack_require__(733);

var _demand_report_index2 = _interopRequireDefault(_demand_report_index);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _sa_group = __webpack_require__(201);

var _sa_group2 = _interopRequireDefault(_sa_group);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var DemandReportIndexController = exports.DemandReportIndexController = function () {
    /*@ngInject*/
    DemandReportIndexController.$inject = ["SaConfigService", "SaGroupService"];
    function DemandReportIndexController(SaConfigService, SaGroupService) {
        _classCallCheck(this, DemandReportIndexController);

        this.saList = [];
        this.SaConfigService = SaConfigService;
        this.SaGroupService = SaGroupService;
    }

    _createClass(DemandReportIndexController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.SaConfigService.api.index(function (response) {
                _this.saList = response;
            });

            this.SaGroupService.api.index(function (response) {
                _this.groupList = response;
            });
        }
    }]);

    return DemandReportIndexController;
}();

exports.default = _angular2.default.module('leptonApp.demandReportIndex', [_angularjs2.default, _sa_config2.default, _sa_group2.default]).config(_demand_report_index2.default).component('demandReportIndex', {
    template: __webpack_require__(734),
    controller: DemandReportIndexController
}).name;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.demand_report_index', {
        url: 'demand_report',
        template: '<demand_report_index></demand_report_index>'
    });
}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\" ng-if=\"$ctrl.groupList.length !== 0 && !$root.is_limited_viewer\">\n  <div class=\"md-toolbar-tools\">\n    <span><i class=\"fa fa-copy fa-fw\"></i>&nbsp;グループ</span>\n  </div>\n</md-toolbar>\n<md-content ng-if=\"$ctrl.groupList.length !== 0 && !$root.is_limited_viewer\">\n  <md-list-item class=\"md-3-line\" ng-repeat=\"group in $ctrl.groupList\">\n    <a ui-sref=\"main.group_report_show.detail({id:{{group.id}}})\" style=\"width: 100%; padding: 12px 0\">\n      <div class=\"md-list-item-text\" layout=\"column\">\n            <h3>{{group.name}}</h3>\n            <h4>{{group.memo}}</h4>\n        </div>\n    </a>\n    <md-divider></md-divider>\n  </md-list-item>\n</md-content>\n\n<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-tachometer-alt fa-fw\"></i>&nbsp;検針端末</h2>\n  </div>\n</md-toolbar>\n<div ng-if=\"$ctrl.saList.length === 0\" class=\"empty-notice\">設定済みの機器がありません。</div>\n<md-content>\n  <md-list-item class=\"md-3-line\" ng-repeat=\"sa in $ctrl.saList\">\n    <a ui-sref=\"main.demand_report_show.detail({id:{{sa.id}}})\" style=\"width: 100%; padding: 12px 0\">\n      <div class=\"md-list-item-text device-list-item\" layout=\"column\">\n        <h3>{{ sa.pms_service_code }} {{ sa.management_id }}</h3>\n        <h4>{{ sa.location }}</h4>\n        <p>{{ sa.memo }}</p>\n      </div>\n    </a>\n    <md-divider></md-divider>\n  </md-list-item>\n</md-content>\n"

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DemandReportShowController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularCookies = __webpack_require__(94);

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _demand_report_show = __webpack_require__(736);

var _demand_report_show2 = _interopRequireDefault(_demand_report_show);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _monthly_max_demand_power = __webpack_require__(218);

var _monthly_max_demand_power2 = _interopRequireDefault(_monthly_max_demand_power);

var _weather = __webpack_require__(130);

var _weather2 = _interopRequireDefault(_weather);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DemandReportShowController = exports.DemandReportShowController = function () {
  /*@ngInject*/
  DemandReportShowController.$inject = ["$state", "$stateParams", "$cookies", "SaConfigService", "MonthlyMaxDemandPowerService"];
  function DemandReportShowController($state, $stateParams, $cookies, SaConfigService, MonthlyMaxDemandPowerService) {
    _classCallCheck(this, DemandReportShowController);

    this.id = $stateParams.id;
    this.cookies = $cookies;
    this.state = $state;
    this.SaConfigService = SaConfigService;
    this.MonthlyMaxDemandPowerService = MonthlyMaxDemandPowerService;
    this.type = $stateParams.type || this.cookies.get('report_type') || 'demand';
    this.term = $stateParams.term || this.cookies.get('report_term') || 'daily';
    this.showSaInfo = false;
    this.sa = null;
  }

  _createClass(DemandReportShowController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.saConfigPromise = this.SaConfigService.api.show({ id: this.id }).$promise;
      this.saConfigPromise.then(function (response) {
        _this.location = response.location;
        _this.memo = response.memo;
        _this.targetPower = response.target_power;
        _this.limitPower = response.limit_power;
        _this.contractPower = response.contract_power;
        _this.billingDate = response.billing_date;
        _this.pms_service_code = response.pms_service_code;
        _this.distribution_id = response.distribution_id;
        _this.sa = response;
      });

      this.saConfigPromise.catch(function (err) {
        if (err.status === 404 || err.status === 403) {
          _this.state.go('main.home');
        }
      });

      this.MonthlyMaxDemandPowerService.show({ id: this.id }, function (response) {
        _this.monthlyMaxPower = response;
      }, function (error_response) {
        _this.monthlyMaxPower = null;
      });

      this.MonthlyMaxDemandPowerPromise = this.MonthlyMaxDemandPowerService.showYearly({ id: this.id }).$promise;
      this.MonthlyMaxDemandPowerPromise.then(function (response) {
        if (response.powers.length === 0) {
          _this.yearlyMaxPower = null;
          return;
        }

        var yearlyMaxPower = response.powers[0];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = response.powers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var power = _step.value;

            if (power.value > yearlyMaxPower.value) {
              yearlyMaxPower = power;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this.yearlyMaxPower = yearlyMaxPower;
      });
    }
  }, {
    key: 'changeType',
    value: function changeType(type) {
      this.cookies.put('report_type', type);
      this.type = type;

      if (type === 'price' && (this.term === 'weekly' || this.term === 'yearly')) {
        this.changeTerm('daily');
      }
    }
  }, {
    key: 'changeTerm',
    value: function changeTerm(term) {
      this.cookies.put('report_term', term);
      this.term = term;
    }
  }, {
    key: 'toggleSaInfo',
    value: function toggleSaInfo() {
      this.showSaInfo = !this.showSaInfo;
    }
  }]);

  return DemandReportShowController;
}();

exports.default = _angular2.default.module('leptonApp.demandReportShow', [_angularjs2.default, _angularCookies2.default, _sa_config2.default, _monthly_max_demand_power2.default]).config(_demand_report_show2.default).component('demandReportShow', {
  template: __webpack_require__(737),
  controller: DemandReportShowController
}).name;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.demand_report_show', {
    template: '<demand-report-show></demand-report-show>'
  }).state('main.demand_report_show.detail', {
    url: 'demand_report/:id',
    params: { type: null, term: null, target: null },
    views: {
      daily: {
        template: '<daily_demand_report></daily_demand_report>'
      },
      weekly: {
        template: '<weekly_demand_report></weekly_demand_report>'
      },
      monthly: {
        template: '<monthly_demand_report></monthly_demand_report>'
      },
      yearly: {
        template: '<yearly_demand_report></yearly_demand_report>'
      },
      daily_active: {
        template: '<daily-active-report></daily-active-report>'
      },
      weekly_active: {
        template: '<weekly-active-report></weekly-active-report>'
      },
      monthly_active: {
        template: '<monthly-active-report></monthly-active-report>'
      },
      yearly_active: {
        template: '<yearly-active-report></yearly-active-report>'
      },
      demand_histogram: {
        template: '<demand-histogram></demand-histogram>'
      },
      daily_price: {
        template: '<daily-price-report></daily-price-report>'
      },
      monthly_price: {
        template: '<monthly-price-report></monthly-price-report>'
      },
      event_report: {
        template: '<event-report></event-report>'
      }
    }
  });
}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports = "<div class=\"demand-report-summary-row\">\n  <table id=\"demandReportSummary\">\n    <tr style=\"background-color: #3f51b5; color: #FFF; padding: 0 5px\">\n      <th>検針日</th>\n      <th>契約電力</th>\n      <th>限界電力</th>\n      <th>目標電力</th>\n      <th>1年間の最大デマンド</th>\n      <th>当月の最大デマンド</th>\n    </tr>\n    <tr>\n      <td ng-if=\"$ctrl.billingDate !== 0\">毎月 <span class=\"value\">{{$ctrl.billingDate}}</span> 日</td>\n      <td ng-if=\"$ctrl.billingDate === 0\"><span class=\"empty-value\"> 未受信 </span></td>\n      <td><span class=\"value\">{{$ctrl.contractPower}}</span> kW</td>\n      <td><span class=\"value\">{{$ctrl.limitPower}}</span> kW</td>\n      <td><span class=\"value\">{{$ctrl.targetPower}}</span> kW</td>\n      <td ng-if=\"$ctrl.yearlyMaxPower !== null\"><span class=\"value\">{{$ctrl.yearlyMaxPower.value}}</span> kW (\n        {{$ctrl.yearlyMaxPower.measured_at | date: 'M月d日'}}({{$ctrl.yearlyMaxPower.measured_at | dayFilter}}) )\n      </td>\n      <td ng-if=\"$ctrl.yearlyMaxPower === null\"><span class=\"empty-value\"> 未受信 </span></td>\n      <td ng-if=\"$ctrl.monthlyMaxPower !== null\"><span class=\"value\">{{$ctrl.monthlyMaxPower.value}}</span> kW (\n        {{$ctrl.monthlyMaxPower.measured_at | date: 'M月d日'}}({{$ctrl.monthlyMaxPower.measured_at | dayFilter}}) )\n      </td>\n      <td ng-if=\"$ctrl.monthlyMaxPower === null\"><span class=\"empty-value\"> 未受信 </span></td>\n    </tr>\n  </table>\n  <div class=\"sa-info-link\">\n    <span class=\"span-link\" ng-click=\"$ctrl.toggleSaInfo()\">\n      <i class=\"fa fa-caret-right\" ng-if=\"!$ctrl.showSaInfo\"></i>\n      <i class=\"fa fa-caret-down\" ng-if=\"$ctrl.showSaInfo\"></i> 機器情報</span>\n  </div>\n</div>\n\n<sa-info-directive sa=\"$ctrl.sa\" show=\"$ctrl.showSaInfo\"></sa-info-directive>\n\n<div class='demand-report-tabs'>\n  <div class='demand-report-tab' ng-class=\"{'demand-report-tab-active': ($ctrl.type === 'demand')}\"\n       ng-click=\"$ctrl.changeType('demand')\">\n    デマンド実績\n  </div>\n  <div class='demand-report-tab' ng-class=\"{'demand-report-tab-active': ($ctrl.type === 'active')}\"\n       ng-click=\"$ctrl.changeType('active')\">\n    消費実績\n  </div>\n  <div class='demand-report-tab' ng-class=\"{'demand-report-tab-active': ($ctrl.type === 'hist')}\"\n       ng-click=\"$ctrl.changeType('hist')\">\n    デマンド値の分布\n  </div>\n  <div class='demand-report-tab' ng-class=\"{'demand-report-tab-active': ($ctrl.type === 'price')}\"\n       ng-click=\"$ctrl.changeType('price')\">\n    概算電気料金\n  </div>\n  <div class='demand-report-tab' ng-class=\"{'demand-report-tab-active': ($ctrl.type === 'event')}\"\n       ng-click=\"$ctrl.changeType('event')\">\n    イベント履歴\n  </div>\n</div>\n<md-divider></md-divider>\n<div class=\"align-right\" ng-if=\"!($ctrl.type === 'hist' || $ctrl.type === 'event')\">\n  <div></div>\n  <div class='demand-report-tabs2'>\n    <div class='demand-report-tab2' ng-class=\"{'demand-report-tab2-active': ($ctrl.term === 'daily')}\"\n         ng-click=\"$ctrl.changeTerm('daily')\">\n      日間\n    </div>\n    <div class='demand-report-tab2' ng-class=\"{'demand-report-tab2-active': ($ctrl.term === 'weekly')}\"\n         ng-click=\"$ctrl.changeTerm('weekly')\" ng-if=\"$ctrl.type !== 'price'\">\n      週間\n    </div>\n    <div class='demand-report-tab2' ng-class=\"{'demand-report-tab2-active': ($ctrl.term === 'monthly')}\"\n         ng-click=\"$ctrl.changeTerm('monthly')\">\n      月間\n    </div>\n    <div class='demand-report-tab2' ng-class=\"{'demand-report-tab2-active': ($ctrl.term === 'yearly')}\"\n         ng-click=\"$ctrl.changeTerm('yearly')\" ng-if=\"$ctrl.type !== 'price'\">\n      年間\n    </div>\n  </div>\n</div>\n\n<div ui-view=\"daily\" ng-if=\"$ctrl.type === 'demand' && $ctrl.term === 'daily'\"></div>\n<div ui-view=\"weekly\" ng-if=\"$ctrl.type === 'demand' && $ctrl.term === 'weekly'\"></div>\n<div ui-view=\"monthly\" ng-if=\"$ctrl.type === 'demand' && $ctrl.term === 'monthly'\"></div>\n<div ui-view=\"yearly\" ng-if=\"$ctrl.type === 'demand' && $ctrl.term === 'yearly'\"></div>\n<div ui-view=\"daily_active\" ng-if=\"$ctrl.type === 'active' && $ctrl.term === 'daily'\"></div>\n<div ui-view=\"weekly_active\" ng-if=\"$ctrl.type === 'active' && $ctrl.term === 'weekly'\"></div>\n<div ui-view=\"monthly_active\" ng-if=\"$ctrl.type === 'active' && $ctrl.term === 'monthly'\"></div>\n<div ui-view=\"yearly_active\" ng-if=\"$ctrl.type === 'active' && $ctrl.term === 'yearly'\"></div>\n<div ui-view=\"demand_histogram\" ng-if=\"$ctrl.type === 'hist'\"></div>\n<div ui-view=\"daily_price\" ng-if=\"$ctrl.type === 'price' && $ctrl.term === 'daily'\"></div>\n<div ui-view=\"monthly_price\" ng-if=\"$ctrl.type === 'price' && $ctrl.term === 'monthly'\"></div>\n<div ui-view=\"event_report\" ng-if=\"$ctrl.type === 'event'\"></div>\n"

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DailyDemandReportController = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _daily_demand_report = __webpack_require__(739);

var _daily_demand_report2 = _interopRequireDefault(_daily_demand_report);

var _demand_power = __webpack_require__(202);

var _demand_power2 = _interopRequireDefault(_demand_power);

var _weather = __webpack_require__(130);

var _weather2 = _interopRequireDefault(_weather);

var _chart = __webpack_require__(70);

var _chart2 = _interopRequireDefault(_chart);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

var _compare_weather = __webpack_require__(128);

var _compare_weather2 = _interopRequireDefault(_compare_weather);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

var _daily_demand_report3 = __webpack_require__(740);

var _daily_demand_report4 = _interopRequireDefault(_daily_demand_report3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DailyDemandReportController = exports.DailyDemandReportController = function () {
  /*@ngInject*/
  DailyDemandReportController.$inject = ["$stateParams", "$q", "$filter", "$interval", "moment", "DemandPowerService", "DateUtil", "CsvUtil", "WeatherService", "CompareWeatherLogic", "PowerFormatter"];
  function DailyDemandReportController($stateParams, $q, $filter, $interval, moment, DemandPowerService, DateUtil, CsvUtil, WeatherService, CompareWeatherLogic, PowerFormatter) {
    _classCallCheck(this, DailyDemandReportController);

    this.id = $stateParams.id;
    this.$q = $q;
    this.$filter = $filter;
    this.interval = $interval;
    this.DemandPowerService = DemandPowerService;
    this.WeatherService = WeatherService;
    this.PowerFormatter = PowerFormatter;
    this.DateUtil = DateUtil;
    this.moment = moment;
    this.CsvUtil = CsvUtil;
    this.CompareWeatherLogic = CompareWeatherLogic;

    this.categories = DateUtil.getXLabels;
    this.today = this.moment().startOf('day').toDate();
    this.targetDate = $stateParams.target || this.today;
    $stateParams.target = null;

    this.maxDate = this.today;
    this.missingTimes = [];

    this.downloadFileName = 'demand_power.csv';

    this.chartConfig = (0, _daily_demand_report4.default)(this);
  }

  _createClass(DailyDemandReportController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.parentComponent.saConfigPromise.then(function (config) {
        var contract_powers = [];
        var limit_powers = [];
        var target_powers = [];
        for (var i = 0; i < 48; i++) {
          contract_powers.push(config.contract_power);
          limit_powers.push(config.limit_power);
          target_powers.push(config.target_power);
        }

        _this.chart.series[1].setData(target_powers, false);
        _this.chart.series[2].setData(limit_powers, false);
        _this.chart.series[3].setData(contract_powers, false);
      });

      this.updateGraph(this.targetDate);

      this.timer = this.interval(function () {
        _this.updateGraph(_this.targetDate);
      }, 300000);
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(targetDate) {
      var _this2 = this;

      var dateQuery = this.DateUtil.getQueryParams(targetDate);

      this.$q.all([this.DemandPowerService.show(_angular2.default.extend({ id: this.id }, dateQuery)).$promise, this.WeatherService.api.index(_angular2.default.extend({ sa_config_id: this.id }, dateQuery)).$promise]).then(function (responses) {
        var _PowerFormatter$forma = _this2.PowerFormatter.formatDemandPowers(responses[0].powers, targetDate, _this2.categories);

        var _PowerFormatter$forma2 = _slicedToArray(_PowerFormatter$forma, 2);

        _this2.demandPowers = _PowerFormatter$forma2[0];
        _this2.missingTimes = _PowerFormatter$forma2[1];

        var weathers = _this2.setWeather(responses[1]);

        _this2.csvData = _this2.CsvUtil.processDemandPower(_this2.demandPowers, _this2.categories, _this2.targetDate, _this2.missingTimes, weathers);
        _this2.downloadFileName = _this2.moment(targetDate).format('[demand_power_]YYYY-MM-DD[.csv]');

        _this2.chart.series[0].setData(_this2.demandPowers);
        _this2.chart.reflow();
        _this2.maxPower = Math.max.apply(null, _this2.demandPowers);
      });
    }
  }, {
    key: 'isMissingTime',
    value: function isMissingTime(time) {
      return this.missingTimes.indexOf(time) !== -1;
    }
  }, {
    key: 'changeDate',
    value: function changeDate(diff) {
      if (diff !== undefined) {
        this.targetDate = this.DateUtil.leapDate(this.targetDate, diff);
      }

      this.updateGraph(this.targetDate);
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      if (this.timer) {
        this.interval.cancel(this.timer);
      }
    }
  }, {
    key: 'setWeather',
    value: function setWeather(weathers) {
      var weatherSamplingInterval = ['03:00', '09:00', '15:00', '21:00'];

      this.weathers = this.CompareWeatherLogic.compareHourly(weathers, weatherSamplingInterval);
      var y = this.weathers.length > 0 ? 46 : null;
      this.chart.xAxis[0].update({
        labels: { y: y }
      }, false);

      this.chart.redraw(false);

      return this.weathers;
    }
  }]);

  return DailyDemandReportController;
}();

exports.default = _angular2.default.module('leptonApp.dailyDemandReport', [_angularjs2.default, _demand_power2.default, _chart2.default, _date_util2.default, _csv2.default, _angularMoment2.default, _weather2.default, _compare_weather2.default, _powerFormatter2.default]).config(_daily_demand_report2.default).component('dailyDemandReport', {
  require: { parentComponent: '^demandReportShow' },
  template: __webpack_require__(741),
  controller: DailyDemandReportController
}).name;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.daily_demand_report', {
        template: '<daily-demand-report></daily-demand-report>'
    });
};

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  var chartConfig = {
    chart: {
      type: 'column',
      height: 300,

      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: { text: '1日のデマンド実績' },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      rotation: -45
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力値 [kW]'
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      reversed: true
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + this.x + "</tspan>";

        var point = this.points[0];
        tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
        if (scope.isMissingTime(point.x)) {
          tip_format += "データ無し";
        } else {
          tip_format += point.y + " kW";
        }
        tip_format += "</span>";

        return tip_format;
      }
    },
    series: [{
      name: '実績',
      color: '#1F85CF',
      marker: { symbol: 'circle' },
      lineWidth: 4
    }, {
      name: '目標電力',
      type: 'line',
      color: '#8bc34a',
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      tooltip: {
        followPointer: true,
        headerFormat: ''
      }
    }, {
      name: '限界電力',
      type: 'line',
      color: '#e67e22',
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      tooltip: {
        followPointer: true,
        headerFormat: ''
      }
    }, {
      name: '契約電力',
      type: 'line',
      color: '#D32F2F',
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      tooltip: {
        followPointer: true,
        headerFormat: ''
      }
    }]
  };

  return chartConfig;
};

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: -25px 0 5px 7px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <md-button ng-click=\"$ctrl.changeDate(-1)\" class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-left\"></i>\n    </md-button>\n    <div datepicker class=\"date-picker\" ng-model=\"$ctrl.targetDate\" ng-change=\"$ctrl.changeDate()\"\n         max-date=\"$ctrl.maxDate\">{{$ctrl.targetDate | date: 'yyyy/MM/dd'}}<i class=\"fa fa-sort-down\"\n                                                                              aria-hidden=\"true\"></i></div>\n    <md-button ng-disabled=\"$ctrl.targetDate.valueOf() === $ctrl.maxDate.valueOf()\" ng-click=\"$ctrl.changeDate(1)\"\n               class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-right\"></i>\n    </md-button>\n  </div>\n  <compare-modal ng-if=\"!$root.is_limited_viewer\"></compare-modal>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n  <div class=\"hourly-weather-content\" ng-if=\"$ctrl.weathers.length > 0\">\n    <div class=\"weather-item\" ng-repeat=\"weather in $ctrl.weathers track by $index\">\n      <weather-directive weather=\"weather\" icon-size=\"'middle'\" simple=\"true\"></weather-directive>\n    </div>\n  </div>\n</md-content>\n\n<div class='demand-report-table-content'>\n  <div>\n    <span class=\"report-table-unit\">(単位: kW)</span>\n    <a csv-downloader filename=\"$ctrl.downloadFileName\" csv-data=\"$ctrl.csvData\"\n       style=\"color: inherit;text-decoration: none;\">\n      <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\"></i> csvダウンロード\n      </md-button>\n    </a>\n  </div>\n  <table class='demand-report-table'>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 24\">\n        {{ time | date : 'HH:mm' }}\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.demandPowers | limitTo : 24 track by $index\"\n          ng-class=\"{'bold-td': (power === $ctrl.maxPower)}\">\n        <span ng-hide='power === 0'>{{ power }}</span>\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 24 : 24\">\n        {{ time | date : 'HH:mm' }}\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.demandPowers | limitTo : 24 : 24 track by $index\"\n          ng-class=\"{'bold-td': (power === $ctrl.maxPower)}\">\n        <span ng-hide='power === 0'>{{ power }}</span>\n      </td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WeeklyDemandReportController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _weekly_demand_report = __webpack_require__(743);

var _weekly_demand_report2 = _interopRequireDefault(_weekly_demand_report);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _daily_max_demand_power = __webpack_require__(220);

var _daily_max_demand_power2 = _interopRequireDefault(_daily_max_demand_power);

var _demand_power = __webpack_require__(202);

var _demand_power2 = _interopRequireDefault(_demand_power);

var _daily_weather = __webpack_require__(192);

var _daily_weather2 = _interopRequireDefault(_daily_weather);

var _weather = __webpack_require__(130);

var _weather2 = _interopRequireDefault(_weather);

var _compare_weather = __webpack_require__(128);

var _compare_weather2 = _interopRequireDefault(_compare_weather);

var _chart = __webpack_require__(70);

var _chart2 = _interopRequireDefault(_chart);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

var _weekly_demand_report3 = __webpack_require__(744);

var _weekly_demand_report4 = _interopRequireDefault(_weekly_demand_report3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var WeeklyDemandReportController = exports.WeeklyDemandReportController = function () {
  /*@ngInject*/
  WeeklyDemandReportController.$inject = ["$stateParams", "$filter", "$state", "$q", "moment", "PowerFormatter", "DailyMaxDemandPowerService", "DemandPowerService", "DateUtil", "CsvUtil", "DailyWeatherService", "WeatherService", "CompareWeatherLogic"];
  function WeeklyDemandReportController($stateParams, $filter, $state, $q, moment, PowerFormatter, DailyMaxDemandPowerService, DemandPowerService, DateUtil, CsvUtil, DailyWeatherService, WeatherService, CompareWeatherLogic) {
    var _this = this;

    _classCallCheck(this, WeeklyDemandReportController);

    this.id = $stateParams.id;
    this.$filter = $filter;
    this.$state = $state;
    this.$q = $q;
    this.moment = moment;
    this.DailyMaxDemandPowerService = DailyMaxDemandPowerService;
    this.DemandPowerService = DemandPowerService;
    this.DailyWeatherService = DailyWeatherService;
    this.WeatherService = WeatherService;
    this.CompareWeatherLogic = CompareWeatherLogic;
    this.PowerFormatter = PowerFormatter;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;

    this.startDate = this.DateUtil.beginningOfWeek(new Date());
    this.endDate = this.DateUtil.leapDate(this.startDate, 6);
    this.maxDate = this.startDate;

    this.categories = [];
    this.Week = ['日', '月', '火', '水', '木', '金', '土'];
    this.downloadFileName = 'demand_power_daily.csv';
    this.bulkDownloadFileName = 'demand_power_hourly.csv';
    this.bulkCsvGenerator = function () {
      return _this.createBulkCsv();
    };
    this.downloading = false;

    this.chartConfig = (0, _weekly_demand_report4.default)(this);
  }

  _createClass(WeeklyDemandReportController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.parentComponent.saConfigPromise.then(function (config) {
        var contract_powers = [];
        var limit_powers = [];
        var target_powers = [];
        for (var i = 0; i < 8; i++) {
          contract_powers.push(config.contract_power);
          limit_powers.push(config.limit_power);
          target_powers.push(config.target_power);
        }

        _this2.chart.series[1].setData(target_powers);
        _this2.chart.series[2].setData(limit_powers);
        _this2.chart.series[3].setData(contract_powers);

        _this2.updateGraph(_this2.startDate, _this2.endDate);
      });
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(startDate, endDate) {
      var _this3 = this;

      this.categories = [];
      for (var i = 0; i < 7; i++) {
        var utc = this.DateUtil.localToUTC(startDate);
        this.categories.push(this.DateUtil.leapDate(utc, i).valueOf());
      }
      var query = _angular2.default.extend({
        id: this.id,
        sa_config_id: this.id
      }, this.DateUtil.getDateRangeQueries(startDate, endDate));

      this.$q.all([this.DailyMaxDemandPowerService.show(query).$promise, this.DailyWeatherService.api.index(query).$promise]).then(function (responses) {
        var powers = responses[0];
        var weathers = responses[1];

        _this3.chart.xAxis[0].setCategories(_this3.categories);

        _this3.demandPowerObjects = _this3.PowerFormatter.formatDailyDemandPowers(powers.powers, _this3.categories);
        _this3.demandPowers = _this3.demandPowerObjects.map(function (power) {
          return power.y;
        });

        _this3.weathers = _this3.CompareWeatherLogic.compareDaily(weathers, _this3.categories);
        var y = _this3.weathers.length > 0 ? 50 : null;

        _this3.chart.xAxis[0].update({
          labels: { y: y }
        });

        _this3.itemWidth = 100 / 7;

        _this3.csvData = _this3.CsvUtil.processMaxDemandPower(_this3.demandPowers, _this3.categories, _this3.weathers);
        _this3.chart.series[0].setData(_this3.demandPowerObjects);
        _this3.chart.reflow();
        _this3.maxPower = Math.max.apply(null, _this3.demandPowers);

        var date = _this3.moment(startDate);
        _this3.downloadFileName = date.format('[demand_power_]YYYY-MM-DD[_week_daily.csv]');
        _this3.bulkDownloadFileName = date.format('[demand_power_]YYYY-MM-DD[_week_hourly.csv]');
      });
    }
  }, {
    key: 'createBulkCsv',
    value: function createBulkCsv() {
      var _this4 = this;

      this.downloading = true;
      var startDate = this.moment(this.startDate);
      var endDate = this.moment(this.endDate).add(1, 'day');
      var powerQuery = _angular2.default.extend({ id: this.id }, this.DateUtil.datetimeRangeQuery(startDate, endDate));
      var weatherQuery = _angular2.default.extend({ sa_config_id: this.id }, this.DateUtil.getDateRangeQueries(startDate, endDate.subtract(1, 'day')));

      return new Promise(function (resolve) {
        _this4.$q.all([_this4.DemandPowerService.show(powerQuery).$promise, _this4.WeatherService.api.index(weatherQuery).$promise]).then(function (responses) {
          resolve(_this4.CsvUtil.processBulkDemandPower(responses[0].powers, responses[1]));
          _this4.downloading = false;
        });
      });
    }
  }, {
    key: 'changeDate',
    value: function changeDate(diff) {
      this.startDate = this.DateUtil.leapDate(this.startDate, diff);
      this.endDate = this.DateUtil.leapDate(this.startDate, 6);

      this.updateGraph(this.startDate, this.endDate);
    }
  }, {
    key: 'getWeek',
    value: function getWeek(timeValue) {
      return this.Week[new Date(timeValue).getDay()];
    }
  }]);

  return WeeklyDemandReportController;
}();

exports.default = _angular2.default.module('leptonApp.weeklyDemandReport', [_angularjs2.default, _angularMoment2.default, _powerFormatter2.default, _daily_max_demand_power2.default, _demand_power2.default, _chart2.default, _date_util2.default, _csv2.default, _compare_weather2.default, _daily_weather2.default, _weather2.default]).config(_weekly_demand_report2.default).component('weeklyDemandReport', {
  require: { parentComponent: '^demandReportShow' },
  template: __webpack_require__(745),
  controller: WeeklyDemandReportController
}).name;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.weekly_demand_report', {
        template: '<weekly-demand-report></weekly-demand-report>'
    });
}

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  var chartConfig = {
    chart: {
      type: 'column',
      height: 300,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: { text: '1週間のデマンド実績' },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        formatter: function formatter() {
          var style = '';
          var day = scope.$filter('dayFilter')(this.value);

          if (day === '日') {
            style = 'color: #ff3131';
          } else if (day === '土') {
            style = 'color: #3737ff';
          }

          return '<span style="' + style + '">' + scope.$filter('date')(this.value, 'MM月dd日') + ' (' + day + ')</span>';
        },
        rotation: 0
      },
      max: 6
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力値 [kW]'
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      reversed: true
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + scope.$filter('date')(this.x, 'MM月dd日') + "</tspan>";

        var point = this.points[0];
        tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
        tip_format += point.y + " kW";
        tip_format += "</span>";

        return tip_format;
      }
    },
    plotOptions: { column: { grouping: false } },
    series: [{
      name: '実績',
      color: '#1F85CF',
      marker: { symbol: 'circle' },
      lineWidth: 4,
      events: {
        click: function click(event) {
          scope.$state.go('main.demand_report_show.detail', { id: scope.id, type: 'demand', term: 'daily', target: event.point.date }, { reload: true });
        }
      },
      cursor: 'pointer'
    }, {
      name: '目標電力',
      type: 'line',
      color: '#8bc34a',
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      tooltip: {
        followPointer: true,
        headerFormat: ''
      },
      pointPlacement: -0.5,
      enableMouseTracking: false
    }, {
      name: '限界電力',
      type: 'line',
      color: '#e67e22',
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      tooltip: {
        followPointer: true,
        headerFormat: ''
      },
      pointPlacement: -0.5,
      enableMouseTracking: false
    }, {
      name: '契約電力',
      type: 'line',
      color: '#D32F2F',
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      tooltip: {
        followPointer: true,
        headerFormat: ''
      },
      pointPlacement: -0.5,
      enableMouseTracking: false
    }]
  };

  return chartConfig;
}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: -25px 0 5px 7px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <md-button ng-click=\"$ctrl.changeDate(-7)\" class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-left\"></i>\n    </md-button>\n    <span>{{$ctrl.startDate | date : 'MM月dd日'}} ~ {{$ctrl.endDate | date : 'MM月dd日'}}</span>\n    <md-button ng-disabled=\"$ctrl.startDate.valueOf() === $ctrl.maxDate.valueOf()\" ng-click=\"$ctrl.changeDate(7)\"\n               class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-right\"></i>\n    </md-button>\n  </div>\n  <compare-modal ng-if=\"!$root.is_limited_viewer\"></compare-modal>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n  <div class=\"daily-weather-content weekly-weather-content\" ng-if=\"$ctrl.weathers.length > 0\">\n    <div class=\"daily-weather-item\" ng-style=\"{'width': $ctrl.itemWidth + '%'}\"\n         ng-repeat=\"weather in $ctrl.weathers track by $index\">\n      <weather-directive weather=\"weather\" icon-size=\"'middle'\" simple=\"true\"></weather-directive>\n    </div>\n  </div>\n</md-content>\n\n<div class='demand-report-table-content'>\n  <div>\n    <span class=\"report-table-unit\">(単位: kW)</span>\n    <a csv-downloader filename=\"$ctrl.downloadFileName\" csv-data=\"$ctrl.csvData\"\n       style=\"color: inherit;text-decoration: none;\">\n      <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\"></i> 日別csvダウンロード\n      </md-button>\n    </a>\n    <a bulk-downloader filename=\"$ctrl.bulkDownloadFileName\" csv-generator=\"$ctrl.bulkCsvGenerator\"\n       style=\"color: inherit;text-decoration: none;\">\n      <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\" ng-if=\"!$ctrl.downloading\"></i>\n        <i class=\"fa fa-spinner\" aria-hidden=\"true\" ng-if=\"$ctrl.downloading\"></i>\n        <span> 時間別csvダウンロード</span>\n      </md-button>\n    </a>\n  </div>\n  <table class='demand-report-table'>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 24\">\n        {{ time | date : 'MM月dd日' }} ({{ $ctrl.getWeek(time) }})\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.demandPowers | limitTo : 24 track by $index\"\n          ng-class=\"{'bold-td': (power === $ctrl.maxPower)}\">\n        <span ng-hide='power === 0'>{{ power }}</span>\n      </td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.monthlyDemandReportController = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _monthly_demand_report = __webpack_require__(747);

var _monthly_demand_report2 = _interopRequireDefault(_monthly_demand_report);

var _daily_max_demand_power = __webpack_require__(220);

var _daily_max_demand_power2 = _interopRequireDefault(_daily_max_demand_power);

var _demand_power = __webpack_require__(202);

var _demand_power2 = _interopRequireDefault(_demand_power);

var _daily_weather = __webpack_require__(192);

var _daily_weather2 = _interopRequireDefault(_daily_weather);

var _weather = __webpack_require__(130);

var _weather2 = _interopRequireDefault(_weather);

var _compare_weather = __webpack_require__(128);

var _compare_weather2 = _interopRequireDefault(_compare_weather);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

var _chart = __webpack_require__(70);

var _chart2 = _interopRequireDefault(_chart);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

var _monthly_demand_report3 = __webpack_require__(748);

var _monthly_demand_report4 = _interopRequireDefault(_monthly_demand_report3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var monthlyDemandReportController = exports.monthlyDemandReportController = function () {
  /*@ngInject*/
  monthlyDemandReportController.$inject = ["$stateParams", "$q", "$filter", "$state", "moment", "PowerFormatter", "DailyMaxDemandPowerService", "DemandPowerService", "DateUtil", "CsvUtil", "DailyWeatherService", "CompareWeatherLogic", "WeatherService"];
  function monthlyDemandReportController($stateParams, $q, $filter, $state, moment, PowerFormatter, DailyMaxDemandPowerService, DemandPowerService, DateUtil, CsvUtil, DailyWeatherService, CompareWeatherLogic, WeatherService) {
    var _this = this;

    _classCallCheck(this, monthlyDemandReportController);

    this.id = $stateParams.id;
    this.$q = $q;
    this.$filter = $filter;
    this.$state = $state;
    this.moment = moment;
    this.DailyMaxDemandPowerService = DailyMaxDemandPowerService;
    this.DemandPowerService = DemandPowerService;
    this.WeatherService = WeatherService;
    this.DailyWeatherService = DailyWeatherService;
    this.CompareWeatherLogic = CompareWeatherLogic;
    this.PowerFormatter = PowerFormatter;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;

    this.today = new Date();
    this.targetDate = $stateParams.target || this.today;
    $stateParams.target = null;

    this.maxDate = this.moment().startOf('day').toDate();

    this.categories = [];
    this.downloadFileName = 'demand_power.csv';
    this.bulkDownloadFileName = 'demand_power.csv';
    this.bulkCsvGenerator = function () {
      return _this.createBulkCsv();
    };
    this.downloading = false;

    this.chartConfig = (0, _monthly_demand_report4.default)(this);
  }

  _createClass(monthlyDemandReportController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.parentComponent.saConfigPromise.then(function (config) {
        _this2.contractPower = config.contract_power;
        _this2.limitPower = config.limit_power;
        _this2.targetPower = config.target_power;
        _this2.billingDay = config.billing_date;

        _this2.updateGraph(_this2.targetDate, _this2.billingDay);
      });
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(targetDate, billingDate) {
      var _this3 = this;

      var _DateUtil$getBillingD = this.DateUtil.getBillingDateDomain(targetDate, billingDate);

      var _DateUtil$getBillingD2 = _slicedToArray(_DateUtil$getBillingD, 2);

      this.startDate = _DateUtil$getBillingD2[0];
      this.endDate = _DateUtil$getBillingD2[1];

      this.billingDate = this.moment(this.endDate).add(1, 'days').toDate();

      var contractPowers = [];
      var limitPowers = [];
      var targetPowers = [];
      var numberOfDays = (this.endDate - this.startDate) / (24 * 60 * 60 * 1000);

      for (var i = 0; i <= numberOfDays + 1; i++) {
        contractPowers.push(this.contractPower);
        limitPowers.push(this.limitPower);
        targetPowers.push(this.targetPower);
      }

      this.categories = [];
      var startUtc = this.DateUtil.localToUTC(this.startDate);
      for (var _i = 0; _i <= numberOfDays; _i++) {
        this.categories.push(this.DateUtil.leapDate(startUtc, _i).valueOf());
      }

      var powerQuery = _angular2.default.extend({ id: this.id }, this.DateUtil.getDateRangeQueries(this.startDate, this.endDate));
      var weatherQuery = _angular2.default.extend({ sa_config_id: this.id }, this.DateUtil.getDateRangeQueries(this.startDate, this.endDate));
      this.$q.all([this.DailyMaxDemandPowerService.show(powerQuery).$promise, this.DailyWeatherService.api.index(weatherQuery).$promise]).then(function (responses) {
        var powers = responses[0];
        var weathers = responses[1];

        _this3.chart.series[1].setData(targetPowers, false);
        _this3.chart.series[2].setData(limitPowers, false);
        _this3.chart.series[3].setData(contractPowers, false);

        _this3.demandPowerObjects = _this3.PowerFormatter.formatDailyDemandPowers(powers.powers, _this3.categories);
        _this3.demandPowers = _this3.demandPowerObjects.map(function (power) {
          return power.y;
        });

        _this3.weathers = _this3.CompareWeatherLogic.compareDaily(weathers, _this3.categories);
        var y = _this3.weathers.length > 0 ? 36 : null;

        _this3.chart.xAxis[0].update({
          categories: _this3.categories,
          max: numberOfDays,
          labels: { y: y }
        });

        _this3.itemWidth = 100 / numberOfDays;

        _this3.csvData = _this3.CsvUtil.processMaxDemandPower(_this3.demandPowers, _this3.categories, _this3.weathers);
        _this3.chart.series[0].setData(_this3.demandPowerObjects);
        _this3.chart.reflow();
        _this3.maxPower = Math.max.apply(null, _this3.demandPowers);

        var date = _this3.moment(_this3.startDate);
        _this3.downloadFileName = date.format('[demand_power_]YYYY-MM[_daily.csv]');
        _this3.bulkDownloadFileName = date.format('[demand_power_]YYYY-MM[_hourly.csv]');
      });
    }
  }, {
    key: 'createBulkCsv',
    value: function createBulkCsv() {
      var _this4 = this;

      this.downloading = true;
      var startDate = this.moment(this.startDate);
      var endDate = this.moment(this.endDate).add(1, 'day');
      var powerQuery = _angular2.default.extend({ id: this.id }, this.DateUtil.datetimeRangeQuery(startDate, endDate));
      var weatherQuery = _angular2.default.extend({ sa_config_id: this.id }, this.DateUtil.getDateRangeQueries(startDate, endDate.subtract(1, 'day')));

      return new Promise(function (resolve) {
        _this4.$q.all([_this4.DemandPowerService.show(powerQuery).$promise, _this4.WeatherService.api.index(weatherQuery).$promise]).then(function (responses) {
          resolve(_this4.CsvUtil.processBulkDemandPower(responses[0].powers, responses[1]));
          _this4.downloading = false;
        });
      });
    }
  }, {
    key: 'changeMonth',
    value: function changeMonth(diff) {
      this.targetDate = this.DateUtil.leapMonth(this.targetDate, diff);

      this.updateGraph(this.targetDate, this.billingDay);
    }
  }]);

  return monthlyDemandReportController;
}();

exports.default = _angular2.default.module('leptonApp.monthlyDemandReport', [_angularjs2.default, _angularMoment2.default, _powerFormatter2.default, _daily_max_demand_power2.default, _demand_power2.default, _chart2.default, _date_util2.default, _csv2.default, _daily_weather2.default, _compare_weather2.default, _weather2.default]).config(_monthly_demand_report2.default).component('monthlyDemandReport', {
  require: { parentComponent: '^demandReportShow' },
  template: __webpack_require__(749),
  controller: monthlyDemandReportController
}).name;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.monthly_demand_report', {
        template: '<monthly-demand-report></monthly-demand-report>'
    });
}

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  var chartConfig = {
    chart: {
      type: 'column',
      height: 300,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: { text: '1ヶ月間のデマンド実績' },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        formatter: function formatter() {
          var style = '';
          var day = scope.$filter('dayFilter')(this.value);
          if (day === '日') {
            style = 'color: #ff3131';
          } else if (day === '土') {
            style = 'color: #3737ff';
          }

          return '<span style="' + style + '">' + scope.$filter('date')(this.value, 'M/d') + ' (' + day + ')</span>';
        }
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力値 [kW]'
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      borderWidth: 0,
      reversed: true
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function formatter() {
        var tip_format = '<tspan style=\'font-size: 12px\'>' + scope.$filter('date')(this.x, 'M/d') + ' (' + scope.$filter('dayFilter')(this.x) + ')</tspan>';

        var point = this.points[0];
        tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
        tip_format += point.y + " kW";
        tip_format += "</span>";

        return tip_format;
      }
    },
    plotOptions: { column: { grouping: false } },
    series: [{
      name: '実績',
      color: '#1F85CF',
      marker: { symbol: 'circle' },
      lineWidth: 4,
      events: {
        click: function click(event) {
          scope.$state.go('main.demand_report_show.detail', { id: scope.id, type: 'demand', term: 'daily', target: event.point.date }, { reload: true });
        }
      },
      cursor: 'pointer'
    }, {
      name: '目標電力',
      type: 'line',
      color: '#8bc34a',
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      tooltip: {
        followPointer: true,
        headerFormat: ''
      },
      pointPlacement: -0.5,
      enableMouseTracking: false
    }, {
      name: '限界電力',
      type: 'line',
      color: '#e67e22',
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      tooltip: {
        followPointer: true,
        headerFormat: ''
      },
      pointPlacement: -0.5,
      enableMouseTracking: false
    }, {
      name: '契約電力',
      type: 'line',
      color: '#D32F2F',
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      tooltip: {
        followPointer: true,
        headerFormat: ''
      },
      pointPlacement: -0.5,
      enableMouseTracking: false
    }]
  };

  return chartConfig;
}

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: 5px 0 5px 7px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <md-button ng-click=\"$ctrl.changeMonth(-1)\" class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-left\"></i>\n    </md-button>\n    <span>{{$ctrl.startDate | date : 'yyyy年MM月dd日'}} ~ {{$ctrl.endDate | date : 'yyyy年MM月dd日'}} <span\n            class=\"date-component-minor\">({{$ctrl.billingDate | date : 'yyyy年MM月'}} 請求分)</span></span>\n    <md-button ng-disabled=\"$ctrl.endDate.valueOf() >= $ctrl.maxDate.valueOf()\" ng-click=\"$ctrl.changeMonth(1)\"\n               class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-right\"></i>\n    </md-button>\n  </div>\n  <compare-modal ng-if=\"!$root.is_limited_viewer\"></compare-modal>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n  <div class=\"daily-weather-content\" ng-if=\"$ctrl.weathers.length > 0\">\n    <div class=\"daily-weather-item\" ng-style=\"{'width': $ctrl.itemWidth + '%'}\"\n         ng-repeat=\"weather in $ctrl.weathers track by $index\">\n      <weather-directive weather=\"weather\" icon-size=\"'small'\" simple=\"true\"></weather-directive>\n    </div>\n  </div>\n</md-content>\n<div class='demand-report-table-content'>\n  <div>\n    <span class=\"report-table-unit\">(単位: kW)</span>\n    <a csv-downloader filename=\"$ctrl.downloadFileName\" csv-data=\"$ctrl.csvData\"\n       style=\"color: inherit;text-decoration: none;\">\n      <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\"></i> 日別csvダウンロード\n      </md-button>\n    </a>\n    <a bulk-downloader filename=\"$ctrl.bulkDownloadFileName\" csv-generator=\"$ctrl.bulkCsvGenerator\"\n       style=\"color: inherit;text-decoration: none;\">\n      <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\" ng-if=\"!$ctrl.downloading\"></i>\n        <i class=\"fa fa-spinner\" aria-hidden=\"true\" ng-if=\"$ctrl.downloading\"></i>\n        <span> 時間別csvダウンロード</span>\n      </md-button>\n    </a>\n  </div>\n  <table class='demand-report-table monthly-demand-report'>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 16\">\n        {{ time | date : 'M/d' }} ({{ time | dayFilter }})\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.demandPowers | limitTo : 16 track by $index\"\n          ng-class=\"{'bold-td': (power === $ctrl.maxPower)}\">\n        <span ng-hide='power === 0'>{{ power }}</span>\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 16 : 16\">\n        {{ time | date : 'M/d' }} ({{ time | dayFilter }})\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.demandPowers | limitTo : 16 : 16 track by $index\"\n          ng-class=\"{'bold-td': (power === $ctrl.maxPower)}\">\n        <span ng-hide='power === 0'>{{ power }}</span>\n      </td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yearlyDemandReportController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _yearly_demand_report = __webpack_require__(751);

var _yearly_demand_report2 = _interopRequireDefault(_yearly_demand_report);

var _chart = __webpack_require__(70);

var _chart2 = _interopRequireDefault(_chart);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

var _yearly_demand_report3 = __webpack_require__(752);

var _yearly_demand_report4 = _interopRequireDefault(_yearly_demand_report3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var yearlyDemandReportController = exports.yearlyDemandReportController = function () {
  /*@ngInject*/
  yearlyDemandReportController.$inject = ["$stateParams", "$q", "$filter", "$state", "moment", "DateUtil", "CsvUtil", "PowerFormatter"];
  function yearlyDemandReportController($stateParams, $q, $filter, $state, moment, DateUtil, CsvUtil, PowerFormatter) {
    _classCallCheck(this, yearlyDemandReportController);

    this.id = $stateParams.id;
    this.$q = $q;
    this.$filter = $filter;
    this.$state = $state;
    this.DateUtil = DateUtil;
    this.moment = moment;
    this.CsvUtil = CsvUtil;
    this.PowerFormatter = PowerFormatter;

    this.downloadFileName = 'demand_power.csv';

    this.chartConfig = (0, _yearly_demand_report4.default)(this);
    this.billing_date = null;
  }

  _createClass(yearlyDemandReportController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.parentComponent.saConfigPromise.then(function (config) {
        _this.contractPower = config.contract_power;
        _this.limitPower = config.limit_power;
        _this.targetPower = config.target_power;
        _this.billing_date = config.billing_date;

        _this.createGraph();
      });
    }
  }, {
    key: 'createGraph',
    value: function createGraph() {
      var _this2 = this;

      var contractPowers = [];
      var limitPowers = [];
      var targetPowers = [];
      for (var i = 0; i < 14; i++) {
        contractPowers.push(this.contractPower);
        limitPowers.push(this.limitPower);
        targetPowers.push(this.targetPower);
      }

      this.parentComponent.MonthlyMaxDemandPowerPromise.then(function (response) {
        _this2.chart.series[1].setData(targetPowers, false);
        _this2.chart.series[2].setData(limitPowers, false);
        _this2.chart.series[3].setData(contractPowers, false);

        var powers = response.powers;
        var lastDate = powers.length > 0 ? _this2.moment(powers[powers.length - 1].billing_date).subtract(1, 'days') : _this2.moment();
        lastDate.startOf('month');

        _this2.startDate = _this2.createStart(_this2.billing_date);
        _this2.endDate = _this2.startDate.clone().add(12, 'months');
        _this2.categories = [];

        var start = _this2.createStart(_this2.billing_date);

        for (var _i = 0; _i < 13; _i++) {
          _this2.categories.push(start.valueOf());
          start.add(1, 'month');
        }

        _this2.chart.xAxis[0].update({
          categories: _this2.categories,
          max: 12
        });

        _this2.demandPowerObjects = _this2.PowerFormatter.formatMonthlyDemandPowers(powers, _this2.categories, _this2.billing_date);
        _this2.demandPowers = _this2.demandPowerObjects.map(function (power) {
          return power.y;
        });
        _this2.csvData = _this2.CsvUtil.processMonthlyMaxDemandPower(_this2.demandPowers, _this2.categories);
        _this2.chart.series[0].setData(_this2.demandPowerObjects);
        _this2.chart.reflow();
        _this2.maxPower = Math.max.apply(null, _this2.demandPowers);

        _this2.downloadFileName = 'demand_power_' + _this2.startDate.format('YYYY-MM') + '_' + _this2.endDate.format('YYYY-MM') + '.csv';
      });
    }
  }, {
    key: 'createStart',
    value: function createStart(configBillingDate) {
      var current = this.moment().startOf('month');
      if (configBillingDate === 1) {
        configBillingDate = 99;
      }

      if (this.moment().date() >= configBillingDate) {
        current.add(1, 'month');
      }

      return current.add(current.utcOffset(), 'minutes').utc().subtract(12, 'month');
    }
  }]);

  return yearlyDemandReportController;
}();

exports.default = _angular2.default.module('leptonApp.yearlyDemandReport', [_angularjs2.default, _chart2.default, _date_util2.default, _angularMoment2.default, _csv2.default, _powerFormatter2.default]).config(_yearly_demand_report2.default).component('yearlyDemandReport', {
  require: { parentComponent: '^demandReportShow' },
  template: __webpack_require__(753),
  controller: yearlyDemandReportController
}).name;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.yearly_demand_report', {
        template: '<yearly-demand-report></yearly-demand-report>'
    });
}

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  var chartConfig = {
    chart: {
      type: 'column',
      height: 300,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: { text: '1年間のデマンド実績' },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        format: '{value:%m月分}'
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力値 [kW]'
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      borderWidth: 0,
      reversed: true
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + scope.$filter('date')(this.x, 'MM月') + "</tspan>";

        var point = this.points[0];
        tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
        tip_format += point.y + " kW";
        tip_format += "</span>";

        return tip_format;
      }
    },
    plotOptions: { column: { grouping: false } },
    series: [{
      name: '実績',
      color: '#1F85CF',
      marker: { symbol: 'circle' },
      lineWidth: 4,
      events: {
        click: function click(event) {
          scope.$state.go('main.demand_report_show.detail', { id: scope.id, type: 'demand', term: 'monthly', target: event.point.date }, { reload: true });
        }
      },
      cursor: 'pointer'
    }, {
      name: '目標電力',
      type: 'line',
      color: '#8bc34a',
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      tooltip: {
        followPointer: true,
        headerFormat: ''
      },
      pointPlacement: -0.5,
      enableMouseTracking: false
    }, {
      name: '限界電力',
      type: 'line',
      color: '#e67e22',
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      tooltip: {
        followPointer: true,
        headerFormat: ''
      },
      pointPlacement: -0.5,
      enableMouseTracking: false
    }, {
      name: '契約電力',
      type: 'line',
      color: '#D32F2F',
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      tooltip: {
        followPointer: true,
        headerFormat: ''
      },
      pointPlacement: -0.5,
      enableMouseTracking: false
    }]
  };

  return chartConfig;
}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: -25px 0 5px 15px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <span>{{$ctrl.startDate | amDateFormat : 'YYYY年MM月'}} ~ {{$ctrl.endDate | amDateFormat : 'YYYY年MM月'}}</span>\n  </div>\n  <compare-modal ng-if=\"!$root.is_limited_viewer\"></compare-modal>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n</md-content>\n<div class='demand-report-table-content'>\n  <div>\n    <span class=\"report-table-unit\">(単位: kW)</span>\n    <a csv-downloader filename=\"$ctrl.downloadFileName\" csv-data=\"$ctrl.csvData\"\n       style=\"color: inherit;text-decoration: none;\">\n      <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\"></i> csvダウンロード\n      </md-button>\n    </a>\n  </div>\n  <table class='demand-report-table'>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories\">\n        {{ time | date : 'MM月分' }}\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.demandPowers track by $index\"\n          ng-class=\"{'bold-td': (power === $ctrl.maxPower)}\">\n        <span ng-hide='power === 0'>{{ power }}</span>\n      </td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EndUserIndexController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _end_user_index = __webpack_require__(755);

var _end_user_index2 = _interopRequireDefault(_end_user_index);

var _end_user = __webpack_require__(471);

var _end_user2 = _interopRequireDefault(_end_user);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var EndUserIndexController = exports.EndUserIndexController = function () {
  /*@ngInject*/
  EndUserIndexController.$inject = ["EndUserService", "$filter"];
  function EndUserIndexController(EndUserService, $filter) {
    var _this = this;

    _classCallCheck(this, EndUserIndexController);

    this.EndUserService = EndUserService;
    this.EndUserService.api.index(function (response) {
      var adminList = $filter("filter")(response, { role: 'admin' }, true);
      var operatorList = $filter("filter")(response, { role: 'operator' }, true);
      var viewerList = $filter("filter")(response, { role: 'viewer' }, true);
      var limitedViewerList = $filter("filter")(response, { role: 'limited_viewer' }, true);

      _this.userList = [adminList, operatorList, viewerList, limitedViewerList];
    });
  }

  _createClass(EndUserIndexController, [{
    key: '$onInit',
    value: function $onInit() {}
  }]);

  return EndUserIndexController;
}();

exports.default = _angular2.default.module('leptonApp.endUserIndex', [_angularjs2.default, _end_user2.default]).config(_end_user_index2.default).component('endUserIndex', {
  template: __webpack_require__(756),
  controller: EndUserIndexController
}).name;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.end_user_index', {
        url: 'user_index',
        template: '<end-user-index></end-user-index>'
    });
};

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports = "<div class=\"user-manage\"><i class=\"fa fa-users\"></i>&nbsp;アカウント管理</div>\n\n<md-content>\n  <md-button class=\"md-primary md-raised\" ng-show=\"$root.is_admin\" ui-sref=\"main.end_user_create\"\n             style=\"margin: 10px 25px 18px; padding: 3px 12px; font-size: 17px;\">アカウントを作成する\n  </md-button>\n</md-content>\n<md-toolbar class=\"md-hue-2\" style=\"min-height: 49px;\">\n  <div class=\"md-toolbar-tools user-list\">\n    <h2><i class=\"fa fa-list-ul\"></i>&nbsp;アカウント 一覧</h2>\n  </div>\n</md-toolbar>\n<md-list>\n  <div ng-repeat=\"role_users in $ctrl.userList\">\n    <md-item ng-repeat=\"user in role_users\">\n      <md-item-content style=\"padding: 0;\">\n        <div layout=\"row\" layout-align=\"center center\" class=\"md-tile-content error-content\"\n             style=\"padding: 0; color: #555; margin: 0px 18px;\">\n          <div class=\"user-role\" flex=\"15\">\n            <h4 ng-if=\"$first\">{{ user.role | roleToString}}</h4>\n          </div>\n          <div flex>\n            <md-button ui-sref=\"main.end_user_edit({id:{{user.id}}})\"\n                       style=\"text-transform: none; width: 100%; text-align: left; margin: 0 8px;\">\n              <div class=\"user-info-name\">{{ user.name }}</div>\n              <span class=\"user-info-email\">{{ user.email }}</span>\n            </md-button>\n            <md-divider ng-if=\"!$last\"></md-divider>\n          </div>\n        </div>\n      </md-item-content>\n    </md-item>\n    <md-divider ng-if=\"!$last\"></md-divider>\n  </div>\n</md-list>\n"

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EndUserCreateController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _lodash = __webpack_require__(498);

var _lodash2 = _interopRequireDefault(_lodash);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _end_user_create = __webpack_require__(758);

var _end_user_create2 = _interopRequireDefault(_end_user_create);

var _end_user = __webpack_require__(471);

var _end_user2 = _interopRequireDefault(_end_user);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _controller_config = __webpack_require__(91);

var _controller_config2 = _interopRequireDefault(_controller_config);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var EndUserCreateController = exports.EndUserCreateController = function () {
  /*@ngInject*/
  EndUserCreateController.$inject = ["EndUserService", "SaConfigService", "ControllerConfigService", "$state", "$mdDialog", "$templateCache", "$q"];
  function EndUserCreateController(EndUserService, SaConfigService, ControllerConfigService, $state, $mdDialog, $templateCache, $q) {
    _classCallCheck(this, EndUserCreateController);

    this.EndUserService = EndUserService;
    this.SaConfigService = SaConfigService;
    this.ControllerConfigService = ControllerConfigService;
    $templateCache.put('role_table.html', __webpack_require__(559));
    this.userData = {};
    this.userData.role = "viewer";
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.$q = $q;
    this.devices = [];
    this.selectedIds = [];
  }

  _createClass(EndUserCreateController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$q.all([this.SaConfigService.api.index().$promise, this.ControllerConfigService.api.index().$promise]).then(function (responses) {
        _this.devices = responses[0].concat(responses[1]);
      });
    }
  }, {
    key: 'showConfirm',
    value: function showConfirm(userData, ev, $mdDialog) {
      var _this2 = this;

      var dialog = {
        confirm: $mdDialog.confirm({
          clickOutsideToClose: true,
          title: '作成しますか？',
          ok: '作成する',
          cancel: '設定に戻る'
        }),
        error: $mdDialog.alert({
          clickOutsideToClose: true,
          title: 'アカウントの作成に失敗しました',
          content: '入力内容を確認してください',
          ok: 'OK'
        }),
        duplication_error: $mdDialog.alert({
          clickOutsideToClose: true,
          title: 'アカウントの作成に失敗しました',
          content: '入力されたメールアドレスは既に登録されています。',
          ok: 'OK'
        }),
        success: $mdDialog.alert({
          clickOutsideToClose: true,
          title: 'アカウントを作成しました',
          content: this.userData.email + " \u5B9B\u306B\u30D1\u30B9\u30EF\u30FC\u30C9\u8A2D\u5B9A\u7528\u306EURL\u304C\u901A\u77E5\u3055\u308C\u307E\u3059\u3002",
          ok: 'OK'
        })
      };

      if (userData.role === 'limited_viewer') {
        _lodash2.default.merge(userData, { config_ids: this.selectedIds });
      }

      this.$mdDialog.show(dialog.confirm.targetEvent(ev)).then(function () {
        _this2.EndUserService.api.create(userData, function (okResponse) {
          _this2.$mdDialog.show(dialog.success).finally(function () {
            _this2.$state.go('main.end_user_index');
          });
        }, function (errResponse) {
          if (errResponse.data.message.email && errResponse.data.message.email[0] === 'address is already in use') {
            _this2.$mdDialog.show(dialog.duplication_error);
          } else {
            _this2.$mdDialog.show(dialog.error);
          }
        });
      });
    }
  }]);

  return EndUserCreateController;
}();

exports.default = _angular2.default.module('leptonApp.endUserCreate', [_angularjs2.default, _end_user2.default, _sa_config2.default, _controller_config2.default]).config(_end_user_create2.default).component('endUserCreate', {
  template: __webpack_require__(759),
  controller: EndUserCreateController
}).name;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.end_user_create', {
        url: 'user_create',
        template: '<end-user-create></end-user-create>'
    });
};

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-user-plus\" style=\"padding-right: 10px;\"></i>新規にアカウントを作成</h2>\n  </div>\n</md-toolbar>\n<p style=\"padding: 0 20px;\">\n  アカウントを作成すると、指定したメールアドレスにパスワード設定のURLが通知されます。<br>\n  パスワードの設定をもってアカウント追加が完了します。\n</p>\n<md-content style=\"padding: 5px 30px;\">\n  <form name=\"createForm\" novalidate>\n    <h4 style=\"margin-bottom: 0; font-size: 18px;\">アカウント情報</h4>\n    <div layout-gt-sm=\"row\" flex=\"40\" offset=\"40\" class=\"account-info-name\">\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px\">\n        <label>名前</label>\n        <input name=\"name\" ng-model=\"$ctrl.userData.name\" md-maxlength=\"255\" required>\n        <div ng-messages=\"createForm.name.$error\" ng-if=\"createForm.name.$dirty\" role=\"alert\" multiple>\n          <div ng-message=\"required\">入力してください</div>\n          <div ng-message=\"md-maxlength\">255文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n    </div>\n    <div layout-gt-sm=\"row\" flex=\"40\" offset=\"40\" class=\"account-info\">\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px\">\n        <label>メールアドレス</label>\n        <input name=\"email\" type=\"email\" ng-model=\"$ctrl.userData.email\" md-maxlength=\"254\" required>\n        <div ng-messages=\"createForm.email.$error\" ng-if=\"createForm.email.$dirty\" role=\"alert\" multiple>\n          <div ng-message=\"required\">入力してください</div>\n          <div ng-message=\"md-maxlength\">254文字以下で記載してください</div>\n          <div ng-message=\"email\">メールアドレスのフォーマットで入力してください</div>\n        </div>\n      </md-input-container>\n    </div>\n    <div layout-gt-sm=\"row\" flex=\"40\" offset=\"40\" class=\"account-info\">\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px\">\n        <label>確認のためメールアドレスをもう一度入力してください</label>\n        <input name=\"email_match\" type=\"text\" ng-model=\"email_match\" md-maxlength=\"254\" match=\"$ctrl.userData.email\"\n               required>\n        <div class=\"invalid\" type=\"text\" ng-messages=\"createForm.email_match.$error\"\n             ng-if=\"createForm.email_match.$dirty\">\n          <div ng-message=\"required\">入力してください</div>\n          <div ng-message=\"md-maxlength\">254文字以内で入力してください</div>\n          <div ng-show=\"createForm.email_match.$error.match\">メールアドレスが一致しません</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <h4 style=\"margin-bottom: 0; font-size: 18px;\">権限を選択</h4>\n    <div class=\"account-info\">\n      <md-input-container style=\"padding-bottom: 0\">\n        <md-radio-group ng-model=\"$ctrl.userData.role\" layout=\"row\" layout-align=\"start center\" required>\n          <md-radio-button class=\"md-primary\" value=\"admin\">アカウント管理者</md-radio-button>\n          <md-radio-button class=\"md-primary\" value=\"operator\">オペレータ</md-radio-button>\n          <md-radio-button class=\"md-primary\" value=\"viewer\">閲覧者</md-radio-button>\n          <md-radio-button class=\"md-primary\" value=\"limited_viewer\">制限付き閲覧者</md-radio-button>\n        </md-radio-group>\n      </md-input-container>\n      <div class=\"invalid\" ng-messages=\"createForm.role.$error\" ng-if=\"createForm.role.$dirty\">\n        <div ng-message=\"required\">入力してください</div>\n      </div>\n    </div>\n\n    <div ng-include=\"'role_table.html'\"></div>\n    <div ng-if=\"$ctrl.userData.role === 'limited_viewer'\" class=\"user-config-check-list\">\n      <h4 style=\"font-size: 18px; margin: 40px 0 10px;\">データ閲覧を許可する機器を選択</h4>\n      <device-check-list device-list=\"$ctrl.devices\" selected-list=\"$ctrl.selectedIds\"></device-check-list>\n    </div>\n    <md-button class=\"md-raised md-primary\" ng-disabled=\"createForm.$invalid\"\n               ng-click=\"$ctrl.showConfirm($ctrl.userData, $event, $ctrl.$mdDialog)\"\n               style=\"margin: 30px 0 25px; padding: 2px 16px;\">アカウントを作成する\n    </md-button>\n  </form>\n</md-content>\n"

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EndUserEditController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _lodash = __webpack_require__(498);

var _lodash2 = _interopRequireDefault(_lodash);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _end_user_edit = __webpack_require__(761);

var _end_user_edit2 = _interopRequireDefault(_end_user_edit);

var _end_user = __webpack_require__(471);

var _end_user2 = _interopRequireDefault(_end_user);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _controller_config = __webpack_require__(91);

var _controller_config2 = _interopRequireDefault(_controller_config);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var EndUserEditController = exports.EndUserEditController = function () {
  /*@ngInject*/
  EndUserEditController.$inject = ["$stateParams", "EndUserService", "$q", "$state", "$mdDialog", "$templateCache", "$auth", "SaConfigService", "ControllerConfigService"];
  function EndUserEditController($stateParams, EndUserService, $q, $state, $mdDialog, $templateCache, $auth, SaConfigService, ControllerConfigService) {
    _classCallCheck(this, EndUserEditController);

    this.userData = {};
    this.userData.id = $stateParams.id;
    this.currentUserEmail = $auth.user.email;
    this.EndUserService = EndUserService;
    this.SaConfigService = SaConfigService;
    this.ControllerConfigService = ControllerConfigService;
    $templateCache.put('role_table.html', __webpack_require__(559));
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.$q = $q;
    this.selectedIds = [];
    this.editDialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '変更しますか？',
        ok: '変更する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '変更しました',
        ok: 'OK'
      })
    };
    this.deleteDialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '削除してよろしいですか？',
        ok: '削除する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '削除しました',
        ok: 'OK'
      })
    };
    this.errorAlert = $mdDialog.alert().title('エラーが発生しました').content('時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。').ok('OK');
  }

  _createClass(EndUserEditController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.EndUserService.api.show({ id: this.userData.id }, function (response) {
        _this.userData = response;
        _this.isSelf = response.email === _this.currentUserEmail;
        if (_this.userData.role === 'limited_viewer') {
          _this.selectedIds = _this.userData.config_ids;
        }
      }, function (err) {
        if (err.status === 404 || err.status === 403) {
          _this.$state.go('main.home');
        }
      });

      this.$q.all([this.SaConfigService.api.index().$promise, this.ControllerConfigService.api.index().$promise]).then(function (responses) {
        _this.devices = responses[0].concat(responses[1]);
      });
    }
  }, {
    key: 'updateUser',
    value: function updateUser(ev) {
      var _this2 = this;

      if (this.userData.role === 'limited_viewer') {
        _lodash2.default.merge(this.userData, { config_ids: this.selectedIds });
      }
      this.$mdDialog.show(this.editDialog.confirm.targetEvent(ev)).then(function () {
        _this2.EndUserService.api.update(_this2.userData, function (okResponse) {
          _this2.$mdDialog.show(_this2.editDialog.success).finally(function () {
            _this2.$state.go('main.end_user_index');
          });
        }, function (errResponse) {
          _this2.$mdDialog.show(_this2.errorAlert);
        });
      });
    }
  }, {
    key: 'deleteUser',
    value: function deleteUser(ev) {
      var _this3 = this;

      this.$mdDialog.show(this.deleteDialog.confirm.targetEvent(ev)).then(function () {
        _this3.EndUserService.api.delete({ id: _this3.userData.id }, function (okResponse) {
          _this3.$mdDialog.show(_this3.deleteDialog.success).finally(function () {
            _this3.$state.go('main.end_user_index');
          });
        }, function (errResponse) {
          _this3.$mdDialog.show(_this3.errorAlert);
        });
      });
    }
  }]);

  return EndUserEditController;
}();

exports.default = _angular2.default.module('leptonApp.endUserEdit', [_angularjs2.default, _end_user2.default, _sa_config2.default, _controller_config2.default]).config(_end_user_edit2.default).component('endUserEdit', {
  template: __webpack_require__(762),
  controller: EndUserEditController
}).name;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.end_user_edit', {
        url: 'user_edit/:id',
        template: '<end-user-edit></end-user-edit>'
    });
};

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-edit\" style=\"padding-right: 10px;\"></i>アカウント情報を編集 : {{ $ctrl.userData.email }}</h2>\n  </div>\n</md-toolbar>\n<md-content class=\"md-padding\" layout=\"row\" layout-align=\"space-between\" style=\"padding-bottom:0;\">\n  <h4 class=\"edit-title\">アカウント情報と権限</h4>\n  <md-button class=\"md-raised md-warn\" ng-click=\"$ctrl.deleteUser($event)\" style=\"margin: 15px 0 0; padding: 3px 20px;\"\n             ng-if=\"!$ctrl.isSelf\">このアカウントを削除する\n  </md-button>\n</md-content>\n<md-content style=\"padding: 5px 30px;\">\n  <form name=\"editForm\" novalidate>\n    <div layout-gt-sm=\"row\" flex=\"40\" offset=\"40\" class=\"account-info-name\">\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px\">\n        <label>名前</label>\n        <input name=\"name\" ng-model=\"$ctrl.userData.name\" md-maxlength=\"255\" required>\n        <div ng-messages=\"editForm.name.$error\" ng-if=\"editForm.name.$dirty\" role=\"alert\" multiple>\n          <div ng-message=\"required\">入力してください</div>\n          <div ng-message=\"md-maxlength\">255文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <div ng-if=\"$ctrl.isSelf\" class=\"role-message\">※自分の権限は変更できません</div>\n    <div ng-if=\"!$ctrl.isSelf\">\n      <div class=\"account-info\">\n        <md-input-container style=\"padding-bottom: 5px\">\n          <md-radio-group ng-model=\"$ctrl.userData.role\" layout=\"row\" layout-align=\"start center\" required>\n            <md-radio-button class=\"md-primary\" value=\"admin\">アカウント管理者</md-radio-button>\n            <md-radio-button class=\"md-primary\" value=\"operator\">オペレータ</md-radio-button>\n            <md-radio-button class=\"md-primary\" value=\"viewer\">閲覧者</md-radio-button>\n            <md-radio-button class=\"md-primary\" value=\"limited_viewer\">制限付き閲覧者</md-radio-button>\n          </md-radio-group>\n        </md-input-container>\n        <div class=\"invalid\" ng-messages=\"editForm.role.$error\" ng-if=\"editForm.role.$dirty\">\n          <div ng-message=\"required\">入力してください</div>\n        </div>\n      </div>\n      <div ng-include=\"'role_table.html'\"></div>\n    </div>\n    <div ng-if=\"$ctrl.userData.role === 'limited_viewer'\" class=\"user-config-check-list\">\n      <h4 style=\"font-size: 18px; margin: 40px 0 10px;\">データ閲覧を許可する機器を選択</h4>\n      <device-check-list device-list=\"$ctrl.devices\" selected-list=\"$ctrl.selectedIds\"></device-check-list>\n    </div>\n    <md-button class=\"md-raised md-primary\" ng-disabled=\"editForm.$invalid\" ng-click=\"$ctrl.updateUser($event)\"\n               style=\"margin: 50px 0 25px; padding: 2px 16px;\">更新する\n    </md-button>\n  </form>\n</md-content>\n"

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EndUserConfirmController = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _end_user_confirm = __webpack_require__(764);

var _end_user_confirm2 = _interopRequireDefault(_end_user_confirm);

var _end_user_confirm3 = __webpack_require__(765);

var _end_user_confirm4 = _interopRequireDefault(_end_user_confirm3);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var EndUserConfirmController = exports.EndUserConfirmController = function () {
    /*@ngInject*/
    EndUserConfirmController.$inject = ["EndUserConfirmService", "$state", "$mdDialog", "$stateParams"];
    function EndUserConfirmController(EndUserConfirmService, $state, $mdDialog, $stateParams) {
        _classCallCheck(this, EndUserConfirmController);

        this.EndUserConfirmService = EndUserConfirmService;
        this.query = {};
        this.query.token = $stateParams.token;
        this.$state = $state;
        this.$mdDialog = $mdDialog;
        this.dialog = {
            error: $mdDialog.alert({
                disableParentScroll: false,
                title: 'パスワードの設定に失敗しました',
                content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
                ok: 'OK'
            }),
            success: $mdDialog.alert({
                disableParentScroll: false,
                title: 'パスワードの設定が完了しました',
                content: 'ログインページに移動します',
                ok: 'OK'
            })
        };
    }

    _createClass(EndUserConfirmController, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'submitConfirm',
        value: function submitConfirm() {
            var _this = this;

            this.EndUserConfirmService.api.update(this.query, function (okResponse) {
                _this.$mdDialog.show(_this.dialog.success).finally(function () {
                    return _this.$state.go('login');
                });
            }, function (errResponse) {
                if (errResponse.data.message === 'wrong token') {
                    _this.dialog.error.content('パスワード設定用URLが無効です');
                }
                _this.$mdDialog.show(_this.dialog.error);
            });
        }
    }]);

    return EndUserConfirmController;
}();

exports.default = _angular2.default.module('leptonApp.endUserConfirm', [_angularjs2.default, _end_user_confirm4.default]).config(_end_user_confirm2.default).component('endUserConfirm', {
    template: __webpack_require__(766),
    controller: EndUserConfirmController
}).name;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('end_user_confirm', {
        url: '/user_confirm/:token',
        template: '<end-user-confirm></end-user-confirm>'
    });
};

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var EndUserConfirmService = function EndUserConfirmService($resource) {
    'ngInject';

    _classCallCheck(this, EndUserConfirmService);

    this.api = $resource('/auth_api/end_user_confirm/:token', { token: '@token' }, {
        update: { method: 'PUT', isArray: false }
    });
};
EndUserConfirmService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.EndUserConfirmService', ['ngResource']).service('EndUserConfirmService', ['$resource', EndUserConfirmService]).name;

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = "<div id=\"header\">\n    <md-button id=\"logo\" ui-sref=\"main.home\">\n    <span class=\"fa-stack\" style=\"font-size: 13px\">\n      <i class=\"fa fa-cloud fa-stack-2x\" style=\"color: #1e88e5\"></i>\n      <i class=\"fa fa-plug fa-stack-1x\" style=\"color: #fffde7\"></i>\n    </span>&nbsp; Bルートデマンド監視サービス\n    </md-button>\n</div>\n<div class=\"md-toolbar-tools confirm_title\">\n    <h2><i class=\"fa fa-lock\"></i> パスワード設定</h2>\n</div>\n<md-content class=\"user-confirm\">\n    <div>\n        <h4 class=\"explanation\">ログイン用のパスワードを設定してください</h4>\n        <div>\n            <form name=\"confirmForm\">\n                <div layout-gt-sm=\"row\" flex=\"40\" offset=\"40\" class=\"password\">\n                    <md-input-container class=\"md-block\" flex-gt-sm style=\"margin:0;\">\n                        <label>パスワード</label>\n                        <input name=\"password\" type=\"password\" ng-model=\"$ctrl.query.password\" required ng-minlength=\"8\" md-maxlength=\"128\" ng-pattern=\"/^[\\w!#$%&@()*+.,/:;<=>?^~]*$/\">\n                        <div class=\"invalid\" ng-messages=\"confirmForm.password.$error\" ng-if=\"confirmForm.password.$dirty\">\n                            <div ng-message=\"required\">入力が必要です</div>\n                            <div ng-message=\"minlength\">8文字以上で記載してください</div>\n                            <div ng-message=\"md-maxlength\">128文字以内で記載してください</div>\n                            <div ng-message=\"pattern\">数字、アルファベット、_!#$%&@()*+.,/:;<=>?^~ のみを入力してください</div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div layout-gt-sm=\"row\" flex=\"40\" offset=\"40\" class=\"password\">\n                    <md-input-container class=\"md-block\" flex-gt-sm style=\"margin:10px 0;\">\n                        <label>パスワード再入力</label>\n                        <input name=\"password_confirmation\" type=\"password\" ng-model=\"$ctrl.query.password_confirmation\" required match=\"$ctrl.query.password\" md-maxlength=\"128\">\n                        <div class=\"invalid\" ng-messages=\"confirmForm.password_confirmation.$error\" ng-if=\"confirmForm.password_confirmation.$dirty\">\n                            <div ng-message=\"required\">入力が必要です</div>\n                            <div ng-show=\"confirmForm.password_confirmation.$error.match\">パスワードが一致しません</div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <md-button style=\"margin: 22px 38px 42px;\" class=\"md-primary md-raised\" ng-click=\"$ctrl.submitConfirm()\" ng-disabled=\"confirmForm.$invalid\">パスワードを設定する</md-button>\n            </form>\n        </div>\n    </div>\n</md-content>\n<md-divider></md-divider>\n<div id=\"footer\">\n    <div><a target=\"_blank\" href=\"http://www.iij.ad.jp/securitypolicy/\">情報セキュリティ基本方針</a></div>\n    <div><a target=\"_blank\" href=\"http://www.iij.ad.jp/privacy/\">個人情報保護ポリシー</a></div>\n    <div>&copy; 2016 Internet Initiative Japan Inc.</div>\n</div>\n"

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotifyListIndexController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _notify_list_index = __webpack_require__(768);

var _notify_list_index2 = _interopRequireDefault(_notify_list_index);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _controller_config = __webpack_require__(91);

var _controller_config2 = _interopRequireDefault(_controller_config);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var NotifyListIndexController = exports.NotifyListIndexController = function () {
  /*@ngInject*/
  NotifyListIndexController.$inject = ["SaConfigService", "ControllerConfigService"];
  function NotifyListIndexController(SaConfigService, ControllerConfigService) {
    _classCallCheck(this, NotifyListIndexController);

    this.saList = [];
    this.SaConfigService = SaConfigService;
    this.ControllerConfigService = ControllerConfigService;
  }

  _createClass(NotifyListIndexController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.SaConfigService.api.index().$promise.then(function (response) {
        _this.saList = response;

        return _this.ControllerConfigService.api.index().$promise;
      }).then(function (response) {
        var controllerDeviceList = response;

        _this.saList.forEach(function (device) {
          var controlTargets = controllerDeviceList.filter(function (controllerDevice) {
            return controllerDevice.reading_device_id === device.id;
          });
          device.controlTargets = controlTargets;
        });
      });
    }
  }]);

  return NotifyListIndexController;
}();

exports.default = _angular2.default.module('leptonApp.notifyListIndex', [_angularjs2.default, _sa_config2.default, _controller_config2.default]).config(_notify_list_index2.default).component('notifyListIndex', {
  template: __webpack_require__(769),
  controller: NotifyListIndexController
}).name;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.notify_list_index', {
        url: 'notify_list',
        template: '<notify-list-index></notify-list-index>'
    });
};

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-envelope fa-fw\"></i>&nbsp;メール通知先を設定する機器を選択</h2>\n  </div>\n</md-toolbar>\n<div ng-if=\"$ctrl.saList.length === 0\" class=\"empty-notice\">設定済みの機器がありません。</div>\n<md-content>\n  <md-list-item class=\"md-3-line\" ng-repeat=\"sa in $ctrl.saList\" style=\"flex-direction: column; padding-right: 0;\">\n    <div class=\"device-list-item-row\">\n      <config-index-item device=\"sa\" link-state=\"'main.notify_list_show'\"></config-index-item>\n      <md-divider></md-divider>\n    </div>\n    <md-divider></md-divider>\n    <md-list-item style=\"padding: 0;\" class=\"md-3-line control-device-list\" ng-repeat=\"controlDevice in sa.controlTargets\">\n      <div class=\"device-list-item-row\">\n        <md-divider></md-divider>\n        <config-index-item device=\"controlDevice\" link-state=\"'main.notify_list_show'\" second-indent=\"true\"></config-index-item>\n      </div>\n    </md-list-item>\n  </md-list-item>\n</md-content>\n"

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NotifyListShowController = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _notify_list_show = __webpack_require__(771);

var _notify_list_show2 = _interopRequireDefault(_notify_list_show);

var _sa_config_notify_list = __webpack_require__(552);

var _sa_config_notify_list2 = _interopRequireDefault(_sa_config_notify_list);

var _mail_test = __webpack_require__(490);

var _mail_test2 = _interopRequireDefault(_mail_test);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _unique_validator = __webpack_require__(488);

var _unique_validator2 = _interopRequireDefault(_unique_validator);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var NotifyListShowController = exports.NotifyListShowController = function () {
    /*@ngInject*/
    NotifyListShowController.$inject = ["$state", "$scope", "$stateParams", "$mdDialog", "SaConfigNotifyListService", "MailTestService", "SaConfigService"];
    function NotifyListShowController($state, $scope, $stateParams, $mdDialog, SaConfigNotifyListService, MailTestService, SaConfigService) {
        _classCallCheck(this, NotifyListShowController);

        this.id = $stateParams.id;
        this.state = $state;
        this.emails = [];
        this.newMail = '';
        this.testMailSending = false;
        this.mailTestSuccessed = false;

        this.NotifyListService = SaConfigNotifyListService;
        this.MailTestService = MailTestService;
        this.SaConfigService = SaConfigService;
        this.$mdDialog = $mdDialog;

        $scope.$watch('$ctrl.newMail', this.resetStatus());
    }

    _createClass(NotifyListShowController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.SaConfigService.api.show({ id: this.id }, function (response) {
                _this.location = response.location;
                _this.memo = response.memo;

                _this.NotifyListService.api.show({ id: _this.id }, function (response) {
                    _this.emails = response.emails;
                });
            }, function (err) {
                if (err.status === 404 || err.status === 403) {
                    _this.state.go('main.home');
                }
            });
        }
    }, {
        key: 'deleteMail',
        value: function deleteMail(email) {
            var targetIndex = this.emails.indexOf(email);
            this.emails.splice(targetIndex, 1);
            this.NotifyListService.api.update({ id: this.id, emails: this.emails });
        }
    }, {
        key: 'addMail',
        value: function addMail(email) {
            this.emails.push(email);
            this.newMail = '';

            this.NotifyListService.api.update({ id: this.id, emails: this.emails });
        }
    }, {
        key: 'sendTestMail',
        value: function sendTestMail(email) {
            var _this2 = this;

            var dialog = {
                confirm: this.$mdDialog.confirm({
                    clickOutsideToClose: true,
                    title: email + "\u5B9B\u306B\u30C6\u30B9\u30C8\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3057\u307E\u3059",
                    ok: '送信する',
                    cancel: '戻る'
                }),
                error: this.$mdDialog.alert({
                    clickOutsideToClose: true,
                    title: 'エラーが発生しました',
                    content: 'メールアドレスを確認してください',
                    ok: 'OK'
                })
            };

            this.$mdDialog.show(dialog.confirm).then(function () {
                _this2.testMailSending = true;
                _this2.MailTestService.api.create({ test_mail: email }, function (okResponse) {
                    _this2.mailTestSuccessed = true;
                }, function (ngResponse) {
                    _this2.resetStatus();
                    _this2.$mdDialog.show(dialog.error);
                });
            });
        }
    }, {
        key: 'resetStatus',
        value: function resetStatus() {
            var _this3 = this;

            return function () {
                if (_this3.testMailSending || _this3.mailTestSuccessed) {
                    _this3.testMailSending = false;
                    _this3.mailTestSuccessed = false;
                }
            };
        }
    }]);

    return NotifyListShowController;
}();

exports.default = _angular2.default.module('leptonApp.notifyListShow', [_angularjs2.default, _sa_config_notify_list2.default, _mail_test2.default, _sa_config2.default, _unique_validator2.default]).config(_notify_list_show2.default).component('notifyListShow', {
    template: __webpack_require__(772),
    controller: NotifyListShowController
}).name;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.notify_list_show', {
        url: 'notify_list/:id',
        template: '<notify-list-show></notify-list-show>'
    });
};

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n    <div class=\"md-toolbar-tools\">\n        <h2><i class=\"fa fa-envelope fa-fw\"></i>&nbsp;メール通知先設定</h2>\n    </div>\n</md-toolbar>\n<div class=\"notify-list\">\n    <div id=\"notify-list-sa-info\">\n        <h3>{{ $ctrl.location }}</h3>\n        <h3>{{ $ctrl.memo }}</h3>\n    </div>\n    <md-toolbar class=\"md-hue-2\" style=\"background-color: #50D4E3;\">\n        通知メール送信先\n    </md-toolbar>\n    <md-list>\n        <md-divider></md-divider>\n        <md-list-item class=\"md-2-line\" ng-class=\"{ 'view-only': $root.is_viewer }\" ng-repeat=\"email in $ctrl.emails\" style=\"padding: 0;\">\n            <div layout=\"row\" layout-align=\"start center\">\n                <div class=\"notify-list-email\" flex=\"auto\">{{email}}</div>\n                <div flex=\"none\">\n                    <md-button class=\"md-raised\" ng-if=\"$root.is_admin || $root.is_operator\"\n                    ng-click=\"$ctrl.deleteMail(email)\"> 送信先から削除 </md-button>\n                </div>\n            </div>\n            <md-divider></md-divider>\n        </md-list-item>\n        <div class='notify-list-notice' ng-if=\"($ctrl.emails.length > 0) && ($root.is_admin || $root.is_operator)\">\n            ※メールアドレスは20件まで登録できます。\n        </div>\n    </md-list>\n    <div ng-if=\"$ctrl.emails.length === 0\">\n        通知先メールが登録されていません\n    </div>\n\n    <form name=\"$ctrl.addEmailForm\" class=\"notify-list-form\" ng-if=\"$root.is_admin || $root.is_operator\" novalidate autocomplete=\"off\">\n        <div layout=\"row\" layout-align=\"start center\">\n            <md-input-container class=\"md-block\" flex-gt-sm>\n                <label>送信先に追加するメールアドレス</label>\n                <input name=\"email\" type=\"email\" ng-model=\"$ctrl.newMail\"\n                    ng-disabled=\"$ctrl.emails.length >= 20\" md-maxlength=\"254\" unique=\"$ctrl.emails\">\n                <div ng-messages=\"$ctrl.addEmailForm.email.$error\" ng-if=\"$ctrl.addEmailForm.email.$dirty\" role=\"alert\" multiple>\n                    <div ng-message=\"required\">入力してください</div>\n                    <div ng-message=\"md-maxlength\">254文字以下で記載してください</div>\n                    <div ng-message=\"email\">メールアドレスのフォーマットで入力してください</div>\n                    <div ng-message=\"unique\">既に登録されているメールアドレスです</div>\n                </div>\n            </md-input-container>\n            <md-button class=\"md-raised\" ng-if=\"!$ctrl.testMailSending\" ng-disabled=\"$ctrl.addEmailForm.$invalid || $ctrl.newMail === ''\" ng-click=\"$ctrl.sendTestMail($ctrl.newMail)\">\n                テストメールを送信\n            </md-button>\n            <div ng-if=\"$ctrl.testMailSending && !$ctrl.mailTestSuccessed\">\n                <i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i>&nbsp;テストメールを送信中\n            </div>\n            <div ng-if=\"$ctrl.testMailSending && $ctrl.mailTestSuccessed\" style=\"color: green;\">\n                <i class=\"fa fa-check\"></i>&nbsp;テストメールを送信しました\n            </div>\n        </div>\n        <md-button class=\"md-raised md-primary\" ng-disabled=\"$ctrl.addEmailForm.$invalid || $ctrl.newMail === ''\" ng-click=\"$ctrl.addMail($ctrl.newMail)\">\n            送信先に追加\n        </md-button>\n    </form>\n</div>\n"

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DemandControlIndexController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _demand_control_index = __webpack_require__(774);

var _demand_control_index2 = _interopRequireDefault(_demand_control_index);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _controller_config = __webpack_require__(91);

var _controller_config2 = _interopRequireDefault(_controller_config);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DemandControlIndexController = exports.DemandControlIndexController = function () {
  /*@ngInject*/
  DemandControlIndexController.$inject = ["SaConfigService", "ControllerConfigService"];
  function DemandControlIndexController(SaConfigService, ControllerConfigService) {
    _classCallCheck(this, DemandControlIndexController);

    this.saList = [];
    this.SaConfigService = SaConfigService;
    this.ControllerConfigService = ControllerConfigService;
  }

  _createClass(DemandControlIndexController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.SaConfigService.api.index().$promise.then(function (response) {
        _this.saList = response;

        return _this.ControllerConfigService.api.index().$promise;
      }).then(function (response) {
        var controllerDeviceList = response;

        _this.saList.forEach(function (device) {
          var controlTargets = controllerDeviceList.filter(function (controllerDevice) {
            return controllerDevice.reading_device_id === device.id;
          });
          device.controlTargets = controlTargets;
        });
      });
    }
  }]);

  return DemandControlIndexController;
}();

exports.default = _angular2.default.module('leptonApp.demandControlIndex', [_angularjs2.default, _sa_config2.default, _controller_config2.default]).config(_demand_control_index2.default).component('demandControlIndex', {
  template: __webpack_require__(775),
  controller: DemandControlIndexController
}).name;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.demand_control_index', {
    url: 'demand_control_index',
    template: '<demand-control-index></demand-control-index>'
  });
};

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-hand-pointer\"></i>&nbsp;デマンド制御を行う機器を選択</h2>\n  </div>\n</md-toolbar>\n<div ng-if=\"$ctrl.saList.length === 0\" class=\"empty-notice\">設定済みの機器がありません。</div>\n<md-content>\n  <md-list-item class=\"md-3-line\" ng-repeat=\"sa in $ctrl.saList\" style=\"flex-direction: column; padding-right: 0;\">\n    <div class=\"device-list-item-row\">\n      <config-index-item device=\"sa\" link-state=\"'main.demand_control_edit'\"></config-index-item>\n      <md-divider></md-divider>\n    </div>\n    <md-list-item style=\"padding: 0;\" class=\"md-3-line control-device-list\" ng-repeat=\"controlDevice in sa.controlTargets\">\n      <div class=\"device-list-item-row\">\n        <md-divider></md-divider>\n        <config-index-item device=\"controlDevice\" link-state=\"'main.demand_control_edit'\" second-indent=\"true\"></config-index-item>\n      </div>\n    </md-list-item>\n  </md-list-item>\n</md-content>\n"

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DemandControlEditController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _demand_control_edit = __webpack_require__(777);

var _demand_control_edit2 = _interopRequireDefault(_demand_control_edit);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _demand_level = __webpack_require__(560);

var _demand_level2 = _interopRequireDefault(_demand_level);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DemandControlEditController = exports.DemandControlEditController = function () {
  /*@ngInject*/
  DemandControlEditController.$inject = ["$state", "$stateParams", "$mdDialog", "SaConfigService", "DemandLevelService"];
  function DemandControlEditController($state, $stateParams, $mdDialog, SaConfigService, DemandLevelService) {
    _classCallCheck(this, DemandControlEditController);

    this.id = $stateParams.id;
    this.$mdDialog = $mdDialog;
    this.$state = $state;
    this.SaConfigService = SaConfigService;
    this.DemandLevelService = DemandLevelService;

    this.dialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '制御レベルを変更しますか？',
        ok: '変更する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '制御レベルを変更しました',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };
  }

  _createClass(DemandControlEditController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.SaConfigService.api.show({ id: this.id }, function (response) {
        _this.device = response;
      }, function (err) {
        if (err.status === 404 || err.status === 403) {
          _this.$state.go('main.home');
        }
      });

      this.DemandLevelService.api.show({ id: this.id }, function (response) {
        _this.demandLevel = _this.currentLevel = response.level + '';
      });
    }
  }, {
    key: 'setLevel',
    value: function setLevel(ev) {
      var _this2 = this;

      this.$mdDialog.show(this.dialog.confirm.targetEvent(ev)).then(function () {
        _this2.DemandLevelService.api.update({ id: _this2.id, level: _this2.demandLevel }, function (response) {
          _this2.currentLevel = _this2.demandLevel;
          _this2.$mdDialog.show(_this2.dialog.success);
        }, function (error) {
          _this2.$mdDialog.show(_this2.dialog.error);
        });
      });
    }
  }]);

  return DemandControlEditController;
}();

exports.default = _angular2.default.module('leptonApp.demandControlEdit', [_angularjs2.default, _sa_config2.default, _demand_level2.default]).config(_demand_control_edit2.default).component('demandControlEdit', {
  template: __webpack_require__(778),
  controller: DemandControlEditController
}).name;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.demand_control_edit', {
    url: 'demand_control_edit/:id',
    template: '<demand-control-edit></demand-control-edit>'
  });
};

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-hand-pointer\"></i>&nbsp;&nbsp;手動デマンド制御</h2>\n  </div>\n</md-toolbar>\n\n<md-content style=\"padding: 5px 30px;\">\n  <div id=\"demand-report-sa-info\" style=\"margin: 20px 0;\">\n    <h3>{{$ctrl.device.location}}</h3>\n    <h3>{{$ctrl.device.memo}}</h3>\n  </div>\n\n  <h4 style=\"margin-bottom: 5px; margin-top: 40px;\">デマンド警報レベルを変更</h4>\n  <div style=\"margin-bottom: 24px;\">\n    <md-input-container style=\"width: 400px;\">\n      <label>一覧から選択</label>\n      <md-select id=\"demandLevelSelect\" name=\"demand_level\" ng-model=\"$ctrl.demandLevel\" required>\n        <md-option value=\"0\">通常状態</md-option>\n        <md-option value=\"1\">目標電力超過</md-option>\n        <md-option value=\"2\">限界電力超過</md-option>\n        <md-option value=\"3\">契約電力超過</md-option>\n      </md-select>\n    </md-input-container>\n    <small class=\"change_flg\" ng-if=\"$ctrl.currentLevel !== $ctrl.demandLevel\">\n      変更済み\n    </small>\n  </div>\n\n  <md-button ng-click=\"$ctrl.setLevel($event)\" ng-disabled=\"$ctrl.currentLevel === $ctrl.demandLevel\" class=\"md-primary md-raised\" style=\"margin: 16px 0; padding: 0 20px\">\n    変更を適用\n  </md-button>\n</md-content>\n"

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DailyActiveReportController = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _daily_active_report = __webpack_require__(780);

var _daily_active_report2 = _interopRequireDefault(_daily_active_report);

var _active_power = __webpack_require__(144);

var _active_power2 = _interopRequireDefault(_active_power);

var _weather = __webpack_require__(130);

var _weather2 = _interopRequireDefault(_weather);

var _compare_weather = __webpack_require__(128);

var _compare_weather2 = _interopRequireDefault(_compare_weather);

var _chart = __webpack_require__(70);

var _chart2 = _interopRequireDefault(_chart);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _math_util = __webpack_require__(88);

var _math_util2 = _interopRequireDefault(_math_util);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

var _daily_active_report3 = __webpack_require__(781);

var _daily_active_report4 = _interopRequireDefault(_daily_active_report3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DailyActiveReportController = exports.DailyActiveReportController = function () {
  /*@ngInject*/
  DailyActiveReportController.$inject = ["$stateParams", "moment", "$interval", "$q", "PowerFormatter", "ActivePowerService", "DateUtil", "MathUtil", "CsvUtil", "WeatherService", "CompareWeatherLogic"];
  function DailyActiveReportController($stateParams, moment, $interval, $q, PowerFormatter, ActivePowerService, DateUtil, MathUtil, CsvUtil, WeatherService, CompareWeatherLogic) {
    _classCallCheck(this, DailyActiveReportController);

    this.ActivePowerService = ActivePowerService;
    this.WeatherService = WeatherService;
    this.CompareWeatherLogic = CompareWeatherLogic;
    this.PowerFormatter = PowerFormatter;
    this.DateUtil = DateUtil;
    this.MathUtil = MathUtil;
    this.CsvUtil = CsvUtil;
    this.interval = $interval;
    var self = this;
    this.moment = moment;
    this.$q = $q;

    this.categories = DateUtil.getXLabels;
    this.id = $stateParams.id;
    this.today = new Date();
    this.targetDate = $stateParams.target || this.today;
    $stateParams.target = null;

    this.maxDate = this.today;
    this.missingTimes = [];
    this.noCalculateTimes = [];

    this.downloadFileName = 'active_power.csv';

    this.chartConfig = (0, _daily_active_report4.default)(this);
  }

  _createClass(DailyActiveReportController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.updateGraph(this.targetDate);

      this.timer = this.interval(function () {
        _this.updateGraph(_this.targetDate);
      }, 300000);
    }
  }, {
    key: 'changeDate',
    value: function changeDate(diff) {
      if (diff !== undefined) {
        this.targetDate = this.DateUtil.leapDate(this.targetDate, diff);
      }

      this.updateGraph(this.targetDate);
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(targetDate) {
      var _this2 = this;

      var powerQuery = _angular2.default.extend({ id: this.id }, this.DateUtil.getActivePowerQueries(targetDate));
      var weatherQuery = _angular2.default.extend({ sa_config_id: this.id }, this.DateUtil.getQueryParams(targetDate));

      var dataPromise = this.$q.all([this.ActivePowerService.show(powerQuery).$promise, this.WeatherService.api.index(weatherQuery).$promise]);
      var upperLimitPromise = dataPromise.then(function (responses) {
        var maxValue = Math.max.apply(Math, responses[0].powers.map(function (power) {
          return power.value;
        }));
        return _this2.ActivePowerService.upper_limit({ id: _this2.id, ref_value: maxValue }).$promise;
      });

      this.$q.all([dataPromise, upperLimitPromise]).then(function (responses) {
        var upperLimit = responses[1].upper_limit;
        var powerData = responses[0][0];
        var weatherData = responses[0][1];

        var _PowerFormatter$forma = _this2.PowerFormatter.formatActivePowers(powerData.powers, _this2.categories, _this2.targetDate, upperLimit);

        var _PowerFormatter$forma2 = _slicedToArray(_PowerFormatter$forma, 3);

        _this2.activePowers = _PowerFormatter$forma2[0];
        _this2.missingTimes = _PowerFormatter$forma2[1];
        _this2.noCalculateTimes = _PowerFormatter$forma2[2];

        var weathers = [];
        if (_this2.chart) {
          weathers = _this2.setWeather(weatherData);
          _this2.series.setData(_this2.activePowers);
        }

        _this2.csvData = _this2.CsvUtil.processActivePower(_this2.activePowers, _this2.categories, targetDate, _this2.missingTimes, _this2.noCalculateTimes, weathers);
        _this2.downloadFileName = _this2.moment(_this2.targetDate).format('[active_power_]YYYY-MM-DD[.csv]');
      });
    }
  }, {
    key: 'isMissingTime',
    value: function isMissingTime(time) {
      return this.missingTimes.indexOf(time) !== -1;
    }
  }, {
    key: 'isNoCalculateTime',
    value: function isNoCalculateTime(time) {
      return this.noCalculateTimes.indexOf(time) !== -1;
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      if (this.timer) {
        this.interval.cancel(this.timer);
      }
    }
  }, {
    key: 'setWeather',
    value: function setWeather(weathers) {
      var weatherSamplingInterval = ['03:00', '09:00', '15:00', '21:00'];

      this.weathers = this.CompareWeatherLogic.compareHourly(weathers, weatherSamplingInterval);
      var y = this.weathers.length > 0 ? 46 : null;

      this.chart.xAxis[0].update({
        labels: { y: y }
      }, false);

      this.chart.reflow();

      return this.weathers;
    }
  }]);

  return DailyActiveReportController;
}();

exports.default = _angular2.default.module('leptonApp.dailyActiveReport', [_angularjs2.default, _angularMoment2.default, _powerFormatter2.default, _math_util2.default, _date_util2.default, _active_power2.default, _csv2.default, _weather2.default, _compare_weather2.default]).config(_daily_active_report2.default).component('dailyActiveReport', {
  require: { parentComponent: '^demandReportShow' },
  template: __webpack_require__(782),
  controller: DailyActiveReportController
}).name;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.daily_active_report', {
        template: '<daily-active-report></daily-active-report>'
    });
};

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  var chartConfig = {
    chart: {
      type: 'column',
      height: 300,
      events: {
        load: function load() {
          scope.series = this.series[0];
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: { text: '1日の電力消費実績' },
    legend: { enabled: false },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      max: scope.categories.length - 1
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力量 [kWh]'
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + this.x + "</tspan>";

        angular.forEach(this.points, function (point, i) {
          tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
          if (scope.isMissingTime(point.x)) {
            tip_format += "データ無し";
          } else if (scope.isNoCalculateTime(point.x)) {
            tip_format += "差分計算不可";
          } else {
            tip_format += point.y + " kWh";
          }
          tip_format += "</span>";
        });

        return tip_format;
      }
    },
    series: [{
      name: '定時有効電力'
    }],
    plotOptions: { column: { grouping: false } }
  };
  return chartConfig;
}

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: -25px 0 5px 7px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <md-button ng-click=\"$ctrl.changeDate(-1)\" class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-left\"></i>\n    </md-button>\n    <div datepicker class=\"date-picker\" ng-model=\"$ctrl.targetDate\" ng-change=\"$ctrl.changeDate()\"\n         max-date=\"$ctrl.maxDate\">{{$ctrl.targetDate | date: 'yyyy/MM/dd'}}<i class=\"fa fa-sort-down\"\n                                                                              aria-hidden=\"true\"></i></div>\n    <md-button ng-disabled=\"$ctrl.targetDate.valueOf() === $ctrl.maxDate.valueOf()\" ng-click=\"$ctrl.changeDate(1)\"\n               class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-right\"></i>\n    </md-button>\n  </div>\n  <compare-modal ng-if=\"!$root.is_limited_viewer\"></compare-modal>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n  <div class=\"hourly-weather-content active-weather-content\" ng-if=\"$ctrl.weathers.length > 0\">\n    <div class=\"weather-item\" ng-repeat=\"weather in $ctrl.weathers track by $index\">\n      <weather-directive weather=\"weather\" icon-size=\"'middle'\" simple=\"true\"></weather-directive>\n    </div>\n  </div>\n</md-content>\n\n<div class='demand-report-table-content'>\n  <div>\n    <span class=\"report-table-unit\">(単位: kWh)</span>\n    <a csv-downloader filename=\"$ctrl.downloadFileName\" csv-data=\"$ctrl.csvData\"\n       style=\"color: inherit;text-decoration: none;\">\n      <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\"></i> csvダウンロード\n      </md-button>\n    </a>\n  </div>\n  <table class='demand-report-table active-report-table'>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 24\">\n        {{ time | date : 'HH:mm' }}\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.activePowers | limitTo : 24 track by $index\">\n        <span ng-hide='power === 0'>{{ power }}</span>\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 24 : 24\">\n        {{ time | date : 'HH:mm' }}\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.activePowers | limitTo : 24 : 24 track by $index\">\n        <span ng-hide='power === 0'>{{ power }}</span>\n      </td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WeeklyActiveReportController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _weekly_active_report = __webpack_require__(784);

var _weekly_active_report2 = _interopRequireDefault(_weekly_active_report);

var _daily_active_power = __webpack_require__(191);

var _daily_active_power2 = _interopRequireDefault(_daily_active_power);

var _active_power = __webpack_require__(144);

var _active_power2 = _interopRequireDefault(_active_power);

var _weather = __webpack_require__(130);

var _weather2 = _interopRequireDefault(_weather);

var _daily_weather = __webpack_require__(192);

var _daily_weather2 = _interopRequireDefault(_daily_weather);

var _compare_weather = __webpack_require__(128);

var _compare_weather2 = _interopRequireDefault(_compare_weather);

var _chart = __webpack_require__(70);

var _chart2 = _interopRequireDefault(_chart);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

var _weekly_active_report3 = __webpack_require__(785);

var _weekly_active_report4 = _interopRequireDefault(_weekly_active_report3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var WeeklyActiveReportController = exports.WeeklyActiveReportController = function () {
  /*@ngInject*/
  WeeklyActiveReportController.$inject = ["$stateParams", "$filter", "$state", "$q", "moment", "PowerFormatter", "DateUtil", "DailyActivePowerService", "ActivePowerService", "CsvUtil", "CompareWeatherLogic", "WeatherService", "DailyWeatherService"];
  function WeeklyActiveReportController($stateParams, $filter, $state, $q, moment, PowerFormatter, DateUtil, DailyActivePowerService, ActivePowerService, CsvUtil, CompareWeatherLogic, WeatherService, DailyWeatherService) {
    var _this = this;

    _classCallCheck(this, WeeklyActiveReportController);

    this.id = $stateParams.id;
    this.$filter = $filter;
    this.$state = $state;
    this.$q = $q;
    this.DailyActivePowerService = DailyActivePowerService;
    this.ActivePowerService = ActivePowerService;
    this.WeatherService = WeatherService;
    this.DailyWeatherService = DailyWeatherService;
    this.CompareWeatherLogic = CompareWeatherLogic;
    this.PowerFormatter = PowerFormatter;
    this.moment = moment;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;

    this.targetDate = this.moment().startOf('week');
    this.startDate = this.targetDate.clone().toDate();
    this.endDate = this.targetDate.clone().add(6, 'days').toDate();
    this.maxDate = this.targetDate.clone().toDate();
    this.downloadFileName = 'active_power_daily.csv';
    this.bulkDownloadFileName = 'active_power_hourly.csv';
    this.bulkCsvGenerator = function () {
      return _this.createBulkCsv();
    };
    this.downloading = false;

    this.Week = ['日', '月', '火', '水', '木', '金', '土'];

    this.categories = [];
    for (var i = 0; i < 7; i++) {
      var utc = this.DateUtil.localToUTC(this.startDate);
      this.categories.push(this.DateUtil.leapDate(utc, i).valueOf());
    }

    this.chartConfig = (0, _weekly_active_report4.default)(this);
  }

  _createClass(WeeklyActiveReportController, [{
    key: '$onInit',
    value: function $onInit() {
      this.updateGraph(this.startDate, this.endDate);
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(startDate, endDate) {
      var _this2 = this;

      this.categories = [];
      for (var i = 0; i < 7; i++) {
        var utc = this.DateUtil.localToUTC(startDate);
        this.categories.push(this.DateUtil.leapDate(utc, i).valueOf());
      }

      var query = _angular2.default.extend({
        id: this.id,
        sa_config_id: this.id
      }, this.DateUtil.getDateRangeQueries(startDate, endDate));

      this.$q.all([this.DailyActivePowerService.show(query).$promise, this.DailyWeatherService.api.index(query).$promise]).then(function (responses) {
        var powers = responses[0];
        var weathers = responses[1];

        _this2.chart.xAxis[0].setCategories(_this2.categories);

        _this2.activePowerObjects = _this2.PowerFormatter.formatDailyActivePowers(powers.powers, _this2.categories);
        _this2.activePowers = _this2.activePowerObjects.map(function (power) {
          return power.y;
        });
        _this2.weathers = _this2.CompareWeatherLogic.compareDaily(weathers, _this2.categories);
        var y = _this2.weathers.length > 0 ? 50 : null;

        _this2.chart.xAxis[0].update({
          labels: { y: y }
        });

        _this2.itemWidth = 100 / 7;

        _this2.csvData = _this2.CsvUtil.processDailyActivePower(_this2.activePowers, _this2.categories, _this2.weathers);
        _this2.chart.series[0].setData(_this2.activePowerObjects);
        _this2.chart.reflow();
        _this2.setFilename(startDate);
      });
    }
  }, {
    key: 'setFilename',
    value: function setFilename(targetDate) {
      var date = this.moment(targetDate);
      this.downloadFileName = date.format('[active_power_]YYYY-MM-DD[_week_daily.csv]');
      this.bulkDownloadFileName = date.format('[active_power_]YYYY-MM-DD[_week_hourly.csv]');
    }
  }, {
    key: 'createBulkCsv',
    value: function createBulkCsv() {
      var _this3 = this;

      this.downloading = true;
      var startDate = this.moment(this.startDate);
      var endDate = this.moment(this.endDate).add(1, 'day');

      var powerQuery = _angular2.default.extend(this.DateUtil.datetimeRangeQuery(startDate, endDate), {
        id: this.id,
        start_min: 0
      });
      var weatherQuery = _angular2.default.extend({ sa_config_id: this.id }, this.DateUtil.getDateRangeQueries(startDate, endDate.subtract(1, 'day')));

      return new Promise(function (resolve) {
        _this3.$q.all([_this3.ActivePowerService.show(powerQuery).$promise, _this3.WeatherService.api.index(weatherQuery).$promise]).then(function (responses) {
          resolve(_this3.CsvUtil.processBulkActivePower(responses[0].powers, responses[1]));
          _this3.downloading = false;
        });
      });
    }
  }, {
    key: 'changeDate',
    value: function changeDate(diff) {
      this.startDate = this.DateUtil.leapDate(this.startDate, diff);
      this.endDate = this.DateUtil.leapDate(this.startDate, 6);

      this.updateGraph(this.startDate, this.endDate);
    }
  }, {
    key: 'getWeek',
    value: function getWeek(timeValue) {
      return this.Week[new Date(timeValue).getDay()];
    }
  }]);

  return WeeklyActiveReportController;
}();

exports.default = _angular2.default.module('leptonApp.weeklyActiveReport', [_angularjs2.default, _angularMoment2.default, _chart2.default, _date_util2.default, _powerFormatter2.default, _csv2.default, _compare_weather2.default, _daily_active_power2.default, _active_power2.default, _weather2.default, _daily_weather2.default]).config(_weekly_active_report2.default).component('weeklyActiveReport', {
  require: { parentComponent: '^demandReportShow' },
  template: __webpack_require__(786),
  controller: WeeklyActiveReportController
}).name;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.weekly_active_report', {
        template: '<weekly-active-report></weekly-active-report>'
    });
};

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  var chartConfig = {
    chart: {
      type: 'column',
      height: 300,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: { text: '1週間の電力消費実績' },
    legend: { enabled: false },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        format: '{value:%m月%d日}',
        formatter: function formatter() {
          var style = '';
          var day = scope.$filter('dayFilter')(this.value);
          if (day === '日') {
            style = 'color: #ff3131';
          } else if (day === '土') {
            style = 'color: #3737ff';
          }

          return '<span style="' + style + '">' + scope.$filter('date')(this.value, 'MM月dd日') + ' (' + day + ')</span>';
        }
      },
      max: 6
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力量 [kWh]'
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + scope.$filter('date')(this.x, 'MM月dd日') + "</tspan>";

        var point = this.points[0];
        tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
        tip_format += point.y + " kWh";
        tip_format += "</span>";

        return tip_format;
      }
    },
    plotOptions: {
      column: { grouping: false },
      series: {
        events: {
          click: function click(event) {
            scope.$state.go('main.demand_report_show.detail', { id: scope.id, type: 'active', term: 'daily', target: event.point.date }, { reload: true });
          }
        },
        cursor: 'pointer'
      }
    },
    series: [{
      name: '定時有効電力'
    }]
  };
  return chartConfig;
}

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: -25px 0 5px 7px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <md-button ng-click=\"$ctrl.changeDate(-7)\" class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-left\"></i>\n    </md-button>\n    <span>{{$ctrl.startDate | date : 'MM月dd日'}} ~ {{$ctrl.endDate | date : 'MM月dd日'}}</span>\n    <md-button ng-disabled=\"$ctrl.startDate.valueOf() === $ctrl.maxDate.valueOf()\" ng-click=\"$ctrl.changeDate(7)\"\n               class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-right\"></i>\n    </md-button>\n  </div>\n  <compare-modal ng-if=\"!$root.is_limited_viewer\"></compare-modal>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n  <div class=\"daily-weather-content weekly-weather-content active-weather-content\" ng-if=\"$ctrl.weathers.length > 0\">\n    <div class=\"daily-weather-item\" ng-style=\"{'width': $ctrl.itemWidth + '%'}\"\n         ng-repeat=\"weather in $ctrl.weathers track by $index\">\n      <weather-directive weather=\"weather\" icon-size=\"'middle'\" simple=\"true\"></weather-directive>\n    </div>\n  </div>\n</md-content>\n\n<div class='demand-report-table-content'>\n  <div>\n    <span class=\"report-table-unit\">(単位: kWh)</span>\n    <a csv-downloader filename=\"$ctrl.downloadFileName\" csv-data=\"$ctrl.csvData\"\n       style=\"color: inherit;text-decoration: none;\">\n      <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\"></i> 日別csvダウンロード\n      </md-button>\n    </a>\n    <a bulk-downloader filename=\"$ctrl.bulkDownloadFileName\" csv-generator=\"$ctrl.bulkCsvGenerator\"\n       style=\"color: inherit;text-decoration: none;\">\n      <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\" ng-if=\"!$ctrl.downloading\"></i>\n        <i class=\"fa fa-spinner\" aria-hidden=\"true\" ng-if=\"$ctrl.downloading\"></i>\n        <span> 時間別csvダウンロード</span>\n      </md-button>\n    </a>\n  </div>\n  <table class='demand-report-table active-report-table'>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 24\">\n        {{ time | date : 'MM月dd日' }} ({{ $ctrl.getWeek(time) }})\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.activePowers | limitTo : 24 track by $index\">\n        <span ng-hide='power === 0'>{{ power }}</span>\n      </td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MonthlyActiveReportController = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _monthly_active_report = __webpack_require__(788);

var _monthly_active_report2 = _interopRequireDefault(_monthly_active_report);

var _daily_active_power = __webpack_require__(191);

var _daily_active_power2 = _interopRequireDefault(_daily_active_power);

var _active_power = __webpack_require__(144);

var _active_power2 = _interopRequireDefault(_active_power);

var _weather = __webpack_require__(130);

var _weather2 = _interopRequireDefault(_weather);

var _daily_weather = __webpack_require__(192);

var _daily_weather2 = _interopRequireDefault(_daily_weather);

var _compare_weather = __webpack_require__(128);

var _compare_weather2 = _interopRequireDefault(_compare_weather);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

var _chart = __webpack_require__(70);

var _chart2 = _interopRequireDefault(_chart);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

var _monthly_active_report3 = __webpack_require__(789);

var _monthly_active_report4 = _interopRequireDefault(_monthly_active_report3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var MonthlyActiveReportController = exports.MonthlyActiveReportController = function () {
  /*@ngInject*/
  MonthlyActiveReportController.$inject = ["$stateParams", "$filter", "$state", "$q", "moment", "PowerFormatter", "DailyActivePowerService", "ActivePowerService", "DateUtil", "CsvUtil", "WeatherService", "DailyWeatherService", "CompareWeatherLogic"];
  function MonthlyActiveReportController($stateParams, $filter, $state, $q, moment, PowerFormatter, DailyActivePowerService, ActivePowerService, DateUtil, CsvUtil, WeatherService, DailyWeatherService, CompareWeatherLogic) {
    var _this = this;

    _classCallCheck(this, MonthlyActiveReportController);

    this.id = $stateParams.id;
    this.$filter = $filter;
    this.$state = $state;
    this.$q = $q;
    this.DailyActivePowerService = DailyActivePowerService;
    this.ActivePowerService = ActivePowerService;
    this.WeatherService = WeatherService;
    this.DailyWeatherService = DailyWeatherService;
    this.CompareWeatherLogic = CompareWeatherLogic;
    this.PowerFormatter = PowerFormatter;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;
    this.moment = moment;

    var today = this.moment();
    this.targetDate = $stateParams.target || today.toDate();
    $stateParams.target = null;

    this.maxDate = this.moment().startOf('day').toDate();

    this.downloadFileName = 'active_power_daily.csv';
    this.bulkDownloadFileName = 'active_power_hourly.csv';
    this.bulkCsvGenerator = function () {
      return _this.createBulkCsv();
    };
    this.downloading = false;

    this.categories = [];
    this.chartConfig = (0, _monthly_active_report4.default)(this);
  }

  _createClass(MonthlyActiveReportController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.parentComponent.saConfigPromise.then(function (config) {
        _this2.billingDay = config.billing_date;
        _this2.updateGraph(_this2.targetDate, _this2.billingDay);
      });
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(targetDate, billingDate) {
      var _this3 = this;

      var _DateUtil$getBillingD = this.DateUtil.getBillingDateDomain(targetDate, billingDate);

      var _DateUtil$getBillingD2 = _slicedToArray(_DateUtil$getBillingD, 2);

      this.startDate = _DateUtil$getBillingD2[0];
      this.endDate = _DateUtil$getBillingD2[1];

      this.billingDate = this.moment(this.endDate).add(1, 'days').toDate();
      var numberOfDays = (this.endDate - this.startDate) / (24 * 60 * 60 * 1000);

      var startUtc = this.DateUtil.localToUTC(this.startDate);
      this.categories = [];
      for (var i = 0; i <= numberOfDays; i++) {
        this.categories.push(this.DateUtil.leapDate(startUtc, i).valueOf());
      }

      var powerQuery = _angular2.default.extend({ id: this.id }, this.DateUtil.getDateRangeQueries(this.startDate, this.endDate));
      var weatherQuery = _angular2.default.extend({ sa_config_id: this.id }, this.DateUtil.getDateRangeQueries(this.startDate, this.endDate));

      this.$q.all([this.DailyActivePowerService.show(powerQuery).$promise, this.DailyWeatherService.api.index(weatherQuery).$promise]).then(function (responses) {
        var powers = responses[0];
        var weathers = responses[1];

        _this3.activePowerObjects = _this3.PowerFormatter.formatDailyActivePowers(powers.powers, _this3.categories);
        _this3.activePowers = _this3.activePowerObjects.map(function (power) {
          return power.y;
        });

        _this3.weathers = _this3.CompareWeatherLogic.compareDaily(weathers, _this3.categories);
        var y = _this3.weathers.length > 0 ? 36 : null;

        _this3.chart.xAxis[0].update({
          categories: _this3.categories,
          max: numberOfDays,
          labels: { y: y }
        });
        _this3.itemWidth = 100 / numberOfDays;

        _this3.csvData = _this3.CsvUtil.processDailyActivePower(_this3.activePowers, _this3.categories, _this3.weathers);
        _this3.chart.series[0].setData(_this3.activePowerObjects);
        _this3.chart.reflow();

        var date = _this3.moment(targetDate);
        _this3.downloadFileName = date.format('[active_power_]YYYY-MM[_daily.csv]');
        _this3.bulkDownloadFileName = date.format('[active_power_]YYYY-MM[_hourly.csv]');
      });
    }
  }, {
    key: 'createBulkCsv',
    value: function createBulkCsv() {
      var _this4 = this;

      this.downloading = true;
      var startDate = this.moment(this.startDate);
      var endDate = this.moment(this.endDate).add(1, 'day');

      var powerQuery = _angular2.default.extend(this.DateUtil.datetimeRangeQuery(startDate, endDate), {
        id: this.id,
        start_min: 0
      });
      var weatherQuery = _angular2.default.extend({ sa_config_id: this.id }, this.DateUtil.getDateRangeQueries(startDate, endDate.subtract(1, 'day')));

      return new Promise(function (resolve) {
        _this4.$q.all([_this4.ActivePowerService.show(powerQuery).$promise, _this4.WeatherService.api.index(weatherQuery).$promise]).then(function (responses) {
          resolve(_this4.CsvUtil.processBulkActivePower(responses[0].powers, responses[1]));
          _this4.downloading = false;
        });
      });
    }
  }, {
    key: 'changeMonth',
    value: function changeMonth(diff) {
      this.targetDate = this.moment(this.targetDate).add(diff, 'months').toDate();

      this.updateGraph(this.targetDate, this.billingDay);
    }
  }]);

  return MonthlyActiveReportController;
}();

exports.default = _angular2.default.module('leptonApp.monthlyActiveReport', [_angularjs2.default, _angularMoment2.default, _chart2.default, _powerFormatter2.default, _daily_active_power2.default, _active_power2.default, _date_util2.default, _csv2.default, _weather2.default, _daily_weather2.default, _compare_weather2.default]).config(_monthly_active_report2.default).component('monthlyActiveReport', {
  require: { parentComponent: '^demandReportShow' },
  template: __webpack_require__(790),
  controller: MonthlyActiveReportController
}).name;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.monthly_active_report', {
        template: '<monthly-active-report></monthly-active-report>'
    });
};

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  var chartConfig = {
    chart: {
      type: 'column',
      height: 300,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: { text: '1ヶ月間の消費実績' },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        formatter: function formatter() {
          var style = '';
          var day = scope.$filter('dayFilter')(this.value);
          if (day === '日') {
            style = 'color: #ff3131';
          } else if (day === '土') {
            style = 'color: #3737ff';
          }

          return '<span style="' + style + '">' + scope.$filter('date')(this.value, 'M/d') + ' (' + day + ')</span>';
        }
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力量 [kWh]'
      }
    },
    legend: { enabled: false },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + scope.$filter('date')(this.x, 'MM月dd日') + "</tspan>";

        var point = this.points[0];
        tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
        tip_format += point.y + " kWh";
        tip_format += "</span>";

        return tip_format;
      }
    },
    plotOptions: { column: { grouping: false } },
    series: [{
      name: '実績',
      events: {
        click: function click(event) {
          scope.$state.go('main.demand_report_show.detail', { id: scope.id, type: 'active', term: 'daily', target: event.point.date }, { reload: true });
        }
      },
      cursor: 'pointer'
    }]
  };

  return chartConfig;
}

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: 5px 0 5px 7px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <md-button ng-click=\"$ctrl.changeMonth(-1)\" class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-left\"></i>\n    </md-button>\n    <span>{{$ctrl.startDate | date : 'yyyy年MM月dd日'}} ~ {{$ctrl.endDate | date : 'yyyy年MM月dd日'}} <span\n            class=\"date-component-minor\">({{$ctrl.billingDate | date : 'yyyy年MM月'}} 請求分)</span></span>\n    <md-button ng-disabled=\"$ctrl.endDate.valueOf() >= $ctrl.maxDate.valueOf()\" ng-click=\"$ctrl.changeMonth(1)\"\n               class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-right\"></i>\n    </md-button>\n  </div>\n  <compare-modal ng-if=\"!$root.is_limited_viewer\"></compare-modal>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n  <div class=\"daily-weather-content active-weather-content\" ng-if=\"$ctrl.weathers.length > 0\">\n    <div class=\"daily-weather-item\" ng-style=\"{'width': $ctrl.itemWidth + '%'}\"\n         ng-repeat=\"weather in $ctrl.weathers track by $index\">\n      <weather-directive weather=\"weather\" icon-size=\"'small'\" simple=\"true\"></weather-directive>\n    </div>\n  </div>\n</md-content>\n<div class='demand-report-table-content'>\n  <div>\n    <span class=\"report-table-unit\">(単位: kWh)</span>\n    <a csv-downloader filename=\"$ctrl.downloadFileName\" csv-data=\"$ctrl.csvData\"\n       style=\"color: inherit;text-decoration: none;\">\n      <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\"></i> 日別csvダウンロード\n      </md-button>\n    </a>\n    <a bulk-downloader filename=\"$ctrl.bulkDownloadFileName\" csv-generator=\"$ctrl.bulkCsvGenerator\"\n       style=\"color: inherit;text-decoration: none;\">\n      <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\" ng-if=\"!$ctrl.downloading\"></i>\n        <i class=\"fa fa-spinner\" aria-hidden=\"true\" ng-if=\"$ctrl.downloading\"></i>\n        <span> 時間別csvダウンロード</span>\n      </md-button>\n    </a>\n  </div>\n  <table class='demand-report-table active-report-table monthly-demand-report'>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 16\">\n        {{ time | date : 'M/d' }} ({{ time | dayFilter }})\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.activePowers | limitTo : 16 track by $index\">\n        <span ng-hide='power === 0'>{{ power }}</span>\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 16 : 16\">\n        {{ time | date : 'M/d' }} ({{ time | dayFilter }})\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.activePowers | limitTo : 16 : 16 track by $index\">\n        <span ng-hide='power === 0'>{{ power }}</span>\n      </td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YearlyActiveReportController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _yearly_active_report = __webpack_require__(792);

var _yearly_active_report2 = _interopRequireDefault(_yearly_active_report);

var _monthly_active_power = __webpack_require__(470);

var _monthly_active_power2 = _interopRequireDefault(_monthly_active_power);

var _chart = __webpack_require__(70);

var _chart2 = _interopRequireDefault(_chart);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

var _yearly_active_report3 = __webpack_require__(793);

var _yearly_active_report4 = _interopRequireDefault(_yearly_active_report3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var YearlyActiveReportController = exports.YearlyActiveReportController = function () {
  /*@ngInject*/
  YearlyActiveReportController.$inject = ["$stateParams", "$filter", "$state", "moment", "PowerFormatter", "DateUtil", "MonthlyActivePowerService", "CsvUtil"];
  function YearlyActiveReportController($stateParams, $filter, $state, moment, PowerFormatter, DateUtil, MonthlyActivePowerService, CsvUtil) {
    _classCallCheck(this, YearlyActiveReportController);

    this.id = $stateParams.id;
    this.$filter = $filter;
    this.$state = $state;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;
    this.moment = moment;
    this.PowerFormatter = PowerFormatter;
    this.MonthlyActivePowerService = MonthlyActivePowerService;

    this.downloadFileName = 'active_power.csv';

    this.chartConfig = (0, _yearly_active_report4.default)(this);
    this.sa = null;
  }

  _createClass(YearlyActiveReportController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.updateGraph();
      this.parentComponent.saConfigPromise.then(function (res) {
        _this.sa = res;
      });
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph() {
      var _this2 = this;

      this.MonthlyActivePowerService.show({ id: this.id }).$promise.then(function (response) {
        var powers = response.powers;
        var lastDate = powers.length > 0 ? _this2.moment(powers[powers.length - 1].billing_date).subtract(1, 'days') : _this2.moment();
        lastDate.startOf('month');

        _this2.startDate = _this2.createStart(_this2.sa.billing_date);
        _this2.endDate = _this2.startDate.clone().add(12, 'months');

        _this2.categories = [];
        var start = _this2.createStart(_this2.sa.billing_date);

        for (var i = 0; i < 13; i++) {
          _this2.categories.push(start.valueOf());
          start.add(1, 'month');
        }

        _this2.chart.xAxis[0].update({
          categories: _this2.categories,
          max: 12
        });

        _this2.activePowerObjects = _this2.PowerFormatter.formatMonthlyActivePowers(powers, _this2.categories, _this2.sa.billing_date);
        _this2.activePowers = _this2.activePowerObjects.map(function (power) {
          return power.y;
        });
        _this2.csvData = _this2.CsvUtil.processMonthlyActivePower(_this2.activePowers, _this2.categories);
        _this2.chart.series[0].setData(_this2.activePowerObjects);
        _this2.chart.reflow();

        _this2.downloadFileName = 'active_power_' + _this2.startDate.format('YYYY-MM') + '_' + _this2.endDate.format('YYYY-MM') + '.csv';
      });
    }
  }, {
    key: 'createStart',
    value: function createStart(configBillingDate) {
      var current = this.moment().startOf('month');
      if (configBillingDate === 1) {
        configBillingDate = 99;
      }

      if (this.moment().date() >= configBillingDate) {
        current.add(1, 'month');
      }

      return current.add(current.utcOffset(), 'minutes').utc().subtract(12, 'month');
    }
  }]);

  return YearlyActiveReportController;
}();

exports.default = _angular2.default.module('leptonApp.yearlyActiveReport', [_angularjs2.default, _chart2.default, _powerFormatter2.default, _date_util2.default, _angularMoment2.default, _monthly_active_power2.default, _csv2.default]).config(_yearly_active_report2.default).component('yearlyActiveReport', {
  require: { parentComponent: '^demandReportShow' },
  template: __webpack_require__(794),
  controller: YearlyActiveReportController
}).name;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.yearly_active_report', {
        template: '<yearly-active-report></yearly-active-report>'
    });
}

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  var chartConfig = {
    chart: {
      type: 'column',
      height: 300,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: { text: '1年間の消費実績' },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        format: '{value:%m月分}'
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力値 [kWh]'
      }
    },
    legend: { enabled: false },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + scope.$filter('date')(this.x, 'MM月') + "</tspan>";

        var point = this.points[0];
        tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
        tip_format += point.y + " kWh";
        tip_format += "</span>";

        return tip_format;
      }
    },
    plotOptions: { column: { grouping: false } },
    series: [{
      name: '実績',
      events: {
        click: function click(event) {
          scope.$state.go('main.demand_report_show.detail', { id: scope.id, type: 'active', term: 'monthly', target: event.point.date }, { reload: true });
        }
      },
      cursor: 'pointer'
    }]
  };

  return chartConfig;
}

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: -25px 0 5px 15px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <span>{{$ctrl.startDate | amDateFormat : 'YYYY年MM月'}} ~ {{$ctrl.endDate | amDateFormat : 'YYYY年MM月'}}</span>\n  </div>\n  <compare-modal ng-if=\"!$root.is_limited_viewer\"></compare-modal>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n</md-content>\n<div class='demand-report-table-content'>\n  <div>\n    <span class=\"report-table-unit\">(単位: kWh)</span>\n    <a csv-downloader filename=\"$ctrl.downloadFileName\" csv-data=\"$ctrl.csvData\"\n       style=\"color: inherit;text-decoration: none;\">\n      <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\"></i> csvダウンロード\n      </md-button>\n    </a>\n  </div>\n  <table class='demand-report-table active-report-table'>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories\">\n        {{ time | date : 'MM月分' }}\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.activePowers track by $index\">\n        <span ng-hide='power === 0'>{{ power }}</span>\n      </td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DemandHistogramController = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _demand_histogram = __webpack_require__(796);

var _demand_histogram2 = _interopRequireDefault(_demand_histogram);

var _chart = __webpack_require__(70);

var _chart2 = _interopRequireDefault(_chart);

var _demand_power = __webpack_require__(202);

var _demand_power2 = _interopRequireDefault(_demand_power);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

var _demand_histogram3 = __webpack_require__(797);

var _demand_histogram4 = _interopRequireDefault(_demand_histogram3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DemandHistogramController = exports.DemandHistogramController = function () {
  /*@ngInject*/
  DemandHistogramController.$inject = ["$stateParams", "$filter", "$interval", "moment", "DemandPowerService", "DateUtil", "CsvUtil"];
  function DemandHistogramController($stateParams, $filter, $interval, moment, DemandPowerService, DateUtil, CsvUtil) {
    _classCallCheck(this, DemandHistogramController);

    this.id = $stateParams.id;
    this.$filter = $filter;
    this.DemandPowerService = DemandPowerService;
    this.DateUtil = DateUtil;
    this.moment = moment;
    this.CsvUtil = CsvUtil;

    this.targetDate = this.moment();
    this.maxDate = this.moment().startOf('day').toDate();

    this.downloadFileName = 'demand_histogram.csv';

    this.chartConfig = (0, _demand_histogram4.default)(this, $filter);
  }

  _createClass(DemandHistogramController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.parentComponent.saConfigPromise.then(function (config) {
        _this.contractPower = config.contract_power;
        _this.limitPower = config.limit_power;
        _this.targetPower = config.target_power;
        _this.billingDay = config.billing_date;

        _this.updateGraph(_this.targetDate, _this.billingDay);
      });
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(targetDate, billingDate) {
      var _this2 = this;

      var _DateUtil$getBillingD = this.DateUtil.getBillingDateDomain(targetDate.toDate(), billingDate);

      var _DateUtil$getBillingD2 = _slicedToArray(_DateUtil$getBillingD, 2);

      this.startDate = _DateUtil$getBillingD2[0];
      this.endDate = _DateUtil$getBillingD2[1];

      this.startDate = this.moment(this.startDate);
      this.endDate = this.moment(this.endDate);

      this.billingDate = this.endDate.clone().add(1, 'days');

      var numberOfDays = this.endDate.diff(this.startDate, 'days');

      this.chart.xAxis[0].removePlotLine('target');
      this.chart.xAxis[0].removePlotLine('limit');
      this.chart.xAxis[0].removePlotLine('contract');

      this.DemandPowerService.show(_angular2.default.extend({ id: this.id }, this.DateUtil.datetimeRangeQuery(this.startDate, this.endDate)), function (response) {
        _this2.histogram = _this2.createHistogram(response.powers);

        if (_this2.histogram.length > 0) {
          _this2.chart.xAxis[0].addPlotLine({
            label: '目標電力',
            id: 'target',
            value: _this2.targetPower,
            color: '#8bc34a',
            width: 2,
            zIndex: 5
          });
          _this2.chart.xAxis[0].addPlotLine({
            label: '限界電力',
            id: 'limit',
            value: _this2.limitPower,
            color: '#e67e22',
            width: 2,
            zIndex: 5
          });
          _this2.chart.xAxis[0].addPlotLine({
            label: '契約電力',
            id: 'contract',
            value: _this2.contractPower,
            color: '#D32F2F',
            width: 2,
            zIndex: 5
          });

          _this2.chart.series[1].setData([[_this2.contractPower, 0]], false);
          _this2.chart.series[2].setData([[_this2.limitPower, 0]], false);
          _this2.chart.series[3].setData([[_this2.targetPower, 0]], false);
        }

        _this2.chart.series[0].setData(_this2.histogram);
        _this2.chart.reflow();

        _this2.reversedHist = _this2.histogram.reverse();
        _this2.csvData = _this2.CsvUtil.processDemandHistogram(_this2.reversedHist);
        _this2.downloadFileName = _this2.startDate.format('[demand_histogram_]YYYY-MM[.csv]');
      });
    }
  }, {
    key: 'createHistogram',
    value: function createHistogram(powers) {
      var x = [];
      var y = [];
      var times = [];

      powers.forEach(function (power) {
        if (power.missing) {
          return;
        }

        var value = Math.round(power.value);
        var x_index = x.indexOf(value);
        if (x_index === -1) {
          x.push(value);
          y.push(1);
          times.push([power.measured_at]);
        } else {
          y[x_index] += 1;
          times[x_index].push(power.measured_at);
        }
      });

      var data = x.map(function (value, index) {
        return { x: value, y: y[index], times: times[index] };
      });

      return data.sort(function (a, b) {
        return a.x - b.x;
      });
    }
  }, {
    key: 'changeMonth',
    value: function changeMonth(diff) {
      this.targetDate = this.targetDate.add(diff, 'months');
      this.updateGraph(this.targetDate, this.billingDay);
    }
  }]);

  return DemandHistogramController;
}();

exports.default = _angular2.default.module('leptonApp.demandHistogram', [_angularjs2.default, _angularMoment2.default, _demand_power2.default, _date_util2.default, _csv2.default]).config(_demand_histogram2.default).component('demandHistogram', {
  require: { parentComponent: '^demandReportShow' },
  template: __webpack_require__(798),
  controller: DemandHistogramController
}).name;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.demand_histogram', {
        template: '<demand-histogram></demand-histogram>'
    });
};

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope", "$filter"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope, $filter) {
  'ngInject';

  var TIMES_VIEW_LIMIT = 15;

  var tooltipFormat = {
    headerFormat: '',
    pointFormatter: function pointFormatter() {
      var tip_format = "";

      tip_format += '<br/><span style="color: ' + this.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + this.series.name + ': ';
      tip_format += this.x + ' kW';
      tip_format += "</span>";

      return tip_format;
    }
  };

  var chartConfig = {
    chart: {
      type: 'column',
      height: 300,
      zoomType: 'x',
      resetZoomButton: {
        theme: {
          fill: 'white',
          stroke: 'silver',
          states: {
            hover: {
              fill: 'rgba(215, 215,215,0.9)',
              style: {}
            }
          }
        }
      },
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: { text: '1ヶ月間のデマンド値分布' },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        format: '{value}'
      },
      title: {
        text: '需要電力値 [kW]'
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '発生回数'
      }
    },
    legend: {
      enabled: false
    },
    plotLines: [{
      id: 'target'
    }, {
      id: 'limit'
    }, {
      id: 'contract'
    }],
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true
    },
    plotOptions: {
      column: {
        grouping: false,
        borderWidth: 2
      }
    },
    series: [{
      name: '発生回数',
      color: '#1F85CF',
      marker: { symbol: 'circle' },
      pointWidth: 5,
      tooltip: {
        headerFormat: '',
        pointFormatter: function pointFormatter() {
          var tip_format = "<span style=\"font-size: 14px;\">\u9700\u8981\u96FB\u529B\u5024: " + this.x + ' kW</span>';
          tip_format += '<br/><span style="font-size: 14px;">' + this.series.name + ': ';
          tip_format += this.y + " \u56DE";
          tip_format += "</span><br/><span style=\"font-size: 14px;\">\u767A\u751F\u6642\u523B:<br/>";

          for (var i = 0; i < this.times.length; i++) {
            if (i >= TIMES_VIEW_LIMIT) {
              tip_format += '...';
              i = this.times.length;
            } else {
              var formattedTime = $filter('date')(this.times[i], 'MM/dd HH:mm');
              tip_format += formattedTime + '<br/>';
            }
          }

          tip_format += '</span>';

          return tip_format;
        }
      }
    }, {
      name: '契約電力',
      marker: { enabled: false },
      color: '#D32F2F',
      tooltip: tooltipFormat
    }, {
      name: '限界電力',
      marker: { enabled: false },
      color: '#e67e22',
      tooltip: tooltipFormat
    }, {
      name: '目標電力',
      marker: { enabled: false },
      color: '#8bc34a',
      tooltip: tooltipFormat
    }]
  };

  return chartConfig;
}

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: 20px 0 5px 7px;\">\n    <div layout=\"row\" layout-align=\"start center\">\n        <md-button ng-click=\"$ctrl.changeMonth(-1)\" class=\"md-fab md-mini md-primary\">\n            <i class=\"fa fa-arrow-left\"></i>\n        </md-button>\n        <span>{{$ctrl.startDate | amDateFormat : 'YYYY年MM月DD日'}} ~ {{$ctrl.endDate | amDateFormat : 'YYYY年MM月DD日'}} <span class=\"date-component-minor\">({{$ctrl.billingDate | amDateFormat : 'YYYY年MM月'}} 請求分)</span></span>\n        <md-button ng-disabled=\"$ctrl.endDate.valueOf() >= $ctrl.maxDate.valueOf()\" ng-click=\"$ctrl.changeMonth(1)\" class=\"md-fab md-mini md-primary\">\n            <i class=\"fa fa-arrow-right\"></i>\n        </md-button>\n    </div>\n</div>\n<md-content>\n    <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n</md-content>\n<div ng-if=\"$ctrl.reversedHist.length > 0\" class='demand-report-table-content' style=\"position: relative;padding: 0;margin: 10px 15px 20px;\">\n    <div>\n        <a csv-downloader filename=\"$ctrl.downloadFileName\" csv-data=\"$ctrl.csvData\" style=\"color: inherit;text-decoration: none;\">\n            <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);\">\n                <i class=\"fa fa-download\" aria-hidden=\"true\"></i> csvダウンロード\n            </md-button>\n        </a>\n    </div>\n    <div class=\"hist-table-content\">\n        <table class='demand-report-table hist-table'>\n            <tr style=\"height: 21px\">\n                <td style=\"width: 103px;\">需要電力値 (kW)</td>\n                <td ng-repeat=\"hist in $ctrl.reversedHist\">\n                   <span>{{ hist.x }}</span>\n                </td>\n            </tr>\n            <tr style=\"height: 20px\">\n                <td style=\"width: 103px;\">発生回数</td>\n                <td ng-repeat=\"hist in $ctrl.reversedHist track by $index\">\n                    <span>{{ hist.y }}</span>\n                </td>\n            </tr>\n        </table>\n    </div>\n</div>\n"

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SaGroupIndexController = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _sa_group_index = __webpack_require__(800);

var _sa_group_index2 = _interopRequireDefault(_sa_group_index);

var _sa_group = __webpack_require__(201);

var _sa_group2 = _interopRequireDefault(_sa_group);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var SaGroupIndexController = exports.SaGroupIndexController = function () {
    /*@ngInject*/
    SaGroupIndexController.$inject = ["SaGroupService"];
    function SaGroupIndexController(SaGroupService) {
        _classCallCheck(this, SaGroupIndexController);

        this.SaGroupService = SaGroupService;
    }

    _createClass(SaGroupIndexController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.SaGroupService.api.index(function (response) {
                _this.groupList = response;
            });
        }
    }]);

    return SaGroupIndexController;
}();

exports.default = _angular2.default.module('leptonApp.saGroupIndex', [_angularjs2.default, _sa_group2.default]).config(_sa_group_index2.default).component('saGroupIndex', {
    template: __webpack_require__(801),
    controller: SaGroupIndexController
}).name;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.sa_group_index', {
    url: 'sa_group',
    template: '<sa-group-index></sa-group-index>'
  });
};

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-copy\"></i>&nbsp;グループ 一覧</h2>\n  </div>\n</md-toolbar>\n<div ng-if=\"$ctrl.groupList.length === 0\" class=\"empty-notice\">グループが登録されていません。</div>\n<md-content>\n    <div class=\"add-link-row\" ng-if=\"!$root.is_viewer\">\n        <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>&nbsp;<span ui-sref=\"main.sa_group_create\">グループを追加</span>\n    </div>\n    <md-divider></md-divider>\n    <md-list-item class=\"md-3-line\" ng-repeat=\"group in $ctrl.groupList\" style=\"flex-direction: column; padding-right: 0;min-height: initial;\">\n        <a ui-sref=\"main.sa_group_edit({id:{{group.id}}})\" style=\"width: 100%; padding: 15px 0\"   layout=\"row\" layout-align=\"start center\">\n        <div class=\"md-list-item-text\" layout=\"column\">\n            <h3>{{group.name}}</h3>\n            <h4>{{group.memo}}</h4>\n        </div>\n        </a>\n        <md-divider></md-divider>\n    </md-list-item>\n</md-content>\n"

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SaGroupCreateController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _sa_group_create = __webpack_require__(803);

var _sa_group_create2 = _interopRequireDefault(_sa_group_create);

var _sa_group = __webpack_require__(201);

var _sa_group2 = _interopRequireDefault(_sa_group);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var SaGroupCreateController = exports.SaGroupCreateController = function () {
  /*@ngInject*/
  SaGroupCreateController.$inject = ["$state", "$mdDialog", "SaGroupService", "SaConfigService"];
  function SaGroupCreateController($state, $mdDialog, SaGroupService, SaConfigService) {
    _classCallCheck(this, SaGroupCreateController);

    this.SaGroupService = SaGroupService;
    this.SaConfigService = SaConfigService;
    this.$state = $state;
    this.$mdDialog = $mdDialog;

    this.configIds = [];
    this.allIds = [];

    this.submitted = false;

    this.dialog = {
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '作成が完了しました',
        content: '一覧 画面に移動します',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };
  }

  _createClass(SaGroupCreateController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.SaConfigService.api.index(function (response) {
        _this.configList = response;
      });
    }
  }, {
    key: 'createGroup',
    value: function createGroup(groupConfig, $event) {
      var _this2 = this;

      this.submitted = true;

      this.SaGroupService.api.create(_angular2.default.merge(groupConfig, { config_ids: this.configIds }), function (ok) {
        _this2.$mdDialog.show(_this2.dialog.success).finally(function () {
          _this2.$state.go('main.sa_group_index');
        });
      }, function (ng) {
        _this2.submitted = false;
        _this2.$mdDialog.show(_this2.dialog.error);
      });
    }
  }]);

  return SaGroupCreateController;
}();

exports.default = _angular2.default.module('leptonApp.saGroupCreate', [_angularjs2.default, _sa_group2.default, _sa_config2.default]).config(_sa_group_create2.default).component('saGroupCreate', {
  template: __webpack_require__(804),
  controller: SaGroupCreateController
}).name;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.sa_group_create', {
        url: 'sa_group_create',
        template: '<sa-group-create></sa-group-create>'
    });
};

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-copy\"></i>&nbsp;グループ作成</h2>\n  </div>\n</md-toolbar>\n<md-content style=\"padding: 5px 30px;\">\n  <form name=\"groupForm\" novalidate>\n    <div layout-gt-sm=\"row\" style=\"margin-top: 20px;\">\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px\">\n        <label>グループ名</label>\n        <input name=\"name\" ng-model=\"$ctrl.groupConfig.name\" md-maxlength=\"64\" required>\n        <div ng-messages=\"groupForm.name.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">64文字以下で記載してください</div>\n          <div ng-message=\"required\">入力が必須です</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px\">\n        <label>メモ</label>\n        <input name=\"memo\" ng-model=\"$ctrl.groupConfig.memo\" md-maxlength=\"128\">\n        <div ng-messages=\"groupForm.memo.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">128文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <div class=\"group-config-list\">\n      <h4>グループに所属させる機器を選択</h4>\n      <device-check-list device-list=\"$ctrl.configList\" selected-list=\"$ctrl.configIds\"></device-check-list>\n    </div>\n\n    <md-button ng-click=\"$ctrl.createGroup($ctrl.groupConfig, $event)\"\n               ng-disabled=\"groupForm.$invalid || $ctrl.configIds.length === 0 || $ctrl.submitted\"\n               class=\"md-primary md-raised\"\n               style=\"margin: 50px 0; padding: 0 20px\">\n      作成する\n    </md-button>\n  </form>\n</md-content>\n"

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SaGroupEditController = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _sa_group_edit = __webpack_require__(806);

var _sa_group_edit2 = _interopRequireDefault(_sa_group_edit);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _sa_group = __webpack_require__(201);

var _sa_group2 = _interopRequireDefault(_sa_group);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var SaGroupEditController = exports.SaGroupEditController = function () {
    /*@ngInject*/
    SaGroupEditController.$inject = ["$state", "$stateParams", "$mdDialog", "SaGroupService", "SaConfigService"];
    function SaGroupEditController($state, $stateParams, $mdDialog, SaGroupService, SaConfigService) {
        _classCallCheck(this, SaGroupEditController);

        this.id = $stateParams.id;
        this.SaGroupService = SaGroupService;
        this.SaConfigService = SaConfigService;
        this.$state = $state;
        this.$mdDialog = $mdDialog;

        this.configIds = [];
        this.groupConfig = { id: this.id };

        this.submitted = false;

        this.dialog = {
            success: $mdDialog.alert({
                clickOutsideToClose: true,
                title: '設定を変更しました',
                content: '一覧 画面に移動します',
                ok: 'OK'
            }),
            error: $mdDialog.alert({
                clickOutsideToClose: true,
                title: 'エラーが発生しました',
                content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
                ok: 'OK'
            })
        };

        this.deleteDialog = {
            confirm: $mdDialog.confirm({
                clickOutsideToClose: true,
                title: '削除してよろしいですか?',
                ok: '削除する',
                cancel: '戻る'
            }),
            success: $mdDialog.alert({
                clickOutsideToClose: true,
                title: 'グループを削除しました',
                content: '一覧 画面に移動します',
                ok: 'OK'
            }),
            error: $mdDialog.alert({
                clickOutsideToClose: true,
                title: 'エラーが発生しました',
                content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
                ok: 'OK'
            })
        };
    }

    _createClass(SaGroupEditController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.SaGroupService.api.show({ id: this.id }, function (response) {
                _this.groupConfig.name = response.name;
                _this.groupConfig.memo = response.memo;

                _this.configIds = response.config_ids;
            }, function (err) {
                if (err.status === 404 || err.status === 403) {
                    _this.$state.go('main.home');
                }
            });

            this.SaConfigService.api.index(function (response) {
                _this.configList = response;
            });
        }
    }, {
        key: 'updateGroup',
        value: function updateGroup(groupConfig, $event) {
            var _this2 = this;

            this.submitted = true;

            this.SaGroupService.api.update(_angular2.default.merge(groupConfig, { config_ids: this.configIds }), function (ok) {
                _this2.$mdDialog.show(_this2.dialog.success).finally(function () {
                    _this2.$state.go('main.sa_group_index');
                });
            }, function (ng) {
                _this2.submitted = false;
                _this2.$mdDialog.show(_this2.dialog.error);
            });
        }
    }, {
        key: 'deleteGroup',
        value: function deleteGroup(ev) {
            var _this3 = this;

            this.submitted = true;

            this.$mdDialog.show(this.deleteDialog.confirm.targetEvent(ev)).then(function () {
                _this3.SaGroupService.api.delete({ id: _this3.id }, function (ok) {
                    _this3.$mdDialog.show(_this3.deleteDialog.success).finally(function () {
                        return _this3.$state.go('main.sa_group_index');
                    });
                }, function (ng) {
                    _this3.$mdDialog.show(_this3.deleteDialog.error);
                    _this3.submitted = false;
                });
            });
        }
    }]);

    return SaGroupEditController;
}();

exports.default = _angular2.default.module('leptonApp.saGroupEdit', [_angularjs2.default, _sa_group2.default, _sa_config2.default]).config(_sa_group_edit2.default).component('saGroupEdit', {
    template: __webpack_require__(807),
    controller: SaGroupEditController
}).name;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.sa_group_edit', {
        url: 'sa_group/:id',
        template: '<sa-group-edit></sa-group-edit>'
    });
};

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-copy\"></i>&nbsp;グループ設定</h2>\n  </div>\n</md-toolbar>\n<md-content style=\"padding: 5px 30px;\">\n  <form readonly-if=\"$root.is_viewer\" name=\"groupForm\" novalidate>\n    <div layout-gt-sm=\"row\" style=\"margin-top: 20px;\">\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px\">\n        <label>グループ名</label>\n        <input name=\"name\" ng-model=\"$ctrl.groupConfig.name\" md-maxlength=\"64\" required>\n        <div ng-messages=\"groupForm.name.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">64文字以下で記載してください</div>\n          <div ng-message=\"required\">入力が必須です</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px\">\n        <label>メモ</label>\n        <input name=\"memo\" ng-model=\"$ctrl.groupConfig.memo\" md-maxlength=\"128\">\n        <div ng-messages=\"groupForm.memo.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">128文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <div class=\"group-config-list\">\n      <h4 style=\"margin-top: 0;\">グループに所属する機器</h4>\n      <device-check-list device-list=\"$ctrl.configList\" selected-list=\"$ctrl.configIds\"></device-check-list>\n    </div>\n\n    <md-button ng-click=\"$ctrl.updateGroup($ctrl.groupConfig, $event)\"\n               ng-if=\"$root.is_admin || $root.is_operator\"\n               ng-disabled=\"groupForm.$invalid || $ctrl.configIds.length === 0 || $ctrl.submitted\"\n               class=\"md-primary md-raised\"\n               style=\"margin: 30px 0; padding: 0 20px\">\n      設定を変更\n    </md-button>\n  </form>\n\n</md-content>\n\n<div ng-if=\"$root.is_admin || $root.is_operator\">\n  <md-divider></md-divider>\n  <md-content style=\"padding: 5px 30px;\">\n    <md-button ng-click=\"$ctrl.deleteGroup($event)\"\n               ng-disabled=\"$ctrl.submitted\" class=\"md-warn md-raised\"\n               style=\"margin: 20px 0; padding: 0 20px\">\n      グループを削除\n    </md-button>\n  </md-content>\n</div>\n"

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupReportShowController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularCookies = __webpack_require__(94);

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _group_report_show = __webpack_require__(809);

var _group_report_show2 = _interopRequireDefault(_group_report_show);

var _sa_group = __webpack_require__(201);

var _sa_group2 = _interopRequireDefault(_sa_group);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var GroupReportShowController = exports.GroupReportShowController = function () {
  /*@ngInject*/
  GroupReportShowController.$inject = ["$state", "$stateParams", "$cookies", "SaGroupService"];
  function GroupReportShowController($state, $stateParams, $cookies, SaGroupService) {
    _classCallCheck(this, GroupReportShowController);

    this.id = $stateParams.id;
    this.cookies = $cookies;
    this.$state = $state;
    this.SaGroupService = SaGroupService;

    this.term = $stateParams.term || this.cookies.get('report_term') || 'daily';
  }

  _createClass(GroupReportShowController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.SaGroupService.api.show({ id: this.id }, function (response) {
        _this.name = response.name;
        _this.memo = response.memo;
      }, function (err) {
        if (err.status === 404 || err.status === 403) {
          _this.$state.go('main.home');
        }
      });
    }
  }, {
    key: 'changeTerm',
    value: function changeTerm(term) {
      this.cookies.put('report_term', term);
      this.term = term;
    }
  }]);

  return GroupReportShowController;
}();

exports.default = _angular2.default.module('leptonApp.groupReportShow', [_angularjs2.default, _angularCookies2.default, _sa_group2.default]).config(_group_report_show2.default).component('groupReportShow', {
  template: __webpack_require__(810),
  controller: GroupReportShowController
}).name;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.group_report_show', {
    template: '<group-report-show></group-report-show>'
  }).state('main.group_report_show.detail', {
    url: 'group_report/:id',
    params: { term: null, target: null },
    views: {
      daily: {
        template: '<daily-group-report></daily-group-report>'
      },
      weekly: {
        template: '<weekly-group-report></weekly-group-report>'
      },
      monthly: {
        template: '<monthly-group-report></monthly-group-report>'
      },
      yearly: {
        template: '<yearly-group-report></yearly-group-report>'
      }
    }
  });
}

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports = "<div id=\"demand-report-sa-info\" style=\"margin: 15px;\">\n    <h3>{{$ctrl.name}}</h3>\n    <h3>{{$ctrl.memo}}</h3>\n</div>\n\n<md-divider></md-divider>\n\n<div class=\"align-right\">\n    <div></div>\n    <div class='demand-report-tabs2'>\n        <div class='demand-report-tab2' ng-class=\"{'demand-report-tab2-active': ($ctrl.term === 'daily')}\" ng-click=\"$ctrl.changeTerm('daily')\">\n            日間\n        </div>\n        <div class='demand-report-tab2' ng-class=\"{'demand-report-tab2-active': ($ctrl.term === 'weekly')}\" ng-click=\"$ctrl.changeTerm('weekly')\">\n            週間\n        </div>\n        <div class='demand-report-tab2' ng-class=\"{'demand-report-tab2-active': ($ctrl.term === 'monthly')}\" ng-click=\"$ctrl.changeTerm('monthly')\">\n            月間\n        </div>\n        <div class='demand-report-tab2' ng-class=\"{'demand-report-tab2-active': ($ctrl.term === 'yearly')}\" ng-click=\"$ctrl.changeTerm('yearly')\">\n            年間\n        </div>\n    </div>\n</div>\n\n<div ui-view=\"daily\" ng-if=\"$ctrl.term === 'daily'\"></div>\n<div ui-view=\"weekly\" ng-if=\"$ctrl.term === 'weekly'\"></div>\n<div ui-view=\"monthly\" ng-if=\"$ctrl.term === 'monthly'\"></div>\n<div ui-view=\"yearly\" ng-if=\"$ctrl.term === 'yearly'\"></div>\n"

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DailyGroupReportController = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _daily_group_report = __webpack_require__(812);

var _daily_group_report2 = _interopRequireDefault(_daily_group_report);

var _group_active_power = __webpack_require__(491);

var _group_active_power2 = _interopRequireDefault(_group_active_power);

var _chart = __webpack_require__(70);

var _chart2 = _interopRequireDefault(_chart);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

var _math_util = __webpack_require__(88);

var _math_util2 = _interopRequireDefault(_math_util);

var _group_report_util = __webpack_require__(219);

var _group_report_util2 = _interopRequireDefault(_group_report_util);

var _daily_group_report3 = __webpack_require__(813);

var _daily_group_report4 = _interopRequireDefault(_daily_group_report3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DailyGroupReportController = exports.DailyGroupReportController = function () {
  /*@ngInject*/
  DailyGroupReportController.$inject = ["$stateParams", "$filter", "$interval", "moment", "GroupActivePowerService", "DateUtil", "CsvUtil", "MathUtil", "GroupReportUtil"];
  function DailyGroupReportController($stateParams, $filter, $interval, moment, GroupActivePowerService, DateUtil, CsvUtil, MathUtil, GroupReportUtil) {
    _classCallCheck(this, DailyGroupReportController);

    this.id = $stateParams.id;
    this.$filter = $filter;
    this.interval = $interval;
    this.GroupActivePowerService = GroupActivePowerService;
    this.DateUtil = DateUtil;
    this.moment = moment;
    this.CsvUtil = CsvUtil;
    this.MathUtil = MathUtil;
    this.GroupReportUtil = GroupReportUtil;

    this.categories = DateUtil.getXLabels;
    this.today = this.moment().startOf('day').toDate();
    this.targetDate = $stateParams.target || this.today;
    this.maxDate = this.today;

    this.downloadFileName = 'active_power.csv';
    this.isOverStackLimit = false;

    this.chartConfig = (0, _daily_group_report4.default)(this);
  }

  _createClass(DailyGroupReportController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.updateGraph();

      this.timer = this.interval(function () {
        _this.changeDate();
      }, 300000);
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph() {
      var _this2 = this;

      this.GroupActivePowerService.show(_angular2.default.extend({ id: this.id }, this.DateUtil.getActivePowerQueries(this.targetDate)), function (response) {
        var _formatGroupActivePow = _this2.formatGroupActivePower(response.powers);

        var _formatGroupActivePow2 = _slicedToArray(_formatGroupActivePow, 2);

        _this2.seriesList = _formatGroupActivePow2[0];
        _this2.sumSeriesList = _formatGroupActivePow2[1];

        if (_this2.isOverStackLimit) {
          _this2.chartConfig.series = _this2.sumSeriesList;
        } else {
          _this2.chartConfig.series = _this2.seriesList;
        }

        _this2.sumSeries = _this2.sumSeriesList[0];

        _this2.csvData = _this2.CsvUtil.processGroupActivePower(_this2.seriesList, _this2.categories, _this2.targetDate);
        _this2.downloadFileName = _this2.moment(_this2.targetDate).format('[group_active_power_]YYYY-MM-DD[.csv]');
      });
    }
  }, {
    key: 'formatGroupActivePower',
    value: function formatGroupActivePower(groupActivePowers) {
      if (groupActivePowers.length <= 1) {
        return [[], []];
      }


      var STACK_LIMIT = 10;
      this.isOverStackLimit = false;

      var firstMeasuredAt = this.moment(groupActivePowers[0].measured_at);
      var beginningTime = this.moment(this.targetDate).startOf('day');
      var shift_range = firstMeasuredAt.diff(beginningTime, 'minutes') / 30;

      var seriesList = this.GroupReportUtil.createSeriesList(groupActivePowers, shift_range);

      if (seriesList.length > STACK_LIMIT) {
        this.isOverStackLimit = true;
      }

      var _GroupReportUtil$crea = this.GroupReportUtil.createStackSeries(seriesList, groupActivePowers),
          _GroupReportUtil$crea2 = _slicedToArray(_GroupReportUtil$crea, 1),
          stackSeriesList = _GroupReportUtil$crea2[0];

      stackSeriesList = this.GroupReportUtil.createDiffArray(stackSeriesList);

      var sumSeries = this.GroupReportUtil.createSumSeries(stackSeriesList);

      return [stackSeriesList, [sumSeries]];
    }
  }, {
    key: 'changeDate',
    value: function changeDate(diff) {
      if (diff !== undefined) {
        this.targetDate = this.DateUtil.leapDate(this.targetDate, diff);
      }

      this.updateGraph();
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      if (this.timer) {
        this.interval.cancel(this.timer);
      }
    }
  }]);

  return DailyGroupReportController;
}();

exports.default = _angular2.default.module('leptonApp.dailyGroupReport', [_angularjs2.default, _group_active_power2.default, _chart2.default, _date_util2.default, _csv2.default, _angularMoment2.default, _math_util2.default, _group_report_util2.default]).config(_daily_group_report2.default).component('dailyGroupReport', {
  require: { parentComponent: '^groupReportShow' },
  template: __webpack_require__(814),
  controller: DailyGroupReportController
}).name;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.daily_group_report', {
        template: '<daily-group-report></daily-group-report>'
    });
};

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
    'ngInject';

    var chartConfig = {
        chart: {
            type: 'column',
            height: 400,
            events: {
                load: function load() {
                    scope.chart = this.chart;
                }
            }
        },

        title: { text: '1日の電力消費実績' },
        legend: { enabled: false },
        xAxis: {
            categories: scope.categories,
            crosshair: true,
            max: scope.categories.length - 1
        },
        yAxis: {
            labels: {
                format: '{value}'
            },
            title: {
                text: '電力量 [kWh]'
            }
        },
        tooltip: {
            enabled: true,
            shared: true,
            formatter: function formatter() {
                var sum = 0;
                var pointsFormat = '';

                if (scope.isOverStackLimit) {
                    sum = this.points[0].y;
                } else {
                    angular.forEach(this.points, function (point, i) {
                        pointsFormat += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 13px;\"> ";
                        pointsFormat += point.y + " kWh";
                        pointsFormat += '<br/><span style="font-size: 10px;">' + subString(point.series.options.location) + '</span>';
                        pointsFormat += "</span>";
                        sum = scope.MathUtil.add(sum, point.y);
                    });
                }

                var headerFormat = '<tspan style="font-size: 12px">' + this.x + "</tspan> <tspan style=\"font-size: 13px\">\u5408\u8A08: " + sum + ' kWh</tspan>';

                return headerFormat + pointsFormat;
            }
        },
        plotOptions: {
            column: {
                grouping: false,
                stacking: 'normal'
            }
        }
    };
    return chartConfig;

    function subString(str) {
        var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

        if (str.length <= 20) {
            return str;
        }
        return str.substr(0, limit) + '...';
    }
}

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: -25px 0 5px 7px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <md-button ng-click=\"$ctrl.changeDate(-1)\" class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-left\"></i>\n    </md-button>\n    <div datepicker class=\"date-picker\" ng-model=\"$ctrl.targetDate\" ng-change=\"$ctrl.changeDate()\" max-date=\"$ctrl.maxDate\">{{$ctrl.targetDate | date: 'yyyy/MM/dd'}}\n      <i class=\"fa fa-sort-down\" aria-hidden=\"true\"></i>\n    </div>\n    <md-button ng-disabled=\"$ctrl.targetDate.valueOf() === $ctrl.maxDate.valueOf()\" ng-click=\"$ctrl.changeDate(1)\"\n               class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-right\"></i>\n    </md-button>\n  </div>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n</md-content>\n\n<div class='demand-report-table-content'>\n  <div>\n    <span class=\"report-table-unit\">合計値 (単位: kWh)</span>\n    <a csv-downloader filename=\"$ctrl.downloadFileName\" csv-data=\"$ctrl.csvData\"\n       style=\"color: inherit;text-decoration: none;\">\n      <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\"></i> csvダウンロード\n      </md-button>\n    </a>\n  </div>\n  <table class='demand-report-table active-report-table'>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 24\">\n        {{ time | date : 'HH:mm' }}\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.sumSeries.data | limitTo : 24 track by $index\">\n        <span ng-hide='power.y === 0'>{{ power.y }}</span>\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 24 : 24\">\n        {{ time | date : 'HH:mm' }}\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.sumSeries.data | limitTo : 24 : 24 track by $index\">\n        <span ng-hide='power.y === 0'>{{ power.y }}</span>\n      </td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WeeklyGroupReportController = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _weekly_group_report = __webpack_require__(816);

var _weekly_group_report2 = _interopRequireDefault(_weekly_group_report);

var _daily_group_active_power = __webpack_require__(492);

var _daily_group_active_power2 = _interopRequireDefault(_daily_group_active_power);

var _chart = __webpack_require__(70);

var _chart2 = _interopRequireDefault(_chart);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

var _math_util = __webpack_require__(88);

var _math_util2 = _interopRequireDefault(_math_util);

var _group_report_util = __webpack_require__(219);

var _group_report_util2 = _interopRequireDefault(_group_report_util);

var _weekly_group_report3 = __webpack_require__(817);

var _weekly_group_report4 = _interopRequireDefault(_weekly_group_report3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var WeeklyGroupReportController = exports.WeeklyGroupReportController = function () {
  /*@ngInject*/
  WeeklyGroupReportController.$inject = ["$state", "$stateParams", "$filter", "moment", "DateUtil", "DailyGroupActivePowerService", "CsvUtil", "GroupReportUtil", "MathUtil"];
  function WeeklyGroupReportController($state, $stateParams, $filter, moment, DateUtil, DailyGroupActivePowerService, CsvUtil, GroupReportUtil, MathUtil) {
    _classCallCheck(this, WeeklyGroupReportController);

    this.id = $stateParams.id;
    this.$filter = $filter;
    this.$state = $state;
    this.DailyGroupActivePowerService = DailyGroupActivePowerService;
    this.moment = moment;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;
    this.MathUtil = MathUtil;
    this.GroupReportUtil = GroupReportUtil;

    this.targetDate = this.moment().startOf('week');
    this.startDate = this.targetDate.clone().toDate();
    this.endDate = this.targetDate.clone().add(6, 'days').toDate();
    this.maxDate = this.targetDate.clone().toDate();
    this.downloadFileName = 'active_power.csv';

    this.Week = ['日', '月', '火', '水', '木', '金', '土'];

    this.chartConfig = (0, _weekly_group_report4.default)(this);
  }

  _createClass(WeeklyGroupReportController, [{
    key: '$onInit',
    value: function $onInit() {
      this.updateGraph();
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph() {
      var _this = this;

      this.categories = [];
      for (var i = 0; i < 7; i++) {
        var utc = this.DateUtil.localToUTC(this.startDate);
        this.categories.push(this.DateUtil.leapDate(utc, i).valueOf());
      }

      this.DailyGroupActivePowerService.show(_angular2.default.extend({ id: this.id }, this.DateUtil.getDateRangeQueries(this.startDate, this.endDate)), function (response) {
        var _formatGroupActivePow = _this.formatGroupActivePower(response.powers);

        var _formatGroupActivePow2 = _slicedToArray(_formatGroupActivePow, 2);

        _this.seriesList = _formatGroupActivePow2[0];
        _this.sumSeriesList = _formatGroupActivePow2[1];

        _this.chartConfig.xAxis.categories = _this.categories;

        if (_this.isOverStackLimit) {
          _this.chartConfig.series = _this.sumSeriesList;
        } else {
          _this.chartConfig.series = _this.seriesList;
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _this.chartConfig.series[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var series = _step.value;

            series.events = {
              click: function click(event) {
                _this.$state.go('main.group_report_show.detail', { id: _this.id, term: 'daily', target: event.point.date }, { reload: true });
              }
            };
            series.cursor = 'pointer';
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this.sumSeries = _this.sumSeriesList[0];
        _this.csvData = _this.CsvUtil.processDailyGroupActivePower(_this.seriesList, _this.categories);
        _this.downloadFileName = _this.moment(_this.startDate).format('[group_active_power_]YYYY-MM-DD[_week.csv]');
      });
    }
  }, {
    key: 'formatGroupActivePower',
    value: function formatGroupActivePower(groupActivePowers) {
      if (groupActivePowers.length < 1) {
        return [[], []];
      }

      var STACK_LIMIT = 10;
      this.isOverStackLimit = false;

      var firstMeasuredAt = this.moment(groupActivePowers[0].date);
      var beginningDate = this.targetDate;
      var shiftRange = firstMeasuredAt.diff(beginningDate, 'days');

      var seriesList = this.GroupReportUtil.createSeriesList(groupActivePowers, shiftRange);

      if (seriesList.length > STACK_LIMIT) {
        this.isOverStackLimit = true;
      }

      var _GroupReportUtil$crea = this.GroupReportUtil.createStackSeries(seriesList, groupActivePowers, shiftRange),
          _GroupReportUtil$crea2 = _slicedToArray(_GroupReportUtil$crea, 2),
          stackSeriesList = _GroupReportUtil$crea2[0],
          sumSeriesList = _GroupReportUtil$crea2[1];

      return [stackSeriesList, sumSeriesList];
    }
  }, {
    key: 'changeDate',
    value: function changeDate(diff) {
      this.targetDate.add(diff, 'days');
      this.startDate = this.DateUtil.leapDate(this.startDate, diff);
      this.endDate = this.DateUtil.leapDate(this.startDate, 6);

      this.updateGraph(this.startDate, this.endDate);
    }
  }, {
    key: 'getWeek',
    value: function getWeek(timeValue) {
      return this.Week[new Date(timeValue).getDay()];
    }
  }]);

  return WeeklyGroupReportController;
}();

exports.default = _angular2.default.module('leptonApp.weeklyGroupReport', [_angularjs2.default, _angularMoment2.default, _date_util2.default, _daily_group_active_power2.default, _csv2.default, _group_report_util2.default, _math_util2.default]).config(_weekly_group_report2.default).component('weeklyGroupReport', {
  require: { parentComponent: '^groupReportShow' },
  template: __webpack_require__(818),
  controller: WeeklyGroupReportController
}).name;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.weekly_group_report', {
        template: '<weekly-group-report></weekly-group-report>'
    });
}

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  var Week = ['日', '月', '火', '水', '木', '金', '土'];

  var chartConfig = {
    chart: {
      type: 'column',
      height: 400,
      events: {
        load: function load() {
          scope.chart = this.chart;
        }
      }
    },
    title: { text: '1週間の電力消費実績' },
    legend: { enabled: false },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        format: '{value:%m月%d日}',
        formatter: function formatter() {
          var week = Week[new Date(this.value).getDay()];
          return scope.$filter('date')(this.value, 'MM月dd日') + ' (' + week + ')';
        }
      },
      max: 6
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力量 [kWh]'
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      formatter: function formatter() {
        var sum = 0;
        var pointsFormat = '';
        var week = Week[new Date(this.x).getDay()];

        if (scope.isOverStackLimit) {
          sum = this.points[0].y;
        } else {
          angular.forEach(this.points, function (point, i) {
            pointsFormat += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 13px;\"> ";
            pointsFormat += point.y + " kWh";
            pointsFormat += '<br/><span style="font-size: 10px;">' + subString(point.series.options.location, 23) + '</span>';
            pointsFormat += "</span>";
            sum = scope.MathUtil.add(sum, point.y);
          });
        }

        var headerFormat = '<tspan style="font-size: 12px">' + scope.moment(this.x).format('MM月DD日') + '  (' + week + ")</tspan> <tspan style=\"font-size: 13px\">\u5408\u8A08: " + sum + ' kWh</tspan>';

        return headerFormat + pointsFormat;
      }
    },
    plotOptions: {
      column: {
        grouping: false,
        stacking: 'normal'
      }
    }
  };
  return chartConfig;

  function subString(str) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

    if (str.length <= 20) {
      return str;
    }
    return str.substr(0, limit) + '...';
  }
}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: -25px 0 5px 7px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <md-button ng-click=\"$ctrl.changeDate(-7)\" class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-left\"></i>\n    </md-button>\n    <span>{{$ctrl.startDate | date : 'MM月dd日'}} ~ {{$ctrl.endDate | date : 'MM月dd日'}}</span>\n    <md-button ng-disabled=\"$ctrl.startDate.valueOf() === $ctrl.maxDate.valueOf()\" ng-click=\"$ctrl.changeDate(7)\"\n               class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-right\"></i>\n    </md-button>\n  </div>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n</md-content>\n\n<div class='demand-report-table-content'>\n  <div>\n    <span class=\"report-table-unit\">合計値 (単位: kWh)</span>\n    <a csv-downloader filename=\"$ctrl.downloadFileName\" csv-data=\"$ctrl.csvData\"\n       style=\"color: inherit;text-decoration: none;\">\n      <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\"></i> csvダウンロード\n      </md-button>\n    </a>\n  </div>\n  <table class='demand-report-table active-report-table'>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 24\">\n        {{ time | date : 'MM月dd日' }} ({{ $ctrl.getWeek(time) }})\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.sumSeries.data | limitTo : 24 track by $index\">\n        <span ng-hide='power.y === 0'>{{ power.y }}</span>\n      </td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MonthlyGroupReportController = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _monthly_group_report = __webpack_require__(820);

var _monthly_group_report2 = _interopRequireDefault(_monthly_group_report);

var _group_active_power = __webpack_require__(491);

var _group_active_power2 = _interopRequireDefault(_group_active_power);

var _daily_group_active_power = __webpack_require__(492);

var _daily_group_active_power2 = _interopRequireDefault(_daily_group_active_power);

var _chart = __webpack_require__(70);

var _chart2 = _interopRequireDefault(_chart);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

var _math_util = __webpack_require__(88);

var _math_util2 = _interopRequireDefault(_math_util);

var _group_report_util = __webpack_require__(219);

var _group_report_util2 = _interopRequireDefault(_group_report_util);

var _monthly_group_report3 = __webpack_require__(821);

var _monthly_group_report4 = _interopRequireDefault(_monthly_group_report3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var MonthlyGroupReportController = exports.MonthlyGroupReportController = function () {
  /*@ngInject*/
  MonthlyGroupReportController.$inject = ["$state", "$stateParams", "$filter", "moment", "DateUtil", "DailyGroupActivePowerService", "CsvUtil", "GroupReportUtil", "MathUtil"];
  function MonthlyGroupReportController($state, $stateParams, $filter, moment, DateUtil, DailyGroupActivePowerService, CsvUtil, GroupReportUtil, MathUtil) {
    _classCallCheck(this, MonthlyGroupReportController);

    this.id = $stateParams.id;
    this.$filter = $filter;
    this.$state = $state;
    this.DailyGroupActivePowerService = DailyGroupActivePowerService;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;
    this.MathUtil = MathUtil;
    this.GroupReportUtil = GroupReportUtil;
    this.moment = moment;

    this.today = this.moment();
    this.targetDate = this.moment($stateParams.target || this.today);
    this.maxDate = this.today.toDate();

    this.downloadFileName = 'active_power.csv';

    this.categories = [];
    this.chartConfig = (0, _monthly_group_report4.default)(this);
  }

  _createClass(MonthlyGroupReportController, [{
    key: '$onInit',
    value: function $onInit() {
      this.updateGraph(this.targetDate);
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(targetDate) {
      var _this = this;

      this.startDate = targetDate.clone().startOf('month');
      this.endDate = targetDate.clone().endOf('month');

      var numberOfDays = this.endDate.diff(this.startDate, 'days');
      var startUtc = this.startDate.clone().add(9, 'hours');

      this.categories = [];
      for (var i = 0; i <= numberOfDays; i++) {
        this.categories.push(startUtc.valueOf());
        startUtc.add(1, 'days');
      }

      this.DailyGroupActivePowerService.show(_angular2.default.extend({ id: this.id }, this.DateUtil.getDateRangeQueries(this.startDate.toDate(), this.endDate.toDate())), function (response) {
        var _formatGroupActivePow = _this.formatGroupActivePower(response.powers);

        var _formatGroupActivePow2 = _slicedToArray(_formatGroupActivePow, 2);

        _this.seriesList = _formatGroupActivePow2[0];
        _this.sumSeriesList = _formatGroupActivePow2[1];

        _this.chartConfig.xAxis.categories = _this.categories;
        _this.chartConfig.xAxis.max = numberOfDays;

        if (_this.isOverStackLimit) {
          _this.chartConfig.series = _this.sumSeriesList;
        } else {
          _this.chartConfig.series = _this.seriesList;
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _this.chartConfig.series[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var series = _step.value;

            series.events = {
              click: function click(event) {
                _this.$state.go('main.group_report_show.detail', { id: _this.id, term: 'daily', target: event.point.date }, { reload: true });
              }
            };
            series.cursor = 'pointer';
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this.sumSeries = _this.sumSeriesList[0];
        _this.csvData = _this.CsvUtil.processDailyGroupActivePower(_this.seriesList, _this.categories);
        _this.downloadFileName = _this.startDate.format('[group_active_power_]YYYY-MM[.csv]');
      });
    }
  }, {
    key: 'formatGroupActivePower',
    value: function formatGroupActivePower(groupActivePowers) {
      if (groupActivePowers.length < 1) {
        return [[], []];
      }

      var STACK_LIMIT = 10;
      this.isOverStackLimit = false;

      var firstMeasuredAt = this.moment(groupActivePowers[0].date);
      var beginningDate = this.targetDate.startOf('month');
      var shiftRange = firstMeasuredAt.diff(beginningDate, 'days');

      var seriesList = this.GroupReportUtil.createSeriesList(groupActivePowers, shiftRange);

      if (seriesList.length > STACK_LIMIT) {
        this.isOverStackLimit = true;
      }

      var _GroupReportUtil$crea = this.GroupReportUtil.createStackSeries(seriesList, groupActivePowers, shiftRange),
          _GroupReportUtil$crea2 = _slicedToArray(_GroupReportUtil$crea, 2),
          stackSeriesList = _GroupReportUtil$crea2[0],
          sumSeriesList = _GroupReportUtil$crea2[1];

      return [stackSeriesList, sumSeriesList];
    }
  }, {
    key: 'changeMonth',
    value: function changeMonth(diff) {
      this.targetDate = this.targetDate.add(diff, 'months');

      this.updateGraph(this.targetDate);
    }
  }]);

  return MonthlyGroupReportController;
}();

exports.default = _angular2.default.module('leptonApp.monthlyGroupReport', [_angularjs2.default, _angularMoment2.default, _date_util2.default, _daily_group_active_power2.default, _csv2.default, _group_report_util2.default, _math_util2.default]).config(_monthly_group_report2.default).component('monthlyGroupReport', {
  require: { parentComponent: '^groupReportShow' },
  template: __webpack_require__(822),
  controller: MonthlyGroupReportController
}).name;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.monthly_group_report', {
        template: '<monthly-group-report></monthly-group-report>'
    });
}

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
    'ngInject';

    var chartConfig = {
        chart: {
            type: 'column',
            height: 400,
            events: {
                load: function load() {
                    scope.chart = this.chart;
                }
            }
        },
        title: { text: '１ヶ月間の電力消費実績' },
        legend: { enabled: false },
        xAxis: {
            categories: scope.categories,
            crosshair: true,
            labels: {
                format: '{value:%m月%d日}'
            }
        },
        yAxis: {
            labels: {
                format: '{value}'
            },
            title: {
                text: '電力量 [kWh]'
            }
        },
        tooltip: {
            enabled: true,
            shared: true,
            formatter: function formatter() {
                var sum = 0;
                var pointsFormat = '';

                if (scope.isOverStackLimit) {
                    sum = this.points[0].y;
                } else {
                    angular.forEach(this.points, function (point, i) {
                        pointsFormat += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 13px;\"> ";
                        pointsFormat += point.y + " kWh";
                        pointsFormat += '<br/><span style="font-size: 10px;">' + subString(point.series.options.location, 23) + '</span>';
                        pointsFormat += "</span>";
                        sum = scope.MathUtil.add(sum, point.y);
                    });
                }

                var headerFormat = '<tspan style="font-size: 12px">' + scope.moment(this.x).format('MM月DD日') + "</tspan> <tspan style=\"font-size: 13px\">\u5408\u8A08: " + sum + ' kWh</tspan>';

                return headerFormat + pointsFormat;
            }
        },
        plotOptions: {
            column: {
                grouping: false,
                stacking: 'normal'
            }
        }
    };
    return chartConfig;

    function subString(str) {
        var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

        if (str.length <= 20) {
            return str;
        }
        return str.substr(0, limit) + '...';
    }
}

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: -25px 0 5px 7px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <md-button ng-click=\"$ctrl.changeMonth(-1)\" class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-left\"></i>\n    </md-button>\n    <span>{{$ctrl.startDate | amDateFormat : 'YYYY年MM月DD日'}} ~ {{$ctrl.endDate | amDateFormat : 'YYYY年MM月DD日'}}</span>\n    <md-button ng-disabled=\"$ctrl.endDate.valueOf() >= $ctrl.maxDate.valueOf()\" ng-click=\"$ctrl.changeMonth(1)\"\n               class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-right\"></i>\n    </md-button>\n  </div>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n</md-content>\n\n<div class='demand-report-table-content'>\n  <div>\n    <span class=\"report-table-unit\">合計値 (単位: kWh)</span>\n    <a csv-downloader filename=\"$ctrl.downloadFileName\" csv-data=\"$ctrl.csvData\"\n       style=\"color: inherit;text-decoration: none;\">\n      <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\"></i> csvダウンロード\n      </md-button>\n    </a>\n  </div>\n  <table class='demand-report-table active-report-table'>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 16\">\n        {{ time | date : 'M/d' }}\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.sumSeries.data | limitTo : 16 track by $index\">\n        <span ng-hide='power.y === 0'>{{ power.y }}</span>\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 16 : 16\">\n        {{ time | date : 'M/d' }}\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.sumSeries.data | limitTo : 16 : 16 track by $index\">\n        <span ng-hide='power.y === 0'>{{ power.y }}</span>\n      </td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YearlyGroupReportController = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _yearly_group_report = __webpack_require__(824);

var _yearly_group_report2 = _interopRequireDefault(_yearly_group_report);

var _monthly_group_active_power = __webpack_require__(555);

var _monthly_group_active_power2 = _interopRequireDefault(_monthly_group_active_power);

var _chart = __webpack_require__(70);

var _chart2 = _interopRequireDefault(_chart);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

var _math_util = __webpack_require__(88);

var _math_util2 = _interopRequireDefault(_math_util);

var _group_report_util = __webpack_require__(219);

var _group_report_util2 = _interopRequireDefault(_group_report_util);

var _yearly_group_report3 = __webpack_require__(825);

var _yearly_group_report4 = _interopRequireDefault(_yearly_group_report3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var YearlyGroupReportController = exports.YearlyGroupReportController = function () {
  /*@ngInject*/
  YearlyGroupReportController.$inject = ["$state", "$stateParams", "$filter", "moment", "DateUtil", "MonthlyGroupActivePowerService", "CsvUtil", "GroupReportUtil", "MathUtil"];
  function YearlyGroupReportController($state, $stateParams, $filter, moment, DateUtil, MonthlyGroupActivePowerService, CsvUtil, GroupReportUtil, MathUtil) {
    _classCallCheck(this, YearlyGroupReportController);

    this.id = $stateParams.id;
    this.$filter = $filter;
    this.$state = $state;
    this.MonthlyGroupActivePowerService = MonthlyGroupActivePowerService;
    this.moment = moment;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;
    this.MathUtil = MathUtil;
    this.GroupReportUtil = GroupReportUtil;

    this.downloadFileName = 'active_power.csv';

    this.chartConfig = (0, _yearly_group_report4.default)(this);
  }

  _createClass(YearlyGroupReportController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.MonthlyGroupActivePowerService.show({ id: this.id }, function (response) {
        var powers = response.powers;
        var lastDate = powers.length > 0 ? _this.moment(powers[powers.length - 1].date).subtract(1, 'days') : _this.moment();
        lastDate.startOf('month');

        _this.startDate = lastDate.clone().subtract(12, 'month');
        _this.endDate = lastDate.clone();

        _this.categories = [];
        var start = lastDate.clone().add(lastDate.utcOffset(), 'minutes').utc().subtract(12, 'month');

        for (var i = 0; i < 13; i++) {
          _this.categories.push(start.valueOf());
          start.add(1, 'month');
        }

        _this.chartConfig.xAxis.categories = _this.categories;
        _this.chartConfig.xAxis.max = 12;

        var _formatGroupActivePow = _this.formatGroupActivePower(powers);

        var _formatGroupActivePow2 = _slicedToArray(_formatGroupActivePow, 2);

        _this.seriesList = _formatGroupActivePow2[0];
        _this.sumSeriesList = _formatGroupActivePow2[1];

        if (_this.isOverStackLimit) {
          _this.chartConfig.series = _this.sumSeriesList;
        } else {
          _this.chartConfig.series = _this.seriesList;
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _this.chartConfig.series[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var series = _step.value;

            series.events = {
              click: function click(event) {
                _this.$state.go('main.group_report_show.detail', { id: _this.id, term: 'monthly', target: event.point.date }, { reload: true });
              }
            };
            series.cursor = 'pointer';
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this.sumSeries = _this.sumSeriesList[0];
        _this.csvData = _this.CsvUtil.processDailyGroupActivePower(_this.seriesList, _this.categories);
        _this.downloadFileName = 'group_active_power_' + _this.startDate.format('YYYY-MM') + '_' + _this.endDate.format('YYYY-MM') + '.csv';
      });
    }
  }, {
    key: 'formatGroupActivePower',
    value: function formatGroupActivePower(groupActivePowers) {
      if (groupActivePowers.length < 1) {
        return [[], []];
      }

      var STACK_LIMIT = 10;
      this.isOverStackLimit = false;

      var firstMeasuredAt = this.moment(groupActivePowers[0].date).subtract(1, 'days').add(this.moment().utcOffset(), 'minutes');
      var beginningDate = this.moment(this.categories[0]);
      var shiftRange = firstMeasuredAt.diff(beginningDate, 'months');

      var seriesList = this.GroupReportUtil.createSeriesList(groupActivePowers, shiftRange);

      if (seriesList.length > STACK_LIMIT) {
        this.isOverStackLimit = true;
      }

      var _GroupReportUtil$crea = this.GroupReportUtil.createStackSeries(seriesList, groupActivePowers, shiftRange),
          _GroupReportUtil$crea2 = _slicedToArray(_GroupReportUtil$crea, 2),
          stackSeriesList = _GroupReportUtil$crea2[0],
          sumSeriesList = _GroupReportUtil$crea2[1];

      return [stackSeriesList, sumSeriesList];
    }
  }]);

  return YearlyGroupReportController;
}();

exports.default = _angular2.default.module('leptonApp.yearlyGroupReport', [_angularjs2.default, _angularMoment2.default, _date_util2.default, _monthly_group_active_power2.default, _csv2.default, _group_report_util2.default, _math_util2.default]).config(_yearly_group_report2.default).component('yearlyGroupReport', {
  require: { parentComponent: '^groupReportShow' },
  template: __webpack_require__(826),
  controller: YearlyGroupReportController
}).name;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.yearly_group_report', {
        template: '<yearly-group-report></yearly-group-report>'
    });
};

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
    'ngInject';

    var chartConfig = {
        chart: {
            type: 'column',
            height: 400,
            events: {
                load: function load() {
                    scope.chart = this.chart;
                }
            }
        },

        title: { text: '1年間の消費実績' },
        legend: { enabled: false },
        xAxis: {
            categories: scope.categories,
            crosshair: true,
            labels: {
                format: '{value:%m月}'
            }
        },
        yAxis: {
            labels: {
                format: '{value}'
            },
            title: {
                text: '電力量 [kWh]'
            }
        },
        tooltip: {
            enabled: true,
            shared: true,
            formatter: function formatter() {
                var sum = 0;
                var pointsFormat = '';

                if (scope.isOverStackLimit) {
                    sum = this.points[0].y;
                } else {
                    angular.forEach(this.points, function (point, i) {
                        pointsFormat += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 13px;\"> ";
                        pointsFormat += point.y + " kWh";
                        pointsFormat += '<br/><span style="font-size: 10px;">' + subString(point.series.options.location, 23) + '</span>';
                        pointsFormat += "</span>";
                        sum = scope.MathUtil.add(sum, point.y);
                    });
                }

                var headerFormat = '<tspan style="font-size: 12px">' + scope.moment(this.x).format('MM月') + "</tspan> <tspan style=\"font-size: 13px\">\u5408\u8A08: " + sum + ' kWh</tspan>';

                return headerFormat + pointsFormat;
            }
        },
        plotOptions: {
            column: {
                grouping: false,
                stacking: 'normal'
            }
        }
    };
    return chartConfig;

    function subString(str) {
        var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

        if (str.length <= 20) {
            return str;
        }
        return str.substr(0, limit) + '...';
    }
}

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: -25px 0 5px 15px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <span>{{$ctrl.startDate | amDateFormat : 'YYYY年MM月'}} ~ {{$ctrl.endDate | amDateFormat : 'YYYY年MM月'}}</span>\n  </div>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n</md-content>\n\n<div class='demand-report-table-content'>\n  <div>\n    <span class=\"report-table-unit\">合計値 (単位: kWh)</span>\n    <a csv-downloader filename=\"$ctrl.downloadFileName\" csv-data=\"$ctrl.csvData\"\n       style=\"color: inherit;text-decoration: none;\">\n      <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\"></i> csvダウンロード\n      </md-button>\n    </a>\n  </div>\n  <table class='demand-report-table active-report-table'>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories\">\n        {{ time | date : 'MM月' }}\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"power in $ctrl.sumSeries.data track by $index\">\n        <span ng-hide='power.y === 0'>{{ power.y }}</span>\n      </td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DailyPriceReportController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _daily_price_report = __webpack_require__(828);

var _daily_price_report2 = _interopRequireDefault(_daily_price_report);

var _active_power = __webpack_require__(144);

var _active_power2 = _interopRequireDefault(_active_power);

var _weather = __webpack_require__(130);

var _weather2 = _interopRequireDefault(_weather);

var _compare_weather = __webpack_require__(128);

var _compare_weather2 = _interopRequireDefault(_compare_weather);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _math_util = __webpack_require__(88);

var _math_util2 = _interopRequireDefault(_math_util);

var _daily_price_report3 = __webpack_require__(829);

var _daily_price_report4 = _interopRequireDefault(_daily_price_report3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DailyPriceReportController = exports.DailyPriceReportController = function () {
  /*@ngInject*/
  DailyPriceReportController.$inject = ["$stateParams", "moment", "$interval", "$filter", "$q", "ActivePowerService", "DateUtil", "MathUtil", "WeatherService", "CompareWeatherLogic"];
  function DailyPriceReportController($stateParams, moment, $interval, $filter, $q, ActivePowerService, DateUtil, MathUtil, WeatherService, CompareWeatherLogic) {
    _classCallCheck(this, DailyPriceReportController);

    this.ActivePowerService = ActivePowerService;
    this.WeatherService = WeatherService;
    this.CompareWeatherLogic = CompareWeatherLogic;
    this.DateUtil = DateUtil;
    this.MathUtil = MathUtil;
    this.interval = $interval;
    this.filter = $filter;
    this.$q = $q;
    var self = this;
    this.moment = moment;

    this.categories = DateUtil.getXLabels;
    this.id = $stateParams.id;
    this.targetDate = this.moment().startOf('day').toDate();
    this.minDate = this.moment().startOf('day').subtract(7, 'days').toDate();
    this.maxDate = this.targetDate;
    this.missingTimes = [];
    this.noCalculateTimes = [];

    this.downloadFileName = 'active_power.csv';

    this.chartConfig = (0, _daily_price_report4.default)(this);
  }

  _createClass(DailyPriceReportController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.parentComponent.saConfigPromise.then(function (config) {
        _this.baseUnitPrice = config.base_unit_price;
        _this.powerUnitPrice = config.power_unit_price;
        _this.contractPower = config.contract_power;

        _this.updateGraph(_this.targetDate);
      });

      this.timer = this.interval(function () {
        _this.updateGraph(_this.targetDate);
      }, 300000);
    }
  }, {
    key: 'changeDate',
    value: function changeDate(diff) {
      if (diff !== undefined) {
        this.targetDate = this.DateUtil.leapDate(this.targetDate, diff);
      }

      this.updateGraph(this.targetDate);
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(targetDate) {
      var _this2 = this;

      var powerQuery = _angular2.default.extend({ id: this.id }, this.DateUtil.getActivePowerQueries(targetDate));
      var weatherQuery = _angular2.default.extend({ sa_config_id: this.id }, this.DateUtil.getQueryParams(targetDate));

      this.$q.all([this.ActivePowerService.show(powerQuery).$promise, this.WeatherService.api.index(weatherQuery).$promise]).then(function (responses) {
        _this2.powerPrices = _this2.formatToPrices(responses[0].powers);

        if (!_this2.chart) {
          return;
        }

        _this2.weathers = _this2.formatWeather(responses[1]);
        _this2.series.setData(_this2.powerPrices);
        _this2.chart.reflow();
      });

      this.ActivePowerService.show(_angular2.default.extend({ id: this.id }, this.DateUtil.getActivePowerQueries(targetDate)), function (response) {
        _this2.powerPrices = _this2.formatToPrices(response.powers);

        if (_this2.chart) {
          _this2.series.setData(_this2.powerPrices);
          _this2.chart.reflow();
        }
      });
    }
  }, {
    key: 'formatToPrices',
    value: function formatToPrices(activePowers) {
      var _this3 = this;

      this.missingTimes = [];
      this.noCalculateTimes = [];
      var sumPower = 0;

      if (activePowers.length === 0) {
        return [];
      }

      var firstMeasuredAt = this.moment(activePowers[0].measured_at);
      var beginningTime = this.moment(this.targetDate).startOf('day');
      var shift_range = firstMeasuredAt.diff(beginningTime, 'minutes') / 30;

      var formated_powers = [];

      activePowers.forEach(function (activePower, index) {
        if (!activePowers[index - 1]) {
          return;
        }

        if (activePower.missing) {
          _this3.missingTimes.push(_this3.categories[index + shift_range - 1]);
          formated_powers.push(0);
        } else if (activePowers[index - 1].missing) {
          _this3.noCalculateTimes.push(_this3.categories[index + shift_range - 1]);
          formated_powers.push(0);
        } else {
          var power = _this3.MathUtil.subtract(activePowers[index].value, activePowers[index - 1].value);
          sumPower += power;
          formated_powers.push(_this3.calcPowerPrice(power));
        }
      });

      for (var i = 0; i < shift_range; i++) {
        formated_powers.unshift(null);
      }

      this.powerPrice = this.calcPowerPrice(sumPower);
      this.basePrice = this.calcBasePrice();

      return formated_powers;
    }
  }, {
    key: 'isMissingTime',
    value: function isMissingTime(time) {
      return this.missingTimes.indexOf(time) !== -1;
    }
  }, {
    key: 'isNoCalculateTime',
    value: function isNoCalculateTime(time) {
      return this.noCalculateTimes.indexOf(time) !== -1;
    }
  }, {
    key: 'calcPowerPrice',
    value: function calcPowerPrice(power) {
      return this.powerUnitPrice * power;
    }
  }, {
    key: 'calcBasePrice',
    value: function calcBasePrice() {
      return this.contractPower * this.baseUnitPrice;
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      if (this.timer) {
        this.interval.cancel(this.timer);
      }
    }
  }, {
    key: 'formatWeather',
    value: function formatWeather(weathers) {
      var weatherSamplingInterval = ['03:00', '09:00', '15:00', '21:00'];

      var formattedWeathers = this.CompareWeatherLogic.compareHourly(weathers, weatherSamplingInterval);
      var y = formattedWeathers.length > 0 ? 46 : null;

      this.chart.xAxis[0].update({
        labels: { y: y }
      }, false);

      this.chart.reflow();

      return formattedWeathers;
    }
  }]);

  return DailyPriceReportController;
}();

exports.default = _angular2.default.module('leptonApp.dailyPriceReport', [_angularjs2.default, _angularMoment2.default, _date_util2.default, _math_util2.default, _active_power2.default, _weather2.default, _compare_weather2.default]).config(_daily_price_report2.default).component('dailyPriceReport', {
  require: { parentComponent: '^demandReportShow' },
  template: __webpack_require__(830),
  controller: DailyPriceReportController
}).name;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.daily_price_report', {
        template: '<daily-price-report></daily-price-report>'
    });
};

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  var chartConfig = {
    chart: {
      type: 'column',
      height: 300,
      events: {
        load: function load() {
          scope.series = this.series[0];
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: { text: '時間毎の電力量料金' },
    legend: { enabled: false },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      max: scope.categories.length - 1
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力量料金 [円]'
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + this.x + "</tspan>";

        angular.forEach(this.points, function (point, i) {
          tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
          if (scope.isMissingTime(point.x)) {
            tip_format += "データ無し";
          } else if (scope.isNoCalculateTime(point.x)) {
            tip_format += "差分計算不可";
          } else {
            tip_format += scope.filter('decimalFilter')(point.y, 1) + " 円";
          }
          tip_format += "</span>";
        });

        return tip_format;
      }
    },
    series: [{
      name: '電力量料金',
      color: '#FFC107'
    }],
    plotOptions: { column: { grouping: false } }
  };
  return chartConfig;
}

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports = "<div layout=\"row\" style=\"margin: -25px 0 5px 15px;\">\n  <div class=\"date-component\">\n      <span>{{ $ctrl.targetDate | date : 'yyyy年MM月dd日' }}</span>\n    </div>\n  </div>\n</div>\n<md-content layout=\"row\" style=\"margin: 0 15px\">\n  <div class=\"price-report-chart\">\n    <chart value=\"$ctrl.chartConfig\" style=\"margin-right: 5px\"></chart>\n    <div class=\"hourly-weather-content active-weather-content\" ng-if=\"$ctrl.weathers.length > 0\">\n      <div class=\"weather-item\" ng-repeat=\"weather in $ctrl.weathers track by $index\">\n        <weather-directive weather=\"weather\" icon-size=\"'middle'\" simple=\"true\"></weather-directive>\n      </div>\n    </div>\n  </div>\n  <div class=\"price-report-sa-info\" style=\"margin-top: 0\">\n    <div class=\"price-report-sa-info-body\">\n      <table border=\"0\">\n        <tr>\n          <td>基本料金単価</td>\n          <td>{{ $ctrl.baseUnitPrice | number }} 円</td>\n        </tr>\n        <tr>\n          <td>電力量単価</td>\n          <td>{{ $ctrl.powerUnitPrice | number }} 円</td>\n        </tr>\n        <tr>\n          <td></td>\n          <td><span class=\"span-link\" ui-sref=\"main.device_config_edit({id:{{$ctrl.id}}})\">単価を編集</span></td>\n        </tr>\n        <tr>\n          <td>&nbsp;</td>\n        </tr>\n        <tr style=\"font-weight: bold\">\n          <td>月の基本料金</td>\n          <td>{{ $ctrl.basePrice | number }} 円</td>\n        </tr>\n        <tr style=\"font-weight: bold\">\n          <td>{{ $ctrl.targetDate | date : 'M/d' }} の電力量料金</td>\n          <td>{{ $ctrl.powerPrice | number }} 円</td>\n        </tr>\n      </table>\n    </div>\n    <div class=\"price-report-note\">\n      <span>※ 電気料金 = (契約電力(kW) × 基本料金単価) + (電気使用量(kWh) × 電力量単価)</span><br>\n      <span>※ 電気料金は概算値です。実際の請求額には力率や燃料費調整額などが考慮されます。</span>\n    </div>\n  </div>\n</md-content>\n\n<div class='demand-report-table-content'>\n  <div class=\"price-report-unit\">\n    <span class=\"report-table-unit\">(単位: 円)</span>\n  </div>\n  <table class='demand-report-table price-report-table'>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 24\">\n        {{ time | date : 'HH:mm' }}\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"price in $ctrl.powerPrices | limitTo : 24 track by $index\">\n        <span ng-hide='price === 0'>{{ price | decimalFilter:1 }}</span>\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 24 : 24\">\n        {{ time | date : 'HH:mm' }}\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"price in $ctrl.powerPrices | limitTo : 24 : 24 track by $index\">\n        <span ng-hide='price === 0'>{{ price | decimalFilter:1 }}</span>\n      </td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MonthlyPriceReportController = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _monthly_price_report = __webpack_require__(832);

var _monthly_price_report2 = _interopRequireDefault(_monthly_price_report);

var _daily_active_power = __webpack_require__(191);

var _daily_active_power2 = _interopRequireDefault(_daily_active_power);

var _daily_weather = __webpack_require__(192);

var _daily_weather2 = _interopRequireDefault(_daily_weather);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _math_util = __webpack_require__(88);

var _math_util2 = _interopRequireDefault(_math_util);

var _compare_weather = __webpack_require__(128);

var _compare_weather2 = _interopRequireDefault(_compare_weather);

var _monthly_price_report3 = __webpack_require__(833);

var _monthly_price_report4 = _interopRequireDefault(_monthly_price_report3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var MonthlyPriceReportController = exports.MonthlyPriceReportController = function () {
  /*@ngInject*/
  MonthlyPriceReportController.$inject = ["$stateParams", "moment", "$interval", "$filter", "$q", "DailyActivePowerService", "DateUtil", "MathUtil", "DailyWeatherService", "CompareWeatherLogic"];
  function MonthlyPriceReportController($stateParams, moment, $interval, $filter, $q, DailyActivePowerService, DateUtil, MathUtil, DailyWeatherService, CompareWeatherLogic) {
    _classCallCheck(this, MonthlyPriceReportController);

    this.id = $stateParams.id;
    this.filter = $filter;
    this.$q = $q;
    this.DailyActivePowerService = DailyActivePowerService;
    this.DailyWeatherService = DailyWeatherService;
    this.CompareWeatherLogic = CompareWeatherLogic;
    this.DateUtil = DateUtil;
    this.MathUtil = MathUtil;
    this.moment = moment;

    this.targetDate = this.moment().startOf('day').toDate();
    this.minDate = this.moment().subtract(1, 'month').toDate();
    this.maxDate = this.moment().startOf('day').toDate();

    this.categories = [];
    this.chartConfig = (0, _monthly_price_report4.default)(this);
  }

  _createClass(MonthlyPriceReportController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.parentComponent.saConfigPromise.then(function (config) {
        _this.billingDay = config.billing_date;
        _this.baseUnitPrice = config.base_unit_price;
        _this.powerUnitPrice = config.power_unit_price;
        _this.contractPower = config.contract_power;

        _this.updateGraph(_this.targetDate, _this.billingDay);
      });
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(targetDate, billingDate) {
      var _this2 = this;

      var _DateUtil$getBillingD = this.DateUtil.getBillingDateDomain(targetDate, billingDate);

      var _DateUtil$getBillingD2 = _slicedToArray(_DateUtil$getBillingD, 2);

      this.startDate = _DateUtil$getBillingD2[0];
      this.endDate = _DateUtil$getBillingD2[1];

      this.billingDate = this.moment(this.endDate).add(1, 'days').toDate();
      var numberOfDays = (this.endDate - this.startDate) / (24 * 60 * 60 * 1000);

      var startUtc = this.DateUtil.localToUTC(this.startDate);
      this.categories = [];
      for (var i = 0; i <= numberOfDays; i++) {
        this.categories.push(this.DateUtil.leapDate(startUtc, i).valueOf());
      }

      var powerQuery = _angular2.default.extend({ id: this.id }, this.DateUtil.getDateRangeQueries(this.startDate, this.endDate));
      var weatherQuery = _angular2.default.extend({ sa_config_id: this.id }, this.DateUtil.getDateRangeQueries(this.startDate, this.endDate));

      this.$q.all([this.DailyActivePowerService.show(powerQuery).$promise, this.DailyWeatherService.api.index(weatherQuery).$promise]).then(function (responses) {
        var powers = responses[0];
        var weathers = responses[1];

        _this2.prices = _this2.formatToPrices(powers.powers);
        _this2.weathers = _this2.CompareWeatherLogic.compareDaily(weathers, _this2.categories);
        var y = _this2.weathers.length > 0 ? 36 : null;
        _this2.chart.xAxis[0].update({
          categories: _this2.categories,
          max: numberOfDays,
          labels: { y: y }
        }, false);
        _this2.itemWidth = 100 / numberOfDays;

        _this2.chart.series[0].setData(_this2.prices);
        _this2.chart.reflow();
      });

      this.DailyActivePowerService.show(_angular2.default.extend({ id: this.id }, this.DateUtil.getDateRangeQueries(this.startDate, this.endDate)), function (response) {
        _this2.chart.xAxis[0].update({
          categories: _this2.categories,
          max: numberOfDays
        });

        _this2.prices = _this2.formatToPrices(response.powers);
        _this2.chart.series[0].setData(_this2.prices);
        _this2.chart.reflow();
      });
    }
  }, {
    key: 'formatToPrices',
    value: function formatToPrices(dailyActivePowers) {
      var _this3 = this;

      var powersIndex = 0;
      this.sumPrice = 0;
      var sumPower = 0;

      var formattedPrices = this.categories.map(function (category) {
        if (!dailyActivePowers[powersIndex]) {
          return null;
        }

        var power = dailyActivePowers[powersIndex].value;
        var date = dailyActivePowers[powersIndex].date;

        var utc = _this3.DateUtil.jstToUTC(date + 'T00:00:00+09:00');
        if (category === utc) {
          powersIndex++;
          sumPower += power;
          return _this3.calcPowerPrice(power);
        } else {
          return null;
        }
      });

      this.powerPrice = this.calcPowerPrice(sumPower);
      this.basePrice = this.calcBasePrice();
      this.sumPrice = this.calcPriceWithBase(sumPower);

      return formattedPrices;
    }
  }, {
    key: 'calcPowerPrice',
    value: function calcPowerPrice(power) {
      return this.powerUnitPrice * power;
    }
  }, {
    key: 'calcBasePrice',
    value: function calcBasePrice() {
      return this.contractPower * this.baseUnitPrice;
    }
  }, {
    key: 'calcPriceWithBase',
    value: function calcPriceWithBase(power) {
      return this.MathUtil.add(this.calcBasePrice(), this.calcPowerPrice(power));
    }
  }]);

  return MonthlyPriceReportController;
}();

exports.default = _angular2.default.module('leptonApp.monthlyPriceReport', [_angularjs2.default, _angularMoment2.default, _daily_active_power2.default, _date_util2.default, _math_util2.default, _daily_weather2.default, _compare_weather2.default]).config(_monthly_price_report2.default).component('monthlyPriceReport', {
  require: { parentComponent: '^demandReportShow' },
  template: __webpack_require__(834),
  controller: MonthlyPriceReportController
}).name;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.monthly_price_report', {
        template: '<monthly-price-report></monthly-price-report>'
    });
};

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  var chartConfig = {
    chart: {
      type: 'column',
      height: 300,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: { text: '1日毎の電力量料金' },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        formatter: function formatter() {
          var style = '';
          var day = scope.filter('dayFilter')(this.value);
          if (day === '日') {
            style = 'color: #ff3131';
          } else if (day === '土') {
            style = 'color: #3737ff';
          }

          return '<span style="' + style + '">' + scope.filter('date')(this.value, 'M/d') + ' (' + day + ')</span>';
        }
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力量料金 [円]'
      }
    },
    legend: { enabled: false },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + scope.filter('date')(this.x, 'MM月dd日') + "</tspan>";

        var point = this.points[0];
        tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
        tip_format += scope.filter('decimalFilter')(point.y, 1) + " 円";
        tip_format += "</span>";

        return tip_format;
      }
    },
    plotOptions: { column: { grouping: false } },
    series: [{
      name: '電力量料金',
      color: '#FFC107'
    }]
  };

  return chartConfig;
}

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: 5px 0 5px 15px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <span>{{$ctrl.startDate | date : 'yyyy年MM月dd日'}} ~ {{$ctrl.endDate | date : 'yyyy年MM月dd日'}} <span\n            class=\"date-component-minor\">({{$ctrl.billingDate | date : 'yyyy年MM月'}} 請求分)</span></span>\n  </div>\n</div>\n<md-content layout=\"row\" style=\"margin: 0 15px\">\n  <div class=\"price-report-chart\">\n    <chart value=\"$ctrl.chartConfig\" style=\"margin-right: 5px\"></chart>\n    <div class=\"daily-weather-content active-weather-content\" ng-if=\"$ctrl.weathers.length > 0\">\n      <div class=\"daily-weather-item\" ng-style=\"{'width': $ctrl.itemWidth + '%'}\"\n           ng-repeat=\"weather in $ctrl.weathers track by $index\">\n        <weather-directive weather=\"weather\" icon-size=\"'small'\" simple=\"true\"></weather-directive>\n      </div>\n    </div>\n  </div>\n  <div class=\"price-report-sa-info\" style=\"margin-top: 0\">\n    <div class=\"price-report-sa-info-body\">\n      <table border=\"0\">\n        <tr>\n          <td>基本料金単価</td>\n          <td>{{ $ctrl.baseUnitPrice | number }} 円</td>\n        </tr>\n        <tr>\n          <td>電力量単価</td>\n          <td>{{ $ctrl.powerUnitPrice | number }} 円</td>\n        </tr>\n        <tr>\n          <td></td>\n          <td><span class=\"span-link\" ui-sref=\"main.device_config_edit({id:{{$ctrl.id}}})\">単価を編集</span></td>\n        </tr>\n        <tr>\n          <td>&nbsp;</td>\n        </tr>\n        <tr style=\"font-weight: bold\">\n          <td>基本料金</td>\n          <td>{{ $ctrl.basePrice | number }} 円</td>\n        </tr>\n        <tr style=\"font-weight: bold\">\n          <td>{{ $ctrl.startDate | date : 'M/d' }} ~ {{ $ctrl.endDate | date : 'M/d' }} の電力量料金</td>\n          <td>{{ $ctrl.powerPrice | number }} 円</td>\n        </tr>\n        <tr>\n          <td>&nbsp;</td>\n        </tr>\n        <tr style=\"font-weight: bold\">\n          <td>{{ $ctrl.startDate | date : 'M/d' }} ~ {{ $ctrl.endDate | date : 'M/d' }} の電気料金</td>\n          <td>{{ $ctrl.sumPrice | number }} 円</td>\n        </tr>\n      </table>\n    </div>\n    <div class=\"price-report-note\">\n      <span>※ 電気料金 = (契約電力(kW) × 基本料金単価) + (電気使用量(kWh) × 電力量単価)</span><br>\n      <span>※ 電気料金は概算値です。実際の請求額には力率や燃料費調整額などが考慮されます。</span>\n    </div>\n  </div>\n</md-content>\n<div class='demand-report-table-content'>\n  <div class=\"price-report-unit\">\n    <span class=\"report-table-unit\">(単位: 円)</span>\n  </div>\n  <table class='demand-report-table price-report-table'>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 16\">\n        {{ time | date : 'M/d' }} ({{ time | dayFilter }})\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"price in $ctrl.prices | limitTo : 16 track by $index\">\n        <span ng-hide='price === 0'>{{ price | decimalFilter:1 }}</span>\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"time in $ctrl.categories | limitTo : 16 : 16\">\n        {{ time | date : 'M/d' }} ({{ time | dayFilter }})\n      </td>\n    </tr>\n    <tr>\n      <td ng-repeat=\"price in $ctrl.prices | limitTo : 16 : 16 track by $index\">\n        <span ng-hide='price === 0'>{{ price | decimalFilter:1 }}</span>\n      </td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EndUserReconfirmController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _end_user_reconfirm = __webpack_require__(836);

var _end_user_reconfirm2 = _interopRequireDefault(_end_user_reconfirm);

var _user_password = __webpack_require__(493);

var _user_password2 = _interopRequireDefault(_user_password);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var EndUserReconfirmController = exports.EndUserReconfirmController = function () {
  /*@ngInject*/
  EndUserReconfirmController.$inject = ["$state", "$mdDialog", "UserPasswordService"];
  function EndUserReconfirmController($state, $mdDialog, UserPasswordService) {
    _classCallCheck(this, EndUserReconfirmController);

    this.UserPasswordService = UserPasswordService;
    this.$mdDialog = $mdDialog;
    this.$state = $state;

    this.email = '';
    this.dialogs = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '以下のメールアドレスに確認用メールを送信しますか？',
        ok: '送信する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '送信が完了しました。',
        content: '送信されたメールをご確認下さい。',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };
  }

  _createClass(EndUserReconfirmController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'showConfirm',
    value: function showConfirm(ev) {
      var _this = this;

      this.dialogs.confirm.content(this.email);
      this.$mdDialog.show(this.dialogs.confirm.targetEvent(ev)).then(function () {
        _this.UserPasswordService.api.create({ email: _this.email }, function (res) {
          _this.$mdDialog.show(_this.dialogs.success).finally(function () {
            _this.$state.go('login');
          });
        }, function (err) {
          if (err.status === 404) {
            _this.dialogs.error.content('指定したメールアドレスのユーザーが存在しませんでした。');
          }
          _this.$mdDialog.show(_this.dialogs.error);
        });
      });
    }
  }]);

  return EndUserReconfirmController;
}();

exports.default = _angular2.default.module('leptonApp.endUserReconfirm', [_angularjs2.default, _user_password2.default]).config(_end_user_reconfirm2.default).component('endUserReconfirm', {
  template: __webpack_require__(837),
  controller: EndUserReconfirmController
}).name;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('end_user_reconfirm', {
    url: '/user_reconfirm',
    template: '<end-user-reconfirm></end-user-reconfirm>'
  });
}

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports = "<div id=\"header\">\n  <md-button id=\"logo\" ui-sref=\"main.home\">\n    <span class=\"fa-stack\" style=\"font-size: 13px\">\n      <i class=\"fa fa-cloud fa-stack-2x\" style=\"color: #1e88e5\"></i>\n      <i class=\"fa fa-plug fa-stack-1x\" style=\"color: #fffde7\"></i>\n    </span>&nbsp; Bルートデマンド監視サービス\n  </md-button>\n</div>\n<div class=\"reconfirm-title\">\n  <span><i class=\"fa fa-lock\"></i> パスワードの再設定</span>\n</div>\n<md-content class=\"user-reconfirm\">\n  <div>\n    <span class=\"reconfirm-explanation\">入力したメールアドレスにパスワード再設定用のURLが送信されます。</span>\n    <div class=\"form-content\">\n      <form name=\"reconfirmForm\">\n        <div layout-gt-sm=\"row\" flex=\"40\" offset=\"40\" class=\"reconfirm-password\">\n          <md-input-container class=\"md-block\" flex-gt-sm style=\"margin:0;\">\n            <label>メールアドレス</label>\n            <input name=\"email\" type=\"email\" ng-model=\"$ctrl.email\" md-maxlength=\"254\" required>\n            <div ng-messages=\"reconfirmForm.email.$error\" ng-if=\"reconfirmForm.email.$dirty\" role=\"alert\" multiple>\n              <div ng-message=\"required\">入力してください</div>\n              <div ng-message=\"md-maxlength\">254文字以下で記載してください</div>\n              <div ng-message=\"email\">メールアドレスのフォーマットで入力してください</div>\n            </div>\n          </md-input-container>\n        </div>\n        <md-button style=\"margin: 8px 0 32px;\" class=\"md-primary md-raised\" ng-click=\"$ctrl.showConfirm($event)\" ng-disabled=\"reconfirmForm.$invalid\">メールを送信</md-button>\n      </form>\n      <p class=\"reconfirm-notice\">\n        ※ ログインIDがメールアドレスではない特殊なアカウントについては、この画面からパスワード再設定用のメールを送信できません。\n      </p>\n      <p class=\"reconfirm-notice\">\n        ※ 再設定用のメールアドレスを送信後も、引き続き以前のパスワードでログインが可能です。\n      </p>\n    </div>\n  </div>\n</md-content>\n<md-divider></md-divider>\n<div id=\"footer\">\n  <div><a target=\"_blank\" href=\"http://www.iij.ad.jp/securitypolicy/\">情報セキュリティ基本方針</a></div>\n  <div><a target=\"_blank\" href=\"http://www.iij.ad.jp/privacy/\">個人情報保護ポリシー</a></div>\n  <div>&copy; 2016 Internet Initiative Japan Inc.</div>\n</div>\n"

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceCheckListController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DeviceCheckListController = exports.DeviceCheckListController = function () {
  /*@ngInject*/
  function DeviceCheckListController() {
    _classCallCheck(this, DeviceCheckListController);

    this.selectedList = this.selectedList || [];
  }

  _createClass(DeviceCheckListController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: '$onChanges',
    value: function $onChanges() {
      if (!this.deviceList) {
        return;
      }
      this.allIds = this.deviceList.map(function (device) {
        return device.id;
      });
    }
  }, {
    key: 'toggleCheck',
    value: function toggleCheck(id) {
      var index = this.selectedList.indexOf(id);

      if (index === -1) {
        this.selectedList.push(id);
      } else {
        this.selectedList.splice(index, 1);
      }

      this.changeSelectedList();
    }
  }, {
    key: 'toggleAllCheck',
    value: function toggleAllCheck() {
      if (this.selectedList.length === this.allIds.length) {
        this.selectedList = [];
      } else {
        _angular2.default.copy(this.allIds, this.selectedList);
      }
    }
  }, {
    key: 'changeSelectedList',
    value: function changeSelectedList() {
      if (this.updateParam) {
        this.updateParam();
      }
    }
  }]);

  return DeviceCheckListController;
}();

exports.default = _angular2.default.module('leptonApp.deviceCheckList', []).component('deviceCheckList', {
  template: __webpack_require__(839),
  controller: DeviceCheckListController,
  bindings: {
    deviceList: '<',
    selectedList: '=',
    disableAll: '=',
    updateParam: '&'
  }
}).name;

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports = "<div class=\"group-config-list-body\">\n  <div class=\"group-config-list-column\">\n    <div>\n      <input type=\"checkbox\"\n             ng-if=\"!$ctrl.disableAll\"\n             ng-checked=\"$ctrl.selectedList.length === $ctrl.allIds.length\"\n             ng-click=\"$ctrl.toggleAllCheck()\">\n    </div>\n    <div ng-repeat=\"config in $ctrl.deviceList\">\n      <input type=\"checkbox\"\n             ng-checked=\"$ctrl.selectedList.indexOf(config.id) !== -1\"\n             ng-click=\"$ctrl.toggleCheck(config.id)\">\n    </div>\n  </div>\n  <div class=\"group-config-list-column\">\n    <div>サービスコード</div>\n    <div ng-repeat=\"config in $ctrl.deviceList\">{{ config.pms_service_code }}</div>\n  </div>\n  <div class=\"group-config-list-column\">\n    <div>設置場所</div>\n    <div ng-repeat=\"config in $ctrl.deviceList\">{{ config.location }}</div>\n  </div>\n  <div class=\"group-config-list-column\">\n    <div>メモ</div>\n    <div ng-repeat=\"config in $ctrl.deviceList\">{{ config.memo }}</div>\n  </div>\n</div>\n"

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventReportController = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _angularScroll = __webpack_require__(547);

var _angularScroll2 = _interopRequireDefault(_angularScroll);

var _event_report = __webpack_require__(841);

var _event_report2 = _interopRequireDefault(_event_report);

var _event = __webpack_require__(90);

var _event2 = _interopRequireDefault(_event);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

var _event_report3 = __webpack_require__(842);

var _event_report4 = _interopRequireDefault(_event_report3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var EventReportController = exports.EventReportController = function () {
  /*@ngInject*/
  EventReportController.$inject = ["$stateParams", "$q", "$filter", "$interval", "$document", "$timeout", "moment", "EventService", "CsvUtil"];
  function EventReportController($stateParams, $q, $filter, $interval, $document, $timeout, moment, EventService, CsvUtil) {
    var _this = this;

    _classCallCheck(this, EventReportController);

    this.id = $stateParams.id;
    this.$q = $q;
    this.$filter = $filter;
    this.$interval = $interval;
    this.$document = $document;
    this.$timeout = $timeout;
    this.moment = moment;
    this.EventService = EventService;
    this.CsvUtil = CsvUtil;

    this.downloadFileName = 'events.csv';

    this.scrollElement = _angular2.default.element(document.querySelector('#event-report-content'));
    this.scrollItemSize = 321;
    this.loadThreshold = this.scrollItemSize * 7;

    this.autoScrolling = false;
    this.dragging = false;

    this.currentDate = this.moment().startOf('day').toDate();
    this.targetDate = this.moment().startOf('day').toDate();
    this.events = [];

    this.scrollElement.on('scroll', function () {
      if (_this.autoScrolling) {
        return;
      }

      var position = _this.scrollElement.scrollLeft() - _this.scrollItemSize / 2;
      var index = Math.floor(position / _this.scrollItemSize);
      var targetDate = _this.events[index + 1].date;

      if (_this.targetDate.valueOf() !== targetDate.valueOf()) {
        _this.$timeout(function () {
          _this.targetDate = targetDate.toDate();
          _this.setPlotLine();
        });
        _this.currentDate = targetDate.toDate();
      }

      _this.infiniteScroll();
    });

    this.chartConfig = (0, _event_report4.default)(this);
  }

  _createClass(EventReportController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      var targetDate = this.moment(this.targetDate);
      this.loadEvent(targetDate).then(function (events) {
        _this2.events = events;
        _this2.scrollToDay(targetDate, 100);

        _this2.updateGraph(_this2.events);
        _this2.csvData = _this2.CsvUtil.createEventReportCsv(_this2.events);
        _this2.downloadFileName = targetDate.format('[event]_YYYY-MM[.csv]');
      });
    }
  }, {
    key: 'loadEvent',
    value: function loadEvent(date) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.EventService.api.show({ id: _this3.id, year: date.year(), month: date.month() + 1 }, function (events) {
          resolve(_this3.divideEvents(events, date));
        });
      });
    }
  }, {
    key: 'isSunday',
    value: function isSunday(date) {
      return date.day() === 0;
    }
  }, {
    key: 'isSaturday',
    value: function isSaturday(date) {
      return date.day() === 6;
    }
  }, {
    key: 'jumpDate',
    value: function jumpDate() {
      var _this4 = this;

      var currentDate = this.moment(this.currentDate);
      var targetDate = this.moment(this.targetDate);
      if (targetDate.month() !== currentDate.month() || targetDate.year() !== currentDate.year()) {
        this.loadEvent(targetDate).then(function (events) {
          _this4.$timeout(function () {
            _this4.events = events;
            _this4.scrollToDay(targetDate);
            _this4.updateGraph(_this4.events);
            _this4.csvData = _this4.CsvUtil.createEventReportCsv(_this4.events);
            _this4.downloadFileName = targetDate.format('[event]_YYYY-MM[.csv]');
          });
        });
      } else {
        this.scrollToDay(targetDate);
      }
      this.currentDate = targetDate.toDate();
    }
  }, {
    key: 'changeDate',
    value: function changeDate(diff) {
      if (this.autoScrolling) {
        return;
      }
      var targetDate = this.moment(this.targetDate);

      targetDate.add(diff, 'days');

      this.targetDate = targetDate.toDate();
      this.currentDate = targetDate.toDate();

      if (scroll) {
        this.scrollToDay(targetDate);
      }
      this.setPlotLine();
    }
  }, {
    key: 'updateEvent',
    value: function updateEvent(targetDate, direction) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        _this5.loadEvent(targetDate).then(function (events) {
          var newEvents = [];
          var newFilename = '';
          if (direction > 0) {
            var threshold = _this5.moment(_this5.targetDate).startOf('month');
            newEvents = _this5.behindEvents(_this5.events, threshold).concat(events);
            newFilename = _this5.moment(_this5.targetDate).format('[event]_YYYY-MM[.csv]');
          } else {
            var _threshold = _this5.moment(_this5.targetDate).startOf('month').add(1, 'months');
            newEvents = events.concat(_this5.frontEvents(_this5.events, _threshold));
            newFilename = _this5.moment(targetDate).format('[event]_YYYY-MM[.csv]');
          }

          _this5.$timeout(function () {
            _this5.events = newEvents;
            resolve();
            _this5.updateGraph(_this5.events);
            _this5.csvData = _this5.CsvUtil.createEventReportCsv(_this5.events);
            _this5.downloadFileName = newFilename;
          });
        });
      });
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(events) {
      var _createGraphData = this.createGraphData(events),
          _createGraphData2 = _slicedToArray(_createGraphData, 2),
          normalData = _createGraphData2[0],
          errorData = _createGraphData2[1];

      this.chart.series[0].setData(normalData);
      this.chart.series[1].setData(errorData);
      this.chart.reflow();
    }
  }, {
    key: 'behindEvents',
    value: function behindEvents(events, date) {
      var index = this.findIndexByDate(events, date);
      if (index < 1) {
        return events;
      }
      return events.slice(index);
    }
  }, {
    key: 'frontEvents',
    value: function frontEvents(events, date) {
      var index = this.findIndexByDate(events, date);
      if (index < 1) {
        return events;
      }
      return events.slice(0, index);
    }
  }, {
    key: 'findIndexByDate',
    value: function findIndexByDate(events, date) {
      var index = -1;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = events.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              i = _step$value[0],
              event = _step$value[1];

          if (event.date.valueOf() === date.valueOf()) {
            index = i;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return index;
    }
  }, {
    key: 'scrollToDay',
    value: function scrollToDay(date) {
      var _this6 = this;

      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;

      this.autoScrolling = true;
      var index = this.findIndexByDate(this.events, date) + 1;

      this.$timeout(function () {
        _this6.scrollElement.scrollTo(_this6.scrollItemSize * (index - 1), 0, duration).then(function () {
          _this6.autoScrolling = false;
          _this6.infiniteScroll();
        });
      }, delay);
      this.setPlotLine();
    }
  }, {
    key: 'infiniteScroll',
    value: function infiniteScroll() {
      var _this7 = this;

      if (this.dragging) {
        return;
      }
      if (this.scrollElement.scrollLeft() < this.loadThreshold) {
        var date = this.moment(this.targetDate).subtract(1, 'month');
        this.autoScrolling = true;
        this.updateEvent(date, -1).then(function () {
          _this7.scrollToDay(_this7.targetDate, 0, 0);
        });
      }

      if (this.scrollElement.scrollLeft() > this.scrollElement[0].scrollWidth - this.loadThreshold) {
        var _date = this.moment(this.targetDate).add(1, 'month');
        this.autoScrolling = true;
        this.updateEvent(_date, 1).then(function () {
          _this7.scrollToDay(_this7.targetDate, 0, 0);
        });
      }
    }
  }, {
    key: 'setDragging',
    value: function setDragging() {
      this.dragging = true;
    }
  }, {
    key: 'removeDragging',
    value: function removeDragging() {
      this.dragging = false;
      this.infiniteScroll();
    }
  }, {
    key: 'createGraphData',
    value: function createGraphData(events) {
      var normalData = [];
      var errorData = [];

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = events[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var dayEvents = _step2.value;

          var date = dayEvents.date.valueOf();
          normalData.push({
            x: date,
            y: this.$filter('normalEventCount')(dayEvents.events)
          });
          errorData.push({
            x: date,
            y: this.$filter('errorEventCount')(dayEvents.events)
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return [normalData, errorData];
    }
  }, {
    key: 'setPlotLine',
    value: function setPlotLine() {
      this.chart.xAxis[0].removePlotLine('target-date');
      this.chart.xAxis[0].addPlotLine({
        id: 'target-date',
        value: this.targetDate.valueOf(),
        color: '#c1c1c1',
        width: 2,
        zIndex: 0
      });
      this.chart.redraw();
    }
  }, {
    key: 'divideEvents',
    value: function divideEvents(events, targetDate) {
      var _this8 = this;

      var result = [];
      var startDate = targetDate.clone().startOf('month');
      var endDate = startDate.clone().endOf('month');

      for (var date = startDate; date.isBefore(endDate); date.add(1, 'days')) {
        result.push({
          date: date.clone(),
          events: []
        });
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        var _loop = function _loop() {
          var event = _step3.value;

          var occurredAt = _this8.moment(event.occurred_at).startOf('day');
          var target = result.find(function (element) {
            return element.date.valueOf() === occurredAt.valueOf();
          });

          target.events.push(event);
        };

        for (var _iterator3 = events[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return result;
    }
  }]);

  return EventReportController;
}();

exports.default = _angular2.default.module('leptonApp.eventReport', [_angularjs2.default, _angularMoment2.default, _angularScroll2.default, _event2.default, _csv2.default]).config(_event_report2.default).component('eventReport', {
  require: { parentComponent: '^demandReportShow' },
  template: __webpack_require__(843),
  controller: EventReportController
}).name;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.event_report', {
    template: '<event-report></event-report>'
  });
}

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  var chartConfig = {
    chart: {
      type: 'line',
      height: 150,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    title: false,
    xAxis: {
      crosshair: true,
      labels: {
        formatter: function formatter() {
          var style = '';
          var day = scope.$filter('dayFilter')(this.value);
          if (day === '日') {
            style = 'color: #ff3131';
          } else if (day === '土') {
            style = 'color: #3737ff';
          }

          return '<span style="' + style + '">' + scope.$filter('date')(this.value, 'M/d') + ' (' + day + ')</span>';
        }
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: false
    },
    plotLines: [{
      id: 'target-date'
    }],
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      borderWidth: 0,
      reversed: true
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function formatter() {
        var tip_format = '<tspan style=\'font-size: 12px\'>' + scope.$filter('date')(this.x, 'M/d') + ' (' + scope.$filter('dayFilter')(this.x) + ')</tspan>';

        var pointNormal = this.points[0];
        var pointError = this.points[1];
        tip_format += '<br/><span style="color:' + pointNormal.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + pointNormal.series.name + ': ';
        tip_format += pointNormal.y + " 回";
        tip_format += "</span>";
        tip_format += '<br/><span style="color:' + pointError.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + pointError.series.name + ': ';
        tip_format += pointError.y + " 回";
        tip_format += "</span>";

        return tip_format;
      }
    },
    plotOptions: { column: { grouping: false } },
    series: [{
      name: '正常系',
      color: '#6ee876',
      marker: { symbol: 'circle' },
      lineWidth: 2,
      cursor: 'pointer'
    }, {
      name: '異常系',
      color: '#ff3535',
      marker: { symbol: 'circle' },
      lineWidth: 2,
      cursor: 'pointer'
    }]
  };

  return chartConfig;
}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports = "<div class=\"event-report\">\n  <div class=\"date-component\" style=\"margin: 10px 0;\">\n    <div layout=\"row\" layout-align=\"start center\">\n      <md-button ng-click=\"$ctrl.changeDate(-1)\" class=\"md-fab md-mini md-primary\">\n        <i class=\"fa fa-arrow-left\"></i>\n      </md-button>\n      <div datepicker class=\"date-picker\" ng-model=\"$ctrl.targetDate\" ng-change=\"$ctrl.jumpDate()\">{{$ctrl.targetDate | date: 'yyyy/MM/dd'}}<i class=\"fa fa-sort-down\" aria-hidden=\"true\"></i></div>\n      <md-button ng-disabled=\"$ctrl.targetDate.valueOf() === $ctrl.maxDate.valueOf()\" ng-click=\"$ctrl.changeDate(1)\" class=\"md-fab md-mini md-primary\">\n        <i class=\"fa fa-arrow-right\"></i>\n      </md-button>\n    </div>\n    <div class=\"event-report-csv-button\">\n      <a csv-downloader filename=\"$ctrl.downloadFileName\" csv-data=\"$ctrl.csvData\" style=\"color: inherit;text-decoration: none;\">\n        <md-button class=\"csv-download-button\" style=\"background: rgba(155,155,155,0.2);margin-left: 0;\">\n          <i class=\"fa fa-download\" aria-hidden=\"true\"></i> csvダウンロード\n        </md-button>\n      </a>\n    </div>\n  </div>\n  <div id=\"event-report-content\" class=\"event-report-content\" drag-scroll=\"true\"\n    ng-mousedown=\"$ctrl.setDragging()\" ng-mouseup=\"$ctrl.removeDragging()\">\n    <div class=\"event-report-day\" ng-repeat=\"eventDay in $ctrl.events\">\n      <div class=\"event-report-day-title\" ng-class=\"{'event-report-sun': $ctrl.isSunday(eventDay.date), 'event-report-sat': $ctrl.isSaturday(eventDay.date)}\">\n        {{eventDay.date | amDateFormat:'YYYY/MM/DD'}} ({{eventDay.date.toDate() | dayFilter}})\n      </div>\n      <div class=\"event-report-event-list\">\n        <div class=\"event-report-event\" ng-repeat=\"event in eventDay.events\" ng-if=\"eventDay.events.length > 0\">\n          <i ng-class=\"event.is_error ? 'fa fa-exclamation-circle error' : 'fa fa-check-square normal'\"></i>\n          <div class=\"event-msg\">\n            {{ event.event_msg }}\n            <span ng-if=\"event.triggered_by\" class=\"edited-by\"> (変更者: {{ event.triggered_by }})</span>\n          </div>\n          <div class=\"event-minor-info\" layout=\"column\" layout-align=\"center end\">\n            <span>{{ event.occurred_at | date : 'HH:mm' }}</span>\n          </div>\n        </div>\n        <div class=\"event-msg event-report-empty-msg\" ng-if=\"eventDay.events.length === 0\">\n          なし\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"event-report-graph-content\">\n    <div>\n      <span class=\"report-table-unit\">イベント発生数の推移</span>\n    </div>\n    <chart value=\"$ctrl.chartConfig\"></chart>\n  </div>\n</div>\n"

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SaRebootController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _sa_reboot = __webpack_require__(845);

var _sa_reboot2 = _interopRequireDefault(_sa_reboot);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _controller_config = __webpack_require__(91);

var _controller_config2 = _interopRequireDefault(_controller_config);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var SaRebootController = exports.SaRebootController = function () {
  /*@ngInject*/
  SaRebootController.$inject = ["$q", "SaConfigService", "ControllerConfigService"];
  function SaRebootController($q, SaConfigService, ControllerConfigService) {
    _classCallCheck(this, SaRebootController);

    this.$q = $q;
    this.SaConfigService = SaConfigService;
    this.ControllerConfigService = ControllerConfigService;

    this.devices = [];
  }

  _createClass(SaRebootController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$q.all([this.SaConfigService.api.index().$promise, this.ControllerConfigService.api.index().$promise]).then(function (responses) {
        _this.devices = responses[0].concat(responses[1]);
      });
    }
  }]);

  return SaRebootController;
}();

exports.default = _angular2.default.module('leptonApp.saReboot', [_angularjs2.default, _sa_config2.default, _controller_config2.default]).config(_sa_reboot2.default).component('saReboot', {
  template: __webpack_require__(846),
  controller: SaRebootController
}).name;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.sa_reboot', {
    url: 'sa_reboot',
    template: '<sa-reboot></sa-reboot>'
  });
}

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-redo\"></i>&nbsp;端末再起動</h2>\n  </div>\n</md-toolbar>\n<div class=\"sa-reboot-item sa-reboot-item-end\" ng-repeat=\"device in $ctrl.devices\">\n  <sa-reboot-item device=\"device\" mode=\"end\"></sa-reboot-item>\n</div>\n"

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatisticsIndexController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _statistics_index = __webpack_require__(848);

var _statistics_index2 = _interopRequireDefault(_statistics_index);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var StatisticsIndexController = exports.StatisticsIndexController = function () {
  /*@ngInject*/
  StatisticsIndexController.$inject = ["SaConfigService"];
  function StatisticsIndexController(SaConfigService) {
    _classCallCheck(this, StatisticsIndexController);

    this.saList = [];
    this.SaConfigService = SaConfigService;
  }

  _createClass(StatisticsIndexController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.SaConfigService.api.index(function (res) {
        _this.saList = res;
      });
    }
  }]);

  return StatisticsIndexController;
}();

exports.default = _angular2.default.module('leptonApp.statisticsIndex', [_angularjs2.default, _sa_config2.default]).config(_statistics_index2.default).component('statisticsIndex', {
  template: __webpack_require__(849),
  controller: StatisticsIndexController
}).name;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'user strict';

routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.statistics_index', {
    url: 'statistics',
    template: '<statistics-index></statistics-index>'
  });
}

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-chart-pie fa-fw\"></i>&nbsp;メーター 一覧</h2>\n  </div>\n</md-toolbar>\n<div ng-if=\"$ctrl.saList.length === 0\" class=\"empty-notice\">設定済みの機器がありません。</div>\n<md-content>\n  <md-list-item class=\"md-3-line\" ng-repeat=\"sa in $ctrl.saList\">\n    <a ui-sref=\"main.statistics_show({id:{{sa.id}}})\" style=\"width: 100%; padding: 12px 0\">\n      <div class=\"md-list-item-text device-list-item\" layout=\"column\" style=\"margin: 0;\">\n        <h3>{{ sa.pms_service_code }} {{ sa.management_id }}</h3>\n        <h4>{{ sa.location }}</h4>\n        <p>{{ sa.memo }}</p>\n      </div>\n    </a>\n    <md-divider></md-divider>\n  </md-list-item>\n</md-content>\n"

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatisticsShowController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _statistics_show = __webpack_require__(851);

var _statistics_show2 = _interopRequireDefault(_statistics_show);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _monthly_active_power = __webpack_require__(470);

var _monthly_active_power2 = _interopRequireDefault(_monthly_active_power);

var _monthly_max_demand_power = __webpack_require__(218);

var _monthly_max_demand_power2 = _interopRequireDefault(_monthly_max_demand_power);

var _event = __webpack_require__(90);

var _event2 = _interopRequireDefault(_event);

var _daily_active_power = __webpack_require__(191);

var _daily_active_power2 = _interopRequireDefault(_daily_active_power);

var _active_power = __webpack_require__(144);

var _active_power2 = _interopRequireDefault(_active_power);

var _daily_weather = __webpack_require__(192);

var _daily_weather2 = _interopRequireDefault(_daily_weather);

var _daily_max_demand_power = __webpack_require__(220);

var _daily_max_demand_power2 = _interopRequireDefault(_daily_max_demand_power);

var _demand_power = __webpack_require__(202);

var _demand_power2 = _interopRequireDefault(_demand_power);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var StatisticsShowController = exports.StatisticsShowController = function () {
  /*@ngInject*/
  StatisticsShowController.$inject = ["$stateParams", "$state", "moment", "$q", "SaConfigService", "MonthlyActivePowerService", "MonthlyMaxDemandPowerService", "EventService", "DailyActivePowerService", "ActivePowerService", "DailyWeatherService", "DailyMaxDemandPowerService", "DemandPowerService", "DateUtil"];
  function StatisticsShowController($stateParams, $state, moment, $q, SaConfigService, MonthlyActivePowerService, MonthlyMaxDemandPowerService, EventService, DailyActivePowerService, ActivePowerService, DailyWeatherService, DailyMaxDemandPowerService, DemandPowerService, DateUtil) {
    _classCallCheck(this, StatisticsShowController);

    this.SaConfigService = SaConfigService;
    this.MonthlyActivePowerService = MonthlyActivePowerService;
    this.MonthlyMaxDemandPowerService = MonthlyMaxDemandPowerService;
    this.EventService = EventService;
    this.DailyActivePowerService = DailyActivePowerService;
    this.ActivePowerService = ActivePowerService;
    this.DailyWeatherService = DailyWeatherService;
    this.DailyMaxDemandPowerService = DailyMaxDemandPowerService;
    this.DemandPowerService = DemandPowerService;
    this.DateUtil = DateUtil;

    this.id = $stateParams.id;
    this.moment = moment;
    this.$q = $q;

    this.targetDate = this.moment().startOf('month').subtract(1, 'month');
    this.saInfo = null;
    this.data = {};

    this.saInfoPromise = null;
  }

  _createClass(StatisticsShowController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.saInfoPromise = this.SaConfigService.api.show({ id: this.id }).$promise;
      this.saInfoPromise.then(function (res) {
        _this.saInfo = res;
      });
      this.updateData(this.targetDate);
    }
  }, {
    key: 'changeMonth',
    value: function changeMonth(diff) {
      this.targetDate.add(diff, 'month');
      this.updateData(this.targetDate);
    }
  }, {
    key: 'updateData',
    value: function updateData(targetDate) {
      var _this2 = this;

      this.data.targetDate = targetDate;

      var eventQuery = this.eventQuery(targetDate);
      this.$q.all([this.EventService.api.show(eventQuery.current).$promise, this.EventService.api.show(eventQuery.before).$promise]).then(function (responses) {
        _this2.data.events = {
          current: responses[0],
          before: responses[1]
        };
      });

      var dailyPowerQuery = this.dailyPowerQuery(targetDate);
      var dailyWeatherQuery = this.dailyWeatherQuery(targetDate);
      this.$q.all([this.DailyActivePowerService.show(dailyPowerQuery.current).$promise, this.DailyActivePowerService.show(dailyPowerQuery.before).$promise, this.DailyWeatherService.api.index(dailyWeatherQuery.current).$promise]).then(function (responses) {
        _this2.data.dailyActivePower = {
          current: responses[0].powers,
          before: responses[1].powers,
          currentWeather: responses[2]
        };
      });

      this.$q.all([this.DailyMaxDemandPowerService.show(dailyPowerQuery.current).$promise, this.DailyMaxDemandPowerService.show(dailyPowerQuery.before).$promise]).then(function (responses) {
        _this2.data.dailyMaxDemandPower = {
          current: responses[0].powers,
          before: responses[1].powers
        };
      });

      var hourlyPowerQuery = this.hourlyPowerQuery(targetDate);
      this.$q.all([this.DemandPowerService.show(hourlyPowerQuery.current).$promise, this.DemandPowerService.show(hourlyPowerQuery.before).$promise]).then(function (responses) {
        _this2.data.demandPower = {
          current: responses[0].powers,
          before: responses[1].powers
        };
      });
    }
  }, {
    key: 'eventQuery',
    value: function eventQuery(targetDate) {
      var beforeDate = targetDate.clone().subtract(1, 'month');
      return {
        current: {
          id: this.id,
          year: targetDate.year(),
          month: targetDate.month() + 1
        },
        before: {
          id: this.id,
          year: beforeDate.year(),
          month: beforeDate.month() + 1
        }
      };
    }
  }, {
    key: 'dailyPowerQuery',
    value: function dailyPowerQuery(targetDate) {
      var endDate = targetDate.clone().endOf('month');
      var startDate = targetDate;
      var beforeStartDate = targetDate.clone().subtract(1, 'month');
      var beforeEndDate = targetDate.clone().subtract(1, 'month').endOf('month');

      return {
        current: _angular2.default.extend({ id: this.id }, this.DateUtil.datetimeRangeQuery(startDate, endDate)),
        before: _angular2.default.extend({ id: this.id }, this.DateUtil.datetimeRangeQuery(beforeStartDate, beforeEndDate))
      };
    }
  }, {
    key: 'dailyWeatherQuery',
    value: function dailyWeatherQuery(targetDate) {
      var endDate = targetDate.clone().endOf('month');
      var startDate = targetDate;
      var beforeStartDate = targetDate.clone().subtract(1, 'month');
      var beforeEndDate = targetDate.clone().subtract(1, 'month').endOf('month');

      return {
        current: _angular2.default.extend({ sa_config_id: this.id }, this.DateUtil.datetimeRangeQuery(startDate, endDate)),
        before: _angular2.default.extend({ sa_config_id: this.id }, this.DateUtil.datetimeRangeQuery(beforeStartDate, beforeEndDate))
      };
    }
  }, {
    key: 'hourlyPowerQuery',
    value: function hourlyPowerQuery(targetDate) {
      var startDate = targetDate.clone().startOf('month');
      var endDate = targetDate.clone().add(1, 'month').startOf('month');
      var beforeStartDate = targetDate.clone().subtract(1, 'month');
      var beforeEndDate = startDate;

      return {
        current: _angular2.default.extend({ id: this.id }, this.DateUtil.datetimeRangeQuery(startDate, endDate)),
        before: _angular2.default.extend({ id: this.id }, this.DateUtil.datetimeRangeQuery(beforeStartDate, beforeEndDate))
      };
    }
  }]);

  return StatisticsShowController;
}();

exports.default = _angular2.default.module('leptonApp.statisticsShow', [_angularMoment2.default, _angularjs2.default, _sa_config2.default, _monthly_active_power2.default, _monthly_max_demand_power2.default, _event2.default, _daily_active_power2.default, _active_power2.default, _daily_weather2.default, _daily_max_demand_power2.default, _demand_power2.default, _date_util2.default]).config(_statistics_show2.default).component('statisticsShow', {
  template: __webpack_require__(852),
  controller: StatisticsShowController
}).name;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'user strict';

routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.statistics_show', {
    url: 'statistics/:id',
    template: '<statistics-show></statistics-show>'
  });
}

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-chart-pie fa-fw\"></i>&nbsp;統計レポート</h2>\n  </div>\n</md-toolbar>\n<div class=\"date-component statistics-date-component\" style=\"margin: 5px 0 5px 7px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <md-button ng-click=\"$ctrl.changeMonth(-1)\" class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-left\"></i>\n    </md-button>\n    <span>{{$ctrl.targetDate | amDateFormat: 'YYYY 年 MM 月'}}分</span>\n    <md-button ng-disabled=\"$ctrl.targetDate >= $ctrl.moment().startOf('month')\" ng-click=\"$ctrl.changeMonth(1)\"\n               class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-right\"></i>\n    </md-button>\n  </div>\n  <div class=\"sa-info-link statistics-sa-info-link\">\n    <span class=\"span-link\" ng-click=\"$ctrl.showSaInfo = !$ctrl.showSaInfo\">\n      <i class=\"fa fa-caret-right\" ng-if=\"!$ctrl.showSaInfo\"></i>\n      <i class=\"fa fa-caret-down\" ng-if=\"$ctrl.showSaInfo\"></i> 機器情報\n    </span>\n  </div>\n</div>\n<sa-info-directive sa=\"$ctrl.saInfo\" show=\"$ctrl.showSaInfo\"></sa-info-directive>\n\n<div class=\"statistics-content\">\n  <div class=\"statistics-content-title\">電力消費状況</div>\n  <div class=\"statistics-content-body\">\n    <power-stat-table data=\"$ctrl.data\"></power-stat-table>\n    <power-stat-graph-index data=\"$ctrl.data\"></power-stat-graph-index>\n  </div>\n</div>\n\n<div class=\"statistics-content\">\n  <div class=\"statistics-content-title\">天候と消費電力の相関</div>\n  <div class=\"statistics-content-body statistics-weather-graph-content\">\n    <weather-correlation-graph data=\"$ctrl.data\" class=\"statistics-weather-graph\"></weather-correlation-graph>\n    <temp-correlation-graph data=\"$ctrl.data\" class=\"statistics-weather-graph\"></temp-correlation-graph>\n  </div>\n</div>\n"

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PowerStatTableController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _math_util = __webpack_require__(88);

var _math_util2 = _interopRequireDefault(_math_util);

__webpack_require__(854);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var PowerStatTableController = exports.PowerStatTableController = function () {
  /*@ngInject*/
  PowerStatTableController.$inject = ["$scope", "$filter", "moment", "MathUtil"];
  function PowerStatTableController($scope, $filter, moment, MathUtil) {
    var _this = this;

    _classCallCheck(this, PowerStatTableController);

    this.moment = moment;
    this.MathUtil = MathUtil;
    this.$filter = $filter;
    this.tableData = {};

    this.WEEK = ['日', '月', '火', '水', '木', '金', '土'];

    $scope.$watch('$ctrl.data.events', function (newValue) {
      return _this.updateEvents(newValue);
    });
    $scope.$watch('$ctrl.data.dailyActivePower', function (newValue) {
      return _this.updateDailyActivePower(newValue);
    });
    $scope.$watch('$ctrl.data.dailyMaxDemandPower', function (newValue) {
      return _this.updateDailyMaxDemandPower(newValue);
    });
    $scope.$watch('$ctrl.data.demandPower', function (newValue) {
      return _this.updateDemandePower(newValue);
    });
  }

  _createClass(PowerStatTableController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'updateEvents',
    value: function updateEvents(events) {
      if (!events) {
        return;
      }
      var currentCount = this.countDemandAlert(events.current);
      var beforeCount = this.countDemandAlert(events.before);
      this.tableData.event = {
        current: currentCount,
        diff: currentCount - beforeCount
      };
    }
  }, {
    key: 'updateDailyActivePower',
    value: function updateDailyActivePower(activePowers) {
      if (!activePowers) {
        return;
      }
      var currentSum = this.sumDailyActivePower(activePowers.current);
      var beforeSum = this.sumDailyActivePower(activePowers.before);
      this.tableData.sumActivePower = {
        current: currentSum,
        diff: this.MathUtil.subtract(currentSum, beforeSum)
      };

      var currentActivePowerMaxDay = this.dailyActivePowerMaxDay(activePowers.current);
      var beforeActivePowerMaxDay = this.dailyActivePowerMaxDay(activePowers.before);
      this.tableData.activePowerMaxDay = {
        current: currentActivePowerMaxDay,
        before: beforeActivePowerMaxDay
      };
    }
  }, {
    key: 'updateDailyMaxDemandPower',
    value: function updateDailyMaxDemandPower(demandPowers) {
      if (!demandPowers) {
        return;
      }
      var currentMaxDemandPower = this.maxDailyDemandPower(demandPowers.current);
      var beforeMaxDemandPower = this.maxDailyDemandPower(demandPowers.before);
      this.tableData.demandPowerMax = {
        current: currentMaxDemandPower,
        diff: this.MathUtil.subtract(currentMaxDemandPower, beforeMaxDemandPower)
      };
    }
  }, {
    key: 'updateDemandePower',
    value: function updateDemandePower(demandPowers) {
      if (!demandPowers) {
        return;
      }
      var currentDemandPowerMaxTime = this.demandPowerMaxTime(demandPowers.current);
      var beforeDemandPowerMaxTime = this.demandPowerMaxTime(demandPowers.before);
      this.tableData.demandPowerMaxTime = {
        current: currentDemandPowerMaxTime,
        before: beforeDemandPowerMaxTime
      };
    }
  }, {
    key: 'countDemandAlert',
    value: function countDemandAlert(eventList) {
      return eventList.filter(function (e) {
        return e.event_tag.match(/.*_exceeded/);
      }).length;
    }
  }, {
    key: 'sumDailyActivePower',
    value: function sumDailyActivePower(powers) {
      var sum = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = powers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var power = _step.value;

          sum = this.MathUtil.add(sum, power.value);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return sum;
    }
  }, {
    key: 'dailyActivePowerMaxDay',
    value: function dailyActivePowerMaxDay(powers) {
      var avgs = {};
      if (powers.length === 0) {
        return 'なし';
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.WEEK[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var day = _step2.value;

          avgs[day] = { count: 0, sum: 0 };
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = powers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var power = _step3.value;

          var _day = this.$filter('dayFilter')(power.date);
          if (avgs[_day]) {
            avgs[_day].count += 1;
            avgs[_day].sum += power.value;
          } else {
            avgs[_day] = { count: 1, sum: power.value };
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var maxDay = '日';

      for (var key in avgs) {
        if (avgs[maxDay].count === 0) {
          maxDay = key;
          continue;
        }
        if (avgs[key].count === 0) {
          continue;
        }

        var max = avgs[maxDay].sum / avgs[maxDay].count;
        var target = avgs[key].sum / avgs[key].count;

        if (target > max) {
          maxDay = key;
        }
      }

      return maxDay;
    }
  }, {
    key: 'maxDailyDemandPower',
    value: function maxDailyDemandPower(powers) {
      var values = powers.map(function (e) {
        return e.value;
      });
      if (values.length === 0) {
        values.push(0);
      }
      return Math.max.apply(null, values);
    }
  }, {
    key: 'demandPowerMaxTime',
    value: function demandPowerMaxTime(powers) {
      powers = powers.filter(function (power) {
        return !power.missing;
      });

      if (powers.length === 0) {
        return 'なし';
      }

      var avgs = {};
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = powers[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var power = _step4.value;

          var timeKey = this.moment(power.measured_at).format('HH:mm');
          if (avgs[timeKey]) {
            avgs[timeKey].count += 1;
            avgs[timeKey].sum += power.value;
          } else {
            avgs[timeKey] = { count: 1, sum: power.value };
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var maxTime = Object.keys(avgs)[0];

      for (var key in avgs) {
        var max = avgs[maxTime].sum / avgs[maxTime].count;
        var target = avgs[key].sum / avgs[key].count;

        if (target > max) {
          maxTime = key;
        }
      }

      return maxTime;
    }
  }]);

  return PowerStatTableController;
}();

exports.default = _angular2.default.module('leptonApp.powerStatTable', [_angularMoment2.default, _math_util2.default]).component('powerStatTable', {
  template: __webpack_require__(855),
  controller: PowerStatTableController,
  bindings: {
    data: '='
  }
}).name;

/***/ }),
/* 854 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = "<table class=\"power-stat-table\">\n  <tr>\n    <th></th>\n    <th>当月</th>\n    <th>前月比</th>\n  </tr>\n  <tr>\n    <th>合計消費電力</th>\n    <td>{{ $ctrl.tableData.sumActivePower.current }} kWh</td>\n    <td ng-if=\"$ctrl.tableData.sumActivePower.diff > 0\" class=\"power-stat-diff-plus\">+{{$ctrl.tableData.sumActivePower.diff}} kWh</td>\n    <td ng-if=\"$ctrl.tableData.sumActivePower.diff === 0\">±0 kWh</td>\n    <td ng-if=\"$ctrl.tableData.sumActivePower.diff < 0\" class=\"power-stat-diff-minus\">{{$ctrl.tableData.sumActivePower.diff}} kWh</td>\n  </tr>\n  <tr>\n    <th>最大デマンド値</th>\n    <td>{{ $ctrl.tableData.demandPowerMax.current }} kW</td>\n    <td ng-if=\"$ctrl.tableData.demandPowerMax.diff > 0\" class=\"power-stat-diff-plus\">+{{$ctrl.tableData.demandPowerMax.diff}} kW</td>\n    <td ng-if=\"$ctrl.tableData.demandPowerMax.diff === 0\">±0 kW</td>\n    <td ng-if=\"$ctrl.tableData.demandPowerMax.diff < 0\" class=\"power-stat-diff-minus\">{{$ctrl.tableData.demandPowerMax.diff}} kW</td>\n  </tr>\n  <tr>\n    <th>警報発生回数</th>\n    <td>{{$ctrl.tableData.event.current}} 件</td>\n    <td ng-if=\"$ctrl.tableData.event.diff > 0\" class=\"power-stat-diff-plus\">+{{$ctrl.tableData.event.diff}} 件</td>\n    <td ng-if=\"$ctrl.tableData.event.diff === 0\">±0 件</td>\n    <td ng-if=\"$ctrl.tableData.event.diff < 0\" class=\"power-stat-diff-minus\">{{$ctrl.tableData.event.diff}} 件</td>\n  </tr>\n  <tr>\n    <th>消費電力の多い曜日</th>\n    <td>{{$ctrl.tableData.activePowerMaxDay.current}}<span ng-if=\"$ctrl.tableData.activePowerMaxDay.current !== 'なし'\">曜日</span></td>\n    <td>{{$ctrl.tableData.activePowerMaxDay.before}} <i class=\"fas fa-arrow-right power-stat-diff-plus\"></i> {{$ctrl.tableData.activePowerMaxDay.current}}</td>\n  </tr>\n  <tr>\n    <th>消費電力の多い時間帯</th>\n    <td>{{$ctrl.tableData.demandPowerMaxTime.current}}</td>\n    <td>{{$ctrl.tableData.demandPowerMaxTime.before}} <i class=\"fas fa-arrow-right power-stat-diff-plus\"></i> {{$ctrl.tableData.demandPowerMaxTime.current}}</td>\n  </tr>\n</table>\n"

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PowerStatGraphIndexController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(857);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var PowerStatGraphIndexController = exports.PowerStatGraphIndexController = function () {
  /*@ngInject*/
  PowerStatGraphIndexController.$inject = ["$cookies"];
  function PowerStatGraphIndexController($cookies) {
    _classCallCheck(this, PowerStatGraphIndexController);

    this.$cookies = $cookies;
    this.type = this.$cookies.get('power_stat_type') || 'event';
  }

  _createClass(PowerStatGraphIndexController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'changeType',
    value: function changeType(type) {
      this.$cookies.put('power_stat_type', type);
      this.type = type;
      this.data.type = type;
    }
  }]);

  return PowerStatGraphIndexController;
}();

exports.default = _angular2.default.module('leptonApp.powerStatGraphIndex', []).component('powerStatGraphIndex', {
  template: __webpack_require__(858),
  controller: PowerStatGraphIndexController,
  bindings: {
    data: '='
  }
}).name;

/***/ }),
/* 857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = "<div class=\"power-stat-graph-tabs\">\n  <div class=\"power-stat-graph-tab\" ng-class=\"{'power-stat-graph-tab-active': ($ctrl.type === 'event')}\"\n       ng-click=\"$ctrl.changeType('event')\">警報発生回数\n  </div>\n  <div class=\"power-stat-graph-tab\" ng-class=\"{'power-stat-graph-tab-active': ($ctrl.type === 'active')}\"\n       ng-click=\"$ctrl.changeType('active')\">平均消費電力\n  </div>\n  <div class=\"power-stat-graph-tab\" ng-class=\"{'power-stat-graph-tab-active': ($ctrl.type === 'demand')}\"\n       ng-click=\"$ctrl.changeType('demand')\">平均デマンド値\n  </div>\n</div>\n<div class=\"power-stat-graph-content\">\n  <power-stat-graph-event ng-show=\"$ctrl.type === 'event'\" data=\"$ctrl.data\"></power-stat-graph-event>\n  <power-stat-graph-active ng-show=\"$ctrl.type === 'active'\" data=\"$ctrl.data\"></power-stat-graph-active>\n  <power-stat-graph-demand ng-show=\"$ctrl.type === 'demand'\" data=\"$ctrl.data\"></power-stat-graph-demand>\n</div>\n"

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PowerStatGraphEventController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _powerStatGraphEvent = __webpack_require__(860);

var _powerStatGraphEvent2 = _interopRequireDefault(_powerStatGraphEvent);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var PowerStatGraphEventController = exports.PowerStatGraphEventController = function () {
  /*@ngInject*/
  PowerStatGraphEventController.$inject = ["$scope", "$filter", "$interval", "moment"];
  function PowerStatGraphEventController($scope, $filter, $interval, moment) {
    var _this = this;

    _classCallCheck(this, PowerStatGraphEventController);

    this.chartConfig = (0, _powerStatGraphEvent2.default)(this);
    this.moment = moment;
    this.$filter = $filter;
    this.$interval = $interval;
    $scope.$watch('$ctrl.data.events', function (newValue) {
      return _this.updateGraph(newValue, _this.data.targetDate);
    });
    $scope.$watch('$ctrl.data.type', function () {
      return _this.reflowGraph();
    });
  }

  _createClass(PowerStatGraphEventController, [{
    key: '$onInit',
    value: function $onInit() {
      this.updateGraph(this.data.events, this.data.targetDate);
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(eventData, targetDate) {
      if (!eventData || !this.chart) {
        return;
      }
      var graphData = this.createGraphData(eventData.current, targetDate);
      this.chart.series[0].setData(graphData);
      this.chart.reflow();
    }
  }, {
    key: 'reflowGraph',
    value: function reflowGraph() {
      var _this2 = this;

      if (!this.chart) {
        return;
      }
      this.$interval(function () {
        _this2.chart.redraw();
        _this2.chart.reflow();
      }, 100);
    }
  }, {
    key: 'createGraphData',
    value: function createGraphData(events, targetDate) {
      var _this3 = this;

      var startDate = targetDate.clone().startOf('month');
      var endDate = targetDate.clone().endOf('month');

      var eventCounts = [];
      var numberOfDays = endDate.diff(startDate, 'days');

      for (var i = 0; i <= numberOfDays; i++) {
        eventCounts.push({ x: startDate.valueOf(), y: 0 });
        startDate.add(1, 'day');
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var event = _step.value;

          if (!event.event_tag.match(/.*_exceeded/)) {
            return 'continue';
          }

          var date = _this3.moment(event.occurred_at).startOf('day').valueOf();
          var countObject = eventCounts.find(function (e) {
            return e.x === date;
          });
          if (countObject) {
            countObject.y += 1;
          }
        };

        for (var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ret = _loop();

          if (_ret === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return eventCounts;
    }
  }]);

  return PowerStatGraphEventController;
}();

exports.default = _angular2.default.module('leptonApp.powerStatGraphEvent', [_angularMoment2.default]).component('powerStatGraphEvent', {
  template: '<chart value="$ctrl.chartConfig"></chart>',
  controller: PowerStatGraphEventController,
  bindings: {
    data: '='
  }
}).name;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  var chartConfig = {
    chart: {
      type: 'line',
      height: 250,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    title: {
      text: '１日あたりの警報発生回数',
      style: { fontSize: '14px' }
    },
    xAxis: {
      crosshair: true,
      labels: {
        formatter: function formatter() {
          var style = '';
          var day = scope.$filter('dayFilter')(this.value);
          if (day === '日') {
            style = 'color: #ff3131';
          } else if (day === '土') {
            style = 'color: #3737ff';
          }

          return '<span style="' + style + '">' + scope.$filter('date')(this.value, 'M/d') + ' (' + day + ')</span>';
        }
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: false
    },
    plotLines: [{
      id: 'target-date'
    }],
    legend: {
      enabled: false
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function formatter() {
        var tip_format = '<tspan style=\'font-size: 12px\'>' + scope.$filter('date')(this.x, 'M/d') + ' (' + scope.$filter('dayFilter')(this.x) + ')</tspan>';

        var pointError = this.points[0];
        tip_format += '<br/><span style="color:' + pointError.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + pointError.series.name + ': ';
        tip_format += pointError.y + " 回";
        tip_format += "</span>";

        return tip_format;
      }
    },
    plotOptions: { column: { grouping: false } },
    series: [{
      name: '警報発生回数',
      color: '#ff3535',
      marker: { enabled: false },
      lineWidth: 1,
      cursor: 'pointer'
    }]
  };

  return chartConfig;
}

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PowerStatGraphActiveController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _powerStatGraphActive = __webpack_require__(862);

var _powerStatGraphActive2 = _interopRequireDefault(_powerStatGraphActive);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var PowerStatGraphActiveController = exports.PowerStatGraphActiveController = function () {
  /*@ngInject*/
  PowerStatGraphActiveController.$inject = ["$scope", "$filter", "$interval", "moment"];
  function PowerStatGraphActiveController($scope, $filter, $interval, moment) {
    var _this = this;

    _classCallCheck(this, PowerStatGraphActiveController);

    this.$filter = $filter;
    this.$interval = $interval;
    this.moment = moment;

    this.WEEK = ['日', '月', '火', '水', '木', '金', '土'];

    this.chartConfig = (0, _powerStatGraphActive2.default)(this);
    $scope.$watch('$ctrl.data.dailyActivePower', function (newValue) {
      return _this.updateGraph(newValue, _this.data.targetDate);
    });
    $scope.$watch('$ctrl.data.type', function () {
      return _this.reflowGraph();
    });
  }

  _createClass(PowerStatGraphActiveController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'updateGraph',
    value: function updateGraph(dailyActivePowers) {
      if (!dailyActivePowers || !this.chart) {
        return;
      }

      var graphData = this.createGraphData(dailyActivePowers.current);

      this.chart.series[0].setData(graphData);
      this.chart.reflow();
    }
  }, {
    key: 'reflowGraph',
    value: function reflowGraph() {
      var _this2 = this;

      if (!this.chart) {
        return;
      }
      this.$interval(function () {
        _this2.chart.redraw();
        _this2.chart.reflow();
      }, 500);
    }
  }, {
    key: 'createGraphData',
    value: function createGraphData(activePowers) {
      if (activePowers.length === 0) {
        return [0, 0, 0, 0, 0, 0, 0];
      }

      var weekAvgs = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.WEEK[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var day = _step.value;

          weekAvgs[day] = { count: 0, sum: 0 };
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = activePowers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var power = _step2.value;

          var _day = this.$filter('dayFilter')(power.date);
          weekAvgs[_day].sum += power.value;
          weekAvgs[_day].count += 1;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var graphData = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.WEEK[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _day2 = _step3.value;

          var avg = 0;
          if (weekAvgs[_day2].count > 0) {
            avg = weekAvgs[_day2].sum / weekAvgs[_day2].count;
          }
          graphData.push(parseFloat(this.$filter('number')(avg, 2).replace(/,/g, '')));
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return graphData;
    }
  }]);

  return PowerStatGraphActiveController;
}();

exports.default = _angular2.default.module('leptonApp.powerStatGraphActive', [_angularMoment2.default]).component('powerStatGraphActive', {
  template: '<chart value="$ctrl.chartConfig"></chart>',
  controller: PowerStatGraphActiveController,
  bindings: {
    data: '='
  }
}).name;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  return {
    chart: {
      type: 'column',
      height: 250,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: {
      text: '曜日毎の平均消費電力',
      style: { fontSize: '14px' }
    },
    legend: { enabled: false },
    xAxis: {
      categories: scope.WEEK,
      crosshair: true,
      labels: {
        formatter: function formatter() {
          var style = '';
          var day = this.value;
          if (day === '日') {
            style = 'color: #ff3131';
          } else if (day === '土') {
            style = 'color: #3737ff';
          }

          return '<span style="' + style + '">' + day + '</span>';
        }
      },
      max: 6
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '平均消費電力 [kWh]',
        style: { 'font-size': '13px' }
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + this.x + "曜日</tspan>";

        var point = this.points[0];
        tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
        tip_format += point.y + " kWh";
        tip_format += "</span>";

        return tip_format;
      }
    },
    plotOptions: {
      column: { grouping: false }
    },
    series: [{
      name: '平均消費電力'
    }]
  };
}

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PowerStatGraphDemandController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _powerStatGraphDemand = __webpack_require__(864);

var _powerStatGraphDemand2 = _interopRequireDefault(_powerStatGraphDemand);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var PowerStatGraphDemandController = exports.PowerStatGraphDemandController = function () {
  /*@ngInject*/
  PowerStatGraphDemandController.$inject = ["$scope", "$interval", "$filter", "moment", "DateUtil"];
  function PowerStatGraphDemandController($scope, $interval, $filter, moment, DateUtil) {
    var _this = this;

    _classCallCheck(this, PowerStatGraphDemandController);

    this.$interval = $interval;
    this.$filter = $filter;
    this.moment = moment;

    this.ticks = DateUtil.getXLabels;
    this.chartConfig = (0, _powerStatGraphDemand2.default)(this);

    $scope.$watch('$ctrl.data.demandPower', function (newValue) {
      return _this.updateGraph(newValue);
    });
    $scope.$watch('$ctrl.data.type', function () {
      return _this.reflowGraph();
    });
  }

  _createClass(PowerStatGraphDemandController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'updateGraph',
    value: function updateGraph(demandPowers) {
      if (!demandPowers || !this.chart) {
        return;
      }

      var graphData = this.createGraphData(demandPowers.current);

      this.chart.series[0].setData(graphData);
      this.chart.reflow();
    }
  }, {
    key: 'createGraphData',
    value: function createGraphData(powers) {
      powers = powers.filter(function (power) {
        return !power.missing;
      });

      if (powers.length === 0) {
        return this.ticks.map(function () {
          return 0;
        });
      }

      var timeAvgs = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.ticks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var time = _step.value;

          timeAvgs[time] = { count: 0, sum: 0 };
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = powers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var power = _step2.value;

          var _time = this.moment(power.measured_at).format('HH:mm');
          timeAvgs[_time].sum += power.value;
          timeAvgs[_time].count += 1;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var graphData = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.ticks[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _time2 = _step3.value;

          var avg = 0;
          if (timeAvgs[_time2].count > 0) {
            avg = timeAvgs[_time2].sum / timeAvgs[_time2].count;
          }
          graphData.push(parseFloat(this.$filter('number')(avg, 2).replace(/,/g, '')));
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return graphData;
    }
  }, {
    key: 'reflowGraph',
    value: function reflowGraph() {
      var _this2 = this;

      if (!this.chart) {
        return;
      }
      this.$interval(function () {
        _this2.chart.redraw();
        _this2.chart.reflow();
      }, 500);
    }
  }]);

  return PowerStatGraphDemandController;
}();

exports.default = _angular2.default.module('leptonApp.powerStatGraphDemand', [_angularMoment2.default, _date_util2.default]).component('powerStatGraphDemand', {
  template: '<chart value="$ctrl.chartConfig"></chart>',
  controller: PowerStatGraphDemandController,
  bindings: {
    data: '='
  }
}).name;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  return {
    chart: {
      type: 'column',
      height: 250,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: {
      text: '時間毎の平均デマンド値',
      style: { fontSize: '14px' }
    },
    legend: { enabled: false },
    xAxis: {
      categories: scope.ticks,
      crosshair: true
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: 'デマンド値の平均 [kW]',
        style: { 'font-size': '13px' }
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + this.x + "</tspan>";

        var point = this.points[0];
        tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
        tip_format += point.y + " kW";
        tip_format += "</span>";

        return tip_format;
      }
    },
    plotOptions: {
      column: { grouping: false }
    },
    series: [{
      name: 'デマンド値の平均',
      color: '#1F85CF'
    }]
  };
}

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WeatherCorrelationGraphController = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _weatherCorrelationGraph = __webpack_require__(866);

var _weatherCorrelationGraph2 = _interopRequireDefault(_weatherCorrelationGraph);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var WeatherCorrelationGraphController = exports.WeatherCorrelationGraphController = function () {
  /*@ngInject*/
  WeatherCorrelationGraphController.$inject = ["$scope", "$filter", "moment"];
  function WeatherCorrelationGraphController($scope, $filter, moment) {
    var _this = this;

    _classCallCheck(this, WeatherCorrelationGraphController);

    this.$filter = $filter;

    this.chartConfig = (0, _weatherCorrelationGraph2.default)(this);

    $scope.$watch('$ctrl.data.dailyActivePower', function (newValue) {
      return _this.updateGraph(newValue);
    });
  }

  _createClass(WeatherCorrelationGraphController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'updateGraph',
    value: function updateGraph(dailyActivePowerData) {
      if (!dailyActivePowerData || !this.chart) {
        return;
      }

      var dailyActivePower = dailyActivePowerData.current;
      var dailyWeather = dailyActivePowerData.currentWeather;

      var _createGraphData = this.createGraphData(dailyActivePower, dailyWeather),
          _createGraphData2 = _slicedToArray(_createGraphData, 2),
          categories = _createGraphData2[0],
          graphData = _createGraphData2[1];

      this.chart.xAxis[0].setCategories(categories);
      this.chart.series[0].setData(graphData);
      this.chart.reflow();
    }
  }, {
    key: 'createGraphData',
    value: function createGraphData(dailyPowers, weathers) {
      if (dailyPowers.length === 0) {
        return [];
      }

      var avgs = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var weather = _step.value;

          if (!weather.icon_id) {
            return 'continue';
          }
          var iconId = weather.icon_id.replace().slice(0, 2);
          if (!iconId) {
            return 'continue';
          }

          if (iconId === '04') {
            iconId = '03';
          }
          if (!avgs[iconId]) {
            avgs[iconId] = { count: 0, sum: 0 };
          }

          var powers = dailyPowers.filter(function (e) {
            return e.date === weather.date;
          });
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = powers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var power = _step3.value;

              avgs[iconId].count += 1;
              avgs[iconId].sum += power.value;
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        };

        for (var _iterator = weathers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ret = _loop();

          if (_ret === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var categories = [];
      var graphData = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Object.keys(avgs)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var key = _step2.value;

          if (avgs[key].count === 0) {
            continue;
          }
          categories.push(key);
          var avg = avgs[key].sum / avgs[key].count;
          graphData.push(parseFloat(this.$filter('number')(avg, 2).replace(/,/g, '')));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return [categories, graphData];
    }
  }]);

  return WeatherCorrelationGraphController;
}();

exports.default = _angular2.default.module('leptonApp.weatherCorrelationGraph', [_angularMoment2.default]).component('weatherCorrelationGraph', {
  template: '<chart value="$ctrl.chartConfig"></chart>',
  controller: WeatherCorrelationGraphController,
  bindings: {
    data: '='
  }
}).name;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  return {
    chart: {
      type: 'column',
      height: 250,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: {
      text: '天候毎の平均消費電力',
      style: { fontSize: '14px' }
    },
    legend: { enabled: false },
    xAxis: {
      crosshair: true,
      labels: {
        useHTML: true,
        formatter: function formatter() {
          if (typeof this.value !== 'string') {
            return;
          }
          return '<img class="statistics-weather-icon" src="vendor/weather-icons/' + this.value + 'd.png"/>';
        }
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '平均消費電力 [kWh]',
        style: { 'font-size': '13px' }
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      useHTML: true,
      formatter: function formatter() {
        return "\u5E73\u5747\u6D88\u8CBB\u96FB\u529B: " + this.y + ' kWh';
      }
    },
    plotOptions: {
      column: { grouping: false }
    },
    series: [{
      name: '平均消費電力'
    }]
  };
}

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TempCorrelationGraphController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _tempCorrelationGraph = __webpack_require__(868);

var _tempCorrelationGraph2 = _interopRequireDefault(_tempCorrelationGraph);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var TempCorrelationGraphController = exports.TempCorrelationGraphController = function () {
  /*@ngInject*/
  TempCorrelationGraphController.$inject = ["$scope", "$filter"];
  function TempCorrelationGraphController($scope, $filter) {
    var _this = this;

    _classCallCheck(this, TempCorrelationGraphController);

    this.$filter = $filter;
    this.chartConfig = (0, _tempCorrelationGraph2.default)(this);
    $scope.$watch('$ctrl.data.dailyActivePower', function (newValue) {
      return _this.updateGraph(newValue);
    });
  }

  _createClass(TempCorrelationGraphController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'updateGraph',
    value: function updateGraph(dailyActivePowerData) {
      if (!dailyActivePowerData || !this.chart) {
        return;
      }

      var dailyActivePower = dailyActivePowerData.current;
      var dailyWeather = dailyActivePowerData.currentWeather;
      var graphData = this.createGraphData(dailyActivePower, dailyWeather);

      this.chart.series[0].setData(graphData);
      this.chart.reflow();
    }
  }, {
    key: 'createGraphData',
    value: function createGraphData(dailyPowers, weathers) {
      var _this2 = this;

      if (dailyPowers.length === 0) {
        return [];
      }

      var graphData = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var weather = _step.value;

          if (!weather.temp) {
            return 'continue';
          }
          var power = dailyPowers.filter(function (e) {
            return e.date === weather.date;
          })[0];
          if (power) {
            var temp = parseFloat(_this2.$filter('number')(weather.temp, 1));
            graphData.push({ x: temp, y: power.value });
          }
        };

        for (var _iterator = weathers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ret = _loop();

          if (_ret === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return graphData;
    }
  }]);

  return TempCorrelationGraphController;
}();

exports.default = _angular2.default.module('leptonApp.tempCorrelationGraph', [_angularMoment2.default]).component('tempCorrelationGraph', {
  template: '<chart value="$ctrl.chartConfig"></chart>',
  controller: TempCorrelationGraphController,
  bindings: {
    data: '='
  }
}).name;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  return {
    chart: {
      type: 'scatter',
      height: 250,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: {
      text: '１日の平均気温と消費電力の相関',
      style: { fontSize: '14px' }
    },
    legend: { enabled: false },
    xAxis: {
      title: {
        text: '１日の平均気温 [℃]'
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '消費電力 [kWh]',
        style: { 'font-size': '13px' }
      }
    },
    tooltip: {
      enabled: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>１日の平均気温: " + this.x + " ℃</tspan>";
        tip_format += "<br/><tspan style='font-size: 12px'>消費電力: " + this.y + " kWh</tspan>";

        return tip_format;
      }
    },
    plotOptions: {
      column: { grouping: false }
    },
    series: [{
      name: '消費電力'
    }]
  };
}

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareModalController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

__webpack_require__(870);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var CompareModalController = exports.CompareModalController = function () {
  /*@ngInject*/
  CompareModalController.$inject = ["$cookies", "$mdDialog", "$stateParams", "SaConfigService"];
  function CompareModalController($cookies, $mdDialog, $stateParams, SaConfigService) {
    var _this = this;

    _classCallCheck(this, CompareModalController);

    this.SaConfigService = SaConfigService;
    this.$cookies = $cookies;
    this.$mdDialog = $mdDialog;
    this.$stateParams = $stateParams;

    this.sa_configs = [];
    this.type = this.$cookies.get('report_type') || 'demand';
    this.term = this.$cookies.get('report_term') || 'daily';
    this.graphType = 'bar';

    /*@ngInject*/
    this.CompareDialogController = function ($scope, $mdDialog, $state, sa_configs, type, term, graphType) {
      $scope.sa_configs = sa_configs;
      $scope.type = type;
      $scope.term = term;
      $scope.graphType = graphType;

      var currentConfig = $scope.sa_configs.find(function (e) {
        return e.id == _this.$stateParams.id;
      });
      if (currentConfig) {
        currentConfig.checked = true;
      }

      $scope.closeDialog = function () {
        $mdDialog.hide();
      };

      $scope.submit = function () {
        $mdDialog.hide();
        var checkedList = $scope.sa_configs.filter(function (e) {
          return e.checked;
        });
        $state.go('main.compare_graph_show', {
          ids: checkedList.map(function (e) {
            return e.id;
          }),
          type: $scope.type,
          term: $scope.term,
          graphType: $scope.graphType
        });
      };
    };
    this.CompareDialogController.$inject = ["$scope", "$mdDialog", "$state", "sa_configs", "type", "term", "graphType"];
  }

  _createClass(CompareModalController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.text = this.value || '他の拠点と比較';
      this.SaConfigService.api.index(function (res) {
        _this2.sa_configs = res;
      });
    }
  }, {
    key: 'showDialog',
    value: function showDialog($event) {
      var parent = _angular2.default.element(document.body);
      this.$mdDialog.show({
        parent: parent,
        targetEvent: $event,
        template: __webpack_require__(871),
        locals: {
          sa_configs: this.sa_configs,
          type: this.type,
          term: this.term,
          graphType: this.graphType
        },
        controller: this.CompareDialogController
      });
    }
  }]);

  return CompareModalController;
}();

exports.default = _angular2.default.module('leptonApp.compareModal', [_sa_config2.default]).component('compareModal', {
  template: __webpack_require__(872),
  controller: CompareModalController,
  bindings: {
    value: '='
  }
}).name;

/***/ }),
/* 870 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports = "<md-dialog aria-label=\"compare dialog\">\n  <md-dialog-content>\n    <div class=\"compare-modal-header\">\n      <div class=\"compare-modal-title\">比較する拠点を選択</div>\n      <md-select ng-model=\"graphType\" placeholder=\"Select a graph type\">\n        <md-option ng-value=\"'bar'\">棒グラフ</md-option>\n        <md-option ng-value=\"'line'\">線グラフ</md-option>\n      </md-select>\n    </div>\n    <div class=\"compare-modal-list\">\n      <div class=\"compare-modal-item\" ng-repeat=\"sa_config in sa_configs\" ng-click=\"sa_config.checked = !sa_config.checked\">\n        <div class=\"compare-modal-item-check\">\n          <i class=\"far fa-square\" ng-if=\"!sa_config.checked\"></i>\n          <i class=\"far fa-check-square\" ng-if=\"sa_config.checked\"></i>\n        </div>\n        <div class=\"compare-modal-item-text\">\n          <p class=\"compare-modal-item-location\">{{sa_config.location}}</p>\n          <p class=\"compare-modal-item-memo\">{{sa_config.memo}}</p>\n        </div>\n      </div>\n    </div>\n  </md-dialog-content>\n  <md-dialog-actions>\n    <button ng-click=\"closeDialog()\" class=\"button button-normal\">キャンセル</button>\n    <button ng-click=\"submit()\" class=\"button button-main\">比較</button>\n  </md-dialog-actions>\n</md-dialog>\n"

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports = "<span class=\"span-link\" ng-click=\"$ctrl.showDialog($event)\">{{ $ctrl.text }}</span>\n"

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareGraphController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _compareGraphShow = __webpack_require__(874);

var _compareGraphShow2 = _interopRequireDefault(_compareGraphShow);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _compare_bookmark = __webpack_require__(495);

var _compare_bookmark2 = _interopRequireDefault(_compare_bookmark);

__webpack_require__(875);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var CompareGraphController = exports.CompareGraphController = function () {
  /*@ngInject*/
  CompareGraphController.$inject = ["$stateParams", "$state", "$scope", "$location", "$interval", "$mdDialog", "moment", "SaConfigService", "CompareBookmarkService"];
  function CompareGraphController($stateParams, $state, $scope, $location, $interval, $mdDialog, moment, SaConfigService, CompareBookmarkService) {
    _classCallCheck(this, CompareGraphController);

    this.$state = $state;
    this.$location = $location;
    this.$mdDialog = $mdDialog;
    this.moment = moment;

    this.SaConfigService = SaConfigService;
    this.CompareBookmarkService = CompareBookmarkService;

    var idList = $stateParams.ids.split(',');
    this.configIds = [];
    if (idList[0] !== '') {
      this.configIds = idList.map(function (e) {
        return parseInt(e);
      });
    }

    this.type = $stateParams.type;
    this.term = $stateParams.term;
    this.graphType = $stateParams.graphType;
    this.registered = false;
    this.query = $stateParams.ids + '?type=' + $stateParams.type + '&term=' + $stateParams.term + '&graphType=' + $stateParams.graphType;
    this.targetDate = $stateParams.date ? new Date(parseInt($stateParams.date)) : moment().startOf('day').toDate();
    this.weekTargetDate = $stateParams.wdate ? new Date(parseInt($stateParams.wdate)) : moment().startOf('week').toDate();
    this.monthTargetDate = $stateParams.mdate ? new Date(parseInt($stateParams.mdate)) : new Date();

    this.saConfigs = [];
    this.selectedConfigs = [];
  }

  _createClass(CompareGraphController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.CompareBookmarkService.show({ id: this.query }, function (res) {
        _this.registered = true;
        _this.bookmarkName = res.name;
      });

      this.SaConfigService.api.index(function (res) {
        _this.saConfigs = res;
        var selectedConfigs = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _this.saConfigs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var config = _step.value;

            if (_this.configIds.indexOf(config.id) !== -1) {
              selectedConfigs.push(config);
              config.checked = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this.selectedConfigs = selectedConfigs;
      });
    }
  }, {
    key: 'changeType',
    value: function changeType(type) {
      this.type = type;
      this.updateParam();
    }
  }, {
    key: 'changeTerm',
    value: function changeTerm(term) {
      this.term = term;
      this.updateParam(true);
    }
  }, {
    key: 'changeGraphType',
    value: function changeGraphType(graphType) {
      this.graphType = graphType;
      this.updateParam();
    }
  }, {
    key: 'updateParam',
    value: function updateParam(resetDate) {
      this.$state.go('main.compare_graph_show', {
        ids: this.configIds,
        type: this.type,
        term: this.term,
        graphType: this.graphType,
        date: resetDate ? this.moment().startOf('day').valueOf() : this.targetDate.valueOf(),
        mdate: resetDate ? this.moment().valueOf() : this.monthTargetDate.valueOf(),
        wdate: resetDate ? this.moment().startOf('week').valueOf() : this.weekTargetDate.valueOf()
      });
    }
  }, {
    key: 'addList',
    value: function addList(name) {
      var _this2 = this;

      this.CompareBookmarkService.create({
        name: name,
        query: this.query
      }, function (res) {
        _this2.registered = true;
        _this2.bookmarkName = res.name;
      });
    }
  }, {
    key: 'changeTargetDate',
    value: function changeTargetDate(date) {
      this.targetDate = date;
    }
  }, {
    key: 'changeWeekTargetDate',
    value: function changeWeekTargetDate(date) {
      this.weekTargetDate = date;
    }
  }, {
    key: 'changeMonthTargetDate',
    value: function changeMonthTargetDate(date) {
      this.monthTargetDate = date;
    }
  }, {
    key: 'toggleBookmark',
    value: function toggleBookmark($event) {
      var _this3 = this;

      if (this.registered) {
        this.CompareBookmarkService.destroy({ id: this.query }, function () {
          _this3.registered = false;
        });
        return;
      }

      var parent = _angular2.default.element(document.body);
      this.$mdDialog.show({
        parent: parent,
        targetEvent: $event,
        template: __webpack_require__(876),
        /*@ngInject*/
        controller: ["$scope", "$mdDialog", "$filter", function controller($scope, $mdDialog, $filter) {
          $scope.bookmarkName = '';
          $scope.defaultName = "\u6BD4\u8F03\u30B0\u30E9\u30D5\uFF08" + $filter('date')(new Date(), 'yyyy-MM-dd') + "\uFF09";

          $scope.closeDialog = function () {
            $mdDialog.cancel();
          };

          $scope.enterInput = function ($event) {
            if ($event.which === 13) {
              $scope.submit();
            }
          };

          $scope.submit = function () {
            var name = $scope.bookmarkName;
            if (name === '') {
              name = $scope.defaultName;
            }
            $mdDialog.hide(name);
          };
        }]
      }).then(function (name) {
        _this3.addList(name);
      });
    }
  }]);

  return CompareGraphController;
}();

exports.default = _angular2.default.module('leptonApp.compareGraph', [_angularMoment2.default, _sa_config2.default, _compare_bookmark2.default]).config(_compareGraphShow2.default).component('compareGraph', {
  template: __webpack_require__(877),
  controller: CompareGraphController
}).name;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.compare_graph_show', {
    url: 'compare/:ids?:type&:term&:graphType&:date&:mdate&:wdate',
    template: '<compare-graph></compare-graph>'
  });
}

/***/ }),
/* 875 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports = "<md-dialog aria-label=\"compare dialog\">\n  <md-dialog-content>\n    <md-input-container class=\"md-block compare-modal-input\" style=\"margin: 25px 20px 0;\">\n      <label>表示名を入力</label>\n      <input name=\"name\" ng-model=\"bookmarkName\" maxlength=\"128\"\n             placeholder=\"{{defaultName}}\" md-autofocus ng-keydown=\"enterInput($event)\">\n    </md-input-container>\n  </md-dialog-content>\n  <md-dialog-actions>\n    <button ng-click=\"closeDialog()\" class=\"button button-normal\">キャンセル</button>\n    <button ng-click=\"submit()\" class=\"button button-main\">登録</button>\n  </md-dialog-actions>\n</md-dialog>\n"

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports = "<div class=\"compare-graph-header-content\">\n  <div class='demand-report-tabs compare-graph-tabs'>\n    <div class='demand-report-tab' ng-class=\"{'demand-report-tab-active': ($ctrl.type === 'demand')}\"\n         ng-click=\"$ctrl.changeType('demand')\">\n      デマンド実績\n    </div>\n    <div class='demand-report-tab' ng-class=\"{'demand-report-tab-active': ($ctrl.type === 'active')}\"\n         ng-click=\"$ctrl.changeType('active')\">\n      消費実績\n    </div>\n  </div>\n  <div class=\"compare-graph-bookmark-area\">\n    <div class=\"compare-graph-bookmark-button\" ng-click=\"$ctrl.toggleBookmark(event)\">\n      <span ng-if=\"$ctrl.registered\">\n        <i class=\"fas fa-star\"></i> {{$ctrl.bookmarkName}}\n      </span>\n      <span ng-if=\"!$ctrl.registered\">\n        <i class=\"far fa-star\"></i> リストに登録\n      </span>\n    </div>\n  </div>\n</div>\n<md-divider></md-divider>\n<div class=\"align-right\">\n  <div></div>\n  <div class='demand-report-tabs2'>\n    <div class='demand-report-tab2' ng-class=\"{'demand-report-tab2-active': ($ctrl.term === 'daily')}\"\n         ng-click=\"$ctrl.changeTerm('daily')\">\n      日間\n    </div>\n    <div class='demand-report-tab2' ng-class=\"{'demand-report-tab2-active': ($ctrl.term === 'weekly')}\"\n         ng-click=\"$ctrl.changeTerm('weekly')\">\n      週間\n    </div>\n    <div class='demand-report-tab2' ng-class=\"{'demand-report-tab2-active': ($ctrl.term === 'monthly')}\"\n         ng-click=\"$ctrl.changeTerm('monthly')\">\n      月間\n    </div>\n    <div class='demand-report-tab2' ng-class=\"{'demand-report-tab2-active': ($ctrl.term === 'yearly')}\"\n         ng-click=\"$ctrl.changeTerm('yearly')\">\n      年間\n    </div>\n  </div>\n</div>\n<div class=\"align-right\" ng-if=\"!($ctrl.type === 'hist' || $ctrl.type === 'event')\">\n  <div></div>\n  <div class='compare-graph-select-graph'>\n    <md-select ng-model=\"$ctrl.graphType\" ng-change=\"$ctrl.changeGraphType($ctrl.graphType)\"\n               placeholder=\"Select a graph type\">\n      <md-option ng-value=\"'bar'\">棒グラフ</md-option>\n      <md-option ng-value=\"'line'\">線グラフ</md-option>\n    </md-select>\n  </div>\n</div>\n\n<compare-graph-daily-demand\n        class=\"compare-graph\"\n        selected-configs=\"$ctrl.selectedConfigs\" config-ids=\"$ctrl.saConfigIds\" graph-type=\"$ctrl.graphType\"\n        target-date=\"$ctrl.targetDate\"\n        update-target-date=\"$ctrl.changeTargetDate(targetDate)\"\n        ng-if=\"$ctrl.type === 'demand' && $ctrl.term === 'daily'\"></compare-graph-daily-demand>\n<compare-graph-weekly-demand\n        class=\"compare-graph\"\n        target-date=\"$ctrl.weekTargetDate\"\n        update-target-date=\"$ctrl.changeWeekTargetDate(targetDate)\"\n        selected-configs=\"$ctrl.selectedConfigs\" config-ids=\"$ctrl.saConfigIds\" graph-type=\"$ctrl.graphType\"\n        ng-if=\"$ctrl.type === 'demand' && $ctrl.term === 'weekly'\"></compare-graph-weekly-demand>\n<compare-graph-monthly-demand\n        class=\"compare-graph\"\n        target-date=\"$ctrl.monthTargetDate\"\n        update-target-date=\"$ctrl.changeMonthTargetDate(targetDate)\"\n        selected-configs=\"$ctrl.selectedConfigs\" config-ids=\"$ctrl.saConfigIds\" graph-type=\"$ctrl.graphType\"\n        ng-if=\"$ctrl.type === 'demand' && $ctrl.term === 'monthly'\"></compare-graph-monthly-demand>\n<compare-graph-yearly-demand\n        class=\"compare-graph\"\n        selected-configs=\"$ctrl.selectedConfigs\" config-ids=\"$ctrl.saConfigIds\" graph-type=\"$ctrl.graphType\"\n        ng-if=\"$ctrl.type === 'demand' && $ctrl.term === 'yearly'\"></compare-graph-yearly-demand>\n<compare-graph-daily-active\n        class=\"compare-graph\"\n        selected-configs=\"$ctrl.selectedConfigs\" config-ids=\"$ctrl.saConfigIds\" graph-type=\"$ctrl.graphType\"\n        target-date=\"$ctrl.targetDate\"\n        update-target-date=\"$ctrl.changeTargetDate(targetDate)\"\n        ng-if=\"$ctrl.type === 'active' && $ctrl.term === 'daily'\"></compare-graph-daily-active>\n<compare-graph-weekly-active\n        class=\"compare-graph\"\n        target-date=\"$ctrl.weekTargetDate\"\n        update-target-date=\"$ctrl.changeWeekTargetDate(targetDate)\"\n        selected-configs=\"$ctrl.selectedConfigs\" config-ids=\"$ctrl.saConfigIds\" graph-type=\"$ctrl.graphType\"\n        ng-if=\"$ctrl.type === 'active' && $ctrl.term === 'weekly'\"></compare-graph-weekly-active>\n<compare-graph-monthly-active\n        class=\"compare-graph\"\n        target-date=\"$ctrl.monthTargetDate\"\n        update-target-date=\"$ctrl.changeMonthTargetDate(targetDate)\"\n        selected-configs=\"$ctrl.selectedConfigs\" config-ids=\"$ctrl.saConfigIds\" graph-type=\"$ctrl.graphType\"\n        ng-if=\"$ctrl.type === 'active' && $ctrl.term === 'monthly'\"></compare-graph-monthly-active>\n<compare-graph-yearly-active\n        class=\"compare-graph\"\n        selected-configs=\"$ctrl.selectedConfigs\" config-ids=\"$ctrl.saConfigIds\" graph-type=\"$ctrl.graphType\"\n        ng-if=\"$ctrl.type === 'active' && $ctrl.term === 'yearly'\"></compare-graph-yearly-active>\n\n<div class=\"compare-graph-config-list\">\n  <device-check-list device-list=\"$ctrl.saConfigs\" selected-list=\"$ctrl.configIds\" update-param=\"$ctrl.updateParam()\"\n                     disable-all=\"true\"></device-check-list>\n</div>\n"

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareGraphDailyDemandController = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _compareGraphDaily = __webpack_require__(879);

var _compareGraphDaily2 = _interopRequireDefault(_compareGraphDaily);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _demand_power = __webpack_require__(202);

var _demand_power2 = _interopRequireDefault(_demand_power);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var CompareGraphDailyDemandController = exports.CompareGraphDailyDemandController = function () {
  /*@ngInject*/
  CompareGraphDailyDemandController.$inject = ["$filter", "$interval", "$q", "$scope", "moment", "DateUtil", "DemandPowerService", "PowerFormatter"];
  function CompareGraphDailyDemandController($filter, $interval, $q, $scope, moment, DateUtil, DemandPowerService, PowerFormatter) {
    var _this = this;

    _classCallCheck(this, CompareGraphDailyDemandController);

    this.$interval = $interval;
    this.$filter = $filter;
    this.$q = $q;
    this.moment = moment;
    this.DateUtil = DateUtil;
    this.DemandPowerService = DemandPowerService;
    this.PowerFormatter = PowerFormatter;
    this.graphUpdating = false;

    this.categories = DateUtil.getXLabels;
    this.maxDate = moment().startOf('day').toDate();
    this.seriesList = [];

    this.chartConfig = (0, _compareGraphDaily2.default)(this);

    $scope.$watch('$ctrl.selectedConfigs', function () {
      return _this.updateGraph(_this.targetDate);
    });
    $scope.$watch('$ctrl.targetDate', function () {
      return _this.updateGraph(_this.targetDate);
    });
  }

  _createClass(CompareGraphDailyDemandController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.timer = this.$interval(function () {
        _this2.updateGraph(_this2.targetDate);
      }, 300000);
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(targetDate) {
      var _this3 = this;

      if (this.chart) {
        this.chart.reflow();
      }
      if (this.selectedConfigs.length === 0) {
        return;
      }
      this.graphUpdating = true;
      this.resetSeries();

      var promises = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.selectedConfigs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var config = _step.value;

          promises.push(this.getDemandData(config, targetDate));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$q.all(promises).then(function (results) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = results[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var result = _step2.value;

            _this3.addSeries(result.demandPowers, result.config);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this3.chart.redraw();
        _this3.chart.reflow();
        _this3.graphUpdating = false;
      });
    }
  }, {
    key: 'getDemandData',
    value: function getDemandData(config, targetDate) {
      var _this4 = this;

      var dateQuery = this.DateUtil.getQueryParams(targetDate);
      var query = _angular2.default.extend({ id: config.id }, dateQuery);

      return new Promise(function (resolve) {
        _this4.DemandPowerService.show(query, function (res) {
          var _PowerFormatter$forma = _this4.PowerFormatter.formatDemandPowers(res.powers, targetDate, _this4.categories),
              _PowerFormatter$forma2 = _slicedToArray(_PowerFormatter$forma, 1),
              demandPowers = _PowerFormatter$forma2[0];

          resolve({ demandPowers: demandPowers, config: config });
        });
      });
    }
  }, {
    key: 'addSeries',
    value: function addSeries(powers, config) {
      if (!powers) {
        return;
      }
      var graphData = this.categories.map(function (e, i) {
        return [e, powers[i]];
      });
      this.chart.addSeries({
        name: config.pms_service_code,
        type: this.graphType,
        data: graphData
      }, false);
    }
  }, {
    key: 'resetSeries',
    value: function resetSeries() {
      if (!this.chart) {
        return;
      }
      while (this.chart.series.length > 0) {
        this.chart.series[0].remove(false);
      }
    }
  }, {
    key: 'changeDate',
    value: function changeDate(diff) {
      if (diff) {
        this.updateTargetDate({ targetDate: this.DateUtil.leapDate(this.targetDate, diff) });
      }
    }
  }]);

  return CompareGraphDailyDemandController;
}();

exports.default = _angular2.default.module('leptonApp.compareGraphDailyDemand', [_angularMoment2.default, _date_util2.default, _demand_power2.default, _powerFormatter2.default]).component('compareGraphDailyDemand', {
  template: __webpack_require__(880),
  controller: CompareGraphDailyDemandController,
  bindings: {
    selectedConfigs: '=',
    configIds: '=',
    graphType: '=',
    targetDate: '=',
    updateTargetDate: '&'
  }
}).name;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  var chartConfig = {
    chart: {
      height: 300,

      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },

    title: { text: '1日のデマンド実績' },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      rotation: -45
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力値 [kW]'
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      reversed: true
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + this.x + "</tspan>";

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var point = _step.value;

            tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
            tip_format += point.y + " kW";
            tip_format += "</span>";
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return tip_format;
      }
    },
    series: []
  };

  return chartConfig;
};

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component compare-graph-date-component\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <md-button ng-disabled=\"$ctrl.graphUpdating\" ng-click=\"$ctrl.changeDate(-1)\" class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-left\"></i>\n    </md-button>\n    <div datepicker class=\"date-picker\" ng-model=\"$ctrl.targetDate\" ng-change=\"$ctrl.changeDate()\"\n         max-date=\"$ctrl.maxDate\">{{$ctrl.targetDate | date: 'yyyy/MM/dd'}}<i class=\"fa fa-sort-down\"\n                                                                              aria-hidden=\"true\"></i></div>\n    <md-button ng-disabled=\"$ctrl.targetDate.valueOf() === $ctrl.maxDate.valueOf() || $ctrl.graphUpdating\" ng-click=\"$ctrl.changeDate(1)\"\n               class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-right\"></i>\n    </md-button>\n  </div>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n</md-content>\n"

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareGraphWeeklyDemandController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

var _daily_max_demand_power = __webpack_require__(220);

var _daily_max_demand_power2 = _interopRequireDefault(_daily_max_demand_power);

var _compareGraphWeekly = __webpack_require__(882);

var _compareGraphWeekly2 = _interopRequireDefault(_compareGraphWeekly);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var CompareGraphWeeklyDemandController = exports.CompareGraphWeeklyDemandController = function () {
  /*@ngInject*/
  CompareGraphWeeklyDemandController.$inject = ["$filter", "$scope", "$q", "moment", "DateUtil", "PowerFormatter", "DailyMaxDemandPowerService"];
  function CompareGraphWeeklyDemandController($filter, $scope, $q, moment, DateUtil, PowerFormatter, DailyMaxDemandPowerService) {
    var _this = this;

    _classCallCheck(this, CompareGraphWeeklyDemandController);

    this.$filter = $filter;
    this.moment = moment;
    this.$q = $q;
    this.DateUtil = DateUtil;
    this.PowerFormatter = PowerFormatter;
    this.DailyMaxDemandPowerService = DailyMaxDemandPowerService;

    this.startDate = this.DateUtil.beginningOfWeek(new Date());
    this.endDate = this.DateUtil.leapDate(this.startDate, 6);
    this.maxDate = this.DateUtil.beginningOfWeek(new Date());
    this.categories = [];
    this.Week = ['日', '月', '火', '水', '木', '金', '土'];
    this.graphUpdating = false;

    this.chartConfig = (0, _compareGraphWeekly2.default)(this);

    $scope.$watch('$ctrl.selectedConfigs', function () {
      return _this.updateGraph(_this.startDate, _this.endDate);
    });
    $scope.$watch('$ctrl.targetDate', function () {
      if (!_this.targetDate) {
        return;
      }
      _this.startDate = _this.targetDate;
      _this.endDate = _this.DateUtil.leapDate(_this.startDate, 6);

      _this.updateGraph(_this.startDate, _this.endDate);
    });
  }

  _createClass(CompareGraphWeeklyDemandController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'changeDate',
    value: function changeDate(diff) {
      this.updateTargetDate({ targetDate: this.DateUtil.leapDate(this.startDate, diff) });
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(startDate, endDate) {
      var _this2 = this;

      if (this.chart) {
        this.chart.reflow();
      }
      if (this.selectedConfigs.length === 0) {
        return;
      }
      this.graphUpdating = true;
      this.resetSeries();

      this.categories = [];
      for (var i = 0; i < 7; i++) {
        var utc = this.DateUtil.localToUTC(startDate);
        this.categories.push(this.DateUtil.leapDate(utc, i).valueOf());
      }
      this.chart.xAxis[0].setCategories(this.categories);

      var promises = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.selectedConfigs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var config = _step.value;

          promises.push(this.getDemandData(config, this.categories, startDate, endDate));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$q.all(promises).then(function (results) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = results[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var result = _step2.value;

            _this2.addSeries(result.powers, result.config);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this2.chart.redraw();
        _this2.chart.reflow();
        _this2.graphUpdating = false;
      });
    }
  }, {
    key: 'getDemandData',
    value: function getDemandData(config, categories, startDate, endDate) {
      var _this3 = this;

      var dateQuery = this.DateUtil.getDateRangeQueries(startDate, endDate);
      var query = _angular2.default.extend({ id: config.id }, dateQuery);

      return new Promise(function (resolve) {
        _this3.DailyMaxDemandPowerService.show(query, function (res) {
          var powers = _this3.PowerFormatter.formatDailyDemandPowers(res.powers, categories);
          resolve({ powers: powers, config: config });
        });
      });
    }
  }, {
    key: 'addSeries',
    value: function addSeries(powers, config) {
      var _this4 = this;

      if (!powers) {
        return;
      }
      var graphData = this.categories.map(function (e, i) {
        var label = _this4.moment(e).format('MM/DD');
        return [label, powers[i].y];
      });
      this.chart.addSeries({
        name: config.pms_service_code,
        type: this.graphType,
        data: graphData
      }, false);
    }
  }, {
    key: 'resetSeries',
    value: function resetSeries() {
      if (!this.chart) {
        return;
      }
      while (this.chart.series.length > 0) {
        this.chart.series[0].remove(false);
      }
    }
  }]);

  return CompareGraphWeeklyDemandController;
}();

exports.default = _angular2.default.module('leptonApp.compareGraphWeeklyDemand', [_angularMoment2.default, _date_util2.default, _powerFormatter2.default, _daily_max_demand_power2.default]).component('compareGraphWeeklyDemand', {
  template: __webpack_require__(883),
  controller: CompareGraphWeeklyDemandController,
  bindings: {
    selectedConfigs: '=',
    configIds: '=',
    graphType: '=',
    targetDate: '=',
    updateTargetDate: '&'
  }
}).name;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  return {
    chart: {
      height: 300,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    title: { text: '1週間のデマンド実績' },
    xAxis: {
      crosshair: true,
      labels: {
        formatter: function formatter() {
          var style = '';
          var day = scope.$filter('dayFilter')(this.value);

          if (day === '日') {
            style = 'color: #ff3131';
          } else if (day === '土') {
            style = 'color: #3737ff';
          }

          return '<span style="' + style + '">' + scope.$filter('date')(this.value, 'MM月dd日') + ' (' + day + ')</span>';
        },
        rotation: 0
      },
      max: 6
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力値 [kW]'
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      reversed: true
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + scope.$filter('date')(this.x, 'MM月dd日') + "</tspan>";

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var point = _step.value;

            tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
            tip_format += point.y + " kW";
            tip_format += "</span>";
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return tip_format;
      }
    },
    plotOptions: { column: { grouping: true } },
    series: []
  };
}

/***/ }),
/* 883 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: -25px 0 5px 7px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <md-button ng-disabled=\"$ctrl.graphUpdating\" ng-click=\"$ctrl.changeDate(-7)\" class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-left\"></i>\n    </md-button>\n    <span>{{$ctrl.startDate | date : 'MM月dd日'}} ~ {{$ctrl.endDate | date : 'MM月dd日'}}</span>\n    <md-button ng-disabled=\"$ctrl.startDate.valueOf() === $ctrl.maxDate.valueOf() || $ctrl.graphUpdating\" ng-click=\"$ctrl.changeDate(7)\"\n               class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-right\"></i>\n    </md-button>\n  </div>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n</md-content>\n"

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareGraphMonthlyDemandController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

var _daily_max_demand_power = __webpack_require__(220);

var _daily_max_demand_power2 = _interopRequireDefault(_daily_max_demand_power);

var _compareGraphMonthly = __webpack_require__(885);

var _compareGraphMonthly2 = _interopRequireDefault(_compareGraphMonthly);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var CompareGraphMonthlyDemandController = exports.CompareGraphMonthlyDemandController = function () {
  /*@ngInject*/
  CompareGraphMonthlyDemandController.$inject = ["$filter", "$scope", "$q", "moment", "DateUtil", "PowerFormatter", "DailyMaxDemandPowerService"];
  function CompareGraphMonthlyDemandController($filter, $scope, $q, moment, DateUtil, PowerFormatter, DailyMaxDemandPowerService) {
    var _this = this;

    _classCallCheck(this, CompareGraphMonthlyDemandController);

    this.$filter = $filter;
    this.moment = moment;
    this.$q = $q;
    this.DailyMaxDemandPowerService = DailyMaxDemandPowerService;
    this.PowerFormatter = PowerFormatter;
    this.DateUtil = DateUtil;

    this.today = new Date();
    this.maxDate = this.moment().startOf('day').toDate();
    this.categories = [];
    this.graphUpdating = false;

    this.chartConfig = (0, _compareGraphMonthly2.default)(this);

    $scope.$watch('$ctrl.selectedConfigs', function () {
      return _this.updateGraph(_this.targetDate);
    });
    $scope.$watch('$ctrl.targetDate', function () {
      return _this.updateGraph(_this.targetDate);
    });
  }

  _createClass(CompareGraphMonthlyDemandController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'changeMonth',
    value: function changeMonth(diff) {
      this.updateTargetDate({ targetDate: this.DateUtil.leapMonth(this.targetDate, diff) });
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(date) {
      var _this2 = this;

      var targetDate = this.moment(date);
      this.startDate = targetDate.clone().startOf('month').toDate();
      this.endDate = targetDate.clone().endOf('month').toDate();

      if (this.chart) {
        this.chart.reflow();
      }
      if (this.selectedConfigs.length === 0) {
        return;
      }
      this.graphUpdating = true;
      this.resetSeries();

      var numberOfDays = (this.endDate - this.startDate) / (24 * 60 * 60 * 1000);
      this.categories = [];
      var startUtc = this.DateUtil.localToUTC(this.startDate);
      for (var i = 0; i <= numberOfDays; i++) {
        this.categories.push(this.DateUtil.leapDate(startUtc, i).valueOf());
      }
      this.chart.xAxis[0].setCategories(this.categories);

      var promises = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.selectedConfigs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var config = _step.value;

          promises.push(this.getDemandData(config, this.categories, this.startDate, this.endDate));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$q.all(promises).then(function (results) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = results[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var result = _step2.value;

            _this2.addSeries(result.powers, result.config);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this2.chart.redraw();
        _this2.chart.reflow();
        _this2.graphUpdating = false;
      });
    }
  }, {
    key: 'getDemandData',
    value: function getDemandData(config, categories, startDate, endDate) {
      var _this3 = this;

      var dateQuery = this.DateUtil.getDateRangeQueries(startDate, endDate);
      var query = _angular2.default.extend({ id: config.id }, dateQuery);

      return new Promise(function (resolve) {
        _this3.DailyMaxDemandPowerService.show(query, function (res) {
          var powers = _this3.PowerFormatter.formatDailyDemandPowers(res.powers, categories);
          resolve({ powers: powers, config: config });
        });
      });
    }
  }, {
    key: 'addSeries',
    value: function addSeries(powers, config) {
      var _this4 = this;

      if (!powers) {
        return;
      }
      var graphData = this.categories.map(function (e, i) {
        var label = _this4.moment(e).format('MM/DD');
        return [label, powers[i].y];
      });
      this.chart.addSeries({
        name: config.pms_service_code,
        type: this.graphType,
        data: graphData
      }, false);
    }
  }, {
    key: 'resetSeries',
    value: function resetSeries() {
      if (!this.chart) {
        return;
      }
      while (this.chart.series.length > 0) {
        this.chart.series[0].remove(false);
      }
    }
  }]);

  return CompareGraphMonthlyDemandController;
}();

exports.default = _angular2.default.module('leptonApp.compareGraphMonthlyDemand', [_angularMoment2.default, _date_util2.default, _powerFormatter2.default, _daily_max_demand_power2.default]).component('compareGraphMonthlyDemand', {
  template: __webpack_require__(886),
  controller: CompareGraphMonthlyDemandController,
  bindings: {
    selectedConfigs: '=',
    configIds: '=',
    graphType: '=',
    targetDate: '=',
    updateTargetDate: '&'
  }
}).name;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  return {
    chart: {
      height: 300,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    title: { text: '1ヶ月間のデマンド実績' },
    xAxis: {
      crosshair: true,
      labels: {
        formatter: function formatter() {
          var style = '';
          var day = scope.$filter('dayFilter')(this.value);
          if (day === '日') {
            style = 'color: #ff3131';
          } else if (day === '土') {
            style = 'color: #3737ff';
          }

          return '<span style="' + style + '">' + scope.$filter('date')(this.value, 'M/d') + ' (' + day + ')</span>';
        }
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力値 [kW]'
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      borderWidth: 0,
      reversed: true
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function formatter() {
        var tip_format = '<tspan style=\'font-size: 12px\'>' + scope.$filter('date')(this.x, 'M/d') + ' (' + scope.$filter('dayFilter')(this.x) + ')</tspan>';

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var point = _step.value;

            tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
            tip_format += point.y + " kW";
            tip_format += "</span>";
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return tip_format;
      }
    },
    plotOptions: { column: { grouping: false } },
    series: []
  };
}

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: -47px 0 5px 7px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <md-button ng-disabled=\"$ctrl.graphUpdating\" ng-click=\"$ctrl.changeMonth(-1)\" class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-left\"></i>\n    </md-button>\n    <span>{{$ctrl.startDate | date : 'yyyy年MM月dd日'}} ~ {{$ctrl.endDate | date : 'yyyy年MM月dd日'}} <span\n            class=\"date-component-minor\">({{$ctrl.billingDate | date : 'yyyy年MM月'}} 請求分)</span></span>\n    <md-button ng-disabled=\"$ctrl.endDate.valueOf() >= $ctrl.maxDate.valueOf() || $ctrl.graphUpdating\" ng-click=\"$ctrl.changeMonth(1)\"\n               class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-right\"></i>\n    </md-button>\n  </div>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n</md-content>\n"

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareGraphYearlyDemand = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

var _monthly_max_demand_power = __webpack_require__(218);

var _monthly_max_demand_power2 = _interopRequireDefault(_monthly_max_demand_power);

var _compareGraphYearly = __webpack_require__(888);

var _compareGraphYearly2 = _interopRequireDefault(_compareGraphYearly);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var CompareGraphYearlyDemand = exports.CompareGraphYearlyDemand = function () {
  /*@ngInject*/
  CompareGraphYearlyDemand.$inject = ["$filter", "$scope", "$q", "moment", "DateUtil", "PowerFormatter", "MonthlyMaxDemandPowerService"];
  function CompareGraphYearlyDemand($filter, $scope, $q, moment, DateUtil, PowerFormatter, MonthlyMaxDemandPowerService) {
    var _this = this;

    _classCallCheck(this, CompareGraphYearlyDemand);

    this.$filter = $filter;
    this.DateUtil = DateUtil;
    this.moment = moment;
    this.$q = $q;
    this.PowerFormatter = PowerFormatter;
    this.MonthlyMaxDemandPowerService = MonthlyMaxDemandPowerService;

    this.chartConfig = (0, _compareGraphYearly2.default)(this);

    $scope.$watch('$ctrl.selectedConfigs', function () {
      return _this.createGraph();
    });
  }

  _createClass(CompareGraphYearlyDemand, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'createGraph',
    value: function createGraph() {
      var _this2 = this;

      this.endDate = this.moment().startOf('month');
      this.startDate = this.endDate.clone().subtract(12, 'months');

      if (this.chart) {
        this.chart.reflow();
      }
      if (this.selectedConfigs.length === 0) {
        return;
      }
      this.resetSeries();

      this.categories = [];
      var start = this.startDate.clone().add(this.startDate.utcOffset(), 'minutes').utc();
      for (var i = 0; i < 13; i++) {
        this.categories.push(start.valueOf());
        start.add(1, 'month');
      }

      var promises = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.selectedConfigs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var config = _step.value;

          promises.push(this.getDemandData(config));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$q.all(promises).then(function (results) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = results[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var result = _step2.value;

            _this2.addSeries(result.demandPowers, result.config);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this2.chart.redraw();
        _this2.chart.reflow();
      });
    }
  }, {
    key: 'getDemandData',
    value: function getDemandData(config) {
      var _this3 = this;

      return new Promise(function (resolve) {
        _this3.MonthlyMaxDemandPowerService.showYearly({ id: config.id }, function (res) {
          var powers = res.powers;

          var demandPowerObjects = _this3.PowerFormatter.formatMonthlyDemandPowers(powers, _this3.categories);
          var demandPowers = demandPowerObjects.map(function (power) {
            return power.y;
          });
          resolve({ demandPowers: demandPowers, config: config });
        });
      });
    }
  }, {
    key: 'addSeries',
    value: function addSeries(powers, config) {
      if (!powers) {
        return;
      }
      var graphData = this.categories.map(function (e, i) {
        return [e, powers[i]];
      });
      this.chart.addSeries({
        name: config.pms_service_code,
        type: this.graphType,
        data: graphData
      });
    }
  }, {
    key: 'resetSeries',
    value: function resetSeries() {
      if (!this.chart) {
        return;
      }
      while (this.chart.series.length > 0) {
        this.chart.series[0].remove(false);
      }
    }
  }]);

  return CompareGraphYearlyDemand;
}();

exports.default = _angular2.default.module('leptonApp.compareGraphYearlyDemand', [_angularMoment2.default, _date_util2.default, _powerFormatter2.default, _monthly_max_demand_power2.default]).component('compareGraphYearlyDemand', {
  template: __webpack_require__(889),
  controller: CompareGraphYearlyDemand,
  bindings: {
    selectedConfigs: '=',
    configIds: '=',
    graphType: '='
  }
}).name;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  return {
    chart: {
      height: 300,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    title: { text: '1年間のデマンド実績' },
    xAxis: {
      crosshair: true,
      labels: {
        format: '{value:%m月分}'
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力値 [kW]'
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      borderWidth: 0,
      reversed: true
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + scope.$filter('date')(this.x, 'MM月') + "</tspan>";

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var point = _step.value;

            tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
            tip_format += point.y + " kW";
            tip_format += "</span>";
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return tip_format;
      }
    },
    plotOptions: { column: { grouping: true } },
    series: []
  };
}

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: -25px 0 5px 15px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <span>{{$ctrl.startDate | amDateFormat : 'YYYY年MM月'}} ~ {{$ctrl.endDate | amDateFormat : 'YYYY年MM月'}}</span>\n  </div>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n</md-content>\n"

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareGraphDailyActiveController = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _active_power = __webpack_require__(144);

var _active_power2 = _interopRequireDefault(_active_power);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _compareGraphDailyActive = __webpack_require__(891);

var _compareGraphDailyActive2 = _interopRequireDefault(_compareGraphDailyActive);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var CompareGraphDailyActiveController = exports.CompareGraphDailyActiveController = function () {
  /*@ngInject*/
  CompareGraphDailyActiveController.$inject = ["$filter", "$interval", "$scope", "$q", "moment", "PowerFormatter", "DateUtil", "ActivePowerService"];
  function CompareGraphDailyActiveController($filter, $interval, $scope, $q, moment, PowerFormatter, DateUtil, ActivePowerService) {
    var _this = this;

    _classCallCheck(this, CompareGraphDailyActiveController);

    this.$filter = $filter;
    this.$interval = $interval;
    this.$q = $q;
    this.moment = moment;
    this.PowerFormatter = PowerFormatter;
    this.DateUtil = DateUtil;
    this.ActivePowerService = ActivePowerService;

    this.categories = this.DateUtil.getXLabels;
    this.maxDate = moment().startOf('day').toDate();
    this.missingTimes = [];
    this.noCalculateTimes = [];
    this.graphUpdating = false;

    this.chartConfig = (0, _compareGraphDailyActive2.default)(this);

    $scope.$watch('$ctrl.selectedConfigs', function () {
      return _this.updateGraph(_this.targetDate);
    });
    $scope.$watch('$ctrl.targetDate', function () {
      return _this.updateGraph(_this.targetDate);
    });
  }

  _createClass(CompareGraphDailyActiveController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.timer = this.$interval(function () {
        _this2.updateGraph(_this2.targetDate);
      }, 300000);
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(targetDate) {
      var _this3 = this;

      if (this.chart) {
        this.chart.reflow();
      }

      if (this.selectedConfigs.length === 0) {
        return;
      }
      this.graphUpdating = true;
      this.resetSeries();

      var promises = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.selectedConfigs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var config = _step.value;

          promises.push(this.getActivePower(config, targetDate));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$q.all(promises).then(function (results) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = results[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var result = _step2.value;

            _this3.addSeries(result.activePowers, result.config);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this3.chart.redraw();
        _this3.chart.reflow();
        _this3.graphUpdating = false;
      });
    }
  }, {
    key: 'getActivePower',
    value: function getActivePower(config, targetDate) {
      var _this4 = this;

      var dateQuery = this.DateUtil.getActivePowerQueries(targetDate);
      var query = _angular2.default.extend({ id: config.id }, dateQuery);

      return new Promise(function (resolve) {
        _this4.ActivePowerService.show(query, function (res) {
          var _PowerFormatter$forma = _this4.PowerFormatter.formatActivePowers(res.powers, _this4.categories, targetDate),
              _PowerFormatter$forma2 = _slicedToArray(_PowerFormatter$forma, 2),
              activePowers = _PowerFormatter$forma2[0];

          resolve({ activePowers: activePowers, config: config });
        });
      });
    }
  }, {
    key: 'addSeries',
    value: function addSeries(powers, config) {
      if (!powers) {
        return;
      }
      var graphData = this.categories.map(function (e, i) {
        return [e, powers[i]];
      });
      this.chart.addSeries({
        name: config.pms_service_code,
        type: this.graphType,
        data: graphData
      }, false);
    }
  }, {
    key: 'changeDate',
    value: function changeDate(diff) {
      if (diff) {
        this.updateTargetDate({ targetDate: this.DateUtil.leapDate(this.targetDate, diff) });
      }
    }
  }, {
    key: 'resetSeries',
    value: function resetSeries() {
      if (!this.chart) {
        return;
      }
      while (this.chart.series.length > 0) {
        this.chart.series[0].remove(false);
      }
    }
  }]);

  return CompareGraphDailyActiveController;
}();

exports.default = _angular2.default.module('leptonApp.compareGraphDailyActive', [_angularMoment2.default, _powerFormatter2.default, _date_util2.default, _active_power2.default]).component('compareGraphDailyActive', {
  template: __webpack_require__(892),
  controller: CompareGraphDailyActiveController,
  bindings: {
    selectedConfigs: '=',
    configIds: '=',
    graphType: '=',
    targetDate: '=',
    updateTargetDate: '&'
  }
}).name;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  var chartConfig = {
    chart: {
      height: 300,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    title: { text: '1日の電力消費実績' },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      reversed: true
    },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      max: scope.categories.length - 1
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力量 [kWh]'
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + this.x + "</tspan>";

        angular.forEach(this.points, function (point, i) {
          tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
          tip_format += point.y + " kWh";
          tip_format += "</span>";
        });

        return tip_format;
      }
    },
    series: [],
    plotOptions: { column: { grouping: true } }
  };
  return chartConfig;
}

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: -48px 0 5px 7px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <md-button ng-disabled=\"$ctrl.graphUpdating\" ng-click=\"$ctrl.changeDate(-1)\" class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-left\"></i>\n    </md-button>\n    <div datepicker class=\"date-picker\" ng-model=\"$ctrl.targetDate\" ng-change=\"$ctrl.changeDate()\"\n         max-date=\"$ctrl.maxDate\">{{$ctrl.targetDate | date: 'yyyy/MM/dd'}}<i class=\"fa fa-sort-down\"\n                                                                              aria-hidden=\"true\"></i></div>\n    <md-button ng-disabled=\"$ctrl.targetDate.valueOf() === $ctrl.maxDate.valueOf() || $ctrl.graphUpdating\" ng-click=\"$ctrl.changeDate(1)\"\n               class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-right\"></i>\n    </md-button>\n  </div>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n</md-content>\n"

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareGraphWeeklyActiveController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

var _daily_active_power = __webpack_require__(191);

var _daily_active_power2 = _interopRequireDefault(_daily_active_power);

var _compareGraphWeekly = __webpack_require__(894);

var _compareGraphWeekly2 = _interopRequireDefault(_compareGraphWeekly);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var CompareGraphWeeklyActiveController = exports.CompareGraphWeeklyActiveController = function () {
  /*@ngInject*/
  CompareGraphWeeklyActiveController.$inject = ["$filter", "$scope", "$q", "moment", "DateUtil", "PowerFormatter", "DailyActivePowerService"];
  function CompareGraphWeeklyActiveController($filter, $scope, $q, moment, DateUtil, PowerFormatter, DailyActivePowerService) {
    var _this = this;

    _classCallCheck(this, CompareGraphWeeklyActiveController);

    this.$filter = $filter;
    this.moment = moment;
    this.$q = $q;
    this.DateUtil = DateUtil;
    this.PowerFormatter = PowerFormatter;
    this.DailyActivePowerService = DailyActivePowerService;
    this.graphUpdating = false;

    this.maxDate = this.moment().startOf('week').toDate();

    this.Week = ['日', '月', '火', '水', '木', '金', '土'];

    this.chartConfig = (0, _compareGraphWeekly2.default)(this);

    $scope.$watch('$ctrl.selectedConfigs', function () {
      return _this.updateGraph(_this.startDate, _this.endDate);
    });
    $scope.$watch('$ctrl.targetDate', function () {
      if (!_this.targetDate) {
        return;
      }
      _this.startDate = _this.targetDate;
      _this.endDate = _this.DateUtil.leapDate(_this.startDate, 6);

      _this.updateGraph(_this.startDate, _this.endDate);
    });
  }

  _createClass(CompareGraphWeeklyActiveController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'changeDate',
    value: function changeDate(diff) {
      this.updateTargetDate({ targetDate: this.DateUtil.leapDate(this.startDate, diff) });
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(startDate, endDate) {
      var _this2 = this;

      if (this.chart) {
        this.chart.reflow();
      }

      if (this.selectedConfigs.length === 0) {
        return;
      }
      this.graphUpdating = true;
      this.resetSeries();

      this.categories = [];
      for (var i = 0; i < 7; i++) {
        var utc = this.DateUtil.localToUTC(startDate);
        this.categories.push(this.DateUtil.leapDate(utc, i).valueOf());
      }
      this.chart.xAxis[0].setCategories(this.categories);

      var promises = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.selectedConfigs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var config = _step.value;

          promises.push(this.getActivePower(config, this.categories, startDate, endDate));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$q.all(promises).then(function (results) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = results[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var result = _step2.value;

            _this2.addSeries(result.powers, result.config);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this2.chart.redraw();
        _this2.chart.reflow();
        _this2.graphUpdating = false;
      });
    }
  }, {
    key: 'getActivePower',
    value: function getActivePower(config, categories, startDate, endDate) {
      var _this3 = this;

      var dateQuery = this.DateUtil.getDateRangeQueries(startDate, endDate);
      var query = _angular2.default.extend({ id: config.id }, dateQuery);

      return new Promise(function (resolve) {
        _this3.DailyActivePowerService.show(query, function (res) {
          var powers = _this3.PowerFormatter.formatDailyActivePowers(res.powers, _this3.categories);
          resolve({ powers: powers, config: config });
        });
      });
    }
  }, {
    key: 'addSeries',
    value: function addSeries(powers, config) {
      var _this4 = this;

      if (!powers) {
        return;
      }
      var graphData = this.categories.map(function (e, i) {
        var label = _this4.moment(e).format('MM/DD');
        return [label, powers[i].y];
      });
      this.chart.addSeries({
        name: config.pms_service_code,
        type: this.graphType,
        data: graphData
      }, false);
    }
  }, {
    key: 'resetSeries',
    value: function resetSeries() {
      if (!this.chart) {
        return;
      }
      while (this.chart.series.length > 0) {
        this.chart.series[0].remove(false);
      }
    }
  }]);

  return CompareGraphWeeklyActiveController;
}();

exports.default = _angular2.default.module('leptonApp.compareGraphWeeklyActive', [_angularMoment2.default, _date_util2.default, _powerFormatter2.default, _daily_active_power2.default]).component('compareGraphWeeklyActive', {
  template: __webpack_require__(895),
  controller: CompareGraphWeeklyActiveController,
  bindings: {
    selectedConfigs: '=',
    configIds: '=',
    graphType: '=',
    targetDate: '=',
    updateTargetDate: '&'
  }
}).name;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  return {
    chart: {
      height: 300,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    title: { text: '1週間の電力消費実績' },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      borderWidth: 0,
      reversed: true
    },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        format: '{value:%m月%d日}',
        formatter: function formatter() {
          var style = '';
          var day = scope.$filter('dayFilter')(this.value);
          if (day === '日') {
            style = 'color: #ff3131';
          } else if (day === '土') {
            style = 'color: #3737ff';
          }

          return '<span style="' + style + '">' + scope.$filter('date')(this.value, 'MM月dd日') + ' (' + day + ')</span>';
        }
      },
      max: 6
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力量 [kWh]'
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + scope.$filter('date')(this.x, 'MM月dd日') + "</tspan>";

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var point = _step.value;

            tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
            tip_format += point.y + " kWh";
            tip_format += "</span>";
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return tip_format;
      }
    },
    plotOptions: {
      column: { grouping: false },
      series: {
        events: {
          click: function click(event) {
            scope.$state.go('main.demand_report_show.detail', { id: scope.id, type: 'active', term: 'daily', target: event.point.date }, { reload: true });
          }
        },
        cursor: 'pointer'
      }
    },
    series: []
  };
}

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: -48px 0 5px 7px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <md-button ng-disabled=\"$ctrl.graphUpdating\" ng-click=\"$ctrl.changeDate(-7)\" class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-left\"></i>\n    </md-button>\n    <span>{{$ctrl.startDate | date : 'MM月dd日'}} ~ {{$ctrl.endDate | date : 'MM月dd日'}}</span>\n    <md-button ng-disabled=\"$ctrl.startDate.valueOf() === $ctrl.maxDate.valueOf() || $ctrl.graphUpdating\" ng-click=\"$ctrl.changeDate(7)\"\n               class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-right\"></i>\n    </md-button>\n  </div>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n</md-content>\n"

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareGraphMonthlyActiveController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

var _daily_active_power = __webpack_require__(191);

var _daily_active_power2 = _interopRequireDefault(_daily_active_power);

var _compareGraphMonthlyActive = __webpack_require__(897);

var _compareGraphMonthlyActive2 = _interopRequireDefault(_compareGraphMonthlyActive);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var CompareGraphMonthlyActiveController = exports.CompareGraphMonthlyActiveController = function () {
  /*@ngInject*/
  CompareGraphMonthlyActiveController.$inject = ["$filter", "$scope", "$q", "moment", "DateUtil", "PowerFormatter", "DailyActivePowerService"];
  function CompareGraphMonthlyActiveController($filter, $scope, $q, moment, DateUtil, PowerFormatter, DailyActivePowerService) {
    var _this = this;

    _classCallCheck(this, CompareGraphMonthlyActiveController);

    this.$filter = $filter;
    this.$q = $q;
    this.moment = moment;
    this.DailyActivePowerService = DailyActivePowerService;
    this.PowerFormatter = PowerFormatter;
    this.DateUtil = DateUtil;

    this.maxDate = this.moment().startOf('day').toDate();
    this.categories = [];
    this.graphUpdating = false;

    this.chartConfig = (0, _compareGraphMonthlyActive2.default)(this);

    $scope.$watch('$ctrl.selectedConfigs', function () {
      return _this.updateGraph(_this.targetDate);
    });
    $scope.$watch('$ctrl.targetDate', function () {
      return _this.updateGraph(_this.targetDate);
    });
  }

  _createClass(CompareGraphMonthlyActiveController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'changeMonth',
    value: function changeMonth(diff) {
      this.updateTargetDate({ targetDate: this.moment(this.targetDate).add(diff, 'months').toDate() });
    }
  }, {
    key: 'updateGraph',
    value: function updateGraph(date) {
      var _this2 = this;

      var targetDate = this.moment(date);
      this.startDate = targetDate.clone().startOf('month').toDate();
      this.endDate = targetDate.clone().endOf('month').toDate();

      if (this.chart) {
        this.chart.reflow();
      }

      if (this.selectedConfigs.length === 0) {
        return;
      }
      this.graphUpdating = true;
      this.resetSeries();

      var numberOfDays = (this.endDate - this.startDate) / (24 * 60 * 60 * 1000);
      this.categories = [];
      var startUtc = this.DateUtil.localToUTC(this.startDate);
      for (var i = 0; i <= numberOfDays; i++) {
        this.categories.push(this.DateUtil.leapDate(startUtc, i).valueOf());
      }
      this.chart.xAxis[0].setCategories(this.categories);

      var promises = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.selectedConfigs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var config = _step.value;

          promises.push(this.getActivePowers(config, this.categories, this.startDate, this.endDate));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$q.all(promises).then(function (results) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = results[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var result = _step2.value;

            _this2.addSeries(result.powers, result.config);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this2.chart.redraw();
        _this2.chart.reflow();
        _this2.graphUpdating = false;
      });
    }
  }, {
    key: 'getActivePowers',
    value: function getActivePowers(config, categories, startDate, endDate) {
      var _this3 = this;

      var dateQuery = this.DateUtil.getDateRangeQueries(startDate, endDate);
      var query = _angular2.default.extend({ id: config.id }, dateQuery);

      return new Promise(function (resolve) {
        _this3.DailyActivePowerService.show(query, function (res) {
          var powers = _this3.PowerFormatter.formatDailyActivePowers(res.powers, _this3.categories);
          resolve({ powers: powers, config: config });
        });
      });
    }
  }, {
    key: 'addSeries',
    value: function addSeries(powers, config) {
      var _this4 = this;

      if (!powers) {
        return;
      }
      var graphData = this.categories.map(function (e, i) {
        var label = _this4.moment(e).format('MM/DD');
        return [label, powers[i].y];
      });
      this.chart.addSeries({
        name: config.pms_service_code,
        type: this.graphType,
        data: graphData
      }, false);
    }
  }, {
    key: 'resetSeries',
    value: function resetSeries() {
      if (!this.chart) {
        return;
      }
      while (this.chart.series.length > 0) {
        this.chart.series[0].remove(false);
      }
    }
  }]);

  return CompareGraphMonthlyActiveController;
}();

exports.default = _angular2.default.module('leptonApp.compareGraphMonthlyActive', [_angularMoment2.default, _date_util2.default, _powerFormatter2.default, _daily_active_power2.default]).component('compareGraphMonthlyActive', {
  template: __webpack_require__(898),
  controller: CompareGraphMonthlyActiveController,
  bindings: {
    selectedConfigs: '=',
    configIds: '=',
    graphType: '=',
    targetDate: '=',
    updateTargetDate: '&'
  }
}).name;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  return {
    chart: {
      height: 300,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    title: { text: '1ヶ月間の消費実績' },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        formatter: function formatter() {
          var style = '';
          var day = scope.$filter('dayFilter')(this.value);
          if (day === '日') {
            style = 'color: #ff3131';
          } else if (day === '土') {
            style = 'color: #3737ff';
          }

          return '<span style="' + style + '">' + scope.$filter('date')(this.value, 'M/d') + ' (' + day + ')</span>';
        }
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力量 [kWh]'
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      borderWidth: 0,
      reversed: true
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + scope.$filter('date')(this.x, 'MM月dd日') + "</tspan>";

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var point = _step.value;

            tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
            tip_format += point.y + " kWh";
            tip_format += "</span>";
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return tip_format;
      }
    },
    plotOptions: { column: { grouping: true } },
    series: []
  };
}

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: -48px 0 5px 7px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <md-button ng-disabled=\"$ctrl.graphUpdating\" ng-click=\"$ctrl.changeMonth(-1)\" class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-left\"></i>\n    </md-button>\n    <span>{{$ctrl.startDate | date : 'yyyy年MM月dd日'}} ~ {{$ctrl.endDate | date : 'yyyy年MM月dd日'}} <span\n            class=\"date-component-minor\">({{$ctrl.billingDate | date : 'yyyy年MM月'}} 請求分)</span></span>\n    <md-button ng-disabled=\"$ctrl.endDate.valueOf() >= $ctrl.maxDate.valueOf() || $ctrl.graphUpdating\" ng-click=\"$ctrl.changeMonth(1)\"\n               class=\"md-fab md-mini md-primary\">\n      <i class=\"fa fa-arrow-right\"></i>\n    </md-button>\n  </div>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n</md-content>\n"

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareGraphYearlyActive = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _date_util = __webpack_require__(39);

var _date_util2 = _interopRequireDefault(_date_util);

var _powerFormatter = __webpack_require__(64);

var _powerFormatter2 = _interopRequireDefault(_powerFormatter);

var _monthly_active_power = __webpack_require__(470);

var _monthly_active_power2 = _interopRequireDefault(_monthly_active_power);

var _compareGraphYearlyActive = __webpack_require__(900);

var _compareGraphYearlyActive2 = _interopRequireDefault(_compareGraphYearlyActive);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var CompareGraphYearlyActive = exports.CompareGraphYearlyActive = function () {
  /*@ngInject*/
  CompareGraphYearlyActive.$inject = ["$filter", "$scope", "$q", "moment", "DateUtil", "PowerFormatter", "MonthlyActivePowerService"];
  function CompareGraphYearlyActive($filter, $scope, $q, moment, DateUtil, PowerFormatter, MonthlyActivePowerService) {
    var _this = this;

    _classCallCheck(this, CompareGraphYearlyActive);

    this.$filter = $filter;
    this.DateUtil = DateUtil;
    this.moment = moment;
    this.$q = $q;
    this.PowerFormatter = PowerFormatter;
    this.MonthlyActivePowerService = MonthlyActivePowerService;

    this.chartConfig = (0, _compareGraphYearlyActive2.default)(this);

    $scope.$watch('$ctrl.selectedConfigs', function () {
      return _this.createGraph();
    });
  }

  _createClass(CompareGraphYearlyActive, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'createGraph',
    value: function createGraph() {
      var _this2 = this;

      this.endDate = this.moment().startOf('month');
      this.startDate = this.endDate.clone().subtract(12, 'months');

      if (this.chart) {
        this.chart.reflow();
      }
      if (this.selectedConfigs.length === 0) {
        return;
      }
      this.resetSeries();

      this.categories = [];
      var start = this.startDate.clone().add(this.startDate.utcOffset(), 'minutes').utc();
      for (var i = 0; i < 13; i++) {
        this.categories.push(start.valueOf());
        start.add(1, 'month');
      }

      var promises = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.selectedConfigs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var config = _step.value;

          promises.push(this.getActivePowers(config));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$q.all(promises).then(function (results) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = results[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var result = _step2.value;

            _this2.addSeries(result.powers, result.config);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this2.chart.redraw();
        _this2.chart.reflow();
      });
    }
  }, {
    key: 'getActivePowers',
    value: function getActivePowers(config) {
      var _this3 = this;

      return new Promise(function (resolve) {
        _this3.MonthlyActivePowerService.show({ id: config.id }, function (res) {
          var activePowerObjects = _this3.PowerFormatter.formatMonthlyActivePowers(res.powers, _this3.categories);
          var powers = activePowerObjects.map(function (power) {
            return power.y;
          });
          resolve({ powers: powers, config: config });
        });
      });
    }
  }, {
    key: 'addSeries',
    value: function addSeries(powers, config) {
      if (!powers) {
        return;
      }
      var graphData = this.categories.map(function (e, i) {
        return [e, powers[i]];
      });
      this.chart.addSeries({
        name: config.pms_service_code,
        type: this.graphType,
        data: graphData
      });
    }
  }, {
    key: 'resetSeries',
    value: function resetSeries() {
      if (!this.chart) {
        return;
      }
      while (this.chart.series.length > 0) {
        this.chart.series[0].remove(false);
      }
    }
  }]);

  return CompareGraphYearlyActive;
}();

exports.default = _angular2.default.module('leptonApp.compareGraphYearlyActive', [_angularMoment2.default, _date_util2.default, _powerFormatter2.default, _monthly_active_power2.default]).component('compareGraphYearlyActive', {
  template: __webpack_require__(901),
  controller: CompareGraphYearlyActive,
  bindings: {
    selectedConfigs: '=',
    configIds: '=',
    graphType: '='
  }
}).name;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartConfig.$inject = ["scope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chartConfig;
function chartConfig(scope) {
  'ngInject';

  return {
    chart: {
      height: 300,
      events: {
        load: function load() {
          scope.chart = this;
        }
      }
    },
    title: { text: '1年間の消費実績' },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        format: '{value:%m月分}'
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力値 [kWh]'
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      borderWidth: 0,
      reversed: true
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function formatter() {
        var tip_format = "<tspan style='font-size: 12px'>" + scope.$filter('date')(this.x, 'MM月') + "</tspan>";

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var point = _step.value;

            tip_format += '<br/><span style="color:' + point.series.color + ";font-size: 12px\">\u25CF</span> <span style=\"font-size: 14px;\">" + point.series.name + ': ';
            tip_format += point.y + " kWh";
            tip_format += "</span>";
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return tip_format;
      }
    },
    plotOptions: { column: { grouping: true } },
    series: []
  };
}

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports = "<div class=\"date-component\" style=\"margin: -42px 0 5px 15px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <span>{{$ctrl.startDate | amDateFormat : 'YYYY年MM月'}} ~ {{$ctrl.endDate | amDateFormat : 'YYYY年MM月'}}</span>\n  </div>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n</md-content>\n"

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareGraphIndexController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _compareGraphIndex = __webpack_require__(903);

var _compareGraphIndex2 = _interopRequireDefault(_compareGraphIndex);

var _compare_bookmark = __webpack_require__(495);

var _compare_bookmark2 = _interopRequireDefault(_compare_bookmark);

__webpack_require__(904);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var CompareGraphIndexController = exports.CompareGraphIndexController = function () {
  /*@ngInject*/
  CompareGraphIndexController.$inject = ["$location", "CompareBookmarkService"];
  function CompareGraphIndexController($location, CompareBookmarkService) {
    _classCallCheck(this, CompareGraphIndexController);

    this.$location = $location;
    this.CompareBookmarkService = CompareBookmarkService;
    this.bookmarks = [];
  }

  _createClass(CompareGraphIndexController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.CompareBookmarkService.index(function (res) {
        _this.bookmarks = res;
      });
    }
  }, {
    key: 'goCompareGraph',
    value: function goCompareGraph(bookmark) {
      this.$location.url('compare/' + bookmark.query);
    }
  }]);

  return CompareGraphIndexController;
}();

exports.default = _angular2.default.module('leptonApp.compareGraphIndex', [_compare_bookmark2.default]).config(_compareGraphIndex2.default).component('compareGraphIndex', {
  template: __webpack_require__(905),
  controller: CompareGraphIndexController
}).name;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.compare_graph_index', {
    url: 'compare',
    template: '<compare-graph-index></compare-graph-index>'
  });
}

/***/ }),
/* 904 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fas fa-exchange-alt\"></i>&nbsp;登録済みの比較グラフ</h2>\n  </div>\n</md-toolbar>\n<md-content>\n  <div class=\"add-link-row\">\n    <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>&nbsp;<compare-modal value=\"'グラフを追加'\"></compare-modal>\n  </div>\n  <md-divider></md-divider>\n  <md-list-item class=\"md-3-line\" ng-repeat=\"bookmark in $ctrl.bookmarks\" style=\"flex-direction: column; padding-right: 0;min-height: initial;\">\n    <a ng-click=\"$ctrl.goCompareGraph(bookmark)\" style=\"width: 100%; padding: 15px 0\" layout=\"row\" layout-align=\"start center\">\n      <div class=\"md-list-item-text\" layout=\"column\">\n        <h3>{{bookmark.name}}</h3>\n      </div>\n    </a>\n    <md-divider></md-divider>\n  </md-list-item>\n  <div ng-if=\"$ctrl.bookmarks.length === 0\" class=\"empty-notice\">比較グラフが登録されていません</div>\n</md-content>\n"

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalEventController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _global_event = __webpack_require__(496);

var _global_event2 = _interopRequireDefault(_global_event);

var _announce = __webpack_require__(489);

var _announce2 = _interopRequireDefault(_announce);

__webpack_require__(907);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var GlobalEventController = exports.GlobalEventController = function () {
  /*@ngInject*/
  GlobalEventController.$inject = ["moment", "$mdDialog", "GlobalEventService", "AnnounceService"];
  function GlobalEventController(moment, $mdDialog, GlobalEventService, AnnounceService) {
    _classCallCheck(this, GlobalEventController);

    this.GlobalEventService = GlobalEventService;
    this.AnnounceService = AnnounceService;
    this.moment = moment;
    this.$mdDialog = $mdDialog;

    this.announces = [];
    this.globalEvents = [];
  }

  _createClass(GlobalEventController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.AnnounceService.api.index(function (res) {
        _this.announces = res;
      });

      this.GlobalEventService.api.index(function (res) {
        _this.globalEvents = res;
      });
    }
  }, {
    key: 'isFutureDate',
    value: function isFutureDate(date) {
      return this.moment(date).valueOf() >= new Date().valueOf();
    }
  }, {
    key: 'showDialog',
    value: function showDialog(announce, ev) {
      var _this2 = this;

      this.AnnounceService.api.show({ id: announce.id }, function (announce) {
        DialogController.$inject = ["$scope", "$mdDialog", "announce"];
        _this2.$mdDialog.show({
          targetEvent: ev,
          templateUrl: 'announce-dialog.html',
          controller: DialogController,
          parent: _angular2.default.element(document.body),
          clickOutsideToClose: true,
          fullscreen: false,
          locals: {
            announce: announce
          }
        });

        /*@ngInject*/
        function DialogController($scope, $mdDialog, announce) {
          $scope.announce = announce;

          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      }, function (response) {
        var alert = _this2.$mdDialog.alert().title('エラー').textContent('障害・メンテナンス情報を取得できませんでした').ok('閉じる');
        _this2.$mdDialog.show(alert);
      });
    }
  }]);

  return GlobalEventController;
}();

exports.default = _angular2.default.module('leptonApp.globalEvent', [_angularjs2.default, _angularMoment2.default, _global_event2.default, _announce2.default]).component('globalEvent', {
  template: __webpack_require__(908),
  controller: GlobalEventController
}).name;

/***/ }),
/* 907 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports = "<div class=\"global-event-content\">\n  <div class=\"global-event-title\">\n    お知らせ\n  </div>\n  <div class=\"global-event-list\">\n    <div class=\"global-event-item\" ng-repeat=\"announce in $ctrl.announces\">\n      <div class=\"global-event-icon\" ng-class=\"{ 'global-event-announce-icon': $ctrl.isFutureDate(announce.end_at) }\">\n        <i class=\"fas fa-info-circle\" ng-if=\"$ctrl.isFutureDate(announce.end_at)\"></i>\n      </div>\n      <div class=\"global-event-text\">\n        <span class=\"span-link\" ng-click=\"$ctrl.showDialog(announce)\">{{ announce.title }} ({{announce.start_at | date:'yyyy/MM/dd'}})</span>\n      </div>\n    </div>\n    <div class=\"global-event-item\" ng-repeat=\"event in $ctrl.globalEvents\">\n      <div class=\"global-event-icon\">\n        <i class=\"fas fa-exclamation-triangle\" ng-if=\"event.is_error\"></i>\n        <i class=\"fas fa-info-circle\" ng-if=\"event.is_info\"></i>\n      </div>\n      <div class=\"global-event-text\">\n        {{ event.text }} ({{event.occurred_at | date:'yyyy/MM/dd'}})\n      </div>\n    </div>\n    <div ng-if=\"$ctrl.announces.length === 0 && $ctrl.globalEvents.length === 0\">\n      お知らせはまだありません。\n    </div>\n  </div>\n</div>\n\n<script type=\"text/ng-template\" id=\"announce-dialog.html\">\n  <md-dialog aria-label=\"Announce\">\n    <form ng-cloak>\n      <md-toolbar>\n        <div class=\"md-dialog-title\" style=\"padding: 10px 20px; background: #ff9800;\">\n          <h3 style=\"margin: 0; font-size: 20px;\">{{ announce.title }}</h3>\n        </div>\n      </md-toolbar>\n\n      <md-dialog-content>\n        <div class=\"md-dialog-content\">\n          <pre>{{ announce.detail }}</pre>\n        </div>\n      </md-dialog-content>\n\n      <md-dialog-actions layout-align=\"center center\">\n        <md-button ng-click=\"closeDialog()\">\n          閉じる\n        </md-button>\n      </md-dialog-actions>\n    </form>\n  </md-dialog>\n</script>\n"

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OemLoginController = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _login = __webpack_require__(910);

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var OemLoginController = exports.OemLoginController = function () {
    /*@ngInject*/
    OemLoginController.$inject = ["$auth", "$scope", "$mdToast"];
    function OemLoginController($auth, $scope, $mdToast) {
        var _this = this;

        _classCallCheck(this, OemLoginController);

        this.loginInfo = {
            email: '',
            password: ''
        };

        this.$auth = $auth;
        this.buttonDisabled = false;
        this.$mdToast = $mdToast;

        $scope.$on('auth:login-error', function (ev, reason) {
            _this.buttonDisabled = false;

            if (reason.errors[0].indexOf('A confirmation email was sent') !== -1) {
                _this.showToast('パスワードが未設定です。パスワード設定用メールが送られていないか確認してください。');
            } else {
                _this.showToast('ログインIDまたはパスワードが違います');
            }
        });
    }

    _createClass(OemLoginController, [{
        key: 'submitLogin',
        value: function submitLogin() {
            this.buttonDisabled = true;
            this.$auth.submitLogin(this.loginInfo, { config: 'oemUser' });
        }
    }, {
        key: 'showToast',
        value: function showToast(message) {
            this.$mdToast.show(this.$mdToast.simple().content(message).position('top left right').hideDelay(3000));
        }
    }]);

    return OemLoginController;
}();

exports.default = _angular2.default.module('leptonApp.oemLogin', [_angularjs2.default]).config(_login2.default).component('oemLogin', {
    template: __webpack_require__(911),
    controller: OemLoginController
}).name;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('oem_login', {
        url: '/admin_login',
        template: '<oem-login></oem-login>'
    });
}

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports = "<div id=\"header\" style=\"backgroud-color: #188526\">\n  <md-button id=\"logo\" ui-sref=\"oem_main.oem_home\">\n    <span class=\"fa-stack\" style=\"font-size: 13px\">\n      <i class=\"fa fa-cloud fa-stack-2x\" style=\"color: rgb(0,150,136)\"></i>\n      <i class=\"fa fa-plug fa-stack-1x\" style=\"color: #fffde7\"></i>\n    </span>&nbsp; IIJ高圧スマートメーターBルート活用サービス 管理画面\n  </md-button>\n</div>\n<md-content class=\"login-content\" md-theme=\"oemTheme\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <h3><i class=\"fas fa-sign-in-alt fa-fw\"></i> ログイン</h3>\n    </div>\n    <div class=\"col-sm-12\">\n      <form name=\"loginForm\" ng-submit=\"$ctrl.submitLogin()\" role=\"form\" ng-init=\"loginForm = {}\">\n        <md-input-container style=\"margin-right: 15px;\">\n          <label><i class=\"fa fa-user fa-fw\"></i> ログインID</label>\n          <input md-maxlength=\"255\" name=\"email\" ng-model=\"$ctrl.loginInfo.email\">\n          <div ng-messages=\"loginForm.email.$error\">\n            <div ng-message=\"required\">入力してください</div>\n            <div ng-message=\"md-maxlength\">255文字以下で記載してください</div>\n          </div>\n        </md-input-container>\n        <md-input-container>\n          <label><i class=\"fa fa-key fa-fw\"></i>パスワード</label>\n          <input md-maxlength=\"128\" name=\"password\" type=\"password\" ng-model=\"$ctrl.loginInfo.password\" maxlength=\"128\">\n          <div ng-messages=\"loginForm.password.$error\">\n            <div ng-message=\"required\">入力してください</div>\n            <div ng-message=\"md-maxlength\">128文字以下で記載してください</div>\n          </div>\n        </md-input-container>\n\n        <div class=\"button-row\">\n          <md-button type=\"submit\" ng-disabled=\"buttonDisabled\" class=\"md-primary md-raised\" style=\"margin: 0; padding: 0 30px;\">ログイン</md-button>\n          <span class=\"span-link reconfirm-link\" ui-sref=\"oem_user_reconfirm\">パスワードを忘れた場合</span>\n        </div>\n      </form>\n    </div>\n  </div>\n</md-content>\n<md-divider></md-divider>\n<div id=\"footer\">\n  <div><a target=\"_blank\" href=\"http://www.iij.ad.jp/securitypolicy/\">情報セキュリティ基本方針</a></div>\n  <div><a target=\"_blank\" href=\"http://www.iij.ad.jp/privacy/\">個人情報保護ポリシー</a></div>\n  <div>&copy; 2016 Internet Initiative Japan Inc.</div>\n</div>\n"

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OemMainController = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _oem_main = __webpack_require__(913);

var _oem_main2 = _interopRequireDefault(_oem_main);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var OemMainController = exports.OemMainController = function () {
    /*@ngInject*/
    OemMainController.$inject = ["$auth"];
    function OemMainController($auth) {
        _classCallCheck(this, OemMainController);

        this.logout = function () {
            $auth.signOut();
        };
    }

    _createClass(OemMainController, [{
        key: '$onInit',
        value: function $onInit() {}
    }]);

    return OemMainController;
}();

exports.default = _angular2.default.module('leptonApp.oemMain', [_angularjs2.default]).config(_oem_main2.default).component('oemMain', {
    template: __webpack_require__(914),
    controller: OemMainController
}).name;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main', {
    url: '/admin',
    template: '<oem-main></oem-main>',
    params: { linkTo: 'oem_main.company_edit', listTitle: '顧客 一覧' }
  });
};

/***/ }),
/* 914 */
/***/ (function(module, exports) {

module.exports = "<div id=\"header\" layout=\"row\" layout-align=\"space-between center\">\n  <md-button id=\"logo\" ui-sref=\"oem_main.oem_home\">\n    <span class=\"fa-stack\" style=\"font-size: 13px\">\n      <i class=\"fa fa-cloud fa-stack-2x\" style=\"color: rgb(0,150,136)\"></i>\n      <i class=\"fa fa-plug fa-stack-1x\" style=\"color: #fffde7; left: 3px; top: 2px;\"></i>\n    </span>&nbsp; IIJ高圧スマートメーターBルート活用サービス 管理用画面\n  </md-button>\n  <div id=\"user-menu\">\n    <div id=\"account\"><i class=\"fa fa-user fa-fw\"></i> {{$root.username}}</div>\n    <div ng-click=\"$ctrl.logout()\" class=\"header-button\"><i class=\"fas fa-sign-out-alt fa-fw\"></i></div>\n  </div>\n</div>\n<div layout=\"row\">\n  <md-sidenav id=\"main-menu\" class=\"md-sidenav-left\" md-component-id=\"left\" md-is-locked-open=\"true\" md-whiteframe=\"1\" layout=\"column\">\n    <md-list>\n      <md-button ui-sref=\"oem_main.oem_home\"><i class=\"fa fa-home fa-fw\"></i> ホーム　</md-button>\n      <md-divider></md-divider>\n      <md-button ui-sref=\"oem_main.company_create\"><i class=\"fa fa-plus-square fa-fw\"></i> 顧客追加</md-button>\n      <md-divider></md-divider>\n      <md-button ui-sref=\"oem_main.company_index({stateName: 'company_edit'})\"><i class=\"fa fa-wrench fa-fw\"></i> 顧客設定</md-button>\n      <md-divider></md-divider>\n      <md-button ui-sref=\"oem_main.company_index({stateName: 'device_type_select'})\"><i class=\"far fa-file fa-fw\"></i> 端末新規作成</md-button>\n      <md-divider></md-divider>\n      <md-button ui-sref=\"oem_main.company_index({stateName: 'device_index'})\"><i class=\"fa fa-cog fa-fw\"></i> 端末設定変更</md-button>\n      <md-divider></md-divider>\n      <md-button ui-sref=\"oem_main.company_index({stateName: 'demand_control_index'})\" ng-if=\"$root.demandEnabled\"><i class=\"fas fa-hand-pointer fa-fw\"></i> 手動デマンド制御</md-button>\n      <md-divider ng-if=\"$root.demandEnabled\"></md-divider>\n      <md-button ui-sref=\"oem_main.company_index({stateName: 'sa_reboot'})\"><i class=\"fas fa-redo fa-fw\" aria-hidden=\"true\"></i> 端末再起動</md-button>\n      <md-divider></md-divider>\n      <md-button ui-sref=\"oem_main.company_index({stateName: 'notify_list_show'})\"><i class=\"fa fa-envelope fa-fw\"></i> メール通知先設定</md-button>\n      <md-divider></md-divider>\n      <md-button ui-sref=\"oem_main.mail_template\"><i class=\"far fa-file-alt fa-fw\"></i> 送信メール設定</md-button>\n      <md-divider></md-divider>\n      <md-button ui-sref=\"oem_main.global_event\"><i class=\"fa fa-info-circle fa-fw\" aria-hidden=\"true\"></i> お知らせ登録</md-button>\n      <md-divider></md-divider>\n      <md-button ui-sref=\"oem_main.oem_user_index\"><i class=\"fa fa-user fa-fw\" aria-hidden=\"true\"></i> ユーザー管理</md-button>\n      <md-divider></md-divider>\n      <md-button ui-sref=\"oem_main.company_index({stateName: 'external_api_credential'})\"><i class=\"fa fa-key fa-fw\"></i> API認証情報</md-button>\n      <md-divider></md-divider>\n    </md-list>\n  </md-sidenav>\n  <div ui-view style=\"width: 100%\" md-theme=\"oemTheme\" flex></div>\n</div>\n"

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OemHomeController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _oem_home = __webpack_require__(916);

var _oem_home2 = _interopRequireDefault(_oem_home);

var _dist_stock = __webpack_require__(87);

var _dist_stock2 = _interopRequireDefault(_dist_stock);

var _service_stock = __webpack_require__(134);

var _service_stock2 = _interopRequireDefault(_service_stock);

var _device_error = __webpack_require__(469);

var _device_error2 = _interopRequireDefault(_device_error);

var _announce = __webpack_require__(489);

var _announce2 = _interopRequireDefault(_announce);

var _event = __webpack_require__(90);

var _event2 = _interopRequireDefault(_event);

var _csv = __webpack_require__(63);

var _csv2 = _interopRequireDefault(_csv);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OemHomeController = exports.OemHomeController = function () {
  /*@ngInject*/
  OemHomeController.$inject = ["$filter", "$interval", "$mdDialog", "CsvUtil", "DistStockService", "ServiceStockService", "DeviceErrorService", "AnnounceService", "EventService"];
  function OemHomeController($filter, $interval, $mdDialog, CsvUtil, DistStockService, ServiceStockService, DeviceErrorService, AnnounceService, EventService) {
    _classCallCheck(this, OemHomeController);

    this.DistStockService = DistStockService;
    this.ServiceStockService = ServiceStockService;
    this.DeviceErrorService = DeviceErrorService;
    this.AnnounceService = AnnounceService;
    this.EventService = EventService;
    this.CsvUtil = CsvUtil;
    this.$filter = $filter;
    this.$interval = $interval;
    this.$mdDialog = $mdDialog;

    this.announces = [];
    this.errorList = [];
    this.correctList = [];
    this.pagination = {};
    this.downloadFileName = 'event.csv';
  }

  _createClass(OemHomeController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.DistStockService.oem_api.count(function (response) {
        _this.deviceStockCount = response.tsw + response.tss;
      });

      this.ServiceStockService.oem_api.count(function (response) {
        _this.serviceStockCount = response.dss + response.dsc;
      });

      this.updateEvents();
      this.updateDeviceError();

      this.AnnounceService.oem_api.index(function (response) {
        _this.announces = response;
      });

      this.timer = this.$interval(function () {
        _this.updateEvents();
        _this.updateDeviceError(_this.pagination.current_page);
      }, 30000);
    }
  }, {
    key: 'changePage',
    value: function changePage(page) {
      this.updateDeviceError(page);
    }
  }, {
    key: 'updateEvents',
    value: function updateEvents() {
      var _this2 = this;

      this.EventService.oem_api.index(function (response) {
        _this2.events = response;
        _this2.eventCsv = _this2.CsvUtil.processOemEvent(_this2.events);
      });
    }
  }, {
    key: 'updateDeviceError',
    value: function updateDeviceError() {
      var _this3 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.DeviceErrorService.oem_api.index({ page: page }, function (response) {
        var list = response.device_errors;
        _this3.pagination = response.pagination;
        _this3.errorList = _this3.$filter("filter")(list, { has_error: true });
        _this3.correctList = _this3.$filter("filter")(list, { has_error: false });
      });
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      if (this.timer) {
        this.$interval.cancel(this.timer);
      }
    }
  }, {
    key: 'isReadingDevice',
    value: function isReadingDevice(device) {
      return device.operating_mode === 'reading';
    }
  }, {
    key: 'isExpiredAnnounce',
    value: function isExpiredAnnounce(announce) {
      var announce_end = Date.parse(announce.end_at);
      var now = Date.now();
      return announce_end < now;
    }
  }, {
    key: 'showDialog',
    value: function showDialog(announce, ev) {
      var _this4 = this;

      this.AnnounceService.oem_api.show({ id: announce.id }, function (announce) {
        DialogController.$inject = ["$scope", "$mdDialog", "announce"];
        _this4.$mdDialog.show({
          targetEvent: ev,
          templateUrl: 'announce-dialog-oem.html',
          controller: DialogController,
          parent: _angular2.default.element(document.body),
          clickOutsideToClose: true,
          fullscreen: false,
          locals: {
            announce: announce
          }
        });

        /*@ngInject*/
        function DialogController($scope, $mdDialog, announce) {
          $scope.announce = announce;

          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      }, function (response) {
        var alert = _this4.$mdDialog.alert().title('エラー').textContent('障害・メンテナンス情報を取得できませんでした').ok('閉じる');
        _this4.$mdDialog.show(alert);
      });
    }
  }]);

  return OemHomeController;
}();

exports.default = _angular2.default.module('leptonApp.oemHome', [_angularjs2.default, _dist_stock2.default, _service_stock2.default, _device_error2.default, _announce2.default, _event2.default, _csv2.default]).config(_oem_home2.default).component('oemHome', {
  template: __webpack_require__(917),
  controller: OemHomeController
}).name;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.oem_home', {
    url: '/home',
    template: '<oem-home></oem-home>'
  });
};

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports = "<md-content>\n  <div layout=\"row\">\n    <div>\n      <div class=\"subcontent\">\n        <div layout=\"row\">\n          <md-button class=\"status-card oem-status-card\" style=\"border-color: #F56523;\">\n            <div class=\"status-card-title\">異常発生中</div>\n            <div style=\"font-size: 15px;\"><span class=\"bold-num\">{{$ctrl.errorList.length}}</span>&nbsp;&nbsp;/{{$ctrl.errorList.length\n              + $ctrl.correctList.length}}\n              件\n            </div>\n          </md-button>\n          <md-button class=\"status-card oem-status-card\" style=\"border-color: #009688;\">\n            <div class=\"status-card-title\">機器在庫</div>\n            <div><span class=\"bold-num\">{{$ctrl.deviceStockCount}}</span> 台</div>\n          </md-button>\n          <md-button class=\"status-card oem-status-card\" style=\"border-color: #009688;\">\n            <div class=\"status-card-title\">新規設定可能</div>\n            <div><span class=\"bold-num\">{{$ctrl.serviceStockCount}}</span> 台</div>\n          </md-button>\n        </div>\n      </div>\n      <div class=\"subcontent\">\n        <div class=\"announce-content\">\n          <table id=\"announce\">\n            <tr>\n              <th>日時</th>\n              <th>内容</th>\n            </tr>\n            <tr ng-repeat=\"m in $ctrl.announces\" ng-if=\"$ctrl.announces.length > 0\">\n              <td ng-class=\"{'expired-announce': $ctrl.isExpiredAnnounce(m) }\">{{m.start_at | date:'M月d日 HH:mm'}}</td>\n              <td ng-class=\"{'expired-announce': $ctrl.isExpiredAnnounce(m) }\">\n                <md-button class=\"announce-button\" ng-click=\"$ctrl.showDialog(m, $event)\">\n                  {{m.title}}\n                </md-button>\n              </td>\n            </tr>\n            <tr ng-if=\"$ctrl.announces.length === 0\" style=\"text-align: center\">\n              <td style=\"font-size: 16px\">{{::today | date: 'M月d日'}} 現在</td>\n              <td>障害・メンテナンス予定はありません。</td>\n            </tr>\n          </table>\n        </div>\n      </div>\n    </div>\n    <div class=\"subcontent\" flex=\"grow\" style=\"margin-top: 20px; margin-left: 0; max-width: calc(100% - 510px);\">\n      <div class=\"home-event-list-title align-right\">\n        <div>\n          <h4>イベント履歴</h4>\n        </div>\n        <div>\n          <a class=\"csv-downloader\" csv-downloader filename=\"$ctrl.downloadFileName\" csv-data=\"$ctrl.eventCsv\">\n            <i class=\"fa fa-download\" aria-hidden=\"true\"></i>\n          </a>\n        </div>\n      </div>\n      <div ng-if=\"$ctrl.events.length === 0\">\n        イベントはまだありません\n      </div>\n      <div class=\"event\" ng-if=\"$ctrl.events.length > 0\">\n        <md-list>\n          <md-list-item class=\"md-2-line\" ng-repeat=\"event in $ctrl.events\" style=\"padding: 0 0 0 10px;min-height: 0\">\n            <div class=\"event-list-item\" layout=\"row\" layout-align=\"start center\">\n              <i ng-class=\"event.is_error ? 'fa fa-exclamation-circle error' : 'fa fa-check-square normal'\"></i>\n              <div class=\"event-info\" layout=\"column\" layout-align=\"space-around start\">\n                <div layout=\"row\" layout-align=\"space-between center\" style=\"width: 100%;\">\n                  <div class=\"event-msg\">\n                    {{ event.event_msg }}<span ng-if=\"event.triggered_by\" class=\"edited-by\"> (変更者: {{ event.triggered_by }})</span>\n                  </div>\n                  <div class=\"event-minor-info\" layout=\"column\" layout-align=\"center end\">\n                    <span>{{ event.occurred_at | date : 'M/d HH:mm' }}</span><span>{{ event.pms_service_code }}</span>\n                  </div>\n                </div>\n                <div class=\"event-minor-info event-location\">\n                  {{ event.company_name }} {{ event.location }}\n                </div>\n              </div>\n            </div>\n            <md-divider></md-divider>\n          </md-list-item>\n        </md-list>\n      </div>\n    </div>\n  </div>\n  <div class=\"subcontent device-status-list\" style=\"margin: 10px 10px 0 15px;\">\n    <div>\n      <md-toolbar class=\"md-hue-2\">\n        稼働中機器一覧\n      </md-toolbar>\n      <div class=\"device-status-list-empty\" ng-if=\"($ctrl.errorList.length + $ctrl.correctList.length) === 0\">\n        稼働中の機器はありません\n      </div>\n      <pagination pg-object=\"$ctrl.pagination\" action=\"$ctrl.changePage(page)\"></pagination>\n      <table class=\"device-list-table\">\n        <tr ng-repeat=\"device in $ctrl.errorList\">\n          <td class=\"device-list-company-name\">\n            <span class=\"span-link\" ui-sref=\"oem_main.company_edit({company_id:{{device.company_id}}})\">\n              {{ device.company_name }}\n            </span>\n          </td>\n          <td class=\"device-list-service-code\">\n            <i class=\"fa fa-fw\" ng-class=\"$ctrl.isReadingDevice(device) ? 'fa-tachometer-alt' : 'fa-sliders-h'\"></i>&nbsp;\n            <span class=\"span-link\" ui-sref=\"{{ $ctrl.isReadingDevice(device) ?\n                'oem_main.device_config_edit({ id: device.id, company_id: device.company_id })'\n                  : 'oem_main.controller_device_edit({ id: device.id, company_id: device.company_id })' }}\">\n              {{ device.pms_service_code }}\n            </span>\n          </td>\n          <td class=\"device-list-info\">\n            <div>{{ device.location }}</div>\n            <div>{{ device.memo }}</div>\n          </td>\n          <td class=\"device-list-status-detail\">\n            <div class=\"status-detail-error\">{{ device | getErrorMessage }}</div>\n          </td>\n        </tr>\n        <tr ng-repeat=\"device in $ctrl.correctList\">\n          <td class=\"device-list-company-name\">\n            <span ui-sref=\"oem_main.company_edit({company_id:{{device.company_id}}})\">\n              {{ device.company_name }}\n            </span>\n          </td>\n          <td class=\"device-list-service-code\">\n            <i class=\"fa fa-fw\" ng-class=\"$ctrl.isReadingDevice(device) ? 'fa-tachometer-alt' : 'fa-sliders-h'\"></i>&nbsp;\n            <span ui-sref=\"{{ $ctrl.isReadingDevice(device) ?\n                'oem_main.device_config_edit({ id: device.id, company_id: device.company_id })'\n                  : 'oem_main.controller_device_edit({ id: device.id, company_id: device.company_id })' }}\">\n              {{ device.pms_service_code }}\n            </span>\n          </td>\n          <td class=\"device-list-info\">\n            <div>{{ device.location }}</div>\n            <div>{{ device.memo }}</div>\n          </td>\n          <td class=\"device-list-status-detail\">\n            <div class=\"status-detail-correct\">{{ device | getErrorMessage }}</div>\n          </td>\n        </tr>\n      </table>\n      <pagination pg-object=\"$ctrl.pagination\" action=\"$ctrl.changePage(page)\"></pagination>\n    </div>\n  </div>\n</md-content>\n<script type=\"text/ng-template\" id=\"announce-dialog-oem.html\">\n  <md-dialog aria-label=\"Announce\">\n    <form ng-cloak>\n      <md-toolbar>\n        <div class=\"md-dialog-title\">\n          <h3>{{ announce.title }}</h3>\n        </div>\n      </md-toolbar>\n      <md-dialog-content>\n        <div class=\"md-dialog-content\">\n          <pre>{{ announce.detail }}</pre>\n        </div>\n      </md-dialog-content>\n      <md-dialog-actions layout-align=\"center center\">\n        <md-button ng-click=\"closeDialog()\">\n          閉じる\n        </md-button>\n      </md-dialog-actions>\n    </form>\n  </md-dialog>\n</script>\n"

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CompanyCreateController = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _company_create = __webpack_require__(919);

var _company_create2 = _interopRequireDefault(_company_create);

var _company = __webpack_require__(95);

var _company2 = _interopRequireDefault(_company);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var CompanyCreateController = exports.CompanyCreateController = function () {
    /*@ngInject*/
    CompanyCreateController.$inject = ["$state", "$mdDialog", "CompanyService"];
    function CompanyCreateController($state, $mdDialog, CompanyService) {
        _classCallCheck(this, CompanyCreateController);

        this.CompanyService = CompanyService;
        this.$mdDialog = $mdDialog;
        this.$state = $state;

        this.companyName = '';
        this.createInitialEndUser = false;
        this.initialUserData = {
            'name': '',
            'email': '',
            'email_match': ''
        };
    }

    _createClass(CompanyCreateController, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'addCompany',
        value: function addCompany() {
            var _this = this;

            var dialog = {
                confirm: this.$mdDialog.confirm({
                    clickOutsideToClose: true,
                    title: this.companyName + " \u3092\u8FFD\u52A0\u3057\u307E\u3059\u304B\uFF1F",
                    ok: '追加する',
                    cancel: '戻る'
                }),
                success: this.$mdDialog.alert({
                    clickOutsideToClose: true,
                    title: '追加しました',
                    content: '設定変更画面に移動します。サポート用アカウントを確認してください。',
                    ok: 'OK'
                }),
                duplication_error: this.$mdDialog.alert({
                    clickOutsideToClose: true,
                    title: 'アカウントの作成に失敗しました',
                    content: '初期アカウントとして入力されたメールアドレスは既に登録されています。',
                    ok: 'OK'
                }),
                error: this.$mdDialog.alert({
                    clickOutsideToClose: true,
                    title: 'エラーが発生しました',
                    content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
                    ok: 'OK'
                })
            };

            this.$mdDialog.show(dialog.confirm).then(function () {
                _this.submitted = true;

                var payload = {
                    name: _this.companyName
                };

                if (_this.createInitialEndUser) {
                    payload['initial_username'] = _this.initialUserData['name'];
                    payload['initial_useremail'] = _this.initialUserData['email'];
                }

                _this.CompanyService.create(payload, function (successResponse) {
                    _this.$mdDialog.show(dialog.success).finally(function () {
                        _this.$state.go('oem_main.company_edit', { company_id: successResponse.id });
                    });
                }, function (errorResponse) {
                    _this.submitted = false;
                    if (errorResponse.data.message.email && errorResponse.data.message.email[0] === 'address is already in use') {
                        _this.$mdDialog.show(dialog.duplication_error);
                    } else {
                        _this.$mdDialog.show(dialog.error);
                    }
                });
            });
        }
    }]);

    return CompanyCreateController;
}();

exports.default = _angular2.default.module('leptonApp.companyCreate', [_angularjs2.default, _company2.default]).config(_company_create2.default).component('companyCreate', {
    template: __webpack_require__(920),
    controller: CompanyCreateController
}).name;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.company_create', {
    url: '/company_create',
    template: '<company-create></company-create>'
  });
};

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n\t<div class=\"md-toolbar-tools\">\n\t\t<h2><i class=\"fa fa-plus-square\"></i>&nbsp;顧客追加</h2>\n\t</div>\n</md-toolbar>\n\n<md-content style=\"padding: 5px 30px;\">\n\t<form name=\"companyForm\" novalidate>\n\t\t<h4 style=\"margin-bottom: 0\">顧客名を入力してください</h4>\n\t\t<md-input-container class=\"md-block\" flex-gt-sm style=\"margin: 30px 0px 17px; width: 400px\">\n            <label>顧客名</label>\n\t\t\t<input name=\"company_name\" ng-model=\"$ctrl.companyName\" md-maxlength=\"128\" required>\n\t\t\t<div ng-messages=\"companyForm.company_name.$error\" ng-if=\"companyForm.company_name.$dirty\" role=\"alert\" multiple>\n\t\t\t\t<div ng-message=\"md-maxlength\">128文字以下で記載してください</div>\n\t\t\t\t<div ng-message=\"required\">顧客名を入力してください</div>\n\t\t\t</div>\n\t\t</md-input-container>\n\n\t\t<md-input-container class=\"md-block\" flex-gt-sm style=\"margin: 30px 0px 17px; width: 400px\">\n\t\t\t<md-checkbox name=\"initial_account_checkbox\" class=\"initial_account_checkbox\" ng-model=\"$ctrl.createInitialEndUser\">\n\t\t\t\t<h4>顧客向け初期アカウントを作成</h4>\n\t\t\t</md-checkbox>\n\t\t</md-input-container>\n\n\t\t<div ng-if=\"$ctrl.createInitialEndUser\">\n\t\t\t<h4 style=\"margin-bottom: 0\">初期アカウント情報を入力してください</h4>\n\t\t\t<md-input-container class=\"md-block\" flex-gt-sm style=\"margin: 30px 0px 17px; width: 600px\">\n\t\t\t\t<label>名前</label>\n\t\t\t\t<input name=\"name\" ng-model=\"$ctrl.initialUserData.name\" ng-required=\"$ctrl.createInitialEndUser\" md-maxlength=\"255\">\n\t\t\t\t<div ng-messages=\"companyForm.name.$error\" ng-if=\"companyForm.name.$dirty\" role=\"alert\" multiple>\n\t\t\t\t\t<div ng-message=\"required\">入力してください</div>\n\t\t\t\t\t<div ng-message=\"md-maxlength\">255文字以下で記載してください</div>\n\t\t\t\t</div>\n\t\t\t</md-input-container>\n\t\t\t<md-input-container class=\"md-block\" flex-gt-sm style=\"margin: 30px 0px 17px; width: 600px\">\n\t\t\t\t<label>メールアドレス</label>\n\t\t\t\t<input name=\"email\" type=\"email\" ng-model=\"$ctrl.initialUserData.email\" ng-required=\"$ctrl.createInitialEndUser\"  md-maxlength=\"254\">\n\t\t\t\t<div ng-messages=\"companyForm.email.$error\" ng-if=\"companyForm.email.$dirty\" role=\"alert\" multiple>\n\t\t\t\t\t<div ng-message=\"required\">入力してください</div>\n\t\t\t\t\t<div ng-message=\"md-maxlength\">254文字以下で記載してください</div>\n\t\t\t\t\t<div ng-message=\"email\">メールアドレスのフォーマットで入力してください</div>\n\t\t\t\t</div>\n\t\t\t</md-input-container>\n\t\t\t<md-input-container class=\"md-block\" flex-gt-sm style=\"margin: 30px 0px 17px; width: 600px\">\n\t\t\t\t<label>確認のためメールアドレスをもう一度入力してください</label>\n\t\t\t\t<input name=\"email_match\" type=\"text\" ng-model=\"$ctrl.initialUserData.email_match\" ng-required=\"$ctrl.createInitialEndUser\"  md-maxlength=\"254\" match=\"$ctrl.initialUserData.email\">\n\t\t\t\t<div class=\"invalid\" type=\"text\" ng-messages=\"companyForm.email_match.$error\" ng-if=\"companyForm.email_match.$dirty\">\n\t\t\t\t\t<div ng-message=\"required\">入力してください</div>\n\t\t\t\t\t<div ng-message=\"md-maxlength\">254文字以内で入力してください</div>\n\t\t\t\t\t<div ng-show=\"companyForm.email_match.$error.match\">メールアドレスが一致しません</div>\n\t\t\t\t</div>\n\t\t\t</md-input-container>\n\n\t\t\t<span class=\"note\">\n\t\t\t\t※入力されたメールアドレスにワンタイムURLを含むメールが送信されます\n\t\t\t</span>\n\t\t</div>\n\n        <md-button ng-click=\"$ctrl.addCompany()\" ng-disabled=\"companyForm.$invalid || $ctrl.submitted\" class=\"md-primary md-raised\" style=\"margin: 16px 0; padding: 0 20px\">追加する</md-button>\n\t</form>\n</md-content>\n"

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompanyIndexController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _company_index = __webpack_require__(922);

var _company_index2 = _interopRequireDefault(_company_index);

var _company = __webpack_require__(95);

var _company2 = _interopRequireDefault(_company);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var CompanyIndexController = exports.CompanyIndexController = function () {
  /*@ngInject*/
  CompanyIndexController.$inject = ["CompanyService", "$stateParams"];
  function CompanyIndexController(CompanyService, $stateParams) {
    _classCallCheck(this, CompanyIndexController);

    this.stateName = $stateParams.stateName;
    this.linkTo = 'oem_main.' + this.stateName;

    this.companyList = [];
    this.CompanyService = CompanyService;
  }

  _createClass(CompanyIndexController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.CompanyService.index(function (response) {
        _this.companyList = response;
      });
    }
  }]);

  return CompanyIndexController;
}();

exports.default = _angular2.default.module('leptonApp.companyIndex', [_angularjs2.default, _company2.default]).config(_company_index2.default).component('companyIndex', {
  template: __webpack_require__(923),
  controller: CompanyIndexController
}).name;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('oem_main.company_index', {
        url: '/company_index/:stateName',
        template: '<company-index></company-index>'
    });
}

/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports = "<device-config-search-form ng-if=\"$ctrl.linkTo === 'oem_main.device_index' || $ctrl.linkTo === 'oem_main.demand_control_index'\"></device-config-search-form>\n<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-list\"></i>&nbsp;&nbsp;{{$ctrl.stateName | companyListTitle}}</h2>\n  </div>\n</md-toolbar>\n<div ng-if=\"$ctrl.companyList.length === 0\" class=\"empty-notice\">まだ顧客がありません。</div>\n<md-content>\n  <md-list-item class=\"md-3-line company-list\" ng-repeat=\"company in $ctrl.companyList\">\n    <a ui-sref=\"{{$ctrl.linkTo}}({company_id:{{company.id}}})\" style=\"width: 100%; padding: 12px 0\">\n      <div class=\"md-list-item-text\" layout=\"column\">\n        <h3 style=\"font-size: 1.2em; margin: 6px 0 6px 0;\">{{company.name}}</h3>\n        <h4 style=\"color: #9e9e9e; font-size: 1em;\">作成日：{{company.created_at | date:'yyyy年MM月dd日'}}</h4>\n      </div>\n    </a>\n    <md-divider></md-divider>\n  </md-list-item>\n</md-content>\n"

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CompanyEditController = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _company_edit = __webpack_require__(925);

var _company_edit2 = _interopRequireDefault(_company_edit);

var _company = __webpack_require__(95);

var _company2 = _interopRequireDefault(_company);

var _end_user = __webpack_require__(471);

var _end_user2 = _interopRequireDefault(_end_user);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var CompanyEditController = exports.CompanyEditController = function () {
    /*@ngInject*/
    CompanyEditController.$inject = ["$stateParams", "$state", "$mdDialog", "CompanyService", "EndUserService", "SaConfigService"];
    function CompanyEditController($stateParams, $state, $mdDialog, CompanyService, EndUserService, SaConfigService) {
        _classCallCheck(this, CompanyEditController);

        this.id = $stateParams.company_id;
        this.CompanyService = CompanyService;
        this.EndUserService = EndUserService;
        this.SaConfigService = SaConfigService;
        this.$mdDialog = $mdDialog;
        this.$state = $state;

        this.company_dialog = {
            confirm: $mdDialog.confirm({
                clickOutsideToClose: true,
                title: '顧客名を変更しますか？',
                ok: '変更する',
                cancel: '戻る'
            }),
            success: $mdDialog.alert({
                clickOutsideToClose: true,
                title: '変更しました',
                ok: 'OK'
            })
        };

        this.companyDestroyDialog = {
            confirm: $mdDialog.confirm({
                clickOutsideToClose: true,
                title: '顧客を削除しますか？',
                ok: '削除する',
                cancel: '戻る'
            }),
            success: $mdDialog.alert({
                clickOutsideToClose: true,
                title: '顧客を削除しました',
                ok: 'OK'
            }),
            error: $mdDialog.alert({
                clickOutsideToClose: true,
                title: '顧客配下に機器が存在しています',
                content: '顧客を削除するには配下の機器を全て解約してください。',
                ok: 'OK'
            })
        };

        this.user_dialog = {
            confirm: $mdDialog.confirm({
                clickOutsideToClose: true,
                title: 'パスワードを更新しますか？',
                content: '以前のパスワードではログインできなくなります',
                ok: '更新する',
                cancel: '戻る'
            }),
            success: $mdDialog.alert({
                clickOutsideToClose: true,
                title: '更新しました',
                ok: 'OK'
            })
        };

        this.error_dialog = $mdDialog.alert({
            clickOutsideToClose: true,
            title: 'エラーが発生しました',
            content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
            ok: 'OK'
        });
    }

    _createClass(CompanyEditController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.CompanyService.show({ id: this.id }, function (response) {
                _this.company = response;
            }, function (err) {
                if (err.status === 404 || err.status === 403) {
                    _this.$state.go('oem_main.oem_home');
                }
            });

            this.EndUserService.oem_api.index({ company_id: this.id }, function (response) {
                _this.supportAccount = response[0];
            });

            this.SaConfigService.oem_api.index({ company_id: this.id }, function (response) {
                _this.saConfigList = response;
            });
        }
    }, {
        key: 'updateCompany',
        value: function updateCompany() {
            var _this2 = this;

            this.$mdDialog.show(this.company_dialog.confirm).then(function () {
                _this2.CompanyService.update(_this2.company, function (okResponse) {
                    _this2.$mdDialog.show(_this2.company_dialog.success);
                }, function (errResponse) {
                    _this2.$mdDialog.show(_this2.error_dialog);
                });
            });
        }
    }, {
        key: 'updateUser',
        value: function updateUser() {
            var _this3 = this;

            this.$mdDialog.show(this.user_dialog.confirm).then(function () {
                _this3.EndUserService.oem_api.update({ id: _this3.supportAccount.id }, function (okResponse) {
                    _this3.supportAccount = okResponse;
                    _this3.$mdDialog.show(_this3.user_dialog.success);
                }, function (errResponse) {
                    _this3.$mdDialog.show(_this3.error_dialog);
                });
            });
        }
    }, {
        key: 'destroyCompany',
        value: function destroyCompany() {
            var _this4 = this;

            if (this.saConfigList.length > 0) {
                this.$mdDialog.show(this.companyDestroyDialog.error);
                return;
            }

            this.$mdDialog.show(this.companyDestroyDialog.confirm).then(function () {
                _this4.CompanyService.destroy({ id: _this4.id }, function (ok) {
                    _this4.$mdDialog.show(_this4.companyDestroyDialog.success).finally(function () {
                        _this4.$state.go('oem_main.company_index');
                    });
                }, function (ng) {
                    _this4.$mdDialog.show(_this4.error_dialog);
                });
            });
        }
    }, {
        key: 'copyToClip',
        value: function copyToClip(event) {
            var prev = event.target.previousElementSibling;
            prev.select();
            document.execCommand("Copy");
        }
    }]);

    return CompanyEditController;
}();

exports.default = _angular2.default.module('leptonApp.companyEdit', [_angularjs2.default, _company2.default, _end_user2.default, _sa_config2.default]).config(_company_edit2.default).component('companyEdit', {
    template: __webpack_require__(926),
    controller: CompanyEditController
}).name;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('oem_main.company_edit', {
        url: '/company_edit/:company_id',
        template: '<company-edit></company-edit>'
    });
}

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n    <div class=\"md-toolbar-tools\">\n        <h2><i class=\"fa fa-wrench\"></i>&nbsp;&nbsp;顧客設定</h2>\n    </div>\n</md-toolbar>\n<md-content class=\"company-edit\">\n    <div class=\"align-right\">\n        <div>\n            <form name=\"companyForm\" novalidate>\n                <md-input-container class=\"md-block\" flex-gt-sm>\n                    <label>顧客名</label>\n                    <input name=\"company_name\" ng-model=\"$ctrl.company.name\" md-maxlength=\"128\" required>\n                    <div ng-messages=\"companyForm.company_name.$error\" ng-if=\"companyForm.company_name.$dirty\" role=\"alert\" multiple>\n                        <div ng-message=\"md-maxlength\">128文字以下で記載してください</div>\n                        <div ng-message=\"required\">顧客名を入力してください</div>\n                    </div>\n                </md-input-container>\n                <md-button ng-click=\"$ctrl.updateCompany()\" ng-disabled=\"companyForm.$invalid\" class=\"md-primary md-raised\">\n                    変更する\n                </md-button>\n            </form>\n            <h3>サポート用アカウント</h3>\n            <p>下記の認証情報で <a href=\"https://hv.pms.iij.jp/\" target=\"_blank\">顧客画面</a> にログインすることができます。</p>\n            <div class=\"login-info\">\n                <div>\n                    <span class=\"login-info-label\">ログインID: </span>\n                    <input class=\"login-info-value\" readonly value=\"{{$ctrl.supportAccount.email}}\">\n                    <md-button ng-click=\"$ctrl.copyToClip($event)\" class=\"md-primary md-raised\">\n                        コピー\n                    </md-button>\n                </div>\n                <div>\n                    <span class=\"login-info-label\">パスワード: </span>\n                    <input class=\"login-info-value\" readonly value=\"{{$ctrl.supportAccount.plain_password}}\">\n                    <md-button ng-click=\"$ctrl.copyToClip($event)\" class=\"md-primary md-raised\">\n                        コピー\n                    </md-button>\n                </div>\n            </div>\n            <md-button class=\"md-warn md-raised\" ng-click=\"$ctrl.updateUser()\" style=\"margin-top: 10px; color: white; padding: 1px 12px;\">\n                パスワードを更新する\n            </md-button>\n        </div>\n        <div>\n            <md-button ng-click=\"$ctrl.destroyCompany()\" class=\"md-warn md-raised\" style=\"padding: 1px 15px;;color: white;background-color: rgb(255,87,34);\">\n                顧客を削除\n            </md-button>\n        </div>\n    </div>\n</md-content>\n"

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OemDeviceConfigCreateController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _device_config_create = __webpack_require__(928);

var _device_config_create2 = _interopRequireDefault(_device_config_create);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _dist_stock = __webpack_require__(87);

var _dist_stock2 = _interopRequireDefault(_dist_stock);

var _company = __webpack_require__(95);

var _company2 = _interopRequireDefault(_company);

var _zipSearch = __webpack_require__(217);

var _zipSearch2 = _interopRequireDefault(_zipSearch);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OemDeviceConfigCreateController = exports.OemDeviceConfigCreateController = function () {
  /*@ngInject*/
  OemDeviceConfigCreateController.$inject = ["SaConfigService", "CompanyService", "$state", "$stateParams", "$scope", "$timeout", "$mdDialog", "DistStockService", "ZipSearchLogic"];
  function OemDeviceConfigCreateController(SaConfigService, CompanyService, $state, $stateParams, $scope, $timeout, $mdDialog, DistStockService, ZipSearchLogic) {
    var _this = this;

    _classCallCheck(this, OemDeviceConfigCreateController);

    this.deviceConfig = {
      mode: 'reading_only',
      wlan_enabled: false,
      company_id: $stateParams.company_id,
      carrier_port: 'emobile0',
      distribution_id: '',
      demand_dead_duration: 600,
      demand_level_down_count: 3,
      remoteio_name: 'panasonic-uenu2d4r12'
    };
    this.SaConfigService = SaConfigService;
    this.DistStockService = DistStockService;
    this.CompanyService = CompanyService;
    this.ZipSearchLogic = ZipSearchLogic;
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.company_id = $stateParams.company_id;
    this.dialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '作成しますか?',
        ok: '作成する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '作成しました',
        content: '端末一覧 画面に移動します',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };

    $scope.$watch('$ctrl.deviceConfig.zip_code', function (current) {
      if (current) {
        _this.ZipSearchLogic.get(current).then(function (address) {
          $timeout(function () {
            _this.deviceConfig.location = address.prefecture_name + address.city_name + address.town_name;
          });
        });
      }
    });
  }

  _createClass(OemDeviceConfigCreateController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.DistStockService.oem_api.index(function (response) {
        _this2.deviceStocks = response.dist_stocks;
      });

      this.CompanyService.show({ id: this.company_id }, function (response) {
        _this2.company = response;
      }, function (err) {
        if (err.status === 404 || err.status === 403) {
          _this2.$state.go('oem_main.oem_home');
        }
      });
    }
  }, {
    key: 'showConfirm',
    value: function showConfirm(deviceConfig, ev) {
      var _this3 = this;

      this.$mdDialog.show(this.dialog.confirm.targetEvent(ev)).then(function () {
        deviceConfig.base_unit_price = deviceConfig.base_unit_price || 0;
        deviceConfig.power_unit_price = deviceConfig.power_unit_price || 0;
        _this3.SaConfigService.oem_api.create(deviceConfig, function (okResponse) {
          _this3.$mdDialog.show(_this3.dialog.success).finally(function () {
            return _this3.$state.go('oem_main.device_index', { company_id: _this3.company_id });
          });
        }, function (errResponse) {
          _this3.$mdDialog.show(_this3.dialog.error.content(errResponse.data.message));
        });
      });
    }
  }]);

  return OemDeviceConfigCreateController;
}();

exports.default = _angular2.default.module('leptonApp.oemDeviceConfigCreate', [_angularjs2.default, _sa_config2.default, _dist_stock2.default, _company2.default, _zipSearch2.default]).config(_device_config_create2.default).component('oemDeviceConfigCreate', {
  template: __webpack_require__(929),
  controller: OemDeviceConfigCreateController
}).name;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.device_config_create', {
    url: '/company/:company_id/device_config_create',
    template: '<oem-device-config-create></oem-device-config-create>',
    params: { id: null }
  });
};

/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-file\"></i>&nbsp;&nbsp;端末新規作成: {{$ctrl.company.name}}</h2>\n  </div>\n</md-toolbar>\n<md-content style=\"padding: 20px 30px;\">\n  <form name=\"configForm\" novalidate>\n    <h4 class=\"input-group-title\">顧客情報</h4>\n    <div layout-gt-sm=\"row\">\n      <md-input-container class=\"md-block input-container\" flex-gt-sm>\n        <label>管理ID</label>\n        <input name=\"management_id\" ng-model=\"$ctrl.deviceConfig.management_id\" md-maxlength=\"16\" maxlength=\"16\">\n        <div ng-messages=\"configForm.management_id.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">16文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-block input-container\" flex-gt-sm>\n        <label>管理情報</label>\n        <input name=\"management_info\" ng-model=\"$ctrl.deviceConfig.management_info\" md-maxlength=\"64\" maxlength=\"64\">\n        <div ng-messages=\"configForm.management_info.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">64文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <h4 class=\"input-group-title\">機器情報</h4>\n    <md-input-container class=\"input-container zip-input-content\" flex-gt-sm>\n      <div>\n        <label>郵便番号 (現地の天候情報取得に使用されます)</label>\n        <input name=\"zip_code\" ng-model=\"$ctrl.deviceConfig.zip_code\" placeholder=\"000-0000\" ng-pattern=\"/^[0-9]{3}-[0-9]{4}$/\">\n        <div ng-messages=\"configForm.zip_code.$error\" role=\"alert\">\n          <div ng-message=\"pattern\">000-0000の形式で記載してください</div>\n        </div>\n      </div>\n      <div class=\"weather-zip-notice\">\n        ※ 事業所用個別郵便番号では天候情報は取得できません。地域の郵便番号を設定ください。<br>\n        ※ 天候情報が取得できなかった場合は、近隣都市の郵便番号をお試しください。\n      </div>\n    </md-input-container>\n    <div layout-gt-sm=\"row\">\n      <md-input-container class=\"md-block input-container\" flex-gt-sm style=\"width: 70%;\">\n        <label>設置場所<span class=\"require-sign\"> ＊</span></label>\n        <input name=\"location\" ng-model=\"$ctrl.deviceConfig.location\" md-maxlength=\"128\" required maxlength=\"128\">\n        <div ng-messages=\"configForm.location.$error\" role=\"alert\">\n          <div ng-message=\"required\">設置場所を入力してください。</div>\n          <div ng-message=\"md-maxlength\">128文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-block input-container\" flex-gt-sm style=\"width: 70%;\">\n        <label>メモ</label>\n        <input name=\"memo\" ng-model=\"$ctrl.deviceConfig.memo\" md-maxlength=\"128\" maxlength=\"128\">\n        <div ng-messages=\"configForm.memo.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">128文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <h4 class=\"input-group-title\">デマンド監視閾値</h4>\n    <span class=\"sub-info\">※ 0 を入力するとデマンド監視が無効化されます</span>\n    <div layout-gt-sm=\"row\">\n      <div layout-gt-sm=\"row\"  flex=\"75\" offset=\"50\">\n        <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px; min-width: 150px;\">\n          <label>契約電力<span class=\"require-sign\"> ＊</span></label>\n          <input type=\"number\" name=\"contract_power\" ng-model=\"$ctrl.deviceConfig.contract_power\" min=\"0\" max=\"99999\" flex=\"80\" required ng-pattern=\"/^[0-9][^\\.]*$/\">\n          <div class=\"power_unit\">&nbsp;&nbsp;kW</div>\n          <div ng-messages=\"configForm.contract_power.$error\" ng-if=\"configForm.contract_power.$dirty\" role=\"alert\" multiple>\n            <div ng-message=\"max\">99999 以下の数字を入力してください。</div>\n            <div ng-message=\"min\">0 以上の数字を入力してください。</div>\n            <div ng-message=\"number\">数値を入力してください。</div>\n            <div ng-message=\"pattern\">整数を入力してください</div>\n            <div ng-message=\"required\">0 ~ 99999 までの数字を入力してください。</div>\n          </div>\n        </md-input-container>\n\n        <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px; min-width: 150px;\">\n          <label>限界電力<span class=\"require-sign\"> ＊</span></label>\n          <input type=\"number\" name=\"limit_power\" ng-model=\"$ctrl.deviceConfig.limit_power\" min=\"0\" max=\"{{$ctrl.deviceConfig.contract_power}}\" flex=\"80\" required ng-pattern=\"/^[0-9][^\\.]*$/\">\n          <div class=\"power_unit\">&nbsp;&nbsp;kW</div>\n          <div ng-messages=\"configForm.limit_power.$error\" ng-if=\"configForm.limit_power.$dirty\" role=\"alert\" multiple>\n            <div ng-message=\"max\">契約電力量以下の数字を入力してください。</div>\n            <div ng-message=\"min\">0 以上の数字を入力してください。</div>\n            <div ng-message=\"number\">数値を入力してください。</div>\n            <div ng-message=\"pattern\">整数を入力してください</div>\n            <div ng-message=\"required\">0 ~ 契約電力量までの数字を入力してください。</div>\n          </div>\n        </md-input-container>\n\n        <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px; min-width: 150px;\">\n          <label>目標電力<span class=\"require-sign\"> ＊</span></label>\n          <input type=\"number\" name=\"target_power\" ng-model=\"$ctrl.deviceConfig.target_power\" min=\"0\" max=\"{{$ctrl.deviceConfig.limit_power}}\" flex=\"80\" required ng-pattern=\"/^[0-9][^\\.]*$/\">\n          <div class=\"power_unit\">&nbsp;&nbsp;kW</div>\n          <div ng-messages=\"configForm.target_power.$error\" ng-if=\"configForm.target_power.$dirty\" role=\"alert\" multiple>\n            <div ng-message=\"max\">限界電力量量以下の数字を入力してください。</div>\n            <div ng-message=\"min\">0 以上の数字を入力してください。</div>\n            <div ng-message=\"number\">数値を入力してください。</div>\n            <div ng-message=\"pattern\">整数を入力してください</div>\n            <div ng-message=\"required\">0 ~ 限界電力量までの数字を入力してください。</div>\n          </div>\n        </md-input-container>\n      </div>\n    </div>\n\n    <h4 class=\"input-group-title\">デマンド監視無効時間</h4>\n    <div class=\"dead-duration-sub\">デマンド時限開始から\n      <duration-selector ng-model=\"$ctrl.deviceConfig.demand_dead_duration\"></duration-selector>\n      分間 デマンド監視を無効化します。\n    </div>\n\n    <h4 class=\"input-group-title\">デマンド警報解除条件</h4>\n    <div style=\"margin-bottom: 30px\">\n      <md-radio-group ng-model=\"$ctrl.deviceConfig.demand_level_down_count\" required>\n        <md-radio-button value=3 class=\"md-primary\" style=\"margin:5px 0\">標準判定</md-radio-button>\n        <span style=\"font-size: 12px; margin-left: 30px;\">※ 予測値が閾値の90％を下回った状態が3分間継続した時点で警報を解除します。</span>\n        <md-radio-button value=1 class=\"md-primary\" style=\"margin:5px 0\">即時解除</md-radio-button>\n        <span style=\"font-size: 12px; margin-left: 30px;\">※ 予測値が閾値の90％を1度下回った時点で警報を解除します。本設定により警報・警報解除が頻発する場合がありますのでご注意ください。</span>\n      </md-radio-group>\n    </div>\n\n    <h4 class=\"input-group-title\">電気料金単価</h4>\n    <div layout-gt-sm=\"row\" flex=\"75\">\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px; min-width: 150px;\">\n        <label>基本料金単価</label>\n        <input type=\"number\" name=\"base_unit_price\" ng-model=\"$ctrl.deviceConfig.base_unit_price\" min=\"0\" max=\"9999.99\" flex=\"80\" step=\"0.01\" ng-pattern=\"/^[0-9]+\\.?[0-9]{0,2}$/\">\n        <div class=\"power_unit\">&nbsp;&nbsp;円 /1 kW</div>\n        <div ng-messages=\"configForm.base_unit_price.$error\" ng-if=\"configForm.base_unit_price.$dirty\" role=\"alert\" multiple>\n          <div ng-message=\"max\">9999.99 以下の数字を入力してください。</div>\n          <div ng-message=\"min\">0 以上の数字を入力してください。</div>\n          <div ng-message=\"pattern\">小数２桁までの数値を入力してください</div>\n          <div ng-message=\"number\">数値を入力してください。</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px; min-width: 150px;\">\n        <label>電力量単価</label>\n        <input type=\"number\" name=\"power_unit_price\" ng-model=\"$ctrl.deviceConfig.power_unit_price\" min=\"0\" max=\"9999.99\" flex=\"80\" step=\"0.01\" ng-pattern=\"/^[0-9]+\\.?[0-9]{0,2}$/\">\n        <div class=\"power_unit\">&nbsp;&nbsp;円 /1 kWh</div>\n        <div ng-messages=\"configForm.power_unit_price.$error\" ng-if=\"configForm.power_unit_price.$dirty\" role=\"alert\" multiple>\n          <div ng-message=\"max\">9999.99 以下の数字を入力してください。</div>\n          <div ng-message=\"min\">0 以上の数字を入力してください。</div>\n          <div ng-message=\"pattern\">小数２桁までの数値を入力してください</div>\n          <div ng-message=\"number\">数値を入力してください。</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <h4 class=\"input-group-title\">機器 ID<span class=\"require-sign\"> ＊</span></h4>\n    <div>\n      <md-input-container>\n        <label>一覧から選択</label>\n        <md-select id=\"distIdSelect\" class=\"ng-animate-disabled\" name=\"distribution_id\" ng-model=\"$ctrl.deviceConfig.distribution_id\" required>\n          <md-option class=\"ng-animate-disabled\" ng-repeat=\"distId in $ctrl.deviceStocks\" value=\"{{distId}}\"><div style=\"margin-right: 20px;\">{{distId}}</div></md-option>\n        </md-select>\n      </md-input-container>\n    </div>\n\n    <h4>クラウドへの接続方法を選択<span class=\"require-sign\"> ＊</span></h4>\n    <div style=\"margin-bottom: 10px\">\n      <md-radio-group ng-model=\"$ctrl.deviceConfig.mode\" required>\n        <md-radio-button value=\"reading_only\" class=\"md-primary\" style=\"margin:5px 0\">有線接続 ( DHCP )</md-radio-button>\n        <md-radio-button value=\"mobile\" class=\"md-primary\" style=\"margin:5px 0\">モバイル接続</md-radio-button>\n      </md-radio-group>\n    </div>\n\n    <div ng-if=\"$ctrl.deviceConfig.mode==='mobile'\" class=\"animate-if\">\n      <md-content style=\"padding: 0 16px\">\n        <h5>モバイルの認証情報</h5>\n        <div layout-gt-sm=\"row\">\n          <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-left: 20px\">\n            <label>モバイル ユーザID<span class=\"require-sign\"> ＊</span></label>\n            <input name=\"userId\" ng-model=\"$ctrl.deviceConfig.line_user_id\" md-maxlength=\"64\" maxlength=\"64\" ng-pattern=\"/^[\\x21-\\x7E]*$/\" required>\n            <div ng-messages=\"configForm.userId.$error\" ng-if=\"configForm.userId.$dirty\" role=\"alert\" multiple>\n              <div ng-message=\"required\">入力してください</div>\n              <div ng-message=\"md-maxlength\">64文字以内を入力してください</div>\n              <div ng-message=\"pattern\">数字、アルファベット、!#$%&'@()*+-_.,/:;<=>?^~{|}[]\\\" のみを入力してください</div>\n            </div>\n          </md-input-container>\n          <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-left: 20px\">\n            <label>モバイル パスワード<span class=\"require-sign\"> ＊</span></label>\n            <input name=\"linePassword\" ng-model=\"$ctrl.deviceConfig.line_password\" md-maxlength=\"64\" maxlength=\"64\" ng-pattern=\"/^[!\\x23-\\x5B\\x5D-\\x7E]*$/\" required>\n            <div ng-messages=\"configForm.linePassword.$error\" ng-if=\"configForm.linePassword.$dirty\" role=\"alert\" multiple>\n              <div ng-message=\"required\">入力してください</div>\n              <div ng-message=\"md-maxlength\">64文字以内を入力してください</div>\n              <div ng-message=\"pattern\">数字、アルファベット、!#$%&'@()*+-_.,/:;<=>?^~{|}[] のみを入力してください</div>\n            </div>\n          </md-input-container>\n        </div>\n        <div ng-if=\"$ctrl.deviceConfig.distribution_id.indexOf('0001-0000-0000-0013') !== -1\">\n          <h5>モバイルデバイスを選択<span class=\"require-sign\"> ＊</span></h5>\n          <md-radio-group ng-model=\"$ctrl.deviceConfig.carrier_port\" required>\n            <md-radio-button value=\"emobile0\" style=\"margin:5px 20px\">EMOBILE (D26HW)</md-radio-button>\n            <md-radio-button value=\"foma0\" style=\"margin:5px 20px\">FOMA (120FU)</md-radio-button>\n            <md-radio-button value=\"kddi0\" style=\"margin:5px 20px\">KDDI (HWD12)</md-radio-button>\n            <md-radio-button value=\"mdm0\" style=\"margin:5px 20px\">LTE (UX312NC, 510FU)</md-radio-button>\n          </md-radio-group>\n        </div>\n        <h5>APN (Access Point Name) を選択<span class=\"require-sign\"> ＊</span></h5>\n        <md-radio-group ng-model=\"$ctrl.deviceConfig.apn\" required>\n          <md-radio-button value=\"iijmobile.jp\" style=\"margin:5px 20px\">iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 下記以外の場合</span>\n          <md-radio-button value=\"k.iijmobile.jp\" style=\"margin:5px 20px\">k.iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 「IIJモバイルサービス/タイプK」または「IIJモバイルBiz+サービス/タイプK」の場合</span>\n          <md-radio-button value=\"s.iijmobile.jp\" style=\"margin:5px 20px\">s.iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 「IIJモバイルサービス/タイプD」の「パケットシェアプラン」または「パケットシェアプランL」の場合</span>\n          <md-radio-button value=\"sd.iijmobile.jp\" style=\"margin:5px 20px\">sd.iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 「IIJモバイルサービス/タイプD」の「定額プランライト」または「定額プランライト：いちねん」の場合</span>\n          <md-radio-button value=\"d.iijmobile.jp\" style=\"margin:5px 20px\">d.iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 「IIJモバイルBiz+サービス/タイプD」の場合</span>\n        </md-radio-group>\n      </md-content>\n    </div>\n\n    <h4 style=\"margin-top: 40px\">接続するリモートI/Oユニットの型番を選択</h4>\n    <div style=\"margin-bottom: 30px\">\n      <md-radio-group ng-model=\"$ctrl.deviceConfig.remoteio_name\" required>\n        <md-radio-button value=\"panasonic-uenu2d4r12\" class=\"md-primary\" style=\"margin:5px 0\">パナソニック製 UENU2D4R12</md-radio-button>\n        <md-radio-button value=\"watanabe-wmb-dio8r\" class=\"md-primary\" style=\"margin:5px 0\">渡辺電機工業製 WMB-DIO8R</md-radio-button>\n      </md-radio-group>\n    </div>\n\n    <md-button ng-click=\"$ctrl.showConfirm($ctrl.deviceConfig, $event)\" ng-disabled=\"configForm.$invalid\" class=\"md-primary md-raised\" style=\"margin: 16px 0; padding: 0 20px\">作成する</md-button>\n  </form>\n</md-content>\n"

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OemDeviceIndexController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _device_index = __webpack_require__(931);

var _device_index2 = _interopRequireDefault(_device_index);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _company = __webpack_require__(95);

var _company2 = _interopRequireDefault(_company);

var _controller_config = __webpack_require__(91);

var _controller_config2 = _interopRequireDefault(_controller_config);

var _sa_config_search = __webpack_require__(494);

var _sa_config_search2 = _interopRequireDefault(_sa_config_search);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OemDeviceIndexController = exports.OemDeviceIndexController = function () {
  /*@ngInject*/
  OemDeviceIndexController.$inject = ["$state", "SaConfigService", "$stateParams", "CompanyService", "ControllerConfigService", "SaConfigSearchService"];
  function OemDeviceIndexController($state, SaConfigService, $stateParams, CompanyService, ControllerConfigService, SaConfigSearchService) {
    _classCallCheck(this, OemDeviceIndexController);

    this.company_id = $stateParams.company_id;
    this.$state = $state;
    this.$stateParams = $stateParams;

    this.saList = [];
    this.SaConfigService = SaConfigService;
    this.CompanyService = CompanyService;
    this.ControllerConfigService = ControllerConfigService;
    this.SaConfigSearchService = SaConfigSearchService;

    this.pagination = {};

    this.searched = this.company_id === 'search';
  }

  _createClass(OemDeviceIndexController, [{
    key: '$onInit',
    value: function $onInit() {
      this.changePage(1);
    }
  }, {
    key: 'changePage',
    value: function changePage(page) {
      if (this.searched) {
        var target = this.$stateParams.target;
        var value = this.$stateParams.value;
        this.loadDeviceBySearch(target, value, page);
      } else {
        this.validateCompany();
        this.loadDeviceByCompany(page);
      }
    }
  }, {
    key: 'loadDeviceByCompany',
    value: function loadDeviceByCompany(page) {
      var _this = this;

      this.SaConfigService.oem_api.pageIndex({ company_id: this.company_id, page: page }).$promise.then(function (response) {
        _this.saList = response.sa_configs;
        _this.pagination = response.pagination;

        return _this.ControllerConfigService.oem_api.index({ company_id: _this.company_id }).$promise;
      }).then(function (response) {
        var controllerDeviceList = response;

        _this.saList.forEach(function (device) {
          device.controlTargets = controllerDeviceList.filter(function (controllerDevice) {
            return controllerDevice.reading_device_id === device.id;
          });
        });
      });
    }
  }, {
    key: 'loadDeviceBySearch',
    value: function loadDeviceBySearch(target, value, page) {
      var _this2 = this;

      this.company = { name: '検索結果' };
      this.SaConfigSearchService.oem_api.pageIndex({ target: target, value: value, page: page }, function (res) {
        _this2.saList = res.sa_configs;
        _this2.pagination = res.pagination;
      });
    }
  }, {
    key: 'validateCompany',
    value: function validateCompany() {
      var _this3 = this;

      this.CompanyService.show({ id: this.company_id }, function (response) {
        _this3.company = response;
      }, function (err) {
        if (err.status === 404 || err.status === 403) {
          _this3.$state.go('oem_main.oem_home');
        }
      });
    }
  }]);

  return OemDeviceIndexController;
}();

exports.default = _angular2.default.module('leptonApp.oemDeviceIndex', [_angularjs2.default, _sa_config2.default, _company2.default, _controller_config2.default, _sa_config_search2.default]).config(_device_index2.default).component('oemDeviceIndex', {
  template: __webpack_require__(932),
  controller: OemDeviceIndexController
}).name;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.device_index', {
    url: '/company/:company_id/device_index?target&value',
    template: '<oem-device-index></oem-device-index>'
  });
};

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports = "<device-config-search-form ng-if=\"$ctrl.searched\"></device-config-search-form>\n<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-list\"></i>&nbsp;&nbsp;端末 一覧: {{$ctrl.company.name}}</h2>\n  </div>\n</md-toolbar>\n<div ng-if=\"$ctrl.saList.length === 0 && !$ctrl.searched\" class=\"empty-notice\">設定済みの機器がありません。</div>\n<div ng-if=\"$ctrl.saList.length === 0 && $ctrl.searched\" class=\"empty-notice\">該当する機器はありませんでした。</div>\n<pagination pg-object=\"$ctrl.pagination\" action=\"$ctrl.changePage(page)\"></pagination>\n<md-content>\n  <md-list-item class=\"md-3-line\" ng-repeat=\"sa in $ctrl.saList\" style=\"flex-direction: column; padding-right: 0;\">\n    <div class=\"device-list-item-row\">\n      <config-index-item device=\"sa\" oem=\"true\"></config-index-item>\n      <md-divider></md-divider>\n    </div>\n    <md-list-item style=\"padding: 0;\" class=\"md-3-line control-device-list\" ng-repeat=\"controlDevice in sa.controlTargets\">\n      <div class=\"device-list-item-row\">\n        <md-divider></md-divider>\n        <config-index-item device=\"controlDevice\" oem=\"true\" second-indent=\"true\"></config-index-item>\n      </div>\n    </md-list-item>\n  </md-list-item>\n</md-content>\n<pagination pg-object=\"$ctrl.pagination\" action=\"$ctrl.changePage(page)\"></pagination>\n"

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OemDeviceConfigEditController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _device_config_edit = __webpack_require__(934);

var _device_config_edit2 = _interopRequireDefault(_device_config_edit);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _company = __webpack_require__(95);

var _company2 = _interopRequireDefault(_company);

var _dist_stock = __webpack_require__(87);

var _dist_stock2 = _interopRequireDefault(_dist_stock);

var _readonly_if = __webpack_require__(497);

var _readonly_if2 = _interopRequireDefault(_readonly_if);

var _zipSearch = __webpack_require__(217);

var _zipSearch2 = _interopRequireDefault(_zipSearch);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OemDeviceConfigEditController = exports.OemDeviceConfigEditController = function () {
  /*@ngInject*/
  OemDeviceConfigEditController.$inject = ["$stateParams", "SaConfigService", "CompanyService", "$state", "$scope", "$timeout", "$mdDialog", "DistStockService", "ZipSearchLogic"];
  function OemDeviceConfigEditController($stateParams, SaConfigService, CompanyService, $state, $scope, $timeout, $mdDialog, DistStockService, ZipSearchLogic) {
    var _this = this;

    _classCallCheck(this, OemDeviceConfigEditController);

    this.id = $stateParams.id;
    this.companyId = $stateParams.company_id;
    this.SaConfigService = SaConfigService;
    this.CompanyService = CompanyService;
    this.DistStockService = DistStockService;
    this.ZipSearchLogic = ZipSearchLogic;
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.dialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '変更しますか？',
        ok: '変更する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '変更しました',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };

    $scope.$watch('$ctrl.deviceConfig.zip_code', function (current) {
      if (current && !_this.deviceConfig.location) {
        _this.ZipSearchLogic.get(current).then(function (address) {
          $timeout(function () {
            _this.deviceConfig.location = address.prefecture_name + address.city_name + address.town_name;
          });
        });
      }
    });
  }

  _createClass(OemDeviceConfigEditController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.CompanyService.show({ id: this.companyId }).$promise.catch(function (err) {
        if (err.status === 404 || err.status === 403) {
          _this2.$state.go('oem_main.oem_home');
        }
      });

      this.SaConfigService.oem_api.show({ id: this.id }, function (response) {
        _this2.deviceConfig = response;
        _this2.deviceConfig.current_id = _this2.deviceConfig.distribution_id;

        var serviceType = _this2.deviceConfig.lait_service_code.match(/^ts[sw]/)[0];
        _this2.DistStockService.oem_api.index({ service_type: serviceType }, function (response) {
          var stocks = response.dist_stocks;
          stocks.unshift(_this2.deviceConfig.distribution_id);
          _this2.distStocks = stocks;
        });
      }, function (err) {
        if (err.status === 404 || err.status === 403) {
          _this2.$state.go('oem_main.oem_home');
        }
      });
    }
  }, {
    key: 'showConfirm',
    value: function showConfirm(deviceConfig, ev) {
      var _this3 = this;

      this.$mdDialog.show(this.dialog.confirm.targetEvent(ev)).then(function () {
        deviceConfig.base_unit_price = deviceConfig.base_unit_price || 0;
        deviceConfig.power_unit_price = deviceConfig.power_unit_price || 0;
        _this3.SaConfigService.oem_api.update(deviceConfig, function (okResponse) {
          _this3.$mdDialog.show(_this3.dialog.success);
        }, function (errResponse) {
          _this3.$mdDialog.show(_this3.dialog.error.content(errResponse.data.message));
        });
      });
    }
  }]);

  return OemDeviceConfigEditController;
}();

exports.default = _angular2.default.module('leptonApp.oemDeviceConfigEdit', [_angularjs2.default, _sa_config2.default, _company2.default, _dist_stock2.default, _readonly_if2.default, _zipSearch2.default]).config(_device_config_edit2.default).component('oemDeviceConfigEdit', {
  template: __webpack_require__(935),
  controller: OemDeviceConfigEditController
}).name;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.device_config_edit', {
    url: '/company/:company_id/device_config_edit/:id',
    template: '<oem-device-config-edit></oem-device-config-edit>'
  });
};

/***/ }),
/* 935 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-cog\"></i>&nbsp;&nbsp;端末設定変更: {{$ctrl.deviceConfig.pms_service_code}}</h2>\n  </div>\n</md-toolbar>\n<md-content style=\"padding: 20px 30px;\">\n  <form readonly-if=\"$root.is_viewer\" name=\"configForm\" novalidate>\n    <h4 class=\"input-group-title\">顧客情報</h4>\n    <div layout-gt-sm=\"row\">\n      <md-input-container class=\"md-block input-container\" flex-gt-sm>\n        <label>管理ID</label>\n        <input name=\"management_id\" ng-model=\"$ctrl.deviceConfig.management_id\" md-maxlength=\"16\" maxlength=\"16\">\n        <div ng-messages=\"configForm.management_id.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">16文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-block input-container\" flex-gt-sm>\n        <label>管理情報</label>\n        <input name=\"management_info\" ng-model=\"$ctrl.deviceConfig.management_info\" md-maxlength=\"64\" maxlength=\"64\">\n        <div ng-messages=\"configForm.management_info.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">64文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <h4 class=\"input-group-title\">機器情報</h4>\n    <md-input-container class=\"input-container zip-input-content\" flex-gt-sm>\n      <div>\n        <label>郵便番号 (現地の天候情報取得に使用されます)</label>\n        <input name=\"zip_code\" ng-model=\"$ctrl.deviceConfig.zip_code\" placeholder=\"000-0000\" ng-pattern=\"/^[0-9]{3}-[0-9]{4}$/\">\n        <div ng-messages=\"configForm.zip_code.$error\" role=\"alert\">\n          <div ng-message=\"pattern\">000-0000の形式で記載してください</div>\n        </div>\n      </div>\n      <div class=\"weather-zip-notice\">\n        ※ 事業所用個別郵便番号では天候情報は取得できません。地域の郵便番号を設定ください。<br>\n        ※ 天候情報が取得できなかった場合は、近隣都市の郵便番号をお試しください。\n      </div>\n    </md-input-container>\n\n    <div layout-gt-sm=\"row\">\n      <md-input-container class=\"md-block input-container\" flex-gt-sm style=\"margin-right: 20px\">\n        <label>設置場所<span class=\"require-sign\"> ＊</span></label>\n        <input name=\"location\" ng-model=\"$ctrl.deviceConfig.location\" md-maxlength=\"128\" required>\n        <div ng-messages=\"configForm.location.$error\" role=\"alert\">\n          <div ng-message=\"required\">設置場所を入力してください。</div>\n          <div ng-message=\"md-maxlength\">128文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-block input-container\" flex-gt-sm style=\"margin-right: 20px\">\n        <label>メモ</label>\n        <input name=\"memo\" ng-model=\"$ctrl.deviceConfig.memo\" md-maxlength=\"128\">\n        <div ng-messages=\"configForm.memo.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">128文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <h4 class=\"input-group-title\">デマンド監視閾値</h4>\n    <span class=\"sub-info\">※ 0 を入力するとデマンド監視が無効化されます</span>\n    <div layout-gt-sm=\"row\">\n      <div layout-gt-sm=\"row\"  flex=\"75\" offset=\"50\">\n        <md-input-container class=\"md-block input-container\" flex-gt-sm style=\"margin-right: 20px; min-width: 150px;\">\n          <label>契約電力<span class=\"require-sign\"> ＊</span></label>\n          <input type=\"number\" name=\"contract_power\" ng-model=\"$ctrl.deviceConfig.contract_power\" min=\"0\" max=\"99999\" flex=\"80\" required ng-pattern=\"/^[0-9][^\\.]*$/\">\n          <div class=\"power_unit\">&nbsp;&nbsp;kW</div>\n          <div ng-messages=\"configForm.contract_power.$error\" ng-if=\"configForm.contract_power.$dirty\" role=\"alert\" multiple>\n            <div ng-message=\"max\">99999 以下の数字を入力してください。</div>\n            <div ng-message=\"min\">0 以上の数字を入力してください。</div>\n            <div ng-message=\"number\">数値を入力してください。</div>\n            <div ng-message=\"pattern\">整数を入力してください</div>\n            <div ng-message=\"required\">0 ~ 99999 までの数字を入力してください。</div>\n          </div>\n        </md-input-container>\n\n        <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px; min-width: 150px;\">\n          <label>限界電力<span class=\"require-sign\"> ＊</span></label>\n          <input type=\"number\" name=\"limit_power\" ng-model=\"$ctrl.deviceConfig.limit_power\" min=\"0\" max=\"{{$ctrl.deviceConfig.contract_power}}\" flex=\"80\" required ng-pattern=\"/^[0-9][^\\.]*$/\">\n          <div class=\"power_unit\">&nbsp;&nbsp;kW</div>\n          <div ng-messages=\"configForm.limit_power.$error\" ng-if=\"configForm.limit_power.$dirty\" role=\"alert\" multiple>\n            <div ng-message=\"max\">契約電力量以下の数字を入力してください。</div>\n            <div ng-message=\"min\">0 以上の数字を入力してください。</div>\n            <div ng-message=\"number\">数値を入力してください。</div>\n            <div ng-message=\"pattern\">整数を入力してください</div>\n            <div ng-message=\"required\">0 ~ 契約電力量までの数字を入力してください。</div>\n          </div>\n        </md-input-container>\n\n        <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px; min-width: 150px;\">\n          <label>目標電力<span class=\"require-sign\"> ＊</span></label>\n          <input type=\"number\" name=\"target_power\" ng-model=\"$ctrl.deviceConfig.target_power\" min=\"0\" max=\"{{$ctrl.deviceConfig.limit_power}}\" flex=\"80\" required ng-pattern=\"/^[0-9][^\\.]*$/\">\n          <div class=\"power_unit\">&nbsp;&nbsp;kW</div>\n          <div ng-messages=\"configForm.target_power.$error\" ng-if=\"configForm.target_power.$dirty\" role=\"alert\" multiple>\n            <div ng-message=\"max\">限界電力量以下の数字を入力してください。</div>\n            <div ng-message=\"min\">0 以上の数字を入力してください。</div>\n            <div ng-message=\"number\">数値を入力してください。</div>\n            <div ng-message=\"pattern\">整数を入力してください</div>\n            <div ng-message=\"required\">0 ~ 限界電力量までの数字を入力してください。</div>\n          </div>\n        </md-input-container>\n      </div>\n    </div>\n\n    <h4 class=\"input-group-title\">デマンド監視無効時間</h4>\n    <div class=\"dead-duration-sub\">デマンド時限開始から\n      <duration-selector ng-model=\"$ctrl.deviceConfig.demand_dead_duration\"></duration-selector>\n      分間 デマンド監視を無効化します。\n    </div>\n\n    <h4 class=\"input-group-title\">デマンド警報解除条件</h4>\n    <div style=\"margin-bottom: 30px\">\n      <md-radio-group ng-model=\"$ctrl.deviceConfig.demand_level_down_count\" required>\n        <md-radio-button value=3 class=\"md-primary\" style=\"margin:5px 0\">標準判定</md-radio-button>\n        <span style=\"font-size: 12px; margin-left: 30px;\">※ 予測値が閾値の90％を下回った状態が3分間継続した時点で警報を解除します。</span>\n        <md-radio-button value=1 class=\"md-primary\" style=\"margin:5px 0\">即時解除</md-radio-button>\n        <span style=\"font-size: 12px; margin-left: 30px;\">※ 予測値が閾値の90％を1度下回った時点で警報を解除します。本設定により警報・警報解除が頻発する場合がありますのでご注意ください。</span>\n      </md-radio-group>\n    </div>\n\n    <h4 class=\"input-group-title\">電気料金単価</h4>\n    <div layout-gt-sm=\"row\" flex=\"75\">\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px; min-width: 150px;\">\n        <label>基本料金単価</label>\n        <input type=\"number\" name=\"base_unit_price\" ng-model=\"$ctrl.deviceConfig.base_unit_price\" min=\"0\" max=\"9999.99\" flex=\"80\" step=\"0.01\" ng-pattern=\"/^[0-9]+\\.?[0-9]{0,2}$/\">\n        <div class=\"power_unit\">&nbsp;&nbsp;円 /1 kW</div>\n        <div ng-messages=\"configForm.base_unit_price.$error\" ng-if=\"configForm.base_unit_price.$dirty\" role=\"alert\" multiple>\n          <div ng-message=\"max\">9999.99 以下の数字を入力してください。</div>\n          <div ng-message=\"min\">0 以上の数字を入力してください。</div>\n          <div ng-message=\"pattern\">小数２桁までの数値を入力してください</div>\n          <div ng-message=\"number\">数値を入力してください。</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px; min-width: 150px;\">\n        <label>電力量単価</label>\n        <input type=\"number\" name=\"power_unit_price\" ng-model=\"$ctrl.deviceConfig.power_unit_price\" min=\"0\" max=\"9999.99\" flex=\"80\" step=\"0.01\" ng-pattern=\"/^[0-9]+\\.?[0-9]{0,2}$/\">\n        <div class=\"power_unit\">&nbsp;&nbsp;円 /1 kWh</div>\n        <div ng-messages=\"configForm.power_unit_price.$error\" ng-if=\"configForm.power_unit_price.$dirty\" role=\"alert\" multiple>\n          <div ng-message=\"max\">9999.99 以下の数字を入力してください。</div>\n          <div ng-message=\"min\">0 以上の数字を入力してください。</div>\n          <div ng-message=\"pattern\">小数２桁までの数値を入力してください</div>\n          <div ng-message=\"number\">数値を入力してください。</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <h4 class=\"input-group-title\">機器 ID<span class=\"require-sign\"> ＊</span></h4>\n    <div>\n      <md-input-container>\n        <label>一覧から選択</label>\n        <md-select id=\"distIdSelect\" class=\"ng-animate-disabled\" name=\"distribution_id\" ng-model=\"$ctrl.deviceConfig.distribution_id\" required>\n          <md-option class=\"ng-animate-disabled\" ng-repeat=\"distId in $ctrl.distStocks\" value=\"{{distId}}\">{{distId}}</md-option>\n        </md-select>\n      </md-input-container>\n      <small class=\"change_flg\" name=\"current_id\" ng-if=\"$ctrl.deviceConfig.current_id !== $ctrl.deviceConfig.distribution_id\">\n        変更あり\n      </small>\n    </div>\n\n    <h4>クラウドへの接続方法を選択<span class=\"require-sign\"> ＊</span></h4>\n    <div style=\"margin-bottom: 10px\">\n      <md-radio-group ng-model=\"$ctrl.deviceConfig.mode\" required>\n        <md-radio-button value=\"reading_only\" class=\"md-primary\" style=\"margin:5px 0\">有線接続 ( DHCP )</md-radio-button>\n        <md-radio-button value=\"mobile\" class=\"md-primary\" style=\"margin:5px 0\">モバイル接続</md-radio-button>\n      </md-radio-group>\n    </div>\n\n    <div ng-if=\"$ctrl.deviceConfig.mode==='mobile'\" class=\"animate-if\">\n      <md-content style=\"padding: 0 16px\">\n        <h5>モバイルの認証情報</h5>\n        <div layout-gt-sm=\"row\">\n          <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-left: 20px\">\n            <label>モバイル ユーザID<span class=\"require-sign\"> ＊</span></label>\n            <input name=\"userId\" ng-model=\"$ctrl.deviceConfig.line_user_id\" md-maxlength=\"64\" ng-pattern=\"/^[\\x21-\\x7E]*$/\" required>\n            <div ng-messages=\"configForm.userId.$error\" ng-if=\"configForm.userId.$dirty\" role=\"alert\" multiple>\n              <div ng-message=\"required\">入力してください</div>\n              <div ng-message=\"md-maxlength\">64文字以内を入力してください</div>\n              <div ng-message=\"pattern\">数字、アルファベット、#$%&'@()*+-_.,/:;<=>?^~{|}[]\\\" のみを入力してください</div>\n            </div>\n          </md-input-container>\n          <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-left: 20px\">\n            <label>モバイル パスワード<span class=\"require-sign\"> ＊</span></label>\n            <input name=\"linePassword\" ng-model=\"$ctrl.deviceConfig.line_password\" md-maxlength=\"64\" ng-pattern=\"/^[!\\x23-\\x5B\\x5D-\\x7E]*$/\" required>\n            <div ng-messages=\"configForm.linePassword.$error\" ng-if=\"configForm.linePassword.$dirty\" role=\"alert\" multiple>\n              <div ng-message=\"required\">入力してください</div>\n              <div ng-message=\"md-maxlength\">64文字以内を入力してください</div>\n              <div ng-message=\"pattern\">数字、アルファベット、!#$%&'@()*+-_.,/:;<=>?^~{|}[] のみを入力してください</div>\n            </div>\n          </md-input-container>\n        </div>\n        <div ng-if=\"$ctrl.deviceConfig.distribution_id.indexOf('0001-0000-0000-0013') !== -1\">\n          <h5>モバイルデバイスを選択<span class=\"require-sign\"> ＊</span></h5>\n          <md-radio-group ng-model=\"$ctrl.deviceConfig.carrier_port\" required>\n            <md-radio-button value=\"emobile0\" style=\"margin:5px 20px\">EMOBILE (D26HW)</md-radio-button>\n            <md-radio-button value=\"foma0\" style=\"margin:5px 20px\">FOMA (120FU)</md-radio-button>\n            <md-radio-button value=\"kddi0\" style=\"margin:5px 20px\">KDDI (HWD12)</md-radio-button>\n            <md-radio-button value=\"mdm0\" style=\"margin:5px 20px\">LTE (UX312NC, 510FU)</md-radio-button>\n          </md-radio-group>\n        </div>\n        <h5>APN (Access Point Name) を選択<span class=\"require-sign\"> ＊</span></h5>\n        <md-radio-group ng-model=\"$ctrl.deviceConfig.apn\" required>\n          <md-radio-button value=\"iijmobile.jp\" style=\"margin:5px 20px\">iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 下記以外の場合</span>\n          <md-radio-button value=\"k.iijmobile.jp\" style=\"margin:5px 20px\">k.iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 「IIJモバイルサービス/タイプK」または「IIJモバイルBiz+サービス/タイプK」の場合</span>\n          <md-radio-button value=\"s.iijmobile.jp\" style=\"margin:5px 20px\">s.iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 「IIJモバイルサービス/タイプD」の「パケットシェアプラン」または「パケットシェアプランL」の場合</span>\n          <md-radio-button value=\"sd.iijmobile.jp\" style=\"margin:5px 20px\">sd.iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 「IIJモバイルサービス/タイプD」の「定額プランライト」または「定額プランライト：いちねん」の場合</span>\n          <md-radio-button value=\"d.iijmobile.jp\" style=\"margin:5px 20px\">d.iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 「IIJモバイルBiz+サービス/タイプD」の場合</span>\n        </md-radio-group>\n      </md-content>\n    </div>\n\n    <h4 style=\"margin-top: 40px\">接続するリモートI/Oユニットの型番を選択</h4>\n    <div style=\"margin-bottom: 30px\">\n      <md-radio-group ng-model=\"$ctrl.deviceConfig.remoteio_name\" required>\n        <md-radio-button value=\"panasonic-uenu2d4r12\" class=\"md-primary\" style=\"margin:5px 0\">パナソニック製 UENU2D4R12</md-radio-button>\n        <md-radio-button value=\"watanabe-wmb-dio8r\" class=\"md-primary\" style=\"margin:5px 0\">渡辺電機工業製 WMB-DIO8R</md-radio-button>\n      </md-radio-group>\n    </div>\n \n    <md-button ng-click=\"$ctrl.showConfirm($ctrl.deviceConfig, $event)\" ng-disabled=\"configForm.$invalid\" class=\"md-primary md-raised\" ng-if=\"$root.is_admin || $root.is_operator\" style=\"margin: 16px 0; padding: 0 20px\">\n        変更する\n    </md-button>\n  </form>\n</md-content>\n"

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceTypeSelectController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _device_type_select = __webpack_require__(937);

var _device_type_select2 = _interopRequireDefault(_device_type_select);

var _company = __webpack_require__(95);

var _company2 = _interopRequireDefault(_company);

var _dist_stock = __webpack_require__(87);

var _dist_stock2 = _interopRequireDefault(_dist_stock);

var _service_stock = __webpack_require__(134);

var _service_stock2 = _interopRequireDefault(_service_stock);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DeviceTypeSelectController = exports.DeviceTypeSelectController = function () {
  /*@ngInject*/
  DeviceTypeSelectController.$inject = ["$state", "$stateParams", "CompanyService", "DistStockService", "ServiceStockService"];
  function DeviceTypeSelectController($state, $stateParams, CompanyService, DistStockService, ServiceStockService) {
    _classCallCheck(this, DeviceTypeSelectController);

    this.company_id = $stateParams.company_id;
    this.$state = $state;
    this.CompanyService = CompanyService;
    this.DistStockService = DistStockService;
    this.ServiceStockService = ServiceStockService;
  }

  _createClass(DeviceTypeSelectController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.CompanyService.show({ id: this.company_id }, function (response) {
        _this.company = response;
      }, function (err) {
        if (err.status === 404 || err.status === 403) {
          _this.$state.go('oem_main.oem_home');
        }
      });

      this.DistStockService.oem_api.count(function (response) {
        _this.tssCount = response.tss;
        _this.tswCount = response.tsw;
        _this.deviceCount = response.tss + response.tsw;
      });

      this.ServiceStockService.oem_api.count(function (response) {
        _this.dssCount = response.dss;
        _this.dscCount = response.dsc;
      });
    }
  }]);

  return DeviceTypeSelectController;
}();

exports.default = _angular2.default.module('leptonApp.deviceTypeSelect', [_angularjs2.default, _company2.default, _dist_stock2.default, _service_stock2.default]).config(_device_type_select2.default).component('deviceTypeSelect', {
  template: __webpack_require__(938),
  controller: DeviceTypeSelectController
}).name;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.device_type_select', {
    url: '/company/:company_id/type_select',
    template: '<device-type-select></device-type-select>'
  });
};

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-file-o\"></i>&nbsp;&nbsp;端末新規作成: {{$ctrl.company.name}}</h2>\n  </div>\n</md-toolbar>\n\n<md-content style=\"padding: 5px 30px\">\n  <h3 style=\"margin: 30px 0 25px;\">作成する端末の種類を選択</h3>\n  <div class=\"type-select-content\">\n    <md-button ng-disabled=\"$ctrl.dssCount === 0 || $ctrl.deviceCount === 0\"\n      class=\"md-primary md-raised\"\n      ui-sref=\"oem_main.device_config_create({company_id: {{$ctrl.company_id}} })\">\n        <i class=\"fa fa-tachometer-alt fa-fw\" aria-hidden=\"true\"></i>&nbsp;検針用\n      </md-button>\n\n    <div>用途：電力データの検針・デマンド監視</div>\n    <div>残り契約数：{{$ctrl.dssCount}} 件</div>\n    <div>機器在庫数：{{$ctrl.deviceCount}} 台</div>\n  </div>\n\n  <div class=\"type-select-content\">\n    <md-button ng-disabled=\"$ctrl.dscCount === 0 || $ctrl.tssCount === 0\"\n      class=\"md-primary md-raised\"\n      ui-sref=\"oem_main.controller_device_create({company_id: {{$ctrl.company_id}} })\">\n        <i class=\"fa fa-sliders-h fa-fw\" aria-hidden=\"true\"></i>&nbsp;制御用\n      </md-button>\n\n    <div>用途：デマンド警報時の機器制御（電力データの検針はできません）</div>\n    <div>残り契約数：{{$ctrl.dscCount}} 件</div>\n    <div>機器在庫数：{{$ctrl.tssCount}} 台</div>\n  </div>\n</md-content>\n"

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _controller_create = __webpack_require__(940);

var _controller_create2 = _interopRequireDefault(_controller_create);

var _company = __webpack_require__(95);

var _company2 = _interopRequireDefault(_company);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _dist_stock = __webpack_require__(87);

var _dist_stock2 = _interopRequireDefault(_dist_stock);

var _controller_config = __webpack_require__(91);

var _controller_config2 = _interopRequireDefault(_controller_config);

var _zipSearch = __webpack_require__(217);

var _zipSearch2 = _interopRequireDefault(_zipSearch);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var ControllerDeviceCreateController = function () {
  /*@ngInject*/
  ControllerDeviceCreateController.$inject = ["$state", "$stateParams", "$scope", "$timeout", "$mdDialog", "CompanyService", "SaConfigService", "DistStockService", "ControllerConfigService", "ZipSearchLogic"];
  function ControllerDeviceCreateController($state, $stateParams, $scope, $timeout, $mdDialog, CompanyService, SaConfigService, DistStockService, ControllerConfigService, ZipSearchLogic) {
    var _this = this;

    _classCallCheck(this, ControllerDeviceCreateController);

    this.CompanyService = CompanyService;
    this.ControllerConfigService = ControllerConfigService;
    this.DistStockService = DistStockService;
    this.SaConfigService = SaConfigService;
    this.ZipSearchLogic = ZipSearchLogic;
    this.company_id = $stateParams.company_id;
    this.$state = $state;
    this.$mdDialog = $mdDialog;

    this.deviceConfig = {
      mode: 'reading_only',
      wlan_enabled: false,
      company_id: $stateParams.company_id,
      carrier_port: 'mdm0',
      remoteio_name: 'panasonic-uenu2d4r12'
    };

    this.dialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '作成しますか?',
        ok: '作成する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '作成しました',
        content: '端末一覧 画面に移動します',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、サポートにお問い合わせください。',
        ok: 'OK'
      })
    };

    $scope.$watch('$ctrl.deviceConfig.zip_code', function (current) {
      if (current) {
        _this.ZipSearchLogic.get(current).then(function (address) {
          $timeout(function () {
            _this.deviceConfig.location = address.prefecture_name + address.city_name + address.town_name;
          });
        });
      }
    });
  }

  _createClass(ControllerDeviceCreateController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.SaConfigService.oem_api.index({ company_id: this.company_id }, function (response) {
        _this2.readingDevices = response;
      });
      this.CompanyService.show({ id: this.company_id }, function (response) {
        _this2.company = response;
      }, function (err) {
        if (err.status === 404 || err.status === 403) {
          _this2.$state.go('oem_main.oem_home');
        }
      });
      this.DistStockService.oem_api.index({ service_type: 'tss' }, function (response) {
        _this2.deviceStocks = response.dist_stocks;
      });
    }
  }, {
    key: 'showConfirm',
    value: function showConfirm(deviceConfig, ev) {
      var _this3 = this;

      this.$mdDialog.show(this.dialog.confirm.targetEvent(ev)).then(function () {
        _this3.ControllerConfigService.oem_api.create(deviceConfig, function (okResponse) {
          _this3.$mdDialog.show(_this3.dialog.success).finally(function () {
            return _this3.$state.go('oem_main.device_index', { company_id: _this3.company_id });
          });
        }, function (errResponse) {
          _this3.$mdDialog.show(_this3.dialog.error.content(errResponse.data.message));
        });
      });
    }
  }]);

  return ControllerDeviceCreateController;
}();

exports.default = _angular2.default.module('leptonApp.controllerDeviceCreate', [_angularjs2.default, _company2.default, _sa_config2.default, _dist_stock2.default, _controller_config2.default, _zipSearch2.default]).config(_controller_create2.default).component('controllerDeviceCreate', {
  template: __webpack_require__(941),
  controller: ControllerDeviceCreateController
}).name;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.controller_device_create', {
    url: '/company/:company_id/controller_create',
    template: '<controller-device-create></controller-device-create>'
  });
};

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-file\"></i>&nbsp;&nbsp;端末新規作成: {{$ctrl.company.name}}</h2>\n  </div>\n</md-toolbar>\n<md-content style=\"padding: 20px 30px;\">\n  <form name=\"configForm\" novalidate>\n    <h4 class=\"input-group-title\">顧客情報</h4>\n    <div layout-gt-sm=\"row\">\n      <md-input-container class=\"md-block input-container\" flex-gt-sm>\n        <label>管理ID</label>\n        <input name=\"management_id\" ng-model=\"$ctrl.deviceConfig.management_id\" md-maxlength=\"16\" maxlength=\"16\">\n        <div ng-messages=\"configForm.management_id.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">16文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-block input-container\" flex-gt-sm>\n        <label>管理情報</label>\n        <input name=\"management_info\" ng-model=\"$ctrl.deviceConfig.management_info\" md-maxlength=\"64\" maxlength=\"64\">\n        <div ng-messages=\"configForm.management_info.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">64文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <h4 class=\"input-group-title\">機器情報</h4>\n    <md-input-container class=\"input-container zip-input-content\" flex-gt-sm>\n      <div>\n        <label>郵便番号</label>\n        <input name=\"zip_code\" ng-model=\"$ctrl.deviceConfig.zip_code\" placeholder=\"000-0000\" ng-pattern=\"/^[0-9]{3}-[0-9]{4}$/\">\n        <div ng-messages=\"configForm.zip_code.$error\" role=\"alert\">\n          <div ng-message=\"pattern\">000-0000の形式で記載してください</div>\n        </div>\n      </div>\n    </md-input-container>\n    <div layout-gt-sm=\"row\">\n      <md-input-container class=\"md-block input-container\" flex-gt-sm style=\"width: 70%;\">\n        <label>設置場所<span class=\"require-sign\"> ＊</span></label>\n        <input name=\"location\" ng-model=\"$ctrl.deviceConfig.location\" md-maxlength=\"128\" required maxlength=\"128\">\n        <div ng-messages=\"configForm.location.$error\" role=\"alert\">\n          <div ng-message=\"required\">設置場所を入力してください。</div>\n          <div ng-message=\"md-maxlength\">128文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-block input-container\" flex-gt-sm style=\"width: 70%;\">\n        <label>メモ</label>\n        <input name=\"memo\" ng-model=\"$ctrl.deviceConfig.memo\" md-maxlength=\"128\" maxlength=\"128\">\n        <div ng-messages=\"configForm.memo.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">128文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <h4 class=\"input-group-title\">連携先 検針用端末<span class=\"require-sign\"> ＊</span></h4>\n    <div>\n      <md-input-container style=\"max-width: 70%\">\n        <label>一覧から選択</label>\n        <md-select id=\"readingDeviceSelect\" class=\"ng-animate-disabled\" name=\"reading_device_id\" ng-model=\"$ctrl.deviceConfig.reading_device_id\" required>\n          <md-option class=\"ng-animate-disabled\" ng-repeat=\"readingDevice in $ctrl.readingDevices\" value=\"{{readingDevice.id}}\">\n            <div class=\"reading-device-info\">\n              <div class=\"reading-device-major-info\">\n                <span class=\"reading-device-code\">{{readingDevice.pms_service_code}}</span>  <span style=\"font-size: 15px;\">{{readingDevice.distribution_id}}</span>\n              </div>\n              <div class=\"reading-device-minor-info\">\n                {{readingDevice.location}}\n              </div>\n            </div>\n          </md-option>\n        </md-select>\n      </md-input-container>\n    </div>\n\n    <h4 class=\"input-group-title\">機器 ID<span class=\"require-sign\"> ＊</span></h4>\n    <div>\n      <md-input-container>\n        <label>一覧から選択</label>\n        <md-select id=\"distIdSelect\" class=\"ng-animate-disabled\" name=\"distribution_id\" ng-model=\"$ctrl.deviceConfig.distribution_id\" required>\n          <md-option class=\"ng-animate-disabled\" ng-repeat=\"distId in $ctrl.deviceStocks\" value=\"{{distId}}\"><div style=\"margin-right: 20px;\">{{distId}}</div></md-option>\n        </md-select>\n      </md-input-container>\n    </div>\n\n    <h4>クラウドへの接続方法を選択<span class=\"require-sign\"> ＊</span></h4>\n    <div style=\"margin-bottom: 10px\">\n      <md-radio-group ng-model=\"$ctrl.deviceConfig.mode\" required>\n        <md-radio-button value=\"reading_only\" class=\"md-primary\" style=\"margin:5px 0\">有線接続 ( DHCP )</md-radio-button>\n        <md-radio-button value=\"mobile\" class=\"md-primary\" style=\"margin:5px 0\">モバイル接続</md-radio-button>\n      </md-radio-group>\n    </div>\n\n    <div ng-if=\"$ctrl.deviceConfig.mode==='mobile'\" class=\"animate-if\">\n      <md-content style=\"padding: 0 16px\">\n        <h5>モバイルの認証情報</h5>\n        <div layout-gt-sm=\"row\">\n          <md-input-container class=\"md-block input-container\" flex-gt-sm style=\"margin-left: 20px\">\n            <label>モバイル ユーザID<span class=\"require-sign\"> ＊</span></label>\n            <input name=\"userId\" ng-model=\"$ctrl.deviceConfig.line_user_id\" md-maxlength=\"64\" maxlength=\"64\" ng-pattern=\"/^[\\x21-\\x7E]*$/\" required>\n            <div ng-messages=\"configForm.userId.$error\" ng-if=\"configForm.userId.$dirty\" role=\"alert\" multiple>\n              <div ng-message=\"required\">入力してください</div>\n              <div ng-message=\"md-maxlength\">64文字以内を入力してください</div>\n              <div ng-message=\"pattern\">数字、アルファベット、!#$%&'@()*+-_.,/:;<=>?^~{|}[]\\\" のみを入力してください</div>\n            </div>\n          </md-input-container>\n          <md-input-container class=\"md-block input-container\" flex-gt-sm style=\"margin-left: 20px\">\n            <label>モバイル パスワード<span class=\"require-sign\"> ＊</span></label>\n            <input name=\"linePassword\" ng-model=\"$ctrl.deviceConfig.line_password\" md-maxlength=\"64\" maxlength=\"64\" ng-pattern=\"/^[!\\x23-\\x5B\\x5D-\\x7E]*$/\" required>\n            <div ng-messages=\"configForm.linePassword.$error\" ng-if=\"configForm.linePassword.$dirty\" role=\"alert\" multiple>\n              <div ng-message=\"required\">入力してください</div>\n              <div ng-message=\"md-maxlength\">64文字以内を入力してください</div>\n              <div ng-message=\"pattern\">数字、アルファベット、!#$%&'@()*+-_.,/:;<=>?^~{|}[] のみを入力してください</div>\n            </div>\n          </md-input-container>\n        </div>\n        <h5>APN (Access Point Name) を選択<span class=\"require-sign\"> ＊</span></h5>\n        <md-radio-group ng-model=\"$ctrl.deviceConfig.apn\" required>\n          <md-radio-button value=\"iijmobile.jp\" style=\"margin:5px 20px\">iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 下記以外の場合</span>\n          <md-radio-button value=\"k.iijmobile.jp\" style=\"margin:5px 20px\">k.iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 「IIJモバイルサービス/タイプK」または「IIJモバイルBiz+サービス/タイプK」の場合</span>\n          <md-radio-button value=\"s.iijmobile.jp\" style=\"margin:5px 20px\">s.iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 「IIJモバイルサービス/タイプD」の「パケットシェアプラン」または「パケットシェアプランL」の場合</span>\n          <md-radio-button value=\"sd.iijmobile.jp\" style=\"margin:5px 20px\">sd.iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 「IIJモバイルサービス/タイプD」の「定額プランライト」または「定額プランライト：いちねん」の場合</span>\n          <md-radio-button value=\"d.iijmobile.jp\" style=\"margin:5px 20px\">d.iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 「IIJモバイルBiz+サービス/タイプD」の場合</span>\n        </md-radio-group>\n      </md-content>\n    </div>\n\n    <h4 style=\"margin-top: 40px\">接続するリモートI/Oユニットの型番を選択</h4>\n    <div style=\"margin-bottom: 30px\">\n      <md-radio-group ng-model=\"$ctrl.deviceConfig.remoteio_name\" required>\n        <md-radio-button value=\"panasonic-uenu2d4r12\" class=\"md-primary\" style=\"margin:5px 0\">パナソニック製 UENU2D4R12</md-radio-button>\n        <md-radio-button value=\"watanabe-wmb-dio8r\" class=\"md-primary\" style=\"margin:5px 0\">渡辺電機工業製 WMB-DIO8R</md-radio-button>\n      </md-radio-group>\n    </div>\n\n    <md-button ng-click=\"$ctrl.showConfirm($ctrl.deviceConfig, $event)\" ng-disabled=\"configForm.$invalid\" class=\"md-primary md-raised\" style=\"margin: 16px 0; padding: 0 20px\">作成する</md-button>\n  </form>\n</md-content>\n"

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _controller_edit = __webpack_require__(943);

var _controller_edit2 = _interopRequireDefault(_controller_edit);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _dist_stock = __webpack_require__(87);

var _dist_stock2 = _interopRequireDefault(_dist_stock);

var _controller_config = __webpack_require__(91);

var _controller_config2 = _interopRequireDefault(_controller_config);

var _zipSearch = __webpack_require__(217);

var _zipSearch2 = _interopRequireDefault(_zipSearch);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OemControllerDeviceEditController = function () {
  /*@ngInject*/
  OemControllerDeviceEditController.$inject = ["$state", "$stateParams", "$scope", "$timeout", "$mdDialog", "SaConfigService", "DistStockService", "ControllerConfigService", "ZipSearchLogic"];
  function OemControllerDeviceEditController($state, $stateParams, $scope, $timeout, $mdDialog, SaConfigService, DistStockService, ControllerConfigService, ZipSearchLogic) {
    var _this = this;

    _classCallCheck(this, OemControllerDeviceEditController);

    this.ControllerConfigService = ControllerConfigService;
    this.DistStockService = DistStockService;
    this.SaConfigService = SaConfigService;
    this.ZipSearchLogic = ZipSearchLogic;
    this.id = $stateParams.id;
    this.company_id = $stateParams.company_id;
    this.$state = $state;
    this.$mdDialog = $mdDialog;

    this.dialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '変更しますか？',
        ok: '変更する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '変更しました',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };

    $scope.$watch('$ctrl.deviceConfig.zip_code', function (current) {
      if (current && !_this.deviceConfig.location) {
        _this.ZipSearchLogic.get(current).then(function (address) {
          $timeout(function () {
            _this.deviceConfig.location = address.prefecture_name + address.city_name + address.town_name;
          });
        });
      }
    });
  }

  _createClass(OemControllerDeviceEditController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.ControllerConfigService.oem_api.show({ id: this.id }).$promise.then(function (response) {
        _this2.deviceConfig = response;
        _this2.currentDistId = _this2.deviceConfig.distribution_id;
        _this2.currentReadingId = _this2.deviceConfig.reading_device_id = _this2.deviceConfig.reading_device_id + '';

        return _this2.DistStockService.oem_api.index({ service_type: 'tss' }).$promise;
      }).catch(function (err) {
        if (err.status === 404 || err.status === 403) {
          _this2.$state.go('oem_main.oem_home');
        }
        return Promise.reject();
      }).then(function (response) {
        var stocks = response.dist_stocks;
        stocks.unshift(_this2.deviceConfig.distribution_id);
        _this2.deviceStocks = stocks;
      });

      this.SaConfigService.oem_api.index({ company_id: this.company_id }, function (response) {
        _this2.readingDevices = response;
      }, function (err) {
        if (err.status === 404 || err.status === 403) {
          _this2.$state.go('oem_main.oem_home');
        }
      });
    }
  }, {
    key: 'showConfirm',
    value: function showConfirm(deviceConfig, ev) {
      var _this3 = this;

      this.$mdDialog.show(this.dialog.confirm.targetEvent(ev)).then(function () {
        _this3.ControllerConfigService.oem_api.update(deviceConfig, function (okResponse) {
          _this3.$mdDialog.show(_this3.dialog.success);
        }, function (errResponse) {
          _this3.$mdDialog.show(_this3.dialog.error.content(errResponse.data.message));
        });
      });
    }
  }]);

  return OemControllerDeviceEditController;
}();

exports.default = _angular2.default.module('leptonApp.oemControllerDeviceEdit', [_angularjs2.default, _sa_config2.default, _dist_stock2.default, _controller_config2.default, _zipSearch2.default]).config(_controller_edit2.default).component('oemControllerDeviceEdit', {
  template: __webpack_require__(944),
  controller: OemControllerDeviceEditController
}).name;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.controller_device_edit', {
    url: '/company/:company_id/controller_edit/:id',
    template: '<oem-controller-device-edit></oem-controller-device-edit>'
  });
};

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-cog\"></i>&nbsp;&nbsp;端末設定変更: {{$ctrl.deviceConfig.pms_service_code}}</h2>\n  </div>\n</md-toolbar>\n<md-content style=\"padding: 20px 30px;\">\n  <form name=\"configForm\" novalidate>\n    <h4 class=\"input-group-title\">顧客情報</h4>\n    <div layout-gt-sm=\"row\">\n      <md-input-container class=\"md-block input-container\" flex-gt-sm>\n        <label>管理ID</label>\n        <input name=\"management_id\" ng-model=\"$ctrl.deviceConfig.management_id\" md-maxlength=\"16\" maxlength=\"16\">\n        <div ng-messages=\"configForm.management_id.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">16文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-block input-container\" flex-gt-sm>\n        <label>管理情報</label>\n        <input name=\"management_info\" ng-model=\"$ctrl.deviceConfig.management_info\" md-maxlength=\"64\" maxlength=\"64\">\n        <div ng-messages=\"configForm.management_info.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">64文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <h4 class=\"input-group-title\">機器情報</h4>\n    <md-input-container class=\"input-container zip-input-content\" flex-gt-sm>\n      <div>\n        <label>郵便番号</label>\n        <input name=\"zip_code\" ng-model=\"$ctrl.deviceConfig.zip_code\" placeholder=\"000-0000\" ng-pattern=\"/^[0-9]{3}-[0-9]{4}$/\">\n        <div ng-messages=\"configForm.zip_code.$error\" role=\"alert\">\n          <div ng-message=\"pattern\">000-0000の形式で記載してください</div>\n        </div>\n      </div>\n    </md-input-container>\n    <div layout-gt-sm=\"row\">\n      <md-input-container class=\"md-block input-container\" flex-gt-sm style=\"margin-right: 20px\">\n        <label>設置場所<span class=\"require-sign\"> ＊</span></label>\n        <input name=\"location\" ng-model=\"$ctrl.deviceConfig.location\" md-maxlength=\"128\" required>\n        <div ng-messages=\"configForm.location.$error\" role=\"alert\">\n          <div ng-message=\"required\">設置場所を入力してください。</div>\n          <div ng-message=\"md-maxlength\">128文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-block input-container\" flex-gt-sm style=\"margin-right: 20px\">\n        <label>メモ</label>\n        <input name=\"memo\" ng-model=\"$ctrl.deviceConfig.memo\" md-maxlength=\"128\">\n        <div ng-messages=\"configForm.memo.$error\" role=\"alert\">\n          <div ng-message=\"md-maxlength\">128文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <h4 class=\"input-group-title\">連携先 検針用端末<span class=\"require-sign\"> ＊</span></h4>\n    <div>\n      <md-input-container style=\"max-width: 70%\">\n        <label>一覧から選択</label>\n        <md-select id=\"readingDeviceSelect\" class=\"ng-animate-disabled\" name=\"reading_device_id\" ng-model=\"$ctrl.deviceConfig.reading_device_id\" required>\n          <md-option class=\"ng-animate-disabled\" ng-repeat=\"readingDevice in $ctrl.readingDevices\" value=\"{{readingDevice.id}}\">\n            <div class=\"reading-device-info\">\n              <div class=\"reading-device-major-info\">\n                <span class=\"reading-device-code\">{{readingDevice.pms_service_code}}</span>  <span style=\"font-size: 15px;\">{{readingDevice.distribution_id}}</span>\n              </div>\n              <div class=\"reading-device-minor-info\">\n                {{readingDevice.location}}\n              </div>\n            </div>\n          </md-option>\n        </md-select>\n      </md-input-container>\n      <small class=\"change_flg\" ng-if=\"$ctrl.currentReadingId !== $ctrl.deviceConfig.reading_device_id\">\n        変更あり\n      </small>\n    </div>\n\n    <h4 class=\"input-group-title\">機器 ID<span class=\"require-sign\"> ＊</span></h4>\n    <div>\n      <md-input-container>\n        <label>一覧から選択</label>\n        <md-select id=\"distIdSelect\" class=\"ng-animate-disabled\" name=\"distribution_id\" ng-model=\"$ctrl.deviceConfig.distribution_id\" required>\n          <md-option class=\"ng-animate-disabled\" ng-repeat=\"distId in $ctrl.deviceStocks\" value=\"{{distId}}\">{{distId}}</md-option>\n        </md-select>\n      </md-input-container>\n      <small class=\"change_flg\" ng-if=\"$ctrl.currentDistId !== $ctrl.deviceConfig.distribution_id\">\n        変更あり\n      </small>\n    </div>\n\n    <h4>クラウドへの接続方法を選択<span class=\"require-sign\"> ＊</span></h4>\n    <div style=\"margin-bottom: 10px\">\n      <md-radio-group ng-model=\"$ctrl.deviceConfig.mode\" required>\n        <md-radio-button value=\"reading_only\" class=\"md-primary\" style=\"margin:5px 0\">有線接続 ( DHCP )</md-radio-button>\n        <md-radio-button value=\"mobile\" class=\"md-primary\" style=\"margin:5px 0\">モバイル接続</md-radio-button>\n      </md-radio-group>\n    </div>\n\n    <div ng-if=\"$ctrl.deviceConfig.mode==='mobile'\" class=\"animate-if\">\n      <md-content style=\"padding: 0 16px\">\n        <h5>モバイルの認証情報<span class=\"require-sign\"> ＊</span></h5>\n        <div layout-gt-sm=\"row\">\n          <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-left: 20px\">\n            <label>モバイル ユーザID</label>\n            <input name=\"userId\" ng-model=\"$ctrl.deviceConfig.line_user_id\" md-maxlength=\"64\" ng-pattern=\"/^[\\x21-\\x7E]*$/\" required>\n            <div ng-messages=\"configForm.userId.$error\" ng-if=\"configForm.userId.$dirty\" role=\"alert\" multiple>\n              <div ng-message=\"required\">入力してください</div>\n              <div ng-message=\"md-maxlength\">64文字以内を入力してください</div>\n              <div ng-message=\"pattern\">数字、アルファベット、!#$%&'@()*+-_.,/:;<=>?^~{|}[]\\\" のみを入力してください</div>\n            </div>\n          </md-input-container>\n          <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-left: 20px\">\n            <label>モバイル パスワード<span class=\"require-sign\"> ＊</span></label>\n            <input name=\"linePassword\" ng-model=\"$ctrl.deviceConfig.line_password\" md-maxlength=\"64\" ng-pattern=\"/^[!\\x23-\\x5B\\x5D-\\x7E]*$/\" required>\n            <div ng-messages=\"configForm.linePassword.$error\" ng-if=\"configForm.linePassword.$dirty\" role=\"alert\" multiple>\n              <div ng-message=\"required\">入力してください</div>\n              <div ng-message=\"md-maxlength\">64文字以内を入力してください</div>\n              <div ng-message=\"pattern\">数字、アルファベット、!#$%&'@()*+-_.,/:;<=>?^~{|}[] のみを入力してください</div>\n            </div>\n          </md-input-container>\n        </div>\n        <h5>APN (Access Point Name) を選択<span class=\"require-sign\"> ＊</span></h5>\n        <md-radio-group ng-model=\"$ctrl.deviceConfig.apn\" required>\n          <md-radio-button value=\"iijmobile.jp\" style=\"margin:5px 20px\">iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 下記以外の場合</span>\n          <md-radio-button value=\"k.iijmobile.jp\" style=\"margin:5px 20px\">k.iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 「IIJモバイルサービス/タイプK」または「IIJモバイルBiz+サービス/タイプK」の場合</span>\n          <md-radio-button value=\"s.iijmobile.jp\" style=\"margin:5px 20px\">s.iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 「IIJモバイルサービス/タイプD」の「パケットシェアプラン」または「パケットシェアプランL」の場合</span>\n          <md-radio-button value=\"sd.iijmobile.jp\" style=\"margin:5px 20px\">sd.iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 「IIJモバイルサービス/タイプD」の「定額プランライト」または「定額プランライト：いちねん」の場合</span>\n          <md-radio-button value=\"d.iijmobile.jp\" style=\"margin:5px 20px\">d.iijmobile.jp</md-radio-button>\n          <span style=\"font-size: 12px; margin-left: 45px;\">※ 「IIJモバイルBiz+サービス/タイプD」の場合</span>\n        </md-radio-group>\n      </md-content>\n    </div>\n\n    <h4 style=\"margin-top: 40px\">接続するリモートI/Oユニットの型番を選択</h4>\n    <div style=\"margin-bottom: 30px\">\n      <md-radio-group ng-model=\"$ctrl.deviceConfig.remoteio_name\" required>\n        <md-radio-button value=\"panasonic-uenu2d4r12\" class=\"md-primary\" style=\"margin:5px 0\">パナソニック製 UENU2D4R12</md-radio-button>\n        <md-radio-button value=\"watanabe-wmb-dio8r\" class=\"md-primary\" style=\"margin:5px 0\">渡辺電機工業製 WMB-DIO8R</md-radio-button>\n      </md-radio-group>\n    </div>\n\n    <md-button ng-click=\"$ctrl.showConfirm($ctrl.deviceConfig, $event)\" ng-disabled=\"configForm.$invalid\" class=\"md-primary md-raised\" style=\"margin: 16px 0; padding: 0 20px\">\n      変更する\n    </md-button>\n  </form>\n</md-content>\n"

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OemNotifyListShowController = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _notify_list_show = __webpack_require__(946);

var _notify_list_show2 = _interopRequireDefault(_notify_list_show);

var _company_notify_list = __webpack_require__(947);

var _company_notify_list2 = _interopRequireDefault(_company_notify_list);

var _mail_test = __webpack_require__(490);

var _mail_test2 = _interopRequireDefault(_mail_test);

var _company = __webpack_require__(95);

var _company2 = _interopRequireDefault(_company);

var _unique_validator = __webpack_require__(488);

var _unique_validator2 = _interopRequireDefault(_unique_validator);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var OemNotifyListShowController = exports.OemNotifyListShowController = function () {
    /*@ngInject*/
    OemNotifyListShowController.$inject = ["$scope", "$state", "$stateParams", "$mdDialog", "CompanyNotifyListService", "MailTestService", "CompanyService"];
    function OemNotifyListShowController($scope, $state, $stateParams, $mdDialog, CompanyNotifyListService, MailTestService, CompanyService) {
        _classCallCheck(this, OemNotifyListShowController);

        this.id = $stateParams.company_id;
        this.emails = [];
        this.inputMail = '';
        this.isTestMailSending = false;
        this.isMailTestSuccessed = false;

        this.NotifyListService = CompanyNotifyListService;
        this.MailTestService = MailTestService;
        this.CompanyService = CompanyService;
        this.$mdDialog = $mdDialog;
        this.$state = $state;

        $scope.$watch('$ctrl.inputMail', this.resetStatus());
    }

    _createClass(OemNotifyListShowController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.CompanyService.show({ id: this.id }, function (response) {
                _this.company_name = response.name;
            }, function (err) {
                if (err.status === 404 || err.status === 403) {
                    _this.$state.go('oem_main.oem_home');
                }
            });

            this.NotifyListService.api.show({ id: this.id }, function (response) {
                _this.emails = response.emails;
            });
        }
    }, {
        key: 'deleteMail',
        value: function deleteMail(email) {
            var targetIndex = this.emails.indexOf(email);
            this.emails.splice(targetIndex, 1);
            this.NotifyListService.api.update({ id: this.id, emails: this.emails });
        }
    }, {
        key: 'addMail',
        value: function addMail(email) {
            this.emails.push(email);
            this.inputMail = '';

            this.NotifyListService.api.update({ id: this.id, emails: this.emails });
        }
    }, {
        key: 'sendTestMail',
        value: function sendTestMail(email) {
            var _this2 = this;

            var dialog = {
                confirm: this.$mdDialog.confirm({
                    clickOutsideToClose: true,
                    title: email + "\u5B9B\u306B\u30C6\u30B9\u30C8\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3057\u307E\u3059",
                    ok: '送信する',
                    cancel: '戻る'
                }),
                error: this.$mdDialog.alert({
                    clickOutsideToClose: true,
                    title: 'エラーが発生しました',
                    content: 'メールアドレスを確認してください',
                    ok: 'OK'
                })
            };

            this.$mdDialog.show(dialog.confirm).then(function () {
                _this2.isTestMailSending = true;
                _this2.MailTestService.oem_api.create({ test_mail: email }, function (okResponse) {
                    _this2.isMailTestSuccessed = true;
                }, function (ngResponse) {
                    _this2.resetStatus();
                    _this2.$mdDialog.show(dialog.error);
                });
            });
        }
    }, {
        key: 'resetStatus',
        value: function resetStatus() {
            var _this3 = this;

            return function () {
                if (_this3.isTestMailSending || _this3.isMailTestSuccessed) {
                    _this3.isTestMailSending = false;
                    _this3.isMailTestSuccessed = false;
                }
            };
        }
    }]);

    return OemNotifyListShowController;
}();

exports.default = _angular2.default.module('leptonApp.oemNotifyListShow', [_angularjs2.default, _company_notify_list2.default, _mail_test2.default, _company2.default, _unique_validator2.default]).config(_notify_list_show2.default).component('oemNotifyListShow', {
    template: __webpack_require__(948),
    controller: OemNotifyListShowController
}).name;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('oem_main.notify_list_show', {
        url: '/notify_list/:company_id',
        template: '<oem-notify-list-show></oem-notify-list-show>'
    });
};

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularResource = __webpack_require__(12);

var _angularResource2 = _interopRequireDefault(_angularResource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var CompanyNotifyListService = function CompanyNotifyListService($resource) {
    'ngInject';

    _classCallCheck(this, CompanyNotifyListService);

    this.api = $resource('/api/oem/company_notify_list/:id', { id: '@id' }, {
        show: { method: 'GET', isArray: false },
        update: { method: 'PUT', isArray: false }
    });
};
CompanyNotifyListService.$inject = ["$resource"];

exports.default = angular.module('leptonApp.CompanyNotifyListService', ['ngResource']).service('CompanyNotifyListService', ['$resource', CompanyNotifyListService]).name;

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n    <div class=\"md-toolbar-tools\">\n        <h2><i class=\"fa fa-envelope fa-fw\"></i>&nbsp;メール通知先設定</h2>\n    </div>\n</md-toolbar>\n<div class=\"notify-list\">\n    <div id=\"notify-list-sa-info\">\n        <h3>{{ $ctrl.company_name }}</h3>\n    </div>\n    <md-toolbar class=\"md-hue-2\" style=\"background-color: rgb(0, 150, 136);\">\n        通知メール送信先\n    </md-toolbar>\n    <md-list>\n        <md-divider></md-divider>\n        <md-list-item class=\"md-2-line\" ng-repeat=\"email in $ctrl.emails\" style=\"padding: 0;\">\n            <div layout=\"row\" layout-align=\"start center\">\n                <div class=\"notify-list-email\" flex=\"auto\">{{email}}</div>\n                <div flex=\"none\">\n                    <md-button class=\"md-raised md-warn\"\n                    ng-click=\"$ctrl.deleteMail(email)\" style=\"color: #FFF\"> 送信先から削除 </md-button>\n                </div>\n            </div>\n            <md-divider></md-divider>\n        </md-list-item>\n        <div class='notify-list-notice' ng-if=\"$ctrl.emails.length > 0\">\n            ※メールアドレスは20件まで登録できます。\n        </div>\n    </md-list>\n    <div ng-if=\"$ctrl.emails.length === 0\">\n        通知先メールが登録されていません\n    </div>\n\n    <form name=\"$ctrl.addEmailForm\" class=\"notify-list-form\" novalidate autocomplete=\"off\">\n        <div layout=\"row\" layout-align=\"start center\">\n            <md-input-container class=\"md-block\" flex-gt-sm>\n                <label>送信先に追加するメールアドレス</label>\n                <input name=\"email\" type=\"email\" ng-model=\"$ctrl.inputMail\"\n                    ng-disabled=\"$ctrl.emails.length >= 20\" md-maxlength=\"254\" unique=\"$ctrl.emails\">\n                <div ng-messages=\"$ctrl.addEmailForm.email.$error\" ng-if=\"$ctrl.addEmailForm.email.$dirty\" role=\"alert\" multiple>\n                    <div ng-message=\"required\">入力してください</div>\n                    <div ng-message=\"md-maxlength\">254文字以下で記載してください</div>\n                    <div ng-message=\"email\">メールアドレスのフォーマットで入力してください</div>\n                    <div ng-message=\"unique\">既に登録されているメールアドレスです</div>\n                </div>\n            </md-input-container>\n            <md-button class=\"md-raised md-warn\" ng-if=\"!$ctrl.isTestMailSending\"\n                ng-disabled=\"$ctrl.addEmailForm.$invalid || $ctrl.inputMail === ''\"\n                ng-click=\"$ctrl.sendTestMail($ctrl.inputMail)\"\n                style=\"color: #FFF\">\n                テストメールを送信\n            </md-button>\n            <div ng-if=\"$ctrl.isTestMailSending && !$ctrl.isMailTestSuccessed\">\n                <i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i>&nbsp;テストメールを送信中\n            </div>\n            <div ng-if=\"$ctrl.isTestMailSending && $ctrl.isMailTestSuccessed\" style=\"color: green;\">\n                <i class=\"fa fa-check\"></i>&nbsp;テストメールを送信しました\n            </div>\n        </div>\n        <md-button class=\"md-raised md-primary\" ng-disabled=\"$ctrl.addEmailForm.$invalid || $ctrl.inputMail === ''\" ng-click=\"$ctrl.addMail($ctrl.inputMail)\">\n            送信先に追加\n        </md-button>\n    </form>\n</div>\n"

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MailTemplateController = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _mail_template = __webpack_require__(950);

var _mail_template2 = _interopRequireDefault(_mail_template);

var _mail_text = __webpack_require__(553);

var _mail_text2 = _interopRequireDefault(_mail_text);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var MailTemplateController = exports.MailTemplateController = function () {
    /*@ngInject*/
    MailTemplateController.$inject = ["$mdDialog", "MailTextService"];
    function MailTemplateController($mdDialog, MailTextService) {
        _classCallCheck(this, MailTemplateController);

        this.MailTextService = MailTextService;
        this.$mdDialog = $mdDialog;

        this.successDialog = $mdDialog.alert({
            clickOutsideToClose: true,
            title: '保存しました',
            ok: 'OK'
        });
    }

    _createClass(MailTemplateController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.MailTextService.oem_api.index(function (response) {
                _this.template = response;
            });
        }
    }, {
        key: 'submit',
        value: function submit(template) {
            var _this2 = this;

            this.MailTextService.oem_api.create(template, function (response) {
                _this2.template.mail_header = response.mail_header;
                _this2.template.mail_footer = response.mail_footer;
                _this2.$mdDialog.show(_this2.successDialog);
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(propName) {
            this.template[propName] = this.breakLongLine(this.template[propName]);
        }
    }, {
        key: 'breakLongLine',
        value: function breakLongLine(text) {
            var _this3 = this;

            var lines = text.split('\n');
            return lines.map(function (line) {
                return line.length <= 78 ? line : _this3.breakLongLine(_this3.textInsert(line, 78, '\n'));
            }).join('\n');
        }
    }, {
        key: 'textInsert',
        value: function textInsert(base, index, text) {
            return base.slice(0, index) + text + base.slice(index, base.length);
        }
    }]);

    return MailTemplateController;
}();

exports.default = _angular2.default.module('leptonApp.mailTemplate', [_angularjs2.default, _mail_text2.default]).config(_mail_template2.default).component('mailTemplate', {
    template: __webpack_require__(951),
    controller: MailTemplateController
}).name;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = routes;
function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('oem_main.mail_template', {
        url: '/mail_template',
        template: '<mail-template></mail-template>'
    });
}

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n\t<div class=\"md-toolbar-tools\">\n\t\t<h2><i class=\"fa fa-file-alt\"></i>&nbsp;&nbsp;送信メール設定</h2>\n\t</div>\n</md-toolbar>\n\n<md-content class=\"mail-template\">\n    顧客や管理者に送信されるメールの文面を設定します。<br>\n    1行が78文字を超えると自動的に改行されます。\n    <form name=\"mailTemplateForm\" novalidate>\n      <md-button ng-disabled=\"mailTemplateForm.$invalid\" class=\"md-primary md-raised\" ng-click=\"$ctrl.submit($ctrl.template)\" style=\"margin-top: 10px; color: white; padding: 1px 12px;margin: 32px 0 30px;\">\n\t\t\t  文面を保存する\n\t    </md-button>\n        <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-bottom: 0;\">\n            <label>挨拶文</label>\n            <textarea rows=\"4\" name=\"mail_header\" ng-model=\"$ctrl.template.mail_header\" ng-change=\"$ctrl.onChange('mail_header')\" md-maxlength=\"2048\">\n            </textarea>\n            <div ng-messages=\"mailTemplateForm.mail_header.$error\" ng-if=\"mailTemplateForm.mail_header.$dirty\" role=\"alert\" multiple>\n\t\t\t\t<div ng-message=\"md-maxlength\">2048文字以下で記載してください</div>\n\t\t\t</div>\n        </md-input-container>\n\n        <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-bottom: 0;\">\n            <label>署名</label>\n            <textarea rows=\"5\" name=\"mail_footer\" ng-model=\"$ctrl.template.mail_footer\" ng-change=\"$ctrl.onChange('mail_footer')\" md-maxlength=\"2048\">\n            </textarea>\n            <div ng-messages=\"mailTemplateForm.mail_footer.$error\" ng-if=\"mailTemplateForm.mail_footer.$dirty\" role=\"alert\" multiple>\n\t\t\t\t<div ng-message=\"md-maxlength\">2048文字以下で記載してください</div>\n\t\t\t</div>\n        </md-input-container>\n    </form>\n\n    <h3>メールプレビュー</h3>\n    <div class=\"mail-template-preview\">\n        <pre>\n{{ $ctrl.template.mail_header }}\n\nデマンドの予測値が 目標電力 を超過しました。\n \n-----------------------------------------------------\n発生日時　　　: 2017/04/25 13:33:32\nサービスコード: dss12345678\n管理ID　　　　: 1230\n設置場所　　　: サンプル設置場所\nメモ　　　　　: サンプル本社\n-----------------------------------------------------\n \n詳細はこちらをご覧ください。\nhttps://hv.pms.iij.jp/demand_monitoring/1\n\n{{ $ctrl.template.mail_footer }}\n        </pre>\n    </div>\n\n    <md-button class=\"md-primary md-raised\" ng-disabled=\"mailTemplateForm.$invalid\" ng-click=\"$ctrl.submit($ctrl.template)\" style=\"margin-top: 10px; color: white; padding: 1px 12px;margin: 32px 0 30px;\">\n\t\t文面を保存する\n\t</md-button>\n</md-content>\n"

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OemDemandControlIndexController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _demand_control_index = __webpack_require__(953);

var _demand_control_index2 = _interopRequireDefault(_demand_control_index);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _company = __webpack_require__(95);

var _company2 = _interopRequireDefault(_company);

var _controller_config = __webpack_require__(91);

var _controller_config2 = _interopRequireDefault(_controller_config);

var _sa_config_search = __webpack_require__(494);

var _sa_config_search2 = _interopRequireDefault(_sa_config_search);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OemDemandControlIndexController = exports.OemDemandControlIndexController = function () {
  /*@ngInject*/
  OemDemandControlIndexController.$inject = ["SaConfigService", "$state", "$stateParams", "CompanyService", "ControllerConfigService", "SaConfigSearchService"];
  function OemDemandControlIndexController(SaConfigService, $state, $stateParams, CompanyService, ControllerConfigService, SaConfigSearchService) {
    _classCallCheck(this, OemDemandControlIndexController);

    this.company_id = $stateParams.company_id;
    this.$state = $state;
    this.$stateParams = $stateParams;

    this.saList = [];
    this.SaConfigService = SaConfigService;
    this.CompanyService = CompanyService;
    this.ControllerConfigService = ControllerConfigService;
    this.SaConfigSearchService = SaConfigSearchService;

    this.pagination = {};

    this.searched = this.company_id === 'search';
  }

  _createClass(OemDemandControlIndexController, [{
    key: '$onInit',
    value: function $onInit() {
      this.changePage(1);
    }
  }, {
    key: 'changePage',
    value: function changePage(page) {
      if (this.searched) {
        var target = this.$stateParams.target;
        var value = this.$stateParams.value;
        this.loadDeviceBySearch(target, value, page);
      } else {
        this.validateCompany();
        this.loadDeviceByCompany(page);
      }
    }
  }, {
    key: 'loadDeviceByCompany',
    value: function loadDeviceByCompany(page) {
      var _this = this;

      this.SaConfigService.oem_api.pageIndex({ company_id: this.company_id, page: page }).$promise.then(function (response) {
        _this.saList = response.sa_configs;
        _this.pagination = response.pagination;

        return _this.ControllerConfigService.oem_api.index({ company_id: _this.company_id }).$promise;
      }).then(function (response) {
        var controllerDeviceList = response;

        _this.saList.forEach(function (device) {
          var controlTargets = controllerDeviceList.filter(function (controllerDevice) {
            return controllerDevice.reading_device_id === device.id;
          });
          device.controlTargets = controlTargets;
        });
      });
    }
  }, {
    key: 'loadDeviceBySearch',
    value: function loadDeviceBySearch(target, value, page) {
      var _this2 = this;

      this.company = { name: '検索結果' };
      this.SaConfigSearchService.oem_api.pageIndex({ target: target, value: value, page: page }, function (res) {
        _this2.saList = res.sa_configs;
        _this2.pagination = res.pagination;
      });
    }
  }, {
    key: 'validateCompany',
    value: function validateCompany() {
      var _this3 = this;

      this.CompanyService.show({ id: this.company_id }, function (response) {
        _this3.company = response;
      }, function (err) {
        if (err.status === 404 || err.status === 403) {
          _this3.$state.go('oem_main.oem_home');
        }
      });
    }
  }]);

  return OemDemandControlIndexController;
}();

exports.default = _angular2.default.module('leptonApp.oemDemandControlIndex', [_angularjs2.default, _sa_config2.default, _company2.default, _controller_config2.default, _sa_config_search2.default]).config(_demand_control_index2.default).component('oemDemandControlIndex', {
  template: __webpack_require__(954),
  controller: OemDemandControlIndexController
}).name;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.demand_control_index', {
    url: '/company/:company_id/demand_control_index?target&value',
    template: '<oem-demand-control-index></oem-demand-control-index>'
  });
};

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports = "<device-config-search-form ng-if=\"$ctrl.searched\"></device-config-search-form>\n<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-hand-pointer\"></i>&nbsp;&nbsp;デマンド制御を行う機器を選択: {{$ctrl.company.name}}</h2>\n  </div>\n</md-toolbar>\n<div ng-if=\"$ctrl.saList.length === 0 && !$ctrl.searched\" class=\"empty-notice\">設定済みの機器がありません。</div>\n<div ng-if=\"$ctrl.saList.length === 0 && $ctrl.searched\" class=\"empty-notice\">該当する機器はありませんでした。</div>\n<pagination pg-object=\"$ctrl.pagination\" action=\"$ctrl.changePage(page)\"></pagination>\n<md-content>\n  <md-list-item class=\"md-3-line\" ng-repeat=\"sa in $ctrl.saList\" style=\"flex-direction: column; padding-right: 0;\">\n    <div class=\"device-list-item-row\">\n      <config-index-item device=\"sa\" oem=\"true\" link-state=\"'oem_main.demand_control_edit'\"></config-index-item>\n      <md-divider></md-divider>\n    </div>\n    <md-list-item style=\"padding: 0;\" class=\"md-3-line control-device-list\" ng-repeat=\"controlDevice in sa.controlTargets\">\n      <div class=\"device-list-item-row\">\n        <md-divider></md-divider>\n        <config-index-item device=\"controlDevice\" oem=\"true\" link-state=\"'oem_main.demand_control_edit'\" second-indent=\"true\"></config-index-item>\n      </div>\n    </md-list-item>\n  </md-list-item>\n</md-content>\n<pagination pg-object=\"$ctrl.pagination\" action=\"$ctrl.changePage(page)\"></pagination>\n"

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OemDemandControlEditController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _demand_control_edit = __webpack_require__(956);

var _demand_control_edit2 = _interopRequireDefault(_demand_control_edit);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _demand_level = __webpack_require__(560);

var _demand_level2 = _interopRequireDefault(_demand_level);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OemDemandControlEditController = exports.OemDemandControlEditController = function () {
  /*@ngInject*/
  OemDemandControlEditController.$inject = ["$state", "$stateParams", "$mdDialog", "SaConfigService", "DemandLevelService"];
  function OemDemandControlEditController($state, $stateParams, $mdDialog, SaConfigService, DemandLevelService) {
    _classCallCheck(this, OemDemandControlEditController);

    this.id = $stateParams.id;

    this.$mdDialog = $mdDialog;
    this.$state = $state;
    this.SaConfigService = SaConfigService;
    this.DemandLevelService = DemandLevelService;

    this.dialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '制御レベルを変更しますか？',
        ok: '変更する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '制御レベルを変更しました',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };
  }

  _createClass(OemDemandControlEditController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.SaConfigService.oem_api.show({ id: this.id }, function (response) {
        _this.device = response;
      }, function (err) {
        if (err.status === 404 || err.status === 403) {
          _this.$state.go('oem_main.oem_home');
        }
      });

      this.DemandLevelService.oem_api.show({ id: this.id }, function (response) {
        _this.demandLevel = _this.currentLevel = response.level + '';
      });
    }
  }, {
    key: 'setLevel',
    value: function setLevel(ev) {
      var _this2 = this;

      this.$mdDialog.show(this.dialog.confirm.targetEvent(ev)).then(function () {
        _this2.DemandLevelService.oem_api.update({ id: _this2.id, level: _this2.demandLevel }, function (response) {
          _this2.currentLevel = _this2.demandLevel;
          _this2.$mdDialog.show(_this2.dialog.success);
        }, function (error) {
          _this2.$mdDialog.show(_this2.dialog.error);
        });
      });
    }
  }]);

  return OemDemandControlEditController;
}();

exports.default = _angular2.default.module('leptonApp.oemDemandControlEdit', [_angularjs2.default, _sa_config2.default, _demand_level2.default]).config(_demand_control_edit2.default).component('oemDemandControlEdit', {
  template: __webpack_require__(957),
  controller: OemDemandControlEditController
}).name;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.demand_control_edit', {
    url: '/company/:company_id/demand_control_edit/:id',
    template: '<oem-demand-control-edit></oem-demand-control-edit>'
  });
};

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-hand-pointer\"></i>&nbsp;&nbsp;手動デマンド制御</h2>\n  </div>\n</md-toolbar>\n\n<md-content style=\"padding: 5px 30px;\">\n  <div id=\"demand-report-sa-info\" style=\"margin: 20px 0;\">\n    <h3>{{$ctrl.device.location}}</h3>\n    <h3>{{$ctrl.device.memo}}</h3>\n  </div>\n\n  <h4 style=\"margin-bottom: 5px; margin-top: 40px;\">デマンド警報レベルを変更</h4>\n  <div style=\"margin-bottom: 24px;\">\n    <md-input-container style=\"width: 400px;\">\n      <label>一覧から選択</label>\n      <md-select id=\"demandLevelSelect\" name=\"demand_level\" ng-model=\"$ctrl.demandLevel\" required>\n        <md-option value=\"0\">通常状態</md-option>\n        <md-option value=\"1\">目標電力超過</md-option>\n        <md-option value=\"2\">限界電力超過</md-option>\n        <md-option value=\"3\">契約電力超過</md-option>\n      </md-select>\n    </md-input-container>\n    <small class=\"change_flg\" ng-if=\"$ctrl.currentLevel !== $ctrl.demandLevel\">\n      変更済み\n    </small>\n  </div>\n\n  <md-button ng-click=\"$ctrl.setLevel($event)\" ng-disabled=\"$ctrl.currentLevel === $ctrl.demandLevel\" class=\"md-primary md-raised\" style=\"margin: 16px 0; padding: 0 20px\">\n    変更を適用\n  </md-button>\n</md-content>\n"

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OemSaRebootController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _sa_reboot = __webpack_require__(959);

var _sa_reboot2 = _interopRequireDefault(_sa_reboot);

var _company = __webpack_require__(95);

var _company2 = _interopRequireDefault(_company);

var _sa_config = __webpack_require__(34);

var _sa_config2 = _interopRequireDefault(_sa_config);

var _controller_config = __webpack_require__(91);

var _controller_config2 = _interopRequireDefault(_controller_config);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OemSaRebootController = exports.OemSaRebootController = function () {
  /*@ngInject*/
  OemSaRebootController.$inject = ["$stateParams", "$q", "CompanyService", "SaConfigService", "ControllerConfigService"];
  function OemSaRebootController($stateParams, $q, CompanyService, SaConfigService, ControllerConfigService) {
    _classCallCheck(this, OemSaRebootController);

    this.company_id = $stateParams.company_id;
    this.$q = $q;
    this.CompanyService = CompanyService;
    this.SaConfigService = SaConfigService;
    this.ControllerConfigService = ControllerConfigService;

    this.devices = [];
  }

  _createClass(OemSaRebootController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.CompanyService.show({ id: this.company_id }, function (response) {
        _this.company = response;
      }, function (err) {
        if (err.status === 404 || err.status === 403) {
          _this.$state.go('oem_main.oem_home');
        }
      });

      this.$q.all([this.SaConfigService.oem_api.index({ company_id: this.company_id }).$promise, this.ControllerConfigService.oem_api.index({ company_id: this.company_id }).$promise]).then(function (responses) {
        _this.devices = responses[0].concat(responses[1]);
      });
    }
  }]);

  return OemSaRebootController;
}();

exports.default = _angular2.default.module('leptonApp.oemSaReboot', [_angularjs2.default, _company2.default, _sa_config2.default, _controller_config2.default]).config(_sa_reboot2.default).component('oemSaReboot', {
  template: __webpack_require__(960),
  controller: OemSaRebootController
}).name;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.sa_reboot', {
    url: '/company/:company_id/sa_reboot',
    template: '<oem-sa-reboot></oem-sa-reboot>'
  });
}

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-redo\"></i>&nbsp;端末再起動</h2>\n  </div>\n</md-toolbar>\n\n<div class=\"sa-reboot-content\">\n  <h3>{{ $ctrl.company.name }}</h3>\n\n  <div class=\"sa-reboot-list\">\n    <md-toolbar class=\"md-hue-2\">\n        端末一覧\n    </md-toolbar>\n\n    <div class=\"sa-reboot-item\" ng-repeat=\"device in $ctrl.devices\">\n      <sa-reboot-item device=\"device\"></sa-reboot-item>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SaRebootItemController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _sa_reboot = __webpack_require__(556);

var _sa_reboot2 = _interopRequireDefault(_sa_reboot);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var SaRebootItemController = exports.SaRebootItemController = function () {
  /*@ngInject*/
  SaRebootItemController.$inject = ["$mdDialog", "$timeout", "SaRebootService"];
  function SaRebootItemController($mdDialog, $timeout, SaRebootService) {
    _classCallCheck(this, SaRebootItemController);

    this.SaRebootService = SaRebootService;
    this.rebooted = false;
    this.rebooting = false;
    this.$mdDialog = $mdDialog;
    this.$timeout = $timeout;
    this.confirmDialog = null;
    this.errorDialog = null;

    this.rebootApiMethod = null;

    this.DialogController = function ($scope, $mdDialog, device) {
      $scope.device = device;
      $scope.closeDialog = function () {
        $mdDialog.hide();
      };
      $scope.cancelDialog = function () {
        $mdDialog.cancel();
      };
    };
  }

  _createClass(SaRebootItemController, [{
    key: '$onChanges',
    value: function $onChanges() {
      if (this.mode) {
        this.rebootApiMethod = this.SaRebootService.api;
      } else {
        this.rebootApiMethod = this.SaRebootService.oem_api;
      }

      this.confirmDialog = this.$mdDialog.confirm({
        clickOutsideToClose: true,
        template: __webpack_require__(962),
        locals: { device: this.device },
        controller: ['$scope', '$mdDialog', 'device', this.DialogController]
      });

      this.errorDialog = this.$mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      });
    }
  }, {
    key: 'showConfirm',
    value: function showConfirm(ev) {
      var _this = this;

      this.$mdDialog.show(this.confirmDialog.targetEvent(ev)).then(function () {
        _this.rebooting = true;
        _this.rebootApiMethod.reboot({ sa_config_id: _this.device.id }, function (response) {
          _this.$timeout(function () {
            _this.rebooting = false;
            _this.rebooted = true;
          }, 2000);
        }, function (err) {
          _this.rebooting = false;
          _this.$mdDialog.show(_this.errorDialog);
        });
      });
    }
  }]);

  return SaRebootItemController;
}();

exports.default = _angular2.default.module('leptonApp.saRebootItem', [_sa_reboot2.default]).component('saRebootItem', {
  template: __webpack_require__(963),
  controller: SaRebootItemController,
  bindings: {
    device: '=',
    mode: '@'
  }
}).name;

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports = "<md-dialog>\n  <md-dialog-content class=\"md-dialog-content\">\n    <h2 class=\"md-title\">以下の機器を再起動しますか？</h2>\n    <md-divider></md-divider>\n    <div class=\"md-dialog-content-body\">\n      <table border=\"0\">\n        <tr>\n          <td>サービスコード:</td><td>{{ device.pms_service_code }}</td>\n        </tr>\n        <tr>\n          <td>管理ID:</td><td>{{ device.management_id }}</td>\n        </tr>\n        <tr>\n          <td>設置場所:</td><td>{{ device.location }}</td>\n        </tr>\n        <tr>\n          <td>機器ID:</td><td>{{ device.distribution_id }}</td>\n        </tr>\n      </table>\n    </div>\n  </md-dialog-content>\n  <md-dialog-actions>\n    <md-button class=\"md-primary\" ng-click=\"cancelDialog()\">戻る</md-button>\n    <md-button class=\"md-primary\" ng-click=\"closeDialog()\">再起動</md-button>\n  </md-dialog-actions>\n</md-dialog>\n"

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports = "<div class=\"sa-reboot-item-content\" layout=\"column\">\n  <div class=\"sa-reboot-item-info\">\n    <h3>{{ $ctrl.device.pms_service_code }} {{ $ctrl.device.management_id }}</h3>\n    <h4>{{ $ctrl.device.location }}</h4>\n    <p>{{ $ctrl.device.memo }}</p>\n  </div>\n  <div class=\"sa-reboot-item-button\">\n    <md-button class=\"md-warn md-raised\" ng-click=\"$ctrl.showConfirm()\" aria-label=\"reboot\" ng-disabled=\"$ctrl.rebooted || $ctrl.rebooting\" style=\"margin-top: 10px; color: white;padding: 1px 12px;\">\n      <span ng-if=\"!$ctrl.rebooting && !$ctrl.rebooted\">再起動</span>\n      <span ng-if=\"$ctrl.rebooting && !$ctrl.rebooted\">\n        <i class=\"fa fa-spinner fa-pulse\" aria-hidden=\"true\"></i> 再起動リクエスト中\n      </span>\n      <span ng-if=\"!$ctrl.rebooting && $ctrl.rebooted\">\n        <i class=\"fa fa-check\" aria-hidden=\"true\"></i> 再起動リクエスト済み\n      </span>\n    </md-button>\n  </div>\n</div>\n"

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OemUserIndexController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _oem_user_index = __webpack_require__(965);

var _oem_user_index2 = _interopRequireDefault(_oem_user_index);

var _oem_user = __webpack_require__(129);

var _oem_user2 = _interopRequireDefault(_oem_user);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OemUserIndexController = exports.OemUserIndexController = function () {
  /*@ngInject*/
  OemUserIndexController.$inject = ["OemUserService", "$filter"];
  function OemUserIndexController(OemUserService, $filter) {
    _classCallCheck(this, OemUserIndexController);

    this.OemUserService = OemUserService;
  }

  _createClass(OemUserIndexController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.OemUserService.oem_api.index(function (response) {
        _this.userList = response;
      });
    }
  }]);

  return OemUserIndexController;
}();

exports.default = _angular2.default.module('leptonApp.oemUserIndex', [_angularjs2.default, _oem_user2.default]).config(_oem_user_index2.default).component('oemUserIndex', {
  template: __webpack_require__(966),
  controller: OemUserIndexController
}).name;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.oem_user_index', {
    url: '/user_index',
    template: '<oem-user-index></oem-user-index>'
  });
};

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\" style=\"min-height: 49px;\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-users\"></i>&nbsp;ユーザー管理</h2>\n  </div>\n</md-toolbar>\n<md-list>\n  <div class=\"add-link-row\">\n    <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>&nbsp;<span ui-sref=\"oem_main.oem_user_create\">ユーザーを追加</span>\n  </div>\n  <md-divider></md-divider>\n  <div ng-repeat=\"user in $ctrl.userList\">\n    <md-item-content style=\"padding: 0;\">\n      <div layout=\"row\" layout-align=\"center center\" class=\"md-tile-content error-content\"\n           style=\"padding: 0; color: #555;\">\n        <div flex>\n          <div ui-sref=\"oem_main.oem_user_edit({id:{{user.id}}})\" class=\"oem-user-item\">\n            <div class=\"oem-user-info-name\">{{ user.name }}</div>\n            <span class=\"oem-user-info-email\">{{ user.email }}</span>\n          </div>\n          <md-divider></md-divider>\n        </div>\n      </div>\n    </md-item-content>\n  </div>\n</md-list>\n"

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OemUserCreateController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _oem_user_create = __webpack_require__(968);

var _oem_user_create2 = _interopRequireDefault(_oem_user_create);

var _oem_user = __webpack_require__(129);

var _oem_user2 = _interopRequireDefault(_oem_user);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OemUserCreateController = exports.OemUserCreateController = function () {
  /*@ngInject*/
  OemUserCreateController.$inject = ["$mdDialog", "$state", "OemUserService"];
  function OemUserCreateController($mdDialog, $state, OemUserService) {
    _classCallCheck(this, OemUserCreateController);

    this.OemUserService = OemUserService;
    this.userData = {};
    this.$state = $state;
    this.$mdDialog = $mdDialog;

    this.dialogs = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '作成しますか？',
        ok: '作成する',
        cancel: '設定に戻る'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'アカウントの作成に失敗しました',
        content: '入力内容を確認してください',
        ok: 'OK'
      }),
      duplication_error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'アカウントの作成に失敗しました',
        content: '入力されたメールアドレスは既に登録されています。',
        ok: 'OK'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'アカウントを作成しました',
        content: '',
        ok: 'OK'
      })
    };
  }

  _createClass(OemUserCreateController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'showConfirm',
    value: function showConfirm(userData, ev) {
      var _this = this;

      this.$mdDialog.show(this.dialogs.confirm.targetEvent(ev)).then(function () {
        _this.OemUserService.oem_api.create(userData, function (res) {
          _this.dialogs.success.content(_this.userData.email + " \u5B9B\u306B\u30D1\u30B9\u30EF\u30FC\u30C9\u8A2D\u5B9A\u7528\u306EURL\u304C\u901A\u77E5\u3055\u308C\u307E\u3059\u3002");
          _this.$mdDialog.show(_this.dialogs.success).finally(function () {
            _this.$state.go('oem_main.oem_user_index');
          });
        }, function (err) {
          if (err.data.message.email && err.data.message.email[0] === 'address is already in use') {
            _this.$mdDialog.show(_this.dialogs.duplication_error);
          } else {
            _this.$mdDialog.show(_this.dialogs.error);
          }
        });
      });
    }
  }]);

  return OemUserCreateController;
}();

exports.default = _angular2.default.module('leptonApp.oemUserCreate', [_angularjs2.default, _oem_user2.default]).config(_oem_user_create2.default).component('oemUserCreate', {
  template: __webpack_require__(969),
  controller: OemUserCreateController
}).name;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.oem_user_create', {
    url: '/user_create',
    template: '<oem-user-create></oem-user-create>'
  });
};

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-user-plus\" style=\"padding-right: 10px;\"></i>新規にアカウントを作成</h2>\n  </div>\n</md-toolbar>\n<p style=\"padding: 0 20px;\">\n  アカウントを作成すると、入力したメールアドレスにパスワード設定のURLが通知されます。<br>\n  パスワードが設定されるまではログインすることができません。\n</p>\n<md-content style=\"padding: 5px 20px;\">\n  <form name=\"createForm\" novalidate>\n    <h4 style=\"margin-bottom: 0; font-size: 18px;margin: 0;\">アカウント情報</h4>\n    <div layout-gt-sm=\"row\" flex=\"40\" offset=\"40\" class=\"account-info-name\">\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px\">\n        <label>名前</label>\n        <input name=\"name\" ng-model=\"$ctrl.userData.name\" md-maxlength=\"255\" required>\n        <div ng-messages=\"createForm.name.$error\" ng-if=\"createForm.name.$dirty\" role=\"alert\" multiple>\n          <div ng-message=\"required\">入力してください</div>\n          <div ng-message=\"md-maxlength\">255文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n    </div>\n    <div layout-gt-sm=\"row\" flex=\"40\" offset=\"40\" class=\"account-info\">\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px\">\n        <label>メールアドレス</label>\n        <input name=\"email\" type=\"email\" ng-model=\"$ctrl.userData.email\" md-maxlength=\"254\" required>\n        <div ng-messages=\"createForm.email.$error\" ng-if=\"createForm.email.$dirty\" role=\"alert\" multiple>\n          <div ng-message=\"required\">入力してください</div>\n          <div ng-message=\"md-maxlength\">254文字以下で記載してください</div>\n          <div ng-message=\"email\">メールアドレスのフォーマットで入力してください</div>\n        </div>\n      </md-input-container>\n    </div>\n    <div layout-gt-sm=\"row\" flex=\"40\" offset=\"40\" class=\"account-info\">\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px\">\n        <label>確認のためメールアドレスをもう一度入力してください</label>\n        <input name=\"email_match\" type=\"text\" ng-model=\"email_match\" md-maxlength=\"254\" match=\"$ctrl.userData.email\" required>\n        <div class=\"invalid\" type=\"text\" ng-messages=\"createForm.email_match.$error\" ng-if=\"createForm.email_match.$dirty\">\n          <div ng-message=\"required\">入力してください</div>\n          <div ng-message=\"md-maxlength\">254文字以内で入力してください</div>\n          <div ng-show=\"createForm.email_match.$error.match\">メールアドレスが一致しません</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <md-button class=\"md-raised md-primary\" ng-disabled=\"createForm.$invalid\" ng-click=\"$ctrl.showConfirm($ctrl.userData, $event)\" style=\"margin: 30px 0 25px; padding: 2px 16px;\">アカウントを作成する</md-button>\n  </form>\n</md-content>\n"

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OemUserEditController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _oem_user_edit = __webpack_require__(971);

var _oem_user_edit2 = _interopRequireDefault(_oem_user_edit);

var _oem_user = __webpack_require__(129);

var _oem_user2 = _interopRequireDefault(_oem_user);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OemUserEditController = exports.OemUserEditController = function () {
  /*@ngInject*/
  OemUserEditController.$inject = ["$auth", "$stateParams", "$mdDialog", "$state", "OemUserService"];
  function OemUserEditController($auth, $stateParams, $mdDialog, $state, OemUserService) {
    _classCallCheck(this, OemUserEditController);

    this.OemUserService = OemUserService;
    this.$mdDialog = $mdDialog;
    this.$state = $state;
    this.userData = { id: $stateParams.id };
    this.isSelf = true;
    this.$auth = $auth;

    this.editDialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '変更しますか？',
        ok: '変更する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '変更しました',
        ok: 'OK'
      })
    };
    this.deleteDialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '削除してよろしいですか？',
        ok: '削除する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '削除しました',
        ok: 'OK'
      })
    };
    this.errorAlert = $mdDialog.alert().title('エラーが発生しました').content('時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。').ok('OK');
  }

  _createClass(OemUserEditController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.OemUserService.oem_api.show({ id: this.userData.id }, function (res) {
        _this.userData = res;
        _this.isSelf = res.email === _this.$auth.user.email;
      }, function (err) {
        if (err.status === 404 || err.status === 403) {
          _this.$state.go('oem_main.oem_home');
        }
      });
    }
  }, {
    key: 'updateUser',
    value: function updateUser(ev) {
      var _this2 = this;

      this.$mdDialog.show(this.editDialog.confirm.targetEvent(ev)).then(function () {
        _this2.OemUserService.oem_api.update(_this2.userData, function () {
          _this2.$mdDialog.show(_this2.editDialog.success).finally(function () {
            _this2.$state.go('oem_main.oem_user_index');
          });
        }, function () {
          _this2.$mdDialog.show(_this2.errorAlert);
        });
      });
    }
  }, {
    key: 'deleteUser',
    value: function deleteUser(ev) {
      var _this3 = this;

      this.$mdDialog.show(this.deleteDialog.confirm.targetEvent(ev)).then(function () {
        _this3.OemUserService.oem_api.delete({ id: _this3.userData.id }, function () {
          _this3.$mdDialog.show(_this3.deleteDialog.success).finally(function () {
            _this3.$state.go('oem_main.oem_user_index');
          });
        }, function () {
          _this3.$mdDialog.show(_this3.errorAlert);
        });
      });
    }
  }]);

  return OemUserEditController;
}();

exports.default = _angular2.default.module('leptonApp.oemUserEdit', [_angularjs2.default, _oem_user2.default]).config(_oem_user_edit2.default).component('oemUserEdit', {
  template: __webpack_require__(972),
  controller: OemUserEditController
}).name;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.oem_user_edit', {
    url: '/user_edit/:id',
    template: '<oem-user-edit></oem-user-edit>'
  });
};

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-edit\" style=\"padding-right: 10px;\"></i>ユーザー情報を編集 : {{ $ctrl.userData.email }}</h2>\n  </div>\n</md-toolbar>\n<md-content class=\"md-padding\" layout=\"row\" layout-align=\"space-between\" style=\"padding-bottom:0;\">\n  <h4 class=\"edit-title\">アカウント情報</h4>\n  <md-button class=\"md-raised md-warn\" ng-click=\"$ctrl.deleteUser($event)\" style=\"margin: 15px 0 0; padding: 3px 20px; color: white;\" ng-if=\"!$ctrl.isSelf\">このアカウントを削除する</md-button>\n</md-content>\n<md-content style=\"padding: 5px 20px;\">\n  <form name=\"editForm\" novalidate>\n    <div layout-gt-sm=\"row\" flex=\"40\" offset=\"40\" class=\"account-info-name\">\n      <md-input-container class=\"md-block\" flex-gt-sm style=\"margin-right: 20px\">\n        <label>名前</label>\n        <input name=\"name\" ng-model=\"$ctrl.userData.name\" md-maxlength=\"255\" required>\n        <div ng-messages=\"editForm.name.$error\" ng-if=\"editForm.name.$dirty\" role=\"alert\" multiple>\n          <div ng-message=\"required\">入力してください</div>\n          <div ng-message=\"md-maxlength\">255文字以下で記載してください</div>\n        </div>\n      </md-input-container>\n    </div>\n\n    <md-button class=\"md-raised md-primary\" ng-disabled=\"editForm.$invalid\" ng-click=\"$ctrl.updateUser($event)\" style=\"margin: 0; padding: 2px 16px;\">更新する</md-button>\n  </form>\n</md-content>\n"

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OemUserConfirmController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _oem_user_confirm = __webpack_require__(974);

var _oem_user_confirm2 = _interopRequireDefault(_oem_user_confirm);

var _oem_user_confirm3 = __webpack_require__(557);

var _oem_user_confirm4 = _interopRequireDefault(_oem_user_confirm3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OemUserConfirmController = exports.OemUserConfirmController = function () {
  /*@ngInject*/
  OemUserConfirmController.$inject = ["$state", "$mdDialog", "$stateParams", "OemUserConfirmService"];
  function OemUserConfirmController($state, $mdDialog, $stateParams, OemUserConfirmService) {
    _classCallCheck(this, OemUserConfirmController);

    this.OemUserConfirmService = OemUserConfirmService;
    this.query = { token: $stateParams.token };
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.dialogs = {
      error: $mdDialog.alert({
        disableParentScroll: false,
        title: 'パスワードの設定に失敗しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      }),
      success: $mdDialog.alert({
        disableParentScroll: false,
        title: 'パスワードの設定が完了しました',
        content: 'ログインページに移動します',
        ok: 'OK'
      })
    };
  }

  _createClass(OemUserConfirmController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'submitConfirm',
    value: function submitConfirm() {
      var _this = this;

      this.OemUserConfirmService.api.update(this.query, function (res) {
        _this.$mdDialog.show(_this.dialogs.success).finally(function () {
          return _this.$state.go('oem_login');
        });
      }, function (err) {
        if (err.data.message === 'wrong token') {
          _this.dialog.error.content('パスワード設定用URLが無効です');
        }
        _this.$mdDialog.show(_this.dialogs.error);
      });
    }
  }]);

  return OemUserConfirmController;
}();

exports.default = _angular2.default.module('leptonApp.oemUserConfirm', [_angularjs2.default, _oem_user_confirm4.default]).config(_oem_user_confirm2.default).component('oemUserConfirm', {
  template: __webpack_require__(975),
  controller: OemUserConfirmController
}).name;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_user_confirm', {
    url: '/admin/user_confirm/:token',
    template: '<oem-user-confirm></oem-user-confirm>'
  });
};

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports = "<div id=\"header\" style=\"backgroud-color: #188526\">\n  <md-button id=\"logo\" ui-sref=\"main.home\">\n    <span class=\"fa-stack\" style=\"font-size: 13px\">\n      <i class=\"fa fa-cloud fa-stack-2x\" style=\"color: rgb(0,150,136)\"></i>\n      <i class=\"fa fa-plug fa-stack-1x\" style=\"color: #fffde7\"></i>\n    </span>&nbsp; IIJ高圧スマートメーターBルート活用サービス 管理画面\n  </md-button>\n</div>\n<div class=\"md-toolbar-tools confirm_title\">\n  <h2><i class=\"fa fa-lock\"></i> パスワード設定</h2>\n</div>\n<md-content class=\"user-confirm\" md-theme=\"oemTheme\">\n  <div>\n    <h4 class=\"explanation\">ログイン用のパスワードを設定してください</h4>\n    <div>\n      <form name=\"confirmForm\">\n        <div layout-gt-sm=\"row\" flex=\"40\" offset=\"40\" class=\"password\">\n          <md-input-container class=\"md-block\" flex-gt-sm style=\"margin:0;\">\n            <label>パスワード</label>\n            <input name=\"password\" type=\"password\" ng-model=\"$ctrl.query.password\" required ng-minlength=\"8\" md-maxlength=\"128\" ng-pattern=\"/^[\\w!#$%&@()*+.,/:;<=>?^~]*$/\">\n            <div class=\"invalid\" ng-messages=\"confirmForm.password.$error\" ng-if=\"confirmForm.password.$dirty\">\n              <div ng-message=\"required\">入力が必要です</div>\n              <div ng-message=\"minlength\">8文字以上で記載してください</div>\n              <div ng-message=\"md-maxlength\">128文字以内で記載してください</div>\n              <div ng-message=\"pattern\">数字、アルファベット、_!#$%&@()*+.,/:;<=>?^~ のみを入力してください</div>\n            </div>\n          </md-input-container>\n        </div>\n        <div layout-gt-sm=\"row\" flex=\"40\" offset=\"40\" class=\"password\">\n          <md-input-container class=\"md-block\" flex-gt-sm style=\"margin:10px 0;\">\n            <label>パスワード再入力</label>\n            <input name=\"password_confirmation\" type=\"password\" ng-model=\"$ctrl.query.password_confirmation\" required match=\"$ctrl.query.password\" md-maxlength=\"128\">\n            <div class=\"invalid\" ng-messages=\"confirmForm.password_confirmation.$error\" ng-if=\"confirmForm.password_confirmation.$dirty\">\n              <div ng-message=\"required\">入力が必要です</div>\n              <div ng-show=\"confirmForm.password_confirmation.$error.match\">パスワードが一致しません</div>\n            </div>\n          </md-input-container>\n        </div>\n        <md-button style=\"margin: 22px 38px 42px;\" class=\"md-primary md-raised\" ng-click=\"$ctrl.submitConfirm()\" ng-disabled=\"confirmForm.$invalid\">パスワードを設定する</md-button>\n      </form>\n    </div>\n  </div>\n</md-content>\n<md-divider></md-divider>\n<div id=\"footer\">\n  <div><a target=\"_blank\" href=\"http://www.iij.ad.jp/securitypolicy/\">情報セキュリティ基本方針</a></div>\n  <div><a target=\"_blank\" href=\"http://www.iij.ad.jp/privacy/\">個人情報保護ポリシー</a></div>\n  <div>&copy; 2016 Internet Initiative Japan Inc.</div>\n</div>\n"

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OemUserReconfirmController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(4);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _oem_user_reconfirm = __webpack_require__(977);

var _oem_user_reconfirm2 = _interopRequireDefault(_oem_user_reconfirm);

var _user_password = __webpack_require__(493);

var _user_password2 = _interopRequireDefault(_user_password);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OemUserReconfirmController = exports.OemUserReconfirmController = function () {
  /*@ngInject*/
  OemUserReconfirmController.$inject = ["$state", "$mdDialog", "UserPasswordService"];
  function OemUserReconfirmController($state, $mdDialog, UserPasswordService) {
    _classCallCheck(this, OemUserReconfirmController);

    this.UserPasswordService = UserPasswordService;
    this.$mdDialog = $mdDialog;
    this.$state = $state;

    this.email = '';
    this.dialogs = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '以下のメールアドレスに確認用メールを送信しますか？',
        ok: '送信する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '送信が完了しました。',
        content: '送信されたメールをご確認下さい。',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };
  }

  _createClass(OemUserReconfirmController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'showConfirm',
    value: function showConfirm(ev) {
      var _this = this;

      this.dialogs.confirm.content(this.email);
      this.$mdDialog.show(this.dialogs.confirm.targetEvent(ev)).then(function () {
        _this.UserPasswordService.oem_api.create({ email: _this.email }, function (res) {
          _this.$mdDialog.show(_this.dialogs.success).finally(function () {
            _this.$state.go('oem_login');
          });
        }, function (err) {
          if (err.status === 404) {
            _this.dialogs.error.content('指定したメールアドレスのユーザーが存在しませんでした。');
          }
          _this.$mdDialog.show(_this.dialogs.error);
        });
      });
    }
  }]);

  return OemUserReconfirmController;
}();

exports.default = _angular2.default.module('leptonApp.oemUserReconfirm', [_angularjs2.default, _user_password2.default]).config(_oem_user_reconfirm2.default).component('oemUserReconfirm', {
  template: __webpack_require__(978),
  controller: OemUserReconfirmController
}).name;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_user_reconfirm', {
    url: '/admin/user_reconfirm',
    template: '<oem-user-reconfirm></oem-user-reconfirm>'
  });
}

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports = "<div id=\"header\" style=\"backgroud-color: #188526\">\n  <md-button id=\"logo\" ui-sref=\"main.home\">\n    <span class=\"fa-stack\" style=\"font-size: 13px\">\n      <i class=\"fa fa-cloud fa-stack-2x\" style=\"color: rgb(0,150,136)\"></i>\n      <i class=\"fa fa-plug fa-stack-1x\" style=\"color: #fffde7\"></i>\n    </span>&nbsp; Bルートデマンド監視サービス\n  </md-button>\n</div>\n<div class=\"reconfirm-title\">\n  <span><i class=\"fa fa-lock\"></i> パスワードの再設定</span>\n</div>\n<md-content class=\"user-reconfirm\" md-theme=\"oemTheme\">\n  <div>\n    <span class=\"reconfirm-explanation\">入力したメールアドレスにパスワード再設定用のURLが送信されます。</span>\n    <div class=\"form-content\">\n      <form name=\"reconfirmForm\">\n        <div layout-gt-sm=\"row\" flex=\"40\" offset=\"40\" class=\"reconfirm-password\">\n          <md-input-container class=\"md-block\" flex-gt-sm style=\"margin:0;\">\n            <label>メールアドレス</label>\n            <input name=\"email\" type=\"email\" ng-model=\"$ctrl.email\" md-maxlength=\"254\" required>\n            <div ng-messages=\"reconfirmForm.email.$error\" ng-if=\"reconfirmForm.email.$dirty\" role=\"alert\" multiple>\n              <div ng-message=\"required\">入力してください</div>\n              <div ng-message=\"md-maxlength\">254文字以下で記載してください</div>\n              <div ng-message=\"email\">メールアドレスのフォーマットで入力してください</div>\n            </div>\n          </md-input-container>\n        </div>\n        <md-button style=\"margin: 8px 0 32px;\" class=\"md-primary md-raised\" ng-click=\"$ctrl.showConfirm($event)\" ng-disabled=\"reconfirmForm.$invalid\">メールを送信</md-button>\n      </form>\n      <p class=\"reconfirm-notice\">\n        ※ ログインIDがメールアドレスではない特殊なアカウントについては、この画面からパスワード再設定用のメールを送信できません。\n      </p>\n      <p class=\"reconfirm-notice\">\n        ※ 再設定用のメールアドレスを送信後も、引き続き以前のパスワードでログインが可能です。\n      </p>\n    </div>\n  </div>\n</md-content>\n<md-divider></md-divider>\n<div id=\"footer\">\n  <div><a target=\"_blank\" href=\"http://www.iij.ad.jp/securitypolicy/\">情報セキュリティ基本方針</a></div>\n  <div><a target=\"_blank\" href=\"http://www.iij.ad.jp/privacy/\">個人情報保護ポリシー</a></div>\n  <div>&copy; 2016 Internet Initiative Japan Inc.</div>\n</div>\n"

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceConfigSearchFormController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DeviceConfigSearchFormController = exports.DeviceConfigSearchFormController = function () {
  /*@ngInject*/
  DeviceConfigSearchFormController.$inject = ["$scope", "$state", "$stateParams"];
  function DeviceConfigSearchFormController($scope, $state, $stateParams) {
    var _this = this;

    _classCallCheck(this, DeviceConfigSearchFormController);

    this.$state = $state;

    this.target = $stateParams.target || 'pms_service_code';
    this.value = $stateParams.value || '';
    this.inputPlaceHolder = '例: pms00000001';
    this.searched = !!$stateParams.target;
    this.stateName = $stateParams.stateName || $state.current.name.split('.')[1];
    this.linkTo = 'oem_main.' + this.stateName;

    $scope.$watch('$ctrl.target', function (newValue) {
      switch (newValue) {
        case 'pms_service_code':
          _this.inputPlaceHolder = '例: pms00000001';
          break;
        case 'distribution_id_suffix':
          _this.inputPlaceHolder = '例: 54A8（下４桁）';
          break;
        case 'management_id':
          _this.inputPlaceHolder = '例: mgmt-id-1';
          break;
        case 'zip_code':
          _this.inputPlaceHolder = '例: 102-0071';
          break;
        case 'location':
          _this.inputPlaceHolder = '例: 東京都千代田区';
          break;
      }
    });
  }

  _createClass(DeviceConfigSearchFormController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'search',
    value: function search() {
      this.$state.go(this.linkTo, {
        company_id: 'search',
        target: this.target,
        value: this.value
      }, { reload: true });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.$state.go('oem_main.company_index', { stateName: this.stateName });
    }
  }]);

  return DeviceConfigSearchFormController;
}();

exports.default = _angular2.default.module('leptonApp.deviceConfigSearchForm', []).component('deviceConfigSearchForm', {
  template: __webpack_require__(980),
  controller: DeviceConfigSearchFormController,
  bindings: {}
}).name;

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports = "<div class=\"device-search-form\">\n  <md-radio-group class=\"device-search-form-radio-group\" ng-model=\"$ctrl.target\">\n    <md-radio-button class=\"md-primary\" value=\"pms_service_code\" aria-label=\"サービスコード\">\n      サービスコード\n    </md-radio-button>\n    <md-radio-button class=\"md-primary\" value=\"distribution_id_suffix\" aria-label=\"機器ID\">機器ID</md-radio-button>\n    <md-radio-button class=\"md-primary\" value=\"management_id\" aria-label=\"管理ID\">\n      管理ID\n    </md-radio-button>\n    <md-radio-button class=\"md-primary\" value=\"zip_code\" aria-label=\"郵便番号\">\n      郵便番号\n    </md-radio-button>\n    <md-radio-button class=\"md-primary\" value=\"location\" aria-label=\"設置場所\">\n      設置場所\n    </md-radio-button>\n  </md-radio-group>\n  <div class=\"device-search-form-form\">\n    <div class=\"device-search-form-input\">\n      <i class=\"fa fa-search\"></i> <input type=\"text\" ng-model=\"$ctrl.value\" placeholder=\"{{$ctrl.inputPlaceHolder}}\">\n    </div>\n    <md-button ng-click=\"$ctrl.search()\" ng-disabled=\"$ctrl.value === ''\" class=\"md-primary md-raised\" style=\"margin: 0 0 0 10px; padding: 0 20px\">検索</md-button>\n    <md-button ng-click=\"$ctrl.reset()\" ng-disabled=\"!$ctrl.searched\" class=\"md-primary md-raised\" style=\"margin: 0 0 0 10px; padding: 0 20px\">戻る</md-button>\n  </div>\n</div>\n"

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OemGlobalEventController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _global_event = __webpack_require__(982);

var _global_event2 = _interopRequireDefault(_global_event);

var _angularMoment = __webpack_require__(14);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _global_event3 = __webpack_require__(496);

var _global_event4 = _interopRequireDefault(_global_event3);

__webpack_require__(983);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OemGlobalEventController = exports.OemGlobalEventController = function () {
  /*@ngInject*/
  OemGlobalEventController.$inject = ["moment", "$mdDialog", "$scope", "GlobalEventService"];
  function OemGlobalEventController(moment, $mdDialog, $scope, GlobalEventService) {
    var _this = this;

    _classCallCheck(this, OemGlobalEventController);

    this.moment = moment;
    this.$mdDialog = $mdDialog;
    this.GlobalEventService = GlobalEventService;

    this.globalEvents = [];
    this.occurred_at = this.moment().toDate();
    this.text = '';

    $scope.$watch('$ctrl.text', function () {
      if (!_this.text) {
        _this.text = '';
      }
    });

    /*@ngInject*/
    this.dialogController = function ($scope, $mdDialog, text, occurred_at) {
      $scope.text = text;
      $scope.occurred_at = occurred_at;

      $scope.closeDialog = function () {
        $mdDialog.cancel();
      };

      $scope.submit = function () {
        $mdDialog.hide();
      };
    };
    this.dialogController.$inject = ["$scope", "$mdDialog", "text", "occurred_at"];
  }

  _createClass(OemGlobalEventController, [{
    key: '$onInit',
    value: function $onInit() {
      this.updateList();
    }
  }, {
    key: 'updateList',
    value: function updateList() {
      var _this2 = this;

      this.GlobalEventService.oem_api.index(function (res) {
        _this2.globalEvents = res;
      });
    }
  }, {
    key: 'showModal',
    value: function showModal($event) {
      var _this3 = this;

      var parent = _angular2.default.element(document.body);
      this.$mdDialog.show({
        parent: parent,
        targetEvent: $event,
        template: __webpack_require__(984),
        locals: {
          text: this.text,
          occurred_at: this.occurred_at
        },
        controller: this.dialogController
      }).then(function () {
        _this3.GlobalEventService.oem_api.create({
          text: _this3.text,
          occurred_at: _this3.moment(_this3.occurred_at).add(9, 'hours')
        }, function (res) {
          _this3.occurred_at = _this3.moment().toDate();
          _this3.text = '';
          _this3.updateList();
        });
      });
    }
  }]);

  return OemGlobalEventController;
}();

exports.default = _angular2.default.module('leptonApp.oemGlobalEvent', [_angularMoment2.default, _global_event4.default]).config(_global_event2.default).component('oemGlobalEvent', {
  template: __webpack_require__(985),
  controller: OemGlobalEventController
}).name;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routes.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.global_event', {
    url: '/global_event',
    template: '<oem-global-event></oem-global-event>'
  });
}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports = "<md-dialog aria-label=\"compare dialog\">\n  <md-dialog-content>\n    <div class=\"oem-global-event-modal-header\">\n      <div class=\"oem-global-event-modal-title\">以下の内容でお知らせを掲載しますか？</div>\n    </div>\n    <div class=\"oem-global-event-modal-list\">\n      <div class=\"oem-global-event-modal-text\">\n        <i class=\"fas fa-info-circle\"></i> {{ text }} ({{occurred_at | date:'yyyy/MM/dd'}})\n      </div>\n    </div>\n  </md-dialog-content>\n  <md-dialog-actions>\n    <button ng-click=\"closeDialog()\" class=\"button button-normal\">キャンセル</button>\n    <button ng-click=\"submit()\" class=\"button button-main\">掲載する</button>\n  </md-dialog-actions>\n</md-dialog>\n"

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-info-circle\"></i>&nbsp;&nbsp;お知らせ登録</h2>\n  </div>\n</md-toolbar>\n\n<md-content class=\"oem-global-event\">\n  顧客へのお知らせを登録することができます。<br>\n  登録されたお知らせはトップページの「お知らせ」に表示されます。\n  <form name=\"globalEventForm\" class=\"oem-global-event-form\" novalidate>\n    <div class=\"oem-global-event-form-item oem-global-event-datepicker\">\n      <div class=\"oem-global-event-label\">\n        対象の日付:\n      </div>\n      <span datepicker class=\"date-picker\" ng-model=\"$ctrl.occurred_at\">\n        <span>\n          {{$ctrl.occurred_at | date: 'yyyy/MM/dd'}}\n          <i class=\"fa fa-sort-down\" aria-hidden=\"true\"></i>\n        </span>\n      </span>\n    </div>\n\n    <div class=\"oem-global-event-form-item\">\n      <div class=\"oem-global-event-label\">\n        お知らせ文面 ({{$ctrl.text.length}}/80):\n      </div>\n      <div>\n        <textarea rows=\"1\" name=\"text\" ng-model=\"$ctrl.text\" maxlength=\"80\" required></textarea>\n      </div>\n    </div>\n\n    <md-button ng-disabled=\"globalEventForm.$invalid\" class=\"md-primary md-raised\" ng-click=\"$ctrl.showModal()\" style=\"margin-top: 10px; color: white; padding: 1px 12px;margin: 32px 0 30px;\">\n      内容を確認\n    </md-button>\n  </form>\n\n  <div class=\"oem-global-event-form-item\">\n    <div class=\"oem-global-event-label\">\n      過去のお知らせ: <span ng-if=\"$ctrl.globalEvents.length === 0\">なし</span>\n    </div>\n    <div class=\"oem-global-event-list\">\n      <div class=\"oem-global-event-item\" ng-repeat=\"event in $ctrl.globalEvents\">\n        <div class=\"oem-global-event-icon\">\n          <i class=\"fas fa-info-circle\"></i>\n        </div>\n        <div class=\"oem-global-event-text\">\n          {{ event.text }} ({{event.occurred_at | date:'yyyy/MM/dd'}})\n        </div>\n      </div>\n    </div>\n  </div>\n</md-content>\n"

/***/ })
]),[591]);


// WEBPACK FOOTER //
// app.ca93007a7cdfe928e336.js